export const pdfAnimationData = {
    "v": "5.6.5",
    "fr": 29.9700012207031,
    "ip": 0,
    "op": 460.000018736184,
    "w": 600,
    "h": 660,
    "nm": "Reports animation",
    "ddd": 0,
    "assets": [
      {
        "id": "image_0",
        "w": 680,
        "h": 554,
        "u": "",
        "p": "data:image/png;base64,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",
        "e": 1
      },
      {
        "id": "image_1",
        "w": 1032,
        "h": 710,
        "u": "",
        "p": "data:image/png;base64,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",
        "e": 1
      },
      {
        "id": "image_2",
        "w": 681,
        "h": 555,
        "u": "",
        "p": "data:image/png;base64,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",
        "e": 1
      },
      {
        "id": "image_3",
        "w": 680,
        "h": 554,
        "u": "",
        "p": "data:image/png;base64,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",
        "e": 1
      },
      {
        "id": "image_4",
        "w": 510,
        "h": 582,
        "u": "",
        "p": "data:image/png;base64,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",
        "e": 1
      },
      {
        "id": "image_5",
        "w": 495,
        "h": 564,
        "u": "",
        "p": "data:image/png;base64,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",
        "e": 1
      },
      {
        "id": "image_6",
        "w": 495,
        "h": 564,
        "u": "",
        "p": "data:image/png;base64,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",
        "e": 1
      }
    ],
    "layers": [
      {
        "ddd": 0,
        "ind": 1,
        "ty": 2,
        "nm": "Bar Card.png",
        "cl": "png",
        "parent": 6,
        "refId": "image_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 289,
                "s": [
                  0
                ]
              },
              {
                "t": 296.000012056327,
                "s": [
                  100
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.1,
                  "y": 1
                },
                "o": {
                  "x": 0.9,
                  "y": 0
                },
                "t": 349,
                "s": [
                  349,
                  159.5,
                  0
                ],
                "to": [
                  0.167,
                  19.5,
                  0
                ],
                "ti": [
                  -0.167,
                  -19.5,
                  0
                ]
              },
              {
                "t": 379.000015436986,
                "s": [
                  350,
                  276.5,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              340,
              277,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.1,
                    0.1,
                    0.1
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.9,
                    0.9,
                    0.9
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 349,
                "s": [
                  29.115,
                  29.115,
                  100
                ]
              },
              {
                "t": 379.000015436986,
                "s": [
                  27.31,
                  27.31,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ip": 0,
        "op": 1077.00004386711,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 2,
        "ty": 2,
        "nm": "Comparison chart.png",
        "cl": "png",
        "parent": 6,
        "refId": "image_1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 289,
                "s": [
                  0
                ]
              },
              {
                "t": 296.000012056327,
                "s": [
                  100
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.1,
                  "y": 1
                },
                "o": {
                  "x": 0.9,
                  "y": 0
                },
                "t": 349,
                "s": [
                  181,
                  182.5,
                  0
                ],
                "to": [
                  3.167,
                  19.333,
                  0
                ],
                "ti": [
                  -3.167,
                  -19.333,
                  0
                ]
              },
              {
                "t": 379.000015436986,
                "s": [
                  200,
                  298.5,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              516,
              355,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.1,
                    0.1,
                    0.1
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.9,
                    0.9,
                    0.9
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 349,
                "s": [
                  29.115,
                  29.115,
                  100
                ]
              },
              {
                "t": 379.000015436986,
                "s": [
                  27.31,
                  27.31,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ip": 0,
        "op": 1077.00004386711,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 3,
        "ty": 2,
        "nm": "Pie Card.png",
        "cl": "png",
        "parent": 6,
        "refId": "image_2",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 289,
                "s": [
                  0
                ]
              },
              {
                "t": 296.000012056327,
                "s": [
                  100
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.1,
                  "y": 1
                },
                "o": {
                  "x": 0.9,
                  "y": 0
                },
                "t": 349,
                "s": [
                  349,
                  339.5,
                  0
                ],
                "to": [
                  0.167,
                  16.333,
                  0
                ],
                "ti": [
                  -0.167,
                  -16.333,
                  0
                ]
              },
              {
                "t": 379.000015436986,
                "s": [
                  350,
                  437.5,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              340.5,
              277.5,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.1,
                    0.1,
                    0.1
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.9,
                    0.9,
                    0.9
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 349,
                "s": [
                  29.115,
                  29.115,
                  100
                ]
              },
              {
                "t": 379.000015436986,
                "s": [
                  27.31,
                  27.31,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ip": 0,
        "op": 1077.00004386711,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 4,
        "ty": 2,
        "nm": "Snapshot card.png",
        "cl": "png",
        "parent": 6,
        "refId": "image_3",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 289,
                "s": [
                  0
                ]
              },
              {
                "t": 296.000012056327,
                "s": [
                  100
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.1,
                  "y": 1
                },
                "o": {
                  "x": 0.9,
                  "y": 0
                },
                "t": 349,
                "s": [
                  130,
                  339.5,
                  0
                ],
                "to": [
                  3.667,
                  16.333,
                  0
                ],
                "ti": [
                  -3.667,
                  -16.333,
                  0
                ]
              },
              {
                "t": 379.000015436986,
                "s": [
                  152,
                  437.5,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              340,
              277,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.1,
                    0.1,
                    0.1
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.9,
                    0.9,
                    0.9
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 349,
                "s": [
                  29.115,
                  29.115,
                  100
                ]
              },
              {
                "t": 379.000015436986,
                "s": [
                  27.31,
                  27.31,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ip": 0,
        "op": 1077.00004386711,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 5,
        "ty": 4,
        "nm": "Decoration_explosion 3",
        "sr": 1.5,
        "ks": {
          "p": {
            "a": 0,
            "k": [
              119,
              125,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              98.5,
              24,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              72.083,
              72.083,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.305,
                        -0.146
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.254,
                        0.759
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.285,
                        -0.47
                      ],
                      [
                        0.142,
                        -0.301
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.757,
                        -1.255
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.468,
                        -0.289
                      ],
                      [
                        0.305,
                        0.146
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.253,
                        -0.76
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.284,
                        0.471
                      ],
                      [
                        -0.142,
                        0.302
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.759,
                        1.253
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.469,
                        0.288
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        1.328,
                        0.622
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.47,
                        -0.284
                      ],
                      [
                        0.172,
                        0.285
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.624,
                        1.326
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.287,
                        0.469
                      ],
                      [
                        -0.289,
                        0.178
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.325,
                        -0.624
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.47,
                        0.285
                      ],
                      [
                        -0.173,
                        -0.284
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.625,
                        -1.326
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.288,
                        -0.468
                      ],
                      [
                        0.287,
                        -0.178
                      ]
                    ],
                    "v": [
                      [
                        -10.051,
                        -10.338
                      ],
                      [
                        -2.424,
                        -6.751
                      ],
                      [
                        1.708,
                        -6.971
                      ],
                      [
                        8.926,
                        -11.334
                      ],
                      [
                        10.292,
                        -10.998
                      ],
                      [
                        10.342,
                        -10.059
                      ],
                      [
                        6.755,
                        -2.426
                      ],
                      [
                        6.967,
                        1.706
                      ],
                      [
                        11.331,
                        8.918
                      ],
                      [
                        11.005,
                        10.288
                      ],
                      [
                        10.051,
                        10.338
                      ],
                      [
                        2.421,
                        6.754
                      ],
                      [
                        -1.708,
                        6.971
                      ],
                      [
                        -8.926,
                        11.333
                      ],
                      [
                        -10.292,
                        10.997
                      ],
                      [
                        -10.34,
                        10.058
                      ],
                      [
                        -6.755,
                        2.426
                      ],
                      [
                        -6.969,
                        -1.703
                      ],
                      [
                        -11.329,
                        -8.919
                      ],
                      [
                        -11.003,
                        -10.288
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 6
                },
                "lc": 1,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    31.266,
                    22.618
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 369.5,
                      "s": [
                        0,
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 374,
                      "s": [
                        120,
                        120
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 378.5,
                      "s": [
                        100,
                        100
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 389,
                      "s": [
                        100,
                        100
                      ]
                    },
                    {
                      "t": 393.500016027584,
                      "s": [
                        0,
                        0
                      ]
                    }
                  ]
                },
                "r": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 369.5,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 479.00001951007,
                      "s": [
                        360
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.569,
                        -0.25
                      ],
                      [
                        -0.165,
                        0
                      ],
                      [
                        -0.259,
                        0.211
                      ],
                      [
                        -0.128,
                        0.652
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.723,
                        0.326
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.169,
                        0.83
                      ],
                      [
                        0.219,
                        0.61
                      ],
                      [
                        0.443,
                        0.2
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.219,
                        1.076
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.568,
                        0.249
                      ],
                      [
                        0.267,
                        -1.358
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.725,
                        -0.325
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.168,
                        -0.831
                      ],
                      [
                        -0.219,
                        -0.61
                      ],
                      [
                        -0.445,
                        -0.2
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.218,
                        -1.078
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0.162,
                        0.07
                      ],
                      [
                        0.287,
                        0
                      ],
                      [
                        0.407,
                        -0.331
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.22,
                        -1.078
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.557,
                        -0.252
                      ],
                      [
                        0.133,
                        -0.662
                      ],
                      [
                        -0.219,
                        -0.609
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.723,
                        -0.326
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.167,
                        -0.846
                      ],
                      [
                        -0.918,
                        -0.402
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.218,
                        1.077
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.558,
                        0.252
                      ],
                      [
                        -0.133,
                        0.662
                      ],
                      [
                        0.218,
                        0.609
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.723,
                        0.324
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.167,
                        0.849
                      ]
                    ],
                    "v": [
                      [
                        -0.49,
                        18.237
                      ],
                      [
                        0.002,
                        18.342
                      ],
                      [
                        0.831,
                        18.025
                      ],
                      [
                        1.663,
                        16.494
                      ],
                      [
                        3.47,
                        7.57
                      ],
                      [
                        4.976,
                        5.328
                      ],
                      [
                        10.961,
                        2.626
                      ],
                      [
                        12.121,
                        0.897
                      ],
                      [
                        11.988,
                        -1.075
                      ],
                      [
                        10.961,
                        -2.33
                      ],
                      [
                        4.976,
                        -5.032
                      ],
                      [
                        3.471,
                        -7.272
                      ],
                      [
                        1.663,
                        -16.193
                      ],
                      [
                        0.488,
                        -17.94
                      ],
                      [
                        -1.663,
                        -16.198
                      ],
                      [
                        -3.476,
                        -7.271
                      ],
                      [
                        -4.978,
                        -5.032
                      ],
                      [
                        -10.961,
                        -2.33
                      ],
                      [
                        -12.121,
                        -0.601
                      ],
                      [
                        -11.989,
                        1.371
                      ],
                      [
                        -10.961,
                        2.626
                      ],
                      [
                        -4.977,
                        5.33
                      ],
                      [
                        -3.476,
                        7.569
                      ],
                      [
                        -1.666,
                        16.483
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 2",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 3
                },
                "lc": 1,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 2",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    161.196,
                    24.045
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 372.039,
                      "s": [
                        0,
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 378.958,
                      "s": [
                        120,
                        120
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 385.876,
                      "s": [
                        100,
                        100
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 402.019,
                      "s": [
                        100,
                        100
                      ]
                    },
                    {
                      "t": 408.938766656417,
                      "s": [
                        0,
                        0
                      ]
                    }
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.027,
                        0.031
                      ],
                      [
                        -0.01,
                        0.024
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.021,
                        -0.018
                      ],
                      [
                        -0.024,
                        0.01
                      ],
                      [
                        -0.029,
                        -0.005
                      ],
                      [
                        -0.059,
                        -0.013
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.015,
                        -0.008
                      ],
                      [
                        -0.029,
                        -0.01
                      ],
                      [
                        -0.015,
                        -0.007
                      ],
                      [
                        -0.029,
                        -0.012
                      ],
                      [
                        -0.018,
                        0
                      ],
                      [
                        -0.031,
                        -0.015
                      ],
                      [
                        -0.012,
                        -0.011
                      ],
                      [
                        -0.027,
                        -0.017
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.014,
                        -0.008
                      ],
                      [
                        -0.025,
                        -0.024
                      ],
                      [
                        -0.009,
                        -0.014
                      ],
                      [
                        -0.023,
                        -0.024
                      ],
                      [
                        -0.007,
                        -0.014
                      ],
                      [
                        -0.021,
                        -0.027
                      ],
                      [
                        -0.009,
                        -0.012
                      ],
                      [
                        -0.018,
                        -0.029
                      ],
                      [
                        -0.008,
                        -0.013
                      ],
                      [
                        -0.015,
                        -0.031
                      ],
                      [
                        -0.002,
                        -0.017
                      ],
                      [
                        -0.012,
                        -0.031
                      ],
                      [
                        -0.005,
                        -0.019
                      ],
                      [
                        -0.007,
                        -0.025
                      ],
                      [
                        -0.007,
                        -0.014
                      ],
                      [
                        -0.006,
                        -0.036
                      ],
                      [
                        0.005,
                        -0.017
                      ],
                      [
                        -0.003,
                        -0.031
                      ],
                      [
                        -0.005,
                        -0.014
                      ],
                      [
                        0,
                        -0.037
                      ],
                      [
                        0.007,
                        -0.016
                      ],
                      [
                        0.004,
                        -0.03
                      ],
                      [
                        0.008,
                        -0.042
                      ],
                      [
                        0.017,
                        -0.04
                      ],
                      [
                        0.013,
                        -0.013
                      ],
                      [
                        0.014,
                        -0.028
                      ],
                      [
                        0,
                        -0.018
                      ],
                      [
                        0.019,
                        -0.03
                      ],
                      [
                        0.015,
                        -0.011
                      ],
                      [
                        0.018,
                        -0.024
                      ],
                      [
                        0.005,
                        -0.015
                      ],
                      [
                        0.025,
                        -0.026
                      ],
                      [
                        0.018,
                        -0.005
                      ],
                      [
                        0.024,
                        -0.021
                      ],
                      [
                        0.006,
                        -0.017
                      ],
                      [
                        0.029,
                        -0.021
                      ],
                      [
                        0.038,
                        -0.019
                      ],
                      [
                        0.04,
                        -0.017
                      ],
                      [
                        0.039,
                        -0.017
                      ],
                      [
                        0.041,
                        -0.012
                      ],
                      [
                        0.017,
                        0.002
                      ],
                      [
                        0.031,
                        -0.006
                      ],
                      [
                        0.012,
                        -0.002
                      ],
                      [
                        0.04,
                        -0.005
                      ],
                      [
                        0.016,
                        -0.008
                      ],
                      [
                        0.035,
                        -0.002
                      ],
                      [
                        0.016,
                        0.004
                      ],
                      [
                        0.033,
                        0.002
                      ],
                      [
                        0.015,
                        0.007
                      ],
                      [
                        0.032,
                        0.005
                      ],
                      [
                        0.017,
                        -0.004
                      ],
                      [
                        0.034,
                        0.007
                      ],
                      [
                        0.013,
                        0.011
                      ],
                      [
                        0.031,
                        0.011
                      ],
                      [
                        0.037,
                        0.02
                      ],
                      [
                        0.038,
                        0.019
                      ],
                      [
                        0.033,
                        0.028
                      ],
                      [
                        0.054,
                        0.067
                      ],
                      [
                        0.007,
                        0.016
                      ],
                      [
                        0.019,
                        0.025
                      ],
                      [
                        0.021,
                        0.037
                      ],
                      [
                        0.012,
                        0.01
                      ],
                      [
                        0.016,
                        0.032
                      ],
                      [
                        0.002,
                        0.017
                      ],
                      [
                        0.01,
                        0.029
                      ],
                      [
                        0,
                        0.018
                      ],
                      [
                        0.007,
                        0.029
                      ],
                      [
                        0.01,
                        0.013
                      ],
                      [
                        0.005,
                        0.037
                      ],
                      [
                        -0.005,
                        0.043
                      ],
                      [
                        -0.007,
                        0.043
                      ],
                      [
                        0.006,
                        0.015
                      ],
                      [
                        -0.005,
                        0.036
                      ],
                      [
                        -0.006,
                        0.018
                      ],
                      [
                        -0.007,
                        0.03
                      ],
                      [
                        -0.003,
                        0.013
                      ],
                      [
                        -0.011,
                        0.036
                      ],
                      [
                        -0.004,
                        0.012
                      ],
                      [
                        -0.015,
                        0.038
                      ],
                      [
                        -0.011,
                        0.012
                      ],
                      [
                        -0.015,
                        0.029
                      ],
                      [
                        -0.034,
                        0.057
                      ],
                      [
                        -0.012,
                        0.011
                      ],
                      [
                        -0.02,
                        0.025
                      ],
                      [
                        -0.003,
                        0.018
                      ],
                      [
                        -0.024,
                        0.026
                      ],
                      [
                        -0.014,
                        0.009
                      ],
                      [
                        -0.025,
                        0.023
                      ],
                      [
                        -0.01,
                        0.012
                      ],
                      [
                        -0.027,
                        0.02
                      ],
                      [
                        -0.018,
                        0.003
                      ],
                      [
                        -0.028,
                        0.017
                      ],
                      [
                        -0.016,
                        0.005
                      ],
                      [
                        -0.03,
                        0.013
                      ],
                      [
                        -0.012,
                        0.01
                      ],
                      [
                        -0.033,
                        0.013
                      ],
                      [
                        -0.017,
                        0.001
                      ],
                      [
                        -0.03,
                        0.009
                      ],
                      [
                        -0.013,
                        0.005
                      ],
                      [
                        -0.039,
                        -0.001
                      ],
                      [
                        -0.015,
                        -0.003
                      ]
                    ],
                    "o": [
                      [
                        0.017,
                        -0.018
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.002,
                        0.028
                      ],
                      [
                        0.023,
                        0.025
                      ],
                      [
                        0.019,
                        -0.008
                      ],
                      [
                        0.06,
                        0.01
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.031,
                        0.009
                      ],
                      [
                        0.013,
                        0.008
                      ],
                      [
                        0.031,
                        0.012
                      ],
                      [
                        0.014,
                        0.007
                      ],
                      [
                        0.026,
                        0.014
                      ],
                      [
                        0.018,
                        -0.001
                      ],
                      [
                        0.027,
                        0.017
                      ],
                      [
                        0.012,
                        0.012
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.021,
                        0.021
                      ],
                      [
                        0.014,
                        0.009
                      ],
                      [
                        0.021,
                        0.023
                      ],
                      [
                        0.008,
                        0.014
                      ],
                      [
                        0.018,
                        0.024
                      ],
                      [
                        0.008,
                        0.014
                      ],
                      [
                        0.015,
                        0.025
                      ],
                      [
                        0.009,
                        0.014
                      ],
                      [
                        0.013,
                        0.026
                      ],
                      [
                        0.009,
                        0.014
                      ],
                      [
                        0.012,
                        0.029
                      ],
                      [
                        0.002,
                        0.016
                      ],
                      [
                        0.011,
                        0.035
                      ],
                      [
                        0.004,
                        0.013
                      ],
                      [
                        0.006,
                        0.028
                      ],
                      [
                        0.008,
                        0.015
                      ],
                      [
                        0.005,
                        0.031
                      ],
                      [
                        -0.005,
                        0.016
                      ],
                      [
                        0.001,
                        0.027
                      ],
                      [
                        0.006,
                        0.018
                      ],
                      [
                        -0.001,
                        0.034
                      ],
                      [
                        -0.006,
                        0.015
                      ],
                      [
                        -0.001,
                        0.043
                      ],
                      [
                        -0.009,
                        0.042
                      ],
                      [
                        -0.011,
                        0.031
                      ],
                      [
                        -0.012,
                        0.011
                      ],
                      [
                        -0.012,
                        0.026
                      ],
                      [
                        0,
                        0.02
                      ],
                      [
                        -0.018,
                        0.029
                      ],
                      [
                        -0.013,
                        0.01
                      ],
                      [
                        -0.018,
                        0.023
                      ],
                      [
                        -0.005,
                        0.018
                      ],
                      [
                        -0.022,
                        0.024
                      ],
                      [
                        -0.016,
                        0.006
                      ],
                      [
                        -0.021,
                        0.018
                      ],
                      [
                        -0.006,
                        0.019
                      ],
                      [
                        -0.035,
                        0.024
                      ],
                      [
                        -0.037,
                        0.022
                      ],
                      [
                        -0.037,
                        0.021
                      ],
                      [
                        -0.04,
                        0.015
                      ],
                      [
                        -0.031,
                        0.006
                      ],
                      [
                        -0.016,
                        -0.001
                      ],
                      [
                        -0.023,
                        0.002
                      ],
                      [
                        -0.02,
                        0.004
                      ],
                      [
                        -0.03,
                        0.001
                      ],
                      [
                        -0.016,
                        0.007
                      ],
                      [
                        -0.03,
                        -0.002
                      ],
                      [
                        -0.016,
                        -0.005
                      ],
                      [
                        -0.031,
                        -0.004
                      ],
                      [
                        -0.015,
                        -0.006
                      ],
                      [
                        -0.029,
                        -0.006
                      ],
                      [
                        -0.018,
                        0.003
                      ],
                      [
                        -0.031,
                        -0.009
                      ],
                      [
                        -0.014,
                        -0.009
                      ],
                      [
                        -0.039,
                        -0.016
                      ],
                      [
                        -0.041,
                        -0.013
                      ],
                      [
                        -0.037,
                        -0.023
                      ],
                      [
                        -0.069,
                        -0.051
                      ],
                      [
                        -0.022,
                        -0.024
                      ],
                      [
                        -0.006,
                        -0.015
                      ],
                      [
                        -0.026,
                        -0.034
                      ],
                      [
                        -0.015,
                        -0.024
                      ],
                      [
                        -0.015,
                        -0.012
                      ],
                      [
                        -0.015,
                        -0.03
                      ],
                      [
                        -0.002,
                        -0.016
                      ],
                      [
                        -0.012,
                        -0.031
                      ],
                      [
                        -0.001,
                        -0.016
                      ],
                      [
                        -0.008,
                        -0.027
                      ],
                      [
                        -0.011,
                        -0.015
                      ],
                      [
                        -0.003,
                        -0.043
                      ],
                      [
                        0,
                        -0.043
                      ],
                      [
                        0.002,
                        -0.028
                      ],
                      [
                        -0.007,
                        -0.018
                      ],
                      [
                        0.006,
                        -0.033
                      ],
                      [
                        0.005,
                        -0.014
                      ],
                      [
                        0.007,
                        -0.026
                      ],
                      [
                        0.003,
                        -0.018
                      ],
                      [
                        0.009,
                        -0.022
                      ],
                      [
                        0.007,
                        -0.019
                      ],
                      [
                        0.015,
                        -0.028
                      ],
                      [
                        0.01,
                        -0.013
                      ],
                      [
                        0.032,
                        -0.052
                      ],
                      [
                        0.019,
                        -0.024
                      ],
                      [
                        0.011,
                        -0.012
                      ],
                      [
                        0.02,
                        -0.022
                      ],
                      [
                        0.004,
                        -0.018
                      ],
                      [
                        0.023,
                        -0.021
                      ],
                      [
                        0.014,
                        -0.008
                      ],
                      [
                        0.026,
                        -0.019
                      ],
                      [
                        0.01,
                        -0.013
                      ],
                      [
                        0.027,
                        -0.017
                      ],
                      [
                        0.017,
                        -0.002
                      ],
                      [
                        0.028,
                        -0.014
                      ],
                      [
                        0.015,
                        -0.005
                      ],
                      [
                        0.027,
                        -0.012
                      ],
                      [
                        0.014,
                        -0.012
                      ],
                      [
                        0.03,
                        -0.009
                      ],
                      [
                        0.016,
                        -0.001
                      ],
                      [
                        0.023,
                        -0.005
                      ],
                      [
                        0.02,
                        -0.008
                      ],
                      [
                        0.024,
                        0
                      ],
                      [
                        0.025,
                        0.006
                      ]
                    ],
                    "v": [
                      [
                        -0.042,
                        -1.369
                      ],
                      [
                        -0.002,
                        -1.431
                      ],
                      [
                        0.003,
                        -1.43
                      ],
                      [
                        0.04,
                        -1.36
                      ],
                      [
                        0.107,
                        -1.353
                      ],
                      [
                        0.178,
                        -1.366
                      ],
                      [
                        0.299,
                        -1.342
                      ],
                      [
                        0.304,
                        -1.341
                      ],
                      [
                        0.366,
                        -1.316
                      ],
                      [
                        0.424,
                        -1.291
                      ],
                      [
                        0.484,
                        -1.264
                      ],
                      [
                        0.54,
                        -1.238
                      ],
                      [
                        0.602,
                        -1.225
                      ],
                      [
                        0.67,
                        -1.211
                      ],
                      [
                        0.719,
                        -1.171
                      ],
                      [
                        0.771,
                        -1.129
                      ],
                      [
                        0.875,
                        -1.052
                      ],
                      [
                        0.924,
                        -1.015
                      ],
                      [
                        0.978,
                        -0.973
                      ],
                      [
                        1.016,
                        -0.923
                      ],
                      [
                        1.056,
                        -0.87
                      ],
                      [
                        1.089,
                        -0.818
                      ],
                      [
                        1.126,
                        -0.762
                      ],
                      [
                        1.159,
                        -0.712
                      ],
                      [
                        1.196,
                        -0.655
                      ],
                      [
                        1.226,
                        -0.602
                      ],
                      [
                        1.258,
                        -0.543
                      ],
                      [
                        1.273,
                        -0.481
                      ],
                      [
                        1.288,
                        -0.417
                      ],
                      [
                        1.308,
                        -0.348
                      ],
                      [
                        1.322,
                        -0.294
                      ],
                      [
                        1.342,
                        -0.238
                      ],
                      [
                        1.363,
                        -0.171
                      ],
                      [
                        1.359,
                        -0.106
                      ],
                      [
                        1.353,
                        -0.042
                      ],
                      [
                        1.364,
                        0.015
                      ],
                      [
                        1.375,
                        0.087
                      ],
                      [
                        1.359,
                        0.152
                      ],
                      [
                        1.344,
                        0.213
                      ],
                      [
                        1.329,
                        0.342
                      ],
                      [
                        1.29,
                        0.465
                      ],
                      [
                        1.255,
                        0.521
                      ],
                      [
                        1.215,
                        0.572
                      ],
                      [
                        1.204,
                        0.632
                      ],
                      [
                        1.185,
                        0.7
                      ],
                      [
                        1.139,
                        0.75
                      ],
                      [
                        1.094,
                        0.794
                      ],
                      [
                        1.066,
                        0.848
                      ],
                      [
                        1.032,
                        0.91
                      ],
                      [
                        0.976,
                        0.945
                      ],
                      [
                        0.919,
                        0.979
                      ],
                      [
                        0.887,
                        1.031
                      ],
                      [
                        0.846,
                        1.09
                      ],
                      [
                        0.734,
                        1.157
                      ],
                      [
                        0.618,
                        1.214
                      ],
                      [
                        0.503,
                        1.271
                      ],
                      [
                        0.382,
                        1.313
                      ],
                      [
                        0.316,
                        1.316
                      ],
                      [
                        0.252,
                        1.319
                      ],
                      [
                        0.202,
                        1.325
                      ],
                      [
                        0.127,
                        1.336
                      ],
                      [
                        0.066,
                        1.353
                      ],
                      [
                        -0.001,
                        1.371
                      ],
                      [
                        -0.062,
                        1.36
                      ],
                      [
                        -0.128,
                        1.348
                      ],
                      [
                        -0.189,
                        1.331
                      ],
                      [
                        -0.251,
                        1.314
                      ],
                      [
                        -0.312,
                        1.316
                      ],
                      [
                        -0.383,
                        1.316
                      ],
                      [
                        -0.439,
                        1.285
                      ],
                      [
                        -0.497,
                        1.254
                      ],
                      [
                        -0.613,
                        1.201
                      ],
                      [
                        -0.732,
                        1.152
                      ],
                      [
                        -0.837,
                        1.077
                      ],
                      [
                        -1.021,
                        0.898
                      ],
                      [
                        -1.057,
                        0.843
                      ],
                      [
                        -1.088,
                        0.788
                      ],
                      [
                        -1.158,
                        0.682
                      ],
                      [
                        -1.198,
                        0.638
                      ],
                      [
                        -1.243,
                        0.582
                      ],
                      [
                        -1.262,
                        0.518
                      ],
                      [
                        -1.277,
                        0.456
                      ],
                      [
                        -1.29,
                        0.391
                      ],
                      [
                        -1.298,
                        0.33
                      ],
                      [
                        -1.325,
                        0.277
                      ],
                      [
                        -1.352,
                        0.21
                      ],
                      [
                        -1.349,
                        0.081
                      ],
                      [
                        -1.339,
                        -0.047
                      ],
                      [
                        -1.349,
                        -0.106
                      ],
                      [
                        -1.357,
                        -0.177
                      ],
                      [
                        -1.34,
                        -0.242
                      ],
                      [
                        -1.323,
                        -0.301
                      ],
                      [
                        -1.311,
                        -0.356
                      ],
                      [
                        -1.294,
                        -0.426
                      ],
                      [
                        -1.275,
                        -0.474
                      ],
                      [
                        -1.249,
                        -0.546
                      ],
                      [
                        -1.213,
                        -0.598
                      ],
                      [
                        -1.176,
                        -0.653
                      ],
                      [
                        -1.111,
                        -0.762
                      ],
                      [
                        -1.07,
                        -0.808
                      ],
                      [
                        -1.027,
                        -0.857
                      ],
                      [
                        -1.001,
                        -0.914
                      ],
                      [
                        -0.969,
                        -0.977
                      ],
                      [
                        -0.919,
                        -1.015
                      ],
                      [
                        -0.865,
                        -1.055
                      ],
                      [
                        -0.818,
                        -1.099
                      ],
                      [
                        -0.771,
                        -1.145
                      ],
                      [
                        -0.71,
                        -1.167
                      ],
                      [
                        -0.646,
                        -1.188
                      ],
                      [
                        -0.589,
                        -1.212
                      ],
                      [
                        -0.529,
                        -1.236
                      ],
                      [
                        -0.478,
                        -1.268
                      ],
                      [
                        -0.417,
                        -1.305
                      ],
                      [
                        -0.355,
                        -1.315
                      ],
                      [
                        -0.292,
                        -1.326
                      ],
                      [
                        -0.241,
                        -1.342
                      ],
                      [
                        -0.167,
                        -1.355
                      ],
                      [
                        -0.111,
                        -1.348
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.009,
                        0.032
                      ],
                      [
                        0.002,
                        0.056
                      ],
                      [
                        0.01,
                        0.077
                      ],
                      [
                        0.011,
                        0.036
                      ],
                      [
                        0.01,
                        0.039
                      ],
                      [
                        0.028,
                        0.073
                      ],
                      [
                        0.004,
                        0.027
                      ],
                      [
                        0.03,
                        0.061
                      ],
                      [
                        0.023,
                        0.025
                      ],
                      [
                        0.029,
                        0.046
                      ],
                      [
                        0.009,
                        0.024
                      ],
                      [
                        0.041,
                        0.053
                      ],
                      [
                        0.059,
                        0.051
                      ],
                      [
                        0.012,
                        0.025
                      ],
                      [
                        0.05,
                        0.044
                      ],
                      [
                        0.029,
                        0.013
                      ],
                      [
                        0.045,
                        0.032
                      ],
                      [
                        0.022,
                        0.019
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.035,
                        0.019
                      ],
                      [
                        0.024,
                        0.017
                      ],
                      [
                        0.037,
                        0.016
                      ],
                      [
                        0.027,
                        0.011
                      ],
                      [
                        0.038,
                        0.012
                      ],
                      [
                        0.076,
                        0.022
                      ],
                      [
                        0.026,
                        0.013
                      ],
                      [
                        0.064,
                        0.012
                      ],
                      [
                        0.023,
                        0.004
                      ],
                      [
                        0.076,
                        0.008
                      ],
                      [
                        0.029,
                        -0.006
                      ],
                      [
                        0.06,
                        0.003
                      ],
                      [
                        0.029,
                        0.003
                      ],
                      [
                        0.062,
                        -0.004
                      ],
                      [
                        0.028,
                        0
                      ],
                      [
                        0.065,
                        -0.009
                      ],
                      [
                        0.028,
                        -0.015
                      ],
                      [
                        0.058,
                        -0.013
                      ],
                      [
                        0.025,
                        -0.005
                      ],
                      [
                        0.066,
                        -0.023
                      ],
                      [
                        0.07,
                        -0.037
                      ],
                      [
                        0.029,
                        -0.025
                      ],
                      [
                        0.035,
                        -0.02
                      ],
                      [
                        0.029,
                        -0.023
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.027,
                        -0.026
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.051,
                        -0.059
                      ],
                      [
                        0.048,
                        -0.061
                      ],
                      [
                        0.038,
                        -0.07
                      ],
                      [
                        0.007,
                        -0.032
                      ],
                      [
                        0.025,
                        -0.049
                      ],
                      [
                        0.029,
                        -0.073
                      ],
                      [
                        0.021,
                        -0.075
                      ],
                      [
                        0,
                        -0.039
                      ],
                      [
                        0.006,
                        -0.04
                      ],
                      [
                        0.006,
                        -0.078
                      ],
                      [
                        -0.001,
                        -0.079
                      ],
                      [
                        -0.012,
                        -0.036
                      ],
                      [
                        -0.006,
                        -0.04
                      ],
                      [
                        -0.001,
                        -0.026
                      ],
                      [
                        -0.015,
                        -0.065
                      ],
                      [
                        -0.003,
                        -0.011
                      ],
                      [
                        -0.033,
                        -0.103
                      ],
                      [
                        -0.007,
                        -0.022
                      ],
                      [
                        -0.029,
                        -0.07
                      ],
                      [
                        -0.009,
                        -0.027
                      ],
                      [
                        -0.03,
                        -0.056
                      ],
                      [
                        -0.011,
                        -0.018
                      ],
                      [
                        -0.042,
                        -0.066
                      ],
                      [
                        -0.016,
                        -0.024
                      ],
                      [
                        -0.039,
                        -0.051
                      ],
                      [
                        -0.027,
                        -0.016
                      ],
                      [
                        -0.041,
                        -0.045
                      ],
                      [
                        -0.019,
                        -0.021
                      ],
                      [
                        -0.045,
                        -0.042
                      ],
                      [
                        -0.025,
                        -0.014
                      ],
                      [
                        -0.048,
                        -0.036
                      ],
                      [
                        -0.021,
                        -0.02
                      ],
                      [
                        -0.053,
                        -0.033
                      ],
                      [
                        -0.023,
                        -0.013
                      ],
                      [
                        -0.06,
                        -0.029
                      ],
                      [
                        -0.031,
                        -0.004
                      ],
                      [
                        -0.056,
                        -0.02
                      ],
                      [
                        -0.023,
                        -0.009
                      ],
                      [
                        -0.067,
                        -0.018
                      ],
                      [
                        -0.029,
                        0
                      ],
                      [
                        -0.058,
                        -0.017
                      ],
                      [
                        -0.031,
                        -0.007
                      ],
                      [
                        -0.03,
                        0.017
                      ],
                      [
                        -0.019,
                        0.024
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.045,
                        -0.018
                      ],
                      [
                        -0.036,
                        0.015
                      ],
                      [
                        -0.046,
                        0.009
                      ],
                      [
                        -0.025,
                        0.003
                      ],
                      [
                        -0.07,
                        0.017
                      ],
                      [
                        -0.027,
                        0.003
                      ],
                      [
                        -0.063,
                        0.02
                      ],
                      [
                        -0.025,
                        0.007
                      ],
                      [
                        -0.061,
                        0.026
                      ],
                      [
                        -0.023,
                        0.02
                      ],
                      [
                        -0.053,
                        0.028
                      ],
                      [
                        -0.026,
                        0.011
                      ],
                      [
                        -0.053,
                        0.034
                      ],
                      [
                        -0.017,
                        0.013
                      ],
                      [
                        -0.063,
                        0.05
                      ],
                      [
                        -0.019,
                        0.022
                      ],
                      [
                        -0.044,
                        0.04
                      ],
                      [
                        -0.021,
                        0.02
                      ],
                      [
                        -0.042,
                        0.046
                      ],
                      [
                        -0.019,
                        0.022
                      ],
                      [
                        -0.038,
                        0.05
                      ],
                      [
                        -0.014,
                        0.026
                      ],
                      [
                        -0.03,
                        0.05
                      ],
                      [
                        -0.011,
                        0.028
                      ],
                      [
                        -0.027,
                        0.052
                      ],
                      [
                        -0.014,
                        0.024
                      ],
                      [
                        -0.023,
                        0.06
                      ],
                      [
                        -0.008,
                        0.039
                      ],
                      [
                        -0.012,
                        0.043
                      ],
                      [
                        0.001,
                        0.031
                      ],
                      [
                        -0.008,
                        0.056
                      ],
                      [
                        -0.001,
                        0.009
                      ],
                      [
                        -0.005,
                        0.022
                      ],
                      [
                        -0.002,
                        0.04
                      ]
                    ],
                    "o": [
                      [
                        -0.007,
                        -0.027
                      ],
                      [
                        0.003,
                        -0.078
                      ],
                      [
                        -0.004,
                        -0.038
                      ],
                      [
                        -0.014,
                        -0.038
                      ],
                      [
                        -0.017,
                        -0.076
                      ],
                      [
                        -0.018,
                        -0.046
                      ],
                      [
                        -0.004,
                        -0.033
                      ],
                      [
                        -0.027,
                        -0.056
                      ],
                      [
                        -0.019,
                        -0.02
                      ],
                      [
                        -0.026,
                        -0.042
                      ],
                      [
                        -0.011,
                        -0.032
                      ],
                      [
                        -0.052,
                        -0.06
                      ],
                      [
                        -0.035,
                        -0.038
                      ],
                      [
                        -0.015,
                        -0.03
                      ],
                      [
                        -0.047,
                        -0.041
                      ],
                      [
                        -0.027,
                        -0.012
                      ],
                      [
                        -0.044,
                        -0.033
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.029,
                        -0.028
                      ],
                      [
                        -0.048,
                        -0.029
                      ],
                      [
                        -0.031,
                        -0.024
                      ],
                      [
                        -0.051,
                        -0.024
                      ],
                      [
                        -0.036,
                        -0.017
                      ],
                      [
                        -0.073,
                        -0.03
                      ],
                      [
                        -0.05,
                        -0.011
                      ],
                      [
                        -0.028,
                        -0.014
                      ],
                      [
                        -0.043,
                        -0.006
                      ],
                      [
                        -0.037,
                        -0.006
                      ],
                      [
                        -0.057,
                        -0.003
                      ],
                      [
                        -0.03,
                        0.006
                      ],
                      [
                        -0.056,
                        0.003
                      ],
                      [
                        -0.03,
                        -0.003
                      ],
                      [
                        -0.053,
                        0.006
                      ],
                      [
                        -0.031,
                        0.001
                      ],
                      [
                        -0.057,
                        0.012
                      ],
                      [
                        -0.025,
                        0.016
                      ],
                      [
                        -0.046,
                        0.014
                      ],
                      [
                        -0.034,
                        0.006
                      ],
                      [
                        -0.073,
                        0.028
                      ],
                      [
                        -0.035,
                        0.015
                      ],
                      [
                        -0.031,
                        0.026
                      ],
                      [
                        -0.033,
                        0.019
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.031,
                        0.022
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.058,
                        0.051
                      ],
                      [
                        -0.057,
                        0.053
                      ],
                      [
                        -0.048,
                        0.064
                      ],
                      [
                        -0.033,
                        0.051
                      ],
                      [
                        -0.007,
                        0.028
                      ],
                      [
                        -0.04,
                        0.067
                      ],
                      [
                        -0.035,
                        0.071
                      ],
                      [
                        -0.011,
                        0.038
                      ],
                      [
                        0.004,
                        0.04
                      ],
                      [
                        -0.021,
                        0.076
                      ],
                      [
                        -0.012,
                        0.078
                      ],
                      [
                        0.001,
                        0.038
                      ],
                      [
                        0.011,
                        0.04
                      ],
                      [
                        0.009,
                        0.049
                      ],
                      [
                        0.001,
                        0.033
                      ],
                      [
                        0.004,
                        0.012
                      ],
                      [
                        0.021,
                        0.077
                      ],
                      [
                        0.015,
                        0.04
                      ],
                      [
                        0.013,
                        0.036
                      ],
                      [
                        0.023,
                        0.048
                      ],
                      [
                        0.009,
                        0.03
                      ],
                      [
                        0.021,
                        0.034
                      ],
                      [
                        0.021,
                        0.036
                      ],
                      [
                        0.032,
                        0.043
                      ],
                      [
                        0.017,
                        0.027
                      ],
                      [
                        0.038,
                        0.042
                      ],
                      [
                        0.026,
                        0.016
                      ],
                      [
                        0.04,
                        0.037
                      ],
                      [
                        0.02,
                        0.023
                      ],
                      [
                        0.049,
                        0.037
                      ],
                      [
                        0.025,
                        0.013
                      ],
                      [
                        0.046,
                        0.028
                      ],
                      [
                        0.022,
                        0.023
                      ],
                      [
                        0.046,
                        0.023
                      ],
                      [
                        0.028,
                        0.016
                      ],
                      [
                        0.053,
                        0.021
                      ],
                      [
                        0.029,
                        0.004
                      ],
                      [
                        0.046,
                        0.015
                      ],
                      [
                        0.032,
                        0.011
                      ],
                      [
                        0.052,
                        0.011
                      ],
                      [
                        0.032,
                        0.001
                      ],
                      [
                        0.059,
                        0.015
                      ],
                      [
                        0.034,
                        0.006
                      ],
                      [
                        0.029,
                        -0.012
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.001,
                        0.023
                      ],
                      [
                        0.035,
                        0.015
                      ],
                      [
                        0.045,
                        -0.014
                      ],
                      [
                        0.045,
                        -0.008
                      ],
                      [
                        0.035,
                        -0.003
                      ],
                      [
                        0.05,
                        -0.014
                      ],
                      [
                        0.032,
                        -0.003
                      ],
                      [
                        0.048,
                        -0.018
                      ],
                      [
                        0.032,
                        -0.009
                      ],
                      [
                        0.053,
                        -0.025
                      ],
                      [
                        0.023,
                        -0.02
                      ],
                      [
                        0.045,
                        -0.028
                      ],
                      [
                        0.028,
                        -0.012
                      ],
                      [
                        0.031,
                        -0.024
                      ],
                      [
                        0.033,
                        -0.025
                      ],
                      [
                        0.042,
                        -0.038
                      ],
                      [
                        0.02,
                        -0.021
                      ],
                      [
                        0.037,
                        -0.041
                      ],
                      [
                        0.023,
                        -0.019
                      ],
                      [
                        0.034,
                        -0.044
                      ],
                      [
                        0.019,
                        -0.023
                      ],
                      [
                        0.03,
                        -0.049
                      ],
                      [
                        0.015,
                        -0.024
                      ],
                      [
                        0.026,
                        -0.052
                      ],
                      [
                        0.011,
                        -0.026
                      ],
                      [
                        0.019,
                        -0.049
                      ],
                      [
                        0.014,
                        -0.027
                      ],
                      [
                        0.021,
                        -0.069
                      ],
                      [
                        0.006,
                        -0.022
                      ],
                      [
                        0.013,
                        -0.058
                      ],
                      [
                        0,
                        -0.029
                      ],
                      [
                        0.003,
                        -0.013
                      ],
                      [
                        0.007,
                        -0.035
                      ],
                      [
                        0.01,
                        -0.039
                      ],
                      [
                        0.003,
                        -0.061
                      ]
                    ],
                    "v": [
                      [
                        2.486,
                        -0.05
                      ],
                      [
                        2.469,
                        -0.163
                      ],
                      [
                        2.459,
                        -0.397
                      ],
                      [
                        2.435,
                        -0.509
                      ],
                      [
                        2.4,
                        -0.624
                      ],
                      [
                        2.331,
                        -0.847
                      ],
                      [
                        2.306,
                        -0.949
                      ],
                      [
                        2.267,
                        -1.075
                      ],
                      [
                        2.197,
                        -1.177
                      ],
                      [
                        2.128,
                        -1.266
                      ],
                      [
                        2.083,
                        -1.36
                      ],
                      [
                        2.02,
                        -1.475
                      ],
                      [
                        1.854,
                        -1.642
                      ],
                      [
                        1.793,
                        -1.731
                      ],
                      [
                        1.714,
                        -1.833
                      ],
                      [
                        1.611,
                        -1.9
                      ],
                      [
                        1.51,
                        -1.957
                      ],
                      [
                        1.424,
                        -2.028
                      ],
                      [
                        1.423,
                        -2.028
                      ],
                      [
                        1.326,
                        -2.098
                      ],
                      [
                        1.23,
                        -2.16
                      ],
                      [
                        1.127,
                        -2.221
                      ],
                      [
                        1.023,
                        -2.268
                      ],
                      [
                        0.911,
                        -2.312
                      ],
                      [
                        0.689,
                        -2.389
                      ],
                      [
                        0.588,
                        -2.427
                      ],
                      [
                        0.467,
                        -2.467
                      ],
                      [
                        0.375,
                        -2.481
                      ],
                      [
                        0.234,
                        -2.5
                      ],
                      [
                        0.118,
                        -2.492
                      ],
                      [
                        -0.002,
                        -2.483
                      ],
                      [
                        -0.115,
                        -2.485
                      ],
                      [
                        -0.236,
                        -2.487
                      ],
                      [
                        -0.346,
                        -2.48
                      ],
                      [
                        -0.473,
                        -2.47
                      ],
                      [
                        -0.583,
                        -2.428
                      ],
                      [
                        -0.693,
                        -2.383
                      ],
                      [
                        -0.792,
                        -2.359
                      ],
                      [
                        -0.922,
                        -2.325
                      ],
                      [
                        -1.135,
                        -2.227
                      ],
                      [
                        -1.232,
                        -2.166
                      ],
                      [
                        -1.331,
                        -2.097
                      ],
                      [
                        -1.424,
                        -2.033
                      ],
                      [
                        -1.521,
                        -1.962
                      ],
                      [
                        -1.609,
                        -1.89
                      ],
                      [
                        -1.699,
                        -1.809
                      ],
                      [
                        -1.864,
                        -1.643
                      ],
                      [
                        -2.023,
                        -1.471
                      ],
                      [
                        -2.152,
                        -1.272
                      ],
                      [
                        -2.199,
                        -1.16
                      ],
                      [
                        -2.236,
                        -1.052
                      ],
                      [
                        -2.34,
                        -0.842
                      ],
                      [
                        -2.424,
                        -0.622
                      ],
                      [
                        -2.439,
                        -0.507
                      ],
                      [
                        -2.443,
                        -0.386
                      ],
                      [
                        -2.484,
                        -0.154
                      ],
                      [
                        -2.501,
                        0.081
                      ],
                      [
                        -2.48,
                        0.194
                      ],
                      [
                        -2.454,
                        0.313
                      ],
                      [
                        -2.443,
                        0.417
                      ],
                      [
                        -2.426,
                        0.546
                      ],
                      [
                        -2.417,
                        0.579
                      ],
                      [
                        -2.361,
                        0.771
                      ],
                      [
                        -2.329,
                        0.858
                      ],
                      [
                        -2.277,
                        0.99
                      ],
                      [
                        -2.238,
                        1.092
                      ],
                      [
                        -2.189,
                        1.208
                      ],
                      [
                        -2.144,
                        1.283
                      ],
                      [
                        -2.066,
                        1.409
                      ],
                      [
                        -2.003,
                        1.5
                      ],
                      [
                        -1.93,
                        1.603
                      ],
                      [
                        -1.84,
                        1.676
                      ],
                      [
                        -1.745,
                        1.752
                      ],
                      [
                        -1.667,
                        1.831
                      ],
                      [
                        -1.581,
                        1.918
                      ],
                      [
                        -1.48,
                        1.982
                      ],
                      [
                        -1.383,
                        2.045
                      ],
                      [
                        -1.296,
                        2.114
                      ],
                      [
                        -1.199,
                        2.192
                      ],
                      [
                        -1.105,
                        2.242
                      ],
                      [
                        -0.99,
                        2.302
                      ],
                      [
                        -0.877,
                        2.332
                      ],
                      [
                        -0.76,
                        2.361
                      ],
                      [
                        -0.665,
                        2.395
                      ],
                      [
                        -0.538,
                        2.435
                      ],
                      [
                        -0.426,
                        2.447
                      ],
                      [
                        -0.305,
                        2.466
                      ],
                      [
                        -0.18,
                        2.496
                      ],
                      [
                        -0.079,
                        2.479
                      ],
                      [
                        -0.006,
                        2.423
                      ],
                      [
                        0.003,
                        2.423
                      ],
                      [
                        0.07,
                        2.487
                      ],
                      [
                        0.18,
                        2.488
                      ],
                      [
                        0.318,
                        2.452
                      ],
                      [
                        0.415,
                        2.439
                      ],
                      [
                        0.549,
                        2.416
                      ],
                      [
                        0.654,
                        2.397
                      ],
                      [
                        0.779,
                        2.37
                      ],
                      [
                        0.879,
                        2.337
                      ],
                      [
                        1.001,
                        2.294
                      ],
                      [
                        1.099,
                        2.229
                      ],
                      [
                        1.198,
                        2.161
                      ],
                      [
                        1.295,
                        2.111
                      ],
                      [
                        1.405,
                        2.053
                      ],
                      [
                        1.473,
                        2.002
                      ],
                      [
                        1.592,
                        1.911
                      ],
                      [
                        1.672,
                        1.83
                      ],
                      [
                        1.756,
                        1.745
                      ],
                      [
                        1.835,
                        1.666
                      ],
                      [
                        1.922,
                        1.58
                      ],
                      [
                        1.993,
                        1.493
                      ],
                      [
                        2.07,
                        1.397
                      ],
                      [
                        2.128,
                        1.296
                      ],
                      [
                        2.188,
                        1.194
                      ],
                      [
                        2.236,
                        1.087
                      ],
                      [
                        2.284,
                        0.98
                      ],
                      [
                        2.329,
                        0.881
                      ],
                      [
                        2.381,
                        0.766
                      ],
                      [
                        2.417,
                        0.632
                      ],
                      [
                        2.441,
                        0.538
                      ],
                      [
                        2.452,
                        0.42
                      ],
                      [
                        2.46,
                        0.304
                      ],
                      [
                        2.465,
                        0.27
                      ],
                      [
                        2.482,
                        0.191
                      ],
                      [
                        2.499,
                        0.071
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 2",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.169000004787,
                    0.161000001197,
                    0.176000004189,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    43.501,
                    31.501
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 380.1,
                      "s": [
                        0,
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 384.769,
                      "s": [
                        120,
                        120
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 389.439,
                      "s": [
                        100,
                        100
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 400.331,
                      "s": [
                        100,
                        100
                      ]
                    },
                    {
                      "t": 405.000016495988,
                      "s": [
                        0,
                        0
                      ]
                    }
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 4",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 248.000010101247,
        "op": 1863.50007590191,
        "st": 248.000010101247,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 6,
        "ty": 4,
        "nm": "Dashboard",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 289,
                "s": [
                  0
                ]
              },
              {
                "t": 296.000012056327,
                "s": [
                  100
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.1,
                  "y": 1
                },
                "o": {
                  "x": 0.9,
                  "y": 0
                },
                "t": 429,
                "s": [
                  296,
                  342,
                  0
                ],
                "to": [
                  0,
                  86.833,
                  0
                ],
                "ti": [
                  0,
                  -86.833,
                  0
                ]
              },
              {
                "t": 459.000018695453,
                "s": [
                  296,
                  863,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              240,
              224.5,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0.167
                  ]
                },
                "t": 289,
                "s": [
                  90,
                  90,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0.167
                  ]
                },
                "t": 298,
                "s": [
                  103,
                  103,
                  100
                ]
              },
              {
                "t": 304.000012382174,
                "s": [
                  100,
                  100,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 25,
            "nm": "Drop Shadow",
            "np": 8,
            "mn": "ADBE Drop Shadow",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 2,
                "nm": "Shadow Color",
                "mn": "ADBE Drop Shadow-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Opacity",
                "mn": "ADBE Drop Shadow-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 30.6
                }
              },
              {
                "ty": 0,
                "nm": "Direction",
                "mn": "ADBE Drop Shadow-0003",
                "ix": 3,
                "v": {
                  "a": 0,
                  "k": 135
                }
              },
              {
                "ty": 0,
                "nm": "Distance",
                "mn": "ADBE Drop Shadow-0004",
                "ix": 4,
                "v": {
                  "a": 0,
                  "k": 3
                }
              },
              {
                "ty": 0,
                "nm": "Softness",
                "mn": "ADBE Drop Shadow-0005",
                "ix": 5,
                "v": {
                  "a": 0,
                  "k": 40
                }
              },
              {
                "ty": 7,
                "nm": "Shadow Only",
                "mn": "ADBE Drop Shadow-0006",
                "ix": 6,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.833,
                        "y": 1
                      },
                      "o": {
                        "x": 0.167,
                        "y": 0
                      },
                      "t": 364,
                      "s": [
                        {
                          "i": [
                            [
                              -2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.209
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.209
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.209
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.209
                            ]
                          ],
                          "v": [
                            [
                              -80,
                              -10.5
                            ],
                            [
                              -74.987,
                              -10.194
                            ],
                            [
                              -70.987,
                              -6.194
                            ],
                            [
                              -70.987,
                              6.806
                            ],
                            [
                              -74.987,
                              10.806
                            ],
                            [
                              -80,
                              10.5
                            ],
                            [
                              -84,
                              6.5
                            ],
                            [
                              -84,
                              -6.5
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "t": 379.000015436986,
                      "s": [
                        {
                          "i": [
                            [
                              -2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.209
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.209
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.209
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.209
                            ]
                          ],
                          "v": [
                            [
                              -80,
                              -10.5
                            ],
                            [
                              80,
                              -10.5
                            ],
                            [
                              84,
                              -6.5
                            ],
                            [
                              84,
                              6.5
                            ],
                            [
                              80,
                              10.5
                            ],
                            [
                              -80,
                              10.5
                            ],
                            [
                              -84,
                              6.5
                            ],
                            [
                              -84,
                              -6.5
                            ]
                          ],
                          "c": true
                        }
                      ]
                    }
                  ]
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.875,
                    0.889999988032,
                    0.925,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    146.059,
                    140.027
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 364,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 372.000015151871,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.833,
                        "y": 1
                      },
                      "o": {
                        "x": 0.167,
                        "y": 0
                      },
                      "t": 364,
                      "s": [
                        {
                          "i": [
                            [
                              -2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.209
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.209
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.209
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.209
                            ]
                          ],
                          "v": [
                            [
                              -109.5,
                              -10.5
                            ],
                            [
                              -105.566,
                              -10.548
                            ],
                            [
                              -101.566,
                              -6.548
                            ],
                            [
                              -101.566,
                              6.452
                            ],
                            [
                              -105.566,
                              10.452
                            ],
                            [
                              -109.5,
                              10.5
                            ],
                            [
                              -113.5,
                              6.5
                            ],
                            [
                              -113.5,
                              -6.5
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "t": 379.000015436986,
                      "s": [
                        {
                          "i": [
                            [
                              -2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.209
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.209
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.209
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.209,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.209
                            ]
                          ],
                          "v": [
                            [
                              -109.5,
                              -10.5
                            ],
                            [
                              109.5,
                              -10.5
                            ],
                            [
                              113.5,
                              -6.5
                            ],
                            [
                              113.5,
                              6.5
                            ],
                            [
                              109.5,
                              10.5
                            ],
                            [
                              -109.5,
                              10.5
                            ],
                            [
                              -113.5,
                              6.5
                            ],
                            [
                              -113.5,
                              -6.5
                            ]
                          ],
                          "c": true
                        }
                      ]
                    }
                  ]
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.875,
                    0.889999988032,
                    0.925,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    175.559,
                    169.027
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 364,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 372.000015151871,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -2.498,
                            1.442
                          ],
                          [
                            -1.442,
                            -2.497
                          ],
                          [
                            2.498,
                            -1.441
                          ],
                          [
                            1.443,
                            2.498
                          ]
                        ],
                        "o": [
                          [
                            2.498,
                            -1.442
                          ],
                          [
                            1.443,
                            2.498
                          ],
                          [
                            -2.498,
                            1.443
                          ],
                          [
                            -1.442,
                            -2.498
                          ]
                        ],
                        "v": [
                          [
                            -2.611,
                            -4.523
                          ],
                          [
                            4.523,
                            -2.612
                          ],
                          [
                            2.612,
                            4.522
                          ],
                          [
                            -4.523,
                            2.611
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        108.861,
                        135.717
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 6",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -9.991,
                            5.769
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            9.991,
                            -5.769
                          ]
                        ],
                        "o": [
                          [
                            -5.769,
                            -9.992
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            5.769,
                            9.992
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -15.453,
                            20.983
                          ],
                          [
                            -7.807,
                            -7.553
                          ],
                          [
                            15.454,
                            -20.983
                          ],
                          [
                            7.808,
                            7.553
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.118000000598,
                        0.231000010173,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 2",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.118000000598,
                        0.231000010173,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        102.187,
                        139.473
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 7",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -2.498,
                            1.442
                          ],
                          [
                            -1.442,
                            -2.498
                          ],
                          [
                            2.498,
                            -1.442
                          ],
                          [
                            1.443,
                            2.498
                          ]
                        ],
                        "o": [
                          [
                            2.498,
                            -1.442
                          ],
                          [
                            1.443,
                            2.498
                          ],
                          [
                            -2.498,
                            1.442
                          ],
                          [
                            -1.442,
                            -2.498
                          ]
                        ],
                        "v": [
                          [
                            -2.611,
                            -4.523
                          ],
                          [
                            4.523,
                            -2.611
                          ],
                          [
                            2.612,
                            4.523
                          ],
                          [
                            -4.523,
                            2.611
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        89.464,
                        116.319
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 8",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -9.991,
                            5.768
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            9.991,
                            -5.769
                          ]
                        ],
                        "o": [
                          [
                            -5.769,
                            -9.991
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            5.769,
                            9.992
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -15.453,
                            20.983
                          ],
                          [
                            -7.807,
                            -7.553
                          ],
                          [
                            15.454,
                            -20.983
                          ],
                          [
                            7.808,
                            7.554
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.118000000598,
                        0.231000010173,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 2",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.118000000598,
                        0.231000010173,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        97.785,
                        112.261
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 9",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    82.24,
                    81.111
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    99.986,
                    125.867
                  ]
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.5,
                          0.5
                        ],
                        "y": [
                          1,
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.5,
                          0.5
                        ],
                        "y": [
                          0,
                          0
                        ]
                      },
                      "t": 369,
                      "s": [
                        80,
                        80
                      ]
                    },
                    {
                      "t": 379.000015436986,
                      "s": [
                        84.949,
                        84.949
                      ]
                    }
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 369,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 379.000015436986,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 11",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        1.542,
                        0
                      ],
                      [
                        0,
                        2.112
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.634,
                        0
                      ],
                      [
                        0,
                        -2.111
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -1.432,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.074
                      ],
                      [
                        1.615,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        2.147
                      ]
                    ],
                    "v": [
                      [
                        75.074,
                        5.35
                      ],
                      [
                        72.577,
                        2.23
                      ],
                      [
                        72.577,
                        2.083
                      ],
                      [
                        75.166,
                        -1.128
                      ],
                      [
                        77.754,
                        2.028
                      ],
                      [
                        77.754,
                        2.175
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -2.404,
                        0
                      ],
                      [
                        -0.514,
                        0.955
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.56,
                        0
                      ],
                      [
                        0,
                        -3.066
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        1.414,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.532,
                        -0.954
                      ],
                      [
                        -2.496,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        3.12
                      ]
                    ],
                    "v": [
                      [
                        74.523,
                        7.113
                      ],
                      [
                        77.68,
                        5.313
                      ],
                      [
                        77.68,
                        6.929
                      ],
                      [
                        79.901,
                        6.929
                      ],
                      [
                        79.901,
                        -7.113
                      ],
                      [
                        77.68,
                        -7.113
                      ],
                      [
                        77.68,
                        -1.202
                      ],
                      [
                        74.615,
                        -2.873
                      ],
                      [
                        70.301,
                        2.139
                      ],
                      [
                        70.301,
                        2.286
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 2",
                "hd": false
              },
              {
                "ind": 2,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.946,
                        0.018
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.605,
                        -1.211
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.038
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.615,
                        0.018
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        64.019,
                        6.929
                      ],
                      [
                        66.24,
                        6.929
                      ],
                      [
                        66.24,
                        1.937
                      ],
                      [
                        69.36,
                        -0.744
                      ],
                      [
                        69.36,
                        -2.818
                      ],
                      [
                        66.24,
                        -0.873
                      ],
                      [
                        66.24,
                        -2.671
                      ],
                      [
                        64.019,
                        -2.671
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 3",
                "hd": false
              },
              {
                "ind": 3,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        1.359,
                        0
                      ],
                      [
                        0,
                        0.808
                      ],
                      [
                        -1.688,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -1.101,
                        0
                      ],
                      [
                        0,
                        -1.175
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        1.229
                      ]
                    ],
                    "v": [
                      [
                        57.093,
                        5.515
                      ],
                      [
                        55.552,
                        4.175
                      ],
                      [
                        58.323,
                        2.615
                      ],
                      [
                        59.461,
                        2.615
                      ],
                      [
                        59.461,
                        3.57
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 4",
                "hd": false
              },
              {
                "ind": 4,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -1.762,
                        0
                      ],
                      [
                        -0.624,
                        0.826
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.148,
                        0
                      ],
                      [
                        0.184,
                        -2.239
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.157,
                        0
                      ],
                      [
                        0,
                        -1.286
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.239
                      ]
                    ],
                    "o": [
                      [
                        1.469,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.625
                      ],
                      [
                        -2.148,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.11,
                        -0.954
                      ],
                      [
                        1.303,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.753,
                        0
                      ],
                      [
                        0,
                        2.001
                      ]
                    ],
                    "v": [
                      [
                        56.561,
                        7.113
                      ],
                      [
                        59.498,
                        5.755
                      ],
                      [
                        59.498,
                        6.929
                      ],
                      [
                        61.682,
                        6.929
                      ],
                      [
                        61.682,
                        0.633
                      ],
                      [
                        57.846,
                        -2.873
                      ],
                      [
                        53.734,
                        0.303
                      ],
                      [
                        55.882,
                        0.303
                      ],
                      [
                        57.718,
                        -1.202
                      ],
                      [
                        59.461,
                        0.725
                      ],
                      [
                        59.461,
                        1.221
                      ],
                      [
                        58.268,
                        1.221
                      ],
                      [
                        53.349,
                        4.268
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 5",
                "hd": false
              },
              {
                "ind": 5,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -2.826,
                        0
                      ],
                      [
                        0,
                        2.991
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.808,
                        0
                      ],
                      [
                        0,
                        -2.974
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        2.827,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.937
                      ],
                      [
                        -2.827,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        2.919
                      ]
                    ],
                    "v": [
                      [
                        47.311,
                        7.113
                      ],
                      [
                        52.249,
                        2.175
                      ],
                      [
                        52.249,
                        2.028
                      ],
                      [
                        47.33,
                        -2.873
                      ],
                      [
                        42.392,
                        2.083
                      ],
                      [
                        42.392,
                        2.23
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 6",
                "hd": false
              },
              {
                "ind": 6,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        1.652,
                        0
                      ],
                      [
                        0,
                        1.964
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.652,
                        0
                      ],
                      [
                        0,
                        -1.982
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -1.689,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.983
                      ],
                      [
                        1.652,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        1.964
                      ]
                    ],
                    "v": [
                      [
                        47.33,
                        5.387
                      ],
                      [
                        44.668,
                        2.193
                      ],
                      [
                        44.668,
                        2.046
                      ],
                      [
                        47.33,
                        -1.128
                      ],
                      [
                        49.973,
                        2.064
                      ],
                      [
                        49.973,
                        2.193
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 7",
                "hd": false
              },
              {
                "ind": 7,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        1.633,
                        0
                      ],
                      [
                        0,
                        2.148
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.542,
                        0
                      ],
                      [
                        0,
                        -2.129
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -1.616,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.129
                      ],
                      [
                        1.45,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        2.056
                      ]
                    ],
                    "v": [
                      [
                        36.438,
                        5.35
                      ],
                      [
                        33.776,
                        2.193
                      ],
                      [
                        33.776,
                        2.046
                      ],
                      [
                        36.419,
                        -1.128
                      ],
                      [
                        38.971,
                        2.046
                      ],
                      [
                        38.971,
                        2.193
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 8",
                "hd": false
              },
              {
                "ind": 8,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -1.523,
                        0
                      ],
                      [
                        0,
                        3.084
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.405,
                        0
                      ],
                      [
                        0.533,
                        -0.918
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        2.478,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -3.102
                      ],
                      [
                        -1.413,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.514,
                        0.973
                      ]
                    ],
                    "v": [
                      [
                        36.988,
                        7.113
                      ],
                      [
                        41.247,
                        2.157
                      ],
                      [
                        41.247,
                        2.01
                      ],
                      [
                        36.988,
                        -2.873
                      ],
                      [
                        33.849,
                        -1.128
                      ],
                      [
                        33.849,
                        -7.113
                      ],
                      [
                        31.628,
                        -7.113
                      ],
                      [
                        31.628,
                        6.929
                      ],
                      [
                        33.849,
                        6.929
                      ],
                      [
                        33.849,
                        5.387
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 9",
                "hd": false
              },
              {
                "ind": 9,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.248,
                        0
                      ],
                      [
                        0,
                        -1.45
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.927,
                        0
                      ],
                      [
                        0.459,
                        -0.936
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.524
                      ],
                      [
                        1.322,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.644
                      ],
                      [
                        -1.579,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        20.67,
                        6.929
                      ],
                      [
                        22.891,
                        6.929
                      ],
                      [
                        22.891,
                        1.275
                      ],
                      [
                        25.149,
                        -1.02
                      ],
                      [
                        27.058,
                        1.092
                      ],
                      [
                        27.058,
                        6.929
                      ],
                      [
                        29.279,
                        6.929
                      ],
                      [
                        29.279,
                        0.89
                      ],
                      [
                        25.994,
                        -2.873
                      ],
                      [
                        22.891,
                        -1.148
                      ],
                      [
                        22.891,
                        -7.113
                      ],
                      [
                        20.67,
                        -7.113
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 10",
                "hd": false
              },
              {
                "ind": 10,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -2.478,
                        0
                      ],
                      [
                        0,
                        1.946
                      ],
                      [
                        2.258,
                        0.348
                      ],
                      [
                        0,
                        0.698
                      ],
                      [
                        -0.954,
                        0
                      ],
                      [
                        -0.183,
                        -0.881
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.964,
                        0
                      ],
                      [
                        0,
                        -1.928
                      ],
                      [
                        -2.534,
                        -0.404
                      ],
                      [
                        0,
                        -0.79
                      ],
                      [
                        1.193,
                        0
                      ],
                      [
                        0.11,
                        0.974
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        2.46,
                        0
                      ],
                      [
                        0,
                        -2.038
                      ],
                      [
                        -1.524,
                        -0.257
                      ],
                      [
                        0,
                        -0.679
                      ],
                      [
                        1.028,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.239,
                        -2.166
                      ],
                      [
                        -1.799,
                        0
                      ],
                      [
                        0,
                        1.799
                      ],
                      [
                        1.413,
                        0.239
                      ],
                      [
                        0,
                        0.808
                      ],
                      [
                        -1.303,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.092,
                        2.038
                      ]
                    ],
                    "v": [
                      [
                        15.095,
                        7.113
                      ],
                      [
                        18.932,
                        4.048
                      ],
                      [
                        15.334,
                        1.11
                      ],
                      [
                        13.351,
                        -0.119
                      ],
                      [
                        14.875,
                        -1.257
                      ],
                      [
                        16.582,
                        0.027
                      ],
                      [
                        18.638,
                        0.027
                      ],
                      [
                        14.875,
                        -2.873
                      ],
                      [
                        11.277,
                        0.01
                      ],
                      [
                        14.747,
                        2.928
                      ],
                      [
                        16.802,
                        4.249
                      ],
                      [
                        15.077,
                        5.479
                      ],
                      [
                        13.168,
                        3.937
                      ],
                      [
                        11.075,
                        3.937
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 11",
                "hd": false
              },
              {
                "ind": 11,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        1.358,
                        0
                      ],
                      [
                        0,
                        0.808
                      ],
                      [
                        -1.688,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -1.102,
                        0
                      ],
                      [
                        0,
                        -1.175
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        1.229
                      ]
                    ],
                    "v": [
                      [
                        4.885,
                        5.515
                      ],
                      [
                        3.343,
                        4.175
                      ],
                      [
                        6.114,
                        2.615
                      ],
                      [
                        7.252,
                        2.615
                      ],
                      [
                        7.252,
                        3.57
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 12",
                "hd": false
              },
              {
                "ind": 12,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -1.762,
                        0
                      ],
                      [
                        -0.624,
                        0.826
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.148,
                        0
                      ],
                      [
                        0.184,
                        -2.239
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.157,
                        0
                      ],
                      [
                        0,
                        -1.286
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.239
                      ]
                    ],
                    "o": [
                      [
                        1.469,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.625
                      ],
                      [
                        -2.148,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.11,
                        -0.954
                      ],
                      [
                        1.303,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.753,
                        0
                      ],
                      [
                        0,
                        2.001
                      ]
                    ],
                    "v": [
                      [
                        4.352,
                        7.113
                      ],
                      [
                        7.289,
                        5.755
                      ],
                      [
                        7.289,
                        6.929
                      ],
                      [
                        9.473,
                        6.929
                      ],
                      [
                        9.473,
                        0.633
                      ],
                      [
                        5.637,
                        -2.873
                      ],
                      [
                        1.525,
                        0.303
                      ],
                      [
                        3.673,
                        0.303
                      ],
                      [
                        5.509,
                        -1.202
                      ],
                      [
                        7.252,
                        0.725
                      ],
                      [
                        7.252,
                        1.221
                      ],
                      [
                        6.059,
                        1.221
                      ],
                      [
                        1.14,
                        4.268
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 13",
                "hd": false
              },
              {
                "ind": 13,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        3.818
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4.571,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        4.607,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -3.818
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -10.873,
                        6.929
                      ],
                      [
                        -6.926,
                        6.929
                      ],
                      [
                        -0.098,
                        0.394
                      ],
                      [
                        -0.098,
                        0.23
                      ],
                      [
                        -6.89,
                        -6.196
                      ],
                      [
                        -10.873,
                        -6.196
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 14",
                "hd": false
              },
              {
                "ind": 14,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.827
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.937,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        3.084,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        2.899
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -8.432,
                        5.001
                      ],
                      [
                        -8.432,
                        -4.268
                      ],
                      [
                        -7.018,
                        -4.268
                      ],
                      [
                        -2.65,
                        0.266
                      ],
                      [
                        -2.65,
                        0.413
                      ],
                      [
                        -7,
                        5.001
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 15",
                "hd": false
              },
              {
                "ind": 15,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.945,
                        0.018
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.606,
                        -1.211
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.038
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.615,
                        0.018
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -22.307,
                        6.929
                      ],
                      [
                        -20.086,
                        6.929
                      ],
                      [
                        -20.086,
                        1.937
                      ],
                      [
                        -16.966,
                        -0.744
                      ],
                      [
                        -16.966,
                        -2.818
                      ],
                      [
                        -20.086,
                        -0.873
                      ],
                      [
                        -20.086,
                        -2.671
                      ],
                      [
                        -22.307,
                        -2.671
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 16",
                "hd": false
              },
              {
                "ind": 16,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -1.34,
                        0
                      ],
                      [
                        -0.11,
                        -1.652
                      ]
                    ],
                    "o": [
                      [
                        0.22,
                        -1.486
                      ],
                      [
                        1.376,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -31.075,
                        1.128
                      ],
                      [
                        -28.615,
                        -1.257
                      ],
                      [
                        -26.284,
                        1.128
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 17",
                "hd": false
              },
              {
                "ind": 17,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -2.827,
                        0
                      ],
                      [
                        -0.312,
                        2.019
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.34,
                        0
                      ],
                      [
                        0.074,
                        1.817
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.386,
                        0
                      ],
                      [
                        0,
                        -2.974
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        2.459,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.165,
                        0.936
                      ],
                      [
                        -1.652,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -3.433
                      ],
                      [
                        -2.735,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        3.029
                      ]
                    ],
                    "v": [
                      [
                        -28.523,
                        7.113
                      ],
                      [
                        -24.118,
                        3.993
                      ],
                      [
                        -26.266,
                        3.993
                      ],
                      [
                        -28.468,
                        5.46
                      ],
                      [
                        -31.112,
                        2.615
                      ],
                      [
                        -24.081,
                        2.615
                      ],
                      [
                        -24.081,
                        1.973
                      ],
                      [
                        -28.615,
                        -2.873
                      ],
                      [
                        -33.387,
                        2.083
                      ],
                      [
                        -33.387,
                        2.23
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 18",
                "hd": false
              },
              {
                "ind": 18,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -41.983,
                        6.929
                      ],
                      [
                        -39.761,
                        6.929
                      ],
                      [
                        -39.761,
                        2.212
                      ],
                      [
                        -36.164,
                        6.929
                      ],
                      [
                        -33.594,
                        6.929
                      ],
                      [
                        -37.632,
                        1.734
                      ],
                      [
                        -33.906,
                        -2.671
                      ],
                      [
                        -36.329,
                        -2.671
                      ],
                      [
                        -39.761,
                        1.55
                      ],
                      [
                        -39.761,
                        -7.113
                      ],
                      [
                        -41.983,
                        -7.113
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 19",
                "hd": false
              },
              {
                "ind": 19,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -2.753,
                        0
                      ],
                      [
                        -0.166,
                        2.202
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.175,
                        0
                      ],
                      [
                        0,
                        2.093
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.523,
                        0
                      ],
                      [
                        -0.184,
                        -1.286
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.13,
                        0
                      ],
                      [
                        0,
                        -3.047
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        2.607,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.128,
                        1.357
                      ],
                      [
                        -1.633,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.982
                      ],
                      [
                        1.175,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.257,
                        -2.644
                      ],
                      [
                        -2.679,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        3.065
                      ]
                    ],
                    "v": [
                      [
                        -48.128,
                        7.113
                      ],
                      [
                        -43.685,
                        3.35
                      ],
                      [
                        -45.723,
                        3.35
                      ],
                      [
                        -48.036,
                        5.406
                      ],
                      [
                        -50.697,
                        2.212
                      ],
                      [
                        -50.697,
                        2.064
                      ],
                      [
                        -48.091,
                        -1.093
                      ],
                      [
                        -45.888,
                        0.725
                      ],
                      [
                        -43.74,
                        0.725
                      ],
                      [
                        -48.128,
                        -2.873
                      ],
                      [
                        -52.973,
                        2.101
                      ],
                      [
                        -52.973,
                        2.248
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 20",
                "hd": false
              },
              {
                "ind": 20,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        1.358,
                        0
                      ],
                      [
                        0,
                        0.808
                      ],
                      [
                        -1.689,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -1.102,
                        0
                      ],
                      [
                        0,
                        -1.175
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        1.229
                      ]
                    ],
                    "v": [
                      [
                        -59.256,
                        5.515
                      ],
                      [
                        -60.798,
                        4.175
                      ],
                      [
                        -58.026,
                        2.615
                      ],
                      [
                        -56.888,
                        2.615
                      ],
                      [
                        -56.888,
                        3.57
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 21",
                "hd": false
              },
              {
                "ind": 21,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -1.763,
                        0
                      ],
                      [
                        -0.625,
                        0.826
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.148,
                        0
                      ],
                      [
                        0.184,
                        -2.239
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.156,
                        0
                      ],
                      [
                        0,
                        -1.286
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.239
                      ]
                    ],
                    "o": [
                      [
                        1.468,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.625
                      ],
                      [
                        -2.147,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.11,
                        -0.954
                      ],
                      [
                        1.303,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.754,
                        0
                      ],
                      [
                        0,
                        2.001
                      ]
                    ],
                    "v": [
                      [
                        -59.788,
                        7.113
                      ],
                      [
                        -56.851,
                        5.755
                      ],
                      [
                        -56.851,
                        6.929
                      ],
                      [
                        -54.667,
                        6.929
                      ],
                      [
                        -54.667,
                        0.633
                      ],
                      [
                        -58.504,
                        -2.873
                      ],
                      [
                        -62.615,
                        0.303
                      ],
                      [
                        -60.468,
                        0.303
                      ],
                      [
                        -58.632,
                        -1.202
                      ],
                      [
                        -56.888,
                        0.725
                      ],
                      [
                        -56.888,
                        1.221
                      ],
                      [
                        -58.081,
                        1.221
                      ],
                      [
                        -63.001,
                        4.268
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 22",
                "hd": false
              },
              {
                "ind": 22,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.946,
                        0.018
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.606,
                        -1.211
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.038
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.616,
                        0.018
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -69.21,
                        6.929
                      ],
                      [
                        -66.989,
                        6.929
                      ],
                      [
                        -66.989,
                        1.937
                      ],
                      [
                        -63.868,
                        -0.744
                      ],
                      [
                        -63.868,
                        -2.818
                      ],
                      [
                        -66.989,
                        -0.873
                      ],
                      [
                        -66.989,
                        -2.671
                      ],
                      [
                        -69.21,
                        -2.671
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 23",
                "hd": false
              },
              {
                "ind": 23,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -76.248,
                        6.929
                      ],
                      [
                        -73.789,
                        6.929
                      ],
                      [
                        -73.789,
                        -4.268
                      ],
                      [
                        -70.136,
                        -4.268
                      ],
                      [
                        -70.136,
                        -6.196
                      ],
                      [
                        -79.901,
                        -6.196
                      ],
                      [
                        -79.901,
                        -4.268
                      ],
                      [
                        -76.248,
                        -4.268
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 24",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.1,
                        "y": 1
                      },
                      "o": {
                        "x": 0.9,
                        "y": 0
                      },
                      "t": 349,
                      "s": [
                        111.405,
                        51.7
                      ],
                      "to": [
                        21.229,
                        4.232
                      ],
                      "ti": [
                        -21.229,
                        -4.232
                      ]
                    },
                    {
                      "t": 379.000015436986,
                      "s": [
                        238.78,
                        77.09
                      ]
                    }
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1,
                          0.1
                        ],
                        "y": [
                          1,
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9,
                          0.9
                        ],
                        "y": [
                          0,
                          0
                        ]
                      },
                      "t": 349,
                      "s": [
                        100,
                        100
                      ]
                    },
                    {
                      "t": 379.000015436986,
                      "s": [
                        156.598,
                        156.598
                      ]
                    }
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -2.043,
                            0
                          ],
                          [
                            0,
                            -2.126
                          ],
                          [
                            2.043,
                            0
                          ],
                          [
                            0,
                            2.125
                          ]
                        ],
                        "o": [
                          [
                            2.043,
                            0
                          ],
                          [
                            0,
                            2.125
                          ],
                          [
                            -2.043,
                            0
                          ],
                          [
                            0,
                            -2.126
                          ]
                        ],
                        "v": [
                          [
                            0,
                            -3.849
                          ],
                          [
                            3.699,
                            0.001
                          ],
                          [
                            0,
                            3.849
                          ],
                          [
                            -3.699,
                            0.001
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.964999988032,
                        0.976000019148,
                        0.987999949736,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        39.482,
                        14.038
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -2.043,
                            0
                          ],
                          [
                            0,
                            -2.126
                          ],
                          [
                            2.043,
                            0
                          ],
                          [
                            0,
                            2.125
                          ]
                        ],
                        "o": [
                          [
                            2.043,
                            0
                          ],
                          [
                            0,
                            2.125
                          ],
                          [
                            -2.043,
                            0
                          ],
                          [
                            0,
                            -2.126
                          ]
                        ],
                        "v": [
                          [
                            0,
                            -3.849
                          ],
                          [
                            3.699,
                            0.001
                          ],
                          [
                            0,
                            3.849
                          ],
                          [
                            -3.699,
                            0.001
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.964999988032,
                        0.976000019148,
                        0.987999949736,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        26.487,
                        14.038
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 3",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -2.043,
                            0
                          ],
                          [
                            0,
                            -2.126
                          ],
                          [
                            2.043,
                            0
                          ],
                          [
                            0,
                            2.125
                          ]
                        ],
                        "o": [
                          [
                            2.043,
                            0
                          ],
                          [
                            0,
                            2.125
                          ],
                          [
                            -2.043,
                            0
                          ],
                          [
                            0,
                            -2.126
                          ]
                        ],
                        "v": [
                          [
                            0,
                            -3.849
                          ],
                          [
                            3.699,
                            0.001
                          ],
                          [
                            0,
                            3.849
                          ],
                          [
                            -3.699,
                            0.001
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.964999988032,
                        0.976000019148,
                        0.987999949736,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        13.493,
                        14.038
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 4",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.981,
                            0
                          ],
                          [
                            0,
                            1.556
                          ],
                          [
                            1.806,
                            0.28
                          ],
                          [
                            0,
                            0.558
                          ],
                          [
                            -0.763,
                            0
                          ],
                          [
                            -0.147,
                            -0.705
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.572,
                            0
                          ],
                          [
                            0,
                            -1.542
                          ],
                          [
                            -2.026,
                            -0.323
                          ],
                          [
                            0,
                            -0.631
                          ],
                          [
                            0.955,
                            0
                          ],
                          [
                            0.088,
                            0.778
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            1.968,
                            0
                          ],
                          [
                            0,
                            -1.63
                          ],
                          [
                            -1.219,
                            -0.205
                          ],
                          [
                            0,
                            -0.543
                          ],
                          [
                            0.822,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            -1.733
                          ],
                          [
                            -1.439,
                            0
                          ],
                          [
                            0,
                            1.439
                          ],
                          [
                            1.132,
                            0.191
                          ],
                          [
                            0,
                            0.646
                          ],
                          [
                            -1.042,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.074,
                            1.63
                          ]
                        ],
                        "v": [
                          [
                            37.35,
                            5.69
                          ],
                          [
                            40.418,
                            3.238
                          ],
                          [
                            37.54,
                            0.888
                          ],
                          [
                            35.954,
                            -0.096
                          ],
                          [
                            37.173,
                            -1.006
                          ],
                          [
                            38.539,
                            0.022
                          ],
                          [
                            40.184,
                            0.022
                          ],
                          [
                            37.173,
                            -2.298
                          ],
                          [
                            34.296,
                            0.007
                          ],
                          [
                            37.07,
                            2.342
                          ],
                          [
                            38.716,
                            3.399
                          ],
                          [
                            37.335,
                            4.383
                          ],
                          [
                            35.807,
                            3.15
                          ],
                          [
                            34.134,
                            3.15
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.234,
                            0
                          ],
                          [
                            0,
                            1.689
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.306,
                            0
                          ],
                          [
                            0,
                            -1.689
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -1.145,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.66
                          ],
                          [
                            1.292,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.718
                          ]
                        ],
                        "v": [
                          [
                            28.85,
                            4.28
                          ],
                          [
                            26.854,
                            1.784
                          ],
                          [
                            26.854,
                            1.667
                          ],
                          [
                            28.924,
                            -0.903
                          ],
                          [
                            30.996,
                            1.623
                          ],
                          [
                            30.996,
                            1.74
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 2",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.925,
                            0
                          ],
                          [
                            -0.412,
                            0.764
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.248,
                            0
                          ],
                          [
                            0,
                            -2.453
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            1.129,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.426,
                            -0.764
                          ],
                          [
                            -1.997,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.496
                          ]
                        ],
                        "v": [
                          [
                            28.411,
                            5.69
                          ],
                          [
                            30.936,
                            4.251
                          ],
                          [
                            30.936,
                            5.543
                          ],
                          [
                            32.712,
                            5.543
                          ],
                          [
                            32.712,
                            -5.69
                          ],
                          [
                            30.936,
                            -5.69
                          ],
                          [
                            30.936,
                            -0.962
                          ],
                          [
                            28.483,
                            -2.298
                          ],
                          [
                            25.034,
                            1.711
                          ],
                          [
                            25.034,
                            1.828
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 3",
                    "hd": false
                  },
                  {
                    "ind": 3,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.555,
                            0.015
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.485,
                            -0.969
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.63
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.292,
                            0.014
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            19.943,
                            5.543
                          ],
                          [
                            21.72,
                            5.543
                          ],
                          [
                            21.72,
                            1.549
                          ],
                          [
                            24.216,
                            -0.595
                          ],
                          [
                            24.216,
                            -2.254
                          ],
                          [
                            21.72,
                            -0.698
                          ],
                          [
                            21.72,
                            -2.137
                          ],
                          [
                            19.943,
                            -2.137
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 4",
                    "hd": false
                  },
                  {
                    "ind": 4,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.087,
                            0
                          ],
                          [
                            0,
                            0.647
                          ],
                          [
                            -1.351,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.881,
                            0
                          ],
                          [
                            0,
                            -0.939
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.984
                          ]
                        ],
                        "v": [
                          [
                            14.339,
                            4.413
                          ],
                          [
                            13.106,
                            3.34
                          ],
                          [
                            15.323,
                            2.092
                          ],
                          [
                            16.233,
                            2.092
                          ],
                          [
                            16.233,
                            2.856
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 5",
                    "hd": false
                  },
                  {
                    "ind": 5,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.41,
                            0
                          ],
                          [
                            -0.5,
                            0.66
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.719,
                            0
                          ],
                          [
                            0.147,
                            -1.791
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.925,
                            0
                          ],
                          [
                            0,
                            -1.028
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.791
                          ]
                        ],
                        "o": [
                          [
                            1.175,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.099
                          ],
                          [
                            -1.718,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.087,
                            -0.763
                          ],
                          [
                            1.043,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.202,
                            0
                          ],
                          [
                            0,
                            1.601
                          ]
                        ],
                        "v": [
                          [
                            13.913,
                            5.69
                          ],
                          [
                            16.263,
                            4.604
                          ],
                          [
                            16.263,
                            5.543
                          ],
                          [
                            18.009,
                            5.543
                          ],
                          [
                            18.009,
                            0.506
                          ],
                          [
                            14.941,
                            -2.298
                          ],
                          [
                            11.652,
                            0.242
                          ],
                          [
                            13.371,
                            0.242
                          ],
                          [
                            14.838,
                            -0.962
                          ],
                          [
                            16.233,
                            0.58
                          ],
                          [
                            16.233,
                            0.977
                          ],
                          [
                            15.279,
                            0.977
                          ],
                          [
                            11.343,
                            3.414
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 6",
                    "hd": false
                  },
                  {
                    "ind": 6,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -2.261,
                            0
                          ],
                          [
                            0,
                            2.393
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.247,
                            0
                          ],
                          [
                            0,
                            -2.379
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            2.262,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.35
                          ],
                          [
                            -2.26,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.335
                          ]
                        ],
                        "v": [
                          [
                            6.449,
                            5.69
                          ],
                          [
                            10.4,
                            1.74
                          ],
                          [
                            10.4,
                            1.623
                          ],
                          [
                            6.464,
                            -2.298
                          ],
                          [
                            2.514,
                            1.667
                          ],
                          [
                            2.514,
                            1.784
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 7",
                    "hd": false
                  },
                  {
                    "ind": 7,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.323,
                            0
                          ],
                          [
                            0,
                            1.572
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.321,
                            0
                          ],
                          [
                            0,
                            -1.586
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -1.351,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.586
                          ],
                          [
                            1.323,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.572
                          ]
                        ],
                        "v": [
                          [
                            6.464,
                            4.31
                          ],
                          [
                            4.335,
                            1.754
                          ],
                          [
                            4.335,
                            1.637
                          ],
                          [
                            6.464,
                            -0.903
                          ],
                          [
                            8.579,
                            1.652
                          ],
                          [
                            8.579,
                            1.754
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 8",
                    "hd": false
                  },
                  {
                    "ind": 8,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.307,
                            0
                          ],
                          [
                            0,
                            1.719
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.234,
                            0
                          ],
                          [
                            0,
                            -1.703
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -1.292,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.703
                          ],
                          [
                            1.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.645
                          ]
                        ],
                        "v": [
                          [
                            -2.314,
                            4.28
                          ],
                          [
                            -4.443,
                            1.754
                          ],
                          [
                            -4.443,
                            1.637
                          ],
                          [
                            -2.328,
                            -0.903
                          ],
                          [
                            -0.287,
                            1.637
                          ],
                          [
                            -0.287,
                            1.754
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 9",
                    "hd": false
                  },
                  {
                    "ind": 9,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.219,
                            0
                          ],
                          [
                            0,
                            2.467
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.924,
                            0
                          ],
                          [
                            0.426,
                            -0.735
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            1.982,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.482
                          ],
                          [
                            -1.131,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.411,
                            0.778
                          ]
                        ],
                        "v": [
                          [
                            -1.873,
                            5.69
                          ],
                          [
                            1.535,
                            1.725
                          ],
                          [
                            1.535,
                            1.608
                          ],
                          [
                            -1.873,
                            -2.298
                          ],
                          [
                            -4.384,
                            -0.903
                          ],
                          [
                            -4.384,
                            -5.69
                          ],
                          [
                            -6.161,
                            -5.69
                          ],
                          [
                            -6.161,
                            5.543
                          ],
                          [
                            -4.384,
                            5.543
                          ],
                          [
                            -4.384,
                            4.31
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 10",
                    "hd": false
                  },
                  {
                    "ind": 10,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.999,
                            0
                          ],
                          [
                            0,
                            -1.161
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.542,
                            0
                          ],
                          [
                            0.368,
                            -0.749
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.219
                          ],
                          [
                            1.057,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.114
                          ],
                          [
                            -1.263,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -14.991,
                            5.543
                          ],
                          [
                            -13.215,
                            5.543
                          ],
                          [
                            -13.215,
                            1.021
                          ],
                          [
                            -11.408,
                            -0.815
                          ],
                          [
                            -9.881,
                            0.874
                          ],
                          [
                            -9.881,
                            5.543
                          ],
                          [
                            -8.104,
                            5.543
                          ],
                          [
                            -8.104,
                            0.712
                          ],
                          [
                            -10.733,
                            -2.298
                          ],
                          [
                            -13.215,
                            -0.918
                          ],
                          [
                            -13.215,
                            -5.69
                          ],
                          [
                            -14.991,
                            -5.69
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 11",
                    "hd": false
                  },
                  {
                    "ind": 11,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.983,
                            0
                          ],
                          [
                            0,
                            1.556
                          ],
                          [
                            1.807,
                            0.28
                          ],
                          [
                            0,
                            0.558
                          ],
                          [
                            -0.763,
                            0
                          ],
                          [
                            -0.147,
                            -0.705
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.572,
                            0
                          ],
                          [
                            0,
                            -1.542
                          ],
                          [
                            -2.027,
                            -0.323
                          ],
                          [
                            0,
                            -0.631
                          ],
                          [
                            0.954,
                            0
                          ],
                          [
                            0.088,
                            0.778
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            1.967,
                            0
                          ],
                          [
                            0,
                            -1.63
                          ],
                          [
                            -1.218,
                            -0.205
                          ],
                          [
                            0,
                            -0.543
                          ],
                          [
                            0.823,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.191,
                            -1.733
                          ],
                          [
                            -1.439,
                            0
                          ],
                          [
                            0,
                            1.439
                          ],
                          [
                            1.13,
                            0.191
                          ],
                          [
                            0,
                            0.646
                          ],
                          [
                            -1.043,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.073,
                            1.63
                          ]
                        ],
                        "v": [
                          [
                            -19.515,
                            5.69
                          ],
                          [
                            -16.446,
                            3.238
                          ],
                          [
                            -19.325,
                            0.888
                          ],
                          [
                            -20.91,
                            -0.096
                          ],
                          [
                            -19.692,
                            -1.006
                          ],
                          [
                            -18.326,
                            0.022
                          ],
                          [
                            -16.681,
                            0.022
                          ],
                          [
                            -19.692,
                            -2.298
                          ],
                          [
                            -22.57,
                            0.007
                          ],
                          [
                            -19.794,
                            2.342
                          ],
                          [
                            -18.15,
                            3.399
                          ],
                          [
                            -19.53,
                            4.383
                          ],
                          [
                            -21.057,
                            3.15
                          ],
                          [
                            -22.731,
                            3.15
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 12",
                    "hd": false
                  },
                  {
                    "ind": 12,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.087,
                            0
                          ],
                          [
                            0,
                            0.647
                          ],
                          [
                            -1.351,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.881,
                            0
                          ],
                          [
                            0,
                            -0.939
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.984
                          ]
                        ],
                        "v": [
                          [
                            -27.748,
                            4.413
                          ],
                          [
                            -28.982,
                            3.34
                          ],
                          [
                            -26.764,
                            2.092
                          ],
                          [
                            -25.854,
                            2.092
                          ],
                          [
                            -25.854,
                            2.856
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 13",
                    "hd": false
                  },
                  {
                    "ind": 13,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.41,
                            0
                          ],
                          [
                            -0.5,
                            0.66
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.718,
                            0
                          ],
                          [
                            0.147,
                            -1.791
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.925,
                            0
                          ],
                          [
                            0,
                            -1.028
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.791
                          ]
                        ],
                        "o": [
                          [
                            1.175,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.099
                          ],
                          [
                            -1.718,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.088,
                            -0.763
                          ],
                          [
                            1.043,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.203,
                            0
                          ],
                          [
                            0,
                            1.601
                          ]
                        ],
                        "v": [
                          [
                            -28.174,
                            5.69
                          ],
                          [
                            -25.824,
                            4.604
                          ],
                          [
                            -25.824,
                            5.543
                          ],
                          [
                            -24.077,
                            5.543
                          ],
                          [
                            -24.077,
                            0.506
                          ],
                          [
                            -27.146,
                            -2.298
                          ],
                          [
                            -30.435,
                            0.242
                          ],
                          [
                            -28.717,
                            0.242
                          ],
                          [
                            -27.249,
                            -0.962
                          ],
                          [
                            -25.854,
                            0.58
                          ],
                          [
                            -25.854,
                            0.977
                          ],
                          [
                            -26.808,
                            0.977
                          ],
                          [
                            -30.744,
                            3.414
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 14",
                    "hd": false
                  },
                  {
                    "ind": 14,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.055
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.656,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            3.686,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.055
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -40.418,
                            5.543
                          ],
                          [
                            -37.261,
                            5.543
                          ],
                          [
                            -31.798,
                            0.315
                          ],
                          [
                            -31.798,
                            0.184
                          ],
                          [
                            -37.231,
                            -4.956
                          ],
                          [
                            -40.418,
                            -4.956
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 15",
                    "hd": false
                  },
                  {
                    "ind": 15,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.262
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.35,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.467,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.32
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -38.465,
                            4.002
                          ],
                          [
                            -38.465,
                            -3.414
                          ],
                          [
                            -37.334,
                            -3.414
                          ],
                          [
                            -33.839,
                            0.213
                          ],
                          [
                            -33.839,
                            0.33
                          ],
                          [
                            -37.32,
                            4.002
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 16",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Merge Paths 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.964999988032,
                        0.976000019148,
                        0.987999949736,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        239.863,
                        13.186
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 5",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -2.998,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.998
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            -2.998
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.998,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -240,
                            -8.418
                          ],
                          [
                            -234.572,
                            -13.846
                          ],
                          [
                            234.572,
                            -13.846
                          ],
                          [
                            240,
                            -8.418
                          ],
                          [
                            240,
                            13.846
                          ],
                          [
                            -240,
                            13.846
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.898000021542,
                        0.383999992819,
                        0.517999985639,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        240,
                        13.846
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 6",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    239.863,
                    224.851
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    240,
                    224.5
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 339,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 349.000014215061,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 8",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.1,
                        "y": 1
                      },
                      "o": {
                        "x": 0.9,
                        "y": 0
                      },
                      "t": 349,
                      "s": [
                        {
                          "i": [
                            [
                              -2.998,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.998
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              2.998,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.998
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              2.998,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.998
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.998,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.998
                            ]
                          ],
                          "v": [
                            [
                              -234.572,
                              -224.398
                            ],
                            [
                              234.573,
                              -224.398
                            ],
                            [
                              240,
                              -218.969
                            ],
                            [
                              240,
                              218.969
                            ],
                            [
                              234.573,
                              224.398
                            ],
                            [
                              -234.572,
                              224.398
                            ],
                            [
                              -240,
                              218.969
                            ],
                            [
                              -240,
                              -218.969
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "t": 379.000015436986,
                      "s": [
                        {
                          "i": [
                            [
                              -2.941,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.941
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              2.941,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.941
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              2.941,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              2.941
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.941,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -2.941
                            ]
                          ],
                          "v": [
                            [
                              -194.018,
                              -189.371
                            ],
                            [
                              213.706,
                              -190.045
                            ],
                            [
                              219.032,
                              -184.719
                            ],
                            [
                              219.032,
                              330.629
                            ],
                            [
                              213.706,
                              335.955
                            ],
                            [
                              -194.018,
                              336.629
                            ],
                            [
                              -199.344,
                              331.303
                            ],
                            [
                              -199.344,
                              -184.045
                            ]
                          ],
                          "c": true
                        }
                      ]
                    }
                  ]
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.964999988032,
                    0.976000019148,
                    0.987999949736,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    239.697,
                    224.772
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 7",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        242.363,
                        -295.695
                      ],
                      [
                        -242.363,
                        -295.695
                      ],
                      [
                        -242.363,
                        295.695
                      ],
                      [
                        242.363,
                        295.695
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 8
                },
                "lc": 1,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.6,
                    0.760784313725,
                    0.349019607843,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    239.881,
                    271.72
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    115.89,
                    103.501
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Rectangle 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 0,
        "op": 1077.00004386711,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 7,
        "ty": 4,
        "nm": "DECOR_2 Outlines",
        "sr": 1.5,
        "ks": {
          "p": {
            "a": 0,
            "k": [
              94.5,
              171,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              38.5,
              38,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              -136.909,
              136.909,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.026,
                        0.031
                      ],
                      [
                        -0.01,
                        0.023
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.02,
                        -0.017
                      ],
                      [
                        -0.024,
                        0.01
                      ],
                      [
                        -0.03,
                        -0.004
                      ],
                      [
                        -0.059,
                        -0.014
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.015,
                        -0.009
                      ],
                      [
                        -0.03,
                        -0.01
                      ],
                      [
                        -0.014,
                        -0.007
                      ],
                      [
                        -0.028,
                        -0.012
                      ],
                      [
                        -0.018,
                        0.001
                      ],
                      [
                        -0.031,
                        -0.016
                      ],
                      [
                        -0.012,
                        -0.012
                      ],
                      [
                        -0.028,
                        -0.018
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.014,
                        -0.008
                      ],
                      [
                        -0.026,
                        -0.023
                      ],
                      [
                        -0.008,
                        -0.013
                      ],
                      [
                        -0.024,
                        -0.025
                      ],
                      [
                        -0.008,
                        -0.014
                      ],
                      [
                        -0.02,
                        -0.026
                      ],
                      [
                        -0.009,
                        -0.012
                      ],
                      [
                        -0.017,
                        -0.03
                      ],
                      [
                        -0.009,
                        -0.013
                      ],
                      [
                        -0.015,
                        -0.032
                      ],
                      [
                        -0.001,
                        -0.016
                      ],
                      [
                        -0.011,
                        -0.031
                      ],
                      [
                        -0.005,
                        -0.02
                      ],
                      [
                        -0.007,
                        -0.025
                      ],
                      [
                        -0.007,
                        -0.013
                      ],
                      [
                        -0.006,
                        -0.035
                      ],
                      [
                        0.005,
                        -0.017
                      ],
                      [
                        -0.002,
                        -0.032
                      ],
                      [
                        -0.004,
                        -0.014
                      ],
                      [
                        0.001,
                        -0.038
                      ],
                      [
                        0.007,
                        -0.017
                      ],
                      [
                        0.004,
                        -0.03
                      ],
                      [
                        0.009,
                        -0.042
                      ],
                      [
                        0.017,
                        -0.04
                      ],
                      [
                        0.014,
                        -0.013
                      ],
                      [
                        0.013,
                        -0.028
                      ],
                      [
                        0,
                        -0.017
                      ],
                      [
                        0.019,
                        -0.03
                      ],
                      [
                        0.014,
                        -0.012
                      ],
                      [
                        0.019,
                        -0.024
                      ],
                      [
                        0.005,
                        -0.016
                      ],
                      [
                        0.025,
                        -0.026
                      ],
                      [
                        0.017,
                        -0.006
                      ],
                      [
                        0.023,
                        -0.021
                      ],
                      [
                        0.005,
                        -0.016
                      ],
                      [
                        0.029,
                        -0.02
                      ],
                      [
                        0.039,
                        -0.02
                      ],
                      [
                        0.039,
                        -0.017
                      ],
                      [
                        0.04,
                        -0.016
                      ],
                      [
                        0.041,
                        -0.012
                      ],
                      [
                        0.018,
                        0.002
                      ],
                      [
                        0.031,
                        -0.006
                      ],
                      [
                        0.013,
                        -0.002
                      ],
                      [
                        0.04,
                        -0.005
                      ],
                      [
                        0.016,
                        -0.008
                      ],
                      [
                        0.034,
                        -0.001
                      ],
                      [
                        0.016,
                        0.005
                      ],
                      [
                        0.033,
                        0.002
                      ],
                      [
                        0.016,
                        0.007
                      ],
                      [
                        0.032,
                        0.005
                      ],
                      [
                        0.017,
                        -0.004
                      ],
                      [
                        0.034,
                        0.008
                      ],
                      [
                        0.013,
                        0.011
                      ],
                      [
                        0.03,
                        0.01
                      ],
                      [
                        0.037,
                        0.019
                      ],
                      [
                        0.039,
                        0.02
                      ],
                      [
                        0.033,
                        0.027
                      ],
                      [
                        0.054,
                        0.066
                      ],
                      [
                        0.007,
                        0.017
                      ],
                      [
                        0.019,
                        0.025
                      ],
                      [
                        0.02,
                        0.037
                      ],
                      [
                        0.011,
                        0.01
                      ],
                      [
                        0.015,
                        0.033
                      ],
                      [
                        0.002,
                        0.018
                      ],
                      [
                        0.01,
                        0.029
                      ],
                      [
                        0,
                        0.018
                      ],
                      [
                        0.008,
                        0.029
                      ],
                      [
                        0.01,
                        0.012
                      ],
                      [
                        0.005,
                        0.036
                      ],
                      [
                        -0.005,
                        0.043
                      ],
                      [
                        -0.006,
                        0.042
                      ],
                      [
                        0.006,
                        0.016
                      ],
                      [
                        -0.005,
                        0.036
                      ],
                      [
                        -0.006,
                        0.017
                      ],
                      [
                        -0.007,
                        0.029
                      ],
                      [
                        -0.003,
                        0.014
                      ],
                      [
                        -0.012,
                        0.035
                      ],
                      [
                        -0.004,
                        0.012
                      ],
                      [
                        -0.016,
                        0.037
                      ],
                      [
                        -0.011,
                        0.012
                      ],
                      [
                        -0.014,
                        0.029
                      ],
                      [
                        -0.035,
                        0.056
                      ],
                      [
                        -0.012,
                        0.011
                      ],
                      [
                        -0.02,
                        0.026
                      ],
                      [
                        -0.004,
                        0.017
                      ],
                      [
                        -0.023,
                        0.025
                      ],
                      [
                        -0.014,
                        0.008
                      ],
                      [
                        -0.025,
                        0.022
                      ],
                      [
                        -0.01,
                        0.012
                      ],
                      [
                        -0.026,
                        0.02
                      ],
                      [
                        -0.018,
                        0.002
                      ],
                      [
                        -0.028,
                        0.017
                      ],
                      [
                        -0.016,
                        0.006
                      ],
                      [
                        -0.03,
                        0.014
                      ],
                      [
                        -0.011,
                        0.01
                      ],
                      [
                        -0.032,
                        0.012
                      ],
                      [
                        -0.016,
                        0.001
                      ],
                      [
                        -0.031,
                        0.009
                      ],
                      [
                        -0.013,
                        0.006
                      ],
                      [
                        -0.039,
                        -0.001
                      ],
                      [
                        -0.015,
                        -0.004
                      ]
                    ],
                    "o": [
                      [
                        0.018,
                        -0.018
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.003,
                        0.028
                      ],
                      [
                        0.023,
                        0.026
                      ],
                      [
                        0.02,
                        -0.008
                      ],
                      [
                        0.059,
                        0.01
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.031,
                        0.009
                      ],
                      [
                        0.014,
                        0.008
                      ],
                      [
                        0.031,
                        0.012
                      ],
                      [
                        0.014,
                        0.008
                      ],
                      [
                        0.026,
                        0.013
                      ],
                      [
                        0.018,
                        0
                      ],
                      [
                        0.026,
                        0.017
                      ],
                      [
                        0.011,
                        0.012
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.022,
                        0.02
                      ],
                      [
                        0.014,
                        0.009
                      ],
                      [
                        0.02,
                        0.023
                      ],
                      [
                        0.008,
                        0.014
                      ],
                      [
                        0.017,
                        0.024
                      ],
                      [
                        0.008,
                        0.014
                      ],
                      [
                        0.016,
                        0.026
                      ],
                      [
                        0.01,
                        0.013
                      ],
                      [
                        0.014,
                        0.026
                      ],
                      [
                        0.008,
                        0.014
                      ],
                      [
                        0.011,
                        0.028
                      ],
                      [
                        0.002,
                        0.017
                      ],
                      [
                        0.012,
                        0.035
                      ],
                      [
                        0.003,
                        0.013
                      ],
                      [
                        0.006,
                        0.028
                      ],
                      [
                        0.008,
                        0.016
                      ],
                      [
                        0.005,
                        0.032
                      ],
                      [
                        -0.004,
                        0.015
                      ],
                      [
                        0.001,
                        0.027
                      ],
                      [
                        0.006,
                        0.018
                      ],
                      [
                        -0.001,
                        0.034
                      ],
                      [
                        -0.006,
                        0.015
                      ],
                      [
                        -0.001,
                        0.043
                      ],
                      [
                        -0.009,
                        0.042
                      ],
                      [
                        -0.011,
                        0.031
                      ],
                      [
                        -0.012,
                        0.012
                      ],
                      [
                        -0.013,
                        0.025
                      ],
                      [
                        0,
                        0.02
                      ],
                      [
                        -0.018,
                        0.029
                      ],
                      [
                        -0.013,
                        0.009
                      ],
                      [
                        -0.017,
                        0.023
                      ],
                      [
                        -0.005,
                        0.017
                      ],
                      [
                        -0.022,
                        0.024
                      ],
                      [
                        -0.016,
                        0.006
                      ],
                      [
                        -0.022,
                        0.019
                      ],
                      [
                        -0.006,
                        0.019
                      ],
                      [
                        -0.036,
                        0.025
                      ],
                      [
                        -0.037,
                        0.021
                      ],
                      [
                        -0.038,
                        0.021
                      ],
                      [
                        -0.039,
                        0.016
                      ],
                      [
                        -0.031,
                        0.007
                      ],
                      [
                        -0.016,
                        -0.002
                      ],
                      [
                        -0.024,
                        0.003
                      ],
                      [
                        -0.019,
                        0.003
                      ],
                      [
                        -0.029,
                        0.001
                      ],
                      [
                        -0.015,
                        0.008
                      ],
                      [
                        -0.031,
                        -0.001
                      ],
                      [
                        -0.016,
                        -0.005
                      ],
                      [
                        -0.03,
                        -0.003
                      ],
                      [
                        -0.014,
                        -0.007
                      ],
                      [
                        -0.028,
                        -0.006
                      ],
                      [
                        -0.017,
                        0.004
                      ],
                      [
                        -0.03,
                        -0.009
                      ],
                      [
                        -0.013,
                        -0.01
                      ],
                      [
                        -0.039,
                        -0.016
                      ],
                      [
                        -0.041,
                        -0.014
                      ],
                      [
                        -0.037,
                        -0.022
                      ],
                      [
                        -0.068,
                        -0.052
                      ],
                      [
                        -0.022,
                        -0.025
                      ],
                      [
                        -0.006,
                        -0.015
                      ],
                      [
                        -0.025,
                        -0.033
                      ],
                      [
                        -0.015,
                        -0.024
                      ],
                      [
                        -0.015,
                        -0.012
                      ],
                      [
                        -0.016,
                        -0.03
                      ],
                      [
                        -0.002,
                        -0.015
                      ],
                      [
                        -0.012,
                        -0.032
                      ],
                      [
                        -0.001,
                        -0.015
                      ],
                      [
                        -0.007,
                        -0.027
                      ],
                      [
                        -0.012,
                        -0.016
                      ],
                      [
                        -0.002,
                        -0.043
                      ],
                      [
                        0,
                        -0.043
                      ],
                      [
                        0.003,
                        -0.028
                      ],
                      [
                        -0.006,
                        -0.017
                      ],
                      [
                        0.005,
                        -0.033
                      ],
                      [
                        0.005,
                        -0.014
                      ],
                      [
                        0.008,
                        -0.026
                      ],
                      [
                        0.003,
                        -0.018
                      ],
                      [
                        0.008,
                        -0.023
                      ],
                      [
                        0.006,
                        -0.02
                      ],
                      [
                        0.014,
                        -0.029
                      ],
                      [
                        0.011,
                        -0.013
                      ],
                      [
                        0.032,
                        -0.052
                      ],
                      [
                        0.018,
                        -0.024
                      ],
                      [
                        0.01,
                        -0.012
                      ],
                      [
                        0.019,
                        -0.022
                      ],
                      [
                        0.004,
                        -0.019
                      ],
                      [
                        0.023,
                        -0.021
                      ],
                      [
                        0.015,
                        -0.009
                      ],
                      [
                        0.026,
                        -0.02
                      ],
                      [
                        0.009,
                        -0.013
                      ],
                      [
                        0.028,
                        -0.016
                      ],
                      [
                        0.018,
                        -0.002
                      ],
                      [
                        0.028,
                        -0.013
                      ],
                      [
                        0.016,
                        -0.005
                      ],
                      [
                        0.026,
                        -0.011
                      ],
                      [
                        0.014,
                        -0.012
                      ],
                      [
                        0.03,
                        -0.009
                      ],
                      [
                        0.016,
                        -0.001
                      ],
                      [
                        0.023,
                        -0.004
                      ],
                      [
                        0.02,
                        -0.007
                      ],
                      [
                        0.023,
                        0
                      ],
                      [
                        0.025,
                        0.006
                      ]
                    ],
                    "v": [
                      [
                        -0.043,
                        -1.369
                      ],
                      [
                        -0.002,
                        -1.431
                      ],
                      [
                        0.002,
                        -1.431
                      ],
                      [
                        0.039,
                        -1.361
                      ],
                      [
                        0.106,
                        -1.354
                      ],
                      [
                        0.178,
                        -1.367
                      ],
                      [
                        0.298,
                        -1.342
                      ],
                      [
                        0.305,
                        -1.341
                      ],
                      [
                        0.365,
                        -1.316
                      ],
                      [
                        0.424,
                        -1.291
                      ],
                      [
                        0.483,
                        -1.265
                      ],
                      [
                        0.54,
                        -1.238
                      ],
                      [
                        0.602,
                        -1.226
                      ],
                      [
                        0.67,
                        -1.211
                      ],
                      [
                        0.72,
                        -1.171
                      ],
                      [
                        0.771,
                        -1.129
                      ],
                      [
                        0.874,
                        -1.052
                      ],
                      [
                        0.923,
                        -1.015
                      ],
                      [
                        0.978,
                        -0.974
                      ],
                      [
                        1.015,
                        -0.924
                      ],
                      [
                        1.056,
                        -0.87
                      ],
                      [
                        1.089,
                        -0.818
                      ],
                      [
                        1.125,
                        -0.763
                      ],
                      [
                        1.158,
                        -0.712
                      ],
                      [
                        1.195,
                        -0.655
                      ],
                      [
                        1.226,
                        -0.603
                      ],
                      [
                        1.259,
                        -0.543
                      ],
                      [
                        1.273,
                        -0.482
                      ],
                      [
                        1.288,
                        -0.417
                      ],
                      [
                        1.308,
                        -0.348
                      ],
                      [
                        1.321,
                        -0.295
                      ],
                      [
                        1.342,
                        -0.239
                      ],
                      [
                        1.363,
                        -0.172
                      ],
                      [
                        1.358,
                        -0.106
                      ],
                      [
                        1.352,
                        -0.042
                      ],
                      [
                        1.363,
                        0.015
                      ],
                      [
                        1.374,
                        0.087
                      ],
                      [
                        1.36,
                        0.152
                      ],
                      [
                        1.344,
                        0.213
                      ],
                      [
                        1.329,
                        0.341
                      ],
                      [
                        1.291,
                        0.465
                      ],
                      [
                        1.254,
                        0.52
                      ],
                      [
                        1.216,
                        0.572
                      ],
                      [
                        1.203,
                        0.631
                      ],
                      [
                        1.185,
                        0.7
                      ],
                      [
                        1.139,
                        0.75
                      ],
                      [
                        1.093,
                        0.794
                      ],
                      [
                        1.066,
                        0.848
                      ],
                      [
                        1.032,
                        0.909
                      ],
                      [
                        0.976,
                        0.945
                      ],
                      [
                        0.919,
                        0.978
                      ],
                      [
                        0.887,
                        1.03
                      ],
                      [
                        0.846,
                        1.089
                      ],
                      [
                        0.734,
                        1.157
                      ],
                      [
                        0.619,
                        1.214
                      ],
                      [
                        0.503,
                        1.27
                      ],
                      [
                        0.382,
                        1.312
                      ],
                      [
                        0.316,
                        1.316
                      ],
                      [
                        0.252,
                        1.318
                      ],
                      [
                        0.201,
                        1.325
                      ],
                      [
                        0.126,
                        1.336
                      ],
                      [
                        0.066,
                        1.352
                      ],
                      [
                        0,
                        1.37
                      ],
                      [
                        -0.062,
                        1.359
                      ],
                      [
                        -0.128,
                        1.347
                      ],
                      [
                        -0.189,
                        1.331
                      ],
                      [
                        -0.251,
                        1.313
                      ],
                      [
                        -0.313,
                        1.315
                      ],
                      [
                        -0.383,
                        1.315
                      ],
                      [
                        -0.44,
                        1.285
                      ],
                      [
                        -0.497,
                        1.254
                      ],
                      [
                        -0.612,
                        1.201
                      ],
                      [
                        -0.732,
                        1.151
                      ],
                      [
                        -0.837,
                        1.077
                      ],
                      [
                        -1.022,
                        0.898
                      ],
                      [
                        -1.057,
                        0.842
                      ],
                      [
                        -1.088,
                        0.787
                      ],
                      [
                        -1.157,
                        0.681
                      ],
                      [
                        -1.197,
                        0.637
                      ],
                      [
                        -1.242,
                        0.581
                      ],
                      [
                        -1.262,
                        0.517
                      ],
                      [
                        -1.276,
                        0.456
                      ],
                      [
                        -1.289,
                        0.39
                      ],
                      [
                        -1.298,
                        0.33
                      ],
                      [
                        -1.324,
                        0.277
                      ],
                      [
                        -1.352,
                        0.21
                      ],
                      [
                        -1.349,
                        0.081
                      ],
                      [
                        -1.339,
                        -0.047
                      ],
                      [
                        -1.349,
                        -0.107
                      ],
                      [
                        -1.357,
                        -0.177
                      ],
                      [
                        -1.34,
                        -0.242
                      ],
                      [
                        -1.323,
                        -0.301
                      ],
                      [
                        -1.311,
                        -0.357
                      ],
                      [
                        -1.293,
                        -0.426
                      ],
                      [
                        -1.275,
                        -0.474
                      ],
                      [
                        -1.248,
                        -0.546
                      ],
                      [
                        -1.213,
                        -0.599
                      ],
                      [
                        -1.177,
                        -0.654
                      ],
                      [
                        -1.11,
                        -0.762
                      ],
                      [
                        -1.069,
                        -0.809
                      ],
                      [
                        -1.027,
                        -0.858
                      ],
                      [
                        -1,
                        -0.914
                      ],
                      [
                        -0.969,
                        -0.977
                      ],
                      [
                        -0.919,
                        -1.015
                      ],
                      [
                        -0.865,
                        -1.055
                      ],
                      [
                        -0.818,
                        -1.1
                      ],
                      [
                        -0.772,
                        -1.146
                      ],
                      [
                        -0.71,
                        -1.167
                      ],
                      [
                        -0.647,
                        -1.189
                      ],
                      [
                        -0.589,
                        -1.213
                      ],
                      [
                        -0.528,
                        -1.237
                      ],
                      [
                        -0.478,
                        -1.269
                      ],
                      [
                        -0.418,
                        -1.305
                      ],
                      [
                        -0.355,
                        -1.316
                      ],
                      [
                        -0.291,
                        -1.327
                      ],
                      [
                        -0.241,
                        -1.343
                      ],
                      [
                        -0.166,
                        -1.356
                      ],
                      [
                        -0.11,
                        -1.348
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.009,
                        0.031
                      ],
                      [
                        0.002,
                        0.056
                      ],
                      [
                        0.01,
                        0.078
                      ],
                      [
                        0.01,
                        0.037
                      ],
                      [
                        0.01,
                        0.039
                      ],
                      [
                        0.028,
                        0.073
                      ],
                      [
                        0.004,
                        0.027
                      ],
                      [
                        0.03,
                        0.061
                      ],
                      [
                        0.024,
                        0.024
                      ],
                      [
                        0.028,
                        0.046
                      ],
                      [
                        0.009,
                        0.025
                      ],
                      [
                        0.041,
                        0.054
                      ],
                      [
                        0.059,
                        0.052
                      ],
                      [
                        0.012,
                        0.025
                      ],
                      [
                        0.05,
                        0.044
                      ],
                      [
                        0.03,
                        0.013
                      ],
                      [
                        0.045,
                        0.032
                      ],
                      [
                        0.021,
                        0.018
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.035,
                        0.019
                      ],
                      [
                        0.024,
                        0.017
                      ],
                      [
                        0.037,
                        0.016
                      ],
                      [
                        0.028,
                        0.011
                      ],
                      [
                        0.038,
                        0.012
                      ],
                      [
                        0.075,
                        0.021
                      ],
                      [
                        0.025,
                        0.013
                      ],
                      [
                        0.063,
                        0.013
                      ],
                      [
                        0.023,
                        0.003
                      ],
                      [
                        0.076,
                        0.008
                      ],
                      [
                        0.029,
                        -0.005
                      ],
                      [
                        0.061,
                        0.002
                      ],
                      [
                        0.028,
                        0.003
                      ],
                      [
                        0.062,
                        -0.003
                      ],
                      [
                        0.029,
                        0
                      ],
                      [
                        0.065,
                        -0.01
                      ],
                      [
                        0.027,
                        -0.016
                      ],
                      [
                        0.057,
                        -0.014
                      ],
                      [
                        0.025,
                        -0.005
                      ],
                      [
                        0.066,
                        -0.022
                      ],
                      [
                        0.071,
                        -0.037
                      ],
                      [
                        0.029,
                        -0.026
                      ],
                      [
                        0.035,
                        -0.021
                      ],
                      [
                        0.029,
                        -0.023
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.027,
                        -0.026
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.05,
                        -0.059
                      ],
                      [
                        0.048,
                        -0.061
                      ],
                      [
                        0.038,
                        -0.069
                      ],
                      [
                        0.007,
                        -0.031
                      ],
                      [
                        0.024,
                        -0.05
                      ],
                      [
                        0.029,
                        -0.072
                      ],
                      [
                        0.022,
                        -0.076
                      ],
                      [
                        -0.001,
                        -0.038
                      ],
                      [
                        0.006,
                        -0.041
                      ],
                      [
                        0.007,
                        -0.078
                      ],
                      [
                        -0.001,
                        -0.078
                      ],
                      [
                        -0.012,
                        -0.037
                      ],
                      [
                        -0.007,
                        -0.039
                      ],
                      [
                        -0.001,
                        -0.027
                      ],
                      [
                        -0.014,
                        -0.065
                      ],
                      [
                        -0.003,
                        -0.01
                      ],
                      [
                        -0.033,
                        -0.102
                      ],
                      [
                        -0.008,
                        -0.022
                      ],
                      [
                        -0.029,
                        -0.069
                      ],
                      [
                        -0.009,
                        -0.026
                      ],
                      [
                        -0.03,
                        -0.057
                      ],
                      [
                        -0.011,
                        -0.019
                      ],
                      [
                        -0.043,
                        -0.067
                      ],
                      [
                        -0.015,
                        -0.023
                      ],
                      [
                        -0.04,
                        -0.052
                      ],
                      [
                        -0.026,
                        -0.015
                      ],
                      [
                        -0.041,
                        -0.044
                      ],
                      [
                        -0.02,
                        -0.022
                      ],
                      [
                        -0.046,
                        -0.042
                      ],
                      [
                        -0.026,
                        -0.014
                      ],
                      [
                        -0.048,
                        -0.036
                      ],
                      [
                        -0.02,
                        -0.021
                      ],
                      [
                        -0.054,
                        -0.033
                      ],
                      [
                        -0.023,
                        -0.013
                      ],
                      [
                        -0.061,
                        -0.029
                      ],
                      [
                        -0.03,
                        -0.005
                      ],
                      [
                        -0.055,
                        -0.021
                      ],
                      [
                        -0.024,
                        -0.009
                      ],
                      [
                        -0.067,
                        -0.018
                      ],
                      [
                        -0.028,
                        -0.001
                      ],
                      [
                        -0.057,
                        -0.016
                      ],
                      [
                        -0.031,
                        -0.006
                      ],
                      [
                        -0.029,
                        0.017
                      ],
                      [
                        -0.02,
                        0.024
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.045,
                        -0.018
                      ],
                      [
                        -0.036,
                        0.015
                      ],
                      [
                        -0.046,
                        0.01
                      ],
                      [
                        -0.024,
                        0.002
                      ],
                      [
                        -0.07,
                        0.016
                      ],
                      [
                        -0.027,
                        0.003
                      ],
                      [
                        -0.062,
                        0.02
                      ],
                      [
                        -0.026,
                        0.007
                      ],
                      [
                        -0.062,
                        0.025
                      ],
                      [
                        -0.024,
                        0.021
                      ],
                      [
                        -0.053,
                        0.027
                      ],
                      [
                        -0.025,
                        0.012
                      ],
                      [
                        -0.053,
                        0.035
                      ],
                      [
                        -0.018,
                        0.012
                      ],
                      [
                        -0.064,
                        0.049
                      ],
                      [
                        -0.02,
                        0.022
                      ],
                      [
                        -0.044,
                        0.041
                      ],
                      [
                        -0.022,
                        0.019
                      ],
                      [
                        -0.042,
                        0.046
                      ],
                      [
                        -0.018,
                        0.022
                      ],
                      [
                        -0.038,
                        0.049
                      ],
                      [
                        -0.015,
                        0.026
                      ],
                      [
                        -0.03,
                        0.05
                      ],
                      [
                        -0.01,
                        0.028
                      ],
                      [
                        -0.026,
                        0.052
                      ],
                      [
                        -0.014,
                        0.024
                      ],
                      [
                        -0.024,
                        0.061
                      ],
                      [
                        -0.009,
                        0.04
                      ],
                      [
                        -0.011,
                        0.043
                      ],
                      [
                        0.001,
                        0.031
                      ],
                      [
                        -0.009,
                        0.057
                      ],
                      [
                        -0.001,
                        0.01
                      ],
                      [
                        -0.004,
                        0.022
                      ],
                      [
                        -0.002,
                        0.041
                      ]
                    ],
                    "o": [
                      [
                        -0.007,
                        -0.027
                      ],
                      [
                        0.003,
                        -0.079
                      ],
                      [
                        -0.005,
                        -0.038
                      ],
                      [
                        -0.014,
                        -0.037
                      ],
                      [
                        -0.016,
                        -0.077
                      ],
                      [
                        -0.018,
                        -0.046
                      ],
                      [
                        -0.004,
                        -0.034
                      ],
                      [
                        -0.028,
                        -0.056
                      ],
                      [
                        -0.018,
                        -0.021
                      ],
                      [
                        -0.026,
                        -0.043
                      ],
                      [
                        -0.012,
                        -0.032
                      ],
                      [
                        -0.052,
                        -0.059
                      ],
                      [
                        -0.035,
                        -0.037
                      ],
                      [
                        -0.016,
                        -0.03
                      ],
                      [
                        -0.047,
                        -0.04
                      ],
                      [
                        -0.026,
                        -0.012
                      ],
                      [
                        -0.044,
                        -0.034
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.029,
                        -0.027
                      ],
                      [
                        -0.048,
                        -0.029
                      ],
                      [
                        -0.032,
                        -0.024
                      ],
                      [
                        -0.051,
                        -0.024
                      ],
                      [
                        -0.036,
                        -0.018
                      ],
                      [
                        -0.072,
                        -0.029
                      ],
                      [
                        -0.051,
                        -0.012
                      ],
                      [
                        -0.028,
                        -0.014
                      ],
                      [
                        -0.043,
                        -0.005
                      ],
                      [
                        -0.038,
                        -0.007
                      ],
                      [
                        -0.056,
                        -0.003
                      ],
                      [
                        -0.029,
                        0.006
                      ],
                      [
                        -0.056,
                        0.002
                      ],
                      [
                        -0.031,
                        -0.003
                      ],
                      [
                        -0.052,
                        0.007
                      ],
                      [
                        -0.031,
                        0.001
                      ],
                      [
                        -0.056,
                        0.011
                      ],
                      [
                        -0.025,
                        0.016
                      ],
                      [
                        -0.047,
                        0.014
                      ],
                      [
                        -0.033,
                        0.006
                      ],
                      [
                        -0.073,
                        0.029
                      ],
                      [
                        -0.035,
                        0.015
                      ],
                      [
                        -0.031,
                        0.026
                      ],
                      [
                        -0.032,
                        0.019
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.031,
                        0.022
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.059,
                        0.051
                      ],
                      [
                        -0.058,
                        0.054
                      ],
                      [
                        -0.047,
                        0.063
                      ],
                      [
                        -0.033,
                        0.052
                      ],
                      [
                        -0.007,
                        0.028
                      ],
                      [
                        -0.041,
                        0.067
                      ],
                      [
                        -0.034,
                        0.072
                      ],
                      [
                        -0.011,
                        0.037
                      ],
                      [
                        0.003,
                        0.041
                      ],
                      [
                        -0.021,
                        0.076
                      ],
                      [
                        -0.011,
                        0.078
                      ],
                      [
                        0.001,
                        0.039
                      ],
                      [
                        0.011,
                        0.039
                      ],
                      [
                        0.009,
                        0.05
                      ],
                      [
                        0.001,
                        0.032
                      ],
                      [
                        0.004,
                        0.012
                      ],
                      [
                        0.02,
                        0.078
                      ],
                      [
                        0.015,
                        0.04
                      ],
                      [
                        0.013,
                        0.035
                      ],
                      [
                        0.023,
                        0.048
                      ],
                      [
                        0.009,
                        0.03
                      ],
                      [
                        0.021,
                        0.034
                      ],
                      [
                        0.022,
                        0.035
                      ],
                      [
                        0.032,
                        0.043
                      ],
                      [
                        0.017,
                        0.027
                      ],
                      [
                        0.038,
                        0.042
                      ],
                      [
                        0.027,
                        0.016
                      ],
                      [
                        0.04,
                        0.037
                      ],
                      [
                        0.019,
                        0.022
                      ],
                      [
                        0.049,
                        0.036
                      ],
                      [
                        0.024,
                        0.013
                      ],
                      [
                        0.046,
                        0.028
                      ],
                      [
                        0.023,
                        0.022
                      ],
                      [
                        0.046,
                        0.023
                      ],
                      [
                        0.029,
                        0.016
                      ],
                      [
                        0.052,
                        0.021
                      ],
                      [
                        0.029,
                        0.004
                      ],
                      [
                        0.046,
                        0.015
                      ],
                      [
                        0.032,
                        0.012
                      ],
                      [
                        0.053,
                        0.012
                      ],
                      [
                        0.032,
                        0.001
                      ],
                      [
                        0.06,
                        0.016
                      ],
                      [
                        0.034,
                        0.007
                      ],
                      [
                        0.029,
                        -0.012
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.001,
                        0.023
                      ],
                      [
                        0.035,
                        0.016
                      ],
                      [
                        0.045,
                        -0.015
                      ],
                      [
                        0.046,
                        -0.007
                      ],
                      [
                        0.035,
                        -0.004
                      ],
                      [
                        0.05,
                        -0.014
                      ],
                      [
                        0.033,
                        -0.003
                      ],
                      [
                        0.048,
                        -0.017
                      ],
                      [
                        0.031,
                        -0.009
                      ],
                      [
                        0.053,
                        -0.026
                      ],
                      [
                        0.022,
                        -0.019
                      ],
                      [
                        0.046,
                        -0.028
                      ],
                      [
                        0.029,
                        -0.012
                      ],
                      [
                        0.031,
                        -0.023
                      ],
                      [
                        0.033,
                        -0.026
                      ],
                      [
                        0.042,
                        -0.038
                      ],
                      [
                        0.019,
                        -0.022
                      ],
                      [
                        0.037,
                        -0.04
                      ],
                      [
                        0.022,
                        -0.02
                      ],
                      [
                        0.033,
                        -0.045
                      ],
                      [
                        0.02,
                        -0.023
                      ],
                      [
                        0.031,
                        -0.05
                      ],
                      [
                        0.015,
                        -0.025
                      ],
                      [
                        0.027,
                        -0.052
                      ],
                      [
                        0.011,
                        -0.027
                      ],
                      [
                        0.02,
                        -0.05
                      ],
                      [
                        0.015,
                        -0.028
                      ],
                      [
                        0.02,
                        -0.069
                      ],
                      [
                        0.006,
                        -0.022
                      ],
                      [
                        0.013,
                        -0.058
                      ],
                      [
                        0,
                        -0.029
                      ],
                      [
                        0.003,
                        -0.013
                      ],
                      [
                        0.007,
                        -0.034
                      ],
                      [
                        0.01,
                        -0.04
                      ],
                      [
                        0.004,
                        -0.061
                      ]
                    ],
                    "v": [
                      [
                        2.485,
                        -0.05
                      ],
                      [
                        2.469,
                        -0.163
                      ],
                      [
                        2.459,
                        -0.398
                      ],
                      [
                        2.435,
                        -0.51
                      ],
                      [
                        2.399,
                        -0.624
                      ],
                      [
                        2.331,
                        -0.848
                      ],
                      [
                        2.306,
                        -0.949
                      ],
                      [
                        2.267,
                        -1.075
                      ],
                      [
                        2.196,
                        -1.177
                      ],
                      [
                        2.128,
                        -1.266
                      ],
                      [
                        2.083,
                        -1.361
                      ],
                      [
                        2.02,
                        -1.476
                      ],
                      [
                        1.853,
                        -1.643
                      ],
                      [
                        1.793,
                        -1.731
                      ],
                      [
                        1.714,
                        -1.834
                      ],
                      [
                        1.61,
                        -1.9
                      ],
                      [
                        1.511,
                        -1.957
                      ],
                      [
                        1.424,
                        -2.028
                      ],
                      [
                        1.423,
                        -2.029
                      ],
                      [
                        1.325,
                        -2.098
                      ],
                      [
                        1.23,
                        -2.161
                      ],
                      [
                        1.126,
                        -2.221
                      ],
                      [
                        1.022,
                        -2.268
                      ],
                      [
                        0.911,
                        -2.313
                      ],
                      [
                        0.69,
                        -2.389
                      ],
                      [
                        0.588,
                        -2.427
                      ],
                      [
                        0.468,
                        -2.468
                      ],
                      [
                        0.375,
                        -2.481
                      ],
                      [
                        0.233,
                        -2.5
                      ],
                      [
                        0.118,
                        -2.493
                      ],
                      [
                        -0.002,
                        -2.483
                      ],
                      [
                        -0.114,
                        -2.486
                      ],
                      [
                        -0.237,
                        -2.488
                      ],
                      [
                        -0.346,
                        -2.481
                      ],
                      [
                        -0.473,
                        -2.47
                      ],
                      [
                        -0.583,
                        -2.428
                      ],
                      [
                        -0.693,
                        -2.383
                      ],
                      [
                        -0.793,
                        -2.36
                      ],
                      [
                        -0.921,
                        -2.326
                      ],
                      [
                        -1.136,
                        -2.228
                      ],
                      [
                        -1.232,
                        -2.166
                      ],
                      [
                        -1.331,
                        -2.097
                      ],
                      [
                        -1.425,
                        -2.034
                      ],
                      [
                        -1.522,
                        -1.962
                      ],
                      [
                        -1.609,
                        -1.89
                      ],
                      [
                        -1.698,
                        -1.809
                      ],
                      [
                        -1.863,
                        -1.644
                      ],
                      [
                        -2.023,
                        -1.471
                      ],
                      [
                        -2.152,
                        -1.273
                      ],
                      [
                        -2.198,
                        -1.161
                      ],
                      [
                        -2.236,
                        -1.052
                      ],
                      [
                        -2.341,
                        -0.843
                      ],
                      [
                        -2.425,
                        -0.622
                      ],
                      [
                        -2.439,
                        -0.508
                      ],
                      [
                        -2.443,
                        -0.386
                      ],
                      [
                        -2.485,
                        -0.155
                      ],
                      [
                        -2.501,
                        0.08
                      ],
                      [
                        -2.481,
                        0.194
                      ],
                      [
                        -2.454,
                        0.312
                      ],
                      [
                        -2.443,
                        0.417
                      ],
                      [
                        -2.427,
                        0.545
                      ],
                      [
                        -2.417,
                        0.578
                      ],
                      [
                        -2.361,
                        0.77
                      ],
                      [
                        -2.329,
                        0.858
                      ],
                      [
                        -2.278,
                        0.989
                      ],
                      [
                        -2.237,
                        1.091
                      ],
                      [
                        -2.189,
                        1.208
                      ],
                      [
                        -2.144,
                        1.283
                      ],
                      [
                        -2.065,
                        1.409
                      ],
                      [
                        -2.003,
                        1.499
                      ],
                      [
                        -1.93,
                        1.603
                      ],
                      [
                        -1.84,
                        1.675
                      ],
                      [
                        -1.744,
                        1.751
                      ],
                      [
                        -1.666,
                        1.831
                      ],
                      [
                        -1.58,
                        1.918
                      ],
                      [
                        -1.48,
                        1.982
                      ],
                      [
                        -1.383,
                        2.045
                      ],
                      [
                        -1.296,
                        2.114
                      ],
                      [
                        -1.198,
                        2.191
                      ],
                      [
                        -1.105,
                        2.241
                      ],
                      [
                        -0.989,
                        2.302
                      ],
                      [
                        -0.877,
                        2.332
                      ],
                      [
                        -0.761,
                        2.361
                      ],
                      [
                        -0.665,
                        2.394
                      ],
                      [
                        -0.538,
                        2.434
                      ],
                      [
                        -0.427,
                        2.447
                      ],
                      [
                        -0.306,
                        2.465
                      ],
                      [
                        -0.179,
                        2.495
                      ],
                      [
                        -0.08,
                        2.478
                      ],
                      [
                        -0.005,
                        2.423
                      ],
                      [
                        0.003,
                        2.423
                      ],
                      [
                        0.07,
                        2.486
                      ],
                      [
                        0.181,
                        2.488
                      ],
                      [
                        0.317,
                        2.451
                      ],
                      [
                        0.414,
                        2.439
                      ],
                      [
                        0.548,
                        2.416
                      ],
                      [
                        0.653,
                        2.396
                      ],
                      [
                        0.778,
                        2.369
                      ],
                      [
                        0.879,
                        2.337
                      ],
                      [
                        1.001,
                        2.294
                      ],
                      [
                        1.099,
                        2.228
                      ],
                      [
                        1.197,
                        2.161
                      ],
                      [
                        1.294,
                        2.11
                      ],
                      [
                        1.404,
                        2.052
                      ],
                      [
                        1.473,
                        2.002
                      ],
                      [
                        1.592,
                        1.911
                      ],
                      [
                        1.672,
                        1.83
                      ],
                      [
                        1.756,
                        1.744
                      ],
                      [
                        1.835,
                        1.666
                      ],
                      [
                        1.922,
                        1.58
                      ],
                      [
                        1.992,
                        1.492
                      ],
                      [
                        2.069,
                        1.397
                      ],
                      [
                        2.128,
                        1.296
                      ],
                      [
                        2.187,
                        1.194
                      ],
                      [
                        2.235,
                        1.087
                      ],
                      [
                        2.283,
                        0.98
                      ],
                      [
                        2.329,
                        0.881
                      ],
                      [
                        2.381,
                        0.765
                      ],
                      [
                        2.417,
                        0.631
                      ],
                      [
                        2.441,
                        0.538
                      ],
                      [
                        2.452,
                        0.419
                      ],
                      [
                        2.46,
                        0.303
                      ],
                      [
                        2.466,
                        0.269
                      ],
                      [
                        2.481,
                        0.191
                      ],
                      [
                        2.498,
                        0.07
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 2",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.169000004787,
                    0.161000001197,
                    0.176000004189,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    72.501,
                    24.328
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 133.5,
                      "s": [
                        0,
                        0
                      ]
                    },
                    {
                      "t": 140.101255706441,
                      "s": [
                        100,
                        100
                      ]
                    }
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 158.25,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 166.500006781684,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.065,
                        0.076
                      ],
                      [
                        -0.023,
                        0.055
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.051,
                        -0.042
                      ],
                      [
                        -0.058,
                        0.025
                      ],
                      [
                        -0.071,
                        -0.011
                      ],
                      [
                        -0.141,
                        -0.033
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.037,
                        -0.02
                      ],
                      [
                        -0.072,
                        -0.022
                      ],
                      [
                        -0.037,
                        -0.018
                      ],
                      [
                        -0.067,
                        -0.028
                      ],
                      [
                        -0.042,
                        0.001
                      ],
                      [
                        -0.074,
                        -0.039
                      ],
                      [
                        -0.028,
                        -0.029
                      ],
                      [
                        -0.066,
                        -0.043
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.032,
                        -0.02
                      ],
                      [
                        -0.061,
                        -0.056
                      ],
                      [
                        -0.02,
                        -0.033
                      ],
                      [
                        -0.054,
                        -0.06
                      ],
                      [
                        -0.019,
                        -0.033
                      ],
                      [
                        -0.049,
                        -0.064
                      ],
                      [
                        -0.021,
                        -0.03
                      ],
                      [
                        -0.043,
                        -0.07
                      ],
                      [
                        -0.021,
                        -0.031
                      ],
                      [
                        -0.036,
                        -0.075
                      ],
                      [
                        -0.004,
                        -0.04
                      ],
                      [
                        -0.028,
                        -0.073
                      ],
                      [
                        -0.012,
                        -0.048
                      ],
                      [
                        -0.016,
                        -0.06
                      ],
                      [
                        -0.016,
                        -0.033
                      ],
                      [
                        -0.015,
                        -0.084
                      ],
                      [
                        0.012,
                        -0.041
                      ],
                      [
                        -0.005,
                        -0.076
                      ],
                      [
                        -0.011,
                        -0.034
                      ],
                      [
                        0.003,
                        -0.089
                      ],
                      [
                        0.016,
                        -0.041
                      ],
                      [
                        0.01,
                        -0.072
                      ],
                      [
                        0.021,
                        -0.102
                      ],
                      [
                        0.039,
                        -0.095
                      ],
                      [
                        0.033,
                        -0.03
                      ],
                      [
                        0.033,
                        -0.067
                      ],
                      [
                        -0.001,
                        -0.04
                      ],
                      [
                        0.046,
                        -0.073
                      ],
                      [
                        0.036,
                        -0.026
                      ],
                      [
                        0.045,
                        -0.058
                      ],
                      [
                        0.01,
                        -0.037
                      ],
                      [
                        0.06,
                        -0.063
                      ],
                      [
                        0.042,
                        -0.015
                      ],
                      [
                        0.057,
                        -0.049
                      ],
                      [
                        0.013,
                        -0.04
                      ],
                      [
                        0.07,
                        -0.05
                      ],
                      [
                        0.092,
                        -0.049
                      ],
                      [
                        0.096,
                        -0.039
                      ],
                      [
                        0.094,
                        -0.039
                      ],
                      [
                        0.099,
                        -0.029
                      ],
                      [
                        0.042,
                        0.005
                      ],
                      [
                        0.075,
                        -0.013
                      ],
                      [
                        0.03,
                        -0.005
                      ],
                      [
                        0.096,
                        -0.01
                      ],
                      [
                        0.037,
                        -0.018
                      ],
                      [
                        0.083,
                        -0.004
                      ],
                      [
                        0.037,
                        0.012
                      ],
                      [
                        0.08,
                        0.004
                      ],
                      [
                        0.037,
                        0.016
                      ],
                      [
                        0.077,
                        0.011
                      ],
                      [
                        0.039,
                        -0.009
                      ],
                      [
                        0.082,
                        0.02
                      ],
                      [
                        0.033,
                        0.027
                      ],
                      [
                        0.072,
                        0.025
                      ],
                      [
                        0.09,
                        0.046
                      ],
                      [
                        0.092,
                        0.046
                      ],
                      [
                        0.08,
                        0.065
                      ],
                      [
                        0.129,
                        0.161
                      ],
                      [
                        0.017,
                        0.039
                      ],
                      [
                        0.045,
                        0.058
                      ],
                      [
                        0.049,
                        0.089
                      ],
                      [
                        0.029,
                        0.024
                      ],
                      [
                        0.039,
                        0.078
                      ],
                      [
                        0.005,
                        0.043
                      ],
                      [
                        0.025,
                        0.068
                      ],
                      [
                        0.001,
                        0.043
                      ],
                      [
                        0.017,
                        0.069
                      ],
                      [
                        0.023,
                        0.031
                      ],
                      [
                        0.012,
                        0.087
                      ],
                      [
                        -0.01,
                        0.103
                      ],
                      [
                        -0.015,
                        0.101
                      ],
                      [
                        0.015,
                        0.037
                      ],
                      [
                        -0.013,
                        0.084
                      ],
                      [
                        -0.014,
                        0.041
                      ],
                      [
                        -0.016,
                        0.07
                      ],
                      [
                        -0.006,
                        0.033
                      ],
                      [
                        -0.027,
                        0.084
                      ],
                      [
                        -0.01,
                        0.029
                      ],
                      [
                        -0.037,
                        0.09
                      ],
                      [
                        -0.025,
                        0.031
                      ],
                      [
                        -0.036,
                        0.069
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.082,
                        0.134
                      ],
                      [
                        -0.027,
                        0.028
                      ],
                      [
                        -0.047,
                        0.061
                      ],
                      [
                        -0.009,
                        0.042
                      ],
                      [
                        -0.056,
                        0.061
                      ],
                      [
                        -0.033,
                        0.02
                      ],
                      [
                        -0.059,
                        0.055
                      ],
                      [
                        -0.024,
                        0.03
                      ],
                      [
                        -0.064,
                        0.048
                      ],
                      [
                        -0.042,
                        0.005
                      ],
                      [
                        -0.068,
                        0.041
                      ],
                      [
                        -0.036,
                        0.013
                      ],
                      [
                        -0.07,
                        0.034
                      ],
                      [
                        -0.029,
                        0.026
                      ],
                      [
                        -0.078,
                        0.03
                      ],
                      [
                        -0.041,
                        0.003
                      ],
                      [
                        -0.074,
                        0.02
                      ],
                      [
                        -0.03,
                        0.013
                      ],
                      [
                        -0.093,
                        -0.003
                      ],
                      [
                        -0.034,
                        -0.008
                      ]
                    ],
                    "o": [
                      [
                        0.042,
                        -0.042
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.006,
                        0.065
                      ],
                      [
                        0.056,
                        0.06
                      ],
                      [
                        0.047,
                        -0.019
                      ],
                      [
                        0.143,
                        0.023
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.075,
                        0.021
                      ],
                      [
                        0.033,
                        0.018
                      ],
                      [
                        0.074,
                        0.029
                      ],
                      [
                        0.032,
                        0.017
                      ],
                      [
                        0.064,
                        0.032
                      ],
                      [
                        0.045,
                        -0.002
                      ],
                      [
                        0.064,
                        0.039
                      ],
                      [
                        0.028,
                        0.028
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.053,
                        0.049
                      ],
                      [
                        0.035,
                        0.021
                      ],
                      [
                        0.05,
                        0.055
                      ],
                      [
                        0.021,
                        0.034
                      ],
                      [
                        0.044,
                        0.058
                      ],
                      [
                        0.019,
                        0.034
                      ],
                      [
                        0.036,
                        0.061
                      ],
                      [
                        0.023,
                        0.033
                      ],
                      [
                        0.031,
                        0.064
                      ],
                      [
                        0.022,
                        0.034
                      ],
                      [
                        0.028,
                        0.069
                      ],
                      [
                        0.003,
                        0.039
                      ],
                      [
                        0.026,
                        0.086
                      ],
                      [
                        0.008,
                        0.03
                      ],
                      [
                        0.015,
                        0.067
                      ],
                      [
                        0.019,
                        0.039
                      ],
                      [
                        0.011,
                        0.077
                      ],
                      [
                        -0.01,
                        0.038
                      ],
                      [
                        0.005,
                        0.066
                      ],
                      [
                        0.015,
                        0.043
                      ],
                      [
                        -0.003,
                        0.082
                      ],
                      [
                        -0.014,
                        0.035
                      ],
                      [
                        -0.002,
                        0.103
                      ],
                      [
                        -0.022,
                        0.101
                      ],
                      [
                        -0.027,
                        0.075
                      ],
                      [
                        -0.028,
                        0.028
                      ],
                      [
                        -0.03,
                        0.061
                      ],
                      [
                        0,
                        0.047
                      ],
                      [
                        -0.042,
                        0.068
                      ],
                      [
                        -0.03,
                        0.023
                      ],
                      [
                        -0.041,
                        0.054
                      ],
                      [
                        -0.013,
                        0.043
                      ],
                      [
                        -0.054,
                        0.057
                      ],
                      [
                        -0.039,
                        0.014
                      ],
                      [
                        -0.052,
                        0.045
                      ],
                      [
                        -0.014,
                        0.046
                      ],
                      [
                        -0.085,
                        0.06
                      ],
                      [
                        -0.09,
                        0.05
                      ],
                      [
                        -0.089,
                        0.051
                      ],
                      [
                        -0.096,
                        0.038
                      ],
                      [
                        -0.075,
                        0.017
                      ],
                      [
                        -0.039,
                        -0.004
                      ],
                      [
                        -0.057,
                        0.008
                      ],
                      [
                        -0.047,
                        0.008
                      ],
                      [
                        -0.072,
                        0.003
                      ],
                      [
                        -0.038,
                        0.02
                      ],
                      [
                        -0.074,
                        -0.004
                      ],
                      [
                        -0.038,
                        -0.012
                      ],
                      [
                        -0.074,
                        -0.009
                      ],
                      [
                        -0.036,
                        -0.016
                      ],
                      [
                        -0.068,
                        -0.014
                      ],
                      [
                        -0.044,
                        0.01
                      ],
                      [
                        -0.074,
                        -0.021
                      ],
                      [
                        -0.031,
                        -0.024
                      ],
                      [
                        -0.095,
                        -0.038
                      ],
                      [
                        -0.098,
                        -0.034
                      ],
                      [
                        -0.088,
                        -0.053
                      ],
                      [
                        -0.165,
                        -0.124
                      ],
                      [
                        -0.054,
                        -0.058
                      ],
                      [
                        -0.014,
                        -0.035
                      ],
                      [
                        -0.062,
                        -0.081
                      ],
                      [
                        -0.036,
                        -0.056
                      ],
                      [
                        -0.036,
                        -0.029
                      ],
                      [
                        -0.036,
                        -0.073
                      ],
                      [
                        -0.005,
                        -0.037
                      ],
                      [
                        -0.029,
                        -0.076
                      ],
                      [
                        -0.002,
                        -0.037
                      ],
                      [
                        -0.017,
                        -0.064
                      ],
                      [
                        -0.027,
                        -0.037
                      ],
                      [
                        -0.006,
                        -0.103
                      ],
                      [
                        0.001,
                        -0.102
                      ],
                      [
                        0.006,
                        -0.068
                      ],
                      [
                        -0.016,
                        -0.042
                      ],
                      [
                        0.014,
                        -0.08
                      ],
                      [
                        0.012,
                        -0.034
                      ],
                      [
                        0.018,
                        -0.063
                      ],
                      [
                        0.008,
                        -0.043
                      ],
                      [
                        0.02,
                        -0.054
                      ],
                      [
                        0.016,
                        -0.046
                      ],
                      [
                        0.034,
                        -0.068
                      ],
                      [
                        0.025,
                        -0.03
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.077,
                        -0.125
                      ],
                      [
                        0.045,
                        -0.06
                      ],
                      [
                        0.027,
                        -0.028
                      ],
                      [
                        0.048,
                        -0.052
                      ],
                      [
                        0.009,
                        -0.045
                      ],
                      [
                        0.055,
                        -0.049
                      ],
                      [
                        0.034,
                        -0.021
                      ],
                      [
                        0.064,
                        -0.047
                      ],
                      [
                        0.024,
                        -0.03
                      ],
                      [
                        0.064,
                        -0.04
                      ],
                      [
                        0.042,
                        -0.006
                      ],
                      [
                        0.066,
                        -0.034
                      ],
                      [
                        0.037,
                        -0.011
                      ],
                      [
                        0.065,
                        -0.026
                      ],
                      [
                        0.032,
                        -0.028
                      ],
                      [
                        0.073,
                        -0.022
                      ],
                      [
                        0.039,
                        -0.002
                      ],
                      [
                        0.055,
                        -0.012
                      ],
                      [
                        0.049,
                        -0.019
                      ],
                      [
                        0.057,
                        -0.001
                      ],
                      [
                        0.061,
                        0.016
                      ]
                    ],
                    "v": [
                      [
                        -0.104,
                        -3.283
                      ],
                      [
                        -0.006,
                        -3.431
                      ],
                      [
                        0.004,
                        -3.429
                      ],
                      [
                        0.093,
                        -3.262
                      ],
                      [
                        0.254,
                        -3.246
                      ],
                      [
                        0.425,
                        -3.276
                      ],
                      [
                        0.714,
                        -3.218
                      ],
                      [
                        0.729,
                        -3.215
                      ],
                      [
                        0.875,
                        -3.156
                      ],
                      [
                        1.016,
                        -3.096
                      ],
                      [
                        1.16,
                        -3.032
                      ],
                      [
                        1.294,
                        -2.969
                      ],
                      [
                        1.441,
                        -2.939
                      ],
                      [
                        1.606,
                        -2.903
                      ],
                      [
                        1.726,
                        -2.807
                      ],
                      [
                        1.849,
                        -2.707
                      ],
                      [
                        2.096,
                        -2.522
                      ],
                      [
                        2.214,
                        -2.433
                      ],
                      [
                        2.345,
                        -2.335
                      ],
                      [
                        2.435,
                        -2.214
                      ],
                      [
                        2.531,
                        -2.086
                      ],
                      [
                        2.612,
                        -1.962
                      ],
                      [
                        2.7,
                        -1.828
                      ],
                      [
                        2.779,
                        -1.707
                      ],
                      [
                        2.868,
                        -1.571
                      ],
                      [
                        2.94,
                        -1.445
                      ],
                      [
                        3.02,
                        -1.302
                      ],
                      [
                        3.056,
                        -1.154
                      ],
                      [
                        3.091,
                        -1.001
                      ],
                      [
                        3.137,
                        -0.833
                      ],
                      [
                        3.17,
                        -0.706
                      ],
                      [
                        3.218,
                        -0.572
                      ],
                      [
                        3.27,
                        -0.411
                      ],
                      [
                        3.259,
                        -0.255
                      ],
                      [
                        3.243,
                        -0.1
                      ],
                      [
                        3.271,
                        0.036
                      ],
                      [
                        3.296,
                        0.208
                      ],
                      [
                        3.263,
                        0.366
                      ],
                      [
                        3.223,
                        0.511
                      ],
                      [
                        3.189,
                        0.82
                      ],
                      [
                        3.097,
                        1.115
                      ],
                      [
                        3.008,
                        1.248
                      ],
                      [
                        2.916,
                        1.372
                      ],
                      [
                        2.887,
                        1.514
                      ],
                      [
                        2.841,
                        1.68
                      ],
                      [
                        2.731,
                        1.798
                      ],
                      [
                        2.622,
                        1.904
                      ],
                      [
                        2.559,
                        2.033
                      ],
                      [
                        2.475,
                        2.181
                      ],
                      [
                        2.34,
                        2.268
                      ],
                      [
                        2.204,
                        2.346
                      ],
                      [
                        2.126,
                        2.472
                      ],
                      [
                        2.027,
                        2.613
                      ],
                      [
                        1.762,
                        2.776
                      ],
                      [
                        1.483,
                        2.911
                      ],
                      [
                        1.207,
                        3.047
                      ],
                      [
                        0.914,
                        3.147
                      ],
                      [
                        0.758,
                        3.155
                      ],
                      [
                        0.603,
                        3.16
                      ],
                      [
                        0.482,
                        3.179
                      ],
                      [
                        0.302,
                        3.203
                      ],
                      [
                        0.158,
                        3.243
                      ],
                      [
                        -0.002,
                        3.287
                      ],
                      [
                        -0.15,
                        3.26
                      ],
                      [
                        -0.308,
                        3.232
                      ],
                      [
                        -0.454,
                        3.192
                      ],
                      [
                        -0.604,
                        3.15
                      ],
                      [
                        -0.75,
                        3.154
                      ],
                      [
                        -0.92,
                        3.154
                      ],
                      [
                        -1.058,
                        3.082
                      ],
                      [
                        -1.194,
                        3.007
                      ],
                      [
                        -1.472,
                        2.881
                      ],
                      [
                        -1.758,
                        2.761
                      ],
                      [
                        -2.01,
                        2.583
                      ],
                      [
                        -2.452,
                        2.153
                      ],
                      [
                        -2.538,
                        2.02
                      ],
                      [
                        -2.612,
                        1.889
                      ],
                      [
                        -2.779,
                        1.634
                      ],
                      [
                        -2.875,
                        1.529
                      ],
                      [
                        -2.984,
                        1.395
                      ],
                      [
                        -3.03,
                        1.24
                      ],
                      [
                        -3.065,
                        1.094
                      ],
                      [
                        -3.096,
                        0.937
                      ],
                      [
                        -3.116,
                        0.791
                      ],
                      [
                        -3.18,
                        0.664
                      ],
                      [
                        -3.245,
                        0.504
                      ],
                      [
                        -3.239,
                        0.194
                      ],
                      [
                        -3.214,
                        -0.112
                      ],
                      [
                        -3.239,
                        -0.255
                      ],
                      [
                        -3.259,
                        -0.423
                      ],
                      [
                        -3.218,
                        -0.58
                      ],
                      [
                        -3.177,
                        -0.722
                      ],
                      [
                        -3.147,
                        -0.855
                      ],
                      [
                        -3.105,
                        -1.021
                      ],
                      [
                        -3.063,
                        -1.137
                      ],
                      [
                        -2.997,
                        -1.309
                      ],
                      [
                        -2.913,
                        -1.437
                      ],
                      [
                        -2.826,
                        -1.566
                      ],
                      [
                        -2.826,
                        -1.567
                      ],
                      [
                        -2.667,
                        -1.826
                      ],
                      [
                        -2.569,
                        -1.94
                      ],
                      [
                        -2.468,
                        -2.057
                      ],
                      [
                        -2.402,
                        -2.192
                      ],
                      [
                        -2.327,
                        -2.344
                      ],
                      [
                        -2.206,
                        -2.433
                      ],
                      [
                        -2.078,
                        -2.53
                      ],
                      [
                        -1.966,
                        -2.638
                      ],
                      [
                        -1.853,
                        -2.747
                      ],
                      [
                        -1.706,
                        -2.798
                      ],
                      [
                        -1.553,
                        -2.85
                      ],
                      [
                        -1.415,
                        -2.908
                      ],
                      [
                        -1.271,
                        -2.966
                      ],
                      [
                        -1.147,
                        -3.043
                      ],
                      [
                        -1.005,
                        -3.129
                      ],
                      [
                        -0.853,
                        -3.156
                      ],
                      [
                        -0.7,
                        -3.18
                      ],
                      [
                        -0.58,
                        -3.219
                      ],
                      [
                        -0.4,
                        -3.251
                      ],
                      [
                        -0.267,
                        -3.233
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.021,
                        0.076
                      ],
                      [
                        0.005,
                        0.134
                      ],
                      [
                        0.023,
                        0.187
                      ],
                      [
                        0.026,
                        0.087
                      ],
                      [
                        0.023,
                        0.094
                      ],
                      [
                        0.07,
                        0.173
                      ],
                      [
                        0.009,
                        0.064
                      ],
                      [
                        0.073,
                        0.147
                      ],
                      [
                        0.054,
                        0.06
                      ],
                      [
                        0.069,
                        0.111
                      ],
                      [
                        0.022,
                        0.06
                      ],
                      [
                        0.099,
                        0.129
                      ],
                      [
                        0.142,
                        0.125
                      ],
                      [
                        0.03,
                        0.06
                      ],
                      [
                        0.119,
                        0.106
                      ],
                      [
                        0.073,
                        0.033
                      ],
                      [
                        0.108,
                        0.078
                      ],
                      [
                        0.052,
                        0.046
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.084,
                        0.046
                      ],
                      [
                        0.057,
                        0.041
                      ],
                      [
                        0.088,
                        0.038
                      ],
                      [
                        0.064,
                        0.029
                      ],
                      [
                        0.09,
                        0.031
                      ],
                      [
                        0.179,
                        0.051
                      ],
                      [
                        0.06,
                        0.031
                      ],
                      [
                        0.154,
                        0.029
                      ],
                      [
                        0.056,
                        0.009
                      ],
                      [
                        0.181,
                        0.02
                      ],
                      [
                        0.072,
                        -0.014
                      ],
                      [
                        0.145,
                        0.006
                      ],
                      [
                        0.069,
                        0.007
                      ],
                      [
                        0.149,
                        -0.007
                      ],
                      [
                        0.067,
                        -0.001
                      ],
                      [
                        0.156,
                        -0.023
                      ],
                      [
                        0.065,
                        -0.038
                      ],
                      [
                        0.138,
                        -0.033
                      ],
                      [
                        0.061,
                        -0.011
                      ],
                      [
                        0.157,
                        -0.056
                      ],
                      [
                        0.167,
                        -0.086
                      ],
                      [
                        0.069,
                        -0.061
                      ],
                      [
                        0.083,
                        -0.049
                      ],
                      [
                        0.071,
                        -0.056
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.066,
                        -0.062
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.123,
                        -0.141
                      ],
                      [
                        0.116,
                        -0.148
                      ],
                      [
                        0.092,
                        -0.165
                      ],
                      [
                        0.017,
                        -0.077
                      ],
                      [
                        0.059,
                        -0.12
                      ],
                      [
                        0.069,
                        -0.175
                      ],
                      [
                        0.051,
                        -0.182
                      ],
                      [
                        -0.002,
                        -0.092
                      ],
                      [
                        0.017,
                        -0.096
                      ],
                      [
                        0.017,
                        -0.188
                      ],
                      [
                        -0.001,
                        -0.189
                      ],
                      [
                        -0.028,
                        -0.088
                      ],
                      [
                        -0.015,
                        -0.096
                      ],
                      [
                        -0.002,
                        -0.064
                      ],
                      [
                        -0.036,
                        -0.157
                      ],
                      [
                        -0.007,
                        -0.024
                      ],
                      [
                        -0.079,
                        -0.246
                      ],
                      [
                        -0.018,
                        -0.052
                      ],
                      [
                        -0.069,
                        -0.167
                      ],
                      [
                        -0.02,
                        -0.064
                      ],
                      [
                        -0.072,
                        -0.137
                      ],
                      [
                        -0.027,
                        -0.046
                      ],
                      [
                        -0.102,
                        -0.16
                      ],
                      [
                        -0.037,
                        -0.056
                      ],
                      [
                        -0.094,
                        -0.123
                      ],
                      [
                        -0.064,
                        -0.037
                      ],
                      [
                        -0.099,
                        -0.108
                      ],
                      [
                        -0.046,
                        -0.051
                      ],
                      [
                        -0.111,
                        -0.099
                      ],
                      [
                        -0.061,
                        -0.033
                      ],
                      [
                        -0.116,
                        -0.086
                      ],
                      [
                        -0.05,
                        -0.05
                      ],
                      [
                        -0.129,
                        -0.08
                      ],
                      [
                        -0.056,
                        -0.032
                      ],
                      [
                        -0.144,
                        -0.07
                      ],
                      [
                        -0.073,
                        -0.01
                      ],
                      [
                        -0.134,
                        -0.05
                      ],
                      [
                        -0.057,
                        -0.022
                      ],
                      [
                        -0.162,
                        -0.044
                      ],
                      [
                        -0.069,
                        -0.002
                      ],
                      [
                        -0.14,
                        -0.039
                      ],
                      [
                        -0.075,
                        -0.015
                      ],
                      [
                        -0.072,
                        0.042
                      ],
                      [
                        -0.048,
                        0.06
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.108,
                        -0.044
                      ],
                      [
                        -0.085,
                        0.035
                      ],
                      [
                        -0.112,
                        0.022
                      ],
                      [
                        -0.058,
                        0.006
                      ],
                      [
                        -0.167,
                        0.039
                      ],
                      [
                        -0.065,
                        0.007
                      ],
                      [
                        -0.151,
                        0.048
                      ],
                      [
                        -0.061,
                        0.018
                      ],
                      [
                        -0.149,
                        0.061
                      ],
                      [
                        -0.055,
                        0.049
                      ],
                      [
                        -0.126,
                        0.066
                      ],
                      [
                        -0.062,
                        0.027
                      ],
                      [
                        -0.128,
                        0.082
                      ],
                      [
                        -0.042,
                        0.031
                      ],
                      [
                        -0.152,
                        0.118
                      ],
                      [
                        -0.048,
                        0.053
                      ],
                      [
                        -0.106,
                        0.098
                      ],
                      [
                        -0.051,
                        0.046
                      ],
                      [
                        -0.1,
                        0.111
                      ],
                      [
                        -0.045,
                        0.052
                      ],
                      [
                        -0.089,
                        0.119
                      ],
                      [
                        -0.035,
                        0.063
                      ],
                      [
                        -0.074,
                        0.122
                      ],
                      [
                        -0.027,
                        0.068
                      ],
                      [
                        -0.062,
                        0.127
                      ],
                      [
                        -0.031,
                        0.059
                      ],
                      [
                        -0.054,
                        0.146
                      ],
                      [
                        -0.023,
                        0.095
                      ],
                      [
                        -0.028,
                        0.104
                      ],
                      [
                        0.002,
                        0.075
                      ],
                      [
                        -0.023,
                        0.136
                      ],
                      [
                        -0.004,
                        0.025
                      ],
                      [
                        -0.013,
                        0.053
                      ],
                      [
                        -0.003,
                        0.097
                      ]
                    ],
                    "o": [
                      [
                        -0.017,
                        -0.065
                      ],
                      [
                        0.008,
                        -0.188
                      ],
                      [
                        -0.013,
                        -0.09
                      ],
                      [
                        -0.034,
                        -0.09
                      ],
                      [
                        -0.039,
                        -0.182
                      ],
                      [
                        -0.041,
                        -0.112
                      ],
                      [
                        -0.011,
                        -0.081
                      ],
                      [
                        -0.066,
                        -0.135
                      ],
                      [
                        -0.046,
                        -0.048
                      ],
                      [
                        -0.063,
                        -0.101
                      ],
                      [
                        -0.028,
                        -0.076
                      ],
                      [
                        -0.124,
                        -0.142
                      ],
                      [
                        -0.084,
                        -0.089
                      ],
                      [
                        -0.036,
                        -0.072
                      ],
                      [
                        -0.112,
                        -0.097
                      ],
                      [
                        -0.062,
                        -0.028
                      ],
                      [
                        -0.106,
                        -0.08
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.071,
                        -0.064
                      ],
                      [
                        -0.116,
                        -0.07
                      ],
                      [
                        -0.077,
                        -0.058
                      ],
                      [
                        -0.123,
                        -0.059
                      ],
                      [
                        -0.087,
                        -0.04
                      ],
                      [
                        -0.174,
                        -0.069
                      ],
                      [
                        -0.123,
                        -0.03
                      ],
                      [
                        -0.069,
                        -0.035
                      ],
                      [
                        -0.102,
                        -0.015
                      ],
                      [
                        -0.09,
                        -0.015
                      ],
                      [
                        -0.137,
                        -0.007
                      ],
                      [
                        -0.071,
                        0.013
                      ],
                      [
                        -0.132,
                        0.007
                      ],
                      [
                        -0.072,
                        -0.006
                      ],
                      [
                        -0.126,
                        0.016
                      ],
                      [
                        -0.076,
                        0.002
                      ],
                      [
                        -0.137,
                        0.027
                      ],
                      [
                        -0.062,
                        0.037
                      ],
                      [
                        -0.111,
                        0.032
                      ],
                      [
                        -0.08,
                        0.015
                      ],
                      [
                        -0.175,
                        0.068
                      ],
                      [
                        -0.085,
                        0.038
                      ],
                      [
                        -0.074,
                        0.062
                      ],
                      [
                        -0.079,
                        0.044
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.075,
                        0.051
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.141,
                        0.123
                      ],
                      [
                        -0.138,
                        0.129
                      ],
                      [
                        -0.116,
                        0.15
                      ],
                      [
                        -0.079,
                        0.125
                      ],
                      [
                        -0.015,
                        0.066
                      ],
                      [
                        -0.097,
                        0.161
                      ],
                      [
                        -0.083,
                        0.17
                      ],
                      [
                        -0.025,
                        0.089
                      ],
                      [
                        0.009,
                        0.098
                      ],
                      [
                        -0.049,
                        0.182
                      ],
                      [
                        -0.027,
                        0.186
                      ],
                      [
                        0.004,
                        0.092
                      ],
                      [
                        0.028,
                        0.092
                      ],
                      [
                        0.021,
                        0.119
                      ],
                      [
                        0.003,
                        0.078
                      ],
                      [
                        0.008,
                        0.03
                      ],
                      [
                        0.05,
                        0.186
                      ],
                      [
                        0.036,
                        0.096
                      ],
                      [
                        0.03,
                        0.085
                      ],
                      [
                        0.056,
                        0.114
                      ],
                      [
                        0.023,
                        0.072
                      ],
                      [
                        0.05,
                        0.082
                      ],
                      [
                        0.051,
                        0.084
                      ],
                      [
                        0.078,
                        0.103
                      ],
                      [
                        0.04,
                        0.063
                      ],
                      [
                        0.092,
                        0.101
                      ],
                      [
                        0.063,
                        0.037
                      ],
                      [
                        0.097,
                        0.088
                      ],
                      [
                        0.048,
                        0.054
                      ],
                      [
                        0.117,
                        0.088
                      ],
                      [
                        0.06,
                        0.032
                      ],
                      [
                        0.111,
                        0.068
                      ],
                      [
                        0.052,
                        0.053
                      ],
                      [
                        0.11,
                        0.055
                      ],
                      [
                        0.067,
                        0.039
                      ],
                      [
                        0.128,
                        0.051
                      ],
                      [
                        0.07,
                        0.011
                      ],
                      [
                        0.111,
                        0.033
                      ],
                      [
                        0.077,
                        0.028
                      ],
                      [
                        0.125,
                        0.027
                      ],
                      [
                        0.079,
                        0.002
                      ],
                      [
                        0.142,
                        0.036
                      ],
                      [
                        0.082,
                        0.015
                      ],
                      [
                        0.07,
                        -0.028
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.003,
                        0.058
                      ],
                      [
                        0.084,
                        0.036
                      ],
                      [
                        0.108,
                        -0.037
                      ],
                      [
                        0.108,
                        -0.019
                      ],
                      [
                        0.085,
                        -0.008
                      ],
                      [
                        0.12,
                        -0.034
                      ],
                      [
                        0.077,
                        -0.008
                      ],
                      [
                        0.114,
                        -0.044
                      ],
                      [
                        0.076,
                        -0.021
                      ],
                      [
                        0.125,
                        -0.062
                      ],
                      [
                        0.054,
                        -0.046
                      ],
                      [
                        0.109,
                        -0.067
                      ],
                      [
                        0.068,
                        -0.029
                      ],
                      [
                        0.073,
                        -0.056
                      ],
                      [
                        0.081,
                        -0.06
                      ],
                      [
                        0.101,
                        -0.092
                      ],
                      [
                        0.046,
                        -0.051
                      ],
                      [
                        0.089,
                        -0.097
                      ],
                      [
                        0.054,
                        -0.048
                      ],
                      [
                        0.079,
                        -0.106
                      ],
                      [
                        0.047,
                        -0.055
                      ],
                      [
                        0.074,
                        -0.119
                      ],
                      [
                        0.034,
                        -0.06
                      ],
                      [
                        0.063,
                        -0.125
                      ],
                      [
                        0.025,
                        -0.063
                      ],
                      [
                        0.046,
                        -0.117
                      ],
                      [
                        0.036,
                        -0.067
                      ],
                      [
                        0.051,
                        -0.164
                      ],
                      [
                        0.014,
                        -0.055
                      ],
                      [
                        0.031,
                        -0.139
                      ],
                      [
                        -0.002,
                        -0.069
                      ],
                      [
                        0.006,
                        -0.03
                      ],
                      [
                        0.015,
                        -0.082
                      ],
                      [
                        0.023,
                        -0.095
                      ],
                      [
                        0.01,
                        -0.146
                      ]
                    ],
                    "v": [
                      [
                        5.964,
                        -0.12
                      ],
                      [
                        5.923,
                        -0.391
                      ],
                      [
                        5.9,
                        -0.954
                      ],
                      [
                        5.842,
                        -1.221
                      ],
                      [
                        5.756,
                        -1.497
                      ],
                      [
                        5.592,
                        -2.031
                      ],
                      [
                        5.533,
                        -2.275
                      ],
                      [
                        5.439,
                        -2.577
                      ],
                      [
                        5.271,
                        -2.823
                      ],
                      [
                        5.105,
                        -3.037
                      ],
                      [
                        4.997,
                        -3.263
                      ],
                      [
                        4.845,
                        -3.538
                      ],
                      [
                        4.446,
                        -3.939
                      ],
                      [
                        4.301,
                        -4.151
                      ],
                      [
                        4.111,
                        -4.397
                      ],
                      [
                        3.862,
                        -4.557
                      ],
                      [
                        3.625,
                        -4.694
                      ],
                      [
                        3.415,
                        -4.864
                      ],
                      [
                        3.413,
                        -4.865
                      ],
                      [
                        3.179,
                        -5.031
                      ],
                      [
                        2.951,
                        -5.181
                      ],
                      [
                        2.702,
                        -5.325
                      ],
                      [
                        2.453,
                        -5.44
                      ],
                      [
                        2.186,
                        -5.547
                      ],
                      [
                        1.655,
                        -5.728
                      ],
                      [
                        1.41,
                        -5.819
                      ],
                      [
                        1.12,
                        -5.916
                      ],
                      [
                        0.898,
                        -5.95
                      ],
                      [
                        0.559,
                        -5.996
                      ],
                      [
                        0.282,
                        -5.976
                      ],
                      [
                        -0.007,
                        -5.955
                      ],
                      [
                        -0.276,
                        -5.961
                      ],
                      [
                        -0.57,
                        -5.966
                      ],
                      [
                        -0.831,
                        -5.949
                      ],
                      [
                        -1.136,
                        -5.923
                      ],
                      [
                        -1.4,
                        -5.822
                      ],
                      [
                        -1.666,
                        -5.714
                      ],
                      [
                        -1.904,
                        -5.659
                      ],
                      [
                        -2.213,
                        -5.576
                      ],
                      [
                        -2.727,
                        -5.343
                      ],
                      [
                        -2.959,
                        -5.195
                      ],
                      [
                        -3.195,
                        -5.028
                      ],
                      [
                        -3.421,
                        -4.877
                      ],
                      [
                        -3.652,
                        -4.704
                      ],
                      [
                        -3.864,
                        -4.533
                      ],
                      [
                        -4.078,
                        -4.339
                      ],
                      [
                        -4.474,
                        -3.942
                      ],
                      [
                        -4.856,
                        -3.526
                      ],
                      [
                        -5.167,
                        -3.053
                      ],
                      [
                        -5.278,
                        -2.782
                      ],
                      [
                        -5.369,
                        -2.523
                      ],
                      [
                        -5.619,
                        -2.019
                      ],
                      [
                        -5.821,
                        -1.491
                      ],
                      [
                        -5.856,
                        -1.217
                      ],
                      [
                        -5.867,
                        -0.926
                      ],
                      [
                        -5.966,
                        -0.37
                      ],
                      [
                        -6.004,
                        0.194
                      ],
                      [
                        -5.956,
                        0.467
                      ],
                      [
                        -5.892,
                        0.75
                      ],
                      [
                        -5.867,
                        1
                      ],
                      [
                        -5.825,
                        1.308
                      ],
                      [
                        -5.803,
                        1.388
                      ],
                      [
                        -5.667,
                        1.848
                      ],
                      [
                        -5.591,
                        2.057
                      ],
                      [
                        -5.469,
                        2.374
                      ],
                      [
                        -5.372,
                        2.618
                      ],
                      [
                        -5.255,
                        2.897
                      ],
                      [
                        -5.146,
                        3.078
                      ],
                      [
                        -4.959,
                        3.379
                      ],
                      [
                        -4.808,
                        3.596
                      ],
                      [
                        -4.634,
                        3.844
                      ],
                      [
                        -4.416,
                        4.018
                      ],
                      [
                        -4.188,
                        4.201
                      ],
                      [
                        -4,
                        4.391
                      ],
                      [
                        -3.793,
                        4.599
                      ],
                      [
                        -3.555,
                        4.753
                      ],
                      [
                        -3.32,
                        4.904
                      ],
                      [
                        -3.111,
                        5.071
                      ],
                      [
                        -2.877,
                        5.256
                      ],
                      [
                        -2.652,
                        5.376
                      ],
                      [
                        -2.377,
                        5.521
                      ],
                      [
                        -2.106,
                        5.592
                      ],
                      [
                        -1.828,
                        5.664
                      ],
                      [
                        -1.598,
                        5.742
                      ],
                      [
                        -1.292,
                        5.839
                      ],
                      [
                        -1.026,
                        5.87
                      ],
                      [
                        -0.734,
                        5.913
                      ],
                      [
                        -0.431,
                        5.985
                      ],
                      [
                        -0.193,
                        5.943
                      ],
                      [
                        -0.014,
                        5.809
                      ],
                      [
                        0.004,
                        5.809
                      ],
                      [
                        0.167,
                        5.965
                      ],
                      [
                        0.432,
                        5.968
                      ],
                      [
                        0.761,
                        5.88
                      ],
                      [
                        0.992,
                        5.848
                      ],
                      [
                        1.314,
                        5.794
                      ],
                      [
                        1.567,
                        5.747
                      ],
                      [
                        1.867,
                        5.683
                      ],
                      [
                        2.107,
                        5.604
                      ],
                      [
                        2.401,
                        5.502
                      ],
                      [
                        2.635,
                        5.344
                      ],
                      [
                        2.872,
                        5.182
                      ],
                      [
                        3.105,
                        5.062
                      ],
                      [
                        3.369,
                        4.923
                      ],
                      [
                        3.533,
                        4.8
                      ],
                      [
                        3.818,
                        4.584
                      ],
                      [
                        4.012,
                        4.388
                      ],
                      [
                        4.212,
                        4.184
                      ],
                      [
                        4.403,
                        3.996
                      ],
                      [
                        4.611,
                        3.789
                      ],
                      [
                        4.78,
                        3.58
                      ],
                      [
                        4.964,
                        3.35
                      ],
                      [
                        5.106,
                        3.108
                      ],
                      [
                        5.249,
                        2.863
                      ],
                      [
                        5.364,
                        2.607
                      ],
                      [
                        5.478,
                        2.349
                      ],
                      [
                        5.587,
                        2.113
                      ],
                      [
                        5.711,
                        1.835
                      ],
                      [
                        5.8,
                        1.515
                      ],
                      [
                        5.858,
                        1.29
                      ],
                      [
                        5.885,
                        1.006
                      ],
                      [
                        5.903,
                        0.727
                      ],
                      [
                        5.917,
                        0.646
                      ],
                      [
                        5.954,
                        0.458
                      ],
                      [
                        5.993,
                        0.17
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 2",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.169000004787,
                    0.161000001197,
                    0.176000004189,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    6.003,
                    34.825
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 133.5,
                      "s": [
                        0,
                        0
                      ]
                    },
                    {
                      "t": 140.101255706441,
                      "s": [
                        100,
                        100
                      ]
                    }
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 158.25,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 166.500006781684,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0.085,
                        -0.505
                      ],
                      [
                        0.3,
                        -1.264
                      ],
                      [
                        1.261,
                        -3.054
                      ],
                      [
                        3.122,
                        -2.115
                      ],
                      [
                        2.138,
                        2.354
                      ],
                      [
                        0.005,
                        1.481
                      ],
                      [
                        -1.043,
                        0.275
                      ],
                      [
                        -1.043,
                        -1.096
                      ],
                      [
                        -0.044,
                        -1.798
                      ],
                      [
                        1.121,
                        -1.996
                      ],
                      [
                        2.416,
                        -1.568
                      ],
                      [
                        4.05,
                        2.175
                      ]
                    ],
                    "o": [
                      [
                        -0.088,
                        0.459
                      ],
                      [
                        -0.214,
                        1.284
                      ],
                      [
                        -0.767,
                        3.23
                      ],
                      [
                        -1.39,
                        3.363
                      ],
                      [
                        -2.105,
                        1.427
                      ],
                      [
                        -1.047,
                        -1.152
                      ],
                      [
                        -0.003,
                        -1.176
                      ],
                      [
                        1.522,
                        -0.401
                      ],
                      [
                        1.227,
                        1.289
                      ],
                      [
                        0.056,
                        2.331
                      ],
                      [
                        -1.408,
                        2.509
                      ],
                      [
                        -3.825,
                        2.483
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        16.565,
                        -19.517
                      ],
                      [
                        16.397,
                        -18.043
                      ],
                      [
                        15.316,
                        -14.287
                      ],
                      [
                        12.001,
                        -5
                      ],
                      [
                        5.955,
                        3.761
                      ],
                      [
                        -2.704,
                        4.838
                      ],
                      [
                        -3.87,
                        0.717
                      ],
                      [
                        -2.086,
                        -1.219
                      ],
                      [
                        1.848,
                        0.124
                      ],
                      [
                        3.517,
                        4.335
                      ],
                      [
                        1.491,
                        10.835
                      ],
                      [
                        -3.885,
                        16.73
                      ],
                      [
                        -16.565,
                        17.342
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 133.5,
                      "s": [
                        100
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 147.87,
                      "s": [
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 151.788,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 164.850006714478,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 151.788,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 164.850006714478,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 2
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    50.203,
                    21.517
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.046,
                        -0.338
                      ],
                      [
                        0.294,
                        -0.692
                      ],
                      [
                        1.165,
                        -0.485
                      ],
                      [
                        0.897,
                        0
                      ],
                      [
                        -0.256,
                        0.069
                      ],
                      [
                        -0.533,
                        0.038
                      ],
                      [
                        -0.785,
                        -0.754
                      ],
                      [
                        -0.324,
                        -0.98
                      ],
                      [
                        -0.213,
                        -0.87
                      ],
                      [
                        0,
                        -0.333
                      ],
                      [
                        0.019,
                        0.112
                      ],
                      [
                        0.006,
                        0.324
                      ],
                      [
                        -0.102,
                        1.073
                      ],
                      [
                        -0.589,
                        0.566
                      ],
                      [
                        -1.018,
                        0.222
                      ],
                      [
                        -0.662,
                        0.043
                      ],
                      [
                        -0.204,
                        0
                      ],
                      [
                        0.317,
                        0.07
                      ],
                      [
                        0.937,
                        0.634
                      ],
                      [
                        0.231,
                        0.443
                      ],
                      [
                        0.202,
                        0.5
                      ],
                      [
                        0.363,
                        0.698
                      ],
                      [
                        0.255,
                        0.367
                      ]
                    ],
                    "o": [
                      [
                        -0.023,
                        -0.912
                      ],
                      [
                        0.099,
                        0.725
                      ],
                      [
                        -0.447,
                        1.049
                      ],
                      [
                        -0.819,
                        0.341
                      ],
                      [
                        -0.266,
                        0
                      ],
                      [
                        0.514,
                        -0.142
                      ],
                      [
                        1.064,
                        -0.076
                      ],
                      [
                        0.773,
                        0.743
                      ],
                      [
                        0.289,
                        0.873
                      ],
                      [
                        0.079,
                        0.323
                      ],
                      [
                        0,
                        0.305
                      ],
                      [
                        -0.052,
                        -0.321
                      ],
                      [
                        -0.022,
                        -1.082
                      ],
                      [
                        0.078,
                        -0.827
                      ],
                      [
                        0.741,
                        -0.713
                      ],
                      [
                        0.648,
                        -0.143
                      ],
                      [
                        0.203,
                        -0.012
                      ],
                      [
                        0.326,
                        0
                      ],
                      [
                        -1.058,
                        -0.231
                      ],
                      [
                        -0.434,
                        -0.294
                      ],
                      [
                        -0.25,
                        -0.48
                      ],
                      [
                        -0.3,
                        -0.742
                      ],
                      [
                        -0.211,
                        -0.405
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.655,
                        -6.681
                      ],
                      [
                        -0.708,
                        -6.179
                      ],
                      [
                        -0.892,
                        -3.769
                      ],
                      [
                        -2.955,
                        -0.837
                      ],
                      [
                        -5.686,
                        -0.016
                      ],
                      [
                        -6.477,
                        0.071
                      ],
                      [
                        -4.869,
                        -0.112
                      ],
                      [
                        -1.72,
                        0.786
                      ],
                      [
                        -0.233,
                        3.636
                      ],
                      [
                        0.178,
                        6.285
                      ],
                      [
                        0.294,
                        7.289
                      ],
                      [
                        0.22,
                        7.106
                      ],
                      [
                        0.105,
                        6.102
                      ],
                      [
                        0.015,
                        2.815
                      ],
                      [
                        1.318,
                        0.735
                      ],
                      [
                        3.807,
                        -0.426
                      ],
                      [
                        5.795,
                        -0.65
                      ],
                      [
                        6.407,
                        -0.655
                      ],
                      [
                        5.431,
                        -0.701
                      ],
                      [
                        2.214,
                        -1.385
                      ],
                      [
                        1.291,
                        -2.663
                      ],
                      [
                        0.527,
                        -4.043
                      ],
                      [
                        -0.349,
                        -6.225
                      ],
                      [
                        -0.94,
                        -7.594
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 2
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    68.528,
                    67.42
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 133.5,
                      "s": [
                        0,
                        0
                      ]
                    },
                    {
                      "t": 141.748755773545,
                      "s": [
                        100,
                        100
                      ]
                    }
                  ]
                },
                "r": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 133.5,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 156.187506361647,
                      "s": [
                        75
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 145.875,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 156.187506361647,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 4",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 0,
        "op": 1615.50006580066,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 8,
        "ty": 4,
        "nm": "blank_template Outlines",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 120,
                "s": [
                  0
                ]
              },
              {
                "t": 125.000005091354,
                "s": [
                  100
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.5,
                  "y": 1
                },
                "o": {
                  "x": 0.5,
                  "y": 0
                },
                "t": 120,
                "s": [
                  306,
                  480,
                  0
                ],
                "to": [
                  0,
                  -11,
                  0
                ],
                "ti": [
                  0,
                  11,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.1,
                  "y": 0.1
                },
                "o": {
                  "x": 0.53,
                  "y": 0.53
                },
                "t": 140,
                "s": [
                  306,
                  414,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.1,
                  "y": 1
                },
                "o": {
                  "x": 0.9,
                  "y": 0
                },
                "t": 249,
                "s": [
                  306,
                  414,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "t": 279.000011363903,
                "s": [
                  306,
                  886.77,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              255,
              256.5,
              0
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 25,
            "nm": "Drop Shadow",
            "np": 8,
            "mn": "ADBE Drop Shadow",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 2,
                "nm": "Shadow Color",
                "mn": "ADBE Drop Shadow-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Opacity",
                "mn": "ADBE Drop Shadow-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 30.6
                }
              },
              {
                "ty": 0,
                "nm": "Direction",
                "mn": "ADBE Drop Shadow-0003",
                "ix": 3,
                "v": {
                  "a": 0,
                  "k": 135
                }
              },
              {
                "ty": 0,
                "nm": "Distance",
                "mn": "ADBE Drop Shadow-0004",
                "ix": 4,
                "v": {
                  "a": 0,
                  "k": 3
                }
              },
              {
                "ty": 0,
                "nm": "Softness",
                "mn": "ADBE Drop Shadow-0005",
                "ix": 5,
                "v": {
                  "a": 0,
                  "k": 40
                }
              },
              {
                "ty": 7,
                "nm": "Shadow Only",
                "mn": "ADBE Drop Shadow-0006",
                "ix": 6,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        242.363,
                        -295.695
                      ],
                      [
                        -242.363,
                        -295.695
                      ],
                      [
                        -242.363,
                        295.695
                      ],
                      [
                        242.363,
                        295.695
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 8
                },
                "lc": 1,
                "lj": 1,
                "ml": 4,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.6,
                    0.760784313725,
                    0.349019607843,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    257.363,
                    308.195
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Rectangle 1",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.313,
                            0
                          ],
                          [
                            0,
                            3.387
                          ],
                          [
                            3.93,
                            0.607
                          ],
                          [
                            0,
                            1.214
                          ],
                          [
                            -1.662,
                            0
                          ],
                          [
                            -0.319,
                            -1.534
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.419,
                            0
                          ],
                          [
                            0,
                            -3.356
                          ],
                          [
                            -4.411,
                            -0.703
                          ],
                          [
                            0,
                            -1.374
                          ],
                          [
                            2.078,
                            0
                          ],
                          [
                            0.19,
                            1.694
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            4.283,
                            0
                          ],
                          [
                            0,
                            -3.547
                          ],
                          [
                            -2.653,
                            -0.448
                          ],
                          [
                            0,
                            -1.183
                          ],
                          [
                            1.789,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.415,
                            -3.771
                          ],
                          [
                            -3.132,
                            0
                          ],
                          [
                            0,
                            3.132
                          ],
                          [
                            2.46,
                            0.416
                          ],
                          [
                            0,
                            1.406
                          ],
                          [
                            -2.269,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.159,
                            3.548
                          ]
                        ],
                        "v": [
                          [
                            6.559,
                            25.763
                          ],
                          [
                            13.237,
                            20.426
                          ],
                          [
                            6.974,
                            15.313
                          ],
                          [
                            3.522,
                            13.173
                          ],
                          [
                            6.175,
                            11.19
                          ],
                          [
                            9.147,
                            13.427
                          ],
                          [
                            12.727,
                            13.427
                          ],
                          [
                            6.175,
                            8.378
                          ],
                          [
                            -0.088,
                            13.395
                          ],
                          [
                            5.952,
                            18.476
                          ],
                          [
                            9.53,
                            20.777
                          ],
                          [
                            6.526,
                            22.919
                          ],
                          [
                            3.204,
                            20.234
                          ],
                          [
                            -0.439,
                            20.234
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.278,
                            0
                          ],
                          [
                            0,
                            1.246
                          ],
                          [
                            1.279,
                            0
                          ],
                          [
                            0,
                            -1.279
                          ]
                        ],
                        "o": [
                          [
                            1.279,
                            0
                          ],
                          [
                            0,
                            -1.279
                          ],
                          [
                            -1.278,
                            0
                          ],
                          [
                            0,
                            1.246
                          ]
                        ],
                        "v": [
                          [
                            -5.629,
                            5.981
                          ],
                          [
                            -3.327,
                            3.776
                          ],
                          [
                            -5.629,
                            1.539
                          ],
                          [
                            -7.929,
                            3.776
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 2",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -7.514,
                            25.443
                          ],
                          [
                            -3.646,
                            25.443
                          ],
                          [
                            -3.646,
                            8.729
                          ],
                          [
                            -7.514,
                            8.729
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 3",
                    "hd": false
                  },
                  {
                    "ind": 3,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.314,
                            0
                          ],
                          [
                            0,
                            3.387
                          ],
                          [
                            3.93,
                            0.607
                          ],
                          [
                            0,
                            1.214
                          ],
                          [
                            -1.662,
                            0
                          ],
                          [
                            -0.32,
                            -1.534
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.419,
                            0
                          ],
                          [
                            0,
                            -3.356
                          ],
                          [
                            -4.41,
                            -0.703
                          ],
                          [
                            0,
                            -1.374
                          ],
                          [
                            2.078,
                            0
                          ],
                          [
                            0.191,
                            1.694
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            4.283,
                            0
                          ],
                          [
                            0,
                            -3.547
                          ],
                          [
                            -2.653,
                            -0.448
                          ],
                          [
                            0,
                            -1.183
                          ],
                          [
                            1.789,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.415,
                            -3.771
                          ],
                          [
                            -3.132,
                            0
                          ],
                          [
                            0,
                            3.132
                          ],
                          [
                            2.461,
                            0.416
                          ],
                          [
                            0,
                            1.406
                          ],
                          [
                            -2.269,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.159,
                            3.548
                          ]
                        ],
                        "v": [
                          [
                            -17.452,
                            25.763
                          ],
                          [
                            -10.773,
                            20.426
                          ],
                          [
                            -17.036,
                            15.313
                          ],
                          [
                            -20.489,
                            13.173
                          ],
                          [
                            -17.836,
                            11.19
                          ],
                          [
                            -14.864,
                            13.427
                          ],
                          [
                            -11.285,
                            13.427
                          ],
                          [
                            -17.836,
                            8.378
                          ],
                          [
                            -24.1,
                            13.395
                          ],
                          [
                            -18.06,
                            18.476
                          ],
                          [
                            -14.48,
                            20.777
                          ],
                          [
                            -17.484,
                            22.919
                          ],
                          [
                            -20.808,
                            20.234
                          ],
                          [
                            -24.451,
                            20.234
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 4",
                    "hd": false
                  },
                  {
                    "ind": 4,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -38.755,
                            31.163
                          ],
                          [
                            -34.952,
                            31.163
                          ],
                          [
                            -25.844,
                            8.729
                          ],
                          [
                            -29.616,
                            8.729
                          ],
                          [
                            -33.706,
                            19.499
                          ],
                          [
                            -38.148,
                            8.729
                          ],
                          [
                            -42.335,
                            8.729
                          ],
                          [
                            -35.719,
                            23.749
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 5",
                    "hd": false
                  },
                  {
                    "ind": 5,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -48.961,
                            25.443
                          ],
                          [
                            -45.094,
                            25.443
                          ],
                          [
                            -45.094,
                            0.995
                          ],
                          [
                            -48.961,
                            0.995
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 6",
                    "hd": false
                  },
                  {
                    "ind": 6,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            2.365,
                            0
                          ],
                          [
                            0,
                            1.405
                          ],
                          [
                            -2.94,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -1.917,
                            0
                          ],
                          [
                            0,
                            -2.046
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.141
                          ]
                        ],
                        "v": [
                          [
                            -61.249,
                            22.982
                          ],
                          [
                            -63.934,
                            20.65
                          ],
                          [
                            -59.109,
                            17.933
                          ],
                          [
                            -57.127,
                            17.933
                          ],
                          [
                            -57.127,
                            19.595
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 7",
                    "hd": false
                  },
                  {
                    "ind": 7,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -3.068,
                            0
                          ],
                          [
                            -1.087,
                            1.438
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.739,
                            0
                          ],
                          [
                            0.319,
                            -3.899
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.014,
                            0
                          ],
                          [
                            0,
                            -2.236
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.899
                          ]
                        ],
                        "o": [
                          [
                            2.557,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -4.57
                          ],
                          [
                            -3.739,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.192,
                            -1.663
                          ],
                          [
                            2.269,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -4.793,
                            0
                          ],
                          [
                            0,
                            3.484
                          ]
                        ],
                        "v": [
                          [
                            -62.176,
                            25.763
                          ],
                          [
                            -57.062,
                            23.398
                          ],
                          [
                            -57.062,
                            25.443
                          ],
                          [
                            -53.26,
                            25.443
                          ],
                          [
                            -53.26,
                            14.482
                          ],
                          [
                            -59.939,
                            8.378
                          ],
                          [
                            -67.098,
                            13.907
                          ],
                          [
                            -63.359,
                            13.907
                          ],
                          [
                            -60.163,
                            11.286
                          ],
                          [
                            -57.127,
                            14.641
                          ],
                          [
                            -57.127,
                            15.505
                          ],
                          [
                            -59.204,
                            15.505
                          ],
                          [
                            -67.769,
                            20.809
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 8",
                    "hd": false
                  },
                  {
                    "ind": 8,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.173,
                            0
                          ],
                          [
                            0,
                            -2.525
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.356,
                            0
                          ],
                          [
                            0.799,
                            -1.63
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.652
                          ],
                          [
                            2.301,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -4.602
                          ],
                          [
                            -2.748,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -85.77,
                            25.443
                          ],
                          [
                            -81.902,
                            25.443
                          ],
                          [
                            -81.902,
                            15.6
                          ],
                          [
                            -77.971,
                            11.606
                          ],
                          [
                            -74.648,
                            15.281
                          ],
                          [
                            -74.648,
                            25.443
                          ],
                          [
                            -70.781,
                            25.443
                          ],
                          [
                            -70.781,
                            14.929
                          ],
                          [
                            -76.501,
                            8.378
                          ],
                          [
                            -81.902,
                            11.382
                          ],
                          [
                            -81.902,
                            8.729
                          ],
                          [
                            -85.77,
                            8.729
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 9",
                    "hd": false
                  },
                  {
                    "ind": 9,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -99.286,
                            6.077
                          ],
                          [
                            -95.93,
                            16.687
                          ],
                          [
                            -102.674,
                            16.687
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 10",
                    "hd": false
                  },
                  {
                    "ind": 10,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -109.449,
                            25.443
                          ],
                          [
                            -105.454,
                            25.443
                          ],
                          [
                            -103.665,
                            19.786
                          ],
                          [
                            -94.941,
                            19.786
                          ],
                          [
                            -93.118,
                            25.443
                          ],
                          [
                            -88.708,
                            25.443
                          ],
                          [
                            -96.251,
                            2.594
                          ],
                          [
                            -101.812,
                            2.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 11",
                    "hd": false
                  },
                  {
                    "ind": 11,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.314,
                            0
                          ],
                          [
                            0,
                            3.387
                          ],
                          [
                            3.93,
                            0.607
                          ],
                          [
                            0,
                            1.214
                          ],
                          [
                            -1.662,
                            0
                          ],
                          [
                            -0.32,
                            -1.534
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.419,
                            0
                          ],
                          [
                            0,
                            -3.356
                          ],
                          [
                            -4.411,
                            -0.703
                          ],
                          [
                            0,
                            -1.374
                          ],
                          [
                            2.077,
                            0
                          ],
                          [
                            0.191,
                            1.694
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            4.282,
                            0
                          ],
                          [
                            0,
                            -3.547
                          ],
                          [
                            -2.652,
                            -0.448
                          ],
                          [
                            0,
                            -1.183
                          ],
                          [
                            1.789,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.416,
                            -3.771
                          ],
                          [
                            -3.132,
                            0
                          ],
                          [
                            0,
                            3.132
                          ],
                          [
                            2.46,
                            0.416
                          ],
                          [
                            0,
                            1.406
                          ],
                          [
                            -2.269,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            3.548
                          ]
                        ],
                        "v": [
                          [
                            102.768,
                            -6.237
                          ],
                          [
                            109.448,
                            -11.574
                          ],
                          [
                            103.184,
                            -16.687
                          ],
                          [
                            99.732,
                            -18.827
                          ],
                          [
                            102.385,
                            -20.81
                          ],
                          [
                            105.357,
                            -18.573
                          ],
                          [
                            108.936,
                            -18.573
                          ],
                          [
                            102.385,
                            -23.622
                          ],
                          [
                            96.121,
                            -18.605
                          ],
                          [
                            102.162,
                            -13.524
                          ],
                          [
                            105.741,
                            -11.223
                          ],
                          [
                            102.736,
                            -9.082
                          ],
                          [
                            99.413,
                            -11.766
                          ],
                          [
                            95.77,
                            -11.766
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 12",
                    "hd": false
                  },
                  {
                    "ind": 12,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.314,
                            0
                          ],
                          [
                            0,
                            3.387
                          ],
                          [
                            3.93,
                            0.607
                          ],
                          [
                            0,
                            1.214
                          ],
                          [
                            -1.66,
                            0
                          ],
                          [
                            -0.319,
                            -1.534
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.421,
                            0
                          ],
                          [
                            0,
                            -3.356
                          ],
                          [
                            -4.411,
                            -0.703
                          ],
                          [
                            0,
                            -1.374
                          ],
                          [
                            2.077,
                            0
                          ],
                          [
                            0.192,
                            1.694
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            4.282,
                            0
                          ],
                          [
                            0,
                            -3.547
                          ],
                          [
                            -2.653,
                            -0.448
                          ],
                          [
                            0,
                            -1.183
                          ],
                          [
                            1.79,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.416,
                            -3.771
                          ],
                          [
                            -3.132,
                            0
                          ],
                          [
                            0,
                            3.132
                          ],
                          [
                            2.46,
                            0.416
                          ],
                          [
                            0,
                            1.406
                          ],
                          [
                            -2.269,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.161,
                            3.548
                          ]
                        ],
                        "v": [
                          [
                            87.206,
                            -6.237
                          ],
                          [
                            93.884,
                            -11.574
                          ],
                          [
                            87.621,
                            -16.687
                          ],
                          [
                            84.169,
                            -18.827
                          ],
                          [
                            86.822,
                            -20.81
                          ],
                          [
                            89.793,
                            -18.573
                          ],
                          [
                            93.374,
                            -18.573
                          ],
                          [
                            86.822,
                            -23.622
                          ],
                          [
                            80.559,
                            -18.605
                          ],
                          [
                            86.598,
                            -13.524
                          ],
                          [
                            90.177,
                            -11.223
                          ],
                          [
                            87.173,
                            -9.082
                          ],
                          [
                            83.849,
                            -11.766
                          ],
                          [
                            80.206,
                            -11.766
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 13",
                    "hd": false
                  },
                  {
                    "ind": 13,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.92,
                            0
                          ],
                          [
                            0,
                            5.209
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            4.89,
                            0
                          ],
                          [
                            0,
                            -5.177
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            4.922,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -5.113
                          ],
                          [
                            -4.921,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            5.081
                          ]
                        ],
                        "v": [
                          [
                            69.622,
                            -6.237
                          ],
                          [
                            78.219,
                            -14.834
                          ],
                          [
                            78.219,
                            -15.09
                          ],
                          [
                            69.654,
                            -23.622
                          ],
                          [
                            61.059,
                            -14.994
                          ],
                          [
                            61.059,
                            -14.738
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 14",
                    "hd": false
                  },
                  {
                    "ind": 14,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            2.876,
                            0
                          ],
                          [
                            0,
                            3.419
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.876,
                            0
                          ],
                          [
                            0,
                            -3.451
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -2.94,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.452
                          ],
                          [
                            2.876,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.419
                          ]
                        ],
                        "v": [
                          [
                            69.654,
                            -9.241
                          ],
                          [
                            65.02,
                            -14.801
                          ],
                          [
                            65.02,
                            -15.057
                          ],
                          [
                            69.654,
                            -20.586
                          ],
                          [
                            74.257,
                            -15.026
                          ],
                          [
                            74.257,
                            -14.801
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 15",
                    "hd": false
                  },
                  {
                    "ind": 15,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            45.434,
                            -6.557
                          ],
                          [
                            59.432,
                            -6.557
                          ],
                          [
                            59.432,
                            -9.945
                          ],
                          [
                            49.686,
                            -9.945
                          ],
                          [
                            49.686,
                            -29.406
                          ],
                          [
                            45.434,
                            -29.406
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 16",
                    "hd": false
                  },
                  {
                    "ind": 16,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            2.684,
                            0
                          ],
                          [
                            0,
                            3.675
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.845,
                            0
                          ],
                          [
                            0,
                            -3.675
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -2.493,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.611
                          ],
                          [
                            2.812,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.739
                          ]
                        ],
                        "v": [
                          [
                            24.956,
                            -9.305
                          ],
                          [
                            20.609,
                            -14.738
                          ],
                          [
                            20.609,
                            -14.994
                          ],
                          [
                            25.117,
                            -20.586
                          ],
                          [
                            29.621,
                            -15.09
                          ],
                          [
                            29.621,
                            -14.834
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 17",
                    "hd": false
                  },
                  {
                    "ind": 17,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.186,
                            0
                          ],
                          [
                            -0.896,
                            1.662
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.715,
                            0
                          ],
                          [
                            0,
                            -5.337
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            2.461,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.928,
                            -1.662
                          ],
                          [
                            -4.347,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            5.433
                          ]
                        ],
                        "v": [
                          [
                            23.997,
                            -6.237
                          ],
                          [
                            29.495,
                            -9.369
                          ],
                          [
                            29.495,
                            -6.557
                          ],
                          [
                            33.361,
                            -6.557
                          ],
                          [
                            33.361,
                            -31.005
                          ],
                          [
                            29.495,
                            -31.005
                          ],
                          [
                            29.495,
                            -20.714
                          ],
                          [
                            24.158,
                            -23.622
                          ],
                          [
                            16.647,
                            -14.898
                          ],
                          [
                            16.647,
                            -14.642
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 18",
                    "hd": false
                  },
                  {
                    "ind": 18,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.173,
                            0
                          ],
                          [
                            0,
                            -2.525
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.355,
                            0
                          ],
                          [
                            0.799,
                            -1.63
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.652
                          ],
                          [
                            2.302,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -4.602
                          ],
                          [
                            -2.749,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.48,
                            -6.557
                          ],
                          [
                            2.385,
                            -6.557
                          ],
                          [
                            2.385,
                            -16.4
                          ],
                          [
                            6.316,
                            -20.394
                          ],
                          [
                            9.64,
                            -16.719
                          ],
                          [
                            9.64,
                            -6.557
                          ],
                          [
                            13.507,
                            -6.557
                          ],
                          [
                            13.507,
                            -17.071
                          ],
                          [
                            7.787,
                            -23.622
                          ],
                          [
                            2.385,
                            -20.618
                          ],
                          [
                            2.385,
                            -23.271
                          ],
                          [
                            -1.48,
                            -23.271
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 19",
                    "hd": false
                  },
                  {
                    "ind": 19,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            2.365,
                            0
                          ],
                          [
                            0,
                            1.405
                          ],
                          [
                            -2.94,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -1.917,
                            0
                          ],
                          [
                            0,
                            -2.046
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.141
                          ]
                        ],
                        "v": [
                          [
                            -13.674,
                            -9.018
                          ],
                          [
                            -16.359,
                            -11.35
                          ],
                          [
                            -11.534,
                            -14.067
                          ],
                          [
                            -9.551,
                            -14.067
                          ],
                          [
                            -9.551,
                            -12.405
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 20",
                    "hd": false
                  },
                  {
                    "ind": 20,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -3.068,
                            0
                          ],
                          [
                            -1.087,
                            1.438
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.739,
                            0
                          ],
                          [
                            0.32,
                            -3.899
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.013,
                            0
                          ],
                          [
                            0,
                            -2.236
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.899
                          ]
                        ],
                        "o": [
                          [
                            2.556,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -4.57
                          ],
                          [
                            -3.739,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.192,
                            -1.663
                          ],
                          [
                            2.269,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -4.794,
                            0
                          ],
                          [
                            0,
                            3.484
                          ]
                        ],
                        "v": [
                          [
                            -14.601,
                            -6.237
                          ],
                          [
                            -9.488,
                            -8.602
                          ],
                          [
                            -9.488,
                            -6.557
                          ],
                          [
                            -5.685,
                            -6.557
                          ],
                          [
                            -5.685,
                            -17.518
                          ],
                          [
                            -12.364,
                            -23.622
                          ],
                          [
                            -19.523,
                            -18.093
                          ],
                          [
                            -15.784,
                            -18.093
                          ],
                          [
                            -12.588,
                            -20.714
                          ],
                          [
                            -9.551,
                            -17.359
                          ],
                          [
                            -9.551,
                            -16.495
                          ],
                          [
                            -11.629,
                            -16.495
                          ],
                          [
                            -20.194,
                            -11.191
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 21",
                    "hd": false
                  },
                  {
                    "ind": 21,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -3.324,
                            0
                          ],
                          [
                            -0.607,
                            0.224
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.767,
                            0
                          ],
                          [
                            0,
                            1.47
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            1.182,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.543,
                            0.224
                          ],
                          [
                            -1.215,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.164
                          ]
                        ],
                        "v": [
                          [
                            -32.245,
                            -6.269
                          ],
                          [
                            -29.626,
                            -6.685
                          ],
                          [
                            -29.626,
                            -9.753
                          ],
                          [
                            -31.51,
                            -9.433
                          ],
                          [
                            -33.428,
                            -11.574
                          ],
                          [
                            -33.428,
                            -20.362
                          ],
                          [
                            -29.754,
                            -20.362
                          ],
                          [
                            -29.754,
                            -23.271
                          ],
                          [
                            -33.428,
                            -23.271
                          ],
                          [
                            -33.428,
                            -26.946
                          ],
                          [
                            -37.296,
                            -26.946
                          ],
                          [
                            -37.296,
                            -23.271
                          ],
                          [
                            -39.533,
                            -23.271
                          ],
                          [
                            -39.533,
                            -20.362
                          ],
                          [
                            -37.296,
                            -20.362
                          ],
                          [
                            -37.296,
                            -11.223
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 22",
                    "hd": false
                  },
                  {
                    "ind": 22,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.278,
                            0
                          ],
                          [
                            0,
                            1.246
                          ],
                          [
                            1.278,
                            0
                          ],
                          [
                            0,
                            -1.278
                          ]
                        ],
                        "o": [
                          [
                            1.278,
                            0
                          ],
                          [
                            0,
                            -1.278
                          ],
                          [
                            -1.278,
                            0
                          ],
                          [
                            0,
                            1.246
                          ]
                        ],
                        "v": [
                          [
                            -44.4,
                            -26.019
                          ],
                          [
                            -42.1,
                            -28.224
                          ],
                          [
                            -44.4,
                            -30.461
                          ],
                          [
                            -46.702,
                            -28.224
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 23",
                    "hd": false
                  },
                  {
                    "ind": 23,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -46.286,
                            -6.557
                          ],
                          [
                            -42.42,
                            -6.557
                          ],
                          [
                            -42.42,
                            -23.271
                          ],
                          [
                            -46.286,
                            -23.271
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 24",
                    "hd": false
                  },
                  {
                    "ind": 24,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.534,
                            0
                          ],
                          [
                            -0.447,
                            -0.191
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.959,
                            0
                          ],
                          [
                            0,
                            -3.675
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.438
                          ],
                          [
                            0.703,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.607,
                            -0.192
                          ],
                          [
                            -3.547,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -56.624,
                            -6.557
                          ],
                          [
                            -52.758,
                            -6.557
                          ],
                          [
                            -52.758,
                            -20.362
                          ],
                          [
                            -48.954,
                            -20.362
                          ],
                          [
                            -48.954,
                            -23.271
                          ],
                          [
                            -52.758,
                            -23.271
                          ],
                          [
                            -52.758,
                            -25.668
                          ],
                          [
                            -50.585,
                            -28.128
                          ],
                          [
                            -48.954,
                            -27.873
                          ],
                          [
                            -48.954,
                            -30.877
                          ],
                          [
                            -51.064,
                            -31.163
                          ],
                          [
                            -56.624,
                            -25.508
                          ],
                          [
                            -56.624,
                            -23.271
                          ],
                          [
                            -58.894,
                            -23.271
                          ],
                          [
                            -58.894,
                            -20.362
                          ],
                          [
                            -56.624,
                            -20.362
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 25",
                    "hd": false
                  },
                  {
                    "ind": 25,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.921,
                            0
                          ],
                          [
                            0,
                            5.209
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            4.89,
                            0
                          ],
                          [
                            0,
                            -5.177
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            4.922,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -5.113
                          ],
                          [
                            -4.921,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            5.081
                          ]
                        ],
                        "v": [
                          [
                            -69.158,
                            -6.237
                          ],
                          [
                            -60.561,
                            -14.834
                          ],
                          [
                            -60.561,
                            -15.09
                          ],
                          [
                            -69.126,
                            -23.622
                          ],
                          [
                            -77.723,
                            -14.994
                          ],
                          [
                            -77.723,
                            -14.738
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 26",
                    "hd": false
                  },
                  {
                    "ind": 26,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            2.876,
                            0
                          ],
                          [
                            0,
                            3.419
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.876,
                            0
                          ],
                          [
                            0,
                            -3.451
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -2.94,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.452
                          ],
                          [
                            2.876,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.419
                          ]
                        ],
                        "v": [
                          [
                            -69.126,
                            -9.241
                          ],
                          [
                            -73.76,
                            -14.801
                          ],
                          [
                            -73.76,
                            -15.057
                          ],
                          [
                            -69.126,
                            -20.586
                          ],
                          [
                            -64.523,
                            -15.026
                          ],
                          [
                            -64.523,
                            -14.801
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 27",
                    "hd": false
                  },
                  {
                    "ind": 27,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.387,
                            0.032
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.055,
                            -2.109
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.548
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.812,
                            0.032
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -88.764,
                            -6.557
                          ],
                          [
                            -84.898,
                            -6.557
                          ],
                          [
                            -84.898,
                            -15.249
                          ],
                          [
                            -79.465,
                            -19.915
                          ],
                          [
                            -79.465,
                            -23.526
                          ],
                          [
                            -84.898,
                            -20.139
                          ],
                          [
                            -84.898,
                            -23.271
                          ],
                          [
                            -88.764,
                            -23.271
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 28",
                    "hd": false
                  },
                  {
                    "ind": 28,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.716
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.812,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.716,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.524
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -103.441,
                            -18.317
                          ],
                          [
                            -103.441,
                            -26.115
                          ],
                          [
                            -100.34,
                            -26.115
                          ],
                          [
                            -96.027,
                            -22.344
                          ],
                          [
                            -96.027,
                            -22.215
                          ],
                          [
                            -100.34,
                            -18.317
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 29",
                    "hd": false
                  },
                  {
                    "ind": 29,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            4.826
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            5.113,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            4.89,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -4.793
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -107.691,
                            -6.557
                          ],
                          [
                            -103.441,
                            -6.557
                          ],
                          [
                            -103.441,
                            -15.249
                          ],
                          [
                            -100.245,
                            -15.249
                          ],
                          [
                            -91.872,
                            -22.215
                          ],
                          [
                            -91.872,
                            -22.344
                          ],
                          [
                            -100.34,
                            -29.406
                          ],
                          [
                            -107.691,
                            -29.406
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 30",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.118000000598,
                        0.231000010173,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        183.573,
                        32.556
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 169,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 179.000007290819,
                          "s": [
                            100
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "title",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -23.267,
                                0.001
                              ],
                              [
                                23.267,
                                -0.001
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.231000010173,
                            0.675,
                            0.773000021542,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 13.316
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            334.104,
                            104.462
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 7",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -23.267,
                                0.001
                              ],
                              [
                                23.267,
                                -0.001
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 13.316
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            254.304,
                            104.462
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 8",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -23.267,
                                0.001
                              ],
                              [
                                23.267,
                                -0.001
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 13.316
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            174.718,
                            104.462
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 9",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.168,
                                0
                              ],
                              [
                                -0.096,
                                -1.44
                              ]
                            ],
                            "o": [
                              [
                                0.192,
                                -1.296
                              ],
                              [
                                1.2,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                25.897,
                                0.584
                              ],
                              [
                                28.041,
                                -1.496
                              ],
                              [
                                30.073,
                                0.584
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ind": 1,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.464,
                                0
                              ],
                              [
                                -0.272,
                                1.76
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.168,
                                0
                              ],
                              [
                                0.064,
                                1.584
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.08,
                                0
                              ],
                              [
                                0,
                                -2.592
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.144,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.144,
                                0.816
                              ],
                              [
                                -1.44,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.992
                              ],
                              [
                                -2.384,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.64
                              ]
                            ],
                            "v": [
                              [
                                28.121,
                                5.8
                              ],
                              [
                                31.961,
                                3.08
                              ],
                              [
                                30.089,
                                3.08
                              ],
                              [
                                28.169,
                                4.36
                              ],
                              [
                                25.865,
                                1.88
                              ],
                              [
                                31.993,
                                1.88
                              ],
                              [
                                31.993,
                                1.32
                              ],
                              [
                                28.041,
                                -2.904
                              ],
                              [
                                23.881,
                                1.416
                              ],
                              [
                                23.881,
                                1.544
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 2",
                        "hd": false
                      },
                      {
                        "ind": 2,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -1.648,
                                0
                              ],
                              [
                                -0.417,
                                0.816
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.04,
                                0
                              ],
                              [
                                0,
                                1.264
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                1.36,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.328
                              ],
                              [
                                -1.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.224
                              ]
                            ],
                            "v": [
                              [
                                17.554,
                                5.8
                              ],
                              [
                                20.21,
                                4.328
                              ],
                              [
                                20.21,
                                5.64
                              ],
                              [
                                22.146,
                                5.64
                              ],
                              [
                                22.146,
                                -2.728
                              ],
                              [
                                20.21,
                                -2.728
                              ],
                              [
                                20.21,
                                2.248
                              ],
                              [
                                18.258,
                                4.248
                              ],
                              [
                                16.61,
                                2.408
                              ],
                              [
                                16.61,
                                -2.728
                              ],
                              [
                                14.674,
                                -2.728
                              ],
                              [
                                14.674,
                                2.632
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 3",
                        "hd": false
                      },
                      {
                        "ind": 3,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.088,
                                0
                              ],
                              [
                                0,
                                -1.264
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.68,
                                0
                              ],
                              [
                                0.4,
                                -0.816
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.328
                              ],
                              [
                                1.152,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.304
                              ],
                              [
                                -1.376,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                5.019,
                                5.64
                              ],
                              [
                                6.955,
                                5.64
                              ],
                              [
                                6.955,
                                0.712
                              ],
                              [
                                8.923,
                                -1.288
                              ],
                              [
                                10.587,
                                0.552
                              ],
                              [
                                10.587,
                                5.64
                              ],
                              [
                                12.523,
                                5.64
                              ],
                              [
                                12.523,
                                0.376
                              ],
                              [
                                9.659,
                                -2.904
                              ],
                              [
                                6.955,
                                -1.4
                              ],
                              [
                                6.955,
                                -2.728
                              ],
                              [
                                5.019,
                                -2.728
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 4",
                        "hd": false
                      },
                      {
                        "ind": 4,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.168,
                                0
                              ],
                              [
                                -0.096,
                                -1.44
                              ]
                            ],
                            "o": [
                              [
                                0.192,
                                -1.296
                              ],
                              [
                                1.2,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -2.806,
                                0.584
                              ],
                              [
                                -0.662,
                                -1.496
                              ],
                              [
                                1.37,
                                0.584
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 5",
                        "hd": false
                      },
                      {
                        "ind": 5,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.464,
                                0
                              ],
                              [
                                -0.272,
                                1.76
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.168,
                                0
                              ],
                              [
                                0.064,
                                1.584
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.08,
                                0
                              ],
                              [
                                0,
                                -2.592
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.144,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.144,
                                0.816
                              ],
                              [
                                -1.44,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.992
                              ],
                              [
                                -2.384,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.64
                              ]
                            ],
                            "v": [
                              [
                                -0.582,
                                5.8
                              ],
                              [
                                3.258,
                                3.08
                              ],
                              [
                                1.386,
                                3.08
                              ],
                              [
                                -0.534,
                                4.36
                              ],
                              [
                                -2.838,
                                1.88
                              ],
                              [
                                3.29,
                                1.88
                              ],
                              [
                                3.29,
                                1.32
                              ],
                              [
                                -0.662,
                                -2.904
                              ],
                              [
                                -4.822,
                                1.416
                              ],
                              [
                                -4.822,
                                1.544
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 6",
                        "hd": false
                      },
                      {
                        "ind": 6,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -10.664,
                                5.64
                              ],
                              [
                                -8.408,
                                5.64
                              ],
                              [
                                -5.384,
                                -2.728
                              ],
                              [
                                -7.288,
                                -2.728
                              ],
                              [
                                -9.448,
                                3.656
                              ],
                              [
                                -11.64,
                                -2.728
                              ],
                              [
                                -13.72,
                                -2.728
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 7",
                        "hd": false
                      },
                      {
                        "ind": 7,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.168,
                                0
                              ],
                              [
                                -0.096,
                                -1.44
                              ]
                            ],
                            "o": [
                              [
                                0.192,
                                -1.296
                              ],
                              [
                                1.2,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -20.525,
                                0.584
                              ],
                              [
                                -18.381,
                                -1.496
                              ],
                              [
                                -16.349,
                                0.584
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 8",
                        "hd": false
                      },
                      {
                        "ind": 8,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.464,
                                0
                              ],
                              [
                                -0.272,
                                1.76
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.168,
                                0
                              ],
                              [
                                0.064,
                                1.584
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.08,
                                0
                              ],
                              [
                                0,
                                -2.592
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.144,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.144,
                                0.816
                              ],
                              [
                                -1.44,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.992
                              ],
                              [
                                -2.384,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.64
                              ]
                            ],
                            "v": [
                              [
                                -18.301,
                                5.8
                              ],
                              [
                                -14.461,
                                3.08
                              ],
                              [
                                -16.333,
                                3.08
                              ],
                              [
                                -18.253,
                                4.36
                              ],
                              [
                                -20.557,
                                1.88
                              ],
                              [
                                -14.429,
                                1.88
                              ],
                              [
                                -14.429,
                                1.32
                              ],
                              [
                                -18.381,
                                -2.904
                              ],
                              [
                                -22.541,
                                1.416
                              ],
                              [
                                -22.541,
                                1.544
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 9",
                        "hd": false
                      },
                      {
                        "ind": 9,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.312
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.424,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.36,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.216
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -29.865,
                                -0.504
                              ],
                              [
                                -29.865,
                                -4.152
                              ],
                              [
                                -28.152,
                                -4.152
                              ],
                              [
                                -25.977,
                                -2.392
                              ],
                              [
                                -25.977,
                                -2.328
                              ],
                              [
                                -28.152,
                                -0.504
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 10",
                        "hd": false
                      },
                      {
                        "ind": 10,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.792
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.511,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.425,
                                -0.368
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.336
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -31.993,
                                5.64
                              ],
                              [
                                -29.865,
                                5.64
                              ],
                              [
                                -29.865,
                                1.016
                              ],
                              [
                                -28.504,
                                1.016
                              ],
                              [
                                -25.513,
                                5.64
                              ],
                              [
                                -23.208,
                                5.64
                              ],
                              [
                                -26.425,
                                0.696
                              ],
                              [
                                -23.88,
                                -2.376
                              ],
                              [
                                -23.88,
                                -2.44
                              ],
                              [
                                -28.152,
                                -5.8
                              ],
                              [
                                -31.993,
                                -5.8
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 11",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0,
                            0,
                            0,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            44.885,
                            104.044
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 12",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        185.159,
                        104.19
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        185.131,
                        104.044
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.5
                            ],
                            "y": [
                              1
                            ]
                          },
                          "o": {
                            "x": [
                              0.5
                            ],
                            "y": [
                              0
                            ]
                          },
                          "t": 185,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 195.000007942513,
                          "s": [
                            100
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -23.267,
                                0.001
                              ],
                              [
                                23.267,
                                -0.001
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.898000021542,
                            0.383999992819,
                            0.517999985639,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 13.316
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            334.104,
                            138.464
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 4",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -23.267,
                                0.001
                              ],
                              [
                                23.267,
                                -0.001
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 13.316
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            254.304,
                            138.464
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 5",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -23.267,
                                0.001
                              ],
                              [
                                23.267,
                                0
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 13.316
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            174.718,
                            138.464
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 6",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -1.664,
                                0
                              ],
                              [
                                -0.304,
                                0.112
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.384,
                                0
                              ],
                              [
                                0,
                                0.736
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0.592,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.272,
                                0.112
                              ],
                              [
                                -0.608,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.584
                              ]
                            ],
                            "v": [
                              [
                                59.523,
                                4.768
                              ],
                              [
                                60.835,
                                4.56
                              ],
                              [
                                60.835,
                                3.024
                              ],
                              [
                                59.891,
                                3.184
                              ],
                              [
                                58.93,
                                2.112
                              ],
                              [
                                58.93,
                                -2.288
                              ],
                              [
                                60.77,
                                -2.288
                              ],
                              [
                                60.77,
                                -3.744
                              ],
                              [
                                58.93,
                                -3.744
                              ],
                              [
                                58.93,
                                -5.584
                              ],
                              [
                                56.994,
                                -5.584
                              ],
                              [
                                56.994,
                                -3.744
                              ],
                              [
                                55.874,
                                -3.744
                              ],
                              [
                                55.874,
                                -2.288
                              ],
                              [
                                56.994,
                                -2.288
                              ],
                              [
                                56.994,
                                2.288
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ind": 1,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -0.64,
                                0
                              ],
                              [
                                0,
                                0.624
                              ],
                              [
                                0.64,
                                0
                              ],
                              [
                                0,
                                -0.64
                              ]
                            ],
                            "o": [
                              [
                                0.64,
                                0
                              ],
                              [
                                0,
                                -0.64
                              ],
                              [
                                -0.64,
                                0
                              ],
                              [
                                0,
                                0.624
                              ]
                            ],
                            "v": [
                              [
                                53.323,
                                -5.12
                              ],
                              [
                                54.475,
                                -6.224
                              ],
                              [
                                53.323,
                                -7.344
                              ],
                              [
                                52.171,
                                -6.224
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 2",
                        "hd": false
                      },
                      {
                        "ind": 2,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                52.379,
                                4.624
                              ],
                              [
                                54.315,
                                4.624
                              ],
                              [
                                54.315,
                                -3.744
                              ],
                              [
                                52.379,
                                -3.744
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 3",
                        "hd": false
                      },
                      {
                        "ind": 3,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.768,
                                0
                              ],
                              [
                                -0.224,
                                -0.096
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.48,
                                0
                              ],
                              [
                                0,
                                -1.84
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.72
                              ],
                              [
                                0.352,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.304,
                                -0.096
                              ],
                              [
                                -1.776,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                47.089,
                                4.624
                              ],
                              [
                                49.025,
                                4.624
                              ],
                              [
                                49.025,
                                -2.288
                              ],
                              [
                                50.929,
                                -2.288
                              ],
                              [
                                50.929,
                                -3.744
                              ],
                              [
                                49.025,
                                -3.744
                              ],
                              [
                                49.025,
                                -4.944
                              ],
                              [
                                50.113,
                                -6.176
                              ],
                              [
                                50.929,
                                -6.048
                              ],
                              [
                                50.929,
                                -7.552
                              ],
                              [
                                49.873,
                                -7.696
                              ],
                              [
                                47.089,
                                -4.864
                              ],
                              [
                                47.089,
                                -3.744
                              ],
                              [
                                45.953,
                                -3.744
                              ],
                              [
                                45.953,
                                -2.288
                              ],
                              [
                                47.089,
                                -2.288
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 4",
                        "hd": false
                      },
                      {
                        "ind": 4,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.464,
                                0
                              ],
                              [
                                0,
                                2.608
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.448,
                                0
                              ],
                              [
                                0,
                                -2.592
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.464,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.56
                              ],
                              [
                                -2.464,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.544
                              ]
                            ],
                            "v": [
                              [
                                40.7,
                                4.784
                              ],
                              [
                                45.004,
                                0.48
                              ],
                              [
                                45.004,
                                0.352
                              ],
                              [
                                40.716,
                                -3.92
                              ],
                              [
                                36.412,
                                0.4
                              ],
                              [
                                36.412,
                                0.528
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 5",
                        "hd": false
                      },
                      {
                        "ind": 5,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                1.44,
                                0
                              ],
                              [
                                0,
                                1.712
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.44,
                                0
                              ],
                              [
                                0,
                                -1.728
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                -1.472,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.728
                              ],
                              [
                                1.44,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.712
                              ]
                            ],
                            "v": [
                              [
                                40.716,
                                3.28
                              ],
                              [
                                38.396,
                                0.496
                              ],
                              [
                                38.396,
                                0.368
                              ],
                              [
                                40.716,
                                -2.4
                              ],
                              [
                                43.02,
                                0.384
                              ],
                              [
                                43.02,
                                0.496
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 6",
                        "hd": false
                      },
                      {
                        "ind": 6,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.696,
                                0.016
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.528,
                                -1.056
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.776
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.408,
                                0.016
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                30.769,
                                4.624
                              ],
                              [
                                32.705,
                                4.624
                              ],
                              [
                                32.705,
                                0.272
                              ],
                              [
                                35.425,
                                -2.064
                              ],
                              [
                                35.425,
                                -3.872
                              ],
                              [
                                32.705,
                                -2.176
                              ],
                              [
                                32.705,
                                -3.744
                              ],
                              [
                                30.769,
                                -3.744
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 7",
                        "hd": false
                      },
                      {
                        "ind": 7,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.36
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.408,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.36,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.264
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                23.307,
                                -1.264
                              ],
                              [
                                23.307,
                                -5.168
                              ],
                              [
                                24.859,
                                -5.168
                              ],
                              [
                                27.019,
                                -3.28
                              ],
                              [
                                27.019,
                                -3.216
                              ],
                              [
                                24.859,
                                -1.264
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 8",
                        "hd": false
                      },
                      {
                        "ind": 8,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.416
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.56,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.448,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.4
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                21.179,
                                4.624
                              ],
                              [
                                23.307,
                                4.624
                              ],
                              [
                                23.307,
                                0.272
                              ],
                              [
                                24.907,
                                0.272
                              ],
                              [
                                29.099,
                                -3.216
                              ],
                              [
                                29.099,
                                -3.28
                              ],
                              [
                                24.859,
                                -6.816
                              ],
                              [
                                21.179,
                                -6.816
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 9",
                        "hd": false
                      },
                      {
                        "ind": 9,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                1.344,
                                0
                              ],
                              [
                                0,
                                1.552
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.44,
                                0
                              ],
                              [
                                0,
                                -1.584
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                -1.248,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.52
                              ],
                              [
                                1.392,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.6
                              ]
                            ],
                            "v": [
                              [
                                10.713,
                                2.8
                              ],
                              [
                                8.505,
                                0.288
                              ],
                              [
                                8.505,
                                0.16
                              ],
                              [
                                10.777,
                                -2.4
                              ],
                              [
                                13.033,
                                0.128
                              ],
                              [
                                13.033,
                                0.24
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 10",
                        "hd": false
                      },
                      {
                        "ind": 10,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.624,
                                0
                              ],
                              [
                                -0.016,
                                2.464
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.376,
                                0
                              ],
                              [
                                0,
                                -2.352
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -2.096,
                                0
                              ],
                              [
                                -0.464,
                                0.8
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.504,
                                0
                              ],
                              [
                                0.161,
                                0.832
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.592,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.48,
                                -0.832
                              ],
                              [
                                -2.16,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.416
                              ],
                              [
                                1.232,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.504
                              ],
                              [
                                -1.264,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.224,
                                1.6
                              ]
                            ],
                            "v": [
                              [
                                10.649,
                                7.696
                              ],
                              [
                                14.905,
                                4
                              ],
                              [
                                14.905,
                                -3.744
                              ],
                              [
                                12.969,
                                -3.744
                              ],
                              [
                                12.969,
                                -2.464
                              ],
                              [
                                10.281,
                                -3.92
                              ],
                              [
                                6.522,
                                0.192
                              ],
                              [
                                6.522,
                                0.304
                              ],
                              [
                                10.233,
                                4.288
                              ],
                              [
                                12.969,
                                2.736
                              ],
                              [
                                12.969,
                                3.968
                              ],
                              [
                                10.633,
                                6.224
                              ],
                              [
                                8.569,
                                4.912
                              ],
                              [
                                6.617,
                                4.912
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 11",
                        "hd": false
                      },
                      {
                        "ind": 11,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.088,
                                0
                              ],
                              [
                                0,
                                -1.264
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.68,
                                0
                              ],
                              [
                                0.4,
                                -0.816
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.328
                              ],
                              [
                                1.152,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.304
                              ],
                              [
                                -1.376,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -2.654,
                                4.624
                              ],
                              [
                                -0.717,
                                4.624
                              ],
                              [
                                -0.717,
                                -0.304
                              ],
                              [
                                1.251,
                                -2.304
                              ],
                              [
                                2.915,
                                -0.464
                              ],
                              [
                                2.915,
                                4.624
                              ],
                              [
                                4.851,
                                4.624
                              ],
                              [
                                4.851,
                                -0.64
                              ],
                              [
                                1.987,
                                -3.92
                              ],
                              [
                                -0.717,
                                -2.416
                              ],
                              [
                                -0.717,
                                -3.744
                              ],
                              [
                                -2.654,
                                -3.744
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 12",
                        "hd": false
                      },
                      {
                        "ind": 12,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -0.64,
                                0
                              ],
                              [
                                0,
                                0.624
                              ],
                              [
                                0.64,
                                0
                              ],
                              [
                                0,
                                -0.64
                              ]
                            ],
                            "o": [
                              [
                                0.64,
                                0
                              ],
                              [
                                0,
                                -0.64
                              ],
                              [
                                -0.64,
                                0
                              ],
                              [
                                0,
                                0.624
                              ]
                            ],
                            "v": [
                              [
                                -6.005,
                                -5.12
                              ],
                              [
                                -4.854,
                                -6.224
                              ],
                              [
                                -6.005,
                                -7.344
                              ],
                              [
                                -7.158,
                                -6.224
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 13",
                        "hd": false
                      },
                      {
                        "ind": 13,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -6.949,
                                4.624
                              ],
                              [
                                -5.014,
                                4.624
                              ],
                              [
                                -5.014,
                                -3.744
                              ],
                              [
                                -6.949,
                                -3.744
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 14",
                        "hd": false
                      },
                      {
                        "ind": 14,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -1.664,
                                0
                              ],
                              [
                                -0.304,
                                0.112
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.384,
                                0
                              ],
                              [
                                0,
                                0.736
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0.592,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.272,
                                0.112
                              ],
                              [
                                -0.608,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.584
                              ]
                            ],
                            "v": [
                              [
                                -10.055,
                                4.768
                              ],
                              [
                                -8.743,
                                4.56
                              ],
                              [
                                -8.743,
                                3.024
                              ],
                              [
                                -9.688,
                                3.184
                              ],
                              [
                                -10.647,
                                2.112
                              ],
                              [
                                -10.647,
                                -2.288
                              ],
                              [
                                -8.807,
                                -2.288
                              ],
                              [
                                -8.807,
                                -3.744
                              ],
                              [
                                -10.647,
                                -3.744
                              ],
                              [
                                -10.647,
                                -5.584
                              ],
                              [
                                -12.583,
                                -5.584
                              ],
                              [
                                -12.583,
                                -3.744
                              ],
                              [
                                -13.703,
                                -3.744
                              ],
                              [
                                -13.703,
                                -2.288
                              ],
                              [
                                -12.583,
                                -2.288
                              ],
                              [
                                -12.583,
                                2.288
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 15",
                        "hd": false
                      },
                      {
                        "ind": 15,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                1.184,
                                0
                              ],
                              [
                                0,
                                0.704
                              ],
                              [
                                -1.472,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                -0.96,
                                0
                              ],
                              [
                                0,
                                -1.024
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.072
                              ]
                            ],
                            "v": [
                              [
                                -19.122,
                                3.392
                              ],
                              [
                                -20.466,
                                2.224
                              ],
                              [
                                -18.05,
                                0.864
                              ],
                              [
                                -17.059,
                                0.864
                              ],
                              [
                                -17.059,
                                1.696
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 16",
                        "hd": false
                      },
                      {
                        "ind": 16,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -1.536,
                                0
                              ],
                              [
                                -0.544,
                                0.72
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.872,
                                0
                              ],
                              [
                                0.16,
                                -1.952
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.008,
                                0
                              ],
                              [
                                0,
                                -1.12
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.952
                              ]
                            ],
                            "o": [
                              [
                                1.28,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.288
                              ],
                              [
                                -1.872,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.096,
                                -0.832
                              ],
                              [
                                1.136,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -2.4,
                                0
                              ],
                              [
                                0,
                                1.744
                              ]
                            ],
                            "v": [
                              [
                                -19.587,
                                4.784
                              ],
                              [
                                -17.027,
                                3.6
                              ],
                              [
                                -17.027,
                                4.624
                              ],
                              [
                                -15.122,
                                4.624
                              ],
                              [
                                -15.122,
                                -0.864
                              ],
                              [
                                -18.466,
                                -3.92
                              ],
                              [
                                -22.05,
                                -1.152
                              ],
                              [
                                -20.178,
                                -1.152
                              ],
                              [
                                -18.578,
                                -2.464
                              ],
                              [
                                -17.059,
                                -0.784
                              ],
                              [
                                -17.059,
                                -0.352
                              ],
                              [
                                -18.098,
                                -0.352
                              ],
                              [
                                -22.386,
                                2.304
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 17",
                        "hd": false
                      },
                      {
                        "ind": 17,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.696,
                                0.016
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.528,
                                -1.056
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.776
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.408,
                                0.016
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -27.981,
                                4.624
                              ],
                              [
                                -26.046,
                                4.624
                              ],
                              [
                                -26.046,
                                0.272
                              ],
                              [
                                -23.326,
                                -2.064
                              ],
                              [
                                -23.326,
                                -3.872
                              ],
                              [
                                -26.046,
                                -2.176
                              ],
                              [
                                -26.046,
                                -3.744
                              ],
                              [
                                -27.981,
                                -3.744
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 18",
                        "hd": false
                      },
                      {
                        "ind": 18,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.168,
                                0
                              ],
                              [
                                -0.097,
                                -1.44
                              ]
                            ],
                            "o": [
                              [
                                0.193,
                                -1.296
                              ],
                              [
                                1.201,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -35.807,
                                -0.432
                              ],
                              [
                                -33.663,
                                -2.512
                              ],
                              [
                                -31.63,
                                -0.432
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 19",
                        "hd": false
                      },
                      {
                        "ind": 19,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.464,
                                0
                              ],
                              [
                                -0.272,
                                1.76
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.168,
                                0
                              ],
                              [
                                0.064,
                                1.584
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.081,
                                0
                              ],
                              [
                                0,
                                -2.592
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.144,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.144,
                                0.816
                              ],
                              [
                                -1.44,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.992
                              ],
                              [
                                -2.383,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.64
                              ]
                            ],
                            "v": [
                              [
                                -33.583,
                                4.784
                              ],
                              [
                                -29.743,
                                2.064
                              ],
                              [
                                -31.615,
                                2.064
                              ],
                              [
                                -33.535,
                                3.344
                              ],
                              [
                                -35.839,
                                0.864
                              ],
                              [
                                -29.71,
                                0.864
                              ],
                              [
                                -29.71,
                                0.304
                              ],
                              [
                                -33.663,
                                -3.92
                              ],
                              [
                                -37.822,
                                0.4
                              ],
                              [
                                -37.822,
                                0.528
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 20",
                        "hd": false
                      },
                      {
                        "ind": 20,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                1.424,
                                0
                              ],
                              [
                                0,
                                1.872
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.345,
                                0
                              ],
                              [
                                0,
                                -1.856
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                -1.408,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.856
                              ],
                              [
                                1.264,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.792
                              ]
                            ],
                            "v": [
                              [
                                -43.195,
                                3.248
                              ],
                              [
                                -45.516,
                                0.496
                              ],
                              [
                                -45.516,
                                0.368
                              ],
                              [
                                -43.212,
                                -2.4
                              ],
                              [
                                -40.988,
                                0.368
                              ],
                              [
                                -40.988,
                                0.496
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 21",
                        "hd": false
                      },
                      {
                        "ind": 21,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.328,
                                0
                              ],
                              [
                                0,
                                2.688
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.095,
                                0
                              ],
                              [
                                0.465,
                                -0.8
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.449,
                                0.816
                              ],
                              [
                                2.159,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.704
                              ],
                              [
                                -1.232,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -47.389,
                                7.488
                              ],
                              [
                                -45.452,
                                7.488
                              ],
                              [
                                -45.452,
                                3.312
                              ],
                              [
                                -42.715,
                                4.784
                              ],
                              [
                                -39.003,
                                0.464
                              ],
                              [
                                -39.003,
                                0.336
                              ],
                              [
                                -42.715,
                                -3.92
                              ],
                              [
                                -45.452,
                                -2.4
                              ],
                              [
                                -45.452,
                                -3.744
                              ],
                              [
                                -47.389,
                                -3.744
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 22",
                        "hd": false
                      },
                      {
                        "ind": 22,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -3.505,
                                0
                              ],
                              [
                                0,
                                3.344
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                3.407,
                                0
                              ],
                              [
                                0,
                                -3.344
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                3.471,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -3.36
                              ],
                              [
                                -3.393,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                3.296
                              ]
                            ],
                            "v": [
                              [
                                -55.042,
                                4.784
                              ],
                              [
                                -49.283,
                                -1.072
                              ],
                              [
                                -49.283,
                                -1.2
                              ],
                              [
                                -55.042,
                                -6.976
                              ],
                              [
                                -60.835,
                                -1.152
                              ],
                              [
                                -60.835,
                                -1.024
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 23",
                        "hd": false
                      },
                      {
                        "ind": 23,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                2.16,
                                0
                              ],
                              [
                                0,
                                2.496
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -2.241,
                                0
                              ],
                              [
                                0,
                                -2.352
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                -2.08,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.464
                              ],
                              [
                                2.239,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.48
                              ]
                            ],
                            "v": [
                              [
                                -55.011,
                                3.072
                              ],
                              [
                                -58.611,
                                -1.04
                              ],
                              [
                                -58.611,
                                -1.168
                              ],
                              [
                                -55.042,
                                -5.28
                              ],
                              [
                                -51.492,
                                -1.184
                              ],
                              [
                                -51.492,
                                -1.056
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 24",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0,
                            0,
                            0,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            73.151,
                            139.06
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 11",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        184.844,
                        139.06
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        184.844,
                        139.06
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.5
                            ],
                            "y": [
                              1
                            ]
                          },
                          "o": {
                            "x": [
                              0.5
                            ],
                            "y": [
                              0
                            ]
                          },
                          "t": 187,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 197.000008023974,
                          "s": [
                            100
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "2",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -23.267,
                                0.001
                              ],
                              [
                                23.267,
                                -0.001
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.898000021542,
                            0.383999992819,
                            0.517999985639,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 13.316
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            334.104,
                            172.466
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 1",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -23.267,
                                0.001
                              ],
                              [
                                23.267,
                                -0.001
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 13.316
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            254.304,
                            172.466
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 2",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -23.267,
                                0
                              ],
                              [
                                23.267,
                                -0.001
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 13.316
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            174.718,
                            172.466
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 3",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                43.841,
                                6.039
                              ],
                              [
                                45.825,
                                6.039
                              ],
                              [
                                47.521,
                                0.408
                              ],
                              [
                                49.073,
                                6.039
                              ],
                              [
                                51.041,
                                6.039
                              ],
                              [
                                53.665,
                                -2.327
                              ],
                              [
                                51.777,
                                -2.327
                              ],
                              [
                                50.033,
                                3.721
                              ],
                              [
                                48.401,
                                -2.327
                              ],
                              [
                                46.785,
                                -2.327
                              ],
                              [
                                45.009,
                                3.721
                              ],
                              [
                                43.345,
                                -2.327
                              ],
                              [
                                41.281,
                                -2.327
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ind": 1,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.464,
                                0
                              ],
                              [
                                0,
                                2.609
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.448,
                                0
                              ],
                              [
                                0,
                                -2.591
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.464,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.561
                              ],
                              [
                                -2.464,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.544
                              ]
                            ],
                            "v": [
                              [
                                36.294,
                                6.199
                              ],
                              [
                                40.598,
                                1.895
                              ],
                              [
                                40.598,
                                1.768
                              ],
                              [
                                36.31,
                                -2.505
                              ],
                              [
                                32.006,
                                1.815
                              ],
                              [
                                32.006,
                                1.943
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 2",
                        "hd": false
                      },
                      {
                        "ind": 2,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                1.44,
                                0
                              ],
                              [
                                0,
                                1.712
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.44,
                                0
                              ],
                              [
                                0,
                                -1.729
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                -1.472,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.727
                              ],
                              [
                                1.44,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.712
                              ]
                            ],
                            "v": [
                              [
                                36.31,
                                4.695
                              ],
                              [
                                33.99,
                                1.911
                              ],
                              [
                                33.99,
                                1.783
                              ],
                              [
                                36.31,
                                -0.984
                              ],
                              [
                                38.614,
                                1.8
                              ],
                              [
                                38.614,
                                1.911
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 3",
                        "hd": false
                      },
                      {
                        "ind": 3,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                28.27,
                                6.039
                              ],
                              [
                                30.206,
                                6.039
                              ],
                              [
                                30.206,
                                -6.2
                              ],
                              [
                                28.27,
                                -6.2
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 4",
                        "hd": false
                      },
                      {
                        "ind": 4,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                19.445,
                                6.039
                              ],
                              [
                                21.572,
                                6.039
                              ],
                              [
                                21.572,
                                1.352
                              ],
                              [
                                25.477,
                                1.352
                              ],
                              [
                                25.477,
                                -0.297
                              ],
                              [
                                21.572,
                                -0.297
                              ],
                              [
                                21.572,
                                -3.704
                              ],
                              [
                                26.532,
                                -3.704
                              ],
                              [
                                26.532,
                                -5.4
                              ],
                              [
                                19.445,
                                -5.4
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 5",
                        "hd": false
                      },
                      {
                        "ind": 5,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.088,
                                0
                              ],
                              [
                                0,
                                -1.264
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.68,
                                0
                              ],
                              [
                                0.4,
                                -0.815
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.328
                              ],
                              [
                                1.152,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.303
                              ],
                              [
                                -1.376,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                5.738,
                                6.039
                              ],
                              [
                                7.674,
                                6.039
                              ],
                              [
                                7.674,
                                1.111
                              ],
                              [
                                9.642,
                                -0.889
                              ],
                              [
                                11.306,
                                0.951
                              ],
                              [
                                11.306,
                                6.039
                              ],
                              [
                                13.242,
                                6.039
                              ],
                              [
                                13.242,
                                0.775
                              ],
                              [
                                10.378,
                                -2.505
                              ],
                              [
                                7.674,
                                -1.001
                              ],
                              [
                                7.674,
                                -6.2
                              ],
                              [
                                5.738,
                                -6.2
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 6",
                        "hd": false
                      },
                      {
                        "ind": 6,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.16,
                                0
                              ],
                              [
                                0,
                                1.697
                              ],
                              [
                                1.968,
                                0.303
                              ],
                              [
                                0,
                                0.609
                              ],
                              [
                                -0.832,
                                0
                              ],
                              [
                                -0.16,
                                -0.767
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.712,
                                0
                              ],
                              [
                                0,
                                -1.681
                              ],
                              [
                                -2.208,
                                -0.353
                              ],
                              [
                                0,
                                -0.687
                              ],
                              [
                                1.04,
                                0
                              ],
                              [
                                0.097,
                                0.847
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.145,
                                0
                              ],
                              [
                                0,
                                -1.775
                              ],
                              [
                                -1.328,
                                -0.225
                              ],
                              [
                                0,
                                -0.591
                              ],
                              [
                                0.896,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.208,
                                -1.887
                              ],
                              [
                                -1.569,
                                0
                              ],
                              [
                                0,
                                1.567
                              ],
                              [
                                1.232,
                                0.208
                              ],
                              [
                                0,
                                0.704
                              ],
                              [
                                -1.135,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.08,
                                1.775
                              ]
                            ],
                            "v": [
                              [
                                0.695,
                                6.199
                              ],
                              [
                                4.039,
                                3.527
                              ],
                              [
                                0.903,
                                0.968
                              ],
                              [
                                -0.825,
                                -0.105
                              ],
                              [
                                0.504,
                                -1.096
                              ],
                              [
                                1.991,
                                0.023
                              ],
                              [
                                3.783,
                                0.023
                              ],
                              [
                                0.504,
                                -2.505
                              ],
                              [
                                -2.633,
                                0.008
                              ],
                              [
                                0.391,
                                2.552
                              ],
                              [
                                2.183,
                                3.703
                              ],
                              [
                                0.679,
                                4.775
                              ],
                              [
                                -0.985,
                                3.432
                              ],
                              [
                                -2.808,
                                3.432
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 7",
                        "hd": false
                      },
                      {
                        "ind": 7,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                1.185,
                                0
                              ],
                              [
                                0,
                                0.704
                              ],
                              [
                                -1.471,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                -0.959,
                                0
                              ],
                              [
                                0,
                                -1.025
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.073
                              ]
                            ],
                            "v": [
                              [
                                -8.388,
                                4.809
                              ],
                              [
                                -9.732,
                                3.641
                              ],
                              [
                                -7.316,
                                2.279
                              ],
                              [
                                -6.324,
                                2.279
                              ],
                              [
                                -6.324,
                                3.111
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 8",
                        "hd": false
                      },
                      {
                        "ind": 8,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -1.537,
                                0
                              ],
                              [
                                -0.545,
                                0.719
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.872,
                                0
                              ],
                              [
                                0.16,
                                -1.953
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.007,
                                0
                              ],
                              [
                                0,
                                -1.12
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.952
                              ]
                            ],
                            "o": [
                              [
                                1.279,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.288
                              ],
                              [
                                -1.871,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.097,
                                -0.832
                              ],
                              [
                                1.137,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -2.399,
                                0
                              ],
                              [
                                0,
                                1.744
                              ]
                            ],
                            "v": [
                              [
                                -8.851,
                                6.199
                              ],
                              [
                                -6.291,
                                5.016
                              ],
                              [
                                -6.291,
                                6.039
                              ],
                              [
                                -4.388,
                                6.039
                              ],
                              [
                                -4.388,
                                0.552
                              ],
                              [
                                -7.732,
                                -2.505
                              ],
                              [
                                -11.316,
                                0.264
                              ],
                              [
                                -9.444,
                                0.264
                              ],
                              [
                                -7.844,
                                -1.049
                              ],
                              [
                                -6.324,
                                0.632
                              ],
                              [
                                -6.324,
                                1.063
                              ],
                              [
                                -7.364,
                                1.063
                              ],
                              [
                                -11.652,
                                3.721
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 9",
                        "hd": false
                      },
                      {
                        "ind": 9,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -3.584,
                                0
                              ],
                              [
                                -0.336,
                                2.752
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.584,
                                0
                              ],
                              [
                                0,
                                2.576
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -2.016,
                                0
                              ],
                              [
                                -0.24,
                                -1.521
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.624,
                                0
                              ],
                              [
                                0,
                                -3.441
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.72,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.224,
                                1.616
                              ],
                              [
                                -2.112,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.56
                              ],
                              [
                                1.648,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.256,
                                -2.689
                              ],
                              [
                                -3.184,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                3.519
                              ]
                            ],
                            "v": [
                              [
                                -17.813,
                                6.199
                              ],
                              [
                                -12.805,
                                2.057
                              ],
                              [
                                -14.885,
                                2.057
                              ],
                              [
                                -17.813,
                                4.473
                              ],
                              [
                                -21.157,
                                0.376
                              ],
                              [
                                -21.157,
                                0.247
                              ],
                              [
                                -17.829,
                                -3.881
                              ],
                              [
                                -15.093,
                                -1.576
                              ],
                              [
                                -12.933,
                                -1.576
                              ],
                              [
                                -17.845,
                                -5.576
                              ],
                              [
                                -23.397,
                                0.264
                              ],
                              [
                                -23.397,
                                0.393
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 10",
                        "hd": false
                      },
                      {
                        "ind": 10,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -1.664,
                                0
                              ],
                              [
                                -0.304,
                                0.112
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.384,
                                0
                              ],
                              [
                                0,
                                0.737
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0.592,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.272,
                                0.113
                              ],
                              [
                                -0.608,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.584
                              ]
                            ],
                            "v": [
                              [
                                -29.852,
                                6.184
                              ],
                              [
                                -28.54,
                                5.977
                              ],
                              [
                                -28.54,
                                4.439
                              ],
                              [
                                -29.484,
                                4.6
                              ],
                              [
                                -30.444,
                                3.527
                              ],
                              [
                                -30.444,
                                -0.872
                              ],
                              [
                                -28.604,
                                -0.872
                              ],
                              [
                                -28.604,
                                -2.327
                              ],
                              [
                                -30.444,
                                -2.327
                              ],
                              [
                                -30.444,
                                -4.169
                              ],
                              [
                                -32.38,
                                -4.169
                              ],
                              [
                                -32.38,
                                -2.327
                              ],
                              [
                                -33.5,
                                -2.327
                              ],
                              [
                                -33.5,
                                -0.872
                              ],
                              [
                                -32.38,
                                -0.872
                              ],
                              [
                                -32.38,
                                3.703
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 11",
                        "hd": false
                      },
                      {
                        "ind": 11,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.168,
                                0
                              ],
                              [
                                -0.096,
                                -1.439
                              ]
                            ],
                            "o": [
                              [
                                0.192,
                                -1.296
                              ],
                              [
                                1.2,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -40.525,
                                0.983
                              ],
                              [
                                -38.381,
                                -1.096
                              ],
                              [
                                -36.349,
                                0.983
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 12",
                        "hd": false
                      },
                      {
                        "ind": 12,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.464,
                                0
                              ],
                              [
                                -0.272,
                                1.76
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.168,
                                0
                              ],
                              [
                                0.064,
                                1.584
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.08,
                                0
                              ],
                              [
                                0,
                                -2.591
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.144,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.144,
                                0.817
                              ],
                              [
                                -1.44,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.993
                              ],
                              [
                                -2.384,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.64
                              ]
                            ],
                            "v": [
                              [
                                -38.301,
                                6.199
                              ],
                              [
                                -34.461,
                                3.479
                              ],
                              [
                                -36.333,
                                3.479
                              ],
                              [
                                -38.253,
                                4.76
                              ],
                              [
                                -40.557,
                                2.279
                              ],
                              [
                                -34.429,
                                2.279
                              ],
                              [
                                -34.429,
                                1.721
                              ],
                              [
                                -38.381,
                                -2.505
                              ],
                              [
                                -42.541,
                                1.815
                              ],
                              [
                                -42.541,
                                1.943
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 13",
                        "hd": false
                      },
                      {
                        "ind": 13,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -53.665,
                                6.039
                              ],
                              [
                                -51.729,
                                6.039
                              ],
                              [
                                -51.729,
                                -2.729
                              ],
                              [
                                -46.577,
                                6.039
                              ],
                              [
                                -44.369,
                                6.039
                              ],
                              [
                                -44.369,
                                -5.4
                              ],
                              [
                                -46.305,
                                -5.4
                              ],
                              [
                                -46.305,
                                2.871
                              ],
                              [
                                -51.121,
                                -5.4
                              ],
                              [
                                -53.665,
                                -5.4
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 14",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0,
                            0,
                            0,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            66.557,
                            171.644
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 10",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        185.131,
                        171.644
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        185.131,
                        171.644
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.5
                            ],
                            "y": [
                              1
                            ]
                          },
                          "o": {
                            "x": [
                              0.5
                            ],
                            "y": [
                              0
                            ]
                          },
                          "t": 189,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 199.000008105436,
                          "s": [
                            100
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "3",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                28.997,
                                312.644
                              ],
                              [
                                28.997,
                                233.834
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 0.731
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 13",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.212,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.213
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                1.213
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.213,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -7.058,
                                4.273
                              ],
                              [
                                -4.863,
                                6.47
                              ],
                              [
                                4.861,
                                6.47
                              ],
                              [
                                7.057,
                                4.273
                              ],
                              [
                                7.057,
                                -6.47
                              ],
                              [
                                -7.058,
                                -6.47
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.583999992819,
                            0.694000004787,
                            0.898000021542,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            86.045,
                            287.354
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 14",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.212,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.213
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                1.213
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.213,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -7.057,
                                10.155
                              ],
                              [
                                -4.863,
                                12.35
                              ],
                              [
                                4.861,
                                12.35
                              ],
                              [
                                7.057,
                                10.155
                              ],
                              [
                                7.057,
                                -12.35
                              ],
                              [
                                -7.057,
                                -12.35
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.583999992819,
                            0.694000004787,
                            0.898000021542,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            43.7,
                            293.235
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 15",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.212,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.212
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                1.212
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.212,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -7.057,
                                6.627
                              ],
                              [
                                -4.863,
                                8.822
                              ],
                              [
                                4.863,
                                8.822
                              ],
                              [
                                7.057,
                                6.627
                              ],
                              [
                                7.057,
                                -8.822
                              ],
                              [
                                -7.057,
                                -8.822
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.583999992819,
                            0.694000004787,
                            0.898000021542,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            64.872,
                            289.707
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 16",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.212,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.212
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                -1.212
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.213,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -7.058,
                                -11.333
                              ],
                              [
                                -4.863,
                                -13.527
                              ],
                              [
                                4.861,
                                -13.527
                              ],
                              [
                                7.057,
                                -11.333
                              ],
                              [
                                7.057,
                                13.526
                              ],
                              [
                                -7.058,
                                13.526
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.941000007181,
                            0.438999998803,
                            0.447000002394,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            86.045,
                            266.182
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 17",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.212,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.213
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                -1.213
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.212,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -7.057,
                                -8.98
                              ],
                              [
                                -4.863,
                                -11.173
                              ],
                              [
                                4.863,
                                -11.173
                              ],
                              [
                                7.057,
                                -8.98
                              ],
                              [
                                7.057,
                                11.173
                              ],
                              [
                                -7.057,
                                11.173
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.941000007181,
                            0.438999998803,
                            0.447000002394,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            64.872,
                            268.534
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 18",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.212,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.213
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                -1.213
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.213,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -7.057,
                                -16.625
                              ],
                              [
                                -4.863,
                                -18.82
                              ],
                              [
                                4.861,
                                -18.82
                              ],
                              [
                                7.057,
                                -16.625
                              ],
                              [
                                7.057,
                                18.82
                              ],
                              [
                                -7.057,
                                18.82
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.941000007181,
                            0.438999998803,
                            0.447000002394,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            43.7,
                            260.889
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 19",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                23.704,
                                280.174
                              ],
                              [
                                103.787,
                                280.174
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 0.731
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 20",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.725,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.725
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.725,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.725
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                2.725,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.725
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -2.725,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.725
                              ]
                            ],
                            "v": [
                              [
                                -45.46,
                                -51.049
                              ],
                              [
                                45.46,
                                -51.049
                              ],
                              [
                                50.393,
                                -46.115
                              ],
                              [
                                50.393,
                                46.116
                              ],
                              [
                                45.46,
                                51.049
                              ],
                              [
                                -45.46,
                                51.049
                              ],
                              [
                                -50.394,
                                46.116
                              ],
                              [
                                -50.394,
                                -46.115
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.885999971278,
                            0.910000011968,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 1.098
                        },
                        "lc": 1,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            1,
                            1,
                            1,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            64.424,
                            273.184
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 21",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": 0.1,
                            "y": 1
                          },
                          "o": {
                            "x": 0.9,
                            "y": 0
                          },
                          "t": 194,
                          "s": [
                            -32.575,
                            249.359
                          ],
                          "to": [
                            16.167,
                            3.971
                          ],
                          "ti": [
                            -16.167,
                            -3.971
                          ]
                        },
                        {
                          "t": 214.000008716399,
                          "s": [
                            64.424,
                            273.184
                          ]
                        }
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        64.424,
                        273.184
                      ]
                    },
                    "s": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 169,
                          "s": [
                            80,
                            80
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 174,
                          "s": [
                            140,
                            140
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 179,
                          "s": [
                            130,
                            130
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 194,
                          "s": [
                            130,
                            130
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 204,
                          "s": [
                            120,
                            120
                          ]
                        },
                        {
                          "t": 214.000008716399,
                          "s": [
                            100,
                            100
                          ]
                        }
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 169,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 174.000007087165,
                          "s": [
                            100
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "chart",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                -1.014
                              ],
                              [
                                1.014,
                                0
                              ],
                              [
                                0,
                                1.014
                              ],
                              [
                                -1.015,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                1.014
                              ],
                              [
                                -1.015,
                                0
                              ],
                              [
                                0,
                                -1.014
                              ],
                              [
                                1.014,
                                0
                              ]
                            ],
                            "v": [
                              [
                                1.837,
                                0
                              ],
                              [
                                0,
                                1.837
                              ],
                              [
                                -1.837,
                                0
                              ],
                              [
                                0,
                                -1.837
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.941000007181,
                            0.438999998803,
                            0.447000002394,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            218.912,
                            269.082
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 22",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                -1.014
                              ],
                              [
                                1.014,
                                0
                              ],
                              [
                                0,
                                1.015
                              ],
                              [
                                -1.016,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                1.015
                              ],
                              [
                                -1.016,
                                0
                              ],
                              [
                                0,
                                -1.014
                              ],
                              [
                                1.014,
                                0
                              ]
                            ],
                            "v": [
                              [
                                1.837,
                                0
                              ],
                              [
                                0,
                                1.837
                              ],
                              [
                                -1.837,
                                0
                              ],
                              [
                                0,
                                -1.836
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.941000007181,
                            0.438999998803,
                            0.447000002394,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            196.742,
                            275.458
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 23",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                -1.014
                              ],
                              [
                                1.014,
                                0
                              ],
                              [
                                0,
                                1.015
                              ],
                              [
                                -1.016,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                1.015
                              ],
                              [
                                -1.016,
                                0
                              ],
                              [
                                0,
                                -1.014
                              ],
                              [
                                1.014,
                                0
                              ]
                            ],
                            "v": [
                              [
                                1.837,
                                0
                              ],
                              [
                                0,
                                1.837
                              ],
                              [
                                -1.837,
                                0
                              ],
                              [
                                0,
                                -1.837
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.941000007181,
                            0.438999998803,
                            0.447000002394,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            181.314,
                            288.682
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 24",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -3.496,
                                -0.607
                              ],
                              [
                                -5.926,
                                -0.16
                              ],
                              [
                                -7.087,
                                5.53
                              ],
                              [
                                -7.086,
                                5.179
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.571,
                                5.308
                              ],
                              [
                                6.909,
                                1.198
                              ],
                              [
                                5.715,
                                0.158
                              ],
                              [
                                4.661,
                                -3.637
                              ],
                              [
                                7.087,
                                -5.18
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -31.218,
                                -10.03
                              ],
                              [
                                -20.532,
                                -4.722
                              ],
                              [
                                -6.871,
                                9.872
                              ],
                              [
                                7.725,
                                -2.793
                              ],
                              [
                                24.039,
                                -1.277
                              ],
                              [
                                31.218,
                                -10.03
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.941000007181,
                            0.438999998803,
                            0.447000002394,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 0.768
                        },
                        "lc": 1,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            187.186,
                            278.934
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 25",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                -1.014
                              ],
                              [
                                1.014,
                                0
                              ],
                              [
                                0,
                                1.015
                              ],
                              [
                                -1.015,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                1.015
                              ],
                              [
                                -1.015,
                                0
                              ],
                              [
                                0,
                                -1.014
                              ],
                              [
                                1.014,
                                0
                              ]
                            ],
                            "v": [
                              [
                                1.837,
                                -0.001
                              ],
                              [
                                0,
                                1.836
                              ],
                              [
                                -1.837,
                                -0.001
                              ],
                              [
                                0,
                                -1.837
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.941000007181,
                            0.438999998803,
                            0.447000002394,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            157.07,
                            269.581
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 26",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                140.281,
                                293.644
                              ],
                              [
                                147.377,
                                293.644
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 4.391
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 27",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                140.281,
                                279.452
                              ],
                              [
                                147.377,
                                279.452
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 4.391
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 28",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                140.281,
                                265.26
                              ],
                              [
                                147.377,
                                265.26
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 4.391
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 29",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                140.281,
                                251.068
                              ],
                              [
                                147.377,
                                251.068
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 4.391
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 30",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                151.622,
                                301.753
                              ],
                              [
                                151.622,
                                243.972
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 0.731
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 31",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                150.418,
                                300.55
                              ],
                              [
                                219.435,
                                300.55
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.889999988032,
                            0.925,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 0.731
                        },
                        "lc": 2,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 32",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.725,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.725
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.726,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.725
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                2.726,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.725
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -2.725,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.725
                              ]
                            ],
                            "v": [
                              [
                                -45.459,
                                -51.049
                              ],
                              [
                                45.459,
                                -51.049
                              ],
                              [
                                50.393,
                                -46.115
                              ],
                              [
                                50.393,
                                46.116
                              ],
                              [
                                45.459,
                                51.049
                              ],
                              [
                                -45.459,
                                51.049
                              ],
                              [
                                -50.393,
                                46.116
                              ],
                              [
                                -50.393,
                                -46.115
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.885999971278,
                            0.910000011968,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 1.098
                        },
                        "lc": 1,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            1,
                            1,
                            1,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            181.001,
                            273.184
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 33",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": 0.1,
                            "y": 1
                          },
                          "o": {
                            "x": 0.9,
                            "y": 0
                          },
                          "t": 194,
                          "s": [
                            137.455,
                            323.833
                          ],
                          "to": [
                            7.258,
                            -8.441
                          ],
                          "ti": [
                            -7.258,
                            8.441
                          ]
                        },
                        {
                          "t": 214.000008716399,
                          "s": [
                            181.001,
                            273.184
                          ]
                        }
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        181.001,
                        273.184
                      ]
                    },
                    "s": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 169,
                          "s": [
                            80,
                            80
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 174,
                          "s": [
                            140,
                            140
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 179,
                          "s": [
                            130,
                            130
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 194,
                          "s": [
                            130,
                            130
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 204,
                          "s": [
                            120,
                            120
                          ]
                        },
                        {
                          "t": 214.000008716399,
                          "s": [
                            100,
                            100
                          ]
                        }
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 169,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 174.000007087165,
                          "s": [
                            100
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "poly",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.235,
                                0
                              ],
                              [
                                -0.101,
                                -1.52
                              ]
                            ],
                            "o": [
                              [
                                0.202,
                                -1.367
                              ],
                              [
                                1.266,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                26.565,
                                0.615
                              ],
                              [
                                28.828,
                                -1.58
                              ],
                              [
                                30.974,
                                0.615
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ind": 1,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.602,
                                0
                              ],
                              [
                                -0.288,
                                1.857
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.234,
                                0
                              ],
                              [
                                0.068,
                                1.672
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.196,
                                0
                              ],
                              [
                                0,
                                -2.737
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.263,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.153,
                                0.861
                              ],
                              [
                                -1.52,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -3.16
                              ],
                              [
                                -2.518,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.788
                              ]
                            ],
                            "v": [
                              [
                                28.913,
                                6.124
                              ],
                              [
                                32.966,
                                3.252
                              ],
                              [
                                30.991,
                                3.252
                              ],
                              [
                                28.962,
                                4.602
                              ],
                              [
                                26.53,
                                1.984
                              ],
                              [
                                33,
                                1.984
                              ],
                              [
                                33,
                                1.393
                              ],
                              [
                                28.828,
                                -3.067
                              ],
                              [
                                24.435,
                                1.495
                              ],
                              [
                                24.435,
                                1.63
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 2",
                        "hd": false
                      },
                      {
                        "ind": 2,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -1.739,
                                0
                              ],
                              [
                                -0.44,
                                0.861
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.099,
                                0
                              ],
                              [
                                0,
                                1.335
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                1.437,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.402
                              ],
                              [
                                -1.181,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.349
                              ]
                            ],
                            "v": [
                              [
                                18.013,
                                6.124
                              ],
                              [
                                20.819,
                                4.569
                              ],
                              [
                                20.819,
                                5.955
                              ],
                              [
                                22.863,
                                5.955
                              ],
                              [
                                22.863,
                                -2.882
                              ],
                              [
                                20.819,
                                -2.882
                              ],
                              [
                                20.819,
                                2.373
                              ],
                              [
                                18.757,
                                4.484
                              ],
                              [
                                17.017,
                                2.542
                              ],
                              [
                                17.017,
                                -2.882
                              ],
                              [
                                14.974,
                                -2.882
                              ],
                              [
                                14.974,
                                2.778
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 3",
                        "hd": false
                      },
                      {
                        "ind": 3,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.148,
                                0
                              ],
                              [
                                0,
                                -1.335
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.772,
                                0
                              ],
                              [
                                0.422,
                                -0.862
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.404
                              ],
                              [
                                1.216,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.432
                              ],
                              [
                                -1.453,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                5.039,
                                5.955
                              ],
                              [
                                7.083,
                                5.955
                              ],
                              [
                                7.083,
                                0.752
                              ],
                              [
                                9.161,
                                -1.361
                              ],
                              [
                                10.918,
                                0.583
                              ],
                              [
                                10.918,
                                5.955
                              ],
                              [
                                12.962,
                                5.955
                              ],
                              [
                                12.962,
                                0.396
                              ],
                              [
                                9.94,
                                -3.067
                              ],
                              [
                                7.083,
                                -1.479
                              ],
                              [
                                7.083,
                                -2.882
                              ],
                              [
                                5.039,
                                -2.882
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 4",
                        "hd": false
                      },
                      {
                        "ind": 4,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.233,
                                0
                              ],
                              [
                                -0.102,
                                -1.52
                              ]
                            ],
                            "o": [
                              [
                                0.203,
                                -1.367
                              ],
                              [
                                1.268,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -2.962,
                                0.615
                              ],
                              [
                                -0.699,
                                -1.58
                              ],
                              [
                                1.447,
                                0.615
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 5",
                        "hd": false
                      },
                      {
                        "ind": 5,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.601,
                                0
                              ],
                              [
                                -0.288,
                                1.857
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.232,
                                0
                              ],
                              [
                                0.069,
                                1.672
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.197,
                                0
                              ],
                              [
                                0,
                                -2.737
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.265,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.151,
                                0.861
                              ],
                              [
                                -1.521,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -3.16
                              ],
                              [
                                -2.517,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.788
                              ]
                            ],
                            "v": [
                              [
                                -0.616,
                                6.124
                              ],
                              [
                                3.44,
                                3.252
                              ],
                              [
                                1.462,
                                3.252
                              ],
                              [
                                -0.564,
                                4.602
                              ],
                              [
                                -2.997,
                                1.984
                              ],
                              [
                                3.474,
                                1.984
                              ],
                              [
                                3.474,
                                1.393
                              ],
                              [
                                -0.699,
                                -3.067
                              ],
                              [
                                -5.091,
                                1.495
                              ],
                              [
                                -5.091,
                                1.63
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 6",
                        "hd": false
                      },
                      {
                        "ind": 6,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -11,
                                5.955
                              ],
                              [
                                -8.618,
                                5.955
                              ],
                              [
                                -5.424,
                                -2.882
                              ],
                              [
                                -7.435,
                                -2.882
                              ],
                              [
                                -9.715,
                                3.859
                              ],
                              [
                                -12.031,
                                -2.882
                              ],
                              [
                                -14.227,
                                -2.882
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 7",
                        "hd": false
                      },
                      {
                        "ind": 7,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -1.235,
                                0
                              ],
                              [
                                -0.1,
                                -1.52
                              ]
                            ],
                            "o": [
                              [
                                0.202,
                                -1.367
                              ],
                              [
                                1.266,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -21.151,
                                0.615
                              ],
                              [
                                -18.888,
                                -1.58
                              ],
                              [
                                -16.743,
                                0.615
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 8",
                        "hd": false
                      },
                      {
                        "ind": 8,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.602,
                                0
                              ],
                              [
                                -0.288,
                                1.857
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.233,
                                0
                              ],
                              [
                                0.067,
                                1.672
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.196,
                                0
                              ],
                              [
                                0,
                                -2.737
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                2.264,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.152,
                                0.861
                              ],
                              [
                                -1.521,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -3.16
                              ],
                              [
                                -2.518,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                2.788
                              ]
                            ],
                            "v": [
                              [
                                -18.803,
                                6.124
                              ],
                              [
                                -14.749,
                                3.252
                              ],
                              [
                                -16.725,
                                3.252
                              ],
                              [
                                -18.753,
                                4.602
                              ],
                              [
                                -21.185,
                                1.984
                              ],
                              [
                                -14.715,
                                1.984
                              ],
                              [
                                -14.715,
                                1.393
                              ],
                              [
                                -18.888,
                                -3.067
                              ],
                              [
                                -23.281,
                                1.495
                              ],
                              [
                                -23.281,
                                1.63
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 9",
                        "hd": false
                      },
                      {
                        "ind": 9,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.384
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.504,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.437,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.283
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -30.754,
                                -0.532
                              ],
                              [
                                -30.754,
                                -4.385
                              ],
                              [
                                -28.947,
                                -4.385
                              ],
                              [
                                -26.648,
                                -2.527
                              ],
                              [
                                -26.648,
                                -2.458
                              ],
                              [
                                -28.947,
                                -0.532
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 10",
                        "hd": false
                      },
                      {
                        "ind": 10,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.893
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.653,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.504,
                                -0.389
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.467
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -33,
                                5.955
                              ],
                              [
                                -30.754,
                                5.955
                              ],
                              [
                                -30.754,
                                1.072
                              ],
                              [
                                -29.318,
                                1.072
                              ],
                              [
                                -26.159,
                                5.955
                              ],
                              [
                                -23.725,
                                5.955
                              ],
                              [
                                -27.122,
                                0.734
                              ],
                              [
                                -24.435,
                                -2.51
                              ],
                              [
                                -24.435,
                                -2.576
                              ],
                              [
                                -28.947,
                                -6.124
                              ],
                              [
                                -33,
                                -6.124
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 11",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0,
                            0,
                            0,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            291.549,
                            244.902
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 34",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -0.956,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.956
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.956,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.956
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0.956,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.956
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.956,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.956
                              ]
                            ],
                            "v": [
                              [
                                -42.725,
                                -5.488
                              ],
                              [
                                42.724,
                                -5.488
                              ],
                              [
                                44.455,
                                -3.759
                              ],
                              [
                                44.455,
                                3.758
                              ],
                              [
                                42.724,
                                5.488
                              ],
                              [
                                -42.725,
                                5.488
                              ],
                              [
                                -44.455,
                                3.758
                              ],
                              [
                                -44.455,
                                -3.759
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.995999983245,
                            0.889999988032,
                            0.791999966491,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            301.619,
                            287.447
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 35",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -0.956,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.956
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.956,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.955
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0.956,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.955
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.956,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.956
                              ]
                            ],
                            "v": [
                              [
                                -31.749,
                                -5.488
                              ],
                              [
                                31.747,
                                -5.488
                              ],
                              [
                                33.478,
                                -3.758
                              ],
                              [
                                33.478,
                                3.758
                              ],
                              [
                                31.747,
                                5.489
                              ],
                              [
                                -31.749,
                                5.489
                              ],
                              [
                                -33.479,
                                3.758
                              ],
                              [
                                -33.479,
                                -3.758
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.995999983245,
                            0.889999988032,
                            0.791999966491,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            290.642,
                            270.982
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 36",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -1.918,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.918
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.918,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.917
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                1.918,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.917
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.918,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.918
                              ]
                            ],
                            "v": [
                              [
                                -52.507,
                                -51.041
                              ],
                              [
                                52.509,
                                -51.041
                              ],
                              [
                                55.98,
                                -47.568
                              ],
                              [
                                55.98,
                                47.569
                              ],
                              [
                                52.509,
                                51.041
                              ],
                              [
                                -52.507,
                                51.041
                              ],
                              [
                                -55.98,
                                47.569
                              ],
                              [
                                -55.98,
                                -47.568
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.875,
                            0.885999971278,
                            0.910000011968,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "w": {
                          "a": 0,
                          "k": 1.098
                        },
                        "lc": 1,
                        "lj": 1,
                        "ml": 4,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            1,
                            1,
                            1,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            301.618,
                            273.176
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 37",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": 0.1,
                            "y": 1
                          },
                          "o": {
                            "x": 0.9,
                            "y": 0
                          },
                          "t": 194,
                          "s": [
                            392.751,
                            283.43
                          ],
                          "to": [
                            -15.189,
                            -1.709
                          ],
                          "ti": [
                            15.189,
                            1.709
                          ]
                        },
                        {
                          "t": 214.000008716399,
                          "s": [
                            301.618,
                            273.176
                          ]
                        }
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        301.618,
                        273.176
                      ]
                    },
                    "s": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 169,
                          "s": [
                            80,
                            80
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 174,
                          "s": [
                            140,
                            140
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 179,
                          "s": [
                            130,
                            130
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 194,
                          "s": [
                            130,
                            130
                          ]
                        },
                        {
                          "i": {
                            "x": [
                              0.833,
                              0.833
                            ],
                            "y": [
                              0.833,
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167,
                              0.167
                            ],
                            "y": [
                              0.167,
                              0.167
                            ]
                          },
                          "t": 204,
                          "s": [
                            120,
                            120
                          ]
                        },
                        {
                          "t": 214.000008716399,
                          "s": [
                            100,
                            100
                          ]
                        }
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 169,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 177.000007209358,
                          "s": [
                            100
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "revenue",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    250.327,
                    252.623
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    184.958,
                    162.813
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "fill",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.498,
                                1.442
                              ],
                              [
                                -1.442,
                                -2.497
                              ],
                              [
                                2.498,
                                -1.441
                              ],
                              [
                                1.443,
                                2.498
                              ]
                            ],
                            "o": [
                              [
                                2.498,
                                -1.442
                              ],
                              [
                                1.443,
                                2.498
                              ],
                              [
                                -2.498,
                                1.443
                              ],
                              [
                                -1.442,
                                -2.498
                              ]
                            ],
                            "v": [
                              [
                                -2.611,
                                -4.523
                              ],
                              [
                                4.523,
                                -2.612
                              ],
                              [
                                2.612,
                                4.522
                              ],
                              [
                                -4.523,
                                2.611
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            1,
                            1,
                            1,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            108.861,
                            135.717
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 6",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -9.991,
                                5.769
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                9.991,
                                -5.769
                              ]
                            ],
                            "o": [
                              [
                                -5.769,
                                -9.992
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                5.769,
                                9.992
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -15.453,
                                20.983
                              ],
                              [
                                -7.807,
                                -7.553
                              ],
                              [
                                15.454,
                                -20.983
                              ],
                              [
                                7.808,
                                7.553
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0,
                            0.118000000598,
                            0.231000010173,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 2",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0,
                            0.118000000598,
                            0.231000010173,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            102.187,
                            139.473
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 7",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.498,
                                1.442
                              ],
                              [
                                -1.442,
                                -2.498
                              ],
                              [
                                2.498,
                                -1.442
                              ],
                              [
                                1.443,
                                2.498
                              ]
                            ],
                            "o": [
                              [
                                2.498,
                                -1.442
                              ],
                              [
                                1.443,
                                2.498
                              ],
                              [
                                -2.498,
                                1.442
                              ],
                              [
                                -1.442,
                                -2.498
                              ]
                            ],
                            "v": [
                              [
                                -2.611,
                                -4.523
                              ],
                              [
                                4.523,
                                -2.611
                              ],
                              [
                                2.612,
                                4.523
                              ],
                              [
                                -4.523,
                                2.611
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            1,
                            1,
                            1,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            89.464,
                            116.319
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 8",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -9.991,
                                5.768
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                9.991,
                                -5.769
                              ]
                            ],
                            "o": [
                              [
                                -5.769,
                                -9.991
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                5.769,
                                9.992
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -15.453,
                                20.983
                              ],
                              [
                                -7.807,
                                -7.553
                              ],
                              [
                                15.454,
                                -20.983
                              ],
                              [
                                7.808,
                                7.554
                              ]
                            ],
                            "c": true
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0,
                            0.118000000598,
                            0.231000010173,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 2",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0,
                            0.118000000598,
                            0.231000010173,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            97.785,
                            112.261
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 9",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        99.986,
                        125.867
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        99.986,
                        125.867
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 11",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": 0.5,
                            "y": 1
                          },
                          "o": {
                            "x": 0.5,
                            "y": 0
                          },
                          "t": 169,
                          "s": [
                            {
                              "i": [
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ]
                              ],
                              "o": [
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ]
                              ],
                              "v": [
                                [
                                  -80,
                                  -10.5
                                ],
                                [
                                  80,
                                  -10.5
                                ],
                                [
                                  84,
                                  -6.5
                                ],
                                [
                                  84,
                                  6.5
                                ],
                                [
                                  80,
                                  10.5
                                ],
                                [
                                  -80,
                                  10.5
                                ],
                                [
                                  -84,
                                  6.5
                                ],
                                [
                                  -84,
                                  -6.5
                                ]
                              ],
                              "c": true
                            }
                          ]
                        },
                        {
                          "t": 184.000007494474,
                          "s": [
                            {
                              "i": [
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ]
                              ],
                              "o": [
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ]
                              ],
                              "v": [
                                [
                                  -80,
                                  -10.5
                                ],
                                [
                                  -74.987,
                                  -10.194
                                ],
                                [
                                  -70.987,
                                  -6.194
                                ],
                                [
                                  -70.987,
                                  6.806
                                ],
                                [
                                  -74.987,
                                  10.806
                                ],
                                [
                                  -80,
                                  10.5
                                ],
                                [
                                  -84,
                                  6.5
                                ],
                                [
                                  -84,
                                  -6.5
                                ]
                              ],
                              "c": true
                            }
                          ]
                        }
                      ]
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.875,
                        0.889999988032,
                        0.925,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        166,
                        197.5
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 177,
                          "s": [
                            100
                          ]
                        },
                        {
                          "t": 184.000007494474,
                          "s": [
                            0
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 3",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": 0.5,
                            "y": 1
                          },
                          "o": {
                            "x": 0.5,
                            "y": 0
                          },
                          "t": 171,
                          "s": [
                            {
                              "i": [
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ]
                              ],
                              "o": [
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ]
                              ],
                              "v": [
                                [
                                  -109.5,
                                  -10.5
                                ],
                                [
                                  109.5,
                                  -10.5
                                ],
                                [
                                  113.5,
                                  -6.5
                                ],
                                [
                                  113.5,
                                  6.5
                                ],
                                [
                                  109.5,
                                  10.5
                                ],
                                [
                                  -109.5,
                                  10.5
                                ],
                                [
                                  -113.5,
                                  6.5
                                ],
                                [
                                  -113.5,
                                  -6.5
                                ]
                              ],
                              "c": true
                            }
                          ]
                        },
                        {
                          "t": 186.000007575935,
                          "s": [
                            {
                              "i": [
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ]
                              ],
                              "o": [
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ]
                              ],
                              "v": [
                                [
                                  -109.5,
                                  -10.5
                                ],
                                [
                                  -105.566,
                                  -10.548
                                ],
                                [
                                  -101.566,
                                  -6.548
                                ],
                                [
                                  -101.566,
                                  6.452
                                ],
                                [
                                  -105.566,
                                  10.452
                                ],
                                [
                                  -109.5,
                                  10.5
                                ],
                                [
                                  -113.5,
                                  6.5
                                ],
                                [
                                  -113.5,
                                  -6.5
                                ]
                              ],
                              "c": true
                            }
                          ]
                        }
                      ]
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.875,
                        0.889999988032,
                        0.925,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        195.5,
                        226.5
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 179,
                          "s": [
                            100
                          ]
                        },
                        {
                          "t": 186.000007575935,
                          "s": [
                            0
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": 0.5,
                            "y": 1
                          },
                          "o": {
                            "x": 0.5,
                            "y": 0
                          },
                          "t": 173,
                          "s": [
                            {
                              "i": [
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ]
                              ],
                              "o": [
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ]
                              ],
                              "v": [
                                [
                                  -127.5,
                                  -10.5
                                ],
                                [
                                  127.5,
                                  -10.5
                                ],
                                [
                                  131.5,
                                  -6.5
                                ],
                                [
                                  131.5,
                                  6.5
                                ],
                                [
                                  127.5,
                                  10.5
                                ],
                                [
                                  -127.5,
                                  10.5
                                ],
                                [
                                  -131.5,
                                  6.5
                                ],
                                [
                                  -131.5,
                                  -6.5
                                ]
                              ],
                              "c": true
                            }
                          ]
                        },
                        {
                          "t": 188.000007657397,
                          "s": [
                            {
                              "i": [
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ]
                              ],
                              "o": [
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ]
                              ],
                              "v": [
                                [
                                  -127.5,
                                  -10.5
                                ],
                                [
                                  -122.394,
                                  -10.548
                                ],
                                [
                                  -118.394,
                                  -6.548
                                ],
                                [
                                  -118.394,
                                  6.452
                                ],
                                [
                                  -122.394,
                                  10.452
                                ],
                                [
                                  -127.5,
                                  10.5
                                ],
                                [
                                  -131.5,
                                  6.5
                                ],
                                [
                                  -131.5,
                                  -6.5
                                ]
                              ],
                              "c": true
                            }
                          ]
                        }
                      ]
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.875,
                        0.889999988032,
                        0.925,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        213.5,
                        255.5
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 181,
                          "s": [
                            100
                          ]
                        },
                        {
                          "t": 188.000007657397,
                          "s": [
                            0
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": 0.833,
                            "y": 1
                          },
                          "o": {
                            "x": 0.167,
                            "y": 0
                          },
                          "t": 159,
                          "s": [
                            {
                              "i": [
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ]
                              ],
                              "o": [
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ]
                              ],
                              "v": [
                                [
                                  -113,
                                  -42
                                ],
                                [
                                  0.5,
                                  -42
                                ],
                                [
                                  4.5,
                                  -38
                                ],
                                [
                                  4.5,
                                  -24
                                ],
                                [
                                  0.5,
                                  -20
                                ],
                                [
                                  -113,
                                  -20
                                ],
                                [
                                  -117,
                                  -24
                                ],
                                [
                                  -117,
                                  -38
                                ]
                              ],
                              "c": true
                            }
                          ]
                        },
                        {
                          "t": 173.000007046434,
                          "s": [
                            {
                              "i": [
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ]
                              ],
                              "o": [
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ]
                              ],
                              "v": [
                                [
                                  -113,
                                  -42
                                ],
                                [
                                  -111.5,
                                  -42
                                ],
                                [
                                  -107.5,
                                  -38
                                ],
                                [
                                  -107.5,
                                  -24
                                ],
                                [
                                  -111.5,
                                  -20
                                ],
                                [
                                  -113,
                                  -20
                                ],
                                [
                                  -117,
                                  -24
                                ],
                                [
                                  -117,
                                  -38
                                ]
                              ],
                              "c": true
                            }
                          ]
                        }
                      ]
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.875,
                        0.889999988032,
                        0.925,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        256.5,
                        168.746
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 164,
                          "s": [
                            100
                          ]
                        },
                        {
                          "t": 173.000007046434,
                          "s": [
                            0
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 4",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": 0.833,
                            "y": 1
                          },
                          "o": {
                            "x": 0.167,
                            "y": 0
                          },
                          "t": 159,
                          "s": [
                            {
                              "i": [
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ]
                              ],
                              "o": [
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ]
                              ],
                              "v": [
                                [
                                  -77,
                                  -11
                                ],
                                [
                                  137,
                                  -11
                                ],
                                [
                                  141,
                                  -7
                                ],
                                [
                                  141,
                                  7
                                ],
                                [
                                  137,
                                  11
                                ],
                                [
                                  -77,
                                  11
                                ],
                                [
                                  -81,
                                  7
                                ],
                                [
                                  -81,
                                  -7
                                ]
                              ],
                              "c": true
                            }
                          ]
                        },
                        {
                          "t": 173.000007046434,
                          "s": [
                            {
                              "i": [
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ]
                              ],
                              "o": [
                                [
                                  0,
                                  0
                                ],
                                [
                                  2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  2.209
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  -2.209,
                                  0
                                ],
                                [
                                  0,
                                  0
                                ],
                                [
                                  0,
                                  -2.209
                                ]
                              ],
                              "v": [
                                [
                                  -77,
                                  -11
                                ],
                                [
                                  -75.5,
                                  -11
                                ],
                                [
                                  -71.5,
                                  -7
                                ],
                                [
                                  -71.5,
                                  7
                                ],
                                [
                                  -75.5,
                                  11
                                ],
                                [
                                  -77,
                                  11
                                ],
                                [
                                  -81,
                                  7
                                ],
                                [
                                  -81,
                                  -7
                                ]
                              ],
                              "c": true
                            }
                          ]
                        }
                      ]
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.875,
                        0.889999988032,
                        0.925,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        220.5,
                        107
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 164,
                          "s": [
                            100
                          ]
                        },
                        {
                          "t": 173.000007046434,
                          "s": [
                            0
                          ]
                        }
                      ]
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 5",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -2.941,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.941
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.941,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.941
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            2.941,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.941
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.941,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.941
                          ]
                        ],
                        "v": [
                          [
                            -196.862,
                            -232.5
                          ],
                          [
                            196.862,
                            -232.5
                          ],
                          [
                            202.188,
                            -227.174
                          ],
                          [
                            202.188,
                            238.174
                          ],
                          [
                            196.862,
                            243.5
                          ],
                          [
                            -196.862,
                            243.5
                          ],
                          [
                            -202.188,
                            238.174
                          ],
                          [
                            -202.188,
                            -227.174
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 4,
                    "nm": "Merge Paths 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.964999988032,
                        0.976000019148,
                        0.987999949736,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        250.188,
                        280.5
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 10",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    255,
                    262
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    255,
                    262
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "template",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 0,
        "op": 1077.00004386711,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 9,
        "ty": 4,
        "nm": "Pablita glow 3",
        "sr": 1.5,
        "ks": {
          "r": {
            "a": 0,
            "k": -55
          },
          "p": {
            "a": 0,
            "k": [
              316,
              37.5,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              38.5,
              18.5,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              73.909,
              73.909,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        81.295,
                        29.948
                      ],
                      [
                        64.789,
                        35.243
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 298,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 304.000012382174,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 307,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 313.000012748751,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 4",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -7.811,
                        15.346
                      ],
                      [
                        9.968,
                        24.391
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 298,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 304.000012382174,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 307,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 313.000012748751,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 3",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        28.252,
                        -7.311
                      ],
                      [
                        28.57,
                        11.096
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 298,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 304.000012382174,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 307,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 313.000012748751,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 2",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        63.125,
                        2.024
                      ],
                      [
                        51.5,
                        15.75
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 298,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 304.000012382174,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 307,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 313.000012748751,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 262.000010671479,
        "op": 1877.50007647214,
        "st": 262.000010671479,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 10,
        "ty": 4,
        "nm": "Pablita glow 2",
        "sr": 1.5,
        "ks": {
          "r": {
            "a": 0,
            "k": -55
          },
          "p": {
            "a": 0,
            "k": [
              331,
              35.5,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              38.5,
              18.5,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              73.909,
              73.909,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        81.295,
                        29.948
                      ],
                      [
                        64.789,
                        35.243
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 120,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 126.000005132085,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 129,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 135.000005498663,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 4",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -7.811,
                        15.346
                      ],
                      [
                        9.968,
                        24.391
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 120,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 126.000005132085,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 129,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 135.000005498663,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 3",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        28.252,
                        -7.311
                      ],
                      [
                        28.57,
                        11.096
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 120,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 126.000005132085,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 129,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 135.000005498663,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 2",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        63.125,
                        2.024
                      ],
                      [
                        51.5,
                        15.75
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 120,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 126.000005132085,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 129,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 135.000005498663,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 84.0000034213901,
        "op": 1699.50006922205,
        "st": 84.0000034213901,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 11,
        "ty": 4,
        "nm": "Pablita glow",
        "sr": 1.5,
        "ks": {
          "r": {
            "a": 0,
            "k": -55
          },
          "p": {
            "a": 0,
            "k": [
              365,
              38.5,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              38.5,
              18.5,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              73.909,
              73.909,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        81.295,
                        29.948
                      ],
                      [
                        64.789,
                        35.243
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 5,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 11.0000004480392,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 14,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 20.0000008146167,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 4",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -7.811,
                        15.346
                      ],
                      [
                        9.968,
                        24.391
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 5,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 11.0000004480392,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 14,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 20.0000008146167,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 3",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        28.252,
                        -7.311
                      ],
                      [
                        28.57,
                        11.096
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 5,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 11.0000004480392,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 14,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 20.0000008146167,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 2",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        63.125,
                        2.024
                      ],
                      [
                        51.5,
                        15.75
                      ]
                    ],
                    "c": false
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 4
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.118000000598,
                    0.231000010173,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 5,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 11.0000004480392,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.1
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.9
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 14,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 20.0000008146167,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Shape 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": -31.0000012626559,
        "op": 1584.50006453801,
        "st": -31.0000012626559,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 12,
        "ty": 4,
        "nm": "button Outlines",
        "sr": 1,
        "ks": {
          "p": {
            "a": 0,
            "k": [
              431,
              68,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              92.5,
              22,
              0
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            4.546
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            5.332,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            5.331,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -4.545
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            96.077,
                            7.583
                          ],
                          [
                            101.026,
                            7.583
                          ],
                          [
                            109.014,
                            0
                          ],
                          [
                            109.014,
                            -0.17
                          ],
                          [
                            101.048,
                            -7.605
                          ],
                          [
                            96.077,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.123
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.057,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.208,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.145
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            99.518,
                            4.907
                          ],
                          [
                            99.518,
                            -4.928
                          ],
                          [
                            100.878,
                            -4.928
                          ],
                          [
                            105.424,
                            -0.127
                          ],
                          [
                            105.424,
                            0.042
                          ],
                          [
                            100.921,
                            4.907
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 2",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.55
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.722,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.657,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.466
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            85.396,
                            -0.616
                          ],
                          [
                            85.396,
                            -4.97
                          ],
                          [
                            87.329,
                            -4.97
                          ],
                          [
                            89.922,
                            -2.889
                          ],
                          [
                            89.922,
                            -2.804
                          ],
                          [
                            87.329,
                            -0.616
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 3",
                    "hd": false
                  },
                  {
                    "ind": 3,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.294
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.591,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.784,
                            -0.531
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.144
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            81.976,
                            7.583
                          ],
                          [
                            85.396,
                            7.583
                          ],
                          [
                            85.396,
                            1.721
                          ],
                          [
                            86.884,
                            1.721
                          ],
                          [
                            90.515,
                            7.583
                          ],
                          [
                            94.17,
                            7.583
                          ],
                          [
                            90.154,
                            1.126
                          ],
                          [
                            93.277,
                            -2.91
                          ],
                          [
                            93.277,
                            -2.995
                          ],
                          [
                            87.414,
                            -7.605
                          ],
                          [
                            81.976,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 4",
                    "hd": false
                  },
                  {
                    "ind": 4,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            72.701,
                            -4.8
                          ],
                          [
                            74.698,
                            1.763
                          ],
                          [
                            70.683,
                            1.763
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 5",
                    "hd": false
                  },
                  {
                    "ind": 5,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            65.671,
                            7.583
                          ],
                          [
                            68.899,
                            7.583
                          ],
                          [
                            69.94,
                            4.206
                          ],
                          [
                            75.441,
                            4.206
                          ],
                          [
                            76.482,
                            7.583
                          ],
                          [
                            80.072,
                            7.583
                          ],
                          [
                            75.144,
                            -7.605
                          ],
                          [
                            70.662,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 6",
                    "hd": false
                  },
                  {
                    "ind": 6,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.759,
                            0
                          ],
                          [
                            0,
                            4.524
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            4.568,
                            0
                          ],
                          [
                            0,
                            -4.524
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            4.736,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -4.567
                          ],
                          [
                            -4.504,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            4.439
                          ]
                        ],
                        "v": [
                          [
                            57.55,
                            7.817
                          ],
                          [
                            65.388,
                            0
                          ],
                          [
                            65.388,
                            -0.17
                          ],
                          [
                            57.571,
                            -7.817
                          ],
                          [
                            49.755,
                            -0.085
                          ],
                          [
                            49.755,
                            0.085
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 7",
                    "hd": false
                  },
                  {
                    "ind": 7,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            2.57,
                            0
                          ],
                          [
                            0,
                            3.101
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.634,
                            0
                          ],
                          [
                            0,
                            -2.953
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -2.484,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.059
                          ],
                          [
                            2.655,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.06
                          ]
                        ],
                        "v": [
                          [
                            57.613,
                            5.077
                          ],
                          [
                            53.345,
                            0.064
                          ],
                          [
                            53.345,
                            -0.106
                          ],
                          [
                            57.571,
                            -5.098
                          ],
                          [
                            61.799,
                            -0.127
                          ],
                          [
                            61.799,
                            0.042
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 8",
                    "hd": false
                  },
                  {
                    "ind": 8,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.275
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.656,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.615,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.359
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            40.065,
                            -1.359
                          ],
                          [
                            40.065,
                            -5.247
                          ],
                          [
                            42.105,
                            -5.247
                          ],
                          [
                            44.441,
                            -3.398
                          ],
                          [
                            44.441,
                            -3.313
                          ],
                          [
                            42.127,
                            -1.359
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 9",
                    "hd": false
                  },
                  {
                    "ind": 9,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.402
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.698,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.868,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            40.065,
                            5.204
                          ],
                          [
                            40.065,
                            0.85
                          ],
                          [
                            42.254,
                            0.85
                          ],
                          [
                            44.888,
                            2.974
                          ],
                          [
                            44.888,
                            3.059
                          ],
                          [
                            42.424,
                            5.204
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 10",
                    "hd": false
                  },
                  {
                    "ind": 10,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.782
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.976,
                            0.403
                          ],
                          [
                            0,
                            1.592
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.313,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            3.506,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.039
                          ],
                          [
                            1.7,
                            -0.489
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.592
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            36.71,
                            7.583
                          ],
                          [
                            42.954,
                            7.583
                          ],
                          [
                            48.286,
                            3.335
                          ],
                          [
                            48.286,
                            3.25
                          ],
                          [
                            45.248,
                            -0.318
                          ],
                          [
                            47.714,
                            -3.568
                          ],
                          [
                            47.714,
                            -3.653
                          ],
                          [
                            42.679,
                            -7.605
                          ],
                          [
                            36.71,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 11",
                    "hd": false
                  },
                  {
                    "ind": 11,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            20.66,
                            7.583
                          ],
                          [
                            24.1,
                            7.583
                          ],
                          [
                            24.1,
                            1.317
                          ],
                          [
                            30.197,
                            1.317
                          ],
                          [
                            30.197,
                            7.583
                          ],
                          [
                            33.639,
                            7.583
                          ],
                          [
                            33.639,
                            -7.605
                          ],
                          [
                            30.197,
                            -7.605
                          ],
                          [
                            30.197,
                            -1.402
                          ],
                          [
                            24.1,
                            -1.402
                          ],
                          [
                            24.1,
                            -7.605
                          ],
                          [
                            20.66,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 12",
                    "hd": false
                  },
                  {
                    "ind": 12,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.165,
                            0
                          ],
                          [
                            0,
                            2.698
                          ],
                          [
                            3.676,
                            0.467
                          ],
                          [
                            0,
                            1.083
                          ],
                          [
                            -1.508,
                            0
                          ],
                          [
                            -0.213,
                            -1.381
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.42,
                            0
                          ],
                          [
                            0,
                            -2.592
                          ],
                          [
                            -3.887,
                            -0.509
                          ],
                          [
                            0,
                            -1.211
                          ],
                          [
                            1.507,
                            0
                          ],
                          [
                            0.149,
                            1.36
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            3.588,
                            0
                          ],
                          [
                            0,
                            -3.144
                          ],
                          [
                            -2.336,
                            -0.341
                          ],
                          [
                            0,
                            -1.02
                          ],
                          [
                            1.508,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.277,
                            -3.017
                          ],
                          [
                            -3.355,
                            0
                          ],
                          [
                            0,
                            2.931
                          ],
                          [
                            2.231,
                            0.34
                          ],
                          [
                            0,
                            1.189
                          ],
                          [
                            -2.252,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.192,
                            3.037
                          ]
                        ],
                        "v": [
                          [
                            12.555,
                            7.817
                          ],
                          [
                            18.354,
                            2.974
                          ],
                          [
                            12.787,
                            -1.635
                          ],
                          [
                            9.964,
                            -3.568
                          ],
                          [
                            12.235,
                            -5.289
                          ],
                          [
                            14.764,
                            -3.271
                          ],
                          [
                            17.929,
                            -3.271
                          ],
                          [
                            12.235,
                            -7.817
                          ],
                          [
                            6.714,
                            -3.292
                          ],
                          [
                            12.193,
                            1.317
                          ],
                          [
                            15.061,
                            3.293
                          ],
                          [
                            12.555,
                            5.311
                          ],
                          [
                            9.58,
                            2.825
                          ],
                          [
                            6.287,
                            2.825
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 13",
                    "hd": false
                  },
                  {
                    "ind": 13,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.721,
                            -4.8
                          ],
                          [
                            0.277,
                            1.763
                          ],
                          [
                            -3.738,
                            1.763
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 14",
                    "hd": false
                  },
                  {
                    "ind": 14,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -8.752,
                            7.583
                          ],
                          [
                            -5.523,
                            7.583
                          ],
                          [
                            -4.482,
                            4.206
                          ],
                          [
                            1.02,
                            4.206
                          ],
                          [
                            2.061,
                            7.583
                          ],
                          [
                            5.65,
                            7.583
                          ],
                          [
                            0.724,
                            -7.605
                          ],
                          [
                            -3.76,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 15",
                    "hd": false
                  },
                  {
                    "ind": 15,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            4.546
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            5.331,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            5.332,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -4.545
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -21.952,
                            7.583
                          ],
                          [
                            -17.004,
                            7.583
                          ],
                          [
                            -9.017,
                            0
                          ],
                          [
                            -9.017,
                            -0.17
                          ],
                          [
                            -16.982,
                            -7.605
                          ],
                          [
                            -21.952,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 16",
                    "hd": false
                  },
                  {
                    "ind": 16,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.123
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.06,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.208,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.145
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -18.512,
                            4.907
                          ],
                          [
                            -18.512,
                            -4.928
                          ],
                          [
                            -17.152,
                            -4.928
                          ],
                          [
                            -12.607,
                            -0.127
                          ],
                          [
                            -12.607,
                            0.042
                          ],
                          [
                            -17.109,
                            4.907
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 17",
                    "hd": false
                  },
                  {
                    "ind": 17,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -36.018,
                            7.583
                          ],
                          [
                            -32.557,
                            7.583
                          ],
                          [
                            -32.557,
                            -4.928
                          ],
                          [
                            -28.456,
                            -4.928
                          ],
                          [
                            -28.456,
                            -7.605
                          ],
                          [
                            -40.118,
                            -7.605
                          ],
                          [
                            -40.118,
                            -4.928
                          ],
                          [
                            -36.018,
                            -4.928
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 18",
                    "hd": false
                  },
                  {
                    "ind": 18,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.55
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.72,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.656,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.466
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -49.361,
                            -0.616
                          ],
                          [
                            -49.361,
                            -4.97
                          ],
                          [
                            -47.428,
                            -4.97
                          ],
                          [
                            -44.837,
                            -2.889
                          ],
                          [
                            -44.837,
                            -2.804
                          ],
                          [
                            -47.428,
                            -0.616
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 19",
                    "hd": false
                  },
                  {
                    "ind": 19,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.294
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.589,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.784,
                            -0.531
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.144
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -52.781,
                            7.583
                          ],
                          [
                            -49.361,
                            7.583
                          ],
                          [
                            -49.361,
                            1.721
                          ],
                          [
                            -47.874,
                            1.721
                          ],
                          [
                            -44.243,
                            7.583
                          ],
                          [
                            -40.59,
                            7.583
                          ],
                          [
                            -44.604,
                            1.126
                          ],
                          [
                            -41.482,
                            -2.91
                          ],
                          [
                            -41.482,
                            -2.995
                          ],
                          [
                            -47.344,
                            -7.605
                          ],
                          [
                            -52.781,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 20",
                    "hd": false
                  },
                  {
                    "ind": 20,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.758,
                            0
                          ],
                          [
                            0,
                            4.524
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            4.567,
                            0
                          ],
                          [
                            0,
                            -4.524
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            4.737,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -4.567
                          ],
                          [
                            -4.502,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            4.439
                          ]
                        ],
                        "v": [
                          [
                            -62.943,
                            7.817
                          ],
                          [
                            -55.105,
                            0
                          ],
                          [
                            -55.105,
                            -0.17
                          ],
                          [
                            -62.921,
                            -7.817
                          ],
                          [
                            -70.738,
                            -0.085
                          ],
                          [
                            -70.738,
                            0.085
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 21",
                    "hd": false
                  },
                  {
                    "ind": 21,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            2.57,
                            0
                          ],
                          [
                            0,
                            3.101
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.633,
                            0
                          ],
                          [
                            0,
                            -2.953
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -2.485,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.059
                          ],
                          [
                            2.656,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.06
                          ]
                        ],
                        "v": [
                          [
                            -62.878,
                            5.077
                          ],
                          [
                            -67.148,
                            0.064
                          ],
                          [
                            -67.148,
                            -0.106
                          ],
                          [
                            -62.921,
                            -5.098
                          ],
                          [
                            -58.693,
                            -0.127
                          ],
                          [
                            -58.693,
                            0.042
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 22",
                    "hd": false
                  },
                  {
                    "ind": 22,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.615
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.679,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.636,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.508
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -79.76,
                            -0.34
                          ],
                          [
                            -79.76,
                            -4.992
                          ],
                          [
                            -78.02,
                            -4.992
                          ],
                          [
                            -75.449,
                            -2.74
                          ],
                          [
                            -75.449,
                            -2.655
                          ],
                          [
                            -78.02,
                            -0.34
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 23",
                    "hd": false
                  },
                  {
                    "ind": 23,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.207
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.696,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.463,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.208
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -83.18,
                            7.583
                          ],
                          [
                            -79.76,
                            7.583
                          ],
                          [
                            -79.76,
                            2.061
                          ],
                          [
                            -77.829,
                            2.061
                          ],
                          [
                            -72.135,
                            -2.676
                          ],
                          [
                            -72.135,
                            -2.761
                          ],
                          [
                            -77.934,
                            -7.605
                          ],
                          [
                            -83.18,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 24",
                    "hd": false
                  },
                  {
                    "ind": 24,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -102.363,
                            7.583
                          ],
                          [
                            -99.283,
                            7.583
                          ],
                          [
                            -99.283,
                            -3.08
                          ],
                          [
                            -95.057,
                            7.583
                          ],
                          [
                            -93.93,
                            7.583
                          ],
                          [
                            -89.725,
                            -3.08
                          ],
                          [
                            -89.725,
                            7.583
                          ],
                          [
                            -86.305,
                            7.583
                          ],
                          [
                            -86.305,
                            -7.605
                          ],
                          [
                            -90.766,
                            -7.605
                          ],
                          [
                            -94.271,
                            1.848
                          ],
                          [
                            -97.818,
                            -7.605
                          ],
                          [
                            -102.363,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 25",
                    "hd": false
                  },
                  {
                    "ind": 25,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -109.014,
                            7.583
                          ],
                          [
                            -105.552,
                            7.583
                          ],
                          [
                            -105.552,
                            -7.605
                          ],
                          [
                            -109.014,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 26",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Merge Paths 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        126.561,
                        22.555
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.719
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.718
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.718
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.719
                          ]
                        ],
                        "v": [
                          [
                            -122.388,
                            -22
                          ],
                          [
                            122.388,
                            -22
                          ],
                          [
                            125.5,
                            -18.888
                          ],
                          [
                            125.5,
                            18.888
                          ],
                          [
                            122.388,
                            22
                          ],
                          [
                            -122.388,
                            22
                          ],
                          [
                            -125.5,
                            18.888
                          ],
                          [
                            -125.5,
                            -18.888
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.118000000598,
                        0.231000010173,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        125.5,
                        22
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.5,
                        "y": 1
                      },
                      "o": {
                        "x": 0.5,
                        "y": 0
                      },
                      "t": 290,
                      "s": [
                        143.605,
                        22
                      ],
                      "to": [
                        -5.518,
                        0
                      ],
                      "ti": [
                        5.518,
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": 0.5,
                        "y": 0.5
                      },
                      "o": {
                        "x": 0.167,
                        "y": 0.167
                      },
                      "t": 300,
                      "s": [
                        110.5,
                        22
                      ],
                      "to": [
                        0,
                        0
                      ],
                      "ti": [
                        0,
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": 0.5,
                        "y": 1
                      },
                      "o": {
                        "x": 0.5,
                        "y": 0
                      },
                      "t": 447,
                      "s": [
                        110.5,
                        22
                      ],
                      "to": [
                        -2,
                        0
                      ],
                      "ti": [
                        2,
                        0
                      ]
                    },
                    {
                      "t": 457.000018613992,
                      "s": [
                        98.5,
                        22
                      ]
                    }
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    125.5,
                    22
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 295,
                      "s": [
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 300,
                      "s": [
                        100
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 452,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 457.000018613992,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Dasahboards",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            90.214,
                            7.594
                          ],
                          [
                            93.654,
                            7.594
                          ],
                          [
                            93.654,
                            1.71
                          ],
                          [
                            98.647,
                            1.71
                          ],
                          [
                            98.647,
                            -0.882
                          ],
                          [
                            93.654,
                            -0.882
                          ],
                          [
                            93.654,
                            -4.896
                          ],
                          [
                            99.964,
                            -4.896
                          ],
                          [
                            99.964,
                            -7.594
                          ],
                          [
                            90.214,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            4.546
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            5.333,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            5.332,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -4.545
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            74.972,
                            7.594
                          ],
                          [
                            79.921,
                            7.594
                          ],
                          [
                            87.908,
                            0.01
                          ],
                          [
                            87.908,
                            -0.16
                          ],
                          [
                            79.942,
                            -7.594
                          ],
                          [
                            74.972,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 2",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.123
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.057,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.208,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.145
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            78.413,
                            4.917
                          ],
                          [
                            78.413,
                            -4.917
                          ],
                          [
                            79.773,
                            -4.917
                          ],
                          [
                            84.318,
                            -0.117
                          ],
                          [
                            84.318,
                            0.053
                          ],
                          [
                            79.816,
                            4.917
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 3",
                    "hd": false
                  },
                  {
                    "ind": 3,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.615
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.679,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.637,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.508
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            65.266,
                            -0.329
                          ],
                          [
                            65.266,
                            -4.982
                          ],
                          [
                            67.008,
                            -4.982
                          ],
                          [
                            69.578,
                            -2.73
                          ],
                          [
                            69.578,
                            -2.645
                          ],
                          [
                            67.008,
                            -0.329
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 4",
                    "hd": false
                  },
                  {
                    "ind": 4,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.207
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.696,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.463,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.208
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            61.846,
                            7.594
                          ],
                          [
                            65.266,
                            7.594
                          ],
                          [
                            65.266,
                            2.072
                          ],
                          [
                            67.199,
                            2.072
                          ],
                          [
                            72.893,
                            -2.665
                          ],
                          [
                            72.893,
                            -2.751
                          ],
                          [
                            67.093,
                            -7.594
                          ],
                          [
                            61.846,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 5",
                    "hd": false
                  },
                  {
                    "ind": 5,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            42.919,
                            7.594
                          ],
                          [
                            46.359,
                            7.594
                          ],
                          [
                            46.359,
                            0.775
                          ],
                          [
                            51.607,
                            7.594
                          ],
                          [
                            55.621,
                            7.594
                          ],
                          [
                            49.313,
                            -0.415
                          ],
                          [
                            55.324,
                            -7.615
                          ],
                          [
                            51.671,
                            -7.615
                          ],
                          [
                            46.359,
                            -1.051
                          ],
                          [
                            46.359,
                            -7.594
                          ],
                          [
                            42.919,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 6",
                    "hd": false
                  },
                  {
                    "ind": 6,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            26.993,
                            7.594
                          ],
                          [
                            30.051,
                            7.594
                          ],
                          [
                            30.051,
                            -3.219
                          ],
                          [
                            36.382,
                            7.594
                          ],
                          [
                            39.822,
                            7.594
                          ],
                          [
                            39.822,
                            -7.594
                          ],
                          [
                            36.764,
                            -7.594
                          ],
                          [
                            36.764,
                            2.411
                          ],
                          [
                            30.986,
                            -7.594
                          ],
                          [
                            26.993,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 7",
                    "hd": false
                  },
                  {
                    "ind": 7,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            17.717,
                            -4.79
                          ],
                          [
                            19.714,
                            1.773
                          ],
                          [
                            15.7,
                            1.773
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 8",
                    "hd": false
                  },
                  {
                    "ind": 8,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            10.688,
                            7.594
                          ],
                          [
                            13.916,
                            7.594
                          ],
                          [
                            14.956,
                            4.217
                          ],
                          [
                            20.458,
                            4.217
                          ],
                          [
                            21.499,
                            7.594
                          ],
                          [
                            25.089,
                            7.594
                          ],
                          [
                            20.16,
                            -7.594
                          ],
                          [
                            15.678,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 9",
                    "hd": false
                  },
                  {
                    "ind": 9,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            0.058,
                            7.594
                          ],
                          [
                            9.681,
                            7.594
                          ],
                          [
                            9.681,
                            4.896
                          ],
                          [
                            3.5,
                            4.896
                          ],
                          [
                            3.5,
                            -7.594
                          ],
                          [
                            0.058,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 10",
                    "hd": false
                  },
                  {
                    "ind": 10,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.275
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.657,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.614,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.359
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -10.417,
                            -1.348
                          ],
                          [
                            -10.417,
                            -5.236
                          ],
                          [
                            -8.378,
                            -5.236
                          ],
                          [
                            -6.04,
                            -3.387
                          ],
                          [
                            -6.04,
                            -3.303
                          ],
                          [
                            -8.357,
                            -1.348
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 11",
                    "hd": false
                  },
                  {
                    "ind": 11,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.402
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.699,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.869,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -10.417,
                            5.215
                          ],
                          [
                            -10.417,
                            0.861
                          ],
                          [
                            -8.229,
                            0.861
                          ],
                          [
                            -5.594,
                            2.984
                          ],
                          [
                            -5.594,
                            3.07
                          ],
                          [
                            -8.059,
                            5.215
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 12",
                    "hd": false
                  },
                  {
                    "ind": 12,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.782
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.975,
                            0.403
                          ],
                          [
                            0,
                            1.592
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.313,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            3.505,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.039
                          ],
                          [
                            1.699,
                            -0.489
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.592
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -13.773,
                            7.594
                          ],
                          [
                            -7.527,
                            7.594
                          ],
                          [
                            -2.197,
                            3.346
                          ],
                          [
                            -2.197,
                            3.26
                          ],
                          [
                            -5.234,
                            -0.307
                          ],
                          [
                            -2.77,
                            -3.557
                          ],
                          [
                            -2.77,
                            -3.643
                          ],
                          [
                            -7.803,
                            -7.594
                          ],
                          [
                            -13.773,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 13",
                    "hd": false
                  },
                  {
                    "ind": 13,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -30.771,
                            7.594
                          ],
                          [
                            -20.534,
                            7.594
                          ],
                          [
                            -20.534,
                            4.917
                          ],
                          [
                            -27.352,
                            4.917
                          ],
                          [
                            -27.352,
                            1.137
                          ],
                          [
                            -22.169,
                            1.137
                          ],
                          [
                            -22.169,
                            -1.37
                          ],
                          [
                            -27.352,
                            -1.37
                          ],
                          [
                            -27.352,
                            -4.917
                          ],
                          [
                            -20.872,
                            -4.917
                          ],
                          [
                            -20.872,
                            -7.594
                          ],
                          [
                            -30.771,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 14",
                    "hd": false
                  },
                  {
                    "ind": 14,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -40.301,
                            7.594
                          ],
                          [
                            -36.839,
                            7.594
                          ],
                          [
                            -36.839,
                            -4.917
                          ],
                          [
                            -32.739,
                            -4.917
                          ],
                          [
                            -32.739,
                            -7.594
                          ],
                          [
                            -44.4,
                            -7.594
                          ],
                          [
                            -44.4,
                            -4.917
                          ],
                          [
                            -40.301,
                            -4.917
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 15",
                    "hd": false
                  },
                  {
                    "ind": 15,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -51.057,
                            -4.79
                          ],
                          [
                            -49.059,
                            1.773
                          ],
                          [
                            -53.074,
                            1.773
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 16",
                    "hd": false
                  },
                  {
                    "ind": 16,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -58.087,
                            7.594
                          ],
                          [
                            -54.859,
                            7.594
                          ],
                          [
                            -53.818,
                            4.217
                          ],
                          [
                            -48.316,
                            4.217
                          ],
                          [
                            -47.275,
                            7.594
                          ],
                          [
                            -43.686,
                            7.594
                          ],
                          [
                            -48.613,
                            -7.594
                          ],
                          [
                            -53.096,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 17",
                    "hd": false
                  },
                  {
                    "ind": 17,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -69.359,
                            7.594
                          ],
                          [
                            -59.12,
                            7.594
                          ],
                          [
                            -59.12,
                            4.917
                          ],
                          [
                            -65.939,
                            4.917
                          ],
                          [
                            -65.939,
                            1.137
                          ],
                          [
                            -60.757,
                            1.137
                          ],
                          [
                            -60.757,
                            -1.37
                          ],
                          [
                            -65.939,
                            -1.37
                          ],
                          [
                            -65.939,
                            -4.917
                          ],
                          [
                            -59.46,
                            -4.917
                          ],
                          [
                            -59.46,
                            -7.594
                          ],
                          [
                            -69.359,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 18",
                    "hd": false
                  },
                  {
                    "ind": 18,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.55
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.72,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.657,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.466
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -80.04,
                            -0.605
                          ],
                          [
                            -80.04,
                            -4.96
                          ],
                          [
                            -78.107,
                            -4.96
                          ],
                          [
                            -75.516,
                            -2.878
                          ],
                          [
                            -75.516,
                            -2.794
                          ],
                          [
                            -78.107,
                            -0.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 19",
                    "hd": false
                  },
                  {
                    "ind": 19,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.294
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.589,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.785,
                            -0.531
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.144
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -83.46,
                            7.594
                          ],
                          [
                            -80.04,
                            7.594
                          ],
                          [
                            -80.04,
                            1.732
                          ],
                          [
                            -78.553,
                            1.732
                          ],
                          [
                            -74.921,
                            7.594
                          ],
                          [
                            -71.266,
                            7.594
                          ],
                          [
                            -75.281,
                            1.137
                          ],
                          [
                            -72.16,
                            -2.9
                          ],
                          [
                            -72.16,
                            -2.984
                          ],
                          [
                            -78.021,
                            -7.594
                          ],
                          [
                            -83.46,
                            -7.594
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 20",
                    "hd": false
                  },
                  {
                    "ind": 20,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.971,
                            0
                          ],
                          [
                            -0.382,
                            3.76
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.89,
                            0
                          ],
                          [
                            0,
                            3.143
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.401,
                            0
                          ],
                          [
                            -0.255,
                            -1.827
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.653,
                            0
                          ],
                          [
                            0,
                            -4.609
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            3.738,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.276,
                            1.954
                          ],
                          [
                            -2.507,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.144
                          ],
                          [
                            1.911,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.361,
                            -3.739
                          ],
                          [
                            -4.312,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            4.673
                          ]
                        ],
                        "v": [
                          [
                            -92.337,
                            7.827
                          ],
                          [
                            -85.52,
                            2.135
                          ],
                          [
                            -88.896,
                            2.135
                          ],
                          [
                            -92.38,
                            5.044
                          ],
                          [
                            -96.331,
                            0.074
                          ],
                          [
                            -96.331,
                            -0.096
                          ],
                          [
                            -92.402,
                            -5.109
                          ],
                          [
                            -89.215,
                            -2.305
                          ],
                          [
                            -85.689,
                            -2.305
                          ],
                          [
                            -92.423,
                            -7.827
                          ],
                          [
                            -99.964,
                            -0.075
                          ],
                          [
                            -99.964,
                            0.096
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 21",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Merge Paths 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        110.712,
                        22.544
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.719
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.718
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.718
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.719
                          ]
                        ],
                        "v": [
                          [
                            -107.388,
                            -22
                          ],
                          [
                            107.388,
                            -22
                          ],
                          [
                            110.5,
                            -18.888
                          ],
                          [
                            110.5,
                            18.888
                          ],
                          [
                            107.388,
                            22
                          ],
                          [
                            -107.388,
                            22
                          ],
                          [
                            -110.5,
                            18.888
                          ],
                          [
                            -110.5,
                            -18.888
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.118000000598,
                        0.231000010173,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        110.5,
                        22
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.5,
                        "y": 1
                      },
                      "o": {
                        "x": 0.5,
                        "y": 0
                      },
                      "t": 110,
                      "s": [
                        143.605,
                        22
                      ],
                      "to": [
                        -5.518,
                        0
                      ],
                      "ti": [
                        5.518,
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": 0.5,
                        "y": 0.5
                      },
                      "o": {
                        "x": 0.5,
                        "y": 0.5
                      },
                      "t": 120,
                      "s": [
                        110.5,
                        22
                      ],
                      "to": [
                        0,
                        0
                      ],
                      "ti": [
                        0,
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": 0.5,
                        "y": 1
                      },
                      "o": {
                        "x": 0.5,
                        "y": 0
                      },
                      "t": 280,
                      "s": [
                        110.5,
                        22
                      ],
                      "to": [
                        -2,
                        0
                      ],
                      "ti": [
                        2,
                        0
                      ]
                    },
                    {
                      "t": 290.000011811942,
                      "s": [
                        98.5,
                        22
                      ]
                    }
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    110.5,
                    22
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 115,
                      "s": [
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 120,
                      "s": [
                        100
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 285,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 290.000011811942,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Blank PDF",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            65.527,
                            7.583
                          ],
                          [
                            75.764,
                            7.583
                          ],
                          [
                            75.764,
                            4.907
                          ],
                          [
                            68.947,
                            4.907
                          ],
                          [
                            68.947,
                            1.126
                          ],
                          [
                            74.13,
                            1.126
                          ],
                          [
                            74.13,
                            -1.38
                          ],
                          [
                            68.947,
                            -1.38
                          ],
                          [
                            68.947,
                            -4.928
                          ],
                          [
                            75.424,
                            -4.928
                          ],
                          [
                            75.424,
                            -7.605
                          ],
                          [
                            65.527,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            55.997,
                            7.583
                          ],
                          [
                            59.46,
                            7.583
                          ],
                          [
                            59.46,
                            -4.928
                          ],
                          [
                            63.559,
                            -4.928
                          ],
                          [
                            63.559,
                            -7.605
                          ],
                          [
                            51.897,
                            -7.605
                          ],
                          [
                            51.897,
                            -4.928
                          ],
                          [
                            55.997,
                            -4.928
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 2",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            45.242,
                            -4.8
                          ],
                          [
                            47.238,
                            1.763
                          ],
                          [
                            43.223,
                            1.763
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 3",
                    "hd": false
                  },
                  {
                    "ind": 3,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            38.212,
                            7.583
                          ],
                          [
                            41.438,
                            7.583
                          ],
                          [
                            42.479,
                            4.206
                          ],
                          [
                            47.981,
                            4.206
                          ],
                          [
                            49.022,
                            7.583
                          ],
                          [
                            52.613,
                            7.583
                          ],
                          [
                            47.684,
                            -7.605
                          ],
                          [
                            43.202,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 4",
                    "hd": false
                  },
                  {
                    "ind": 4,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            27.583,
                            7.583
                          ],
                          [
                            37.204,
                            7.583
                          ],
                          [
                            37.204,
                            4.886
                          ],
                          [
                            31.023,
                            4.886
                          ],
                          [
                            31.023,
                            -7.605
                          ],
                          [
                            27.583,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 5",
                    "hd": false
                  },
                  {
                    "ind": 5,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.615
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.678,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.636,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.508
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            17.877,
                            -0.34
                          ],
                          [
                            17.877,
                            -4.992
                          ],
                          [
                            19.618,
                            -4.992
                          ],
                          [
                            22.188,
                            -2.74
                          ],
                          [
                            22.188,
                            -2.655
                          ],
                          [
                            19.618,
                            -0.34
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 6",
                    "hd": false
                  },
                  {
                    "ind": 6,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.207
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.695,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.463,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.208
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            14.457,
                            7.583
                          ],
                          [
                            17.877,
                            7.583
                          ],
                          [
                            17.877,
                            2.061
                          ],
                          [
                            19.809,
                            2.061
                          ],
                          [
                            25.503,
                            -2.676
                          ],
                          [
                            25.503,
                            -2.761
                          ],
                          [
                            19.704,
                            -7.605
                          ],
                          [
                            14.457,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 7",
                    "hd": false
                  },
                  {
                    "ind": 7,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -4.725,
                            7.583
                          ],
                          [
                            -1.645,
                            7.583
                          ],
                          [
                            -1.645,
                            -3.08
                          ],
                          [
                            2.582,
                            7.583
                          ],
                          [
                            3.708,
                            7.583
                          ],
                          [
                            7.914,
                            -3.08
                          ],
                          [
                            7.914,
                            7.583
                          ],
                          [
                            11.334,
                            7.583
                          ],
                          [
                            11.334,
                            -7.605
                          ],
                          [
                            6.873,
                            -7.605
                          ],
                          [
                            3.368,
                            1.848
                          ],
                          [
                            -0.18,
                            -7.605
                          ],
                          [
                            -4.725,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 8",
                    "hd": false
                  },
                  {
                    "ind": 8,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -17.188,
                            7.583
                          ],
                          [
                            -6.949,
                            7.583
                          ],
                          [
                            -6.949,
                            4.907
                          ],
                          [
                            -13.768,
                            4.907
                          ],
                          [
                            -13.768,
                            1.126
                          ],
                          [
                            -8.585,
                            1.126
                          ],
                          [
                            -8.585,
                            -1.38
                          ],
                          [
                            -13.768,
                            -1.38
                          ],
                          [
                            -13.768,
                            -4.928
                          ],
                          [
                            -7.288,
                            -4.928
                          ],
                          [
                            -7.288,
                            -7.605
                          ],
                          [
                            -17.188,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 9",
                    "hd": false
                  },
                  {
                    "ind": 9,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -26.716,
                            7.583
                          ],
                          [
                            -23.255,
                            7.583
                          ],
                          [
                            -23.255,
                            -4.928
                          ],
                          [
                            -19.154,
                            -4.928
                          ],
                          [
                            -19.154,
                            -7.605
                          ],
                          [
                            -30.816,
                            -7.605
                          ],
                          [
                            -30.816,
                            -4.928
                          ],
                          [
                            -26.716,
                            -4.928
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 10",
                    "hd": false
                  },
                  {
                    "ind": 10,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -46.689,
                            7.583
                          ],
                          [
                            -36.451,
                            7.583
                          ],
                          [
                            -36.451,
                            4.907
                          ],
                          [
                            -43.27,
                            4.907
                          ],
                          [
                            -43.27,
                            1.126
                          ],
                          [
                            -38.087,
                            1.126
                          ],
                          [
                            -38.087,
                            -1.38
                          ],
                          [
                            -43.27,
                            -1.38
                          ],
                          [
                            -43.27,
                            -4.928
                          ],
                          [
                            -36.79,
                            -4.928
                          ],
                          [
                            -36.79,
                            -7.605
                          ],
                          [
                            -46.689,
                            -7.605
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 11",
                    "hd": false
                  },
                  {
                    "ind": 11,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -4.163,
                            0
                          ],
                          [
                            0,
                            2.698
                          ],
                          [
                            3.675,
                            0.467
                          ],
                          [
                            0,
                            1.083
                          ],
                          [
                            -1.508,
                            0
                          ],
                          [
                            -0.213,
                            -1.381
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.42,
                            0
                          ],
                          [
                            0,
                            -2.592
                          ],
                          [
                            -3.887,
                            -0.509
                          ],
                          [
                            0,
                            -1.211
                          ],
                          [
                            1.508,
                            0
                          ],
                          [
                            0.149,
                            1.36
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            3.59,
                            0
                          ],
                          [
                            0,
                            -3.144
                          ],
                          [
                            -2.336,
                            -0.341
                          ],
                          [
                            0,
                            -1.02
                          ],
                          [
                            1.508,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.276,
                            -3.017
                          ],
                          [
                            -3.356,
                            0
                          ],
                          [
                            0,
                            2.931
                          ],
                          [
                            2.231,
                            0.34
                          ],
                          [
                            0,
                            1.189
                          ],
                          [
                            -2.252,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.191,
                            3.037
                          ]
                        ],
                        "v": [
                          [
                            -54.794,
                            7.817
                          ],
                          [
                            -48.995,
                            2.974
                          ],
                          [
                            -54.561,
                            -1.635
                          ],
                          [
                            -57.387,
                            -3.568
                          ],
                          [
                            -55.113,
                            -5.289
                          ],
                          [
                            -52.585,
                            -3.271
                          ],
                          [
                            -49.421,
                            -3.271
                          ],
                          [
                            -55.113,
                            -7.817
                          ],
                          [
                            -60.637,
                            -3.292
                          ],
                          [
                            -55.156,
                            1.317
                          ],
                          [
                            -52.288,
                            3.293
                          ],
                          [
                            -54.794,
                            5.311
                          ],
                          [
                            -57.768,
                            2.825
                          ],
                          [
                            -61.061,
                            2.825
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 12",
                    "hd": false
                  },
                  {
                    "ind": 12,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -3.994,
                            0
                          ],
                          [
                            0,
                            4.143
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.039,
                            0
                          ],
                          [
                            0,
                            2.529
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            4.099,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.783
                          ],
                          [
                            -2.082,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            4.035
                          ]
                        ],
                        "v": [
                          [
                            -69.497,
                            7.817
                          ],
                          [
                            -63.082,
                            1.529
                          ],
                          [
                            -63.082,
                            -7.605
                          ],
                          [
                            -66.546,
                            -7.605
                          ],
                          [
                            -66.546,
                            1.317
                          ],
                          [
                            -69.477,
                            5.077
                          ],
                          [
                            -72.301,
                            1.444
                          ],
                          [
                            -72.301,
                            -7.605
                          ],
                          [
                            -75.764,
                            -7.605
                          ],
                          [
                            -75.764,
                            1.657
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 13",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        92.995,
                        22.555
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.719
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.718
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.718
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.719,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.719
                          ]
                        ],
                        "v": [
                          [
                            -89.388,
                            -22
                          ],
                          [
                            89.388,
                            -22
                          ],
                          [
                            92.5,
                            -18.888
                          ],
                          [
                            92.5,
                            18.888
                          ],
                          [
                            89.388,
                            22
                          ],
                          [
                            -89.388,
                            22
                          ],
                          [
                            -92.5,
                            18.888
                          ],
                          [
                            -92.5,
                            -18.888
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -92.5,
                            -22
                          ],
                          [
                            92.5,
                            -22
                          ],
                          [
                            92.5,
                            22
                          ],
                          [
                            -92.5,
                            22
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 2",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.118000000598,
                        0.231000010173,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        92.5,
                        22
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.5,
                        "y": 1
                      },
                      "o": {
                        "x": 0.5,
                        "y": 0
                      },
                      "t": 0,
                      "s": [
                        143.605,
                        22
                      ],
                      "to": [
                        -3.018,
                        0
                      ],
                      "ti": [
                        3.018,
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": 0.5,
                        "y": 0.5
                      },
                      "o": {
                        "x": 0.5,
                        "y": 0.5
                      },
                      "t": 10,
                      "s": [
                        125.5,
                        22
                      ],
                      "to": [
                        0,
                        0
                      ],
                      "ti": [
                        0,
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": 0.5,
                        "y": 1
                      },
                      "o": {
                        "x": 0.5,
                        "y": 0
                      },
                      "t": 100,
                      "s": [
                        125.5,
                        22
                      ],
                      "to": [
                        -4.5,
                        0
                      ],
                      "ti": [
                        4.5,
                        0
                      ]
                    },
                    {
                      "t": 110.000004480392,
                      "s": [
                        98.5,
                        22
                      ]
                    }
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    92.5,
                    22
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 5,
                      "s": [
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 10,
                      "s": [
                        100
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 105,
                      "s": [
                        100
                      ]
                    },
                    {
                      "t": 110.000004480392,
                      "s": [
                        0
                      ]
                    }
                  ]
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Template",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 0,
        "op": 1077.00004386711,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 13,
        "ty": 2,
        "nm": "Management Accounts (1).png",
        "cl": "png",
        "refId": "image_4",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.5
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.5
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 100,
                "s": [
                  100
                ]
              },
              {
                "t": 110.000004480392,
                "s": [
                  0
                ]
              }
            ]
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.1
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.9
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 40,
                "s": [
                  0
                ]
              },
              {
                "t": 80.0000032584668,
                "s": [
                  3
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.1,
                  "y": 1
                },
                "o": {
                  "x": 0.9,
                  "y": 0
                },
                "t": 40,
                "s": [
                  366,
                  928,
                  0
                ],
                "to": [
                  0,
                  -82,
                  0
                ],
                "ti": [
                  0,
                  82,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.5,
                  "y": 0.5
                },
                "o": {
                  "x": 0.9,
                  "y": 0.9
                },
                "t": 80,
                "s": [
                  366,
                  436,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.5,
                  "y": 1
                },
                "o": {
                  "x": 0.5,
                  "y": 0
                },
                "t": 100,
                "s": [
                  366,
                  436,
                  0
                ],
                "to": [
                  0,
                  7.667,
                  0
                ],
                "ti": [
                  0,
                  -7.667,
                  0
                ]
              },
              {
                "t": 120.0000048877,
                "s": [
                  366,
                  482,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              255,
              291,
              0
            ]
          }
        },
        "ao": 0,
        "ip": 40.0000016292334,
        "op": 1117.00004549634,
        "st": 40.0000016292334,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 14,
        "ty": 2,
        "nm": "Executive Summary (1).png",
        "cl": "png",
        "refId": "image_5",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.5
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.5
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 100,
                "s": [
                  100
                ]
              },
              {
                "t": 110.000004480392,
                "s": [
                  0
                ]
              }
            ]
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.1
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.9
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 20,
                "s": [
                  0
                ]
              },
              {
                "t": 60.0000024438501,
                "s": [
                  -2
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.1,
                  "y": 1
                },
                "o": {
                  "x": 0.9,
                  "y": 0
                },
                "t": 20,
                "s": [
                  300,
                  971,
                  0
                ],
                "to": [
                  0,
                  -87.5,
                  0
                ],
                "ti": [
                  0,
                  7.333,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.66,
                  "y": 0.66
                },
                "o": {
                  "x": 0.9,
                  "y": 0.9
                },
                "t": 60,
                "s": [
                  300,
                  446,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.583,
                  "y": 1
                },
                "o": {
                  "x": 0.266,
                  "y": 0
                },
                "t": 100,
                "s": [
                  300,
                  446,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "t": 120.0000048877,
                "s": [
                  300,
                  496,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              247.5,
              282,
              0
            ]
          }
        },
        "ao": 0,
        "ip": 20.0000008146167,
        "op": 1097.00004468173,
        "st": 20.0000008146167,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 15,
        "ty": 2,
        "nm": "Business Plan (1).png",
        "cl": "png",
        "refId": "image_6",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.5
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.5
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 100,
                "s": [
                  100
                ]
              },
              {
                "t": 110.000004480392,
                "s": [
                  0
                ]
              }
            ]
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.5
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 0,
                "s": [
                  0
                ]
              },
              {
                "t": 40.0000016292334,
                "s": [
                  -6
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.1,
                  "y": 1
                },
                "o": {
                  "x": 0.9,
                  "y": 0
                },
                "t": 0,
                "s": [
                  242,
                  936.037,
                  0
                ],
                "to": [
                  0,
                  -12.391,
                  0
                ],
                "ti": [
                  0,
                  10.703,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.623,
                  "y": 0.623
                },
                "o": {
                  "x": 0.9,
                  "y": 0.9
                },
                "t": 40,
                "s": [
                  242,
                  466,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.606,
                  "y": 1
                },
                "o": {
                  "x": 0.28,
                  "y": 0
                },
                "t": 100,
                "s": [
                  242,
                  466,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "t": 120.0000048877,
                "s": [
                  242,
                  527,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              247.5,
              282,
              0
            ]
          }
        },
        "ao": 0,
        "ip": 0,
        "op": 1077.00004386711,
        "st": 0,
        "bm": 0
      }
    ],
    "markers": [
      
    ]
  };

  export const emailAnimationData = {
    "v": "5.7.1",
    "fr": 24,
    "ip": 20,
    "op": 68,
    "w": 500,
    "h": 500,
    "nm": "3343837",
    "ddd": 0,
    "assets": [
      {
        "id": "image_0",
        "w": 121,
        "h": 142,
        "u": "",
        "p": "data:image/png;base64,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",
        "e": 1
      },
      {
        "id": "image_1",
        "w": 453,
        "h": 2,
        "u": "",
        "p": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcUAAAAEAgMAAACCbMyyAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAACXBIWXMAAAABAAAAAQBPJcTWAAAADFBMVEUnMjgmMjhHcEwoNDhg1hBDAAAABHRSTlPAgABAUjfSjAAAAB9JREFUGNNjWEVv0MAQShA4MBAPGAkbd4BhAHxJfysBLtX6NJm7U6kAAAAASUVORK5CYII=",
        "e": 1
      }
    ],
    "layers": [
      {
        "ddd": 0,
        "ind": 1,
        "ty": 2,
        "nm": "Plant",
        "refId": "image_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              87.507,
              396.191,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              60.483,
              70.922,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "ip": 0,
        "op": 720,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 2,
        "ty": 4,
        "nm": "Character Outlines",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              363.274,
              332.56,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              84.836,
              141.542,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.144,
                        0.009
                      ],
                      [
                        -0.162,
                        2.4
                      ],
                      [
                        -0.144,
                        -0.01
                      ],
                      [
                        0.162,
                        -2.4
                      ]
                    ],
                    "o": [
                      [
                        -0.144,
                        -0.01
                      ],
                      [
                        0.162,
                        -2.401
                      ],
                      [
                        0.143,
                        0.009
                      ],
                      [
                        -0.162,
                        2.4
                      ]
                    ],
                    "v": [
                      [
                        -0.293,
                        4.346
                      ],
                      [
                        -0.259,
                        -0.018
                      ],
                      [
                        0.294,
                        -4.345
                      ],
                      [
                        0.26,
                        0.018
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    117.669,
                    185.937
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.045,
                        -0.003
                      ],
                      [
                        0.008,
                        -0.318
                      ],
                      [
                        0.053,
                        -0.605
                      ],
                      [
                        0.585,
                        -2.097
                      ],
                      [
                        1.56,
                        -2.434
                      ],
                      [
                        2.795,
                        -1.833
                      ],
                      [
                        2.894,
                        -0.204
                      ],
                      [
                        2.028,
                        0.795
                      ],
                      [
                        0.906,
                        0.808
                      ],
                      [
                        0.204,
                        0.248
                      ],
                      [
                        -0.013,
                        0.012
                      ],
                      [
                        -0.938,
                        -0.751
                      ],
                      [
                        -2.004,
                        -0.753
                      ],
                      [
                        -2.815,
                        0.24
                      ],
                      [
                        -2.732,
                        1.775
                      ],
                      [
                        -1.532,
                        2.374
                      ],
                      [
                        -0.637,
                        2.048
                      ],
                      [
                        -0.175,
                        1.192
                      ]
                    ],
                    "o": [
                      [
                        0.018,
                        0.001
                      ],
                      [
                        -0.003,
                        0.321
                      ],
                      [
                        -0.113,
                        1.207
                      ],
                      [
                        -0.6,
                        2.087
                      ],
                      [
                        -1.543,
                        2.436
                      ],
                      [
                        -2.802,
                        1.819
                      ],
                      [
                        -2.899,
                        0.222
                      ],
                      [
                        -2.033,
                        -0.815
                      ],
                      [
                        -0.453,
                        -0.41
                      ],
                      [
                        -0.212,
                        -0.239
                      ],
                      [
                        0.041,
                        -0.039
                      ],
                      [
                        0.934,
                        0.749
                      ],
                      [
                        2.001,
                        0.734
                      ],
                      [
                        2.809,
                        -0.225
                      ],
                      [
                        2.728,
                        -1.789
                      ],
                      [
                        1.552,
                        -2.371
                      ],
                      [
                        0.622,
                        -2.056
                      ],
                      [
                        0.173,
                        -1.193
                      ]
                    ],
                    "v": [
                      [
                        16.363,
                        -11.921
                      ],
                      [
                        16.377,
                        -11.433
                      ],
                      [
                        16.289,
                        -10.039
                      ],
                      [
                        15.335,
                        -4.99
                      ],
                      [
                        12.226,
                        1.976
                      ],
                      [
                        5.674,
                        8.621
                      ],
                      [
                        -3.129,
                        11.702
                      ],
                      [
                        -10.671,
                        10.583
                      ],
                      [
                        -15.076,
                        7.928
                      ],
                      [
                        -16.069,
                        6.94
                      ],
                      [
                        -16.372,
                        6.559
                      ],
                      [
                        -14.947,
                        7.772
                      ],
                      [
                        -10.54,
                        10.238
                      ],
                      [
                        -3.168,
                        11.225
                      ],
                      [
                        5.389,
                        8.185
                      ],
                      [
                        11.823,
                        1.714
                      ],
                      [
                        14.982,
                        -5.095
                      ],
                      [
                        16.088,
                        -10.064
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    114.292,
                    176.851
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -3.484,
                        -8.804
                      ],
                      [
                        -2.479,
                        -1.196
                      ],
                      [
                        -2.628,
                        0.724
                      ],
                      [
                        -6.144,
                        2.865
                      ],
                      [
                        -1.155,
                        2.204
                      ],
                      [
                        0.786,
                        2.86
                      ],
                      [
                        3.137,
                        8.994
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0.132,
                        9.467
                      ],
                      [
                        1.013,
                        2.559
                      ],
                      [
                        2.455,
                        1.185
                      ],
                      [
                        6.535,
                        -1.802
                      ],
                      [
                        2.255,
                        -1.052
                      ],
                      [
                        1.377,
                        -2.627
                      ],
                      [
                        -2.524,
                        -9.186
                      ],
                      [
                        -0.653,
                        -1.875
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -22.257,
                        -6.385
                      ],
                      [
                        -16.773,
                        21.325
                      ],
                      [
                        -11.95,
                        27.781
                      ],
                      [
                        -3.957,
                        27.627
                      ],
                      [
                        15.107,
                        20.61
                      ],
                      [
                        20.88,
                        16.1
                      ],
                      [
                        20.745,
                        7.423
                      ],
                      [
                        12.25,
                        -19.858
                      ],
                      [
                        8.596,
                        -28.966
                      ]
                    ],
                    "c": false
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    118.692,
                    183.102
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        33.719,
                        7.414
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -30.667,
                        83.882
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        30.88,
                        -45.534
                      ],
                      [
                        -30.88,
                        38.218
                      ],
                      [
                        -30.323,
                        33.919
                      ],
                      [
                        26.407,
                        -45.633
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    124.905,
                    139.52
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 4",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -3.903,
                        -0.426
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.046,
                        -0.521
                      ],
                      [
                        0.178,
                        -2.517
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.998,
                        0.329
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.159,
                        -0.146
                      ],
                      [
                        -1.263,
                        0.629
                      ],
                      [
                        -0.245,
                        3.458
                      ]
                    ],
                    "v": [
                      [
                        -37.604,
                        -40.174
                      ],
                      [
                        -39.883,
                        47.771
                      ],
                      [
                        -34.876,
                        47.771
                      ],
                      [
                        -33.577,
                        -38.286
                      ],
                      [
                        -29.613,
                        -42.982
                      ],
                      [
                        18.826,
                        -37.372
                      ],
                      [
                        34.124,
                        47.771
                      ],
                      [
                        39.883,
                        47.771
                      ],
                      [
                        24.314,
                        -40.609
                      ],
                      [
                        -31.378,
                        -47.625
                      ],
                      [
                        -34.778,
                        -47.111
                      ],
                      [
                        -37.527,
                        -42.708
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.922000002394,
                    0.922000002394,
                    0.922000002394,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    79.732,
                    228.074
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 5",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.009
                      ],
                      [
                        0.236,
                        -0.008
                      ],
                      [
                        0.438,
                        -0.011
                      ],
                      [
                        1.722,
                        -0.021
                      ],
                      [
                        6.223,
                        -0.036
                      ],
                      [
                        3.67,
                        -0.011
                      ],
                      [
                        1.956,
                        -0.004
                      ],
                      [
                        1.006,
                        -0.002
                      ],
                      [
                        0.999,
                        -0.082
                      ],
                      [
                        1.668,
                        -1.307
                      ],
                      [
                        0.732,
                        -2.068
                      ],
                      [
                        0.193,
                        -1.134
                      ],
                      [
                        0.187,
                        -1.145
                      ],
                      [
                        0.385,
                        -2.351
                      ],
                      [
                        2.043,
                        -12.35
                      ],
                      [
                        0.589,
                        -3.475
                      ],
                      [
                        0.165,
                        -0.937
                      ],
                      [
                        0.049,
                        -0.258
                      ],
                      [
                        0.009,
                        0.002
                      ],
                      [
                        -0.03,
                        0.235
                      ],
                      [
                        -0.06,
                        0.434
                      ],
                      [
                        -0.258,
                        1.702
                      ],
                      [
                        -0.972,
                        6.147
                      ],
                      [
                        -3.051,
                        18.805
                      ],
                      [
                        -0.376,
                        2.29
                      ],
                      [
                        -0.185,
                        1.127
                      ],
                      [
                        -0.396,
                        1.086
                      ],
                      [
                        -1.768,
                        1.327
                      ],
                      [
                        -2.093,
                        0.215
                      ],
                      [
                        -1.006,
                        0.003
                      ],
                      [
                        -0.978,
                        -0.001
                      ],
                      [
                        -1.837,
                        -0.004
                      ],
                      [
                        -3.125,
                        -0.009
                      ],
                      [
                        -3.525,
                        -0.019
                      ],
                      [
                        -0.952,
                        -0.01
                      ],
                      [
                        -0.262,
                        -0.007
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.009
                      ],
                      [
                        -0.262,
                        0.007
                      ],
                      [
                        -0.952,
                        0.011
                      ],
                      [
                        -3.525,
                        0.019
                      ],
                      [
                        -3.125,
                        0.009
                      ],
                      [
                        -1.837,
                        0.005
                      ],
                      [
                        -0.978,
                        0.002
                      ],
                      [
                        -1.004,
                        0.006
                      ],
                      [
                        -2.007,
                        0.213
                      ],
                      [
                        -1.69,
                        1.274
                      ],
                      [
                        -0.375,
                        1.033
                      ],
                      [
                        -0.184,
                        1.127
                      ],
                      [
                        -0.375,
                        2.29
                      ],
                      [
                        -3.11,
                        18.796
                      ],
                      [
                        -1.04,
                        6.135
                      ],
                      [
                        -0.299,
                        1.695
                      ],
                      [
                        -0.082,
                        0.431
                      ],
                      [
                        -0.047,
                        0.231
                      ],
                      [
                        -0.009,
                        -0.001
                      ],
                      [
                        0.035,
                        -0.259
                      ],
                      [
                        0.142,
                        -0.94
                      ],
                      [
                        0.55,
                        -3.482
                      ],
                      [
                        2.005,
                        -12.356
                      ],
                      [
                        0.386,
                        -2.351
                      ],
                      [
                        0.187,
                        -1.145
                      ],
                      [
                        0.193,
                        -1.115
                      ],
                      [
                        0.767,
                        -2.163
                      ],
                      [
                        1.745,
                        -1.361
                      ],
                      [
                        1.06,
                        -0.083
                      ],
                      [
                        1.006,
                        0.002
                      ],
                      [
                        1.956,
                        0.004
                      ],
                      [
                        3.67,
                        0.012
                      ],
                      [
                        6.223,
                        0.035
                      ],
                      [
                        1.722,
                        0.022
                      ],
                      [
                        0.438,
                        0.012
                      ],
                      [
                        0.236,
                        0.008
                      ]
                    ],
                    "v": [
                      [
                        32.688,
                        -44.602
                      ],
                      [
                        32.331,
                        -44.576
                      ],
                      [
                        31.285,
                        -44.548
                      ],
                      [
                        27.263,
                        -44.499
                      ],
                      [
                        12.469,
                        -44.416
                      ],
                      [
                        2.254,
                        -44.385
                      ],
                      [
                        -3.437,
                        -44.372
                      ],
                      [
                        -6.413,
                        -44.367
                      ],
                      [
                        -9.445,
                        -44.303
                      ],
                      [
                        -15.132,
                        -42.035
                      ],
                      [
                        -18.862,
                        -36.864
                      ],
                      [
                        -19.566,
                        -33.589
                      ],
                      [
                        -20.123,
                        -30.18
                      ],
                      [
                        -21.262,
                        -23.216
                      ],
                      [
                        -29.229,
                        24.941
                      ],
                      [
                        -31.702,
                        39.526
                      ],
                      [
                        -32.4,
                        43.487
                      ],
                      [
                        -32.595,
                        44.516
                      ],
                      [
                        -32.678,
                        44.862
                      ],
                      [
                        -32.647,
                        44.507
                      ],
                      [
                        -32.504,
                        43.47
                      ],
                      [
                        -31.902,
                        39.495
                      ],
                      [
                        -29.592,
                        24.883
                      ],
                      [
                        -21.776,
                        -23.3
                      ],
                      [
                        -20.633,
                        -30.264
                      ],
                      [
                        -20.074,
                        -33.673
                      ],
                      [
                        -19.344,
                        -37.031
                      ],
                      [
                        -15.435,
                        -42.428
                      ],
                      [
                        -9.492,
                        -44.781
                      ],
                      [
                        -6.413,
                        -44.835
                      ],
                      [
                        -3.437,
                        -44.83
                      ],
                      [
                        2.254,
                        -44.817
                      ],
                      [
                        12.469,
                        -44.785
                      ],
                      [
                        27.263,
                        -44.703
                      ],
                      [
                        31.285,
                        -44.654
                      ],
                      [
                        32.331,
                        -44.627
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.16862745098039217,
                    0.21176470588235294,
                    0.28627450980392155,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    135.849,
                    142.924
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 6",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -2.814,
                        10.357
                      ],
                      [
                        -3.207,
                        1.939
                      ],
                      [
                        -2.792,
                        -0.06
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.6,
                        -3.756
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        7.504,
                        0.327
                      ],
                      [
                        0.391,
                        -1.967
                      ],
                      [
                        0.152,
                        0.124
                      ],
                      [
                        -5.654,
                        -0.344
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        1.548,
                        -5.696
                      ],
                      [
                        2.39,
                        -1.446
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        3.802,
                        0.083
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -15.277,
                        -0.04
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -4.693,
                        -0.206
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -4.401,
                        -3.566
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -9.587,
                        37.421
                      ],
                      [
                        1.042,
                        -33.913
                      ],
                      [
                        9.707,
                        -44.986
                      ],
                      [
                        17.642,
                        -47.09
                      ],
                      [
                        59.154,
                        -46.178
                      ],
                      [
                        65.208,
                        -38.917
                      ],
                      [
                        51.452,
                        47.15
                      ],
                      [
                        0.434,
                        47.15
                      ],
                      [
                        -55.969,
                        41.483
                      ],
                      [
                        -61.408,
                        45.049
                      ],
                      [
                        -61.408,
                        45.049
                      ],
                      [
                        -57.529,
                        34.501
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.22745098039215686,
                    0.2823529411764706,
                    0.3803921568627451,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    103.613,
                    140.317
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 7",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -3.005,
                        0.263
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        18.782,
                        -3.94
                      ],
                      [
                        0.251,
                        -3.458
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        3.005,
                        -0.263
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.25,
                        3.457
                      ]
                    ],
                    "v": [
                      [
                        -37.04,
                        -37.364
                      ],
                      [
                        -37.831,
                        50.581
                      ],
                      [
                        -32.822,
                        50.581
                      ],
                      [
                        -32.449,
                        -35.614
                      ],
                      [
                        -29.193,
                        -39.814
                      ],
                      [
                        18.811,
                        -37.809
                      ],
                      [
                        32.072,
                        50.581
                      ],
                      [
                        37.831,
                        50.581
                      ],
                      [
                        24.878,
                        -37.799
                      ],
                      [
                        -31.698,
                        -46.641
                      ],
                      [
                        -36.456,
                        -44.015
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    130.186,
                    225.264
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 8",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 8,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.04,
                        -0.012
                      ],
                      [
                        0.164,
                        -0.304
                      ],
                      [
                        0.635,
                        -0.146
                      ],
                      [
                        0.452,
                        0.758
                      ],
                      [
                        -0.048,
                        0.437
                      ],
                      [
                        -0.069,
                        0.412
                      ],
                      [
                        0.456,
                        0.524
                      ],
                      [
                        0.532,
                        0.04
                      ],
                      [
                        0.041,
                        0.085
                      ],
                      [
                        -1.263,
                        0.028
                      ],
                      [
                        -0.564,
                        -0.621
                      ],
                      [
                        0.198,
                        -0.932
                      ],
                      [
                        -0.338,
                        -0.575
                      ],
                      [
                        -0.491,
                        0.08
                      ],
                      [
                        -0.188,
                        0.227
                      ]
                    ],
                    "o": [
                      [
                        0.028,
                        0.006
                      ],
                      [
                        -0.16,
                        0.293
                      ],
                      [
                        -0.629,
                        0.153
                      ],
                      [
                        -0.231,
                        -0.38
                      ],
                      [
                        0.043,
                        -0.443
                      ],
                      [
                        0.166,
                        -0.804
                      ],
                      [
                        -0.453,
                        -0.533
                      ],
                      [
                        -1.097,
                        -0.073
                      ],
                      [
                        -0.055,
                        -0.012
                      ],
                      [
                        0.606,
                        -0.008
                      ],
                      [
                        0.567,
                        0.589
                      ],
                      [
                        -0.172,
                        0.89
                      ],
                      [
                        0.318,
                        0.582
                      ],
                      [
                        0.512,
                        -0.071
                      ],
                      [
                        0.194,
                        -0.235
                      ]
                    ],
                    "v": [
                      [
                        3.574,
                        1.935
                      ],
                      [
                        3.448,
                        2.442
                      ],
                      [
                        2.29,
                        3.294
                      ],
                      [
                        0.345,
                        2.403
                      ],
                      [
                        0.102,
                        1.103
                      ],
                      [
                        0.334,
                        -0.17
                      ],
                      [
                        -0.223,
                        -2.262
                      ],
                      [
                        -1.829,
                        -3.071
                      ],
                      [
                        -3.557,
                        -2.703
                      ],
                      [
                        -1.815,
                        -3.439
                      ],
                      [
                        0.134,
                        -2.584
                      ],
                      [
                        0.847,
                        -0.086
                      ],
                      [
                        0.761,
                        2.164
                      ],
                      [
                        2.224,
                        2.932
                      ],
                      [
                        3.28,
                        2.329
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    119.366,
                    67.567
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 10",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 9,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.04,
                        -0.012
                      ],
                      [
                        0.164,
                        -0.304
                      ],
                      [
                        0.635,
                        -0.146
                      ],
                      [
                        0.452,
                        0.758
                      ],
                      [
                        -0.047,
                        0.438
                      ],
                      [
                        -0.068,
                        0.412
                      ],
                      [
                        0.457,
                        0.525
                      ],
                      [
                        0.531,
                        0.04
                      ],
                      [
                        0.04,
                        0.085
                      ],
                      [
                        -1.262,
                        0.028
                      ],
                      [
                        -0.564,
                        -0.621
                      ],
                      [
                        0.198,
                        -0.932
                      ],
                      [
                        -0.338,
                        -0.575
                      ],
                      [
                        -0.491,
                        0.08
                      ],
                      [
                        -0.187,
                        0.227
                      ]
                    ],
                    "o": [
                      [
                        0.028,
                        0.006
                      ],
                      [
                        -0.159,
                        0.293
                      ],
                      [
                        -0.629,
                        0.153
                      ],
                      [
                        -0.232,
                        -0.38
                      ],
                      [
                        0.044,
                        -0.442
                      ],
                      [
                        0.167,
                        -0.804
                      ],
                      [
                        -0.452,
                        -0.532
                      ],
                      [
                        -1.098,
                        -0.074
                      ],
                      [
                        -0.056,
                        -0.012
                      ],
                      [
                        0.607,
                        -0.008
                      ],
                      [
                        0.567,
                        0.589
                      ],
                      [
                        -0.172,
                        0.89
                      ],
                      [
                        0.318,
                        0.581
                      ],
                      [
                        0.511,
                        -0.071
                      ],
                      [
                        0.194,
                        -0.235
                      ]
                    ],
                    "v": [
                      [
                        3.575,
                        1.935
                      ],
                      [
                        3.448,
                        2.442
                      ],
                      [
                        2.291,
                        3.294
                      ],
                      [
                        0.346,
                        2.403
                      ],
                      [
                        0.102,
                        1.102
                      ],
                      [
                        0.334,
                        -0.17
                      ],
                      [
                        -0.223,
                        -2.263
                      ],
                      [
                        -1.828,
                        -3.071
                      ],
                      [
                        -3.556,
                        -2.703
                      ],
                      [
                        -1.815,
                        -3.439
                      ],
                      [
                        0.135,
                        -2.584
                      ],
                      [
                        0.847,
                        -0.086
                      ],
                      [
                        0.762,
                        2.164
                      ],
                      [
                        2.225,
                        2.932
                      ],
                      [
                        3.28,
                        2.329
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    90.39,
                    69.283
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 11",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 10,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.009,
                        0.041
                      ],
                      [
                        -0.318,
                        -0.136
                      ],
                      [
                        -0.203,
                        -0.619
                      ],
                      [
                        0.714,
                        -0.52
                      ],
                      [
                        0.44,
                        0.008
                      ],
                      [
                        0.416,
                        0.03
                      ],
                      [
                        0.482,
                        -0.502
                      ],
                      [
                        -0.008,
                        -0.533
                      ],
                      [
                        0.081,
                        -0.048
                      ],
                      [
                        0.141,
                        1.256
                      ],
                      [
                        -0.568,
                        0.618
                      ],
                      [
                        -0.946,
                        -0.111
                      ],
                      [
                        -0.541,
                        0.39
                      ],
                      [
                        0.123,
                        0.481
                      ],
                      [
                        0.244,
                        0.167
                      ]
                    ],
                    "o": [
                      [
                        0.002,
                        -0.028
                      ],
                      [
                        0.305,
                        0.133
                      ],
                      [
                        0.208,
                        0.613
                      ],
                      [
                        -0.357,
                        0.264
                      ],
                      [
                        -0.445,
                        -0.003
                      ],
                      [
                        -0.815,
                        -0.092
                      ],
                      [
                        -0.489,
                        0.499
                      ],
                      [
                        0.026,
                        1.1
                      ],
                      [
                        -0.007,
                        0.056
                      ],
                      [
                        -0.064,
                        -0.602
                      ],
                      [
                        0.534,
                        -0.618
                      ],
                      [
                        0.902,
                        0.092
                      ],
                      [
                        0.55,
                        -0.369
                      ],
                      [
                        -0.118,
                        -0.503
                      ],
                      [
                        -0.251,
                        -0.173
                      ]
                    ],
                    "v": [
                      [
                        1.625,
                        -3.761
                      ],
                      [
                        2.141,
                        -3.681
                      ],
                      [
                        3.094,
                        -2.605
                      ],
                      [
                        2.383,
                        -0.587
                      ],
                      [
                        1.109,
                        -0.228
                      ],
                      [
                        -0.18,
                        -0.343
                      ],
                      [
                        -2.212,
                        0.401
                      ],
                      [
                        -2.871,
                        2.074
                      ],
                      [
                        -2.349,
                        3.761
                      ],
                      [
                        -3.238,
                        2.093
                      ],
                      [
                        -2.564,
                        0.075
                      ],
                      [
                        -0.142,
                        -0.863
                      ],
                      [
                        2.107,
                        -0.981
                      ],
                      [
                        2.74,
                        -2.507
                      ],
                      [
                        2.043,
                        -3.503
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    91.465,
                    139.396
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 14",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 11,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.008,
                        0.041
                      ],
                      [
                        -0.319,
                        -0.136
                      ],
                      [
                        -0.203,
                        -0.619
                      ],
                      [
                        0.715,
                        -0.52
                      ],
                      [
                        0.441,
                        0.008
                      ],
                      [
                        0.416,
                        0.03
                      ],
                      [
                        0.482,
                        -0.502
                      ],
                      [
                        -0.009,
                        -0.533
                      ],
                      [
                        0.081,
                        -0.047
                      ],
                      [
                        0.142,
                        1.255
                      ],
                      [
                        -0.568,
                        0.617
                      ],
                      [
                        -0.946,
                        -0.111
                      ],
                      [
                        -0.542,
                        0.39
                      ],
                      [
                        0.124,
                        0.482
                      ],
                      [
                        0.243,
                        0.167
                      ]
                    ],
                    "o": [
                      [
                        0.003,
                        -0.029
                      ],
                      [
                        0.305,
                        0.133
                      ],
                      [
                        0.208,
                        0.613
                      ],
                      [
                        -0.357,
                        0.264
                      ],
                      [
                        -0.444,
                        -0.003
                      ],
                      [
                        -0.816,
                        -0.093
                      ],
                      [
                        -0.49,
                        0.499
                      ],
                      [
                        0.025,
                        1.099
                      ],
                      [
                        -0.006,
                        0.056
                      ],
                      [
                        -0.064,
                        -0.603
                      ],
                      [
                        0.535,
                        -0.619
                      ],
                      [
                        0.902,
                        0.092
                      ],
                      [
                        0.55,
                        -0.369
                      ],
                      [
                        -0.117,
                        -0.502
                      ],
                      [
                        -0.251,
                        -0.172
                      ]
                    ],
                    "v": [
                      [
                        1.624,
                        -3.76
                      ],
                      [
                        2.141,
                        -3.681
                      ],
                      [
                        3.095,
                        -2.605
                      ],
                      [
                        2.382,
                        -0.586
                      ],
                      [
                        1.109,
                        -0.227
                      ],
                      [
                        -0.179,
                        -0.342
                      ],
                      [
                        -2.212,
                        0.402
                      ],
                      [
                        -2.871,
                        2.075
                      ],
                      [
                        -2.349,
                        3.761
                      ],
                      [
                        -3.239,
                        2.094
                      ],
                      [
                        -2.564,
                        0.076
                      ],
                      [
                        -0.141,
                        -0.862
                      ],
                      [
                        2.107,
                        -0.98
                      ],
                      [
                        2.739,
                        -2.507
                      ],
                      [
                        2.043,
                        -3.503
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    92.066,
                    91.899
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 15",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 12,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.039,
                        -0.014
                      ],
                      [
                        0.048,
                        0.341
                      ],
                      [
                        -0.423,
                        0.495
                      ],
                      [
                        -0.814,
                        -0.342
                      ],
                      [
                        -0.222,
                        -0.38
                      ],
                      [
                        -0.19,
                        -0.373
                      ],
                      [
                        -0.68,
                        -0.15
                      ],
                      [
                        -0.451,
                        0.284
                      ],
                      [
                        -0.083,
                        -0.045
                      ],
                      [
                        1,
                        -0.773
                      ],
                      [
                        0.822,
                        0.164
                      ],
                      [
                        0.395,
                        0.867
                      ],
                      [
                        0.614,
                        0.261
                      ],
                      [
                        0.349,
                        -0.355
                      ],
                      [
                        0.016,
                        -0.295
                      ]
                    ],
                    "o": [
                      [
                        -0.026,
                        0.013
                      ],
                      [
                        -0.046,
                        -0.33
                      ],
                      [
                        0.416,
                        -0.496
                      ],
                      [
                        0.411,
                        0.167
                      ],
                      [
                        0.229,
                        0.382
                      ],
                      [
                        0.344,
                        0.745
                      ],
                      [
                        0.68,
                        0.16
                      ],
                      [
                        0.926,
                        -0.592
                      ],
                      [
                        0.052,
                        -0.023
                      ],
                      [
                        -0.482,
                        0.366
                      ],
                      [
                        -0.806,
                        -0.136
                      ],
                      [
                        -0.39,
                        -0.817
                      ],
                      [
                        -0.601,
                        -0.279
                      ],
                      [
                        -0.368,
                        0.362
                      ],
                      [
                        -0.018,
                        0.304
                      ]
                    ],
                    "v": [
                      [
                        -4.149,
                        0.44
                      ],
                      [
                        -4.348,
                        -0.042
                      ],
                      [
                        -3.924,
                        -1.415
                      ],
                      [
                        -1.83,
                        -1.854
                      ],
                      [
                        -0.862,
                        -0.952
                      ],
                      [
                        -0.292,
                        0.21
                      ],
                      [
                        1.4,
                        1.561
                      ],
                      [
                        3.171,
                        1.257
                      ],
                      [
                        4.342,
                        -0.066
                      ],
                      [
                        3.378,
                        1.561
                      ],
                      [
                        1.303,
                        2.031
                      ],
                      [
                        -0.755,
                        0.445
                      ],
                      [
                        -2.023,
                        -1.415
                      ],
                      [
                        -3.657,
                        -1.163
                      ],
                      [
                        -4.146,
                        -0.051
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    96.388,
                    107.769
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 16",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 13,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.009,
                        0.041
                      ],
                      [
                        -0.318,
                        -0.136
                      ],
                      [
                        -0.203,
                        -0.619
                      ],
                      [
                        0.714,
                        -0.52
                      ],
                      [
                        0.44,
                        0.008
                      ],
                      [
                        0.416,
                        0.03
                      ],
                      [
                        0.482,
                        -0.502
                      ],
                      [
                        -0.008,
                        -0.533
                      ],
                      [
                        0.082,
                        -0.047
                      ],
                      [
                        0.141,
                        1.255
                      ],
                      [
                        -0.568,
                        0.617
                      ],
                      [
                        -0.946,
                        -0.111
                      ],
                      [
                        -0.542,
                        0.39
                      ],
                      [
                        0.123,
                        0.482
                      ],
                      [
                        0.244,
                        0.166
                      ]
                    ],
                    "o": [
                      [
                        0.002,
                        -0.029
                      ],
                      [
                        0.305,
                        0.133
                      ],
                      [
                        0.209,
                        0.613
                      ],
                      [
                        -0.357,
                        0.264
                      ],
                      [
                        -0.445,
                        -0.003
                      ],
                      [
                        -0.815,
                        -0.093
                      ],
                      [
                        -0.489,
                        0.499
                      ],
                      [
                        0.026,
                        1.099
                      ],
                      [
                        -0.006,
                        0.057
                      ],
                      [
                        -0.064,
                        -0.603
                      ],
                      [
                        0.534,
                        -0.619
                      ],
                      [
                        0.902,
                        0.092
                      ],
                      [
                        0.55,
                        -0.369
                      ],
                      [
                        -0.118,
                        -0.502
                      ],
                      [
                        -0.251,
                        -0.173
                      ]
                    ],
                    "v": [
                      [
                        1.624,
                        -3.761
                      ],
                      [
                        2.14,
                        -3.681
                      ],
                      [
                        3.094,
                        -2.606
                      ],
                      [
                        2.382,
                        -0.587
                      ],
                      [
                        1.109,
                        -0.228
                      ],
                      [
                        -0.18,
                        -0.343
                      ],
                      [
                        -2.213,
                        0.401
                      ],
                      [
                        -2.872,
                        2.074
                      ],
                      [
                        -2.35,
                        3.76
                      ],
                      [
                        -3.239,
                        2.093
                      ],
                      [
                        -2.564,
                        0.075
                      ],
                      [
                        -0.142,
                        -0.863
                      ],
                      [
                        2.106,
                        -0.981
                      ],
                      [
                        2.739,
                        -2.508
                      ],
                      [
                        2.042,
                        -3.503
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    121.45,
                    85.145
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 17",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 14,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.038,
                        -0.018
                      ],
                      [
                        0.208,
                        -0.276
                      ],
                      [
                        0.65,
                        -0.049
                      ],
                      [
                        0.333,
                        0.817
                      ],
                      [
                        -0.113,
                        0.426
                      ],
                      [
                        -0.129,
                        0.396
                      ],
                      [
                        0.372,
                        0.588
                      ],
                      [
                        0.521,
                        0.12
                      ],
                      [
                        0.028,
                        0.091
                      ],
                      [
                        -1.253,
                        -0.162
                      ],
                      [
                        -0.463,
                        -0.7
                      ],
                      [
                        0.335,
                        -0.893
                      ],
                      [
                        -0.248,
                        -0.619
                      ],
                      [
                        -0.498,
                        0.005
                      ],
                      [
                        -0.22,
                        0.196
                      ]
                    ],
                    "o": [
                      [
                        0.026,
                        0.01
                      ],
                      [
                        -0.201,
                        0.265
                      ],
                      [
                        -0.644,
                        0.056
                      ],
                      [
                        -0.171,
                        -0.411
                      ],
                      [
                        0.11,
                        -0.43
                      ],
                      [
                        0.285,
                        -0.771
                      ],
                      [
                        -0.367,
                        -0.594
                      ],
                      [
                        -1.073,
                        -0.238
                      ],
                      [
                        -0.052,
                        -0.021
                      ],
                      [
                        0.6,
                        0.083
                      ],
                      [
                        0.473,
                        0.667
                      ],
                      [
                        -0.304,
                        0.852
                      ],
                      [
                        0.227,
                        0.622
                      ],
                      [
                        0.515,
                        0.006
                      ],
                      [
                        0.228,
                        -0.202
                      ]
                    ],
                    "v": [
                      [
                        3.19,
                        2.539
                      ],
                      [
                        2.988,
                        3.021
                      ],
                      [
                        1.715,
                        3.69
                      ],
                      [
                        -0.074,
                        2.516
                      ],
                      [
                        -0.118,
                        1.193
                      ],
                      [
                        0.302,
                        -0.029
                      ],
                      [
                        0.067,
                        -2.183
                      ],
                      [
                        -1.4,
                        -3.223
                      ],
                      [
                        -3.163,
                        -3.119
                      ],
                      [
                        -1.33,
                        -3.584
                      ],
                      [
                        0.467,
                        -2.445
                      ],
                      [
                        0.797,
                        0.132
                      ],
                      [
                        0.374,
                        2.343
                      ],
                      [
                        1.706,
                        3.322
                      ],
                      [
                        2.839,
                        2.884
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    93.35,
                    123.143
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 18",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 15,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.037,
                        -0.018
                      ],
                      [
                        0.208,
                        -0.275
                      ],
                      [
                        0.65,
                        -0.049
                      ],
                      [
                        0.333,
                        0.817
                      ],
                      [
                        -0.113,
                        0.426
                      ],
                      [
                        -0.129,
                        0.396
                      ],
                      [
                        0.372,
                        0.588
                      ],
                      [
                        0.521,
                        0.12
                      ],
                      [
                        0.028,
                        0.091
                      ],
                      [
                        -1.253,
                        -0.163
                      ],
                      [
                        -0.464,
                        -0.699
                      ],
                      [
                        0.335,
                        -0.893
                      ],
                      [
                        -0.248,
                        -0.619
                      ],
                      [
                        -0.498,
                        0.005
                      ],
                      [
                        -0.22,
                        0.196
                      ]
                    ],
                    "o": [
                      [
                        0.027,
                        0.01
                      ],
                      [
                        -0.202,
                        0.266
                      ],
                      [
                        -0.644,
                        0.056
                      ],
                      [
                        -0.171,
                        -0.411
                      ],
                      [
                        0.11,
                        -0.43
                      ],
                      [
                        0.285,
                        -0.771
                      ],
                      [
                        -0.367,
                        -0.594
                      ],
                      [
                        -1.073,
                        -0.238
                      ],
                      [
                        -0.052,
                        -0.021
                      ],
                      [
                        0.6,
                        0.082
                      ],
                      [
                        0.473,
                        0.668
                      ],
                      [
                        -0.304,
                        0.852
                      ],
                      [
                        0.227,
                        0.622
                      ],
                      [
                        0.515,
                        0.006
                      ],
                      [
                        0.227,
                        -0.202
                      ]
                    ],
                    "v": [
                      [
                        3.189,
                        2.54
                      ],
                      [
                        2.988,
                        3.021
                      ],
                      [
                        1.714,
                        3.691
                      ],
                      [
                        -0.074,
                        2.517
                      ],
                      [
                        -0.118,
                        1.194
                      ],
                      [
                        0.301,
                        -0.029
                      ],
                      [
                        0.067,
                        -2.183
                      ],
                      [
                        -1.4,
                        -3.223
                      ],
                      [
                        -3.163,
                        -3.118
                      ],
                      [
                        -1.33,
                        -3.583
                      ],
                      [
                        0.467,
                        -2.445
                      ],
                      [
                        0.796,
                        0.133
                      ],
                      [
                        0.374,
                        2.344
                      ],
                      [
                        1.706,
                        3.323
                      ],
                      [
                        2.839,
                        2.885
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    106.297,
                    92.857
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 19",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 16,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.009,
                        0.041
                      ],
                      [
                        -0.318,
                        -0.136
                      ],
                      [
                        -0.204,
                        -0.619
                      ],
                      [
                        0.715,
                        -0.519
                      ],
                      [
                        0.441,
                        0.008
                      ],
                      [
                        0.416,
                        0.03
                      ],
                      [
                        0.482,
                        -0.502
                      ],
                      [
                        -0.009,
                        -0.533
                      ],
                      [
                        0.081,
                        -0.048
                      ],
                      [
                        0.142,
                        1.256
                      ],
                      [
                        -0.568,
                        0.618
                      ],
                      [
                        -0.946,
                        -0.111
                      ],
                      [
                        -0.542,
                        0.389
                      ],
                      [
                        0.124,
                        0.481
                      ],
                      [
                        0.243,
                        0.167
                      ]
                    ],
                    "o": [
                      [
                        0.003,
                        -0.028
                      ],
                      [
                        0.306,
                        0.133
                      ],
                      [
                        0.208,
                        0.613
                      ],
                      [
                        -0.357,
                        0.264
                      ],
                      [
                        -0.444,
                        -0.003
                      ],
                      [
                        -0.816,
                        -0.092
                      ],
                      [
                        -0.49,
                        0.499
                      ],
                      [
                        0.025,
                        1.1
                      ],
                      [
                        -0.006,
                        0.056
                      ],
                      [
                        -0.064,
                        -0.602
                      ],
                      [
                        0.535,
                        -0.618
                      ],
                      [
                        0.902,
                        0.092
                      ],
                      [
                        0.55,
                        -0.37
                      ],
                      [
                        -0.117,
                        -0.503
                      ],
                      [
                        -0.251,
                        -0.172
                      ]
                    ],
                    "v": [
                      [
                        1.624,
                        -3.761
                      ],
                      [
                        2.14,
                        -3.681
                      ],
                      [
                        3.095,
                        -2.605
                      ],
                      [
                        2.382,
                        -0.587
                      ],
                      [
                        1.109,
                        -0.228
                      ],
                      [
                        -0.179,
                        -0.343
                      ],
                      [
                        -2.212,
                        0.401
                      ],
                      [
                        -2.871,
                        2.074
                      ],
                      [
                        -2.349,
                        3.761
                      ],
                      [
                        -3.239,
                        2.093
                      ],
                      [
                        -2.564,
                        0.075
                      ],
                      [
                        -0.141,
                        -0.863
                      ],
                      [
                        2.107,
                        -0.98
                      ],
                      [
                        2.739,
                        -2.507
                      ],
                      [
                        2.043,
                        -3.503
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    108.22,
                    77.807
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 20",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 17,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.041,
                        0.005
                      ],
                      [
                        -0.002,
                        -0.473
                      ],
                      [
                        0.916,
                        -0.318
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4.192,
                        -0.149
                      ],
                      [
                        2.365,
                        -0.036
                      ],
                      [
                        0.591,
                        0.316
                      ],
                      [
                        -0.018,
                        0.016
                      ],
                      [
                        -0.588,
                        -0.247
                      ],
                      [
                        -1.151,
                        0.021
                      ],
                      [
                        -3.556,
                        0.126
                      ],
                      [
                        -2.319,
                        0.021
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.026,
                        0.418
                      ]
                    ],
                    "o": [
                      [
                        0.016,
                        -0.005
                      ],
                      [
                        0.022,
                        0.449
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.315,
                        0.145
                      ],
                      [
                        -3.564,
                        0.127
                      ],
                      [
                        -1.184,
                        -0.026
                      ],
                      [
                        -0.593,
                        -0.319
                      ],
                      [
                        0.029,
                        -0.037
                      ],
                      [
                        0.589,
                        0.245
                      ],
                      [
                        2.3,
                        -0.129
                      ],
                      [
                        4.198,
                        -0.149
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.744,
                        -0.218
                      ],
                      [
                        0.05,
                        -0.434
                      ]
                    ],
                    "v": [
                      [
                        11.925,
                        -1.505
                      ],
                      [
                        12.054,
                        -0.806
                      ],
                      [
                        10.883,
                        0.79
                      ],
                      [
                        10.873,
                        0.793
                      ],
                      [
                        10.847,
                        0.795
                      ],
                      [
                        0.618,
                        1.262
                      ],
                      [
                        -8.511,
                        1.51
                      ],
                      [
                        -11.248,
                        0.915
                      ],
                      [
                        -12.058,
                        0.281
                      ],
                      [
                        -11.163,
                        0.73
                      ],
                      [
                        -8.507,
                        1.142
                      ],
                      [
                        0.593,
                        0.742
                      ],
                      [
                        10.842,
                        0.479
                      ],
                      [
                        10.804,
                        0.485
                      ],
                      [
                        11.886,
                        -0.819
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    96.797,
                    60.635
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 23",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 18,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.735,
                        0.873
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0.734,
                        -0.873
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -11.804,
                        0.749
                      ],
                      [
                        -11.629,
                        -5.212
                      ],
                      [
                        11.202,
                        -5.939
                      ],
                      [
                        12.365,
                        -0.105
                      ],
                      [
                        9.905,
                        4.257
                      ],
                      [
                        -11.115,
                        6.085
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    96.543,
                    60.166
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 26",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 19,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 24,
                      "s": [
                        {
                          "i": [
                            [
                              0,
                              0
                            ],
                            [
                              4.255,
                              -8.828
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -3.104,
                              5.678
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              -3.332,
                              6.912
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              6.296,
                              1.206
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              28.354,
                              -31.853
                            ],
                            [
                              15.496,
                              -21.911
                            ],
                            [
                              -2.405,
                              13.777
                            ],
                            [
                              -24.678,
                              12.292
                            ],
                            [
                              -29.132,
                              22.452
                            ],
                            [
                              1.431,
                              30.647
                            ],
                            [
                              16.332,
                              22.334
                            ],
                            [
                              29.132,
                              -1.085
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 46,
                      "s": [
                        {
                          "i": [
                            [
                              0,
                              0
                            ],
                            [
                              4.255,
                              -8.828
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -3.104,
                              5.678
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              -3.332,
                              6.912
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              6.296,
                              1.206
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              28.354,
                              -31.853
                            ],
                            [
                              15.496,
                              -21.911
                            ],
                            [
                              -7.53,
                              12.652
                            ],
                            [
                              -33.428,
                              13.542
                            ],
                            [
                              -38.132,
                              22.077
                            ],
                            [
                              -3.694,
                              29.522
                            ],
                            [
                              11.207,
                              21.209
                            ],
                            [
                              29.132,
                              -1.085
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "t": 68,
                      "s": [
                        {
                          "i": [
                            [
                              0,
                              0
                            ],
                            [
                              4.255,
                              -8.828
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -3.104,
                              5.678
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              -3.332,
                              6.912
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              6.296,
                              1.206
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              28.354,
                              -31.853
                            ],
                            [
                              15.496,
                              -21.911
                            ],
                            [
                              -2.405,
                              13.777
                            ],
                            [
                              -24.678,
                              12.292
                            ],
                            [
                              -29.132,
                              22.452
                            ],
                            [
                              1.431,
                              30.647
                            ],
                            [
                              16.332,
                              22.334
                            ],
                            [
                              29.132,
                              -1.085
                            ]
                          ],
                          "c": true
                        }
                      ]
                    }
                  ],
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    54.16,
                    92.768
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 27",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 20,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        12.452,
                        6.475
                      ],
                      [
                        -3.379,
                        14.969
                      ],
                      [
                        -4.147,
                        4.314
                      ],
                      [
                        -4.596,
                        1.034
                      ],
                      [
                        -4.71,
                        0.125
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -2.893,
                        -1.504
                      ],
                      [
                        1.318,
                        -5.837
                      ],
                      [
                        3.266,
                        -3.396
                      ],
                      [
                        4.598,
                        -1.033
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -20.063,
                        33.682
                      ],
                      [
                        -15.689,
                        -12.023
                      ],
                      [
                        -8.474,
                        -28.208
                      ],
                      [
                        3.882,
                        -34.648
                      ],
                      [
                        16.927,
                        -35.934
                      ],
                      [
                        21.076,
                        30.605
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    113.431,
                    125.374
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 28",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 21,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0.062,
                        -4.554
                      ],
                      [
                        -0.531,
                        -1.596
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -26.448,
                        0.155
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.577,
                        6.747
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        11.967,
                        -0.85
                      ]
                    ],
                    "o": [
                      [
                        -4.529,
                        3.233
                      ],
                      [
                        -0.136,
                        10.163
                      ],
                      [
                        0.777,
                        2.331
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        6.587,
                        -1.574
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.045,
                        -14.951
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -24.868,
                        -49.566
                      ],
                      [
                        -27.597,
                        -33.098
                      ],
                      [
                        -26.236,
                        -11.803
                      ],
                      [
                        -22.644,
                        10.389
                      ],
                      [
                        -27.381,
                        36.533
                      ],
                      [
                        5.186,
                        51.99
                      ],
                      [
                        18.365,
                        48.841
                      ],
                      [
                        28.821,
                        34.367
                      ],
                      [
                        25.821,
                        -0.743
                      ],
                      [
                        21.827,
                        -29.238
                      ],
                      [
                        -0.549,
                        -51.294
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    107.382,
                    110.481
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 29",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 22,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.833,
                        "y": 0.833
                      },
                      "o": {
                        "x": 0.167,
                        "y": 0.167
                      },
                      "t": 22,
                      "s": [
                        {
                          "i": [
                            [
                              3.233,
                              0.626
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -0.742,
                              -0.035
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              1.514,
                              1.497
                            ],
                            [
                              1.839,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0.415,
                              -0.617
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.128,
                              -0.037
                            ],
                            [
                              -1.307,
                              -1.293
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              -16.114,
                              5.347
                            ],
                            [
                              -12.58,
                              -1.278
                            ],
                            [
                              -10.717,
                              -2.215
                            ],
                            [
                              -9.136,
                              -2.14
                            ],
                            [
                              -6.446,
                              -4.652
                            ],
                            [
                              -3.304,
                              -4.652
                            ],
                            [
                              -0.886,
                              -6.266
                            ],
                            [
                              8.442,
                              -4.472
                            ],
                            [
                              16.114,
                              -2.409
                            ],
                            [
                              11.747,
                              6.266
                            ],
                            [
                              7.364,
                              5.342
                            ],
                            [
                              0.011,
                              5.216
                            ],
                            [
                              -5.662,
                              2.827
                            ],
                            [
                              -10.571,
                              0.809
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.833,
                        "y": 0.833
                      },
                      "o": {
                        "x": 0.167,
                        "y": 0.167
                      },
                      "t": 30,
                      "s": [
                        {
                          "i": [
                            [
                              2.873,
                              -0.337
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -0.742,
                              -0.035
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              1.514,
                              1.497
                            ],
                            [
                              1.839,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0.415,
                              -0.617
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.128,
                              -0.037
                            ],
                            [
                              -1.307,
                              -1.293
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              -12.989,
                              5.347
                            ],
                            [
                              -12.58,
                              -1.278
                            ],
                            [
                              -10.717,
                              -2.215
                            ],
                            [
                              -9.136,
                              -2.14
                            ],
                            [
                              -6.446,
                              -4.652
                            ],
                            [
                              -3.304,
                              -4.652
                            ],
                            [
                              -0.886,
                              -6.266
                            ],
                            [
                              8.442,
                              -4.472
                            ],
                            [
                              16.114,
                              -2.409
                            ],
                            [
                              11.747,
                              6.266
                            ],
                            [
                              7.364,
                              5.342
                            ],
                            [
                              0.011,
                              5.216
                            ],
                            [
                              -5.662,
                              2.827
                            ],
                            [
                              -10.571,
                              0.809
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.833,
                        "y": 0.833
                      },
                      "o": {
                        "x": 0.167,
                        "y": 0.167
                      },
                      "t": 37,
                      "s": [
                        {
                          "i": [
                            [
                              3.233,
                              0.626
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -0.742,
                              -0.035
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              1.514,
                              1.497
                            ],
                            [
                              1.839,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0.415,
                              -0.617
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.128,
                              -0.037
                            ],
                            [
                              -1.307,
                              -1.293
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              -16.114,
                              5.347
                            ],
                            [
                              -12.58,
                              -1.278
                            ],
                            [
                              -10.717,
                              -2.215
                            ],
                            [
                              -9.136,
                              -2.14
                            ],
                            [
                              -6.446,
                              -4.652
                            ],
                            [
                              -3.304,
                              -4.652
                            ],
                            [
                              -0.886,
                              -6.266
                            ],
                            [
                              8.442,
                              -4.472
                            ],
                            [
                              16.114,
                              -2.409
                            ],
                            [
                              11.747,
                              6.266
                            ],
                            [
                              7.364,
                              5.342
                            ],
                            [
                              0.011,
                              5.216
                            ],
                            [
                              -5.662,
                              2.827
                            ],
                            [
                              -10.571,
                              0.809
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.833,
                        "y": 0.833
                      },
                      "o": {
                        "x": 0.167,
                        "y": 0.167
                      },
                      "t": 44,
                      "s": [
                        {
                          "i": [
                            [
                              2.873,
                              -0.337
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -0.742,
                              -0.035
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              1.514,
                              1.497
                            ],
                            [
                              1.839,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0.415,
                              -0.617
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.128,
                              -0.037
                            ],
                            [
                              -1.307,
                              -1.293
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              -12.989,
                              5.347
                            ],
                            [
                              -12.58,
                              -1.278
                            ],
                            [
                              -10.717,
                              -2.215
                            ],
                            [
                              -9.136,
                              -2.14
                            ],
                            [
                              -6.446,
                              -4.652
                            ],
                            [
                              -3.304,
                              -4.652
                            ],
                            [
                              -0.886,
                              -6.266
                            ],
                            [
                              8.442,
                              -4.472
                            ],
                            [
                              16.114,
                              -2.409
                            ],
                            [
                              11.747,
                              6.266
                            ],
                            [
                              7.364,
                              5.342
                            ],
                            [
                              0.011,
                              5.216
                            ],
                            [
                              -5.662,
                              2.827
                            ],
                            [
                              -10.571,
                              0.809
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.833,
                        "y": 0.833
                      },
                      "o": {
                        "x": 0.167,
                        "y": 0.167
                      },
                      "t": 52,
                      "s": [
                        {
                          "i": [
                            [
                              3.233,
                              0.626
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -0.742,
                              -0.035
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              1.514,
                              1.497
                            ],
                            [
                              1.839,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0.415,
                              -0.617
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.128,
                              -0.037
                            ],
                            [
                              -1.307,
                              -1.293
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              -16.114,
                              5.347
                            ],
                            [
                              -12.58,
                              -1.278
                            ],
                            [
                              -10.717,
                              -2.215
                            ],
                            [
                              -9.136,
                              -2.14
                            ],
                            [
                              -6.446,
                              -4.652
                            ],
                            [
                              -3.304,
                              -4.652
                            ],
                            [
                              -0.886,
                              -6.266
                            ],
                            [
                              8.442,
                              -4.472
                            ],
                            [
                              16.114,
                              -2.409
                            ],
                            [
                              11.747,
                              6.266
                            ],
                            [
                              7.364,
                              5.342
                            ],
                            [
                              0.011,
                              5.216
                            ],
                            [
                              -5.662,
                              2.827
                            ],
                            [
                              -10.571,
                              0.809
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.833,
                        "y": 0.833
                      },
                      "o": {
                        "x": 0.167,
                        "y": 0.167
                      },
                      "t": 61,
                      "s": [
                        {
                          "i": [
                            [
                              2.873,
                              -0.337
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -0.742,
                              -0.035
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              1.514,
                              1.497
                            ],
                            [
                              1.839,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0.415,
                              -0.617
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.128,
                              -0.037
                            ],
                            [
                              -1.307,
                              -1.293
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              -12.989,
                              5.347
                            ],
                            [
                              -12.58,
                              -1.278
                            ],
                            [
                              -10.717,
                              -2.215
                            ],
                            [
                              -9.136,
                              -2.14
                            ],
                            [
                              -6.446,
                              -4.652
                            ],
                            [
                              -3.304,
                              -4.652
                            ],
                            [
                              -0.886,
                              -6.266
                            ],
                            [
                              8.442,
                              -4.472
                            ],
                            [
                              16.114,
                              -2.409
                            ],
                            [
                              11.747,
                              6.266
                            ],
                            [
                              7.364,
                              5.342
                            ],
                            [
                              0.011,
                              5.216
                            ],
                            [
                              -5.662,
                              2.827
                            ],
                            [
                              -10.571,
                              0.809
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "t": 68,
                      "s": [
                        {
                          "i": [
                            [
                              3.233,
                              0.626
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -0.742,
                              -0.035
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              1.514,
                              1.497
                            ],
                            [
                              1.839,
                              0
                            ]
                          ],
                          "o": [
                            [
                              0,
                              0
                            ],
                            [
                              0.415,
                              -0.617
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -2.128,
                              -0.037
                            ],
                            [
                              -1.307,
                              -1.293
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          "v": [
                            [
                              -16.114,
                              5.347
                            ],
                            [
                              -12.58,
                              -1.278
                            ],
                            [
                              -10.717,
                              -2.215
                            ],
                            [
                              -9.136,
                              -2.14
                            ],
                            [
                              -6.446,
                              -4.652
                            ],
                            [
                              -3.304,
                              -4.652
                            ],
                            [
                              -0.886,
                              -6.266
                            ],
                            [
                              8.442,
                              -4.472
                            ],
                            [
                              16.114,
                              -2.409
                            ],
                            [
                              11.747,
                              6.266
                            ],
                            [
                              7.364,
                              5.342
                            ],
                            [
                              0.011,
                              5.216
                            ],
                            [
                              -5.662,
                              2.827
                            ],
                            [
                              -10.571,
                              0.809
                            ]
                          ],
                          "c": true
                        }
                      ]
                    }
                  ],
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    0.745000023935,
                    0.616000007181,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 24,
                      "s": [
                        16.365,
                        108.755
                      ],
                      "to": [
                        -1.625,
                        0.042
                      ],
                      "ti": [
                        0,
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 46,
                      "s": [
                        6.615,
                        109.005
                      ],
                      "to": [
                        0,
                        0
                      ],
                      "ti": [
                        -1.625,
                        0.042
                      ]
                    },
                    {
                      "t": 68,
                      "s": [
                        16.365,
                        108.755
                      ]
                    }
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 32",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 23,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.018,
                        -0.002
                      ],
                      [
                        0.094,
                        0.58
                      ],
                      [
                        0.163,
                        1.069
                      ],
                      [
                        0.558,
                        3.917
                      ],
                      [
                        1.638,
                        12.049
                      ],
                      [
                        1.021,
                        7.791
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.944,
                        1.432
                      ],
                      [
                        0.548,
                        0.406
                      ],
                      [
                        -0.011,
                        0.016
                      ],
                      [
                        -0.141,
                        -0.084
                      ],
                      [
                        -0.247,
                        -0.155
                      ],
                      [
                        -0.986,
                        -0.699
                      ],
                      [
                        -3.574,
                        -2.4
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.571,
                        -11.565
                      ],
                      [
                        -1.042,
                        -7.957
                      ],
                      [
                        -0.283,
                        -2.264
                      ],
                      [
                        -0.072,
                        -0.627
                      ]
                    ],
                    "o": [
                      [
                        -0.018,
                        0.003
                      ],
                      [
                        -0.096,
                        -0.626
                      ],
                      [
                        -0.321,
                        -2.259
                      ],
                      [
                        -1.081,
                        -7.952
                      ],
                      [
                        -1.515,
                        -11.573
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -3.569,
                        -2.455
                      ],
                      [
                        -0.942,
                        -0.698
                      ],
                      [
                        -0.513,
                        -0.374
                      ],
                      [
                        0.005,
                        -0.008
                      ],
                      [
                        0.166,
                        0.103
                      ],
                      [
                        0.534,
                        0.346
                      ],
                      [
                        1.983,
                        1.382
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.058,
                        7.786
                      ],
                      [
                        1.578,
                        12.058
                      ],
                      [
                        0.488,
                        3.926
                      ],
                      [
                        0.122,
                        1.074
                      ],
                      [
                        0.06,
                        0.585
                      ]
                    ],
                    "v": [
                      [
                        10.577,
                        40.889
                      ],
                      [
                        10.407,
                        40.008
                      ],
                      [
                        10.018,
                        37.466
                      ],
                      [
                        8.686,
                        28.105
                      ],
                      [
                        4.486,
                        -2.805
                      ],
                      [
                        0.572,
                        -32.686
                      ],
                      [
                        0.655,
                        -32.553
                      ],
                      [
                        -7.577,
                        -38.64
                      ],
                      [
                        -9.813,
                        -40.295
                      ],
                      [
                        -10.584,
                        -40.884
                      ],
                      [
                        -10.364,
                        -40.769
                      ],
                      [
                        -9.75,
                        -40.384
                      ],
                      [
                        -7.453,
                        -38.81
                      ],
                      [
                        0.865,
                        -32.87
                      ],
                      [
                        0.936,
                        -32.822
                      ],
                      [
                        0.948,
                        -32.737
                      ],
                      [
                        5.003,
                        -2.874
                      ],
                      [
                        9.052,
                        28.056
                      ],
                      [
                        10.22,
                        37.439
                      ],
                      [
                        10.511,
                        39.993
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.270999983245,
                    0.352999997606,
                    0.39199999641,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    36.859,
                    210.111
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 33",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 24,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.336,
                        3.711
                      ],
                      [
                        -9.485,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.697,
                        -3.882
                      ],
                      [
                        3.21,
                        -8.925
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -35.797,
                        54.645
                      ],
                      [
                        -51.92,
                        -28.179
                      ],
                      [
                        -50.945,
                        -39.77
                      ],
                      [
                        -29.784,
                        -54.645
                      ],
                      [
                        20.052,
                        -54.645
                      ],
                      [
                        52.617,
                        -40.212
                      ],
                      [
                        52.617,
                        -18.379
                      ],
                      [
                        -22.33,
                        -24.258
                      ],
                      [
                        -12.514,
                        49.341
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    59.95,
                    201.659
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 34",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 25,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.335,
                        3.711
                      ],
                      [
                        -9.486,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        11.735,
                        0.921
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.697,
                        -3.882
                      ],
                      [
                        3.212,
                        -8.925
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        11.771
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -37.792,
                        52.563
                      ],
                      [
                        -51.92,
                        -26.098
                      ],
                      [
                        -50.946,
                        -37.688
                      ],
                      [
                        -29.784,
                        -52.563
                      ],
                      [
                        20.052,
                        -52.563
                      ],
                      [
                        52.617,
                        -38.13
                      ],
                      [
                        30.851,
                        -18.005
                      ],
                      [
                        -22.331,
                        -22.176
                      ],
                      [
                        -14.668,
                        49.073
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    103.168,
                    199.577
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 35",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 26,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.103,
                        -0.008
                      ],
                      [
                        0.166,
                        1.163
                      ],
                      [
                        0.366,
                        0.688
                      ],
                      [
                        0.273,
                        0.327
                      ],
                      [
                        0.704,
                        -0.059
                      ],
                      [
                        0.054,
                        -0.262
                      ],
                      [
                        0.001,
                        -0.219
                      ],
                      [
                        -0.135,
                        -0.373
                      ],
                      [
                        -0.439,
                        -0.393
                      ],
                      [
                        -0.003,
                        0.063
                      ],
                      [
                        0.725,
                        0.795
                      ],
                      [
                        0.206,
                        0.662
                      ],
                      [
                        0.007,
                        0.37
                      ],
                      [
                        -0.152,
                        -0.01
                      ],
                      [
                        -0.211,
                        -0.279
                      ],
                      [
                        -0.182,
                        -0.303
                      ],
                      [
                        -0.131,
                        -0.525
                      ]
                    ],
                    "o": [
                      [
                        0.068,
                        0.015
                      ],
                      [
                        -0.084,
                        -0.576
                      ],
                      [
                        -0.186,
                        -0.343
                      ],
                      [
                        -0.285,
                        -0.316
                      ],
                      [
                        -0.362,
                        0.059
                      ],
                      [
                        -0.07,
                        0.27
                      ],
                      [
                        0.019,
                        0.438
                      ],
                      [
                        0.27,
                        0.751
                      ],
                      [
                        0.899,
                        0.799
                      ],
                      [
                        0.041,
                        -0.101
                      ],
                      [
                        -0.357,
                        -0.393
                      ],
                      [
                        -0.102,
                        -0.329
                      ],
                      [
                        -0.021,
                        -0.398
                      ],
                      [
                        0.18,
                        -0.039
                      ],
                      [
                        0.252,
                        0.288
                      ],
                      [
                        0.36,
                        0.611
                      ],
                      [
                        0.265,
                        1.056
                      ]
                    ],
                    "v": [
                      [
                        1.495,
                        2.768
                      ],
                      [
                        1.621,
                        0.914
                      ],
                      [
                        0.973,
                        -1.028
                      ],
                      [
                        0.287,
                        -2.04
                      ],
                      [
                        -1.059,
                        -2.725
                      ],
                      [
                        -1.717,
                        -2.064
                      ],
                      [
                        -1.77,
                        -1.36
                      ],
                      [
                        -1.524,
                        -0.134
                      ],
                      [
                        -0.369,
                        1.589
                      ],
                      [
                        1.316,
                        2.388
                      ],
                      [
                        -0.055,
                        1.274
                      ],
                      [
                        -0.975,
                        -0.321
                      ],
                      [
                        -1.152,
                        -1.378
                      ],
                      [
                        -0.939,
                        -2.107
                      ],
                      [
                        -0.182,
                        -1.638
                      ],
                      [
                        0.467,
                        -0.743
                      ],
                      [
                        1.184,
                        1.002
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    28.093,
                    257.115
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 36",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 27,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.022,
                        -0.095
                      ],
                      [
                        -1.082,
                        0.418
                      ],
                      [
                        -0.627,
                        0.445
                      ],
                      [
                        -0.305,
                        0.288
                      ],
                      [
                        -0.142,
                        0.25
                      ],
                      [
                        0.285,
                        0.242
                      ],
                      [
                        0.264,
                        -0.047
                      ],
                      [
                        0.188,
                        -0.088
                      ],
                      [
                        0.317,
                        -0.225
                      ],
                      [
                        0.342,
                        -0.471
                      ],
                      [
                        -0.067,
                        -0.022
                      ],
                      [
                        -0.728,
                        0.817
                      ],
                      [
                        -0.597,
                        0.392
                      ],
                      [
                        -0.354,
                        0.156
                      ],
                      [
                        -0.133,
                        -0.152
                      ],
                      [
                        0.059,
                        -0.129
                      ],
                      [
                        0.144,
                        -0.14
                      ],
                      [
                        0.284,
                        -0.22
                      ],
                      [
                        0.49,
                        -0.25
                      ]
                    ],
                    "o": [
                      [
                        0.013,
                        0.074
                      ],
                      [
                        0.538,
                        -0.209
                      ],
                      [
                        0.313,
                        -0.222
                      ],
                      [
                        0.146,
                        -0.141
                      ],
                      [
                        0.159,
                        -0.224
                      ],
                      [
                        -0.243,
                        -0.243
                      ],
                      [
                        -0.269,
                        0.045
                      ],
                      [
                        -0.386,
                        0.18
                      ],
                      [
                        -0.63,
                        0.455
                      ],
                      [
                        -0.686,
                        0.95
                      ],
                      [
                        0.093,
                        0.042
                      ],
                      [
                        0.363,
                        -0.406
                      ],
                      [
                        0.298,
                        -0.196
                      ],
                      [
                        0.364,
                        -0.178
                      ],
                      [
                        0.049,
                        0.057
                      ],
                      [
                        -0.062,
                        0.12
                      ],
                      [
                        -0.279,
                        0.275
                      ],
                      [
                        -0.571,
                        0.443
                      ],
                      [
                        -0.983,
                        0.5
                      ]
                    ],
                    "v": [
                      [
                        -2.577,
                        1.868
                      ],
                      [
                        -0.76,
                        1.493
                      ],
                      [
                        1.026,
                        0.525
                      ],
                      [
                        1.96,
                        -0.239
                      ],
                      [
                        2.423,
                        -0.778
                      ],
                      [
                        2.315,
                        -1.737
                      ],
                      [
                        1.456,
                        -1.987
                      ],
                      [
                        0.793,
                        -1.756
                      ],
                      [
                        -0.262,
                        -1.14
                      ],
                      [
                        -1.717,
                        0.299
                      ],
                      [
                        -2.491,
                        1.992
                      ],
                      [
                        -1.371,
                        0.579
                      ],
                      [
                        0.069,
                        -0.661
                      ],
                      [
                        1.048,
                        -1.194
                      ],
                      [
                        1.871,
                        -1.289
                      ],
                      [
                        1.872,
                        -1.077
                      ],
                      [
                        1.531,
                        -0.684
                      ],
                      [
                        0.681,
                        0.058
                      ],
                      [
                        -0.943,
                        1.087
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    31.883,
                    257.807
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 37",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 28,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.114,
                        -0.122
                      ],
                      [
                        -1.017,
                        0.134
                      ],
                      [
                        -0.063,
                        0.171
                      ],
                      [
                        1.195,
                        -0.174
                      ]
                    ],
                    "o": [
                      [
                        0.107,
                        0.146
                      ],
                      [
                        1.013,
                        -0.154
                      ],
                      [
                        0.076,
                        -0.148
                      ],
                      [
                        -1.196,
                        0.165
                      ]
                    ],
                    "v": [
                      [
                        -1.887,
                        0.523
                      ],
                      [
                        0.001,
                        0.128
                      ],
                      [
                        1.926,
                        -0.017
                      ],
                      [
                        -0.087,
                        -0.495
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    31.194,
                    263.637
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 38",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 29,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.18,
                        0.019
                      ],
                      [
                        0.651,
                        0.88
                      ],
                      [
                        0.045,
                        -0.163
                      ],
                      [
                        -0.523,
                        -0.731
                      ]
                    ],
                    "o": [
                      [
                        0.169,
                        0.006
                      ],
                      [
                        -0.645,
                        -0.884
                      ],
                      [
                        -0.071,
                        0.166
                      ],
                      [
                        0.541,
                        0.717
                      ]
                    ],
                    "v": [
                      [
                        0.926,
                        1.445
                      ],
                      [
                        0.512,
                        -0.366
                      ],
                      [
                        -1.092,
                        -1.301
                      ],
                      [
                        0.004,
                        0.009
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    24.181,
                    274.4
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 39",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 30,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.03,
                        -0.17
                      ],
                      [
                        -0.753,
                        -0.63
                      ],
                      [
                        -0.176,
                        0.043
                      ],
                      [
                        0.952,
                        0.763
                      ]
                    ],
                    "o": [
                      [
                        -0.006,
                        0.181
                      ],
                      [
                        0.773,
                        0.606
                      ],
                      [
                        0.172,
                        -0.006
                      ],
                      [
                        -0.945,
                        -0.774
                      ]
                    ],
                    "v": [
                      [
                        -1.49,
                        -1.02
                      ],
                      [
                        0.086,
                        -0.063
                      ],
                      [
                        1.349,
                        1.283
                      ],
                      [
                        0.483,
                        -0.552
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    27.845,
                    271.868
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 40",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 31,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.071,
                        -0.154
                      ],
                      [
                        -0.988,
                        -0.395
                      ],
                      [
                        -0.15,
                        0.103
                      ],
                      [
                        1.204,
                        0.457
                      ]
                    ],
                    "o": [
                      [
                        0.041,
                        0.177
                      ],
                      [
                        0.998,
                        0.369
                      ],
                      [
                        0.156,
                        -0.067
                      ],
                      [
                        -1.199,
                        -0.468
                      ]
                    ],
                    "v": [
                      [
                        -1.884,
                        -0.469
                      ],
                      [
                        0.047,
                        0.005
                      ],
                      [
                        1.799,
                        0.949
                      ],
                      [
                        0.273,
                        -0.583
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    31.733,
                    268.976
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 41",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 32,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.412,
                        -1.103
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        18.203,
                        -2.191
                      ],
                      [
                        17.511,
                        -5.115
                      ],
                      [
                        -17.066,
                        2.984
                      ],
                      [
                        -18.13,
                        5.115
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    31.694,
                    277.72
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 42",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 33,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0.021,
                        -0.744
                      ],
                      [
                        0.743,
                        0.039
                      ],
                      [
                        -0.104,
                        0.737
                      ],
                      [
                        -0.711,
                        -0.215
                      ]
                    ],
                    "o": [
                      [
                        0.741,
                        0.051
                      ],
                      [
                        -0.02,
                        0.743
                      ],
                      [
                        -0.742,
                        -0.038
                      ],
                      [
                        0.102,
                        -0.736
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.089,
                        -1.418
                      ],
                      [
                        1.455,
                        0.069
                      ],
                      [
                        -0.007,
                        1.436
                      ],
                      [
                        -1.445,
                        -0.146
                      ],
                      [
                        0.233,
                        -1.399
                      ]
                    ],
                    "c": false
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    41.304,
                    266.158
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 43",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 34,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.486,
                        -3.513
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        12.686,
                        -18.269
                      ],
                      [
                        18.41,
                        10.963
                      ],
                      [
                        -17.924,
                        18.269
                      ],
                      [
                        -1.014,
                        4.008
                      ],
                      [
                        -5.45,
                        -14.572
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    31.488,
                    264.565
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 44",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 35,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.102,
                        -0.009
                      ],
                      [
                        0.151,
                        1.165
                      ],
                      [
                        0.358,
                        0.693
                      ],
                      [
                        0.27,
                        0.33
                      ],
                      [
                        0.705,
                        -0.05
                      ],
                      [
                        0.057,
                        -0.26
                      ],
                      [
                        0.003,
                        -0.219
                      ],
                      [
                        -0.13,
                        -0.375
                      ],
                      [
                        -0.434,
                        -0.4
                      ],
                      [
                        -0.003,
                        0.064
                      ],
                      [
                        0.714,
                        0.805
                      ],
                      [
                        0.197,
                        0.664
                      ],
                      [
                        0.003,
                        0.371
                      ],
                      [
                        -0.153,
                        -0.013
                      ],
                      [
                        -0.207,
                        -0.28
                      ],
                      [
                        -0.178,
                        -0.307
                      ],
                      [
                        -0.125,
                        -0.526
                      ]
                    ],
                    "o": [
                      [
                        0.068,
                        0.016
                      ],
                      [
                        -0.077,
                        -0.577
                      ],
                      [
                        -0.18,
                        -0.344
                      ],
                      [
                        -0.28,
                        -0.321
                      ],
                      [
                        -0.364,
                        0.053
                      ],
                      [
                        -0.075,
                        0.27
                      ],
                      [
                        0.013,
                        0.439
                      ],
                      [
                        0.26,
                        0.754
                      ],
                      [
                        0.889,
                        0.81
                      ],
                      [
                        0.043,
                        -0.099
                      ],
                      [
                        -0.353,
                        -0.397
                      ],
                      [
                        -0.099,
                        -0.331
                      ],
                      [
                        -0.015,
                        -0.397
                      ],
                      [
                        0.18,
                        -0.037
                      ],
                      [
                        0.248,
                        0.292
                      ],
                      [
                        0.351,
                        0.615
                      ],
                      [
                        0.25,
                        1.061
                      ]
                    ],
                    "v": [
                      [
                        1.46,
                        2.78
                      ],
                      [
                        1.611,
                        0.928
                      ],
                      [
                        0.988,
                        -1.023
                      ],
                      [
                        0.315,
                        -2.043
                      ],
                      [
                        -1.02,
                        -2.746
                      ],
                      [
                        -1.687,
                        -2.095
                      ],
                      [
                        -1.749,
                        -1.391
                      ],
                      [
                        -1.52,
                        -0.162
                      ],
                      [
                        -0.388,
                        1.577
                      ],
                      [
                        1.286,
                        2.397
                      ],
                      [
                        -0.069,
                        1.265
                      ],
                      [
                        -0.968,
                        -0.341
                      ],
                      [
                        -1.132,
                        -1.402
                      ],
                      [
                        -0.908,
                        -2.126
                      ],
                      [
                        -0.158,
                        -1.649
                      ],
                      [
                        0.479,
                        -0.744
                      ],
                      [
                        1.173,
                        1.009
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    70.405,
                    252.185
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 45",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 36,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.021,
                        -0.097
                      ],
                      [
                        -1.087,
                        0.404
                      ],
                      [
                        -0.634,
                        0.437
                      ],
                      [
                        -0.308,
                        0.284
                      ],
                      [
                        -0.144,
                        0.247
                      ],
                      [
                        0.282,
                        0.246
                      ],
                      [
                        0.264,
                        -0.044
                      ],
                      [
                        0.189,
                        -0.087
                      ],
                      [
                        0.319,
                        -0.221
                      ],
                      [
                        0.348,
                        -0.465
                      ],
                      [
                        -0.067,
                        -0.023
                      ],
                      [
                        -0.739,
                        0.807
                      ],
                      [
                        -0.602,
                        0.385
                      ],
                      [
                        -0.355,
                        0.152
                      ],
                      [
                        -0.132,
                        -0.153
                      ],
                      [
                        0.06,
                        -0.128
                      ],
                      [
                        0.145,
                        -0.138
                      ],
                      [
                        0.288,
                        -0.217
                      ],
                      [
                        0.493,
                        -0.242
                      ]
                    ],
                    "o": [
                      [
                        0.012,
                        0.073
                      ],
                      [
                        0.541,
                        -0.201
                      ],
                      [
                        0.317,
                        -0.218
                      ],
                      [
                        0.148,
                        -0.139
                      ],
                      [
                        0.162,
                        -0.223
                      ],
                      [
                        -0.239,
                        -0.245
                      ],
                      [
                        -0.271,
                        0.041
                      ],
                      [
                        -0.387,
                        0.174
                      ],
                      [
                        -0.636,
                        0.447
                      ],
                      [
                        -0.699,
                        0.942
                      ],
                      [
                        0.091,
                        0.044
                      ],
                      [
                        0.369,
                        -0.402
                      ],
                      [
                        0.3,
                        -0.191
                      ],
                      [
                        0.367,
                        -0.173
                      ],
                      [
                        0.048,
                        0.059
                      ],
                      [
                        -0.064,
                        0.119
                      ],
                      [
                        -0.283,
                        0.27
                      ],
                      [
                        -0.576,
                        0.435
                      ],
                      [
                        -0.99,
                        0.488
                      ]
                    ],
                    "v": [
                      [
                        -2.6,
                        1.839
                      ],
                      [
                        -0.778,
                        1.487
                      ],
                      [
                        1.021,
                        0.543
                      ],
                      [
                        1.964,
                        -0.209
                      ],
                      [
                        2.435,
                        -0.741
                      ],
                      [
                        2.339,
                        -1.702
                      ],
                      [
                        1.484,
                        -1.963
                      ],
                      [
                        0.817,
                        -1.74
                      ],
                      [
                        -0.244,
                        -1.139
                      ],
                      [
                        -1.719,
                        0.28
                      ],
                      [
                        -2.514,
                        1.963
                      ],
                      [
                        -1.377,
                        0.566
                      ],
                      [
                        0.079,
                        -0.656
                      ],
                      [
                        1.065,
                        -1.176
                      ],
                      [
                        1.891,
                        -1.26
                      ],
                      [
                        1.889,
                        -1.048
                      ],
                      [
                        1.543,
                        -0.659
                      ],
                      [
                        0.682,
                        0.072
                      ],
                      [
                        -0.954,
                        1.078
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    74.186,
                    252.915
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 46",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 37,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.113,
                        -0.124
                      ],
                      [
                        -1.019,
                        0.12
                      ],
                      [
                        -0.064,
                        0.17
                      ],
                      [
                        1.198,
                        -0.158
                      ]
                    ],
                    "o": [
                      [
                        0.105,
                        0.147
                      ],
                      [
                        1.015,
                        -0.142
                      ],
                      [
                        0.078,
                        -0.148
                      ],
                      [
                        -1.198,
                        0.149
                      ]
                    ],
                    "v": [
                      [
                        -1.892,
                        0.503
                      ],
                      [
                        0.002,
                        0.133
                      ],
                      [
                        1.927,
                        0.013
                      ],
                      [
                        -0.079,
                        -0.492
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    73.419,
                    258.736
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 47",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 38,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.18,
                        0.016
                      ],
                      [
                        0.639,
                        0.888
                      ],
                      [
                        0.047,
                        -0.163
                      ],
                      [
                        -0.514,
                        -0.738
                      ]
                    ],
                    "o": [
                      [
                        0.169,
                        0.008
                      ],
                      [
                        -0.633,
                        -0.893
                      ],
                      [
                        -0.074,
                        0.165
                      ],
                      [
                        0.53,
                        0.725
                      ]
                    ],
                    "v": [
                      [
                        0.902,
                        1.461
                      ],
                      [
                        0.513,
                        -0.355
                      ],
                      [
                        -1.078,
                        -1.314
                      ],
                      [
                        0.001,
                        0.01
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    66.271,
                    269.406
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 48",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 39,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.027,
                        -0.17
                      ],
                      [
                        -0.744,
                        -0.639
                      ],
                      [
                        -0.175,
                        0.041
                      ],
                      [
                        0.941,
                        0.778
                      ]
                    ],
                    "o": [
                      [
                        -0.008,
                        0.181
                      ],
                      [
                        0.764,
                        0.617
                      ],
                      [
                        0.172,
                        -0.004
                      ],
                      [
                        -0.934,
                        -0.785
                      ]
                    ],
                    "v": [
                      [
                        -1.476,
                        -1.044
                      ],
                      [
                        0.087,
                        -0.066
                      ],
                      [
                        1.331,
                        1.295
                      ],
                      [
                        0.49,
                        -0.551
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    69.963,
                    266.931
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 49",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 40,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.068,
                        -0.156
                      ],
                      [
                        -0.983,
                        -0.408
                      ],
                      [
                        -0.15,
                        0.101
                      ],
                      [
                        1.198,
                        0.473
                      ]
                    ],
                    "o": [
                      [
                        0.04,
                        0.177
                      ],
                      [
                        0.993,
                        0.383
                      ],
                      [
                        0.158,
                        -0.065
                      ],
                      [
                        -1.193,
                        -0.483
                      ]
                    ],
                    "v": [
                      [
                        -1.877,
                        -0.499
                      ],
                      [
                        0.049,
                        0
                      ],
                      [
                        1.787,
                        0.967
                      ],
                      [
                        0.282,
                        -0.585
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    73.888,
                    264.09
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 50",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 41,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.397,
                        -1.108
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        18.247,
                        -1.946
                      ],
                      [
                        17.595,
                        -4.879
                      ],
                      [
                        -17.087,
                        2.76
                      ],
                      [
                        -18.179,
                        4.878
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    73.718,
                    272.824
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 51",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 42,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0.03,
                        -0.743
                      ],
                      [
                        0.742,
                        0.047
                      ],
                      [
                        -0.113,
                        0.734
                      ],
                      [
                        -0.709,
                        -0.225
                      ]
                    ],
                    "o": [
                      [
                        0.741,
                        0.061
                      ],
                      [
                        -0.031,
                        0.743
                      ],
                      [
                        -0.741,
                        -0.048
                      ],
                      [
                        0.113,
                        -0.735
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.108,
                        -1.417
                      ],
                      [
                        1.455,
                        0.088
                      ],
                      [
                        -0.026,
                        1.436
                      ],
                      [
                        -1.443,
                        -0.165
                      ],
                      [
                        0.252,
                        -1.396
                      ]
                    ],
                    "c": false
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    83.497,
                    261.395
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 52",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 43,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.439,
                        -3.52
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        13.099,
                        -18.065
                      ],
                      [
                        18.432,
                        11.241
                      ],
                      [
                        -17.993,
                        18.065
                      ],
                      [
                        -0.896,
                        4.029
                      ],
                      [
                        -5.085,
                        -14.608
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    73.532,
                    259.638
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 53",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 44,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 0,
        "op": 720,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 3,
        "ty": 4,
        "nm": "Shape Layer 1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 20,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 32,
                "s": [
                  -3
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 58,
                "s": [
                  3
                ]
              },
              {
                "t": 68,
                "s": [
                  0
                ]
              }
            ],
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              374.5,
              250.5,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              95,
              62.5,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.512,
                        3.111
                      ],
                      [
                        -0.683,
                        3.079
                      ],
                      [
                        -0.696,
                        3.239
                      ],
                      [
                        1.917,
                        2.701
                      ],
                      [
                        5.425,
                        0.301
                      ],
                      [
                        6.807,
                        -0.652
                      ],
                      [
                        6.376,
                        1.006
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.151,
                        -3.503
                      ],
                      [
                        0.001,
                        -0.031
                      ],
                      [
                        -3.367,
                        -1.14
                      ],
                      [
                        -0.412,
                        -0.133
                      ],
                      [
                        -0.867,
                        -0.864
                      ],
                      [
                        0.066,
                        -1.818
                      ],
                      [
                        -0.616,
                        -1.712
                      ],
                      [
                        -0.599,
                        0.159
                      ],
                      [
                        -0.069,
                        0.736
                      ],
                      [
                        -1.938,
                        -1.57
                      ],
                      [
                        0.671,
                        -1.407
                      ],
                      [
                        0.305,
                        -1.671
                      ],
                      [
                        -1.259,
                        -1.531
                      ],
                      [
                        -0.536,
                        -0.45
                      ],
                      [
                        -3.588,
                        -1.241
                      ],
                      [
                        -1.828,
                        1.77
                      ]
                    ],
                    "o": [
                      [
                        2.188,
                        -2.272
                      ],
                      [
                        0.511,
                        -3.113
                      ],
                      [
                        0.718,
                        -3.234
                      ],
                      [
                        0.695,
                        -3.238
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -9.255,
                        0.886
                      ],
                      [
                        -5.959,
                        -0.939
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.001,
                        0.032
                      ],
                      [
                        -0.133,
                        3.551
                      ],
                      [
                        0.411,
                        0.139
                      ],
                      [
                        1.165,
                        0.376
                      ],
                      [
                        1.289,
                        1.284
                      ],
                      [
                        -0.067,
                        1.818
                      ],
                      [
                        0.209,
                        0.584
                      ],
                      [
                        0.714,
                        -0.19
                      ],
                      [
                        0.203,
                        -2.143
                      ],
                      [
                        1.211,
                        0.98
                      ],
                      [
                        -0.719,
                        1.508
                      ],
                      [
                        -0.513,
                        2.815
                      ],
                      [
                        0.443,
                        0.54
                      ],
                      [
                        2.725,
                        2.296
                      ],
                      [
                        2.404,
                        0.832
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        14.839,
                        25.146
                      ],
                      [
                        18.547,
                        16.6
                      ],
                      [
                        19.826,
                        7.229
                      ],
                      [
                        22.605,
                        -2.306
                      ],
                      [
                        21.318,
                        -11.871
                      ],
                      [
                        14.626,
                        -15.882
                      ],
                      [
                        3.212,
                        -22.69
                      ],
                      [
                        -12.67,
                        -25.531
                      ],
                      [
                        -19.736,
                        -21.156
                      ],
                      [
                        -23.163,
                        -15.221
                      ],
                      [
                        -23.167,
                        -15.128
                      ],
                      [
                        -17.644,
                        -7.233
                      ],
                      [
                        -16.408,
                        -6.827
                      ],
                      [
                        -13.16,
                        -5.194
                      ],
                      [
                        -11.727,
                        -0.091
                      ],
                      [
                        -11.437,
                        5.319
                      ],
                      [
                        -10.128,
                        6.383
                      ],
                      [
                        -9.376,
                        4.462
                      ],
                      [
                        -4.48,
                        2.26
                      ],
                      [
                        -3.497,
                        6.249
                      ],
                      [
                        -6.091,
                        10.608
                      ],
                      [
                        -2.041,
                        17.417
                      ],
                      [
                        -0.6,
                        18.928
                      ],
                      [
                        8.385,
                        25.638
                      ],
                      [
                        15.543,
                        24.49
                      ]
                    ],
                    "c": false
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    92.032,
                    26.721
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 30",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.883,
                        6.777
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.202,
                        -4.329
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        15.614,
                        -21.486
                      ],
                      [
                        15.76,
                        26.4
                      ],
                      [
                        -4.783,
                        27.38
                      ],
                      [
                        -5.378,
                        15.733
                      ],
                      [
                        -14.558,
                        10.405
                      ],
                      [
                        -15.46,
                        -27.38
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    0.745000023935,
                    0.616000007181,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    90.898,
                    35.851
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 31",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 0,
        "op": 720,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 4,
        "ty": 4,
        "nm": "Desk Outlines",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              253.361,
              329.335,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              137.538,
              137.778,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        28.198,
                        1.301
                      ],
                      [
                        -28.198,
                        1.301
                      ],
                      [
                        -28.198,
                        -1.301
                      ],
                      [
                        28.198,
                        -1.301
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    157.017,
                    114.679
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        40.837,
                        4.35
                      ],
                      [
                        -40.837,
                        4.35
                      ],
                      [
                        -40.837,
                        -4.35
                      ],
                      [
                        40.837,
                        -4.35
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    50.579,
                    120.331
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -12.202,
                        75.313
                      ],
                      [
                        -4.682,
                        75.313
                      ],
                      [
                        12.202,
                        -75.313
                      ],
                      [
                        2.335,
                        -75.313
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    12.452,
                    199.993
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -11.828,
                        75.313
                      ],
                      [
                        -4.307,
                        75.313
                      ],
                      [
                        11.828,
                        -75.313
                      ],
                      [
                        1.96,
                        -75.313
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    76.59,
                    199.993
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 4",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        132.542,
                        4.35
                      ],
                      [
                        -71.602,
                        4.35
                      ],
                      [
                        -132.541,
                        4.35
                      ],
                      [
                        -132.541,
                        -4.35
                      ],
                      [
                        132.542,
                        -4.35
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.270999983245,
                    0.352999997606,
                    0.39199999641,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    142.284,
                    120.33
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 5",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        12.211,
                        75.313
                      ],
                      [
                        4.69,
                        75.313
                      ],
                      [
                        -12.211,
                        -75.313
                      ],
                      [
                        -2.343,
                        -75.313
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.270999983245,
                    0.352999997606,
                    0.39199999641,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    212.755,
                    199.993
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 6",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        12.148,
                        75.313
                      ],
                      [
                        4.626,
                        75.313
                      ],
                      [
                        -12.148,
                        -75.313
                      ],
                      [
                        -2.279,
                        -75.313
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.270999983245,
                    0.352999997606,
                    0.39199999641,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    260.37,
                    199.993
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 7",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.003,
                        -1.596
                      ],
                      [
                        0.073,
                        42.42
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        47.055,
                        -0.015
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.004,
                        -21.341
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.209,
                        -0.003
                      ],
                      [
                        71.942,
                        -0.085
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.003,
                        24.497
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -32.86,
                        -0.01
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -0.003,
                        -1.597
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -32.86,
                        0.01
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.004,
                        24.497
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        71.942,
                        0.085
                      ],
                      [
                        -2.208,
                        0.002
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.003,
                        -21.341
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        47.055,
                        0.014
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.073,
                        42.421
                      ]
                    ],
                    "v": [
                      [
                        61.535,
                        34.636
                      ],
                      [
                        61.414,
                        -34.627
                      ],
                      [
                        61.535,
                        -34.507
                      ],
                      [
                        -61.49,
                        -34.47
                      ],
                      [
                        -61.499,
                        -34.47
                      ],
                      [
                        -61.342,
                        -34.627
                      ],
                      [
                        -61.354,
                        34.636
                      ],
                      [
                        -61.499,
                        34.49
                      ],
                      [
                        61.535,
                        34.636
                      ],
                      [
                        -61.499,
                        34.783
                      ],
                      [
                        -61.645,
                        34.783
                      ],
                      [
                        -61.645,
                        34.636
                      ],
                      [
                        -61.655,
                        -34.627
                      ],
                      [
                        -61.655,
                        -34.783
                      ],
                      [
                        -61.499,
                        -34.783
                      ],
                      [
                        -61.49,
                        -34.783
                      ],
                      [
                        61.535,
                        -34.746
                      ],
                      [
                        61.654,
                        -34.746
                      ],
                      [
                        61.653,
                        -34.627
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    150.836,
                    42.207
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 8",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 8,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.439
                      ],
                      [
                        0.439,
                        0
                      ],
                      [
                        0,
                        0.439
                      ],
                      [
                        -0.439,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.439
                      ],
                      [
                        -0.439,
                        0
                      ],
                      [
                        0,
                        -0.439
                      ],
                      [
                        0.439,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.795,
                        0
                      ],
                      [
                        0,
                        0.795
                      ],
                      [
                        -0.795,
                        0
                      ],
                      [
                        0,
                        -0.795
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    98.897,
                    9.819
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 9",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 9,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.439
                      ],
                      [
                        0.439,
                        0
                      ],
                      [
                        0,
                        0.439
                      ],
                      [
                        -0.44,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.439
                      ],
                      [
                        -0.44,
                        0
                      ],
                      [
                        0,
                        -0.439
                      ],
                      [
                        0.439,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.796,
                        0
                      ],
                      [
                        0,
                        0.795
                      ],
                      [
                        -0.796,
                        0
                      ],
                      [
                        0,
                        -0.795
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    95.796,
                    9.819
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 10",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 10,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.439
                      ],
                      [
                        0.439,
                        0
                      ],
                      [
                        0,
                        0.439
                      ],
                      [
                        -0.439,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.439
                      ],
                      [
                        -0.439,
                        0
                      ],
                      [
                        0,
                        -0.439
                      ],
                      [
                        0.439,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.796,
                        0
                      ],
                      [
                        0,
                        0.795
                      ],
                      [
                        -0.796,
                        0
                      ],
                      [
                        0,
                        -0.795
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    92.695,
                    9.819
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 11",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 11,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        14.553,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -14.56,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -14.56,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        14.553,
                        0
                      ]
                    ],
                    "v": [
                      [
                        26.356,
                        -0.001
                      ],
                      [
                        0.002,
                        0.26
                      ],
                      [
                        -26.356,
                        -0.001
                      ],
                      [
                        0.002,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    153.25,
                    37.832
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 31,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 32,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 12",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 12,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.32,
                        1.32
                      ],
                      [
                        -1.32,
                        1.32
                      ],
                      [
                        -1.32,
                        -1.32
                      ],
                      [
                        1.32,
                        -1.32
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    123.018,
                    37.84
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 13",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 13,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.189,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.19,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.19,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.189,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.154,
                        -0.001
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -2.154,
                        -0.001
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    198.998,
                    37.84
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 30,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 31,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 14",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 14,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.189,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.19,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.19,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.189,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.154,
                        0
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -2.154,
                        0
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    198.998,
                    29.368
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 26,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 27,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 15",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 15,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        6.041,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -6.043,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -6.043,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        6.041,
                        0
                      ]
                    ],
                    "v": [
                      [
                        10.939,
                        0
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -10.94,
                        0
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    137.834,
                    29.116
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 27,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 28,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 16",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 16,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.32,
                        1.32
                      ],
                      [
                        -1.32,
                        1.32
                      ],
                      [
                        -1.32,
                        -1.32
                      ],
                      [
                        1.32,
                        -1.32
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    123.018,
                    29.124
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 17",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 17,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        46.632,
                        4.363
                      ],
                      [
                        -46.632,
                        4.363
                      ],
                      [
                        -46.632,
                        -4.363
                      ],
                      [
                        46.632,
                        -4.363
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    165.739,
                    29.318
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 18",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 18,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.145
                      ],
                      [
                        1.201,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.201,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.201,
                        0
                      ],
                      [
                        0,
                        -0.145
                      ],
                      [
                        1.201,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.175,
                        0
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -2.175,
                        0
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    199.383,
                    72.206
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 47,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 48,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 19",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 19,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        10.656,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -10.661,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -10.661,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        10.656,
                        0
                      ]
                    ],
                    "v": [
                      [
                        19.299,
                        -0.001
                      ],
                      [
                        0.001,
                        0.26
                      ],
                      [
                        -19.298,
                        -0.001
                      ],
                      [
                        0.001,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    145.887,
                    72.279
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 48,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 49,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 20",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 20,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.333,
                        1.32
                      ],
                      [
                        -1.333,
                        1.32
                      ],
                      [
                        -1.333,
                        -1.32
                      ],
                      [
                        1.333,
                        -1.32
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    122.676,
                    72.286
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 21",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 21,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        -4.363
                      ],
                      [
                        46.626,
                        -4.363
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.922000002394,
                    0.922000002394,
                    0.922000002394,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    165.746,
                    72.481
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 22",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 22,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.201,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.201,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.201,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.201,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.175,
                        -0.001
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -2.175,
                        -0.001
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    199.383,
                    63.61
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 43,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 44,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 23",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 23,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        10.656,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -10.661,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -10.661,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        10.656,
                        0
                      ]
                    ],
                    "v": [
                      [
                        19.299,
                        0
                      ],
                      [
                        0.001,
                        0.26
                      ],
                      [
                        -19.298,
                        0
                      ],
                      [
                        0.001,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    145.887,
                    63.681
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 43,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 44,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 24",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 24,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.333,
                        1.32
                      ],
                      [
                        -1.333,
                        1.32
                      ],
                      [
                        -1.333,
                        -1.32
                      ],
                      [
                        1.333,
                        -1.32
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    122.676,
                    63.689
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 25",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 25,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        -4.363
                      ],
                      [
                        46.626,
                        -4.363
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    165.746,
                    63.883
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 26",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 26,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.201,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.201,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.201,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.201,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.175,
                        -0.001
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -2.175,
                        -0.001
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    199.383,
                    55.012
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 39,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 40,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 27",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 27,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        10.656,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -10.661,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -10.661,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        10.656,
                        0
                      ]
                    ],
                    "v": [
                      [
                        19.299,
                        0
                      ],
                      [
                        0.001,
                        0.26
                      ],
                      [
                        -19.298,
                        0
                      ],
                      [
                        0.001,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    145.887,
                    55.084
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 39,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 40,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 28",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 28,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.333,
                        1.32
                      ],
                      [
                        -1.333,
                        1.32
                      ],
                      [
                        -1.333,
                        -1.32
                      ],
                      [
                        1.333,
                        -1.32
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    122.676,
                    55.092
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 29",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 29,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        -4.363
                      ],
                      [
                        46.626,
                        -4.363
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    165.746,
                    55.286
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 30",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 30,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.201,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.201,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.201,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.201,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.175,
                        0
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -2.175,
                        0
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    199.383,
                    46.415
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 33,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 34,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 31",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 31,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        10.656,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -10.661,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -10.661,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        10.656,
                        0
                      ]
                    ],
                    "v": [
                      [
                        19.299,
                        0
                      ],
                      [
                        0.001,
                        0.26
                      ],
                      [
                        -19.298,
                        0
                      ],
                      [
                        0.001,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    145.887,
                    46.487
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 34,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 35,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 32",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 32,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.333,
                        1.32
                      ],
                      [
                        -1.333,
                        1.32
                      ],
                      [
                        -1.333,
                        -1.32
                      ],
                      [
                        1.333,
                        -1.32
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    122.676,
                    46.495
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 33",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 33,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        -4.363
                      ],
                      [
                        46.626,
                        -4.363
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    165.746,
                    46.689
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 34",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 34,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.189,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.19,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -1.19,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        1.189,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.154,
                        0
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -2.154,
                        0
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    198.998,
                    20.429
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 24,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 25,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 35",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 35,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        10.555,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -10.56,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -10.56,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        10.555,
                        0
                      ]
                    ],
                    "v": [
                      [
                        19.115,
                        0
                      ],
                      [
                        0.001,
                        0.26
                      ],
                      [
                        -19.116,
                        0
                      ],
                      [
                        0.001,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    146.01,
                    20.501
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 24,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 25,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 36",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 36,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.32,
                        1.32
                      ],
                      [
                        -1.32,
                        1.32
                      ],
                      [
                        -1.32,
                        -1.32
                      ],
                      [
                        1.32,
                        -1.32
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    123.018,
                    20.509
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 37",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 37,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        -4.363
                      ],
                      [
                        46.626,
                        -4.363
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    165.746,
                    20.703
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 38",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 38,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.352,
                        0.353
                      ],
                      [
                        -0.352,
                        0.353
                      ],
                      [
                        -0.352,
                        -0.353
                      ],
                      [
                        0.352,
                        -0.353
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    199.539,
                    14.439
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 39",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 39,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.352,
                        0.353
                      ],
                      [
                        -0.352,
                        0.353
                      ],
                      [
                        -0.352,
                        -0.353
                      ],
                      [
                        0.352,
                        -0.353
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    199.539,
                    13.505
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 40",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 40,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.353,
                        0.353
                      ],
                      [
                        -0.353,
                        0.353
                      ],
                      [
                        -0.353,
                        -0.353
                      ],
                      [
                        0.353,
                        -0.353
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    198.442,
                    14.439
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 41",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 41,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.353,
                        0.353
                      ],
                      [
                        -0.353,
                        0.353
                      ],
                      [
                        -0.353,
                        -0.353
                      ],
                      [
                        0.353,
                        -0.353
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    198.442,
                    13.505
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 42",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 42,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.397,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0.398
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.398,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -0.398
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.398,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -0.398
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.397,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0.398
                      ]
                    ],
                    "v": [
                      [
                        2.094,
                        0.856
                      ],
                      [
                        -2.094,
                        0.856
                      ],
                      [
                        -2.814,
                        0.137
                      ],
                      [
                        -2.814,
                        -0.136
                      ],
                      [
                        -2.094,
                        -0.856
                      ],
                      [
                        2.094,
                        -0.856
                      ],
                      [
                        2.814,
                        -0.136
                      ],
                      [
                        2.814,
                        0.137
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    192.287,
                    14.131
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 43",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 43,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.397,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0.398
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.398,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -0.398
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.398,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -0.398
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.397,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0.398
                      ]
                    ],
                    "v": [
                      [
                        31.485,
                        0.856
                      ],
                      [
                        -31.485,
                        0.856
                      ],
                      [
                        -32.205,
                        0.137
                      ],
                      [
                        -32.205,
                        -0.136
                      ],
                      [
                        -31.485,
                        -0.856
                      ],
                      [
                        31.485,
                        -0.856
                      ],
                      [
                        32.205,
                        -0.136
                      ],
                      [
                        32.205,
                        0.137
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    153.904,
                    14.131
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 44",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 44,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        46.626,
                        2.188
                      ],
                      [
                        -46.626,
                        2.188
                      ],
                      [
                        -46.626,
                        -2.188
                      ],
                      [
                        46.626,
                        -2.188
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.961000031116,
                    0.961000031116,
                    0.961000031116,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    165.746,
                    14.153
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 45",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 45,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        4.363
                      ],
                      [
                        -46.626,
                        -4.363
                      ],
                      [
                        46.626,
                        -4.363
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.922000002394,
                    0.922000002394,
                    0.922000002394,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    165.746,
                    38.033
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 46",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 46,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.018,
                        0
                      ],
                      [
                        0.289,
                        1.075
                      ],
                      [
                        1.589,
                        1.186
                      ],
                      [
                        1.136,
                        0.193
                      ],
                      [
                        1.206,
                        -0.464
                      ],
                      [
                        0.817,
                        -1.135
                      ],
                      [
                        0.014,
                        -1.482
                      ],
                      [
                        -0.84,
                        -1.122
                      ],
                      [
                        -1.206,
                        -0.436
                      ],
                      [
                        -1.128,
                        0.187
                      ],
                      [
                        -0.787,
                        0.579
                      ],
                      [
                        -0.285,
                        1.054
                      ],
                      [
                        -0.058,
                        -0.003
                      ],
                      [
                        -0.002,
                        -0.299
                      ],
                      [
                        0.124,
                        -0.557
                      ],
                      [
                        1.644,
                        -1.29
                      ],
                      [
                        1.203,
                        -0.225
                      ],
                      [
                        1.297,
                        0.483
                      ],
                      [
                        0.884,
                        1.216
                      ],
                      [
                        0.012,
                        1.594
                      ],
                      [
                        -0.907,
                        1.2
                      ],
                      [
                        -1.296,
                        0.454
                      ],
                      [
                        -1.195,
                        -0.218
                      ],
                      [
                        -0.814,
                        -0.63
                      ],
                      [
                        -0.234,
                        -1.1
                      ],
                      [
                        0.008,
                        -0.298
                      ]
                    ],
                    "o": [
                      [
                        -0.058,
                        0.003
                      ],
                      [
                        -0.286,
                        -1.055
                      ],
                      [
                        -0.787,
                        -0.58
                      ],
                      [
                        -1.128,
                        -0.186
                      ],
                      [
                        -1.205,
                        0.436
                      ],
                      [
                        -0.839,
                        1.121
                      ],
                      [
                        0.014,
                        1.482
                      ],
                      [
                        0.816,
                        1.136
                      ],
                      [
                        1.206,
                        0.464
                      ],
                      [
                        1.136,
                        -0.193
                      ],
                      [
                        1.59,
                        -1.187
                      ],
                      [
                        0.289,
                        -1.075
                      ],
                      [
                        0.018,
                        0
                      ],
                      [
                        0.008,
                        0.299
                      ],
                      [
                        -0.233,
                        1.099
                      ],
                      [
                        -0.814,
                        0.63
                      ],
                      [
                        -1.196,
                        0.218
                      ],
                      [
                        -1.296,
                        -0.455
                      ],
                      [
                        -0.907,
                        -1.2
                      ],
                      [
                        0.013,
                        -1.594
                      ],
                      [
                        0.884,
                        -1.216
                      ],
                      [
                        1.297,
                        -0.483
                      ],
                      [
                        1.204,
                        0.225
                      ],
                      [
                        1.643,
                        1.289
                      ],
                      [
                        0.124,
                        0.557
                      ],
                      [
                        -0.002,
                        0.3
                      ]
                    ],
                    "v": [
                      [
                        7.204,
                        0
                      ],
                      [
                        6.883,
                        -1.707
                      ],
                      [
                        4.29,
                        -5.491
                      ],
                      [
                        1.38,
                        -6.755
                      ],
                      [
                        -2.223,
                        -6.436
                      ],
                      [
                        -5.396,
                        -4.042
                      ],
                      [
                        -6.721,
                        -0.001
                      ],
                      [
                        -5.396,
                        4.041
                      ],
                      [
                        -2.223,
                        6.436
                      ],
                      [
                        1.38,
                        6.754
                      ],
                      [
                        4.29,
                        5.491
                      ],
                      [
                        6.883,
                        1.707
                      ],
                      [
                        7.204,
                        0
                      ],
                      [
                        7.234,
                        0.455
                      ],
                      [
                        7.081,
                        1.756
                      ],
                      [
                        4.514,
                        5.784
                      ],
                      [
                        1.46,
                        7.179
                      ],
                      [
                        -2.387,
                        6.887
                      ],
                      [
                        -5.807,
                        4.343
                      ],
                      [
                        -7.242,
                        -0.001
                      ],
                      [
                        -5.807,
                        -4.344
                      ],
                      [
                        -2.387,
                        -6.887
                      ],
                      [
                        1.46,
                        -7.179
                      ],
                      [
                        4.514,
                        -5.784
                      ],
                      [
                        7.081,
                        -1.756
                      ],
                      [
                        7.234,
                        -0.456
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    103.759,
                    23.433
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 47",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 47,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        1.381,
                        0
                      ],
                      [
                        0,
                        -1.381
                      ],
                      [
                        -1.38,
                        0
                      ],
                      [
                        0,
                        1.38
                      ]
                    ],
                    "o": [
                      [
                        -1.38,
                        0
                      ],
                      [
                        0,
                        1.38
                      ],
                      [
                        1.381,
                        0
                      ],
                      [
                        0,
                        -1.381
                      ]
                    ],
                    "v": [
                      [
                        0,
                        -2.5
                      ],
                      [
                        -2.5,
                        0
                      ],
                      [
                        0,
                        2.5
                      ],
                      [
                        2.5,
                        0
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    103.965,
                    21.238
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 48",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 48,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        1.845,
                        0
                      ],
                      [
                        0,
                        -1.844
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.153,
                        0
                      ],
                      [
                        -1.029,
                        0.581
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -1.845,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.962,
                        0.488
                      ],
                      [
                        1.266,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.844
                      ]
                    ],
                    "v": [
                      [
                        0,
                        -3.14
                      ],
                      [
                        -3.34,
                        0.201
                      ],
                      [
                        -3.34,
                        2.37
                      ],
                      [
                        -0.141,
                        3.14
                      ],
                      [
                        3.34,
                        2.223
                      ],
                      [
                        3.34,
                        0.201
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    103.965,
                    27.387
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 49",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 49,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        1.381,
                        0
                      ],
                      [
                        0,
                        1.381
                      ],
                      [
                        -1.38,
                        0
                      ],
                      [
                        0,
                        -1.38
                      ]
                    ],
                    "o": [
                      [
                        -1.38,
                        0
                      ],
                      [
                        0,
                        -1.38
                      ],
                      [
                        1.381,
                        0
                      ],
                      [
                        0,
                        1.381
                      ]
                    ],
                    "v": [
                      [
                        0.14,
                        0.689
                      ],
                      [
                        -2.36,
                        -1.811
                      ],
                      [
                        0.14,
                        -4.311
                      ],
                      [
                        2.64,
                        -1.811
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        3.917,
                        0
                      ],
                      [
                        0,
                        -3.917
                      ],
                      [
                        -2.308,
                        -1.17
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.845,
                        0
                      ],
                      [
                        0,
                        -1.845
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        2.652
                      ]
                    ],
                    "o": [
                      [
                        -3.917,
                        0
                      ],
                      [
                        0,
                        2.764
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.845
                      ],
                      [
                        1.845,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.154,
                        -1.217
                      ],
                      [
                        0,
                        -3.917
                      ]
                    ],
                    "v": [
                      [
                        0,
                        -6.708
                      ],
                      [
                        -7.093,
                        0.384
                      ],
                      [
                        -3.2,
                        6.708
                      ],
                      [
                        -3.2,
                        4.539
                      ],
                      [
                        0.14,
                        1.198
                      ],
                      [
                        3.481,
                        4.539
                      ],
                      [
                        3.481,
                        6.56
                      ],
                      [
                        7.093,
                        0.384
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    103.825,
                    23.049
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 50",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 50,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        5.287,
                        0
                      ],
                      [
                        0,
                        0.145
                      ],
                      [
                        -5.29,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.145
                      ],
                      [
                        -5.29,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        5.287,
                        0
                      ]
                    ],
                    "v": [
                      [
                        9.576,
                        -0.001
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -9.576,
                        -0.001
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    104.364,
                    72.765
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 40,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 41,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 51",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 51,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        5.287,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -5.29,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -5.29,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        5.287,
                        0
                      ]
                    ],
                    "v": [
                      [
                        9.576,
                        0
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -9.576,
                        0
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    104.364,
                    58.2
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 34,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 35,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 52",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 52,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        4.036,
                        0
                      ],
                      [
                        0,
                        0.145
                      ],
                      [
                        -4.037,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.145
                      ],
                      [
                        -4.037,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        4.036,
                        0
                      ]
                    ],
                    "v": [
                      [
                        7.308,
                        -0.001
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -7.308,
                        -0.001
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    104.158,
                    65.055
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 36,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 37,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 53",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 53,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        4.036,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -4.036,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -4.036,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        4.036,
                        0
                      ]
                    ],
                    "v": [
                      [
                        7.308,
                        0
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -7.308,
                        0
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    102.097,
                    51.493
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 30,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 31,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 54",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 54,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        8.147,
                        0
                      ],
                      [
                        0,
                        0.145
                      ],
                      [
                        -8.151,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.145
                      ],
                      [
                        -8.151,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        8.147,
                        0
                      ]
                    ],
                    "v": [
                      [
                        14.755,
                        -0.001
                      ],
                      [
                        0.001,
                        0.26
                      ],
                      [
                        -14.755,
                        -0.001
                      ],
                      [
                        0.001,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    104.364,
                    68.963
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 55",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 55,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        5.287,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -5.29,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -5.29,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        5.287,
                        0
                      ]
                    ],
                    "v": [
                      [
                        9.576,
                        0
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -9.576,
                        0
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    104.364,
                    39.313
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 25,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 26,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 56",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 56,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        5.287,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -5.29,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -5.29,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        5.287,
                        0
                      ]
                    ],
                    "v": [
                      [
                        9.576,
                        0
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -9.576,
                        0
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    104.364,
                    45.373
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 28,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 29,
                      "s": [
                        100
                      ]
                    }
                  ],
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 57",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 57,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -250,
                        250
                      ],
                      [
                        250,
                        250
                      ],
                      [
                        250,
                        -250
                      ],
                      [
                        -250,
                        -250
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -250,
                        -250
                      ],
                      [
                        250,
                        -250
                      ],
                      [
                        250,
                        250
                      ],
                      [
                        -250,
                        250
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 2,
                "ty": "sh",
                "ix": 3,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -44.838,
                        10.52
                      ],
                      [
                        -15.069,
                        10.52
                      ],
                      [
                        -15.069,
                        4.097
                      ],
                      [
                        -44.838,
                        4.097
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 3",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    134.176,
                    58.443
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 48,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 58",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 58,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -250,
                        250
                      ],
                      [
                        250,
                        250
                      ],
                      [
                        250,
                        -250
                      ],
                      [
                        -250,
                        -250
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -250,
                        -250
                      ],
                      [
                        250,
                        -250
                      ],
                      [
                        250,
                        250
                      ],
                      [
                        -250,
                        250
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 2,
                "ty": "sh",
                "ix": 3,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -44.838,
                        -4.258
                      ],
                      [
                        -15.069,
                        -4.258
                      ],
                      [
                        -15.069,
                        -10.065
                      ],
                      [
                        -44.838,
                        -10.065
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 3",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    134.176,
                    58.443
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 48,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 59",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 59,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -250,
                        250
                      ],
                      [
                        250,
                        250
                      ],
                      [
                        250,
                        -250
                      ],
                      [
                        -250,
                        -250
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -250,
                        -250
                      ],
                      [
                        250,
                        -250
                      ],
                      [
                        250,
                        250
                      ],
                      [
                        -250,
                        250
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 2,
                "ty": "sh",
                "ix": 3,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -44.838,
                        -16.116
                      ],
                      [
                        -15.069,
                        -16.116
                      ],
                      [
                        -15.069,
                        -21.923
                      ],
                      [
                        -44.838,
                        -21.923
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 3",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    134.051,
                    58.38
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 48,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 60",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 60,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        14.891,
                        32.439
                      ],
                      [
                        -14.891,
                        32.439
                      ],
                      [
                        -14.891,
                        -32.439
                      ],
                      [
                        14.891,
                        -32.439
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    104.229,
                    44.404
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 61",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 61,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0.006,
                        0.862
                      ],
                      [
                        0.01,
                        1.667
                      ],
                      [
                        0.023,
                        6.31
                      ],
                      [
                        0.045,
                        22.326
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        48.311,
                        -0.023
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.006,
                        -22.427
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -22.354,
                        -0.029
                      ],
                      [
                        -6.085,
                        -0.015
                      ],
                      [
                        -1.595,
                        -0.007
                      ],
                      [
                        -0.416,
                        -0.004
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.397,
                        -0.005
                      ],
                      [
                        0.774,
                        -0.006
                      ],
                      [
                        3.016,
                        -0.013
                      ],
                      [
                        11.161,
                        -0.028
                      ],
                      [
                        37.117,
                        -0.048
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.007,
                        25.771
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -33.92,
                        -0.016
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.025,
                        -12.643
                      ],
                      [
                        0.012,
                        -3.341
                      ],
                      [
                        0.005,
                        -0.864
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.005,
                        -0.873
                      ],
                      [
                        -0.012,
                        -3.35
                      ],
                      [
                        -0.025,
                        -12.613
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -33.92,
                        0.016
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.007,
                        25.771
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        37.052,
                        0.048
                      ],
                      [
                        11.185,
                        0.028
                      ],
                      [
                        3.037,
                        0.013
                      ],
                      [
                        0.785,
                        0.006
                      ],
                      [
                        0.406,
                        0.004
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.41,
                        0.004
                      ],
                      [
                        -1.583,
                        0.007
                      ],
                      [
                        -6.073,
                        0.015
                      ],
                      [
                        -22.394,
                        0.029
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.006,
                        -22.427
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        48.311,
                        0.023
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.045,
                        22.378
                      ],
                      [
                        -0.022,
                        6.291
                      ],
                      [
                        -0.01,
                        1.651
                      ],
                      [
                        -0.007,
                        0.849
                      ]
                    ],
                    "v": [
                      [
                        63.3,
                        36.421
                      ],
                      [
                        63.279,
                        35.107
                      ],
                      [
                        63.256,
                        31.292
                      ],
                      [
                        63.205,
                        16.715
                      ],
                      [
                        63.099,
                        -36.404
                      ],
                      [
                        63.3,
                        -36.204
                      ],
                      [
                        -63.23,
                        -36.144
                      ],
                      [
                        -63.24,
                        -36.144
                      ],
                      [
                        -62.979,
                        -36.404
                      ],
                      [
                        -62.997,
                        36.421
                      ],
                      [
                        -63.24,
                        36.18
                      ],
                      [
                        27.767,
                        36.298
                      ],
                      [
                        53.906,
                        36.363
                      ],
                      [
                        60.877,
                        36.393
                      ],
                      [
                        62.679,
                        36.408
                      ],
                      [
                        63.3,
                        36.421
                      ],
                      [
                        62.708,
                        36.437
                      ],
                      [
                        60.933,
                        36.451
                      ],
                      [
                        54.012,
                        36.48
                      ],
                      [
                        27.928,
                        36.546
                      ],
                      [
                        -63.24,
                        36.663
                      ],
                      [
                        -63.482,
                        36.665
                      ],
                      [
                        -63.482,
                        36.421
                      ],
                      [
                        -63.5,
                        -36.404
                      ],
                      [
                        -63.5,
                        -36.665
                      ],
                      [
                        -63.24,
                        -36.665
                      ],
                      [
                        -63.23,
                        -36.665
                      ],
                      [
                        63.3,
                        -36.605
                      ],
                      [
                        63.5,
                        -36.605
                      ],
                      [
                        63.5,
                        -36.404
                      ],
                      [
                        63.394,
                        16.839
                      ],
                      [
                        63.343,
                        31.37
                      ],
                      [
                        63.321,
                        35.148
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    151.159,
                    42.203
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 62",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 62,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        63.27,
                        36.413
                      ],
                      [
                        -63.27,
                        36.413
                      ],
                      [
                        -63.27,
                        -36.413
                      ],
                      [
                        63.27,
                        -36.413
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    151.189,
                    42.212
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 63",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 63,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -1.521
                      ],
                      [
                        1.523,
                        0
                      ],
                      [
                        0,
                        1.521
                      ],
                      [
                        -1.521,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        1.521
                      ],
                      [
                        -1.521,
                        0
                      ],
                      [
                        0,
                        -1.521
                      ],
                      [
                        1.523,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.756,
                        0
                      ],
                      [
                        -0.001,
                        2.756
                      ],
                      [
                        -2.756,
                        0
                      ],
                      [
                        -0.001,
                        -2.756
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    154.161,
                    86.759
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 64",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 64,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.431,
                        1.581
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -11.538,
                        -2.109
                      ],
                      [
                        -12.771,
                        0.364
                      ],
                      [
                        9.509,
                        2.11
                      ],
                      [
                        12.77,
                        -2.109
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    150.539,
                    98.137
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 65",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 65,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -11.56,
                        11.837
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -7.479,
                        -7.479
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        15.477,
                        -9.976
                      ],
                      [
                        -8.832,
                        -9.976
                      ],
                      [
                        -8.832,
                        9.976
                      ],
                      [
                        16.311,
                        9.976
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    147.832,
                    106.004
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 66",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 66,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.197,
                        0.014
                      ],
                      [
                        -0.386,
                        0.068
                      ],
                      [
                        -1.347,
                        0.711
                      ],
                      [
                        -1.026,
                        1.983
                      ],
                      [
                        -0.115,
                        1.272
                      ],
                      [
                        -0.016,
                        1.448
                      ],
                      [
                        0.034,
                        20.765
                      ],
                      [
                        0.006,
                        5.669
                      ],
                      [
                        0.003,
                        2.946
                      ],
                      [
                        0.002,
                        1.499
                      ],
                      [
                        1.285,
                        0.684
                      ],
                      [
                        0.751,
                        -0.025
                      ],
                      [
                        0.777,
                        0
                      ],
                      [
                        1.578,
                        -0.001
                      ],
                      [
                        3.253,
                        -0.002
                      ],
                      [
                        6.866,
                        -0.004
                      ],
                      [
                        31.69,
                        -0.008
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.446,
                        -0.09
                      ],
                      [
                        -0.002,
                        -1.858
                      ],
                      [
                        0.001,
                        -3.857
                      ],
                      [
                        0.001,
                        -7.473
                      ],
                      [
                        0.005,
                        -13.734
                      ],
                      [
                        -0.08,
                        -1.652
                      ],
                      [
                        -0.961,
                        -1.317
                      ],
                      [
                        -1.469,
                        -0.659
                      ],
                      [
                        -1.626,
                        0.041
                      ],
                      [
                        -6.106,
                        -0.004
                      ],
                      [
                        -10.387,
                        -0.009
                      ],
                      [
                        -11.626,
                        -0.019
                      ],
                      [
                        -3.067,
                        -0.01
                      ],
                      [
                        -0.794,
                        -0.006
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.784,
                        -0.008
                      ],
                      [
                        1.521,
                        -0.012
                      ],
                      [
                        5.8,
                        -0.022
                      ],
                      [
                        20.763,
                        -0.036
                      ],
                      [
                        12.212,
                        -0.012
                      ],
                      [
                        6.505,
                        -0.004
                      ],
                      [
                        1.531,
                        0.723
                      ],
                      [
                        0.996,
                        1.399
                      ],
                      [
                        0.155,
                        1.727
                      ],
                      [
                        0.019,
                        1.724
                      ],
                      [
                        0.005,
                        14.945
                      ],
                      [
                        0.001,
                        7.718
                      ],
                      [
                        -0.001,
                        3.915
                      ],
                      [
                        -0.672,
                        0.793
                      ],
                      [
                        -1.028,
                        0.184
                      ],
                      [
                        -0.482,
                        0.006
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -27.463,
                        -0.006
                      ],
                      [
                        -6.505,
                        -0.003
                      ],
                      [
                        -3.154,
                        -0.002
                      ],
                      [
                        -1.552,
                        -0.001
                      ],
                      [
                        -0.771,
                        0
                      ],
                      [
                        -0.705,
                        -0.376
                      ],
                      [
                        -0.008,
                        -1.582
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.002,
                        -2.834
                      ],
                      [
                        0.005,
                        -5.192
                      ],
                      [
                        0.02,
                        -11.627
                      ],
                      [
                        0.096,
                        -1.302
                      ],
                      [
                        0.526,
                        -0.996
                      ],
                      [
                        1.342,
                        -0.727
                      ],
                      [
                        0.778,
                        -0.079
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0.197,
                        -0.025
                      ],
                      [
                        0.771,
                        -0.095
                      ],
                      [
                        1.319,
                        -0.732
                      ],
                      [
                        0.509,
                        -0.983
                      ],
                      [
                        0.085,
                        -1.268
                      ],
                      [
                        -0.02,
                        -11.627
                      ],
                      [
                        -0.006,
                        -5.192
                      ],
                      [
                        -0.002,
                        -2.834
                      ],
                      [
                        -0.002,
                        -1.472
                      ],
                      [
                        -0.01,
                        -1.433
                      ],
                      [
                        -0.646,
                        -0.338
                      ],
                      [
                        -0.771,
                        0.001
                      ],
                      [
                        -1.552,
                        0.001
                      ],
                      [
                        -3.154,
                        0.002
                      ],
                      [
                        -6.505,
                        0.004
                      ],
                      [
                        -27.463,
                        0.006
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.502,
                        0.005
                      ],
                      [
                        -1.85,
                        0.292
                      ],
                      [
                        -0.002,
                        3.912
                      ],
                      [
                        -0.002,
                        7.718
                      ],
                      [
                        -0.006,
                        14.945
                      ],
                      [
                        0.017,
                        1.707
                      ],
                      [
                        0.148,
                        1.643
                      ],
                      [
                        0.946,
                        1.332
                      ],
                      [
                        1.476,
                        0.69
                      ],
                      [
                        6.505,
                        0.004
                      ],
                      [
                        12.212,
                        0.012
                      ],
                      [
                        20.763,
                        0.035
                      ],
                      [
                        5.8,
                        0.022
                      ],
                      [
                        1.521,
                        0.012
                      ],
                      [
                        0.784,
                        0.008
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.794,
                        0.006
                      ],
                      [
                        -3.067,
                        0.01
                      ],
                      [
                        -11.626,
                        0.019
                      ],
                      [
                        -10.387,
                        0.009
                      ],
                      [
                        -6.106,
                        0.005
                      ],
                      [
                        -1.613,
                        0.045
                      ],
                      [
                        -1.544,
                        -0.692
                      ],
                      [
                        -1.011,
                        -1.383
                      ],
                      [
                        -0.086,
                        -1.733
                      ],
                      [
                        -0.005,
                        -13.734
                      ],
                      [
                        -0.002,
                        -7.473
                      ],
                      [
                        0.001,
                        -3.86
                      ],
                      [
                        0.011,
                        -1.039
                      ],
                      [
                        0.67,
                        -0.799
                      ],
                      [
                        0.523,
                        -0.102
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        31.69,
                        0.007
                      ],
                      [
                        6.866,
                        0.004
                      ],
                      [
                        3.253,
                        0.002
                      ],
                      [
                        1.578,
                        0.001
                      ],
                      [
                        0.777,
                        0.001
                      ],
                      [
                        0.789,
                        -0.026
                      ],
                      [
                        1.421,
                        0.757
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.003,
                        2.946
                      ],
                      [
                        -0.006,
                        5.669
                      ],
                      [
                        -0.035,
                        20.765
                      ],
                      [
                        -0.024,
                        1.455
                      ],
                      [
                        -0.124,
                        1.296
                      ],
                      [
                        -1.056,
                        2.007
                      ],
                      [
                        -1.37,
                        0.704
                      ],
                      [
                        -0.783,
                        0.075
                      ]
                    ],
                    "v": [
                      [
                        60.575,
                        47.752
                      ],
                      [
                        60.872,
                        47.724
                      ],
                      [
                        61.753,
                        47.644
                      ],
                      [
                        65.027,
                        46.577
                      ],
                      [
                        68.887,
                        42.61
                      ],
                      [
                        69.882,
                        39.197
                      ],
                      [
                        69.915,
                        35.097
                      ],
                      [
                        69.833,
                        -14.1
                      ],
                      [
                        69.814,
                        -30.401
                      ],
                      [
                        69.807,
                        -39.072
                      ],
                      [
                        69.8,
                        -43.528
                      ],
                      [
                        67.656,
                        -47.039
                      ],
                      [
                        65.544,
                        -47.52
                      ],
                      [
                        63.223,
                        -47.519
                      ],
                      [
                        58.528,
                        -47.515
                      ],
                      [
                        48.916,
                        -47.509
                      ],
                      [
                        28.851,
                        -47.498
                      ],
                      [
                        -60.492,
                        -47.477
                      ],
                      [
                        -63.459,
                        -47.477
                      ],
                      [
                        -64.939,
                        -47.477
                      ],
                      [
                        -66.367,
                        -47.412
                      ],
                      [
                        -69.679,
                        -43.531
                      ],
                      [
                        -69.684,
                        -31.876
                      ],
                      [
                        -69.688,
                        -9.08
                      ],
                      [
                        -69.703,
                        34.015
                      ],
                      [
                        -69.666,
                        39.11
                      ],
                      [
                        -67.977,
                        43.671
                      ],
                      [
                        -64.259,
                        46.713
                      ],
                      [
                        -59.557,
                        47.523
                      ],
                      [
                        -40.63,
                        47.536
                      ],
                      [
                        -6.656,
                        47.568
                      ],
                      [
                        42.537,
                        47.65
                      ],
                      [
                        55.911,
                        47.699
                      ],
                      [
                        59.389,
                        47.726
                      ],
                      [
                        60.575,
                        47.752
                      ],
                      [
                        59.389,
                        47.778
                      ],
                      [
                        55.911,
                        47.805
                      ],
                      [
                        42.537,
                        47.854
                      ],
                      [
                        -6.656,
                        47.937
                      ],
                      [
                        -40.63,
                        47.968
                      ],
                      [
                        -59.557,
                        47.981
                      ],
                      [
                        -64.449,
                        47.137
                      ],
                      [
                        -68.358,
                        43.945
                      ],
                      [
                        -70.138,
                        39.151
                      ],
                      [
                        -70.183,
                        34.015
                      ],
                      [
                        -70.198,
                        -9.08
                      ],
                      [
                        -70.202,
                        -31.876
                      ],
                      [
                        -70.199,
                        -43.54
                      ],
                      [
                        -69.118,
                        -46.399
                      ],
                      [
                        -66.458,
                        -47.924
                      ],
                      [
                        -64.939,
                        -47.998
                      ],
                      [
                        -63.459,
                        -47.998
                      ],
                      [
                        -60.492,
                        -47.998
                      ],
                      [
                        28.851,
                        -47.978
                      ],
                      [
                        48.916,
                        -47.967
                      ],
                      [
                        58.528,
                        -47.96
                      ],
                      [
                        63.223,
                        -47.957
                      ],
                      [
                        65.544,
                        -47.956
                      ],
                      [
                        67.86,
                        -47.419
                      ],
                      [
                        70.225,
                        -43.536
                      ],
                      [
                        70.225,
                        -39.072
                      ],
                      [
                        70.217,
                        -30.401
                      ],
                      [
                        70.2,
                        -14.1
                      ],
                      [
                        70.118,
                        35.097
                      ],
                      [
                        70.059,
                        39.214
                      ],
                      [
                        69.024,
                        42.682
                      ],
                      [
                        65.077,
                        46.67
                      ],
                      [
                        61.76,
                        47.697
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    151.153,
                    48.276
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 67",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 67,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        5.215,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        5.214
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.365,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.365
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -5.214,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.365
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.364,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        5.214
                      ]
                    ],
                    "v": [
                      [
                        60.539,
                        47.745
                      ],
                      [
                        -60.538,
                        47.745
                      ],
                      [
                        -69.98,
                        38.304
                      ],
                      [
                        -69.98,
                        -43.463
                      ],
                      [
                        -65.698,
                        -47.745
                      ],
                      [
                        65.699,
                        -47.745
                      ],
                      [
                        69.98,
                        -43.463
                      ],
                      [
                        69.98,
                        38.304
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    151.188,
                    48.283
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 68",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 68,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 0,
        "op": 720,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 5,
        "ty": 4,
        "nm": "Shape Layer 3",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.667
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.333
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 40,
                "s": [
                  50
                ]
              },
              {
                "t": 57,
                "s": [
                  -57
                ]
              }
            ],
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 40,
                "s": [
                  236,
                  243,
                  0
                ],
                "to": [
                  -51.167,
                  -8.083,
                  0
                ],
                "ti": [
                  51.167,
                  8.083,
                  0
                ]
              },
              {
                "t": 57,
                "s": [
                  -71,
                  194.5,
                  0
                ]
              }
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              29,
              196,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.093,
                        0.087
                      ],
                      [
                        -5.059,
                        -5.406
                      ],
                      [
                        0.093,
                        -0.087
                      ],
                      [
                        5.061,
                        5.407
                      ]
                    ],
                    "o": [
                      [
                        0.093,
                        -0.087
                      ],
                      [
                        5.061,
                        5.407
                      ],
                      [
                        -0.094,
                        0.088
                      ],
                      [
                        -5.059,
                        -5.406
                      ]
                    ],
                    "v": [
                      [
                        -9.162,
                        -9.79
                      ],
                      [
                        0.168,
                        -0.158
                      ],
                      [
                        9.162,
                        9.789
                      ],
                      [
                        -0.169,
                        0.157
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    44.798,
                    204.816
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 13",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.104,
                        0.073
                      ],
                      [
                        -4.291,
                        6.118
                      ],
                      [
                        -0.104,
                        -0.073
                      ],
                      [
                        4.292,
                        -6.12
                      ]
                    ],
                    "o": [
                      [
                        -0.104,
                        -0.073
                      ],
                      [
                        4.292,
                        -6.119
                      ],
                      [
                        0.104,
                        0.073
                      ],
                      [
                        -4.29,
                        6.117
                      ]
                    ],
                    "v": [
                      [
                        -7.77,
                        11.078
                      ],
                      [
                        -0.189,
                        -0.133
                      ],
                      [
                        7.77,
                        -11.079
                      ],
                      [
                        0.188,
                        0.133
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    11.062,
                    208.028
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 14",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.011,
                        -0.011
                      ],
                      [
                        0.293,
                        -0.315
                      ],
                      [
                        0.54,
                        -0.566
                      ],
                      [
                        2.023,
                        -2.065
                      ],
                      [
                        6.306,
                        -6.343
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.13,
                        0.087
                      ],
                      [
                        4.982,
                        3.322
                      ],
                      [
                        1.417,
                        0.96
                      ],
                      [
                        0.396,
                        0.276
                      ],
                      [
                        -0.009,
                        0.014
                      ],
                      [
                        -0.373,
                        -0.229
                      ],
                      [
                        -0.673,
                        -0.424
                      ],
                      [
                        -2.463,
                        -1.596
                      ],
                      [
                        -7.559,
                        -4.977
                      ],
                      [
                        -0.12,
                        -0.079
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -4.185,
                        4.158
                      ],
                      [
                        -1.205,
                        1.18
                      ],
                      [
                        -0.343,
                        0.327
                      ]
                    ],
                    "o": [
                      [
                        0.011,
                        0.012
                      ],
                      [
                        -0.328,
                        0.343
                      ],
                      [
                        -1.18,
                        1.205
                      ],
                      [
                        -4.159,
                        4.183
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.12,
                        -0.08
                      ],
                      [
                        -7.53,
                        -5.021
                      ],
                      [
                        -2.429,
                        -1.645
                      ],
                      [
                        -0.654,
                        -0.455
                      ],
                      [
                        -0.356,
                        -0.254
                      ],
                      [
                        0.008,
                        -0.014
                      ],
                      [
                        0.407,
                        0.257
                      ],
                      [
                        1.437,
                        0.931
                      ],
                      [
                        5.001,
                        3.293
                      ],
                      [
                        0.131,
                        0.086
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        6.344,
                        -6.303
                      ],
                      [
                        2.065,
                        -2.021
                      ],
                      [
                        0.565,
                        -0.54
                      ],
                      [
                        0.315,
                        -0.294
                      ]
                    ],
                    "v": [
                      [
                        25.333,
                        -11.592
                      ],
                      [
                        24.901,
                        -11.094
                      ],
                      [
                        23.6,
                        -9.734
                      ],
                      [
                        18.751,
                        -4.783
                      ],
                      [
                        2.592,
                        11.469
                      ],
                      [
                        2.458,
                        11.602
                      ],
                      [
                        2.3,
                        11.499
                      ],
                      [
                        1.919,
                        11.245
                      ],
                      [
                        -17.406,
                        -1.641
                      ],
                      [
                        -23.232,
                        -5.589
                      ],
                      [
                        -24.805,
                        -6.684
                      ],
                      [
                        -25.335,
                        -7.09
                      ],
                      [
                        -24.753,
                        -6.76
                      ],
                      [
                        -23.133,
                        -5.74
                      ],
                      [
                        -17.225,
                        -1.913
                      ],
                      [
                        2.174,
                        10.861
                      ],
                      [
                        2.555,
                        11.113
                      ],
                      [
                        2.266,
                        11.141
                      ],
                      [
                        18.521,
                        -5.012
                      ],
                      [
                        23.475,
                        -9.861
                      ],
                      [
                        24.835,
                        -11.16
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    25.594,
                    192.046
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 15",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        26.85,
                        14.825
                      ],
                      [
                        -23.816,
                        19.326
                      ],
                      [
                        -26.85,
                        -14.825
                      ],
                      [
                        23.816,
                        -19.326
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    27.109,
                    199.781
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 16",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 0,
        "op": 720,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 6,
        "ty": 4,
        "nm": "Screen Outlines",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              182.517,
              137.142,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              135.779,
              92,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        2.124,
                        0.002
                      ],
                      [
                        -158.99,
                        0.14
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.007,
                        -65.252
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        74.521,
                        0.014
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.002,
                        1.708
                      ],
                      [
                        -0.127,
                        -111.421
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -101.533,
                        0.019
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.007,
                        55.697
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        2.125,
                        -0.002
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.007,
                        55.697
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -101.533,
                        -0.019
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.126,
                        -111.421
                      ],
                      [
                        0.002,
                        1.707
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        74.521,
                        -0.015
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.009,
                        -65.252
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -158.99,
                        -0.14
                      ]
                    ],
                    "v": [
                      [
                        -134.91,
                        -91.512
                      ],
                      [
                        134.858,
                        -91.749
                      ],
                      [
                        135.096,
                        -91.749
                      ],
                      [
                        135.096,
                        -91.512
                      ],
                      [
                        135.118,
                        91.467
                      ],
                      [
                        135.118,
                        91.488
                      ],
                      [
                        135.118,
                        91.749
                      ],
                      [
                        134.858,
                        91.748
                      ],
                      [
                        -134.91,
                        91.697
                      ],
                      [
                        -135.118,
                        91.696
                      ],
                      [
                        -135.118,
                        91.488
                      ],
                      [
                        -134.91,
                        -91.512
                      ],
                      [
                        -134.701,
                        91.488
                      ],
                      [
                        -134.91,
                        91.281
                      ],
                      [
                        134.858,
                        91.229
                      ],
                      [
                        134.597,
                        91.488
                      ],
                      [
                        134.597,
                        91.467
                      ],
                      [
                        134.619,
                        -91.512
                      ],
                      [
                        134.858,
                        -91.274
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    136.19,
                    92
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        20.074,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -20.08,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -20.08,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        20.074,
                        0
                      ]
                    ],
                    "v": [
                      [
                        36.352,
                        0
                      ],
                      [
                        0.002,
                        0.26
                      ],
                      [
                        -36.352,
                        0
                      ],
                      [
                        0.002,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    16.763,
                    103.447
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    -37,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 50,
                      "s": [
                        0,
                        100
                      ]
                    },
                    {
                      "t": 59,
                      "s": [
                        100,
                        100
                      ]
                    }
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        4.681,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -4.681,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -4.681,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        4.681,
                        0
                      ]
                    ],
                    "v": [
                      [
                        8.476,
                        0
                      ],
                      [
                        0,
                        0.26
                      ],
                      [
                        -8.476,
                        0
                      ],
                      [
                        0,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    16.887,
                    90.503
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    -9,
                    -0.25
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 42,
                      "s": [
                        0,
                        100
                      ]
                    },
                    {
                      "t": 51,
                      "s": [
                        100,
                        100
                      ]
                    }
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        73.707,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -73.733,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -73.733,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        73.707,
                        0
                      ]
                    ],
                    "v": [
                      [
                        133.479,
                        -0.001
                      ],
                      [
                        0.007,
                        0.26
                      ],
                      [
                        -133.479,
                        -0.001
                      ],
                      [
                        0.007,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    134.759,
                    36.352
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 4",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        73.735,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -73.761,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -73.761,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        73.735,
                        0
                      ]
                    ],
                    "v": [
                      [
                        133.529,
                        -0.001
                      ],
                      [
                        0.007,
                        0.26
                      ],
                      [
                        -133.529,
                        -0.001
                      ],
                      [
                        0.007,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    134.708,
                    51.763
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 5",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        73.707,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -73.733,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -73.733,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        73.707,
                        0
                      ]
                    ],
                    "v": [
                      [
                        133.479,
                        0
                      ],
                      [
                        0.007,
                        0.26
                      ],
                      [
                        -133.479,
                        0
                      ],
                      [
                        0.007,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    134.759,
                    69.328
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 6",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.018
                      ],
                      [
                        0.309,
                        -0.016
                      ],
                      [
                        0.536,
                        -0.02
                      ],
                      [
                        2.038,
                        -0.034
                      ],
                      [
                        6.411,
                        0
                      ],
                      [
                        4.202,
                        0.047
                      ],
                      [
                        1.259,
                        0.021
                      ],
                      [
                        0.37,
                        0.014
                      ],
                      [
                        0,
                        0.018
                      ],
                      [
                        -0.309,
                        0.016
                      ],
                      [
                        -0.536,
                        0.02
                      ],
                      [
                        -2.038,
                        0.034
                      ],
                      [
                        -6.414,
                        0
                      ],
                      [
                        -4.202,
                        -0.047
                      ],
                      [
                        -1.259,
                        -0.02
                      ],
                      [
                        -0.37,
                        -0.014
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.018
                      ],
                      [
                        -0.37,
                        0.014
                      ],
                      [
                        -1.259,
                        0.021
                      ],
                      [
                        -4.202,
                        0.047
                      ],
                      [
                        -6.414,
                        0
                      ],
                      [
                        -2.038,
                        -0.034
                      ],
                      [
                        -0.536,
                        -0.02
                      ],
                      [
                        -0.309,
                        -0.016
                      ],
                      [
                        0,
                        -0.018
                      ],
                      [
                        0.37,
                        -0.014
                      ],
                      [
                        1.259,
                        -0.02
                      ],
                      [
                        4.202,
                        -0.047
                      ],
                      [
                        6.411,
                        0
                      ],
                      [
                        2.038,
                        0.034
                      ],
                      [
                        0.536,
                        0.02
                      ],
                      [
                        0.309,
                        0.016
                      ]
                    ],
                    "v": [
                      [
                        23.222,
                        0
                      ],
                      [
                        22.75,
                        0.052
                      ],
                      [
                        21.397,
                        0.102
                      ],
                      [
                        16.42,
                        0.184
                      ],
                      [
                        0.001,
                        0.26
                      ],
                      [
                        -16.421,
                        0.184
                      ],
                      [
                        -21.398,
                        0.102
                      ],
                      [
                        -22.751,
                        0.052
                      ],
                      [
                        -23.222,
                        0
                      ],
                      [
                        -22.751,
                        -0.052
                      ],
                      [
                        -21.398,
                        -0.102
                      ],
                      [
                        -16.421,
                        -0.184
                      ],
                      [
                        0.001,
                        -0.26
                      ],
                      [
                        16.42,
                        -0.184
                      ],
                      [
                        21.397,
                        -0.102
                      ],
                      [
                        22.75,
                        -0.052
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    46.897,
                    60.068
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    -23.25,
                    -0.5
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 34,
                      "s": [
                        0,
                        100
                      ]
                    },
                    {
                      "t": 43,
                      "s": [
                        100,
                        100
                      ]
                    }
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 7",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        28.406,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -28.417,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -28.417,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        28.406,
                        0
                      ]
                    ],
                    "v": [
                      [
                        51.443,
                        0
                      ],
                      [
                        0.003,
                        0.26
                      ],
                      [
                        -51.443,
                        0
                      ],
                      [
                        0.003,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    28.219,
                    44.465
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    -51.75,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 28,
                      "s": [
                        0,
                        100
                      ]
                    },
                    {
                      "t": 35,
                      "s": [
                        100,
                        100
                      ]
                    }
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 8",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 8,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -0.144
                      ],
                      [
                        19.638,
                        0
                      ],
                      [
                        0,
                        0.144
                      ],
                      [
                        -19.645,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.144
                      ],
                      [
                        -19.645,
                        0
                      ],
                      [
                        0,
                        -0.144
                      ],
                      [
                        19.638,
                        0
                      ]
                    ],
                    "v": [
                      [
                        35.564,
                        0
                      ],
                      [
                        0.001,
                        0.26
                      ],
                      [
                        -35.564,
                        0
                      ],
                      [
                        0.001,
                        -0.26
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    28.34,
                    27.488
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    -36,
                    -0.5
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833,
                          0.833
                        ],
                        "y": [
                          0.833,
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167,
                          0.167
                        ],
                        "y": [
                          0.167,
                          0.167
                        ]
                      },
                      "t": 21,
                      "s": [
                        0,
                        100
                      ]
                    },
                    {
                      "t": 27,
                      "s": [
                        100,
                        100
                      ]
                    }
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 9",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 9,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ],
                      [
                        0,
                        -0.284
                      ],
                      [
                        0.255,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -0.284
                      ],
                      [
                        0.255,
                        0
                      ],
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.475,
                        1.43
                      ],
                      [
                        0.007,
                        0.947
                      ],
                      [
                        0.475,
                        1.43
                      ],
                      [
                        0.007,
                        1.919
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ],
                      [
                        0,
                        -0.283
                      ],
                      [
                        0.255,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -0.283
                      ],
                      [
                        0.255,
                        0
                      ],
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.475,
                        -1.437
                      ],
                      [
                        0.007,
                        -1.919
                      ],
                      [
                        0.475,
                        -1.437
                      ],
                      [
                        0.007,
                        -0.947
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    37.863,
                    60.884
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 10",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 10,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0.305,
                        0
                      ],
                      [
                        0,
                        0.76
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.376,
                        0
                      ],
                      [
                        -0.142,
                        0.114
                      ]
                    ],
                    "o": [
                      [
                        -0.206,
                        0.177
                      ],
                      [
                        -0.76,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0.404
                      ],
                      [
                        0.199,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.327,
                        2.051
                      ],
                      [
                        0.504,
                        2.313
                      ],
                      [
                        -0.688,
                        1.135
                      ],
                      [
                        -0.688,
                        -0.929
                      ],
                      [
                        -1.327,
                        -0.929
                      ],
                      [
                        -1.327,
                        -1.49
                      ],
                      [
                        -0.688,
                        -1.49
                      ],
                      [
                        -0.688,
                        -2.313
                      ],
                      [
                        -0.007,
                        -2.313
                      ],
                      [
                        -0.007,
                        -1.49
                      ],
                      [
                        1.072,
                        -1.49
                      ],
                      [
                        1.072,
                        -0.929
                      ],
                      [
                        -0.007,
                        -0.929
                      ],
                      [
                        -0.007,
                        1.107
                      ],
                      [
                        0.582,
                        1.739
                      ],
                      [
                        1.114,
                        1.561
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    33.654,
                    60.49
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 11",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 11,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        1.121
                      ],
                      [
                        -1.157,
                        0
                      ],
                      [
                        -0.298,
                        -0.525
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.411,
                        0
                      ],
                      [
                        0,
                        -0.802
                      ],
                      [
                        -0.738,
                        0
                      ],
                      [
                        -0.241,
                        0.369
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.674,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -1.121
                      ],
                      [
                        0.674,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.241,
                        -0.369
                      ],
                      [
                        -0.738,
                        0
                      ],
                      [
                        0,
                        0.816
                      ],
                      [
                        0.411,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.298,
                        0.525
                      ],
                      [
                        -1.157,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -1.76,
                        -0.004
                      ],
                      [
                        0.227,
                        -1.919
                      ],
                      [
                        1.76,
                        -1.117
                      ],
                      [
                        1.241,
                        -0.784
                      ],
                      [
                        0.22,
                        -1.323
                      ],
                      [
                        -1.072,
                        -0.004
                      ],
                      [
                        0.22,
                        1.324
                      ],
                      [
                        1.241,
                        0.785
                      ],
                      [
                        1.76,
                        1.111
                      ],
                      [
                        0.227,
                        1.919
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    30.182,
                    60.884
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 12",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 12,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.071,
                        -0.639
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.659,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.071,
                        -0.632
                      ],
                      [
                        -0.653,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -1.192,
                        -0.266
                      ],
                      [
                        1.221,
                        -0.266
                      ],
                      [
                        0.015,
                        -1.345
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.007,
                        -0.064
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.744,
                        0
                      ],
                      [
                        -0.277,
                        0.305
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.624,
                        0
                      ],
                      [
                        0,
                        1.121
                      ],
                      [
                        -1.086,
                        0
                      ],
                      [
                        0,
                        -1.157
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0.085,
                        0.66
                      ],
                      [
                        0.44,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.341,
                        0.397
                      ],
                      [
                        -1.213,
                        0
                      ],
                      [
                        0,
                        -1.114
                      ],
                      [
                        1.085,
                        0
                      ],
                      [
                        0,
                        0.056
                      ]
                    ],
                    "v": [
                      [
                        1.859,
                        0.223
                      ],
                      [
                        -1.192,
                        0.223
                      ],
                      [
                        0.17,
                        1.323
                      ],
                      [
                        1.256,
                        0.869
                      ],
                      [
                        1.632,
                        1.309
                      ],
                      [
                        0.149,
                        1.919
                      ],
                      [
                        -1.873,
                        -0.004
                      ],
                      [
                        0.015,
                        -1.919
                      ],
                      [
                        1.873,
                        0.018
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    25.957,
                    60.884
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 13",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 13,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0.249
                      ],
                      [
                        -0.262,
                        0
                      ],
                      [
                        0,
                        -0.241
                      ],
                      [
                        0.27,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -0.248
                      ],
                      [
                        0.263,
                        0
                      ],
                      [
                        0,
                        0.255
                      ],
                      [
                        -0.262,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.146,
                        -2.948
                      ],
                      [
                        0.607,
                        -3.395
                      ],
                      [
                        1.068,
                        -2.962
                      ],
                      [
                        0.607,
                        -2.508
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.191,
                        0.156
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.22,
                        0
                      ],
                      [
                        0,
                        0.433
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.773,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0.135,
                        0.114
                      ],
                      [
                        0.362,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0.766
                      ],
                      [
                        -0.312,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -1.068,
                        3.168
                      ],
                      [
                        -0.848,
                        2.643
                      ],
                      [
                        -0.294,
                        2.821
                      ],
                      [
                        0.266,
                        2.161
                      ],
                      [
                        0.266,
                        -1.784
                      ],
                      [
                        0.947,
                        -1.784
                      ],
                      [
                        0.947,
                        2.147
                      ],
                      [
                        -0.251,
                        3.395
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    22.188,
                    60.785
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 14",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 14,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0.802
                      ],
                      [
                        0.724,
                        0
                      ],
                      [
                        0,
                        -0.802
                      ],
                      [
                        -0.716,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -0.802
                      ],
                      [
                        -0.716,
                        0
                      ],
                      [
                        0,
                        0.802
                      ],
                      [
                        0.724,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.26,
                        0.73
                      ],
                      [
                        -0.01,
                        -0.589
                      ],
                      [
                        -1.273,
                        0.73
                      ],
                      [
                        -0.01,
                        2.058
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -1.149
                      ],
                      [
                        1.1,
                        0
                      ],
                      [
                        0.305,
                        0.426
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.532,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        1.149
                      ],
                      [
                        -0.554,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.313,
                        -0.405
                      ],
                      [
                        1.1,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.947,
                        0.73
                      ],
                      [
                        0.046,
                        2.653
                      ],
                      [
                        -1.294,
                        2.015
                      ],
                      [
                        -1.294,
                        2.61
                      ],
                      [
                        -1.947,
                        2.61
                      ],
                      [
                        -1.947,
                        -2.653
                      ],
                      [
                        -1.266,
                        -2.653
                      ],
                      [
                        -1.266,
                        -0.581
                      ],
                      [
                        0.046,
                        -1.186
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    19.532,
                    60.15
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 15",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 15,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.532,
                        0
                      ],
                      [
                        0,
                        1.107
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.646,
                        0
                      ],
                      [
                        0,
                        0.809
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.276,
                        0.39
                      ],
                      [
                        -0.972,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0.738
                      ],
                      [
                        0.71,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.771,
                        -1.902
                      ],
                      [
                        1.771,
                        1.86
                      ],
                      [
                        1.124,
                        1.86
                      ],
                      [
                        1.124,
                        1.292
                      ],
                      [
                        -0.152,
                        1.902
                      ],
                      [
                        -1.771,
                        0.262
                      ],
                      [
                        -1.771,
                        -1.902
                      ],
                      [
                        -1.089,
                        -1.902
                      ],
                      [
                        -1.089,
                        0.185
                      ],
                      [
                        -0.075,
                        1.292
                      ],
                      [
                        1.089,
                        0.042
                      ],
                      [
                        1.089,
                        -1.902
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    14.521,
                    60.902
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 16",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 16,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.397,
                        0.369
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.638,
                        0
                      ],
                      [
                        0,
                        0.433
                      ],
                      [
                        0,
                        1.845
                      ],
                      [
                        -1.306,
                        0
                      ],
                      [
                        -0.412,
                        -0.284
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.44,
                        0
                      ],
                      [
                        0,
                        -0.433
                      ],
                      [
                        0,
                        -1.823
                      ],
                      [
                        1.313,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0.369,
                        0.334
                      ],
                      [
                        0.859,
                        0
                      ],
                      [
                        0,
                        -1.213
                      ],
                      [
                        0,
                        -0.766
                      ],
                      [
                        0.582,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.432,
                        -0.276
                      ],
                      [
                        -0.844,
                        0
                      ],
                      [
                        0,
                        1.213
                      ],
                      [
                        0,
                        0.759
                      ],
                      [
                        -0.759,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -1.912,
                        1.916
                      ],
                      [
                        -1.65,
                        1.362
                      ],
                      [
                        -0.011,
                        1.937
                      ],
                      [
                        1.217,
                        1.171
                      ],
                      [
                        -1.791,
                        -1.121
                      ],
                      [
                        0.11,
                        -2.54
                      ],
                      [
                        1.707,
                        -2.1
                      ],
                      [
                        1.472,
                        -1.533
                      ],
                      [
                        0.11,
                        -1.937
                      ],
                      [
                        -1.096,
                        -1.149
                      ],
                      [
                        1.912,
                        1.128
                      ],
                      [
                        -0.011,
                        2.54
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    9.943,
                    60.278
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 17",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 17,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ],
                      [
                        0,
                        -0.284
                      ],
                      [
                        0.255,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -0.284
                      ],
                      [
                        0.255,
                        0
                      ],
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.475,
                        1.43
                      ],
                      [
                        0.007,
                        0.947
                      ],
                      [
                        0.475,
                        1.43
                      ],
                      [
                        0.007,
                        1.919
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ],
                      [
                        0,
                        -0.283
                      ],
                      [
                        0.255,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -0.283
                      ],
                      [
                        0.255,
                        0
                      ],
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.475,
                        -1.437
                      ],
                      [
                        0.007,
                        -1.919
                      ],
                      [
                        0.475,
                        -1.437
                      ],
                      [
                        0.007,
                        -0.947
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    20.163,
                    43.959
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 18",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 18,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        1.121
                      ],
                      [
                        -1.157,
                        0
                      ],
                      [
                        -0.299,
                        -0.525
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.411,
                        0
                      ],
                      [
                        0,
                        -0.802
                      ],
                      [
                        -0.738,
                        0
                      ],
                      [
                        -0.241,
                        0.369
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.674,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -1.121
                      ],
                      [
                        0.674,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.241,
                        -0.369
                      ],
                      [
                        -0.738,
                        0
                      ],
                      [
                        0,
                        0.816
                      ],
                      [
                        0.411,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.299,
                        0.525
                      ],
                      [
                        -1.157,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -1.76,
                        -0.004
                      ],
                      [
                        0.227,
                        -1.919
                      ],
                      [
                        1.76,
                        -1.117
                      ],
                      [
                        1.241,
                        -0.784
                      ],
                      [
                        0.22,
                        -1.323
                      ],
                      [
                        -1.072,
                        -0.004
                      ],
                      [
                        0.22,
                        1.324
                      ],
                      [
                        1.241,
                        0.785
                      ],
                      [
                        1.76,
                        1.111
                      ],
                      [
                        0.227,
                        1.919
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    15.465,
                    43.959
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 19",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 19,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        1.469
                      ],
                      [
                        -1.512,
                        0
                      ],
                      [
                        -0.454,
                        -0.51
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.547,
                        0
                      ],
                      [
                        0,
                        -1.1
                      ],
                      [
                        -1.121,
                        0
                      ],
                      [
                        -0.383,
                        0.405
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.774,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -1.469
                      ],
                      [
                        0.766,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.383,
                        -0.404
                      ],
                      [
                        -1.121,
                        0
                      ],
                      [
                        0,
                        1.1
                      ],
                      [
                        0.547,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.454,
                        0.511
                      ],
                      [
                        -1.504,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -2.26,
                        0
                      ],
                      [
                        0.373,
                        -2.54
                      ],
                      [
                        2.26,
                        -1.767
                      ],
                      [
                        1.799,
                        -1.32
                      ],
                      [
                        0.401,
                        -1.909
                      ],
                      [
                        -1.55,
                        0
                      ],
                      [
                        0.401,
                        1.909
                      ],
                      [
                        1.799,
                        1.312
                      ],
                      [
                        2.26,
                        1.76
                      ],
                      [
                        0.365,
                        2.54
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    11.039,
                    43.353
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 20",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 20,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ],
                      [
                        0,
                        -0.284
                      ],
                      [
                        0.255,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -0.284
                      ],
                      [
                        0.255,
                        0
                      ],
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.475,
                        1.43
                      ],
                      [
                        0.007,
                        0.947
                      ],
                      [
                        0.475,
                        1.43
                      ],
                      [
                        0.007,
                        1.919
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ],
                      [
                        0,
                        -0.283
                      ],
                      [
                        0.255,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -0.283
                      ],
                      [
                        0.255,
                        0
                      ],
                      [
                        0,
                        0.284
                      ],
                      [
                        -0.263,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.475,
                        -1.437
                      ],
                      [
                        0.007,
                        -1.919
                      ],
                      [
                        0.475,
                        -1.437
                      ],
                      [
                        0.007,
                        -0.947
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    18.719,
                    27.252
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 21",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 21,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0.802
                      ],
                      [
                        0.724,
                        0
                      ],
                      [
                        0,
                        -0.802
                      ],
                      [
                        -0.723,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -0.802
                      ],
                      [
                        -0.723,
                        0
                      ],
                      [
                        0,
                        0.802
                      ],
                      [
                        0.724,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.266,
                        -0.004
                      ],
                      [
                        0.003,
                        -1.323
                      ],
                      [
                        -1.266,
                        -0.004
                      ],
                      [
                        0.003,
                        1.324
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        1.121
                      ],
                      [
                        -1.128,
                        0
                      ],
                      [
                        0,
                        -1.121
                      ],
                      [
                        1.128,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -1.121
                      ],
                      [
                        1.128,
                        0
                      ],
                      [
                        0,
                        1.121
                      ],
                      [
                        -1.128,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -1.954,
                        -0.004
                      ],
                      [
                        0.003,
                        -1.919
                      ],
                      [
                        1.954,
                        -0.004
                      ],
                      [
                        0.003,
                        1.919
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    13.763,
                    27.252
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 22",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 22,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.351,
                        -1.867
                      ],
                      [
                        -2.054,
                        -1.867
                      ],
                      [
                        -2.054,
                        -2.483
                      ],
                      [
                        2.054,
                        -2.483
                      ],
                      [
                        2.054,
                        -1.867
                      ],
                      [
                        0.351,
                        -1.867
                      ],
                      [
                        0.351,
                        2.483
                      ],
                      [
                        -0.351,
                        2.483
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    9.822,
                    26.646
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 23",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 23,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.34,
                        -2.633
                      ],
                      [
                        0.34,
                        -2.633
                      ],
                      [
                        0.34,
                        2.633
                      ],
                      [
                        -0.34,
                        2.633
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    46.181,
                    8.778
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 24",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 24,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.34,
                        -1.076
                      ],
                      [
                        0.341,
                        -1.076
                      ],
                      [
                        0.341,
                        2.685
                      ],
                      [
                        -0.34,
                        2.685
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0.248
                      ],
                      [
                        -0.263,
                        0
                      ],
                      [
                        0,
                        -0.242
                      ],
                      [
                        0.269,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -0.248
                      ],
                      [
                        0.262,
                        0
                      ],
                      [
                        0,
                        0.255
                      ],
                      [
                        -0.263,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.461,
                        -2.238
                      ],
                      [
                        0.001,
                        -2.685
                      ],
                      [
                        0.461,
                        -2.253
                      ],
                      [
                        0.001,
                        -1.798
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    44.204,
                    8.725
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 25",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 25,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.17,
                        0.433
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -0.32
                      ],
                      [
                        -0.519,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.674,
                        0
                      ],
                      [
                        0,
                        0.376
                      ],
                      [
                        0.51,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.954,
                        0.727
                      ],
                      [
                        0.954,
                        0.202
                      ],
                      [
                        -0.096,
                        0.202
                      ],
                      [
                        -0.962,
                        0.784
                      ],
                      [
                        -0.131,
                        1.394
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -1.029
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.589,
                        0
                      ],
                      [
                        0,
                        0.653
                      ],
                      [
                        -1.121,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.674,
                        0
                      ],
                      [
                        0.291,
                        -0.248
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.603,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.227,
                        0.34
                      ],
                      [
                        -0.851,
                        0
                      ],
                      [
                        0,
                        -0.603
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -0.575
                      ],
                      [
                        -0.447,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.39,
                        -0.312
                      ],
                      [
                        1.029,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.635,
                        -0.394
                      ],
                      [
                        1.635,
                        1.876
                      ],
                      [
                        0.99,
                        1.876
                      ],
                      [
                        0.99,
                        1.38
                      ],
                      [
                        -0.245,
                        1.919
                      ],
                      [
                        -1.635,
                        0.812
                      ],
                      [
                        -0.124,
                        -0.288
                      ],
                      [
                        0.954,
                        -0.288
                      ],
                      [
                        0.954,
                        -0.422
                      ],
                      [
                        -0.053,
                        -1.331
                      ],
                      [
                        -1.245,
                        -0.926
                      ],
                      [
                        -1.529,
                        -1.437
                      ],
                      [
                        0.025,
                        -1.919
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    40.97,
                    9.534
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 26",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 26,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -1.107
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.617,
                        0
                      ],
                      [
                        0,
                        -0.816
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.618,
                        0
                      ],
                      [
                        0,
                        -0.816
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.567,
                        0
                      ],
                      [
                        -0.248,
                        -0.468
                      ],
                      [
                        -0.638,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -0.738
                      ],
                      [
                        -0.681,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -0.738
                      ],
                      [
                        -0.681,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.269,
                        -0.383
                      ],
                      [
                        0.575,
                        0
                      ],
                      [
                        0.283,
                        -0.425
                      ],
                      [
                        0.915,
                        0
                      ]
                    ],
                    "v": [
                      [
                        3.122,
                        -0.266
                      ],
                      [
                        3.122,
                        1.898
                      ],
                      [
                        2.441,
                        1.898
                      ],
                      [
                        2.441,
                        -0.188
                      ],
                      [
                        1.469,
                        -1.288
                      ],
                      [
                        0.341,
                        -0.039
                      ],
                      [
                        0.341,
                        1.898
                      ],
                      [
                        -0.34,
                        1.898
                      ],
                      [
                        -0.34,
                        -0.188
                      ],
                      [
                        -1.313,
                        -1.288
                      ],
                      [
                        -2.441,
                        -0.039
                      ],
                      [
                        -2.441,
                        1.898
                      ],
                      [
                        -3.122,
                        1.898
                      ],
                      [
                        -3.122,
                        -1.863
                      ],
                      [
                        -2.469,
                        -1.863
                      ],
                      [
                        -2.469,
                        -1.302
                      ],
                      [
                        -1.171,
                        -1.898
                      ],
                      [
                        0.135,
                        -1.203
                      ],
                      [
                        1.582,
                        -1.898
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    35.256,
                    9.512
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 27",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 27,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.802,
                        1.866
                      ],
                      [
                        1.802,
                        2.483
                      ],
                      [
                        -1.802,
                        2.483
                      ],
                      [
                        -1.802,
                        -2.483
                      ],
                      [
                        1.702,
                        -2.483
                      ],
                      [
                        1.702,
                        -1.866
                      ],
                      [
                        -1.093,
                        -1.866
                      ],
                      [
                        -1.093,
                        -0.34
                      ],
                      [
                        1.397,
                        -0.34
                      ],
                      [
                        1.397,
                        0.263
                      ],
                      [
                        -1.093,
                        0.263
                      ],
                      [
                        -1.093,
                        1.866
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    29.287,
                    8.927
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 28",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 28,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        3.146,
                        -1.881
                      ],
                      [
                        1.742,
                        1.881
                      ],
                      [
                        1.089,
                        1.881
                      ],
                      [
                        0.003,
                        -0.972
                      ],
                      [
                        -1.096,
                        1.881
                      ],
                      [
                        -1.749,
                        1.881
                      ],
                      [
                        -3.146,
                        -1.881
                      ],
                      [
                        -2.501,
                        -1.881
                      ],
                      [
                        -1.408,
                        1.115
                      ],
                      [
                        -0.273,
                        -1.881
                      ],
                      [
                        0.301,
                        -1.881
                      ],
                      [
                        1.415,
                        1.128
                      ],
                      [
                        2.536,
                        -1.881
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    21.65,
                    9.53
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 29",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 29,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.071,
                        -0.639
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.659,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.071,
                        -0.632
                      ],
                      [
                        -0.653,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -1.192,
                        -0.266
                      ],
                      [
                        1.221,
                        -0.266
                      ],
                      [
                        0.015,
                        -1.345
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.007,
                        -0.064
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.744,
                        0
                      ],
                      [
                        -0.277,
                        0.305
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.624,
                        0
                      ],
                      [
                        0,
                        1.121
                      ],
                      [
                        -1.086,
                        0
                      ],
                      [
                        0,
                        -1.157
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0.085,
                        0.66
                      ],
                      [
                        0.44,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.341,
                        0.397
                      ],
                      [
                        -1.213,
                        0
                      ],
                      [
                        0,
                        -1.114
                      ],
                      [
                        1.085,
                        0
                      ],
                      [
                        0,
                        0.056
                      ]
                    ],
                    "v": [
                      [
                        1.859,
                        0.223
                      ],
                      [
                        -1.192,
                        0.223
                      ],
                      [
                        0.17,
                        1.323
                      ],
                      [
                        1.256,
                        0.869
                      ],
                      [
                        1.632,
                        1.309
                      ],
                      [
                        0.149,
                        1.919
                      ],
                      [
                        -1.873,
                        -0.004
                      ],
                      [
                        0.015,
                        -1.919
                      ],
                      [
                        1.873,
                        0.018
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    16.365,
                    9.534
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 30",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 30,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.135,
                        -2.484
                      ],
                      [
                        2.135,
                        2.484
                      ],
                      [
                        1.553,
                        2.484
                      ],
                      [
                        -1.426,
                        -1.221
                      ],
                      [
                        -1.426,
                        2.484
                      ],
                      [
                        -2.135,
                        2.484
                      ],
                      [
                        -2.135,
                        -2.484
                      ],
                      [
                        -1.555,
                        -2.484
                      ],
                      [
                        1.425,
                        1.221
                      ],
                      [
                        1.425,
                        -2.484
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    11.32,
                    8.927
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 31",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 31,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0.794
                      ],
                      [
                        0.787,
                        0.026
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.068
                      ],
                      [
                        -1.044,
                        -0.094
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0.911
                      ],
                      [
                        -0.912,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -0.59
                      ],
                      [
                        0.59,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0.285
                      ],
                      [
                        -0.278,
                        0.067
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -0.493
                      ],
                      [
                        -0.483,
                        -0.077
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.025,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -0.793
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.044,
                        0.095
                      ],
                      [
                        0,
                        1.068
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.912,
                        0
                      ],
                      [
                        0,
                        -0.911
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.59,
                        0
                      ],
                      [
                        0,
                        0.59
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.273,
                        -0.071
                      ],
                      [
                        0,
                        -0.287
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.483,
                        0.078
                      ],
                      [
                        0,
                        0.494
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.025,
                        0.001
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.787,
                        -0.026
                      ]
                    ],
                    "v": [
                      [
                        4.431,
                        -0.583
                      ],
                      [
                        3.011,
                        -2.049
                      ],
                      [
                        3.011,
                        -2.052
                      ],
                      [
                        -2.566,
                        -2.052
                      ],
                      [
                        -2.566,
                        -2.042
                      ],
                      [
                        -4.431,
                        0
                      ],
                      [
                        -2.566,
                        2.042
                      ],
                      [
                        -2.566,
                        2.052
                      ],
                      [
                        1.929,
                        2.052
                      ],
                      [
                        1.929,
                        1.653
                      ],
                      [
                        -2.379,
                        1.653
                      ],
                      [
                        -4.031,
                        0
                      ],
                      [
                        -2.379,
                        -1.652
                      ],
                      [
                        2.962,
                        -1.652
                      ],
                      [
                        4.032,
                        -0.583
                      ],
                      [
                        2.962,
                        0.487
                      ],
                      [
                        -1.567,
                        0.487
                      ],
                      [
                        -1.567,
                        0.492
                      ],
                      [
                        -2.042,
                        -0.101
                      ],
                      [
                        -1.558,
                        -0.695
                      ],
                      [
                        1.929,
                        -0.695
                      ],
                      [
                        1.929,
                        -1.095
                      ],
                      [
                        -1.404,
                        -1.095
                      ],
                      [
                        -1.406,
                        -1.095
                      ],
                      [
                        -1.567,
                        -1.095
                      ],
                      [
                        -1.567,
                        -1.079
                      ],
                      [
                        -2.421,
                        -0.101
                      ],
                      [
                        -1.567,
                        0.878
                      ],
                      [
                        -1.567,
                        0.887
                      ],
                      [
                        -1.478,
                        0.887
                      ],
                      [
                        -1.404,
                        0.894
                      ],
                      [
                        -1.404,
                        0.887
                      ],
                      [
                        3.011,
                        0.887
                      ],
                      [
                        3.011,
                        0.884
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    260.617,
                    60.568
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 32",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 32,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -1.672,
                        -1.674
                      ],
                      [
                        1.674,
                        -1.674
                      ],
                      [
                        1.674,
                        1.673
                      ],
                      [
                        -1.672,
                        1.673
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -2.07,
                        2.07
                      ],
                      [
                        2.07,
                        2.07
                      ],
                      [
                        2.07,
                        -2.07
                      ],
                      [
                        -2.07,
                        -2.07
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    255.142,
                    9.525
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 33",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 33,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.012,
                        -1.732
                      ],
                      [
                        1.73,
                        -2.012
                      ],
                      [
                        -0.001,
                        -0.281
                      ],
                      [
                        -1.732,
                        -2.012
                      ],
                      [
                        -2.012,
                        -1.732
                      ],
                      [
                        -0.282,
                        -0.001
                      ],
                      [
                        -2.012,
                        1.731
                      ],
                      [
                        -1.732,
                        2.012
                      ],
                      [
                        -0.001,
                        0.281
                      ],
                      [
                        1.73,
                        2.012
                      ],
                      [
                        2.012,
                        1.731
                      ],
                      [
                        0.28,
                        -0.001
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    262.629,
                    9.525
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 34",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 34,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -1.871,
                        0.198
                      ],
                      [
                        1.871,
                        0.198
                      ],
                      [
                        1.871,
                        0
                      ],
                      [
                        -1.871,
                        0
                      ],
                      [
                        1.871,
                        0
                      ],
                      [
                        1.871,
                        -0.198
                      ],
                      [
                        -1.871,
                        -0.198
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    247.844,
                    9.525
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 35",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 35,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.001,
                        0.502
                      ],
                      [
                        1.326,
                        -0.824
                      ],
                      [
                        1.487,
                        -0.663
                      ],
                      [
                        -0.001,
                        0.824
                      ],
                      [
                        -1.487,
                        -0.663
                      ],
                      [
                        -1.327,
                        -0.824
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    83.248,
                    168.621
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 36",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 36,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.796,
                        -0.177
                      ],
                      [
                        0.796,
                        -0.177
                      ],
                      [
                        0.796,
                        0.177
                      ],
                      [
                        -0.796,
                        0.177
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    64.675,
                    165.757
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 37",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 37,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.796,
                        -0.177
                      ],
                      [
                        0.796,
                        -0.177
                      ],
                      [
                        0.796,
                        0.177
                      ],
                      [
                        -0.796,
                        0.177
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    64.675,
                    165.403
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 38",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 38,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -0.795,
                        -0.354
                      ],
                      [
                        -0.795,
                        0
                      ],
                      [
                        0.796,
                        0
                      ],
                      [
                        0.796,
                        -0.354
                      ],
                      [
                        2.159,
                        -0.354
                      ],
                      [
                        2.159,
                        0.354
                      ],
                      [
                        -2.159,
                        0.354
                      ],
                      [
                        -2.159,
                        -0.354
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    64.675,
                    165.935
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 39",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 39,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.159,
                        2.301
                      ],
                      [
                        -2.159,
                        2.301
                      ],
                      [
                        -2.159,
                        -2.301
                      ],
                      [
                        2.159,
                        -2.301
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    64.675,
                    168.959
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 40",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 40,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.001,
                        5.422
                      ],
                      [
                        0.001,
                        -5.422
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.171,
                        -5.423
                      ],
                      [
                        -0.171,
                        -5.423
                      ],
                      [
                        -0.171,
                        5.423
                      ],
                      [
                        0.171,
                        5.423
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    73.302,
                    168.243
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 41",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 41,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.638,
                        2.595
                      ],
                      [
                        -0.001,
                        1.732
                      ],
                      [
                        -1.637,
                        2.595
                      ],
                      [
                        -1.34,
                        0.86
                      ],
                      [
                        -1.324,
                        0.771
                      ],
                      [
                        -2.65,
                        -0.521
                      ],
                      [
                        -0.818,
                        -0.788
                      ],
                      [
                        -0.001,
                        -2.447
                      ],
                      [
                        0.821,
                        -0.788
                      ],
                      [
                        2.65,
                        -0.521
                      ],
                      [
                        1.39,
                        0.708
                      ],
                      [
                        1.327,
                        0.771
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.046,
                        -1.1
                      ],
                      [
                        -0.001,
                        -3.217
                      ],
                      [
                        -1.046,
                        -1.1
                      ],
                      [
                        -3.383,
                        -0.76
                      ],
                      [
                        -1.691,
                        0.889
                      ],
                      [
                        -2.092,
                        3.217
                      ],
                      [
                        -0.001,
                        2.118
                      ],
                      [
                        2.09,
                        3.217
                      ],
                      [
                        1.691,
                        0.889
                      ],
                      [
                        3.383,
                        -0.76
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    31.278,
                    168.638
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 42",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 42,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0.622,
                        0
                      ],
                      [
                        0,
                        0.623
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.403,
                        0
                      ],
                      [
                        0,
                        -0.403
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.194,
                        0
                      ],
                      [
                        0.045,
                        0.189
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.337,
                        0
                      ],
                      [
                        -0.053,
                        0.33
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0.018
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.543,
                        0
                      ],
                      [
                        0.018,
                        -0.538
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.73,
                        0
                      ],
                      [
                        -0.065,
                        0.713
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0.623
                      ],
                      [
                        -0.623,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -0.403
                      ],
                      [
                        0.403,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.048,
                        0.186
                      ],
                      [
                        -0.197,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.053,
                        0.33
                      ],
                      [
                        0.337,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.001,
                        -0.017
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.018,
                        -0.538
                      ],
                      [
                        -0.542,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.065,
                        0.713
                      ],
                      [
                        0.73,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.13,
                        1.626
                      ],
                      [
                        0.001,
                        2.755
                      ],
                      [
                        -1.128,
                        1.626
                      ],
                      [
                        -1.128,
                        -2.024
                      ],
                      [
                        -0.398,
                        -2.755
                      ],
                      [
                        0.333,
                        -2.024
                      ],
                      [
                        0.333,
                        1.071
                      ],
                      [
                        0.337,
                        1.071
                      ],
                      [
                        -0.068,
                        1.396
                      ],
                      [
                        -0.475,
                        1.065
                      ],
                      [
                        -0.475,
                        -1.318
                      ],
                      [
                        -0.747,
                        -1.318
                      ],
                      [
                        -0.747,
                        0.959
                      ],
                      [
                        -0.747,
                        0.961
                      ],
                      [
                        -0.747,
                        1.071
                      ],
                      [
                        -0.738,
                        1.071
                      ],
                      [
                        -0.068,
                        1.655
                      ],
                      [
                        0.6,
                        1.071
                      ],
                      [
                        0.607,
                        1.071
                      ],
                      [
                        0.607,
                        1.01
                      ],
                      [
                        0.611,
                        0.959
                      ],
                      [
                        0.607,
                        0.959
                      ],
                      [
                        0.607,
                        -2.058
                      ],
                      [
                        0.605,
                        -2.058
                      ],
                      [
                        -0.398,
                        -3.028
                      ],
                      [
                        -1.4,
                        -2.058
                      ],
                      [
                        -1.402,
                        -2.058
                      ],
                      [
                        -1.402,
                        1.754
                      ],
                      [
                        -1.395,
                        1.754
                      ],
                      [
                        0.001,
                        3.028
                      ],
                      [
                        1.396,
                        1.754
                      ],
                      [
                        1.402,
                        1.754
                      ],
                      [
                        1.402,
                        -1.318
                      ],
                      [
                        1.13,
                        -1.318
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    43.208,
                    168.674
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 43",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 43,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.606,
                        0
                      ],
                      [
                        0,
                        0.606
                      ],
                      [
                        -0.605,
                        0
                      ],
                      [
                        0,
                        -0.606
                      ]
                    ],
                    "o": [
                      [
                        -0.605,
                        0
                      ],
                      [
                        0,
                        -0.606
                      ],
                      [
                        0.606,
                        0
                      ],
                      [
                        0,
                        0.606
                      ]
                    ],
                    "v": [
                      [
                        0,
                        0.061
                      ],
                      [
                        -1.097,
                        -1.036
                      ],
                      [
                        0,
                        -2.133
                      ],
                      [
                        1.097,
                        -1.036
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        1.024,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.056
                      ],
                      [
                        -0.717,
                        -0.74
                      ],
                      [
                        -0.217,
                        0.243
                      ],
                      [
                        0,
                        1.056
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.024,
                        0
                      ],
                      [
                        0,
                        1.056
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.717,
                        -0.74
                      ],
                      [
                        0,
                        -1.056
                      ]
                    ],
                    "v": [
                      [
                        0.178,
                        -3.107
                      ],
                      [
                        0.163,
                        -3.107
                      ],
                      [
                        -0.163,
                        -3.107
                      ],
                      [
                        -0.178,
                        -3.107
                      ],
                      [
                        -2.032,
                        -1.106
                      ],
                      [
                        -0.178,
                        2.864
                      ],
                      [
                        0.178,
                        2.864
                      ],
                      [
                        2.032,
                        -1.106
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    19.444,
                    168.753
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 44",
            "np": 6,
            "cix": 2,
            "bm": 0,
            "ix": 44,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -2.639,
                        0.186
                      ],
                      [
                        2.639,
                        0.186
                      ],
                      [
                        2.639,
                        -0.186
                      ],
                      [
                        -2.639,
                        -0.186
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    53.52,
                    171.743
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 45",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 45,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0.002,
                        -1.453
                      ],
                      [
                        0.904,
                        0.435
                      ],
                      [
                        -0.904,
                        0.435
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -1.116,
                        0.869
                      ],
                      [
                        1.114,
                        0.869
                      ],
                      [
                        1.816,
                        2.329
                      ],
                      [
                        2.295,
                        2.329
                      ],
                      [
                        0.063,
                        -2.329
                      ],
                      [
                        -0.06,
                        -2.329
                      ],
                      [
                        -2.295,
                        2.329
                      ],
                      [
                        -1.811,
                        2.329
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.149000010771,
                    0.195999998205,
                    0.219999994016,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    53.534,
                    168.236
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 46",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 46,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -250,
                        250
                      ],
                      [
                        250,
                        250
                      ],
                      [
                        250,
                        -250
                      ],
                      [
                        -250,
                        -250
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -250,
                        -250
                      ],
                      [
                        250,
                        -250
                      ],
                      [
                        250,
                        250
                      ],
                      [
                        -250,
                        250
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 2,
                "ty": "sh",
                "ix": 3,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -202.084,
                        -21.232
                      ],
                      [
                        67.889,
                        -21.232
                      ],
                      [
                        67.889,
                        -49.371
                      ],
                      [
                        -202.084,
                        -49.371
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 3",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.922000002394,
                    0.922000002394,
                    0.922000002394,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    203.262,
                    204.857
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 47",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 47,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        134.986,
                        9.071
                      ],
                      [
                        -134.986,
                        9.071
                      ],
                      [
                        -134.986,
                        -9.071
                      ],
                      [
                        134.986,
                        -9.071
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    136.165,
                    9.524
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 48",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 48,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        134.883,
                        -91.501
                      ],
                      [
                        -134.885,
                        -91.501
                      ],
                      [
                        -134.885,
                        91.499
                      ],
                      [
                        134.883,
                        91.499
                      ]
                    ],
                    "c": false
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        135.089,
                        91.637
                      ],
                      [
                        -135.089,
                        91.637
                      ],
                      [
                        -135.089,
                        -91.637
                      ],
                      [
                        135.089,
                        -91.637
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 2",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    136.165,
                    91.989
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 49",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 49,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -134.884,
                        91.5
                      ],
                      [
                        134.884,
                        91.5
                      ],
                      [
                        134.884,
                        -91.5
                      ],
                      [
                        -134.884,
                        -91.5
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    135.134,
                    91.988
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 50",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 50,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 0,
        "op": 720,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 7,
        "ty": 2,
        "nm": "Floor",
        "refId": "image_1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              251,
              466.863,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              226.359,
              0.51,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "ip": 0,
        "op": 720,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 9,
        "ty": 4,
        "nm": "Background Complete Outlines",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              261.924,
              270.748,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              209.396,
              196.365,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        4.581,
                        -10.234
                      ],
                      [
                        6.109,
                        10.234
                      ],
                      [
                        -4.277,
                        10.234
                      ],
                      [
                        -6.109,
                        -10.234
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    120.767,
                    191.57
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        8.365,
                        -14.914
                      ],
                      [
                        11.051,
                        14.83
                      ],
                      [
                        -8.421,
                        15.085
                      ],
                      [
                        -11.051,
                        -15.086
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    121.115,
                    192.131
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        11.329,
                        -17.755
                      ],
                      [
                        14.395,
                        17.755
                      ],
                      [
                        -11.546,
                        17.755
                      ],
                      [
                        -14.395,
                        -17.755
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.922000002394,
                    0.922000002394,
                    0.922000002394,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    120.685,
                    192.156
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        3.62,
                        -9.321
                      ],
                      [
                        -4.318,
                        9.32
                      ],
                      [
                        0.792,
                        9.32
                      ],
                      [
                        4.318,
                        -0.635
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    104.024,
                    200.591
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 4",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        1.809
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.809,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -1.809,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.809
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        9.915,
                        3.374
                      ],
                      [
                        -6.64,
                        3.374
                      ],
                      [
                        -9.915,
                        0.1
                      ],
                      [
                        -9.915,
                        -0.1
                      ],
                      [
                        -6.64,
                        -3.374
                      ],
                      [
                        9.915,
                        -3.374
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    133.819,
                    215.722
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 5",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        3.209
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -3.209,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -3.209,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -3.209
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        27.892,
                        -5.811
                      ],
                      [
                        27.892,
                        5.811
                      ],
                      [
                        -22.082,
                        5.811
                      ],
                      [
                        -27.892,
                        0.001
                      ],
                      [
                        -27.892,
                        0
                      ],
                      [
                        -22.082,
                        -5.811
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.961000031116,
                    0.961000031116,
                    0.961000031116,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    115.843,
                    215.722
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 6",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        1.808
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.809,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -1.809,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.808
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        9.915,
                        3.375
                      ],
                      [
                        -6.64,
                        3.375
                      ],
                      [
                        -9.915,
                        0.1
                      ],
                      [
                        -9.915,
                        -0.1
                      ],
                      [
                        -6.64,
                        -3.375
                      ],
                      [
                        9.915,
                        -3.375
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.980000035903,
                    0.980000035903,
                    0.980000035903,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    133.819,
                    227.344
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 7",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        3.209
                      ],
                      [
                        -3.209,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -3.209,
                        0
                      ],
                      [
                        0,
                        -3.209
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        27.892,
                        -5.811
                      ],
                      [
                        27.892,
                        5.811
                      ],
                      [
                        -22.082,
                        5.811
                      ],
                      [
                        -27.892,
                        0.001
                      ],
                      [
                        -22.082,
                        -5.811
                      ]
                    ],
                    "c": false
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    115.843,
                    227.344
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 8",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 8,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        29.67,
                        -18.88
                      ],
                      [
                        23.107,
                        -18.88
                      ],
                      [
                        24.715,
                        -37.706
                      ],
                      [
                        31.879,
                        -37.706
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        24.068,
                        28.859
                      ],
                      [
                        19.029,
                        28.859
                      ],
                      [
                        20.538,
                        11.199
                      ],
                      [
                        26.141,
                        11.199
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 2",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 2,
                "ty": "sh",
                "ix": 3,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -1.594,
                        -10.057
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0.259,
                        1.361
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -25.182,
                        -37.706
                      ],
                      [
                        -22.138,
                        -18.88
                      ],
                      [
                        -28.684,
                        -18.88
                      ],
                      [
                        -31.841,
                        -37.706
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 3",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 3,
                "ty": "sh",
                "ix": 4,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        14.45,
                        -18.88
                      ],
                      [
                        15.075,
                        -37.706
                      ],
                      [
                        24.066,
                        -37.706
                      ],
                      [
                        22.458,
                        -18.88
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 4",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 4,
                "ty": "sh",
                "ix": 5,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        12.864,
                        28.859
                      ],
                      [
                        13.451,
                        11.199
                      ],
                      [
                        19.887,
                        11.199
                      ],
                      [
                        18.379,
                        28.859
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 5",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 5,
                "ty": "sh",
                "ix": 6,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.864,
                        -5.523
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0.959,
                        6.111
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -17.397,
                        11.199
                      ],
                      [
                        -14.63,
                        28.859
                      ],
                      [
                        -20.676,
                        28.859
                      ],
                      [
                        -23.638,
                        11.199
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 6",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 6,
                "ty": "sh",
                "ix": 7,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -1.108,
                        -7.054
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.994,
                        6.283
                      ]
                    ],
                    "v": [
                      [
                        -18.163,
                        6.324
                      ],
                      [
                        -24.456,
                        6.324
                      ],
                      [
                        -27.867,
                        -14.005
                      ],
                      [
                        -21.367,
                        -14.005
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 7",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 7,
                "ty": "sh",
                "ix": 8,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.329,
                        2.088
                      ],
                      [
                        0.711,
                        4.495
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.324,
                        -2.062
                      ],
                      [
                        -0.755,
                        -4.799
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -9.455,
                        -14.005
                      ],
                      [
                        -7.875,
                        6.324
                      ],
                      [
                        -17.508,
                        6.324
                      ],
                      [
                        -18.49,
                        0.087
                      ],
                      [
                        -20.71,
                        -14.005
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 8",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 8,
                "ty": "sh",
                "ix": 9,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.353,
                        2.213
                      ],
                      [
                        0.254,
                        1.077
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.412,
                        -2.6
                      ],
                      [
                        -1.215,
                        -7.612
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -9.833,
                        -18.88
                      ],
                      [
                        -21.482,
                        -18.88
                      ],
                      [
                        -22.639,
                        -26.155
                      ],
                      [
                        -24.564,
                        -37.706
                      ],
                      [
                        -11.298,
                        -37.706
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 9",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 9,
                "ty": "sh",
                "ix": 10,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        1.825,
                        -18.88
                      ],
                      [
                        -9.186,
                        -18.88
                      ],
                      [
                        -10.648,
                        -37.706
                      ],
                      [
                        1.391,
                        -37.706
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 10",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 10,
                "ty": "sh",
                "ix": 11,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        2.471,
                        -18.88
                      ],
                      [
                        2.038,
                        -37.706
                      ],
                      [
                        14.426,
                        -37.706
                      ],
                      [
                        13.801,
                        -18.88
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 11",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 11,
                "ty": "sh",
                "ix": 12,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        3.053,
                        6.324
                      ],
                      [
                        2.585,
                        -14.005
                      ],
                      [
                        13.639,
                        -14.005
                      ],
                      [
                        12.964,
                        6.324
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 12",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 12,
                "ty": "sh",
                "ix": 13,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -7.227,
                        6.324
                      ],
                      [
                        -8.807,
                        -14.005
                      ],
                      [
                        1.937,
                        -14.005
                      ],
                      [
                        2.405,
                        6.324
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 13",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 13,
                "ty": "sh",
                "ix": 14,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.052,
                        6.695
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.746,
                        -4.767
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -6.123,
                        28.859
                      ],
                      [
                        -13.975,
                        28.859
                      ],
                      [
                        -16.743,
                        11.199
                      ],
                      [
                        -7.496,
                        11.199
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 14",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 14,
                "ty": "sh",
                "ix": 15,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -6.847,
                        11.199
                      ],
                      [
                        2.517,
                        11.199
                      ],
                      [
                        2.924,
                        28.859
                      ],
                      [
                        -5.475,
                        28.859
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 15",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 15,
                "ty": "sh",
                "ix": 16,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        3.572,
                        28.859
                      ],
                      [
                        3.165,
                        11.199
                      ],
                      [
                        12.801,
                        11.199
                      ],
                      [
                        12.215,
                        28.859
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 16",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 16,
                "ty": "sh",
                "ix": 17,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        22.691,
                        -14.005
                      ],
                      [
                        29.098,
                        -14.005
                      ],
                      [
                        26.713,
                        6.324
                      ],
                      [
                        20.954,
                        6.324
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 17",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 17,
                "ty": "sh",
                "ix": 18,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        20.305,
                        6.324
                      ],
                      [
                        13.611,
                        6.324
                      ],
                      [
                        14.288,
                        -14.005
                      ],
                      [
                        22.042,
                        -14.005
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 18",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 18,
                "ty": "sh",
                "ix": 19,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.84,
                        -0.819
                      ],
                      [
                        -0.076,
                        -0.021
                      ],
                      [
                        -0.199,
                        -0.036
                      ],
                      [
                        -0.451,
                        -0.019
                      ],
                      [
                        -0.003,
                        -0.022
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.518,
                        0.103
                      ],
                      [
                        -0.418,
                        3.56
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.513,
                        3.059
                      ],
                      [
                        0.075,
                        0.024
                      ],
                      [
                        0.194,
                        0.05
                      ],
                      [
                        0.43,
                        0.088
                      ],
                      [
                        0.004,
                        0.021
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.547,
                        0
                      ],
                      [
                        3.432,
                        -0.53
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        32.607,
                        -38.357
                      ],
                      [
                        -32.606,
                        -38.357
                      ],
                      [
                        -20.858,
                        31.689
                      ],
                      [
                        -15.291,
                        37.925
                      ],
                      [
                        -15.063,
                        37.987
                      ],
                      [
                        -14.482,
                        38.138
                      ],
                      [
                        -13.156,
                        38.29
                      ],
                      [
                        -13.145,
                        38.357
                      ],
                      [
                        -12.827,
                        38.307
                      ],
                      [
                        -12.826,
                        38.307
                      ],
                      [
                        16.239,
                        38.307
                      ],
                      [
                        17.837,
                        38.147
                      ],
                      [
                        24.434,
                        31.302
                      ],
                      [
                        30.096,
                        -16.961
                      ],
                      [
                        30.352,
                        -18.88
                      ],
                      [
                        30.322,
                        -18.88
                      ],
                      [
                        32.564,
                        -37.993
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 19",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "mm",
                "mm": 1,
                "nm": "Merge Paths 1",
                "mn": "ADBE Vector Filter - Merge",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.877999997606,
                    0.877999997606,
                    0.877999997606,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    153.659,
                    354.123
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 21",
            "np": 23,
            "cix": 2,
            "bm": 0,
            "ix": 13,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -2.398,
                        4.406
                      ],
                      [
                        -1.69,
                        0.712
                      ],
                      [
                        -1.399,
                        1.189
                      ],
                      [
                        -1.75,
                        2.992
                      ],
                      [
                        -3.962,
                        -0.181
                      ],
                      [
                        -1.715,
                        -4.225
                      ],
                      [
                        -0.035,
                        -4.564
                      ],
                      [
                        1.852,
                        -1.704
                      ],
                      [
                        2.315,
                        0.071
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -1.394,
                        -1.195
                      ],
                      [
                        0.879,
                        -1.614
                      ],
                      [
                        1.69,
                        -0.711
                      ],
                      [
                        2.637,
                        -2.244
                      ],
                      [
                        2.009,
                        -3.436
                      ],
                      [
                        4.538,
                        0.206
                      ],
                      [
                        1.715,
                        4.226
                      ],
                      [
                        0.02,
                        2.523
                      ],
                      [
                        -1.708,
                        1.571
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -14.697,
                        14.773
                      ],
                      [
                        -16.803,
                        5.386
                      ],
                      [
                        -12.368,
                        2.261
                      ],
                      [
                        -7.504,
                        -0.257
                      ],
                      [
                        -2.389,
                        -9.22
                      ],
                      [
                        7.333,
                        -15.049
                      ],
                      [
                        17.37,
                        -6.912
                      ],
                      [
                        19.18,
                        6.569
                      ],
                      [
                        17.236,
                        13.641
                      ],
                      [
                        10.641,
                        15.16
                      ],
                      [
                        -14.156,
                        14.398
                      ]
                    ],
                    "c": false
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.961000031116,
                    0.961000031116,
                    0.961000031116,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    153.536,
                    369.183
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 22",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 14,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 0,
        "op": 720,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 11,
        "ty": 4,
        "nm": "Shape Layer 2",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.667
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.333
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 23,
                "s": [
                  -57
                ]
              },
              {
                "t": 40,
                "s": [
                  54
                ]
              }
            ],
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 23,
                "s": [
                  298.5,
                  243.5,
                  0
                ],
                "to": [
                  41.5,
                  -8.583,
                  0
                ],
                "ti": [
                  -41.5,
                  8.583,
                  0
                ]
              },
              {
                "t": 40,
                "s": [
                  547.5,
                  192,
                  0
                ]
              }
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              381.5,
              119.5,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0.121,
                        -0.066
                      ],
                      [
                        4.18,
                        7.653
                      ],
                      [
                        -0.121,
                        0.066
                      ],
                      [
                        -4.181,
                        -7.655
                      ]
                    ],
                    "o": [
                      [
                        -0.122,
                        0.066
                      ],
                      [
                        -4.181,
                        -7.655
                      ],
                      [
                        0.122,
                        -0.067
                      ],
                      [
                        4.179,
                        7.653
                      ]
                    ],
                    "v": [
                      [
                        7.569,
                        13.859
                      ],
                      [
                        -0.22,
                        0.121
                      ],
                      [
                        -7.569,
                        -13.858
                      ],
                      [
                        0.221,
                        -0.12
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    403.623,
                    130.317
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 9",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.086,
                        -0.108
                      ],
                      [
                        6.7,
                        -5.363
                      ],
                      [
                        0.087,
                        0.108
                      ],
                      [
                        -6.702,
                        5.364
                      ]
                    ],
                    "o": [
                      [
                        0.087,
                        0.108
                      ],
                      [
                        -6.702,
                        5.364
                      ],
                      [
                        -0.086,
                        -0.109
                      ],
                      [
                        6.7,
                        -5.363
                      ]
                    ],
                    "v": [
                      [
                        12.133,
                        -9.712
                      ],
                      [
                        0.158,
                        0.195
                      ],
                      [
                        -12.133,
                        9.711
                      ],
                      [
                        -0.156,
                        -0.197
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    362.71,
                    123.27
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 10",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -0.009,
                        -0.015
                      ],
                      [
                        0.459,
                        -0.312
                      ],
                      [
                        0.848,
                        -0.564
                      ],
                      [
                        3.126,
                        -2.031
                      ],
                      [
                        9.652,
                        -6.184
                      ],
                      [
                        0.153,
                        0.031
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.422,
                        0.558
                      ],
                      [
                        0.816,
                        1.08
                      ],
                      [
                        1.5,
                        1.987
                      ],
                      [
                        2.27,
                        3.02
                      ],
                      [
                        1.284,
                        1.727
                      ],
                      [
                        0.353,
                        0.484
                      ],
                      [
                        -0.014,
                        0.01
                      ],
                      [
                        -0.347,
                        -0.432
                      ],
                      [
                        -0.629,
                        -0.799
                      ],
                      [
                        -2.279,
                        -2.95
                      ],
                      [
                        -3.016,
                        -3.946
                      ],
                      [
                        -1.639,
                        -2.154
                      ],
                      [
                        -0.846,
                        -1.114
                      ],
                      [
                        -0.429,
                        -0.565
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.665,
                        0.12
                      ],
                      [
                        -6.392,
                        4.051
                      ],
                      [
                        -1.826,
                        1.14
                      ],
                      [
                        -0.511,
                        0.311
                      ]
                    ],
                    "o": [
                      [
                        0.01,
                        0.015
                      ],
                      [
                        -0.498,
                        0.331
                      ],
                      [
                        -1.805,
                        1.173
                      ],
                      [
                        -6.371,
                        4.082
                      ],
                      [
                        -0.673,
                        -0.119
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.429,
                        -0.565
                      ],
                      [
                        -0.844,
                        -1.115
                      ],
                      [
                        -1.631,
                        -2.16
                      ],
                      [
                        -2.984,
                        -3.97
                      ],
                      [
                        -2.224,
                        -2.991
                      ],
                      [
                        -0.599,
                        -0.823
                      ],
                      [
                        -0.321,
                        -0.451
                      ],
                      [
                        0.013,
                        -0.011
                      ],
                      [
                        0.371,
                        0.469
                      ],
                      [
                        1.316,
                        1.703
                      ],
                      [
                        2.294,
                        3.002
                      ],
                      [
                        1.508,
                        1.981
                      ],
                      [
                        0.819,
                        1.079
                      ],
                      [
                        0.421,
                        0.557
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.146,
                        -0.023
                      ],
                      [
                        9.682,
                        -6.136
                      ],
                      [
                        3.161,
                        -1.975
                      ],
                      [
                        0.869,
                        -0.53
                      ],
                      [
                        0.475,
                        -0.285
                      ]
                    ],
                    "v": [
                      [
                        30.099,
                        -5.877
                      ],
                      [
                        29.413,
                        -5.38
                      ],
                      [
                        27.395,
                        -4.038
                      ],
                      [
                        19.921,
                        0.819
                      ],
                      [
                        -4.839,
                        16.684
                      ],
                      [
                        -5.184,
                        16.612
                      ],
                      [
                        -5.194,
                        16.599
                      ],
                      [
                        -5.215,
                        16.572
                      ],
                      [
                        -5.255,
                        16.52
                      ],
                      [
                        -5.337,
                        16.411
                      ],
                      [
                        -5.499,
                        16.197
                      ],
                      [
                        -5.823,
                        15.77
                      ],
                      [
                        -6.466,
                        14.919
                      ],
                      [
                        -7.742,
                        13.235
                      ],
                      [
                        -10.233,
                        9.941
                      ],
                      [
                        -14.936,
                        3.71
                      ],
                      [
                        -22.88,
                        -6.858
                      ],
                      [
                        -28.199,
                        -14.009
                      ],
                      [
                        -29.625,
                        -15.969
                      ],
                      [
                        -30.095,
                        -16.673
                      ],
                      [
                        -29.544,
                        -16.03
                      ],
                      [
                        -28.043,
                        -14.127
                      ],
                      [
                        -22.595,
                        -7.073
                      ],
                      [
                        -14.569,
                        3.431
                      ],
                      [
                        -9.841,
                        9.645
                      ],
                      [
                        -7.342,
                        12.934
                      ],
                      [
                        -6.066,
                        14.617
                      ],
                      [
                        -5.423,
                        15.467
                      ],
                      [
                        -5.098,
                        15.895
                      ],
                      [
                        -4.936,
                        16.108
                      ],
                      [
                        -4.854,
                        16.215
                      ],
                      [
                        -4.814,
                        16.27
                      ],
                      [
                        -4.794,
                        16.296
                      ],
                      [
                        -4.784,
                        16.309
                      ],
                      [
                        -5.108,
                        16.26
                      ],
                      [
                        19.73,
                        0.52
                      ],
                      [
                        27.289,
                        -4.203
                      ],
                      [
                        29.359,
                        -5.465
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    388.208,
                    108.156
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 11",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.082,
                        0.5
                      ],
                      [
                        -0.161,
                        0.949
                      ],
                      [
                        -0.622,
                        3.593
                      ],
                      [
                        -2.207,
                        12.552
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        22.621,
                        4.039
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.26,
                        -12.561
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -10.605,
                        -1.93
                      ],
                      [
                        -2.893,
                        -0.533
                      ],
                      [
                        -0.768,
                        -0.144
                      ],
                      [
                        -0.21,
                        -0.041
                      ],
                      [
                        -0.004,
                        -0.005
                      ],
                      [
                        0.185,
                        0.029
                      ],
                      [
                        0.354,
                        0.058
                      ],
                      [
                        1.411,
                        0.241
                      ],
                      [
                        5.284,
                        0.921
                      ],
                      [
                        17.785,
                        3.142
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.64,
                        14.762
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -16.676,
                        -3.005
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.32,
                        -7.22
                      ],
                      [
                        0.356,
                        -1.923
                      ],
                      [
                        0.096,
                        -0.506
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0.088,
                        -0.516
                      ],
                      [
                        0.335,
                        -1.937
                      ],
                      [
                        1.265,
                        -7.199
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -16.681,
                        -2.979
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.655,
                        14.759
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        17.708,
                        3.223
                      ],
                      [
                        5.295,
                        0.976
                      ],
                      [
                        1.426,
                        0.268
                      ],
                      [
                        0.363,
                        0.071
                      ],
                      [
                        0.193,
                        0.039
                      ],
                      [
                        0.003,
                        0.005
                      ],
                      [
                        -0.205,
                        -0.033
                      ],
                      [
                        -0.761,
                        -0.13
                      ],
                      [
                        -2.885,
                        -0.503
                      ],
                      [
                        -10.65,
                        -1.882
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.246,
                        -12.563
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        22.615,
                        4.074
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.302,
                        12.588
                      ],
                      [
                        -0.662,
                        3.566
                      ],
                      [
                        -0.177,
                        0.93
                      ],
                      [
                        -0.094,
                        0.484
                      ]
                    ],
                    "v": [
                      [
                        26.405,
                        26.214
                      ],
                      [
                        26.52,
                        25.444
                      ],
                      [
                        26.892,
                        23.245
                      ],
                      [
                        28.337,
                        14.9
                      ],
                      [
                        33.622,
                        -15.167
                      ],
                      [
                        33.785,
                        -14.932
                      ],
                      [
                        -26.412,
                        -25.679
                      ],
                      [
                        -26.417,
                        -25.68
                      ],
                      [
                        -26.126,
                        -25.883
                      ],
                      [
                        -33.563,
                        15.458
                      ],
                      [
                        -33.748,
                        15.192
                      ],
                      [
                        9.574,
                        23.077
                      ],
                      [
                        21.956,
                        25.36
                      ],
                      [
                        25.254,
                        25.98
                      ],
                      [
                        26.108,
                        26.147
                      ],
                      [
                        26.405,
                        26.214
                      ],
                      [
                        26.13,
                        26.178
                      ],
                      [
                        25.297,
                        26.042
                      ],
                      [
                        22.033,
                        25.485
                      ],
                      [
                        9.68,
                        23.332
                      ],
                      [
                        -33.829,
                        15.644
                      ],
                      [
                        -34.055,
                        15.604
                      ],
                      [
                        -34.014,
                        15.377
                      ],
                      [
                        -26.62,
                        -25.972
                      ],
                      [
                        -26.576,
                        -26.219
                      ],
                      [
                        -26.328,
                        -26.174
                      ],
                      [
                        -26.324,
                        -26.173
                      ],
                      [
                        33.856,
                        -15.33
                      ],
                      [
                        34.055,
                        -15.294
                      ],
                      [
                        34.019,
                        -15.096
                      ],
                      [
                        28.504,
                        15.058
                      ],
                      [
                        26.966,
                        23.34
                      ],
                      [
                        26.556,
                        25.494
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.45098039215686275,
                    0.9019607843137255,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    384.486,
                    117.411
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 12",
            "np": 4,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 0,
        "op": 720,
        "st": 0,
        "bm": 0
      }
    ],
    "markers": [
      
    ]
  };

  export const whatsappAnimationData = {
    "v": "5.7.5",
    "fr": 30,
    "ip": 0,
    "op": 1050,
    "w": 1000,
    "h": 1000,
    "nm": "Composição 1",
    "ddd": 0,
    "assets": [
      {
        "id": "image_0",
        "w": 1920,
        "h": 1084,
        "u": "",
        "p": "data:image/png;base64,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",
        "e": 1
      },
      {
        "id": "image_1",
        "w": 154,
        "h": 30,
        "u": "",
        "p": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSgBBwcHCggKEwoKEygaFhooKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKP/AABEIAB4AmgMBEQACEQEDEQH/xAGiAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgsQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+gEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoLEQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/APnOgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA//2Q==",
        "e": 1
      },
      {
        "id": "image_2",
        "w": 144,
        "h": 132,
        "u": "",
        "p": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACEAQMAAABFzzB2AAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAA1BMVEVHcEyC+tLSAAAAAXRSTlMAQObYZgAAABlJREFUSMftwQENAAAAwqD3T20ON6AAAHg1CcwAAYGUZbgAAAAASUVORK5CYII=",
        "e": 1
      },
      {
        "id": "image_3",
        "w": 144,
        "h": 132,
        "u": "",
        "p": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACEBAMAAACNL78GAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAG1BMVEVHcEz//v7//////v7//////////////v7//v5YqIbKAAAACHRSTlMAv3jrKxFLoQEk8EIAAAFJSURBVGje7ZaxasMwFEXd0KQdnaGQMd28FhrIaMiSsWl+oGPGQhevsaG9n90nWZKl0e8FSuGeyRHo4KPYkquKEEIIIYQQQsj/4hH9eHEBthskrlrR/V4ubiE6AZ83EXVu6vM6AHwrRQtgNw3Kr61SdMHQToNHDG86kV/qic38siA6FS2asiDq8FPZykaR3MKTsWwUlbewcI+USrTc4zUbOmjKvOiuXFxVmRc1xX+vK3OiVTlTV+ZEB+DDXOZE8s7X5jIRDbJp9OYyEQFfQJuV9cqtFtf3rG1VdM4T7fK7OBf7ybw1amVdUlunLEsvbW0sC9tIalOXBdExzleXBVFs05fFzT+0nfMnSiUKbfqy7FyrTWVRtPTnkaEsHdn+hGz0ZUnk2ixlSeTapOwlfkasDR9aQ4MMtegBJWqRtJlEhBBCCCGEEEL+kl/kYqrrjtH/KAAAAABJRU5ErkJggg==",
        "e": 1
      },
      {
        "id": "image_4",
        "w": 144,
        "h": 132,
        "u": "",
        "p": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACEAQMAAABFzzB2AAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAACXBIWXMAAAABAAAAAQBPJcTWAAAABlBMVEVHcEyAXlQ2IXrmAAAAAXRSTlMAQObYZgAAAPVJREFUSMftlksSgyAQRLWyYMkROIpHk6N5FI7g0oXFJPEHNOMEykqykeUraZoBemyae/x9dB6JIprwIyJKSfsi5HAezjRvlM7sF2RRKhVTK4rF9IrmTJ18pp7ob4QGXDBe8rGjET3ELvSOZvQQuzgQJfUD1B/IotPIa47agFyORtxPQCqg6RzpgOYi5LNdFyLKalOKLFbwAhpqEP0OuSL0BRP1xbl6HJ2Mzu+EEZFwC7WIhHtf9oaYx9eKyFUlABcdTMAYAXkp0pjgY+KRCVEmag9jVoxtJtyZFsA0iq0WAzYraDoK1dkGtojZj82wMf7+bcDxBCGtrzBQKf+oAAAAAElFTkSuQmCC",
        "e": 1
      },
      {
        "id": "comp_0",
        "layers": [
          {
            "ddd": 0,
            "ind": 1,
            "ty": 2,
            "nm": "Otomatik Mesaj.png",
            "cl": "png",
            "refId": "image_0",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 636,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 642,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11,
                "x": "var $bm_rt;\n$bm_rt = transform.opacity;"
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  582,
                  498,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  609,
                  449,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  70,
                  70,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "ip": 544,
            "op": 926,
            "st": 544,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 2,
            "ty": 2,
            "nm": "Otomatik Mesaj.png",
            "cl": "png",
            "refId": "image_0",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 391,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 396,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11,
                "x": "var $bm_rt;\n$bm_rt = transform.opacity;"
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  421,
                  500,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  414,
                  698,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  70,
                  70,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "ip": 310,
            "op": 1360,
            "st": 310,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 3,
            "ty": 5,
            "nm": "Kurumsal ZEKA",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 115,
                    "s": [
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 116,
                    "s": [
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 136,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 137,
                    "s": [
                      100
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  428,
                  276,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "t": {
              "d": {
                "k": [
                  {
                    "s": {
                      "s": 14,
                      "f": "Helvetica",
                      "t": "Kurumsal ZEKA",
                      "ca": 0,
                      "j": 0,
                      "tr": 0,
                      "lh": 16.8,
                      "ls": 0,
                      "fc": [
                        1,
                        1,
                        1
                      ]
                    },
                    "t": 0
                  }
                ]
              },
              "p": {
                
              },
              "m": {
                "g": 1,
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 2
                }
              },
              "a": [
                
              ]
            },
            "ip": 116,
            "op": 1166,
            "st": 116,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 4,
            "ty": 2,
            "nm": "Screenshot 2020-12-26 at 3.56.28 AM.png",
            "cl": "56 28 png",
            "refId": "image_1",
            "sr": 1,
            "ks": {
              "o": {
                "a": 0,
                "k": 100,
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  500,
                  500,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  73,
                  253,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "ip": 112,
            "op": 901,
            "st": 112,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 5,
            "ty": 0,
            "nm": "Screenshot_2020-12-25_at_9.22.27_PM-removebg-preview",
            "cl": "22 27_PM-removebg-preview",
            "refId": "comp_1",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 106,
                    "s": [
                      0
                    ]
                  },
                  {
                    "t": 128,
                    "s": [
                      100
                    ]
                  }
                ],
                "ix": 11,
                "x": "var $bm_rt;\n$bm_rt = transform.opacity;"
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  402,
                  238,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  58,
                  -45,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  34,
                  34,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "w": 144,
            "h": 132,
            "ip": 106,
            "op": 1156,
            "st": 106,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 6,
            "ty": 5,
            "nm": "KurumSozlesme.PDF dosyasıını indirebilirsiniz.  ",
            "cl": "PDF ",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 889,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 902,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11,
                "x": "var $bm_rt;\n$bm_rt = transform.opacity;"
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 829,
                    "s": [
                      679.5,
                      691.5,
                      0
                    ],
                    "to": [
                      -26.667,
                      -6.75,
                      0
                    ],
                    "ti": [
                      26.667,
                      6.75,
                      0
                    ]
                  },
                  {
                    "t": 840,
                    "s": [
                      519.5,
                      651,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 829,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  },
                  {
                    "t": 840,
                    "s": [
                      71,
                      71,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "t": {
              "d": {
                "k": [
                  {
                    "s": {
                      "sz": [
                        320.690124511719,
                        82.8873062133789
                      ],
                      "ps": [
                        -169.5,
                        -14.5
                      ],
                      "s": 16,
                      "f": "Helvetica",
                      "t": "KurumSozlesme.PDF dosyasıını indirebilirsiniz.\r\r",
                      "ca": 0,
                      "j": 0,
                      "tr": 0,
                      "lh": 19.2000007629395,
                      "ls": 0,
                      "fc": [
                        1,
                        1,
                        1
                      ]
                    },
                    "t": 0
                  }
                ]
              },
              "p": {
                
              },
              "m": {
                "g": 1,
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 2
                }
              },
              "a": [
                {
                  "nm": "Animador 1",
                  "s": {
                    "t": 0,
                    "xe": {
                      "a": 0,
                      "k": 0,
                      "ix": 7
                    },
                    "ne": {
                      "a": 0,
                      "k": 0,
                      "ix": 8
                    },
                    "a": {
                      "a": 0,
                      "k": 100,
                      "ix": 4
                    },
                    "b": 1,
                    "rn": 0,
                    "sh": 1,
                    "s": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 794,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 843,
                          "s": [
                            100
                          ]
                        }
                      ],
                      "ix": 1
                    },
                    "r": 1
                  },
                  "a": {
                    "o": {
                      "a": 0,
                      "k": 0,
                      "ix": 9
                    }
                  }
                }
              ]
            },
            "ip": 790,
            "op": 1209,
            "st": 489,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "Talk 04/conversas_whatsapp contornos 2",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 889,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 902,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11,
                "x": "var $bm_rt;\n$bm_rt = transform.opacity;"
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 828,
                    "s": [
                      682.5,
                      738,
                      0
                    ],
                    "to": [
                      -26.833,
                      -10.833,
                      0
                    ],
                    "ti": [
                      26.833,
                      11,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 840,
                    "s": [
                      521.5,
                      673,
                      0
                    ],
                    "to": [
                      -26.833,
                      -11,
                      0
                    ],
                    "ti": [
                      0,
                      0.167,
                      0
                    ]
                  },
                  {
                    "t": 1014,
                    "s": [
                      521.5,
                      672,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  130.5,
                  48,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 773,
                    "s": [
                      0,
                      0,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0
                      ]
                    },
                    "t": 779,
                    "s": [
                      180,
                      180,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 784,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 828,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "t": 840,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.254,
                            0.203
                          ],
                          [
                            1.434,
                            -1.784
                          ],
                          [
                            0.202,
                            0.19
                          ],
                          [
                            0.174,
                            -0.219
                          ],
                          [
                            -0.434,
                            -0.434
                          ],
                          [
                            -1.665,
                            2.072
                          ]
                        ],
                        "o": [
                          [
                            -1.447,
                            1.799
                          ],
                          [
                            -0.214,
                            -0.2
                          ],
                          [
                            -0.211,
                            0.265
                          ],
                          [
                            0.428,
                            0.43
                          ],
                          [
                            1.651,
                            -2.055
                          ],
                          [
                            -0.264,
                            -0.211
                          ]
                        ],
                        "v": [
                          [
                            2.363,
                            -3.392
                          ],
                          [
                            -1.941,
                            1.96
                          ],
                          [
                            -2.546,
                            1.394
                          ],
                          [
                            -3.12,
                            2.113
                          ],
                          [
                            -1.845,
                            3.392
                          ],
                          [
                            3.12,
                            -2.786
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 894,
                          "s": [
                            0.207843139768,
                            0.564705908298,
                            0.517647087574,
                            1
                          ]
                        },
                        {
                          "t": 898,
                          "s": [
                            0,
                            0.642999985639,
                            0.933000033509,
                            1
                          ]
                        }
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        227.225,
                        67.285
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.261,
                            0.209
                          ],
                          [
                            1.462,
                            -1.818
                          ],
                          [
                            0.612,
                            0.618
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.884,
                            -0.883
                          ],
                          [
                            -1.663,
                            2.071
                          ]
                        ],
                        "o": [
                          [
                            -1.442,
                            1.795
                          ],
                          [
                            -0.645,
                            -0.652
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.878,
                            0.878
                          ],
                          [
                            1.64,
                            -2.042
                          ],
                          [
                            -0.262,
                            -0.209
                          ]
                        ],
                        "v": [
                          [
                            3.038,
                            -3.388
                          ],
                          [
                            -1.294,
                            1.999
                          ],
                          [
                            -3.156,
                            0.117
                          ],
                          [
                            -3.794,
                            0.756
                          ],
                          [
                            -1.163,
                            3.388
                          ],
                          [
                            3.794,
                            -2.783
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 894,
                          "s": [
                            0.207843139768,
                            0.564705908298,
                            0.517647087574,
                            1
                          ]
                        },
                        {
                          "t": 898,
                          "s": [
                            0,
                            0.642999985639,
                            0.933000033509,
                            1
                          ]
                        }
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        223.396,
                        67.281
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 2",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.206,
                            0.205
                          ],
                          [
                            0,
                            0.284
                          ],
                          [
                            0.196,
                            0.207
                          ],
                          [
                            0.403,
                            0
                          ],
                          [
                            0.178,
                            -0.207
                          ],
                          [
                            0,
                            -0.278
                          ],
                          [
                            -0.23,
                            -0.176
                          ],
                          [
                            -0.314,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.206,
                            -0.205
                          ],
                          [
                            0,
                            -0.246
                          ],
                          [
                            -0.197,
                            -0.207
                          ],
                          [
                            -0.399,
                            0
                          ],
                          [
                            -0.179,
                            0.207
                          ],
                          [
                            0,
                            0.311
                          ],
                          [
                            0.231,
                            0.176
                          ],
                          [
                            0.366,
                            0
                          ]
                        ],
                        "v": [
                          [
                            0.85,
                            -0.929
                          ],
                          [
                            1.159,
                            -1.663
                          ],
                          [
                            0.864,
                            -2.343
                          ],
                          [
                            -0.035,
                            -2.654
                          ],
                          [
                            -0.901,
                            -2.343
                          ],
                          [
                            -1.169,
                            -1.616
                          ],
                          [
                            -0.823,
                            -0.885
                          ],
                          [
                            -0.007,
                            -0.621
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.254,
                            0.208
                          ],
                          [
                            0,
                            0.413
                          ],
                          [
                            0.261,
                            0.222
                          ],
                          [
                            0.409,
                            0
                          ],
                          [
                            0.251,
                            -0.226
                          ],
                          [
                            0,
                            -0.401
                          ],
                          [
                            -0.23,
                            -0.251
                          ],
                          [
                            -0.48,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.254,
                            -0.208
                          ],
                          [
                            0,
                            -0.428
                          ],
                          [
                            -0.262,
                            -0.221
                          ],
                          [
                            -0.397,
                            0
                          ],
                          [
                            -0.251,
                            0.226
                          ],
                          [
                            0,
                            0.344
                          ],
                          [
                            0.229,
                            0.251
                          ],
                          [
                            0.385,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.004,
                            2.341
                          ],
                          [
                            1.385,
                            1.41
                          ],
                          [
                            0.993,
                            0.436
                          ],
                          [
                            -0.014,
                            0.103
                          ],
                          [
                            -0.986,
                            0.443
                          ],
                          [
                            -1.362,
                            1.383
                          ],
                          [
                            -1.018,
                            2.276
                          ],
                          [
                            0.046,
                            2.652
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.129,
                            0.133
                          ],
                          [
                            0,
                            0.394
                          ],
                          [
                            -0.357,
                            0.353
                          ],
                          [
                            -0.654,
                            0
                          ],
                          [
                            -0.36,
                            -0.334
                          ],
                          [
                            0,
                            -0.446
                          ],
                          [
                            0.209,
                            -0.255
                          ],
                          [
                            0.246,
                            -0.138
                          ],
                          [
                            -0.158,
                            -0.163
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.392,
                            -0.405
                          ],
                          [
                            0.714,
                            0
                          ],
                          [
                            0.445,
                            0.35
                          ],
                          [
                            0,
                            0.665
                          ],
                          [
                            -0.19,
                            0.285
                          ],
                          [
                            -0.375,
                            0.151
                          ]
                        ],
                        "o": [
                          [
                            -0.244,
                            -0.246
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.357,
                            -0.355
                          ],
                          [
                            0.634,
                            0
                          ],
                          [
                            0.36,
                            0.334
                          ],
                          [
                            0,
                            0.413
                          ],
                          [
                            -0.117,
                            0.145
                          ],
                          [
                            0.275,
                            0.126
                          ],
                          [
                            0.293,
                            0.307
                          ],
                          [
                            0,
                            0.582
                          ],
                          [
                            -0.391,
                            0.405
                          ],
                          [
                            -0.644,
                            0
                          ],
                          [
                            -0.444,
                            -0.349
                          ],
                          [
                            0,
                            -0.391
                          ],
                          [
                            0.191,
                            -0.284
                          ],
                          [
                            -0.231,
                            -0.099
                          ]
                        ],
                        "v": [
                          [
                            -1.676,
                            -0.65
                          ],
                          [
                            -2.042,
                            -1.61
                          ],
                          [
                            -1.506,
                            -2.879
                          ],
                          [
                            0.011,
                            -3.41
                          ],
                          [
                            1.501,
                            -2.909
                          ],
                          [
                            2.04,
                            -1.739
                          ],
                          [
                            1.727,
                            -0.737
                          ],
                          [
                            1.182,
                            -0.312
                          ],
                          [
                            1.831,
                            0.122
                          ],
                          [
                            2.272,
                            1.322
                          ],
                          [
                            1.685,
                            2.802
                          ],
                          [
                            0.028,
                            3.41
                          ],
                          [
                            -1.605,
                            2.885
                          ],
                          [
                            -2.272,
                            1.364
                          ],
                          [
                            -1.986,
                            0.35
                          ],
                          [
                            -1.136,
                            -0.303
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        212.733,
                        66.881
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 3",
                "np": 7,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.256,
                            0.382
                          ],
                          [
                            0,
                            1.04
                          ],
                          [
                            0.185,
                            0.484
                          ],
                          [
                            0.534,
                            0
                          ],
                          [
                            0.227,
                            -0.461
                          ],
                          [
                            0,
                            -0.897
                          ],
                          [
                            -0.145,
                            -0.409
                          ],
                          [
                            -0.537,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.256,
                            -0.381
                          ],
                          [
                            0,
                            -0.751
                          ],
                          [
                            -0.185,
                            -0.486
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.226,
                            0.46
                          ],
                          [
                            0,
                            0.674
                          ],
                          [
                            0.222,
                            0.625
                          ],
                          [
                            0.431,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.002,
                            2.066
                          ],
                          [
                            1.385,
                            -0.067
                          ],
                          [
                            1.107,
                            -1.92
                          ],
                          [
                            0.029,
                            -2.648
                          ],
                          [
                            -1.046,
                            -1.957
                          ],
                          [
                            -1.386,
                            0.077
                          ],
                          [
                            -1.167,
                            1.702
                          ],
                          [
                            -0.029,
                            2.639
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.382,
                            -0.705
                          ],
                          [
                            0,
                            -0.948
                          ],
                          [
                            0.268,
                            -0.587
                          ],
                          [
                            0.879,
                            0
                          ],
                          [
                            0.388,
                            0.689
                          ],
                          [
                            0,
                            0.969
                          ],
                          [
                            -0.194,
                            0.539
                          ],
                          [
                            -0.951,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.296,
                            0.545
                          ],
                          [
                            0,
                            0.898
                          ],
                          [
                            -0.388,
                            0.843
                          ],
                          [
                            -0.795,
                            0
                          ],
                          [
                            -0.323,
                            -0.575
                          ],
                          [
                            0,
                            -0.751
                          ],
                          [
                            0.363,
                            -1.003
                          ],
                          [
                            0.857,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.838,
                            -2.338
                          ],
                          [
                            2.281,
                            -0.099
                          ],
                          [
                            1.88,
                            2.131
                          ],
                          [
                            -0.023,
                            3.396
                          ],
                          [
                            -1.796,
                            2.362
                          ],
                          [
                            -2.281,
                            0.044
                          ],
                          [
                            -1.99,
                            -1.891
                          ],
                          [
                            -0.02,
                            -3.396
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        207.473,
                        66.885
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 4",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            1.434
                          ],
                          [
                            0.483,
                            1.434
                          ],
                          [
                            0.483,
                            2.441
                          ],
                          [
                            -0.483,
                            2.441
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            -2.441
                          ],
                          [
                            0.483,
                            -2.441
                          ],
                          [
                            0.483,
                            -1.434
                          ],
                          [
                            -0.483,
                            -1.434
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        203.801,
                        67.661
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 5",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.204,
                            0.422
                          ],
                          [
                            -0.594,
                            0.344
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.164
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.231,
                            0.227
                          ],
                          [
                            0.385,
                            0
                          ],
                          [
                            0.218,
                            -0.433
                          ],
                          [
                            0.013,
                            -0.411
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.203,
                            0.363
                          ],
                          [
                            -0.911,
                            0
                          ],
                          [
                            -0.349,
                            -0.409
                          ],
                          [
                            0,
                            -0.502
                          ],
                          [
                            0.372,
                            -0.376
                          ],
                          [
                            0.557,
                            -0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.172,
                            -0.151
                          ],
                          [
                            0.08,
                            -0.326
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.205,
                            -0.422
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.397,
                            -0.231
                          ],
                          [
                            0.252,
                            -0.256
                          ],
                          [
                            0,
                            -0.386
                          ],
                          [
                            -0.23,
                            -0.226
                          ],
                          [
                            -0.569,
                            0
                          ],
                          [
                            -0.118,
                            0.231
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.009,
                            -0.576
                          ],
                          [
                            0.36,
                            -0.641
                          ],
                          [
                            0.758,
                            0
                          ],
                          [
                            0.35,
                            0.409
                          ],
                          [
                            0,
                            0.529
                          ],
                          [
                            -0.216,
                            0.219
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.302,
                            0.167
                          ],
                          [
                            -0.307,
                            0.268
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.031,
                            -0.569
                          ]
                        ],
                        "v": [
                          [
                            -1.933,
                            1.83
                          ],
                          [
                            -0.735,
                            0.682
                          ],
                          [
                            0.152,
                            0.169
                          ],
                          [
                            0.988,
                            -0.424
                          ],
                          [
                            1.367,
                            -1.303
                          ],
                          [
                            1.02,
                            -2.221
                          ],
                          [
                            0.096,
                            -2.561
                          ],
                          [
                            -1.085,
                            -1.911
                          ],
                          [
                            -1.28,
                            -0.949
                          ],
                          [
                            -2.124,
                            -0.949
                          ],
                          [
                            -1.806,
                            -2.357
                          ],
                          [
                            0.101,
                            -3.318
                          ],
                          [
                            1.761,
                            -2.704
                          ],
                          [
                            2.286,
                            -1.337
                          ],
                          [
                            1.727,
                            0.02
                          ],
                          [
                            0.568,
                            0.814
                          ],
                          [
                            -0.065,
                            1.165
                          ],
                          [
                            -0.776,
                            1.641
                          ],
                          [
                            -1.358,
                            2.533
                          ],
                          [
                            2.254,
                            2.533
                          ],
                          [
                            2.254,
                            3.318
                          ],
                          [
                            -2.286,
                            3.318
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        199.592,
                        66.784
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 6",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.237,
                            0.138
                          ],
                          [
                            -0.117,
                            0.51
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.6,
                            -0.058
                          ],
                          [
                            0.237,
                            -0.136
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.221,
                            -1.391
                          ],
                          [
                            -1.221,
                            -2.028
                          ],
                          [
                            0.035,
                            -2.322
                          ],
                          [
                            0.566,
                            -3.293
                          ],
                          [
                            1.221,
                            -3.293
                          ],
                          [
                            1.221,
                            3.293
                          ],
                          [
                            0.335,
                            3.293
                          ],
                          [
                            0.335,
                            -1.391
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        193.877,
                        66.809
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 7",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 7,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            9.15,
                            2.815
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.315,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.314
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.315
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -9.15,
                            -2.815
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.314
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.315
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.315,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            121.092,
                            25.588
                          ],
                          [
                            111.658,
                            12.636
                          ],
                          [
                            111.658,
                            -34.489
                          ],
                          [
                            105.658,
                            -40.489
                          ],
                          [
                            -124.241,
                            -40.489
                          ],
                          [
                            -130.241,
                            -34.489
                          ],
                          [
                            -130.241,
                            34.489
                          ],
                          [
                            -124.241,
                            40.489
                          ],
                          [
                            105.658,
                            40.489
                          ],
                          [
                            111.658,
                            34.489
                          ],
                          [
                            111.658,
                            30.515
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.33300000359,
                        0.282000014361,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        130.491,
                        40.739
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 8",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 8,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": 773,
            "op": 1406,
            "st": 686,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 8,
            "ty": 5,
            "nm": "Sözleşme",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 889,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 902,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 749,
                    "s": [
                      300.5,
                      674,
                      0
                    ],
                    "to": [
                      0,
                      0,
                      0
                    ],
                    "ti": [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 750,
                    "s": [
                      302,
                      667,
                      0
                    ],
                    "to": [
                      0,
                      0,
                      0
                    ],
                    "ti": [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    "t": 761,
                    "s": [
                      495,
                      602,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 749,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  },
                  {
                    "t": 761,
                    "s": [
                      70,
                      70,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "t": {
              "d": {
                "k": [
                  {
                    "s": {
                      "sz": [
                        339,
                        35
                      ],
                      "ps": [
                        -169.5,
                        -14.5
                      ],
                      "s": 16,
                      "f": "Helvetica",
                      "t": "Sözleşme",
                      "ca": 0,
                      "j": 0,
                      "tr": 0,
                      "lh": 19.2,
                      "ls": 0,
                      "fc": [
                        1,
                        1,
                        1
                      ]
                    },
                    "t": 0
                  }
                ]
              },
              "p": {
                
              },
              "m": {
                "g": 1,
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 2
                }
              },
              "a": [
                {
                  "nm": "Animador 1",
                  "s": {
                    "t": 0,
                    "xe": {
                      "a": 0,
                      "k": 0,
                      "ix": 7
                    },
                    "ne": {
                      "a": 0,
                      "k": 0,
                      "ix": 8
                    },
                    "a": {
                      "a": 0,
                      "k": 100,
                      "ix": 4
                    },
                    "b": 1,
                    "rn": 0,
                    "sh": 1,
                    "s": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 661,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 710,
                          "s": [
                            100
                          ]
                        }
                      ],
                      "ix": 1
                    },
                    "r": 1
                  },
                  "a": {
                    "o": {
                      "a": 0,
                      "k": 0,
                      "ix": 9
                    }
                  }
                }
              ]
            },
            "ip": 650,
            "op": 1325,
            "st": 590,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "Talk 05/conversas_whatsapp contornos",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 887,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 900,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 749,
                    "s": [
                      286.5,
                      674,
                      0
                    ],
                    "to": [
                      32.333,
                      -12.5,
                      0
                    ],
                    "ti": [
                      -32.333,
                      12.5,
                      0
                    ]
                  },
                  {
                    "t": 761,
                    "s": [
                      480.5,
                      599,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  129.5,
                  16,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 640,
                    "s": [
                      0,
                      0,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 646,
                    "s": [
                      180,
                      180,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 651,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 749,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "t": 761,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.206,
                            0.205
                          ],
                          [
                            0,
                            0.284
                          ],
                          [
                            0.196,
                            0.207
                          ],
                          [
                            0.403,
                            0
                          ],
                          [
                            0.178,
                            -0.207
                          ],
                          [
                            0,
                            -0.278
                          ],
                          [
                            -0.23,
                            -0.176
                          ],
                          [
                            -0.314,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.206,
                            -0.205
                          ],
                          [
                            0,
                            -0.246
                          ],
                          [
                            -0.197,
                            -0.207
                          ],
                          [
                            -0.399,
                            0
                          ],
                          [
                            -0.179,
                            0.207
                          ],
                          [
                            0,
                            0.311
                          ],
                          [
                            0.231,
                            0.176
                          ],
                          [
                            0.366,
                            0
                          ]
                        ],
                        "v": [
                          [
                            0.85,
                            -0.929
                          ],
                          [
                            1.159,
                            -1.663
                          ],
                          [
                            0.864,
                            -2.343
                          ],
                          [
                            -0.035,
                            -2.654
                          ],
                          [
                            -0.901,
                            -2.343
                          ],
                          [
                            -1.169,
                            -1.616
                          ],
                          [
                            -0.823,
                            -0.885
                          ],
                          [
                            -0.007,
                            -0.621
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.254,
                            0.208
                          ],
                          [
                            0,
                            0.413
                          ],
                          [
                            0.261,
                            0.222
                          ],
                          [
                            0.409,
                            0
                          ],
                          [
                            0.251,
                            -0.226
                          ],
                          [
                            0,
                            -0.401
                          ],
                          [
                            -0.23,
                            -0.251
                          ],
                          [
                            -0.48,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.254,
                            -0.208
                          ],
                          [
                            0,
                            -0.428
                          ],
                          [
                            -0.262,
                            -0.221
                          ],
                          [
                            -0.397,
                            0
                          ],
                          [
                            -0.251,
                            0.226
                          ],
                          [
                            0,
                            0.344
                          ],
                          [
                            0.229,
                            0.251
                          ],
                          [
                            0.385,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.004,
                            2.341
                          ],
                          [
                            1.385,
                            1.41
                          ],
                          [
                            0.993,
                            0.436
                          ],
                          [
                            -0.014,
                            0.103
                          ],
                          [
                            -0.986,
                            0.443
                          ],
                          [
                            -1.362,
                            1.383
                          ],
                          [
                            -1.018,
                            2.276
                          ],
                          [
                            0.046,
                            2.652
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.129,
                            0.133
                          ],
                          [
                            0,
                            0.394
                          ],
                          [
                            -0.357,
                            0.353
                          ],
                          [
                            -0.654,
                            0
                          ],
                          [
                            -0.36,
                            -0.334
                          ],
                          [
                            0,
                            -0.446
                          ],
                          [
                            0.209,
                            -0.255
                          ],
                          [
                            0.246,
                            -0.138
                          ],
                          [
                            -0.158,
                            -0.163
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.392,
                            -0.405
                          ],
                          [
                            0.714,
                            0
                          ],
                          [
                            0.445,
                            0.35
                          ],
                          [
                            0,
                            0.665
                          ],
                          [
                            -0.19,
                            0.285
                          ],
                          [
                            -0.375,
                            0.151
                          ]
                        ],
                        "o": [
                          [
                            -0.244,
                            -0.246
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.357,
                            -0.355
                          ],
                          [
                            0.634,
                            0
                          ],
                          [
                            0.36,
                            0.334
                          ],
                          [
                            0,
                            0.413
                          ],
                          [
                            -0.117,
                            0.145
                          ],
                          [
                            0.275,
                            0.126
                          ],
                          [
                            0.293,
                            0.307
                          ],
                          [
                            0,
                            0.582
                          ],
                          [
                            -0.391,
                            0.405
                          ],
                          [
                            -0.644,
                            0
                          ],
                          [
                            -0.444,
                            -0.349
                          ],
                          [
                            0,
                            -0.391
                          ],
                          [
                            0.191,
                            -0.284
                          ],
                          [
                            -0.231,
                            -0.099
                          ]
                        ],
                        "v": [
                          [
                            -1.676,
                            -0.65
                          ],
                          [
                            -2.042,
                            -1.61
                          ],
                          [
                            -1.506,
                            -2.879
                          ],
                          [
                            0.011,
                            -3.41
                          ],
                          [
                            1.501,
                            -2.909
                          ],
                          [
                            2.04,
                            -1.739
                          ],
                          [
                            1.727,
                            -0.737
                          ],
                          [
                            1.182,
                            -0.312
                          ],
                          [
                            1.831,
                            0.122
                          ],
                          [
                            2.272,
                            1.322
                          ],
                          [
                            1.685,
                            2.802
                          ],
                          [
                            0.028,
                            3.41
                          ],
                          [
                            -1.605,
                            2.885
                          ],
                          [
                            -2.272,
                            1.364
                          ],
                          [
                            -1.986,
                            0.35
                          ],
                          [
                            -1.136,
                            -0.303
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        248.439,
                        23.413
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 7,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.256,
                            0.382
                          ],
                          [
                            0,
                            1.04
                          ],
                          [
                            0.185,
                            0.484
                          ],
                          [
                            0.534,
                            0
                          ],
                          [
                            0.227,
                            -0.461
                          ],
                          [
                            0,
                            -0.897
                          ],
                          [
                            -0.145,
                            -0.409
                          ],
                          [
                            -0.537,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.256,
                            -0.381
                          ],
                          [
                            0,
                            -0.751
                          ],
                          [
                            -0.185,
                            -0.486
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.226,
                            0.46
                          ],
                          [
                            0,
                            0.674
                          ],
                          [
                            0.222,
                            0.625
                          ],
                          [
                            0.431,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.002,
                            2.066
                          ],
                          [
                            1.385,
                            -0.067
                          ],
                          [
                            1.107,
                            -1.92
                          ],
                          [
                            0.029,
                            -2.648
                          ],
                          [
                            -1.046,
                            -1.957
                          ],
                          [
                            -1.386,
                            0.077
                          ],
                          [
                            -1.167,
                            1.702
                          ],
                          [
                            -0.029,
                            2.639
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.382,
                            -0.705
                          ],
                          [
                            0,
                            -0.948
                          ],
                          [
                            0.268,
                            -0.587
                          ],
                          [
                            0.879,
                            0
                          ],
                          [
                            0.388,
                            0.689
                          ],
                          [
                            0,
                            0.969
                          ],
                          [
                            -0.194,
                            0.539
                          ],
                          [
                            -0.951,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.296,
                            0.545
                          ],
                          [
                            0,
                            0.898
                          ],
                          [
                            -0.388,
                            0.843
                          ],
                          [
                            -0.795,
                            0
                          ],
                          [
                            -0.323,
                            -0.575
                          ],
                          [
                            0,
                            -0.751
                          ],
                          [
                            0.363,
                            -1.003
                          ],
                          [
                            0.857,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.838,
                            -2.338
                          ],
                          [
                            2.281,
                            -0.099
                          ],
                          [
                            1.88,
                            2.131
                          ],
                          [
                            -0.023,
                            3.396
                          ],
                          [
                            -1.796,
                            2.362
                          ],
                          [
                            -2.281,
                            0.044
                          ],
                          [
                            -1.99,
                            -1.891
                          ],
                          [
                            -0.02,
                            -3.396
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        243.179,
                        23.417
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 2",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            1.434
                          ],
                          [
                            0.483,
                            1.434
                          ],
                          [
                            0.483,
                            2.441
                          ],
                          [
                            -0.483,
                            2.441
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            -2.441
                          ],
                          [
                            0.483,
                            -2.441
                          ],
                          [
                            0.483,
                            -1.434
                          ],
                          [
                            -0.483,
                            -1.434
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        239.507,
                        24.194
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 3",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.204,
                            0.422
                          ],
                          [
                            -0.594,
                            0.344
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.164
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.231,
                            0.227
                          ],
                          [
                            0.385,
                            0
                          ],
                          [
                            0.218,
                            -0.433
                          ],
                          [
                            0.013,
                            -0.411
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.203,
                            0.363
                          ],
                          [
                            -0.911,
                            0
                          ],
                          [
                            -0.349,
                            -0.409
                          ],
                          [
                            0,
                            -0.502
                          ],
                          [
                            0.372,
                            -0.376
                          ],
                          [
                            0.557,
                            -0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.172,
                            -0.151
                          ],
                          [
                            0.08,
                            -0.326
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.205,
                            -0.422
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.397,
                            -0.231
                          ],
                          [
                            0.252,
                            -0.256
                          ],
                          [
                            0,
                            -0.386
                          ],
                          [
                            -0.23,
                            -0.226
                          ],
                          [
                            -0.569,
                            0
                          ],
                          [
                            -0.118,
                            0.231
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.009,
                            -0.576
                          ],
                          [
                            0.36,
                            -0.641
                          ],
                          [
                            0.758,
                            0
                          ],
                          [
                            0.35,
                            0.409
                          ],
                          [
                            0,
                            0.529
                          ],
                          [
                            -0.216,
                            0.219
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.302,
                            0.167
                          ],
                          [
                            -0.307,
                            0.268
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.031,
                            -0.569
                          ]
                        ],
                        "v": [
                          [
                            -1.933,
                            1.83
                          ],
                          [
                            -0.735,
                            0.682
                          ],
                          [
                            0.152,
                            0.169
                          ],
                          [
                            0.988,
                            -0.424
                          ],
                          [
                            1.367,
                            -1.303
                          ],
                          [
                            1.02,
                            -2.221
                          ],
                          [
                            0.096,
                            -2.561
                          ],
                          [
                            -1.085,
                            -1.911
                          ],
                          [
                            -1.28,
                            -0.949
                          ],
                          [
                            -2.124,
                            -0.949
                          ],
                          [
                            -1.806,
                            -2.357
                          ],
                          [
                            0.101,
                            -3.318
                          ],
                          [
                            1.761,
                            -2.704
                          ],
                          [
                            2.286,
                            -1.337
                          ],
                          [
                            1.727,
                            0.02
                          ],
                          [
                            0.568,
                            0.814
                          ],
                          [
                            -0.065,
                            1.165
                          ],
                          [
                            -0.776,
                            1.641
                          ],
                          [
                            -1.358,
                            2.533
                          ],
                          [
                            2.254,
                            2.533
                          ],
                          [
                            2.254,
                            3.318
                          ],
                          [
                            -2.286,
                            3.318
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        235.298,
                        23.316
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 4",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.237,
                            0.138
                          ],
                          [
                            -0.117,
                            0.51
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.6,
                            -0.058
                          ],
                          [
                            0.237,
                            -0.136
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.221,
                            -1.391
                          ],
                          [
                            -1.221,
                            -2.028
                          ],
                          [
                            0.035,
                            -2.322
                          ],
                          [
                            0.566,
                            -3.293
                          ],
                          [
                            1.221,
                            -3.293
                          ],
                          [
                            1.221,
                            3.293
                          ],
                          [
                            0.335,
                            3.293
                          ],
                          [
                            0.335,
                            -1.391
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        229.583,
                        23.342
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 5",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.313
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            6.595,
                            -2.029
                          ],
                          [
                            -2.168,
                            -0.263
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.314
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.596,
                            3.099
                          ],
                          [
                            -8.524,
                            2.622
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.314
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.313
                          ]
                        ],
                        "v": [
                          [
                            122.938,
                            -15.604
                          ],
                          [
                            -105.235,
                            -15.604
                          ],
                          [
                            -111.235,
                            -9.604
                          ],
                          [
                            -111.235,
                            -6.947
                          ],
                          [
                            -120.414,
                            4.013
                          ],
                          [
                            -111.235,
                            8.91
                          ],
                          [
                            -111.235,
                            9.604
                          ],
                          [
                            -105.235,
                            15.604
                          ],
                          [
                            122.938,
                            15.604
                          ],
                          [
                            128.938,
                            9.604
                          ],
                          [
                            128.938,
                            -9.604
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.238999998803,
                        0.234999997008,
                        0.246999987434,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        129.188,
                        15.854
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 6",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": 639,
            "op": 1272,
            "st": 552,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 11,
            "ty": 5,
            "nm": "Son güncelleme 15dk önce” soluk gri renkte yazsın Alsancak Şube\t10.000 Bornova Şube\t5.000 Göztepe Şube\t3.000 Toplam\t18.000   ",
            "cl": "000 000 000 000",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 887,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 900,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 638,
                    "s": [
                      679.5,
                      569.5,
                      0
                    ],
                    "to": [
                      -26.667,
                      -9.083,
                      0
                    ],
                    "ti": [
                      26.667,
                      9.083,
                      0
                    ]
                  },
                  {
                    "t": 650,
                    "s": [
                      519.5,
                      515,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 638,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  },
                  {
                    "t": 650,
                    "s": [
                      71,
                      71,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "t": {
              "d": {
                "k": [
                  {
                    "s": {
                      "sz": [
                        320.690124511719,
                        102.60563659668
                      ],
                      "ps": [
                        -169.5,
                        -27.1760597229004
                      ],
                      "s": 14,
                      "f": "Helvetica",
                      "t": "Son güncelleme 15dk önce” soluk gri renkte yazsın\rAlsancak Şube\t10.000\rBornova Şube\t5.000\rGöztepe Şube\t3.000\rToplam\t18.000\r\r\r",
                      "ca": 0,
                      "j": 0,
                      "tr": 0,
                      "lh": 16.8000011444092,
                      "ls": 0,
                      "fc": [
                        1,
                        1,
                        1
                      ]
                    },
                    "t": 0
                  }
                ]
              },
              "p": {
                
              },
              "m": {
                "g": 1,
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 2
                }
              },
              "a": [
                {
                  "nm": "Animador 1",
                  "s": {
                    "t": 0,
                    "xe": {
                      "a": 0,
                      "k": 0,
                      "ix": 7
                    },
                    "ne": {
                      "a": 0,
                      "k": 0,
                      "ix": 8
                    },
                    "a": {
                      "a": 0,
                      "k": 100,
                      "ix": 4
                    },
                    "b": 1,
                    "rn": 0,
                    "sh": 1,
                    "s": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 533,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 582,
                          "s": [
                            100
                          ]
                        }
                      ],
                      "ix": 1
                    },
                    "r": 1
                  },
                  "a": {
                    "o": {
                      "a": 0,
                      "k": 0,
                      "ix": 9
                    }
                  }
                }
              ]
            },
            "ip": 529,
            "op": 901,
            "st": 228,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 12,
            "ty": 4,
            "nm": "01/Sem título-3 contornos 2",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 547,
                    "s": [
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 557,
                    "s": [
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 617,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 634,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  801,
                  529,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  501,
                  127,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  11.898,
                  11.898,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -2.876,
                            1.919
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.342,
                            1.22
                          ],
                          [
                            4.592,
                            -1.825
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.411,
                            0
                          ],
                          [
                            3.571,
                            1.386
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.263,
                            -1.772
                          ],
                          [
                            1.877,
                            -8.726
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -17.56,
                            0
                          ],
                          [
                            -4.296,
                            11.086
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            5.345,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.63
                          ],
                          [
                            -2.629,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.697,
                            -11.135
                          ],
                          [
                            -3.214,
                            -1.677
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.529,
                            1.401
                          ],
                          [
                            -3.379,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -4.586,
                            -1.781
                          ],
                          [
                            -3.279,
                            1.778
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            16.648
                          ],
                          [
                            13.569,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -4.447,
                            2.966
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.629,
                            0
                          ],
                          [
                            0,
                            -2.63
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.46,
                            0
                          ]
                        ],
                        "v": [
                          [
                            21.747,
                            13.699
                          ],
                          [
                            30.804,
                            7.66
                          ],
                          [
                            30.804,
                            -28.754
                          ],
                          [
                            22.426,
                            -44.913
                          ],
                          [
                            10.281,
                            -43.041
                          ],
                          [
                            10.27,
                            -43.036
                          ],
                          [
                            -0.001,
                            -40.314
                          ],
                          [
                            -10.322,
                            -43.008
                          ],
                          [
                            -10.334,
                            -43.013
                          ],
                          [
                            -10.339,
                            -43.015
                          ],
                          [
                            -22.93,
                            -44.865
                          ],
                          [
                            -30.805,
                            -28.815
                          ],
                          [
                            -30.805,
                            9.785
                          ],
                          [
                            -0.001,
                            38.988
                          ],
                          [
                            28.852,
                            20.406
                          ],
                          [
                            27.031,
                            21.621
                          ],
                          [
                            12.061,
                            26.154
                          ],
                          [
                            4.008,
                            26.154
                          ],
                          [
                            -0.753,
                            21.393
                          ],
                          [
                            4.008,
                            16.632
                          ],
                          [
                            12.061,
                            16.632
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.004,
                            -0.065
                          ],
                          [
                            6.825,
                            -7.108
                          ],
                          [
                            6.874,
                            0
                          ],
                          [
                            3.745,
                            3.873
                          ],
                          [
                            -0.003,
                            0.157
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.063
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -8.262,
                            0
                          ],
                          [
                            -6.519,
                            4.125
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.004,
                            0.113
                          ],
                          [
                            -3.748,
                            3.903
                          ],
                          [
                            -6.849,
                            0
                          ],
                          [
                            -6.89,
                            -7.128
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.004,
                            -0.065
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            6.52,
                            4.125
                          ],
                          [
                            8.263,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.063
                          ]
                        ],
                        "v": [
                          [
                            22.563,
                            47.076
                          ],
                          [
                            16.008,
                            65.853
                          ],
                          [
                            -0.001,
                            71.734
                          ],
                          [
                            -15.968,
                            65.896
                          ],
                          [
                            -22.564,
                            47.077
                          ],
                          [
                            -22.564,
                            47.076
                          ],
                          [
                            -22.559,
                            46.884
                          ],
                          [
                            -22.559,
                            42.17
                          ],
                          [
                            -0.001,
                            48.511
                          ],
                          [
                            22.558,
                            42.17
                          ],
                          [
                            22.558,
                            46.884
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            5.278,
                            2.246
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.907,
                            6.88
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            7.876
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            6.938,
                            0.971
                          ],
                          [
                            31.9,
                            0
                          ],
                          [
                            1.029,
                            -30.979
                          ],
                          [
                            0,
                            -7.202
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -7.876,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -4.286,
                            -5.38
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.002,
                            -5.736
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.894,
                            -0.892
                          ],
                          [
                            -1.262,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.893,
                            0.894
                          ],
                          [
                            0,
                            1.262
                          ]
                        ],
                        "o": [
                          [
                            -0.001,
                            -5.735
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            4.287,
                            -5.381
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            7.875,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -7.202
                          ],
                          [
                            -1.029,
                            -30.979
                          ],
                          [
                            -31.899,
                            0
                          ],
                          [
                            -6.939,
                            0.971
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            7.876
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.907,
                            6.882
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -5.279,
                            2.246
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.264
                          ],
                          [
                            0.892,
                            0.894
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.263,
                            0
                          ],
                          [
                            0.893,
                            -0.893
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            81.257,
                            74.099
                          ],
                          [
                            72.567,
                            60.96
                          ],
                          [
                            32.08,
                            43.735
                          ],
                          [
                            32.08,
                            33.641
                          ],
                          [
                            39.985,
                            14.97
                          ],
                          [
                            48.262,
                            14.97
                          ],
                          [
                            62.546,
                            0.685
                          ],
                          [
                            62.546,
                            -19.791
                          ],
                          [
                            50.248,
                            -33.934
                          ],
                          [
                            -0.001,
                            -81.258
                          ],
                          [
                            -50.249,
                            -33.934
                          ],
                          [
                            -62.546,
                            -19.791
                          ],
                          [
                            -62.546,
                            0.685
                          ],
                          [
                            -48.262,
                            14.97
                          ],
                          [
                            -39.986,
                            14.97
                          ],
                          [
                            -32.081,
                            33.641
                          ],
                          [
                            -32.081,
                            43.735
                          ],
                          [
                            -72.567,
                            60.96
                          ],
                          [
                            -81.258,
                            74.1
                          ],
                          [
                            -81.258,
                            76.495
                          ],
                          [
                            -79.864,
                            79.862
                          ],
                          [
                            -76.498,
                            81.258
                          ],
                          [
                            76.497,
                            81.258
                          ],
                          [
                            79.865,
                            79.862
                          ],
                          [
                            81.258,
                            76.495
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        159.998,
                        120.497
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.295,
                            -3.811
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.779,
                            2.104
                          ],
                          [
                            3.271,
                            0
                          ],
                          [
                            2.428,
                            -2.229
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.611,
                            -4.062
                          ],
                          [
                            -1.78,
                            -2.104
                          ],
                          [
                            -3.559,
                            0
                          ],
                          [
                            -2.426,
                            2.23
                          ]
                        ],
                        "v": [
                          [
                            -10.203,
                            -6.068
                          ],
                          [
                            13.69,
                            -6.068
                          ],
                          [
                            11.938,
                            -15.318
                          ],
                          [
                            4.36,
                            -18.472
                          ],
                          [
                            -4.622,
                            -15.129
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.69,
                            -3.955
                          ],
                          [
                            0.324,
                            -4.602
                          ],
                          [
                            1.151,
                            -5.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.986,
                            -2.373
                          ],
                          [
                            -2.985,
                            0
                          ],
                          [
                            -2.373,
                            1.797
                          ],
                          [
                            -1.223,
                            1.725
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.992,
                            -3.596
                          ],
                          [
                            9.062,
                            0
                          ],
                          [
                            4.692,
                            4.819
                          ],
                          [
                            -2.301,
                            10.859
                          ],
                          [
                            -6.31,
                            5.43
                          ],
                          [
                            -8.235,
                            0
                          ],
                          [
                            -3.541,
                            -1.833
                          ]
                        ],
                        "o": [
                          [
                            1.582,
                            3.489
                          ],
                          [
                            -0.145,
                            2.697
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.043,
                            5.897
                          ],
                          [
                            1.797,
                            1.475
                          ],
                          [
                            3.164,
                            0
                          ],
                          [
                            1.258,
                            -0.971
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.15,
                            3.487
                          ],
                          [
                            -6.256,
                            5.716
                          ],
                          [
                            -7.479,
                            0
                          ],
                          [
                            -4.692,
                            -4.818
                          ],
                          [
                            2.157,
                            -10.176
                          ],
                          [
                            6.311,
                            -5.428
                          ],
                          [
                            4.888,
                            0
                          ],
                          [
                            3.543,
                            1.834
                          ]
                        ],
                        "v": [
                          [
                            27.55,
                            -19.714
                          ],
                          [
                            29.44,
                            -7.578
                          ],
                          [
                            27.497,
                            4.072
                          ],
                          [
                            -12.738,
                            4.072
                          ],
                          [
                            -9.825,
                            16.477
                          ],
                          [
                            -2.653,
                            18.688
                          ],
                          [
                            5.654,
                            15.992
                          ],
                          [
                            9.374,
                            11.947
                          ],
                          [
                            25.07,
                            11.947
                          ],
                          [
                            17.357,
                            22.572
                          ],
                          [
                            -5.619,
                            31.147
                          ],
                          [
                            -23.876,
                            23.92
                          ],
                          [
                            -27.462,
                            0.405
                          ],
                          [
                            -14.76,
                            -23.004
                          ],
                          [
                            7.056,
                            -31.147
                          ],
                          [
                            19.702,
                            -28.397
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        822.648,
                        135.001
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 2",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.485,
                            -0.593
                          ],
                          [
                            -3.128,
                            0
                          ],
                          [
                            -0.521,
                            0.018
                          ],
                          [
                            -0.539,
                            0.036
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.085,
                            2.77
                          ],
                          [
                            -0.755,
                            3.667
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.503,
                            2.41
                          ],
                          [
                            0.485,
                            0.593
                          ],
                          [
                            0.467,
                            0
                          ],
                          [
                            0.521,
                            -0.018
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -7.3,
                            0.252
                          ],
                          [
                            -1.331,
                            -1.761
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -17.501,
                            -10.508
                          ],
                          [
                            -15.182,
                            -21.456
                          ],
                          [
                            -6.983,
                            -21.456
                          ],
                          [
                            -3.479,
                            -37.853
                          ],
                          [
                            11.731,
                            -37.853
                          ],
                          [
                            8.226,
                            -21.456
                          ],
                          [
                            17.771,
                            -21.456
                          ],
                          [
                            15.453,
                            -10.508
                          ],
                          [
                            5.906,
                            -10.508
                          ],
                          [
                            -0.729,
                            20.558
                          ],
                          [
                            -0.755,
                            25.062
                          ],
                          [
                            4.666,
                            25.952
                          ],
                          [
                            6.149,
                            25.925
                          ],
                          [
                            7.74,
                            25.845
                          ],
                          [
                            5.26,
                            37.332
                          ],
                          [
                            -2.075,
                            37.601
                          ],
                          [
                            -16.152,
                            33.826
                          ],
                          [
                            -17.016,
                            25.682
                          ],
                          [
                            -9.303,
                            -10.508
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        778.439,
                        127.413
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.545,
                            -7.371
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.504,
                            1.654
                          ],
                          [
                            4.242,
                            0
                          ],
                          [
                            2.877,
                            -4.422
                          ],
                          [
                            0.755,
                            -3.632
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.05,
                            1.33
                          ],
                          [
                            -4.853,
                            0
                          ],
                          [
                            -3.183,
                            -3.182
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.682,
                            -3.092
                          ],
                          [
                            -0.862,
                            -3.021
                          ],
                          [
                            -5.214,
                            0
                          ],
                          [
                            -1.509,
                            2.338
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.625,
                            -3.02
                          ],
                          [
                            3.668,
                            -2.374
                          ],
                          [
                            6.076,
                            0
                          ],
                          [
                            3.182,
                            3.183
                          ]
                        ],
                        "v": [
                          [
                            30.025,
                            -9.492
                          ],
                          [
                            21.611,
                            30.096
                          ],
                          [
                            5.862,
                            30.096
                          ],
                          [
                            13.413,
                            -5.663
                          ],
                          [
                            13.682,
                            -12.782
                          ],
                          [
                            6.023,
                            -17.312
                          ],
                          [
                            -6.112,
                            -10.679
                          ],
                          [
                            -9.51,
                            -1.725
                          ],
                          [
                            -16.251,
                            30.096
                          ],
                          [
                            -31.57,
                            30.096
                          ],
                          [
                            -19.11,
                            -28.585
                          ],
                          [
                            -4.279,
                            -28.585
                          ],
                          [
                            -6.112,
                            -20.01
                          ],
                          [
                            0.9,
                            -26.535
                          ],
                          [
                            13.682,
                            -30.096
                          ],
                          [
                            27.57,
                            -25.322
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        721.152,
                        134.11
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 4",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.294,
                            -3.811
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.78,
                            2.104
                          ],
                          [
                            3.271,
                            0
                          ],
                          [
                            2.427,
                            -2.229
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.611,
                            -4.062
                          ],
                          [
                            -1.78,
                            -2.104
                          ],
                          [
                            -3.561,
                            0
                          ],
                          [
                            -2.427,
                            2.23
                          ]
                        ],
                        "v": [
                          [
                            -10.202,
                            -6.068
                          ],
                          [
                            13.691,
                            -6.068
                          ],
                          [
                            11.938,
                            -15.318
                          ],
                          [
                            4.361,
                            -18.472
                          ],
                          [
                            -4.62,
                            -15.129
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.691,
                            -3.955
                          ],
                          [
                            0.323,
                            -4.602
                          ],
                          [
                            1.151,
                            -5.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.984,
                            -2.373
                          ],
                          [
                            -2.985,
                            0
                          ],
                          [
                            -2.374,
                            1.797
                          ],
                          [
                            -1.223,
                            1.725
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.991,
                            -3.596
                          ],
                          [
                            9.062,
                            0
                          ],
                          [
                            4.692,
                            4.819
                          ],
                          [
                            -2.302,
                            10.859
                          ],
                          [
                            -6.31,
                            5.43
                          ],
                          [
                            -8.234,
                            0
                          ],
                          [
                            -3.542,
                            -1.833
                          ]
                        ],
                        "o": [
                          [
                            1.582,
                            3.489
                          ],
                          [
                            -0.144,
                            2.697
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.043,
                            5.897
                          ],
                          [
                            1.798,
                            1.475
                          ],
                          [
                            3.163,
                            0
                          ],
                          [
                            1.258,
                            -0.971
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.151,
                            3.487
                          ],
                          [
                            -6.257,
                            5.716
                          ],
                          [
                            -7.479,
                            0
                          ],
                          [
                            -4.693,
                            -4.818
                          ],
                          [
                            2.157,
                            -10.176
                          ],
                          [
                            6.311,
                            -5.428
                          ],
                          [
                            4.889,
                            0
                          ],
                          [
                            3.541,
                            1.834
                          ]
                        ],
                        "v": [
                          [
                            27.552,
                            -19.714
                          ],
                          [
                            29.44,
                            -7.578
                          ],
                          [
                            27.498,
                            4.072
                          ],
                          [
                            -12.737,
                            4.072
                          ],
                          [
                            -9.825,
                            16.477
                          ],
                          [
                            -2.651,
                            18.688
                          ],
                          [
                            5.655,
                            15.992
                          ],
                          [
                            9.376,
                            11.947
                          ],
                          [
                            25.071,
                            11.947
                          ],
                          [
                            17.359,
                            22.572
                          ],
                          [
                            -5.618,
                            31.147
                          ],
                          [
                            -23.874,
                            23.92
                          ],
                          [
                            -27.461,
                            0.405
                          ],
                          [
                            -14.76,
                            -23.004
                          ],
                          [
                            7.057,
                            -31.147
                          ],
                          [
                            19.705,
                            -28.397
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        656.96,
                        135.001
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 5",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.079,
                            5.143
                          ],
                          [
                            2.948,
                            3.093
                          ],
                          [
                            2.948,
                            0
                          ],
                          [
                            2.823,
                            -3.398
                          ],
                          [
                            1.078,
                            -5.035
                          ],
                          [
                            -1.439,
                            -3.254
                          ],
                          [
                            -4.352,
                            0
                          ],
                          [
                            -2.966,
                            3.237
                          ]
                        ],
                        "o": [
                          [
                            1.51,
                            -7.191
                          ],
                          [
                            -1.834,
                            -1.869
                          ],
                          [
                            -4.495,
                            0
                          ],
                          [
                            -2.822,
                            3.398
                          ],
                          [
                            -1.152,
                            5.429
                          ],
                          [
                            1.438,
                            3.254
                          ],
                          [
                            4.35,
                            0
                          ],
                          [
                            2.967,
                            -3.236
                          ]
                        ],
                        "v": [
                          [
                            9.089,
                            10.247
                          ],
                          [
                            6.931,
                            -5.179
                          ],
                          [
                            -0.243,
                            -7.982
                          ],
                          [
                            -11.219,
                            -2.886
                          ],
                          [
                            -17.07,
                            9.762
                          ],
                          [
                            -16.639,
                            22.787
                          ],
                          [
                            -7.955,
                            27.669
                          ],
                          [
                            3.02,
                            22.813
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.152,
                            -2.769
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.146,
                            -1.582
                          ],
                          [
                            4.171,
                            0
                          ],
                          [
                            3.506,
                            5.555
                          ],
                          [
                            -1.834,
                            8.702
                          ],
                          [
                            -5.844,
                            5.753
                          ],
                          [
                            -7.731,
                            0
                          ],
                          [
                            -2.427,
                            -1.565
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.949,
                            3.488
                          ],
                          [
                            -3.147,
                            1.581
                          ],
                          [
                            -6.868,
                            0
                          ],
                          [
                            -3.506,
                            -5.555
                          ],
                          [
                            2.158,
                            -10.032
                          ],
                          [
                            5.842,
                            -5.752
                          ],
                          [
                            3.56,
                            0
                          ],
                          [
                            2.427,
                            1.563
                          ]
                        ],
                        "v": [
                          [
                            13.511,
                            -12.567
                          ],
                          [
                            19.443,
                            -40.613
                          ],
                          [
                            35.03,
                            -40.613
                          ],
                          [
                            18.203,
                            38.778
                          ],
                          [
                            3.263,
                            38.778
                          ],
                          [
                            4.989,
                            30.635
                          ],
                          [
                            -4.153,
                            38.239
                          ],
                          [
                            -15.129,
                            40.613
                          ],
                          [
                            -30.689,
                            32.279
                          ],
                          [
                            -33.197,
                            10.894
                          ],
                          [
                            -21.196,
                            -12.783
                          ],
                          [
                            -0.836,
                            -21.412
                          ],
                          [
                            8.144,
                            -19.066
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        595.871,
                        125.427
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 6",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.545,
                            -7.371
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.503,
                            1.654
                          ],
                          [
                            4.242,
                            0
                          ],
                          [
                            2.876,
                            -4.422
                          ],
                          [
                            0.755,
                            -3.632
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.049,
                            1.33
                          ],
                          [
                            -4.854,
                            0
                          ],
                          [
                            -3.182,
                            -3.182
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.683,
                            -3.092
                          ],
                          [
                            -0.863,
                            -3.021
                          ],
                          [
                            -5.214,
                            0
                          ],
                          [
                            -1.51,
                            2.338
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.624,
                            -3.02
                          ],
                          [
                            3.668,
                            -2.374
                          ],
                          [
                            6.076,
                            0
                          ],
                          [
                            3.182,
                            3.183
                          ]
                        ],
                        "v": [
                          [
                            30.024,
                            -9.492
                          ],
                          [
                            21.61,
                            30.096
                          ],
                          [
                            5.861,
                            30.096
                          ],
                          [
                            13.412,
                            -5.663
                          ],
                          [
                            13.682,
                            -12.782
                          ],
                          [
                            6.023,
                            -17.312
                          ],
                          [
                            -6.112,
                            -10.679
                          ],
                          [
                            -9.51,
                            -1.725
                          ],
                          [
                            -16.252,
                            30.096
                          ],
                          [
                            -31.569,
                            30.096
                          ],
                          [
                            -19.11,
                            -28.585
                          ],
                          [
                            -4.278,
                            -28.585
                          ],
                          [
                            -6.112,
                            -20.01
                          ],
                          [
                            0.899,
                            -26.535
                          ],
                          [
                            13.682,
                            -30.096
                          ],
                          [
                            27.57,
                            -25.322
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        524.776,
                        134.11
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 7",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 7,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.294,
                            -3.811
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.78,
                            2.104
                          ],
                          [
                            3.271,
                            0
                          ],
                          [
                            2.427,
                            -2.229
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.611,
                            -4.062
                          ],
                          [
                            -1.78,
                            -2.104
                          ],
                          [
                            -3.561,
                            0
                          ],
                          [
                            -2.427,
                            2.23
                          ]
                        ],
                        "v": [
                          [
                            -10.202,
                            -6.068
                          ],
                          [
                            13.691,
                            -6.068
                          ],
                          [
                            11.938,
                            -15.318
                          ],
                          [
                            4.361,
                            -18.472
                          ],
                          [
                            -4.62,
                            -15.129
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.691,
                            -3.955
                          ],
                          [
                            0.323,
                            -4.602
                          ],
                          [
                            1.151,
                            -5.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.984,
                            -2.373
                          ],
                          [
                            -2.985,
                            0
                          ],
                          [
                            -2.374,
                            1.797
                          ],
                          [
                            -1.223,
                            1.725
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.991,
                            -3.596
                          ],
                          [
                            9.062,
                            0
                          ],
                          [
                            4.692,
                            4.819
                          ],
                          [
                            -2.302,
                            10.859
                          ],
                          [
                            -6.31,
                            5.43
                          ],
                          [
                            -8.234,
                            0
                          ],
                          [
                            -3.542,
                            -1.833
                          ]
                        ],
                        "o": [
                          [
                            1.582,
                            3.489
                          ],
                          [
                            -0.144,
                            2.697
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.043,
                            5.897
                          ],
                          [
                            1.798,
                            1.475
                          ],
                          [
                            3.163,
                            0
                          ],
                          [
                            1.258,
                            -0.971
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.151,
                            3.487
                          ],
                          [
                            -6.257,
                            5.716
                          ],
                          [
                            -7.479,
                            0
                          ],
                          [
                            -4.693,
                            -4.818
                          ],
                          [
                            2.157,
                            -10.176
                          ],
                          [
                            6.311,
                            -5.428
                          ],
                          [
                            4.889,
                            0
                          ],
                          [
                            3.541,
                            1.834
                          ]
                        ],
                        "v": [
                          [
                            27.552,
                            -19.714
                          ],
                          [
                            29.44,
                            -7.578
                          ],
                          [
                            27.498,
                            4.072
                          ],
                          [
                            -12.737,
                            4.072
                          ],
                          [
                            -9.825,
                            16.477
                          ],
                          [
                            -2.651,
                            18.688
                          ],
                          [
                            5.655,
                            15.992
                          ],
                          [
                            9.376,
                            11.947
                          ],
                          [
                            25.071,
                            11.947
                          ],
                          [
                            17.359,
                            22.572
                          ],
                          [
                            -5.618,
                            31.147
                          ],
                          [
                            -23.874,
                            23.92
                          ],
                          [
                            -27.461,
                            0.405
                          ],
                          [
                            -14.76,
                            -23.004
                          ],
                          [
                            7.057,
                            -31.147
                          ],
                          [
                            19.705,
                            -28.397
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        460.584,
                        135.001
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 8",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 8,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.486,
                            -0.593
                          ],
                          [
                            -3.128,
                            0
                          ],
                          [
                            -0.522,
                            0.018
                          ],
                          [
                            -0.539,
                            0.036
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.085,
                            2.77
                          ],
                          [
                            -0.755,
                            3.667
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.503,
                            2.41
                          ],
                          [
                            0.485,
                            0.593
                          ],
                          [
                            0.467,
                            0
                          ],
                          [
                            0.521,
                            -0.018
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -7.3,
                            0.252
                          ],
                          [
                            -1.33,
                            -1.761
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -17.501,
                            -10.508
                          ],
                          [
                            -15.182,
                            -21.456
                          ],
                          [
                            -6.984,
                            -21.456
                          ],
                          [
                            -3.479,
                            -37.853
                          ],
                          [
                            11.731,
                            -37.853
                          ],
                          [
                            8.226,
                            -21.456
                          ],
                          [
                            17.771,
                            -21.456
                          ],
                          [
                            15.453,
                            -10.508
                          ],
                          [
                            5.906,
                            -10.508
                          ],
                          [
                            -0.729,
                            20.558
                          ],
                          [
                            -0.755,
                            25.062
                          ],
                          [
                            4.666,
                            25.952
                          ],
                          [
                            6.148,
                            25.925
                          ],
                          [
                            7.74,
                            25.845
                          ],
                          [
                            5.258,
                            37.332
                          ],
                          [
                            -2.076,
                            37.601
                          ],
                          [
                            -16.154,
                            33.826
                          ],
                          [
                            -17.016,
                            25.682
                          ],
                          [
                            -9.303,
                            -10.508
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        416.377,
                        127.413
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 9",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 9,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -3.937,
                            9.708
                          ],
                          [
                            16.234,
                            9.708
                          ],
                          [
                            12.945,
                            -21.573
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            7.605,
                            -39.75
                          ],
                          [
                            26.375,
                            -39.75
                          ],
                          [
                            37.646,
                            39.75
                          ],
                          [
                            19.632,
                            39.75
                          ],
                          [
                            17.96,
                            23.408
                          ],
                          [
                            -11.326,
                            23.408
                          ],
                          [
                            -20.279,
                            39.75
                          ],
                          [
                            -37.646,
                            39.75
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        348.392,
                        124.456
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 10",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 10,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            69.836,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -69.836
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -69.836,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            69.836
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -69.836,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            69.836
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            69.836,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -69.836
                          ]
                        ],
                        "v": [
                          [
                            374.081,
                            -126.45
                          ],
                          [
                            -374.08,
                            -126.45
                          ],
                          [
                            -500.53,
                            -0.001
                          ],
                          [
                            -500.53,
                            0.001
                          ],
                          [
                            -374.08,
                            126.45
                          ],
                          [
                            374.081,
                            126.45
                          ],
                          [
                            500.53,
                            0.001
                          ],
                          [
                            500.53,
                            -0.001
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.086000001197,
                        0.791999966491,
                        0.709999952129,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        500.78,
                        126.7
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 11",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 11,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": 545,
            "op": 637,
            "st": 55,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 13,
            "ty": 4,
            "nm": "01/Sem título-3 contornos",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 547,
                    "s": [
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 557,
                    "s": [
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 617,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 634,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  801,
                  529,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  501,
                  127,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  11.898,
                  11.898,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -2.876,
                            1.919
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.342,
                            1.22
                          ],
                          [
                            4.592,
                            -1.825
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.411,
                            0
                          ],
                          [
                            3.571,
                            1.386
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.263,
                            -1.772
                          ],
                          [
                            1.877,
                            -8.726
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -17.56,
                            0
                          ],
                          [
                            -4.296,
                            11.086
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            5.345,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.63
                          ],
                          [
                            -2.629,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.697,
                            -11.135
                          ],
                          [
                            -3.214,
                            -1.677
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.529,
                            1.401
                          ],
                          [
                            -3.379,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -4.586,
                            -1.781
                          ],
                          [
                            -3.279,
                            1.778
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            16.648
                          ],
                          [
                            13.569,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -4.447,
                            2.966
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.629,
                            0
                          ],
                          [
                            0,
                            -2.63
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.46,
                            0
                          ]
                        ],
                        "v": [
                          [
                            21.747,
                            13.699
                          ],
                          [
                            30.804,
                            7.66
                          ],
                          [
                            30.804,
                            -28.754
                          ],
                          [
                            22.426,
                            -44.913
                          ],
                          [
                            10.281,
                            -43.041
                          ],
                          [
                            10.27,
                            -43.036
                          ],
                          [
                            -0.001,
                            -40.314
                          ],
                          [
                            -10.322,
                            -43.008
                          ],
                          [
                            -10.334,
                            -43.013
                          ],
                          [
                            -10.339,
                            -43.015
                          ],
                          [
                            -22.93,
                            -44.865
                          ],
                          [
                            -30.805,
                            -28.815
                          ],
                          [
                            -30.805,
                            9.785
                          ],
                          [
                            -0.001,
                            38.988
                          ],
                          [
                            28.852,
                            20.406
                          ],
                          [
                            27.031,
                            21.621
                          ],
                          [
                            12.061,
                            26.154
                          ],
                          [
                            4.008,
                            26.154
                          ],
                          [
                            -0.753,
                            21.393
                          ],
                          [
                            4.008,
                            16.632
                          ],
                          [
                            12.061,
                            16.632
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.004,
                            -0.065
                          ],
                          [
                            6.825,
                            -7.108
                          ],
                          [
                            6.874,
                            0
                          ],
                          [
                            3.745,
                            3.873
                          ],
                          [
                            -0.003,
                            0.157
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.063
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -8.262,
                            0
                          ],
                          [
                            -6.519,
                            4.125
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.004,
                            0.113
                          ],
                          [
                            -3.748,
                            3.903
                          ],
                          [
                            -6.849,
                            0
                          ],
                          [
                            -6.89,
                            -7.128
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.004,
                            -0.065
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            6.52,
                            4.125
                          ],
                          [
                            8.263,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.063
                          ]
                        ],
                        "v": [
                          [
                            22.563,
                            47.076
                          ],
                          [
                            16.008,
                            65.853
                          ],
                          [
                            -0.001,
                            71.734
                          ],
                          [
                            -15.968,
                            65.896
                          ],
                          [
                            -22.564,
                            47.077
                          ],
                          [
                            -22.564,
                            47.076
                          ],
                          [
                            -22.559,
                            46.884
                          ],
                          [
                            -22.559,
                            42.17
                          ],
                          [
                            -0.001,
                            48.511
                          ],
                          [
                            22.558,
                            42.17
                          ],
                          [
                            22.558,
                            46.884
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            5.278,
                            2.246
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.907,
                            6.88
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            7.876
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            6.938,
                            0.971
                          ],
                          [
                            31.9,
                            0
                          ],
                          [
                            1.029,
                            -30.979
                          ],
                          [
                            0,
                            -7.202
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -7.876,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -4.286,
                            -5.38
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.002,
                            -5.736
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.894,
                            -0.892
                          ],
                          [
                            -1.262,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.893,
                            0.894
                          ],
                          [
                            0,
                            1.262
                          ]
                        ],
                        "o": [
                          [
                            -0.001,
                            -5.735
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            4.287,
                            -5.381
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            7.875,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -7.202
                          ],
                          [
                            -1.029,
                            -30.979
                          ],
                          [
                            -31.899,
                            0
                          ],
                          [
                            -6.939,
                            0.971
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            7.876
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.907,
                            6.882
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -5.279,
                            2.246
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.264
                          ],
                          [
                            0.892,
                            0.894
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.263,
                            0
                          ],
                          [
                            0.893,
                            -0.893
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            81.257,
                            74.099
                          ],
                          [
                            72.567,
                            60.96
                          ],
                          [
                            32.08,
                            43.735
                          ],
                          [
                            32.08,
                            33.641
                          ],
                          [
                            39.985,
                            14.97
                          ],
                          [
                            48.262,
                            14.97
                          ],
                          [
                            62.546,
                            0.685
                          ],
                          [
                            62.546,
                            -19.791
                          ],
                          [
                            50.248,
                            -33.934
                          ],
                          [
                            -0.001,
                            -81.258
                          ],
                          [
                            -50.249,
                            -33.934
                          ],
                          [
                            -62.546,
                            -19.791
                          ],
                          [
                            -62.546,
                            0.685
                          ],
                          [
                            -48.262,
                            14.97
                          ],
                          [
                            -39.986,
                            14.97
                          ],
                          [
                            -32.081,
                            33.641
                          ],
                          [
                            -32.081,
                            43.735
                          ],
                          [
                            -72.567,
                            60.96
                          ],
                          [
                            -81.258,
                            74.1
                          ],
                          [
                            -81.258,
                            76.495
                          ],
                          [
                            -79.864,
                            79.862
                          ],
                          [
                            -76.498,
                            81.258
                          ],
                          [
                            76.497,
                            81.258
                          ],
                          [
                            79.865,
                            79.862
                          ],
                          [
                            81.258,
                            76.495
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        159.998,
                        120.497
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.295,
                            -3.811
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.779,
                            2.104
                          ],
                          [
                            3.271,
                            0
                          ],
                          [
                            2.428,
                            -2.229
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.611,
                            -4.062
                          ],
                          [
                            -1.78,
                            -2.104
                          ],
                          [
                            -3.559,
                            0
                          ],
                          [
                            -2.426,
                            2.23
                          ]
                        ],
                        "v": [
                          [
                            -10.203,
                            -6.068
                          ],
                          [
                            13.69,
                            -6.068
                          ],
                          [
                            11.938,
                            -15.318
                          ],
                          [
                            4.36,
                            -18.472
                          ],
                          [
                            -4.622,
                            -15.129
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.69,
                            -3.955
                          ],
                          [
                            0.324,
                            -4.602
                          ],
                          [
                            1.151,
                            -5.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.986,
                            -2.373
                          ],
                          [
                            -2.985,
                            0
                          ],
                          [
                            -2.373,
                            1.797
                          ],
                          [
                            -1.223,
                            1.725
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.992,
                            -3.596
                          ],
                          [
                            9.062,
                            0
                          ],
                          [
                            4.692,
                            4.819
                          ],
                          [
                            -2.301,
                            10.859
                          ],
                          [
                            -6.31,
                            5.43
                          ],
                          [
                            -8.235,
                            0
                          ],
                          [
                            -3.541,
                            -1.833
                          ]
                        ],
                        "o": [
                          [
                            1.582,
                            3.489
                          ],
                          [
                            -0.145,
                            2.697
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.043,
                            5.897
                          ],
                          [
                            1.797,
                            1.475
                          ],
                          [
                            3.164,
                            0
                          ],
                          [
                            1.258,
                            -0.971
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.15,
                            3.487
                          ],
                          [
                            -6.256,
                            5.716
                          ],
                          [
                            -7.479,
                            0
                          ],
                          [
                            -4.692,
                            -4.818
                          ],
                          [
                            2.157,
                            -10.176
                          ],
                          [
                            6.311,
                            -5.428
                          ],
                          [
                            4.888,
                            0
                          ],
                          [
                            3.543,
                            1.834
                          ]
                        ],
                        "v": [
                          [
                            27.55,
                            -19.714
                          ],
                          [
                            29.44,
                            -7.578
                          ],
                          [
                            27.497,
                            4.072
                          ],
                          [
                            -12.738,
                            4.072
                          ],
                          [
                            -9.825,
                            16.477
                          ],
                          [
                            -2.653,
                            18.688
                          ],
                          [
                            5.654,
                            15.992
                          ],
                          [
                            9.374,
                            11.947
                          ],
                          [
                            25.07,
                            11.947
                          ],
                          [
                            17.357,
                            22.572
                          ],
                          [
                            -5.619,
                            31.147
                          ],
                          [
                            -23.876,
                            23.92
                          ],
                          [
                            -27.462,
                            0.405
                          ],
                          [
                            -14.76,
                            -23.004
                          ],
                          [
                            7.056,
                            -31.147
                          ],
                          [
                            19.702,
                            -28.397
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        822.648,
                        135.001
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 2",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.485,
                            -0.593
                          ],
                          [
                            -3.128,
                            0
                          ],
                          [
                            -0.521,
                            0.018
                          ],
                          [
                            -0.539,
                            0.036
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.085,
                            2.77
                          ],
                          [
                            -0.755,
                            3.667
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.503,
                            2.41
                          ],
                          [
                            0.485,
                            0.593
                          ],
                          [
                            0.467,
                            0
                          ],
                          [
                            0.521,
                            -0.018
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -7.3,
                            0.252
                          ],
                          [
                            -1.331,
                            -1.761
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -17.501,
                            -10.508
                          ],
                          [
                            -15.182,
                            -21.456
                          ],
                          [
                            -6.983,
                            -21.456
                          ],
                          [
                            -3.479,
                            -37.853
                          ],
                          [
                            11.731,
                            -37.853
                          ],
                          [
                            8.226,
                            -21.456
                          ],
                          [
                            17.771,
                            -21.456
                          ],
                          [
                            15.453,
                            -10.508
                          ],
                          [
                            5.906,
                            -10.508
                          ],
                          [
                            -0.729,
                            20.558
                          ],
                          [
                            -0.755,
                            25.062
                          ],
                          [
                            4.666,
                            25.952
                          ],
                          [
                            6.149,
                            25.925
                          ],
                          [
                            7.74,
                            25.845
                          ],
                          [
                            5.26,
                            37.332
                          ],
                          [
                            -2.075,
                            37.601
                          ],
                          [
                            -16.152,
                            33.826
                          ],
                          [
                            -17.016,
                            25.682
                          ],
                          [
                            -9.303,
                            -10.508
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        778.439,
                        127.413
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.545,
                            -7.371
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.504,
                            1.654
                          ],
                          [
                            4.242,
                            0
                          ],
                          [
                            2.877,
                            -4.422
                          ],
                          [
                            0.755,
                            -3.632
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.05,
                            1.33
                          ],
                          [
                            -4.853,
                            0
                          ],
                          [
                            -3.183,
                            -3.182
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.682,
                            -3.092
                          ],
                          [
                            -0.862,
                            -3.021
                          ],
                          [
                            -5.214,
                            0
                          ],
                          [
                            -1.509,
                            2.338
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.625,
                            -3.02
                          ],
                          [
                            3.668,
                            -2.374
                          ],
                          [
                            6.076,
                            0
                          ],
                          [
                            3.182,
                            3.183
                          ]
                        ],
                        "v": [
                          [
                            30.025,
                            -9.492
                          ],
                          [
                            21.611,
                            30.096
                          ],
                          [
                            5.862,
                            30.096
                          ],
                          [
                            13.413,
                            -5.663
                          ],
                          [
                            13.682,
                            -12.782
                          ],
                          [
                            6.023,
                            -17.312
                          ],
                          [
                            -6.112,
                            -10.679
                          ],
                          [
                            -9.51,
                            -1.725
                          ],
                          [
                            -16.251,
                            30.096
                          ],
                          [
                            -31.57,
                            30.096
                          ],
                          [
                            -19.11,
                            -28.585
                          ],
                          [
                            -4.279,
                            -28.585
                          ],
                          [
                            -6.112,
                            -20.01
                          ],
                          [
                            0.9,
                            -26.535
                          ],
                          [
                            13.682,
                            -30.096
                          ],
                          [
                            27.57,
                            -25.322
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        721.152,
                        134.11
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 4",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.294,
                            -3.811
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.78,
                            2.104
                          ],
                          [
                            3.271,
                            0
                          ],
                          [
                            2.427,
                            -2.229
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.611,
                            -4.062
                          ],
                          [
                            -1.78,
                            -2.104
                          ],
                          [
                            -3.561,
                            0
                          ],
                          [
                            -2.427,
                            2.23
                          ]
                        ],
                        "v": [
                          [
                            -10.202,
                            -6.068
                          ],
                          [
                            13.691,
                            -6.068
                          ],
                          [
                            11.938,
                            -15.318
                          ],
                          [
                            4.361,
                            -18.472
                          ],
                          [
                            -4.62,
                            -15.129
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.691,
                            -3.955
                          ],
                          [
                            0.323,
                            -4.602
                          ],
                          [
                            1.151,
                            -5.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.984,
                            -2.373
                          ],
                          [
                            -2.985,
                            0
                          ],
                          [
                            -2.374,
                            1.797
                          ],
                          [
                            -1.223,
                            1.725
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.991,
                            -3.596
                          ],
                          [
                            9.062,
                            0
                          ],
                          [
                            4.692,
                            4.819
                          ],
                          [
                            -2.302,
                            10.859
                          ],
                          [
                            -6.31,
                            5.43
                          ],
                          [
                            -8.234,
                            0
                          ],
                          [
                            -3.542,
                            -1.833
                          ]
                        ],
                        "o": [
                          [
                            1.582,
                            3.489
                          ],
                          [
                            -0.144,
                            2.697
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.043,
                            5.897
                          ],
                          [
                            1.798,
                            1.475
                          ],
                          [
                            3.163,
                            0
                          ],
                          [
                            1.258,
                            -0.971
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.151,
                            3.487
                          ],
                          [
                            -6.257,
                            5.716
                          ],
                          [
                            -7.479,
                            0
                          ],
                          [
                            -4.693,
                            -4.818
                          ],
                          [
                            2.157,
                            -10.176
                          ],
                          [
                            6.311,
                            -5.428
                          ],
                          [
                            4.889,
                            0
                          ],
                          [
                            3.541,
                            1.834
                          ]
                        ],
                        "v": [
                          [
                            27.552,
                            -19.714
                          ],
                          [
                            29.44,
                            -7.578
                          ],
                          [
                            27.498,
                            4.072
                          ],
                          [
                            -12.737,
                            4.072
                          ],
                          [
                            -9.825,
                            16.477
                          ],
                          [
                            -2.651,
                            18.688
                          ],
                          [
                            5.655,
                            15.992
                          ],
                          [
                            9.376,
                            11.947
                          ],
                          [
                            25.071,
                            11.947
                          ],
                          [
                            17.359,
                            22.572
                          ],
                          [
                            -5.618,
                            31.147
                          ],
                          [
                            -23.874,
                            23.92
                          ],
                          [
                            -27.461,
                            0.405
                          ],
                          [
                            -14.76,
                            -23.004
                          ],
                          [
                            7.057,
                            -31.147
                          ],
                          [
                            19.705,
                            -28.397
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        656.96,
                        135.001
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 5",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.079,
                            5.143
                          ],
                          [
                            2.948,
                            3.093
                          ],
                          [
                            2.948,
                            0
                          ],
                          [
                            2.823,
                            -3.398
                          ],
                          [
                            1.078,
                            -5.035
                          ],
                          [
                            -1.439,
                            -3.254
                          ],
                          [
                            -4.352,
                            0
                          ],
                          [
                            -2.966,
                            3.237
                          ]
                        ],
                        "o": [
                          [
                            1.51,
                            -7.191
                          ],
                          [
                            -1.834,
                            -1.869
                          ],
                          [
                            -4.495,
                            0
                          ],
                          [
                            -2.822,
                            3.398
                          ],
                          [
                            -1.152,
                            5.429
                          ],
                          [
                            1.438,
                            3.254
                          ],
                          [
                            4.35,
                            0
                          ],
                          [
                            2.967,
                            -3.236
                          ]
                        ],
                        "v": [
                          [
                            9.089,
                            10.247
                          ],
                          [
                            6.931,
                            -5.179
                          ],
                          [
                            -0.243,
                            -7.982
                          ],
                          [
                            -11.219,
                            -2.886
                          ],
                          [
                            -17.07,
                            9.762
                          ],
                          [
                            -16.639,
                            22.787
                          ],
                          [
                            -7.955,
                            27.669
                          ],
                          [
                            3.02,
                            22.813
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.152,
                            -2.769
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.146,
                            -1.582
                          ],
                          [
                            4.171,
                            0
                          ],
                          [
                            3.506,
                            5.555
                          ],
                          [
                            -1.834,
                            8.702
                          ],
                          [
                            -5.844,
                            5.753
                          ],
                          [
                            -7.731,
                            0
                          ],
                          [
                            -2.427,
                            -1.565
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.949,
                            3.488
                          ],
                          [
                            -3.147,
                            1.581
                          ],
                          [
                            -6.868,
                            0
                          ],
                          [
                            -3.506,
                            -5.555
                          ],
                          [
                            2.158,
                            -10.032
                          ],
                          [
                            5.842,
                            -5.752
                          ],
                          [
                            3.56,
                            0
                          ],
                          [
                            2.427,
                            1.563
                          ]
                        ],
                        "v": [
                          [
                            13.511,
                            -12.567
                          ],
                          [
                            19.443,
                            -40.613
                          ],
                          [
                            35.03,
                            -40.613
                          ],
                          [
                            18.203,
                            38.778
                          ],
                          [
                            3.263,
                            38.778
                          ],
                          [
                            4.989,
                            30.635
                          ],
                          [
                            -4.153,
                            38.239
                          ],
                          [
                            -15.129,
                            40.613
                          ],
                          [
                            -30.689,
                            32.279
                          ],
                          [
                            -33.197,
                            10.894
                          ],
                          [
                            -21.196,
                            -12.783
                          ],
                          [
                            -0.836,
                            -21.412
                          ],
                          [
                            8.144,
                            -19.066
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        595.871,
                        125.427
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 6",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.545,
                            -7.371
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.503,
                            1.654
                          ],
                          [
                            4.242,
                            0
                          ],
                          [
                            2.876,
                            -4.422
                          ],
                          [
                            0.755,
                            -3.632
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.049,
                            1.33
                          ],
                          [
                            -4.854,
                            0
                          ],
                          [
                            -3.182,
                            -3.182
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.683,
                            -3.092
                          ],
                          [
                            -0.863,
                            -3.021
                          ],
                          [
                            -5.214,
                            0
                          ],
                          [
                            -1.51,
                            2.338
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.624,
                            -3.02
                          ],
                          [
                            3.668,
                            -2.374
                          ],
                          [
                            6.076,
                            0
                          ],
                          [
                            3.182,
                            3.183
                          ]
                        ],
                        "v": [
                          [
                            30.024,
                            -9.492
                          ],
                          [
                            21.61,
                            30.096
                          ],
                          [
                            5.861,
                            30.096
                          ],
                          [
                            13.412,
                            -5.663
                          ],
                          [
                            13.682,
                            -12.782
                          ],
                          [
                            6.023,
                            -17.312
                          ],
                          [
                            -6.112,
                            -10.679
                          ],
                          [
                            -9.51,
                            -1.725
                          ],
                          [
                            -16.252,
                            30.096
                          ],
                          [
                            -31.569,
                            30.096
                          ],
                          [
                            -19.11,
                            -28.585
                          ],
                          [
                            -4.278,
                            -28.585
                          ],
                          [
                            -6.112,
                            -20.01
                          ],
                          [
                            0.899,
                            -26.535
                          ],
                          [
                            13.682,
                            -30.096
                          ],
                          [
                            27.57,
                            -25.322
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        524.776,
                        134.11
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 7",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 7,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.294,
                            -3.811
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.78,
                            2.104
                          ],
                          [
                            3.271,
                            0
                          ],
                          [
                            2.427,
                            -2.229
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.611,
                            -4.062
                          ],
                          [
                            -1.78,
                            -2.104
                          ],
                          [
                            -3.561,
                            0
                          ],
                          [
                            -2.427,
                            2.23
                          ]
                        ],
                        "v": [
                          [
                            -10.202,
                            -6.068
                          ],
                          [
                            13.691,
                            -6.068
                          ],
                          [
                            11.938,
                            -15.318
                          ],
                          [
                            4.361,
                            -18.472
                          ],
                          [
                            -4.62,
                            -15.129
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.691,
                            -3.955
                          ],
                          [
                            0.323,
                            -4.602
                          ],
                          [
                            1.151,
                            -5.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.984,
                            -2.373
                          ],
                          [
                            -2.985,
                            0
                          ],
                          [
                            -2.374,
                            1.797
                          ],
                          [
                            -1.223,
                            1.725
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.991,
                            -3.596
                          ],
                          [
                            9.062,
                            0
                          ],
                          [
                            4.692,
                            4.819
                          ],
                          [
                            -2.302,
                            10.859
                          ],
                          [
                            -6.31,
                            5.43
                          ],
                          [
                            -8.234,
                            0
                          ],
                          [
                            -3.542,
                            -1.833
                          ]
                        ],
                        "o": [
                          [
                            1.582,
                            3.489
                          ],
                          [
                            -0.144,
                            2.697
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.043,
                            5.897
                          ],
                          [
                            1.798,
                            1.475
                          ],
                          [
                            3.163,
                            0
                          ],
                          [
                            1.258,
                            -0.971
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.151,
                            3.487
                          ],
                          [
                            -6.257,
                            5.716
                          ],
                          [
                            -7.479,
                            0
                          ],
                          [
                            -4.693,
                            -4.818
                          ],
                          [
                            2.157,
                            -10.176
                          ],
                          [
                            6.311,
                            -5.428
                          ],
                          [
                            4.889,
                            0
                          ],
                          [
                            3.541,
                            1.834
                          ]
                        ],
                        "v": [
                          [
                            27.552,
                            -19.714
                          ],
                          [
                            29.44,
                            -7.578
                          ],
                          [
                            27.498,
                            4.072
                          ],
                          [
                            -12.737,
                            4.072
                          ],
                          [
                            -9.825,
                            16.477
                          ],
                          [
                            -2.651,
                            18.688
                          ],
                          [
                            5.655,
                            15.992
                          ],
                          [
                            9.376,
                            11.947
                          ],
                          [
                            25.071,
                            11.947
                          ],
                          [
                            17.359,
                            22.572
                          ],
                          [
                            -5.618,
                            31.147
                          ],
                          [
                            -23.874,
                            23.92
                          ],
                          [
                            -27.461,
                            0.405
                          ],
                          [
                            -14.76,
                            -23.004
                          ],
                          [
                            7.057,
                            -31.147
                          ],
                          [
                            19.705,
                            -28.397
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        460.584,
                        135.001
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 8",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 8,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.486,
                            -0.593
                          ],
                          [
                            -3.128,
                            0
                          ],
                          [
                            -0.522,
                            0.018
                          ],
                          [
                            -0.539,
                            0.036
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.085,
                            2.77
                          ],
                          [
                            -0.755,
                            3.667
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.503,
                            2.41
                          ],
                          [
                            0.485,
                            0.593
                          ],
                          [
                            0.467,
                            0
                          ],
                          [
                            0.521,
                            -0.018
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -7.3,
                            0.252
                          ],
                          [
                            -1.33,
                            -1.761
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -17.501,
                            -10.508
                          ],
                          [
                            -15.182,
                            -21.456
                          ],
                          [
                            -6.984,
                            -21.456
                          ],
                          [
                            -3.479,
                            -37.853
                          ],
                          [
                            11.731,
                            -37.853
                          ],
                          [
                            8.226,
                            -21.456
                          ],
                          [
                            17.771,
                            -21.456
                          ],
                          [
                            15.453,
                            -10.508
                          ],
                          [
                            5.906,
                            -10.508
                          ],
                          [
                            -0.729,
                            20.558
                          ],
                          [
                            -0.755,
                            25.062
                          ],
                          [
                            4.666,
                            25.952
                          ],
                          [
                            6.148,
                            25.925
                          ],
                          [
                            7.74,
                            25.845
                          ],
                          [
                            5.258,
                            37.332
                          ],
                          [
                            -2.076,
                            37.601
                          ],
                          [
                            -16.154,
                            33.826
                          ],
                          [
                            -17.016,
                            25.682
                          ],
                          [
                            -9.303,
                            -10.508
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        416.377,
                        127.413
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 9",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 9,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -3.937,
                            9.708
                          ],
                          [
                            16.234,
                            9.708
                          ],
                          [
                            12.945,
                            -21.573
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            7.605,
                            -39.75
                          ],
                          [
                            26.375,
                            -39.75
                          ],
                          [
                            37.646,
                            39.75
                          ],
                          [
                            19.632,
                            39.75
                          ],
                          [
                            17.96,
                            23.408
                          ],
                          [
                            -11.326,
                            23.408
                          ],
                          [
                            -20.279,
                            39.75
                          ],
                          [
                            -37.646,
                            39.75
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        348.392,
                        124.456
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 10",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 10,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            69.836,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -69.836
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -69.836,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            69.836
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -69.836,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            69.836
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            69.836,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -69.836
                          ]
                        ],
                        "v": [
                          [
                            374.081,
                            -126.45
                          ],
                          [
                            -374.08,
                            -126.45
                          ],
                          [
                            -500.53,
                            -0.001
                          ],
                          [
                            -500.53,
                            0.001
                          ],
                          [
                            -374.08,
                            126.45
                          ],
                          [
                            374.081,
                            126.45
                          ],
                          [
                            500.53,
                            0.001
                          ],
                          [
                            500.53,
                            -0.001
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.086000001197,
                        0.791999966491,
                        0.709999952129,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        500.78,
                        126.7
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 11",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 11,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": 545,
            "op": 637,
            "st": 55,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 14,
            "ty": 4,
            "nm": "Talk 04/conversas_whatsapp contornos",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 887,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 900,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11,
                "x": "var $bm_rt;\n$bm_rt = transform.opacity;"
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 638,
                    "s": [
                      682.5,
                      600,
                      0
                    ],
                    "to": [
                      -26.833,
                      -10.833,
                      0
                    ],
                    "ti": [
                      26.833,
                      10.833,
                      0
                    ]
                  },
                  {
                    "t": 650,
                    "s": [
                      521.5,
                      535,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  130.5,
                  48,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 531,
                    "s": [
                      0,
                      0,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 537,
                    "s": [
                      180,
                      180,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 542,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 638,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "t": 650,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.254,
                            0.203
                          ],
                          [
                            1.434,
                            -1.784
                          ],
                          [
                            0.202,
                            0.19
                          ],
                          [
                            0.174,
                            -0.219
                          ],
                          [
                            -0.434,
                            -0.434
                          ],
                          [
                            -1.665,
                            2.072
                          ]
                        ],
                        "o": [
                          [
                            -1.447,
                            1.799
                          ],
                          [
                            -0.214,
                            -0.2
                          ],
                          [
                            -0.211,
                            0.265
                          ],
                          [
                            0.428,
                            0.43
                          ],
                          [
                            1.651,
                            -2.055
                          ],
                          [
                            -0.264,
                            -0.211
                          ]
                        ],
                        "v": [
                          [
                            2.363,
                            -3.392
                          ],
                          [
                            -1.941,
                            1.96
                          ],
                          [
                            -2.546,
                            1.394
                          ],
                          [
                            -3.12,
                            2.113
                          ],
                          [
                            -1.845,
                            3.392
                          ],
                          [
                            3.12,
                            -2.786
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 652,
                          "s": [
                            0.207843139768,
                            0.564705908298,
                            0.517647087574,
                            1
                          ]
                        },
                        {
                          "t": 656,
                          "s": [
                            0,
                            0.642999985639,
                            0.933000033509,
                            1
                          ]
                        }
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        227.225,
                        67.285
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.261,
                            0.209
                          ],
                          [
                            1.462,
                            -1.818
                          ],
                          [
                            0.612,
                            0.618
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.884,
                            -0.883
                          ],
                          [
                            -1.663,
                            2.071
                          ]
                        ],
                        "o": [
                          [
                            -1.442,
                            1.795
                          ],
                          [
                            -0.645,
                            -0.652
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.878,
                            0.878
                          ],
                          [
                            1.64,
                            -2.042
                          ],
                          [
                            -0.262,
                            -0.209
                          ]
                        ],
                        "v": [
                          [
                            3.038,
                            -3.388
                          ],
                          [
                            -1.294,
                            1.999
                          ],
                          [
                            -3.156,
                            0.117
                          ],
                          [
                            -3.794,
                            0.756
                          ],
                          [
                            -1.163,
                            3.388
                          ],
                          [
                            3.794,
                            -2.783
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 652,
                          "s": [
                            0.207843139768,
                            0.564705908298,
                            0.517647087574,
                            1
                          ]
                        },
                        {
                          "t": 656,
                          "s": [
                            0,
                            0.642999985639,
                            0.933000033509,
                            1
                          ]
                        }
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        223.396,
                        67.281
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 2",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.206,
                            0.205
                          ],
                          [
                            0,
                            0.284
                          ],
                          [
                            0.196,
                            0.207
                          ],
                          [
                            0.403,
                            0
                          ],
                          [
                            0.178,
                            -0.207
                          ],
                          [
                            0,
                            -0.278
                          ],
                          [
                            -0.23,
                            -0.176
                          ],
                          [
                            -0.314,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.206,
                            -0.205
                          ],
                          [
                            0,
                            -0.246
                          ],
                          [
                            -0.197,
                            -0.207
                          ],
                          [
                            -0.399,
                            0
                          ],
                          [
                            -0.179,
                            0.207
                          ],
                          [
                            0,
                            0.311
                          ],
                          [
                            0.231,
                            0.176
                          ],
                          [
                            0.366,
                            0
                          ]
                        ],
                        "v": [
                          [
                            0.85,
                            -0.929
                          ],
                          [
                            1.159,
                            -1.663
                          ],
                          [
                            0.864,
                            -2.343
                          ],
                          [
                            -0.035,
                            -2.654
                          ],
                          [
                            -0.901,
                            -2.343
                          ],
                          [
                            -1.169,
                            -1.616
                          ],
                          [
                            -0.823,
                            -0.885
                          ],
                          [
                            -0.007,
                            -0.621
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.254,
                            0.208
                          ],
                          [
                            0,
                            0.413
                          ],
                          [
                            0.261,
                            0.222
                          ],
                          [
                            0.409,
                            0
                          ],
                          [
                            0.251,
                            -0.226
                          ],
                          [
                            0,
                            -0.401
                          ],
                          [
                            -0.23,
                            -0.251
                          ],
                          [
                            -0.48,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.254,
                            -0.208
                          ],
                          [
                            0,
                            -0.428
                          ],
                          [
                            -0.262,
                            -0.221
                          ],
                          [
                            -0.397,
                            0
                          ],
                          [
                            -0.251,
                            0.226
                          ],
                          [
                            0,
                            0.344
                          ],
                          [
                            0.229,
                            0.251
                          ],
                          [
                            0.385,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.004,
                            2.341
                          ],
                          [
                            1.385,
                            1.41
                          ],
                          [
                            0.993,
                            0.436
                          ],
                          [
                            -0.014,
                            0.103
                          ],
                          [
                            -0.986,
                            0.443
                          ],
                          [
                            -1.362,
                            1.383
                          ],
                          [
                            -1.018,
                            2.276
                          ],
                          [
                            0.046,
                            2.652
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.129,
                            0.133
                          ],
                          [
                            0,
                            0.394
                          ],
                          [
                            -0.357,
                            0.353
                          ],
                          [
                            -0.654,
                            0
                          ],
                          [
                            -0.36,
                            -0.334
                          ],
                          [
                            0,
                            -0.446
                          ],
                          [
                            0.209,
                            -0.255
                          ],
                          [
                            0.246,
                            -0.138
                          ],
                          [
                            -0.158,
                            -0.163
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.392,
                            -0.405
                          ],
                          [
                            0.714,
                            0
                          ],
                          [
                            0.445,
                            0.35
                          ],
                          [
                            0,
                            0.665
                          ],
                          [
                            -0.19,
                            0.285
                          ],
                          [
                            -0.375,
                            0.151
                          ]
                        ],
                        "o": [
                          [
                            -0.244,
                            -0.246
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.357,
                            -0.355
                          ],
                          [
                            0.634,
                            0
                          ],
                          [
                            0.36,
                            0.334
                          ],
                          [
                            0,
                            0.413
                          ],
                          [
                            -0.117,
                            0.145
                          ],
                          [
                            0.275,
                            0.126
                          ],
                          [
                            0.293,
                            0.307
                          ],
                          [
                            0,
                            0.582
                          ],
                          [
                            -0.391,
                            0.405
                          ],
                          [
                            -0.644,
                            0
                          ],
                          [
                            -0.444,
                            -0.349
                          ],
                          [
                            0,
                            -0.391
                          ],
                          [
                            0.191,
                            -0.284
                          ],
                          [
                            -0.231,
                            -0.099
                          ]
                        ],
                        "v": [
                          [
                            -1.676,
                            -0.65
                          ],
                          [
                            -2.042,
                            -1.61
                          ],
                          [
                            -1.506,
                            -2.879
                          ],
                          [
                            0.011,
                            -3.41
                          ],
                          [
                            1.501,
                            -2.909
                          ],
                          [
                            2.04,
                            -1.739
                          ],
                          [
                            1.727,
                            -0.737
                          ],
                          [
                            1.182,
                            -0.312
                          ],
                          [
                            1.831,
                            0.122
                          ],
                          [
                            2.272,
                            1.322
                          ],
                          [
                            1.685,
                            2.802
                          ],
                          [
                            0.028,
                            3.41
                          ],
                          [
                            -1.605,
                            2.885
                          ],
                          [
                            -2.272,
                            1.364
                          ],
                          [
                            -1.986,
                            0.35
                          ],
                          [
                            -1.136,
                            -0.303
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        212.733,
                        66.881
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 3",
                "np": 7,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.256,
                            0.382
                          ],
                          [
                            0,
                            1.04
                          ],
                          [
                            0.185,
                            0.484
                          ],
                          [
                            0.534,
                            0
                          ],
                          [
                            0.227,
                            -0.461
                          ],
                          [
                            0,
                            -0.897
                          ],
                          [
                            -0.145,
                            -0.409
                          ],
                          [
                            -0.537,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.256,
                            -0.381
                          ],
                          [
                            0,
                            -0.751
                          ],
                          [
                            -0.185,
                            -0.486
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.226,
                            0.46
                          ],
                          [
                            0,
                            0.674
                          ],
                          [
                            0.222,
                            0.625
                          ],
                          [
                            0.431,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.002,
                            2.066
                          ],
                          [
                            1.385,
                            -0.067
                          ],
                          [
                            1.107,
                            -1.92
                          ],
                          [
                            0.029,
                            -2.648
                          ],
                          [
                            -1.046,
                            -1.957
                          ],
                          [
                            -1.386,
                            0.077
                          ],
                          [
                            -1.167,
                            1.702
                          ],
                          [
                            -0.029,
                            2.639
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.382,
                            -0.705
                          ],
                          [
                            0,
                            -0.948
                          ],
                          [
                            0.268,
                            -0.587
                          ],
                          [
                            0.879,
                            0
                          ],
                          [
                            0.388,
                            0.689
                          ],
                          [
                            0,
                            0.969
                          ],
                          [
                            -0.194,
                            0.539
                          ],
                          [
                            -0.951,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.296,
                            0.545
                          ],
                          [
                            0,
                            0.898
                          ],
                          [
                            -0.388,
                            0.843
                          ],
                          [
                            -0.795,
                            0
                          ],
                          [
                            -0.323,
                            -0.575
                          ],
                          [
                            0,
                            -0.751
                          ],
                          [
                            0.363,
                            -1.003
                          ],
                          [
                            0.857,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.838,
                            -2.338
                          ],
                          [
                            2.281,
                            -0.099
                          ],
                          [
                            1.88,
                            2.131
                          ],
                          [
                            -0.023,
                            3.396
                          ],
                          [
                            -1.796,
                            2.362
                          ],
                          [
                            -2.281,
                            0.044
                          ],
                          [
                            -1.99,
                            -1.891
                          ],
                          [
                            -0.02,
                            -3.396
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        207.473,
                        66.885
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 4",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            1.434
                          ],
                          [
                            0.483,
                            1.434
                          ],
                          [
                            0.483,
                            2.441
                          ],
                          [
                            -0.483,
                            2.441
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            -2.441
                          ],
                          [
                            0.483,
                            -2.441
                          ],
                          [
                            0.483,
                            -1.434
                          ],
                          [
                            -0.483,
                            -1.434
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        203.801,
                        67.661
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 5",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.204,
                            0.422
                          ],
                          [
                            -0.594,
                            0.344
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.164
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.231,
                            0.227
                          ],
                          [
                            0.385,
                            0
                          ],
                          [
                            0.218,
                            -0.433
                          ],
                          [
                            0.013,
                            -0.411
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.203,
                            0.363
                          ],
                          [
                            -0.911,
                            0
                          ],
                          [
                            -0.349,
                            -0.409
                          ],
                          [
                            0,
                            -0.502
                          ],
                          [
                            0.372,
                            -0.376
                          ],
                          [
                            0.557,
                            -0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.172,
                            -0.151
                          ],
                          [
                            0.08,
                            -0.326
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.205,
                            -0.422
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.397,
                            -0.231
                          ],
                          [
                            0.252,
                            -0.256
                          ],
                          [
                            0,
                            -0.386
                          ],
                          [
                            -0.23,
                            -0.226
                          ],
                          [
                            -0.569,
                            0
                          ],
                          [
                            -0.118,
                            0.231
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.009,
                            -0.576
                          ],
                          [
                            0.36,
                            -0.641
                          ],
                          [
                            0.758,
                            0
                          ],
                          [
                            0.35,
                            0.409
                          ],
                          [
                            0,
                            0.529
                          ],
                          [
                            -0.216,
                            0.219
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.302,
                            0.167
                          ],
                          [
                            -0.307,
                            0.268
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.031,
                            -0.569
                          ]
                        ],
                        "v": [
                          [
                            -1.933,
                            1.83
                          ],
                          [
                            -0.735,
                            0.682
                          ],
                          [
                            0.152,
                            0.169
                          ],
                          [
                            0.988,
                            -0.424
                          ],
                          [
                            1.367,
                            -1.303
                          ],
                          [
                            1.02,
                            -2.221
                          ],
                          [
                            0.096,
                            -2.561
                          ],
                          [
                            -1.085,
                            -1.911
                          ],
                          [
                            -1.28,
                            -0.949
                          ],
                          [
                            -2.124,
                            -0.949
                          ],
                          [
                            -1.806,
                            -2.357
                          ],
                          [
                            0.101,
                            -3.318
                          ],
                          [
                            1.761,
                            -2.704
                          ],
                          [
                            2.286,
                            -1.337
                          ],
                          [
                            1.727,
                            0.02
                          ],
                          [
                            0.568,
                            0.814
                          ],
                          [
                            -0.065,
                            1.165
                          ],
                          [
                            -0.776,
                            1.641
                          ],
                          [
                            -1.358,
                            2.533
                          ],
                          [
                            2.254,
                            2.533
                          ],
                          [
                            2.254,
                            3.318
                          ],
                          [
                            -2.286,
                            3.318
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        199.592,
                        66.784
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 6",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.237,
                            0.138
                          ],
                          [
                            -0.117,
                            0.51
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.6,
                            -0.058
                          ],
                          [
                            0.237,
                            -0.136
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.221,
                            -1.391
                          ],
                          [
                            -1.221,
                            -2.028
                          ],
                          [
                            0.035,
                            -2.322
                          ],
                          [
                            0.566,
                            -3.293
                          ],
                          [
                            1.221,
                            -3.293
                          ],
                          [
                            1.221,
                            3.293
                          ],
                          [
                            0.335,
                            3.293
                          ],
                          [
                            0.335,
                            -1.391
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        193.877,
                        66.809
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 7",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 7,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            9.15,
                            2.815
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.315,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.314
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.315
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -9.15,
                            -2.815
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.314
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.315
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.315,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            121.092,
                            25.588
                          ],
                          [
                            111.658,
                            12.636
                          ],
                          [
                            111.658,
                            -34.489
                          ],
                          [
                            105.658,
                            -40.489
                          ],
                          [
                            -124.241,
                            -40.489
                          ],
                          [
                            -130.241,
                            -34.489
                          ],
                          [
                            -130.241,
                            34.489
                          ],
                          [
                            -124.241,
                            40.489
                          ],
                          [
                            105.658,
                            40.489
                          ],
                          [
                            111.658,
                            34.489
                          ],
                          [
                            111.658,
                            30.515
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.33300000359,
                        0.282000014361,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        130.491,
                        40.739
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 8",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 8,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": 531,
            "op": 1164,
            "st": 444,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 15,
            "ty": 5,
            "nm": "Ciro",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 887,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 900,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 518,
                    "s": [
                      211.5,
                      510.5,
                      0
                    ],
                    "to": [
                      27.833,
                      -7.917,
                      0
                    ],
                    "ti": [
                      -27.833,
                      7.917,
                      0
                    ]
                  },
                  {
                    "t": 530,
                    "s": [
                      378.5,
                      463,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  -165.445,
                  -8.377,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 518,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  },
                  {
                    "t": 530,
                    "s": [
                      71,
                      71,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "t": {
              "d": {
                "k": [
                  {
                    "s": {
                      "sz": [
                        89.7042236328125,
                        35
                      ],
                      "ps": [
                        -169.5,
                        -14.5
                      ],
                      "s": 16,
                      "f": "Helvetica",
                      "t": "Ciro",
                      "ca": 0,
                      "j": 0,
                      "tr": 0,
                      "lh": 19.2,
                      "ls": 0,
                      "fc": [
                        1,
                        1,
                        1
                      ]
                    },
                    "t": 0
                  }
                ]
              },
              "p": {
                
              },
              "m": {
                "g": 1,
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 2
                }
              },
              "a": [
                {
                  "nm": "Animador 1",
                  "s": {
                    "t": 0,
                    "xe": {
                      "a": 0,
                      "k": 0,
                      "ix": 7
                    },
                    "ne": {
                      "a": 0,
                      "k": 0,
                      "ix": 8
                    },
                    "a": {
                      "a": 0,
                      "k": 100,
                      "ix": 4
                    },
                    "b": 1,
                    "rn": 0,
                    "sh": 1,
                    "s": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 419,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 468,
                          "s": [
                            100
                          ]
                        }
                      ],
                      "ix": 1
                    },
                    "r": 1
                  },
                  "a": {
                    "o": {
                      "a": 0,
                      "k": 0,
                      "ix": 9
                    }
                  }
                }
              ]
            },
            "ip": 410,
            "op": 901,
            "st": 110,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 16,
            "ty": 4,
            "nm": "Talk 03/conversas_whatsapp contornos",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 887,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 900,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 518,
                    "s": [
                      246.5,
                      515,
                      0
                    ],
                    "to": [
                      26,
                      -8.667,
                      0
                    ],
                    "ti": [
                      -26,
                      8.667,
                      0
                    ]
                  },
                  {
                    "t": 530,
                    "s": [
                      402.5,
                      463,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  52,
                  16,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 409,
                    "s": [
                      0,
                      0,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 415,
                    "s": [
                      180,
                      180,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 420,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 518,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "t": 530,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.206,
                            0.205
                          ],
                          [
                            0,
                            0.284
                          ],
                          [
                            0.196,
                            0.207
                          ],
                          [
                            0.403,
                            0
                          ],
                          [
                            0.178,
                            -0.206
                          ],
                          [
                            0,
                            -0.278
                          ],
                          [
                            -0.23,
                            -0.176
                          ],
                          [
                            -0.314,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.206,
                            -0.205
                          ],
                          [
                            0,
                            -0.247
                          ],
                          [
                            -0.197,
                            -0.206
                          ],
                          [
                            -0.399,
                            0
                          ],
                          [
                            -0.179,
                            0.207
                          ],
                          [
                            0,
                            0.312
                          ],
                          [
                            0.231,
                            0.176
                          ],
                          [
                            0.366,
                            0
                          ]
                        ],
                        "v": [
                          [
                            0.85,
                            -0.93
                          ],
                          [
                            1.159,
                            -1.663
                          ],
                          [
                            0.864,
                            -2.344
                          ],
                          [
                            -0.035,
                            -2.654
                          ],
                          [
                            -0.901,
                            -2.344
                          ],
                          [
                            -1.169,
                            -1.617
                          ],
                          [
                            -0.823,
                            -0.885
                          ],
                          [
                            -0.007,
                            -0.621
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.254,
                            0.208
                          ],
                          [
                            0,
                            0.412
                          ],
                          [
                            0.261,
                            0.223
                          ],
                          [
                            0.409,
                            0
                          ],
                          [
                            0.251,
                            -0.227
                          ],
                          [
                            0,
                            -0.401
                          ],
                          [
                            -0.23,
                            -0.25
                          ],
                          [
                            -0.48,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.254,
                            -0.208
                          ],
                          [
                            0,
                            -0.428
                          ],
                          [
                            -0.262,
                            -0.22
                          ],
                          [
                            -0.397,
                            0
                          ],
                          [
                            -0.251,
                            0.226
                          ],
                          [
                            0,
                            0.343
                          ],
                          [
                            0.229,
                            0.252
                          ],
                          [
                            0.385,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.004,
                            2.341
                          ],
                          [
                            1.385,
                            1.41
                          ],
                          [
                            0.993,
                            0.435
                          ],
                          [
                            -0.014,
                            0.103
                          ],
                          [
                            -0.986,
                            0.443
                          ],
                          [
                            -1.362,
                            1.383
                          ],
                          [
                            -1.018,
                            2.275
                          ],
                          [
                            0.046,
                            2.652
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.129,
                            0.133
                          ],
                          [
                            0,
                            0.394
                          ],
                          [
                            -0.357,
                            0.353
                          ],
                          [
                            -0.654,
                            0
                          ],
                          [
                            -0.36,
                            -0.334
                          ],
                          [
                            0,
                            -0.447
                          ],
                          [
                            0.209,
                            -0.255
                          ],
                          [
                            0.246,
                            -0.138
                          ],
                          [
                            -0.158,
                            -0.163
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.392,
                            -0.405
                          ],
                          [
                            0.714,
                            0
                          ],
                          [
                            0.445,
                            0.35
                          ],
                          [
                            0,
                            0.666
                          ],
                          [
                            -0.19,
                            0.284
                          ],
                          [
                            -0.375,
                            0.15
                          ]
                        ],
                        "o": [
                          [
                            -0.244,
                            -0.246
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.357,
                            -0.355
                          ],
                          [
                            0.634,
                            0
                          ],
                          [
                            0.36,
                            0.334
                          ],
                          [
                            0,
                            0.413
                          ],
                          [
                            -0.117,
                            0.145
                          ],
                          [
                            0.275,
                            0.127
                          ],
                          [
                            0.293,
                            0.307
                          ],
                          [
                            0,
                            0.582
                          ],
                          [
                            -0.391,
                            0.405
                          ],
                          [
                            -0.644,
                            0
                          ],
                          [
                            -0.444,
                            -0.348
                          ],
                          [
                            0,
                            -0.391
                          ],
                          [
                            0.191,
                            -0.284
                          ],
                          [
                            -0.231,
                            -0.099
                          ]
                        ],
                        "v": [
                          [
                            -1.676,
                            -0.65
                          ],
                          [
                            -2.042,
                            -1.61
                          ],
                          [
                            -1.506,
                            -2.879
                          ],
                          [
                            0.011,
                            -3.41
                          ],
                          [
                            1.501,
                            -2.91
                          ],
                          [
                            2.04,
                            -1.739
                          ],
                          [
                            1.727,
                            -0.737
                          ],
                          [
                            1.182,
                            -0.313
                          ],
                          [
                            1.831,
                            0.122
                          ],
                          [
                            2.272,
                            1.322
                          ],
                          [
                            1.685,
                            2.802
                          ],
                          [
                            0.028,
                            3.41
                          ],
                          [
                            -1.605,
                            2.884
                          ],
                          [
                            -2.272,
                            1.363
                          ],
                          [
                            -1.986,
                            0.35
                          ],
                          [
                            -1.136,
                            -0.303
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        94.565,
                        23.056
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 7,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.256,
                            0.382
                          ],
                          [
                            0,
                            1.04
                          ],
                          [
                            0.185,
                            0.484
                          ],
                          [
                            0.534,
                            0
                          ],
                          [
                            0.227,
                            -0.461
                          ],
                          [
                            0,
                            -0.896
                          ],
                          [
                            -0.145,
                            -0.408
                          ],
                          [
                            -0.537,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.256,
                            -0.381
                          ],
                          [
                            0,
                            -0.752
                          ],
                          [
                            -0.185,
                            -0.486
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.226,
                            0.459
                          ],
                          [
                            0,
                            0.674
                          ],
                          [
                            0.222,
                            0.625
                          ],
                          [
                            0.431,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.002,
                            2.066
                          ],
                          [
                            1.385,
                            -0.067
                          ],
                          [
                            1.107,
                            -1.92
                          ],
                          [
                            0.029,
                            -2.649
                          ],
                          [
                            -1.046,
                            -1.956
                          ],
                          [
                            -1.385,
                            0.076
                          ],
                          [
                            -1.168,
                            1.701
                          ],
                          [
                            -0.03,
                            2.639
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.382,
                            -0.705
                          ],
                          [
                            0,
                            -0.947
                          ],
                          [
                            0.268,
                            -0.587
                          ],
                          [
                            0.879,
                            0
                          ],
                          [
                            0.388,
                            0.689
                          ],
                          [
                            0,
                            0.969
                          ],
                          [
                            -0.194,
                            0.539
                          ],
                          [
                            -0.951,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.296,
                            0.545
                          ],
                          [
                            0,
                            0.899
                          ],
                          [
                            -0.388,
                            0.844
                          ],
                          [
                            -0.795,
                            0
                          ],
                          [
                            -0.323,
                            -0.575
                          ],
                          [
                            0,
                            -0.751
                          ],
                          [
                            0.363,
                            -1.004
                          ],
                          [
                            0.857,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.838,
                            -2.338
                          ],
                          [
                            2.281,
                            -0.1
                          ],
                          [
                            1.88,
                            2.131
                          ],
                          [
                            -0.023,
                            3.396
                          ],
                          [
                            -1.797,
                            2.363
                          ],
                          [
                            -2.281,
                            0.045
                          ],
                          [
                            -1.991,
                            -1.89
                          ],
                          [
                            -0.02,
                            -3.396
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        89.305,
                        23.059
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 2",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            1.433
                          ],
                          [
                            0.483,
                            1.433
                          ],
                          [
                            0.483,
                            2.441
                          ],
                          [
                            -0.483,
                            2.441
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            -2.441
                          ],
                          [
                            0.483,
                            -2.441
                          ],
                          [
                            0.483,
                            -1.434
                          ],
                          [
                            -0.483,
                            -1.434
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        85.633,
                        23.836
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 3",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.204,
                            0.422
                          ],
                          [
                            -0.594,
                            0.343
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.163
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.231,
                            0.227
                          ],
                          [
                            0.385,
                            0
                          ],
                          [
                            0.218,
                            -0.432
                          ],
                          [
                            0.013,
                            -0.41
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.203,
                            0.363
                          ],
                          [
                            -0.911,
                            0
                          ],
                          [
                            -0.349,
                            -0.41
                          ],
                          [
                            0,
                            -0.502
                          ],
                          [
                            0.372,
                            -0.376
                          ],
                          [
                            0.557,
                            -0.311
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.172,
                            -0.152
                          ],
                          [
                            0.08,
                            -0.326
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.205,
                            -0.422
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.397,
                            -0.232
                          ],
                          [
                            0.252,
                            -0.256
                          ],
                          [
                            0,
                            -0.386
                          ],
                          [
                            -0.23,
                            -0.226
                          ],
                          [
                            -0.569,
                            0
                          ],
                          [
                            -0.118,
                            0.232
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.009,
                            -0.575
                          ],
                          [
                            0.36,
                            -0.64
                          ],
                          [
                            0.758,
                            0
                          ],
                          [
                            0.35,
                            0.409
                          ],
                          [
                            0,
                            0.529
                          ],
                          [
                            -0.216,
                            0.219
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.302,
                            0.166
                          ],
                          [
                            -0.307,
                            0.268
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.031,
                            -0.57
                          ]
                        ],
                        "v": [
                          [
                            -1.933,
                            1.83
                          ],
                          [
                            -0.735,
                            0.681
                          ],
                          [
                            0.152,
                            0.168
                          ],
                          [
                            0.988,
                            -0.424
                          ],
                          [
                            1.367,
                            -1.303
                          ],
                          [
                            1.02,
                            -2.221
                          ],
                          [
                            0.096,
                            -2.562
                          ],
                          [
                            -1.085,
                            -1.913
                          ],
                          [
                            -1.28,
                            -0.95
                          ],
                          [
                            -2.124,
                            -0.95
                          ],
                          [
                            -1.806,
                            -2.358
                          ],
                          [
                            0.101,
                            -3.318
                          ],
                          [
                            1.761,
                            -2.704
                          ],
                          [
                            2.286,
                            -1.337
                          ],
                          [
                            1.727,
                            0.02
                          ],
                          [
                            0.568,
                            0.814
                          ],
                          [
                            -0.065,
                            1.165
                          ],
                          [
                            -0.776,
                            1.641
                          ],
                          [
                            -1.358,
                            2.533
                          ],
                          [
                            2.254,
                            2.533
                          ],
                          [
                            2.254,
                            3.318
                          ],
                          [
                            -2.286,
                            3.318
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        81.424,
                        22.959
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 4",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.237,
                            0.137
                          ],
                          [
                            -0.117,
                            0.51
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.6,
                            -0.058
                          ],
                          [
                            0.237,
                            -0.136
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.221,
                            -1.391
                          ],
                          [
                            -1.221,
                            -2.028
                          ],
                          [
                            0.035,
                            -2.322
                          ],
                          [
                            0.566,
                            -3.292
                          ],
                          [
                            1.221,
                            -3.292
                          ],
                          [
                            1.221,
                            3.292
                          ],
                          [
                            0.335,
                            3.292
                          ],
                          [
                            0.335,
                            -1.391
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        75.71,
                        22.984
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 5",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            3.313,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.313
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            6.595,
                            -2.03
                          ],
                          [
                            -2.168,
                            -0.263
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.313,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.314
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -3.313,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.595,
                            3.099
                          ],
                          [
                            -8.525,
                            2.623
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.314
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.313,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.313
                          ]
                        ],
                        "v": [
                          [
                            45.255,
                            -15.604
                          ],
                          [
                            -27.552,
                            -15.604
                          ],
                          [
                            -33.552,
                            -9.604
                          ],
                          [
                            -33.552,
                            -8.762
                          ],
                          [
                            -42.73,
                            2.198
                          ],
                          [
                            -33.552,
                            7.095
                          ],
                          [
                            -33.552,
                            9.604
                          ],
                          [
                            -27.552,
                            15.604
                          ],
                          [
                            45.255,
                            15.604
                          ],
                          [
                            51.255,
                            9.604
                          ],
                          [
                            51.255,
                            -9.604
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.238999998803,
                        0.234999997008,
                        0.246999987434,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        51.505,
                        15.854
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 6",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": 410,
            "op": 900,
            "st": 99,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 17,
            "ty": 5,
            "nm": "1 Ciro  2 Maliyetler 3 Faturalar 4 Borç 5 Alacak 6 Sözleşme",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 887,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 900,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 399,
                    "s": [
                      679.5,
                      395.5,
                      0
                    ],
                    "to": [
                      -26.667,
                      -4.917,
                      0
                    ],
                    "ti": [
                      26.667,
                      4.917,
                      0
                    ]
                  },
                  {
                    "t": 411,
                    "s": [
                      519.5,
                      366,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 399,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  },
                  {
                    "t": 411,
                    "s": [
                      71,
                      71,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "t": {
              "d": {
                "k": [
                  {
                    "s": {
                      "sz": [
                        339,
                        118.098587036133
                      ],
                      "ps": [
                        -169.5,
                        -14.5
                      ],
                      "s": 16,
                      "f": "Helvetica",
                      "t": "1 Ciro \r2 Maliyetler\r3 Faturalar\r4 Borç\r5 Alacak\r6 Sözleşme",
                      "ca": 0,
                      "j": 0,
                      "tr": 0,
                      "lh": 19.2000007629395,
                      "ls": 0,
                      "fc": [
                        1,
                        1,
                        1
                      ]
                    },
                    "t": 0
                  }
                ]
              },
              "p": {
                
              },
              "m": {
                "g": 1,
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 2
                }
              },
              "a": [
                {
                  "nm": "Animador 1",
                  "s": {
                    "t": 0,
                    "xe": {
                      "a": 0,
                      "k": 0,
                      "ix": 7
                    },
                    "ne": {
                      "a": 0,
                      "k": 0,
                      "ix": 8
                    },
                    "a": {
                      "a": 0,
                      "k": 100,
                      "ix": 4
                    },
                    "b": 1,
                    "rn": 0,
                    "sh": 1,
                    "s": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 301,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 350,
                          "s": [
                            100
                          ]
                        }
                      ],
                      "ix": 1
                    },
                    "r": 1
                  },
                  "a": {
                    "o": {
                      "a": 0,
                      "k": 0,
                      "ix": 9
                    }
                  }
                }
              ]
            },
            "ip": 290,
            "op": 900,
            "st": 230,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 18,
            "ty": 4,
            "nm": "02/Sem título-3 contornos",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 310,
                    "s": [
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 320,
                    "s": [
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 380,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 397,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  801,
                  357,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  706,
                  127,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  11.898,
                  11.898,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            3.369,
                            -3.369
                          ],
                          [
                            16.002,
                            0
                          ],
                          [
                            10.106,
                            11.791
                          ],
                          [
                            -3.369,
                            3.369
                          ],
                          [
                            -2.527,
                            0
                          ],
                          [
                            -1.684,
                            -1.684
                          ],
                          [
                            -11.791,
                            0
                          ],
                          [
                            -7.579,
                            8.422
                          ],
                          [
                            -2.527,
                            0
                          ],
                          [
                            -1.684,
                            -1.684
                          ]
                        ],
                        "o": [
                          [
                            -10.106,
                            11.791
                          ],
                          [
                            -16.002,
                            0
                          ],
                          [
                            -2.527,
                            -3.369
                          ],
                          [
                            1.685,
                            -1.684
                          ],
                          [
                            2.526,
                            0
                          ],
                          [
                            7.58,
                            8.422
                          ],
                          [
                            11.791,
                            0
                          ],
                          [
                            1.685,
                            -1.684
                          ],
                          [
                            2.526,
                            0
                          ],
                          [
                            1.684,
                            2.527
                          ]
                        ],
                        "v": [
                          [
                            43.374,
                            26.95
                          ],
                          [
                            2.106,
                            45.48
                          ],
                          [
                            -39.162,
                            26.95
                          ],
                          [
                            -38.32,
                            15.16
                          ],
                          [
                            -32.424,
                            12.634
                          ],
                          [
                            -26.529,
                            15.16
                          ],
                          [
                            2.947,
                            28.636
                          ],
                          [
                            32.425,
                            15.16
                          ],
                          [
                            38.321,
                            12.634
                          ],
                          [
                            44.215,
                            15.16
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -6.737,
                            0
                          ],
                          [
                            0,
                            -6.738
                          ],
                          [
                            6.738,
                            0
                          ],
                          [
                            0,
                            6.738
                          ]
                        ],
                        "o": [
                          [
                            6.738,
                            0
                          ],
                          [
                            0,
                            6.738
                          ],
                          [
                            -6.737,
                            0
                          ],
                          [
                            0,
                            -6.737
                          ]
                        ],
                        "v": [
                          [
                            -20.635,
                            -31.162
                          ],
                          [
                            -8.843,
                            -19.371
                          ],
                          [
                            -20.635,
                            -6.738
                          ],
                          [
                            -32.424,
                            -18.528
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -5.895,
                            0
                          ],
                          [
                            0,
                            -6.738
                          ],
                          [
                            6.738,
                            0
                          ],
                          [
                            0,
                            6.738
                          ]
                        ],
                        "o": [
                          [
                            6.738,
                            0
                          ],
                          [
                            0,
                            6.738
                          ],
                          [
                            -6.738,
                            0
                          ],
                          [
                            0,
                            -6.738
                          ]
                        ],
                        "v": [
                          [
                            23.161,
                            -31.162
                          ],
                          [
                            34.951,
                            -19.371
                          ],
                          [
                            23.161,
                            -7.579
                          ],
                          [
                            11.369,
                            -19.371
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 3,
                    "ty": "sh",
                    "ix": 4,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            42.11,
                            0
                          ],
                          [
                            0,
                            -42.111
                          ],
                          [
                            -6.737,
                            -11.791
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.685,
                            -1.685
                          ],
                          [
                            -1.684,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -13.476,
                            0
                          ],
                          [
                            0,
                            42.11
                          ]
                        ],
                        "o": [
                          [
                            -42.111,
                            0
                          ],
                          [
                            0,
                            13.475
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.842,
                            2.527
                          ],
                          [
                            1.684,
                            1.684
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            11.791,
                            6.737
                          ],
                          [
                            42.11,
                            0
                          ],
                          [
                            0,
                            -42.111
                          ]
                        ],
                        "v": [
                          [
                            0.421,
                            -75.798
                          ],
                          [
                            -75.377,
                            0.001
                          ],
                          [
                            -65.271,
                            37.9
                          ],
                          [
                            -75.377,
                            68.218
                          ],
                          [
                            -73.692,
                            74.114
                          ],
                          [
                            -67.798,
                            75.798
                          ],
                          [
                            -37.479,
                            65.692
                          ],
                          [
                            0.421,
                            75.798
                          ],
                          [
                            76.219,
                            0.001
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 4",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        143.633,
                        123.7
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            1.079,
                            -0.377
                          ],
                          [
                            1.797,
                            -0.324
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.582,
                            -0.827
                          ],
                          [
                            0.611,
                            -2.948
                          ],
                          [
                            -1.205,
                            -1.168
                          ],
                          [
                            -2.086,
                            0
                          ],
                          [
                            -3.201,
                            1.942
                          ],
                          [
                            -1.222,
                            5.142
                          ]
                        ],
                        "o": [
                          [
                            -1.079,
                            0.612
                          ],
                          [
                            -1.079,
                            0.378
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.381,
                            0.576
                          ],
                          [
                            -2.661,
                            1.402
                          ],
                          [
                            -0.575,
                            2.625
                          ],
                          [
                            1.205,
                            1.169
                          ],
                          [
                            3.308,
                            0
                          ],
                          [
                            3.199,
                            -1.941
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            10.302,
                            0.593
                          ],
                          [
                            7.066,
                            2.076
                          ],
                          [
                            2.751,
                            3.128
                          ],
                          [
                            -0.808,
                            3.775
                          ],
                          [
                            -8.252,
                            5.879
                          ],
                          [
                            -13.16,
                            12.405
                          ],
                          [
                            -12.216,
                            18.095
                          ],
                          [
                            -7.281,
                            19.848
                          ],
                          [
                            2.482,
                            16.935
                          ],
                          [
                            9.115,
                            6.31
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -1.331,
                            0.539
                          ],
                          [
                            -0.432,
                            1.977
                          ],
                          [
                            1.474,
                            0.917
                          ],
                          [
                            3.237,
                            0
                          ],
                          [
                            1.905,
                            -1.797
                          ],
                          [
                            0.863,
                            -2.265
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.236,
                            3.309
                          ],
                          [
                            -9.889,
                            0
                          ],
                          [
                            -4.458,
                            -2.553
                          ],
                          [
                            1.511,
                            -7.083
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.467,
                            -2.66
                          ],
                          [
                            -0.342,
                            -0.72
                          ],
                          [
                            -0.9,
                            -0.466
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.036,
                            1.043
                          ],
                          [
                            -0.181,
                            1.331
                          ],
                          [
                            3.092,
                            -1.618
                          ],
                          [
                            4.171,
                            0
                          ],
                          [
                            2.822,
                            3.038
                          ],
                          [
                            -1.187,
                            5.574
                          ],
                          [
                            -6.256,
                            3.235
                          ],
                          [
                            -6.113,
                            0.755
                          ]
                        ],
                        "o": [
                          [
                            2.947,
                            -0.359
                          ],
                          [
                            2.373,
                            -0.935
                          ],
                          [
                            0.503,
                            -2.409
                          ],
                          [
                            -1.475,
                            -0.917
                          ],
                          [
                            -3.632,
                            0
                          ],
                          [
                            -1.331,
                            1.331
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.438,
                            -5.141
                          ],
                          [
                            5.178,
                            -5.178
                          ],
                          [
                            6.435,
                            0
                          ],
                          [
                            4.458,
                            2.553
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.396,
                            1.87
                          ],
                          [
                            -0.323,
                            2.015
                          ],
                          [
                            0.341,
                            0.719
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.215,
                            -1.186
                          ],
                          [
                            0.035,
                            -1.043
                          ],
                          [
                            -2.626,
                            2.301
                          ],
                          [
                            -3.74,
                            1.905
                          ],
                          [
                            -5.323,
                            0
                          ],
                          [
                            -2.822,
                            -3.038
                          ],
                          [
                            1.546,
                            -7.227
                          ],
                          [
                            3.416,
                            -1.762
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            2.482,
                            -6.58
                          ],
                          [
                            8.9,
                            -7.928
                          ],
                          [
                            13.107,
                            -12.297
                          ],
                          [
                            11.65,
                            -17.286
                          ],
                          [
                            4.584,
                            -18.661
                          ],
                          [
                            -3.721,
                            -15.965
                          ],
                          [
                            -7.011,
                            -10.572
                          ],
                          [
                            -21.844,
                            -10.572
                          ],
                          [
                            -14.832,
                            -23.246
                          ],
                          [
                            7.767,
                            -31.012
                          ],
                          [
                            24.109,
                            -27.183
                          ],
                          [
                            28.531,
                            -12.729
                          ],
                          [
                            22.761,
                            14.239
                          ],
                          [
                            21.466,
                            21.034
                          ],
                          [
                            21.493,
                            25.134
                          ],
                          [
                            23.354,
                            26.913
                          ],
                          [
                            22.922,
                            29.178
                          ],
                          [
                            6.202,
                            29.178
                          ],
                          [
                            5.933,
                            25.835
                          ],
                          [
                            6.257,
                            22.275
                          ],
                          [
                            -2.319,
                            28.154
                          ],
                          [
                            -14.184,
                            31.012
                          ],
                          [
                            -26.401,
                            26.455
                          ],
                          [
                            -28.855,
                            13.537
                          ],
                          [
                            -17.151,
                            -2.157
                          ],
                          [
                            -2.858,
                            -5.933
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        1284.975,
                        130.167
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 2",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0.827,
                            1.762
                          ],
                          [
                            3.632,
                            0
                          ],
                          [
                            2.984,
                            -5.141
                          ],
                          [
                            0.97,
                            -4.531
                          ],
                          [
                            -0.432,
                            -2.624
                          ],
                          [
                            -5.071,
                            0
                          ],
                          [
                            -1.924,
                            1.942
                          ],
                          [
                            -0.971,
                            3.093
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.919,
                            -4.171
                          ],
                          [
                            9.456,
                            0
                          ],
                          [
                            3.254,
                            5.609
                          ],
                          [
                            -1.906,
                            8.953
                          ],
                          [
                            -6.131,
                            5.609
                          ],
                          [
                            -8.666,
                            0
                          ],
                          [
                            -3.991,
                            -3.307
                          ],
                          [
                            0.935,
                            -8.377
                          ]
                        ],
                        "o": [
                          [
                            0.18,
                            -2.193
                          ],
                          [
                            -1.222,
                            -2.373
                          ],
                          [
                            -5.178,
                            0
                          ],
                          [
                            -1.582,
                            2.733
                          ],
                          [
                            -0.9,
                            4.315
                          ],
                          [
                            0.791,
                            4.891
                          ],
                          [
                            3.594,
                            0
                          ],
                          [
                            1.923,
                            -1.942
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.331,
                            4.675
                          ],
                          [
                            -6.256,
                            6.724
                          ],
                          [
                            -9.457,
                            0
                          ],
                          [
                            -3.255,
                            -5.609
                          ],
                          [
                            2.121,
                            -10.103
                          ],
                          [
                            6.13,
                            -5.609
                          ],
                          [
                            7.37,
                            0
                          ],
                          [
                            3.991,
                            3.309
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            12.836,
                            -8.63
                          ],
                          [
                            11.865,
                            -14.563
                          ],
                          [
                            4.584,
                            -18.122
                          ],
                          [
                            -7.659,
                            -10.409
                          ],
                          [
                            -11.488,
                            0.486
                          ],
                          [
                            -12.189,
                            10.895
                          ],
                          [
                            -3.397,
                            18.229
                          ],
                          [
                            4.881,
                            15.318
                          ],
                          [
                            9.223,
                            7.767
                          ],
                          [
                            24.918,
                            7.767
                          ],
                          [
                            17.043,
                            21.034
                          ],
                          [
                            -6.526,
                            31.12
                          ],
                          [
                            -25.592,
                            22.707
                          ],
                          [
                            -27.614,
                            0.862
                          ],
                          [
                            -15.236,
                            -22.706
                          ],
                          [
                            6.958,
                            -31.12
                          ],
                          [
                            24.001,
                            -26.159
                          ],
                          [
                            28.585,
                            -8.63
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        1225.647,
                        130.275
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            13.268,
                            -25.808
                          ],
                          [
                            -2.319,
                            -25.808
                          ],
                          [
                            0.702,
                            -39.993
                          ],
                          [
                            16.289,
                            -39.993
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -3.83,
                            -18.796
                          ],
                          [
                            11.757,
                            -18.796
                          ],
                          [
                            -0.701,
                            39.993
                          ],
                          [
                            -16.289,
                            39.993
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        1181.204,
                        119.352
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 4",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.485,
                            -0.593
                          ],
                          [
                            -3.129,
                            0
                          ],
                          [
                            -0.521,
                            0.019
                          ],
                          [
                            -0.54,
                            0.036
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.085,
                            2.77
                          ],
                          [
                            -0.755,
                            3.668
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.503,
                            2.41
                          ],
                          [
                            0.485,
                            0.593
                          ],
                          [
                            0.467,
                            0
                          ],
                          [
                            0.522,
                            -0.018
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -7.3,
                            0.251
                          ],
                          [
                            -1.33,
                            -1.761
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -17.501,
                            -10.508
                          ],
                          [
                            -15.182,
                            -21.457
                          ],
                          [
                            -6.984,
                            -21.457
                          ],
                          [
                            -3.479,
                            -37.853
                          ],
                          [
                            11.731,
                            -37.853
                          ],
                          [
                            8.226,
                            -21.457
                          ],
                          [
                            17.771,
                            -21.457
                          ],
                          [
                            15.453,
                            -10.508
                          ],
                          [
                            5.906,
                            -10.508
                          ],
                          [
                            -0.728,
                            20.558
                          ],
                          [
                            -0.755,
                            25.062
                          ],
                          [
                            4.667,
                            25.952
                          ],
                          [
                            6.148,
                            25.925
                          ],
                          [
                            7.74,
                            25.844
                          ],
                          [
                            5.26,
                            37.332
                          ],
                          [
                            -2.076,
                            37.602
                          ],
                          [
                            -16.152,
                            33.826
                          ],
                          [
                            -17.016,
                            25.682
                          ],
                          [
                            -9.303,
                            -10.508
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        1149.409,
                        122.553
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 5",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            30.878,
                            -42.339
                          ],
                          [
                            11.029,
                            -26.213
                          ],
                          [
                            -0.081,
                            -26.213
                          ],
                          [
                            13.727,
                            -42.339
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            1.079,
                            -0.378
                          ],
                          [
                            1.797,
                            -0.323
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.582,
                            -0.827
                          ],
                          [
                            0.611,
                            -2.948
                          ],
                          [
                            -1.205,
                            -1.168
                          ],
                          [
                            -2.086,
                            0
                          ],
                          [
                            -3.202,
                            1.941
                          ],
                          [
                            -1.222,
                            5.142
                          ]
                        ],
                        "o": [
                          [
                            -1.079,
                            0.612
                          ],
                          [
                            -1.08,
                            0.377
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.381,
                            0.576
                          ],
                          [
                            -2.661,
                            1.402
                          ],
                          [
                            -0.575,
                            2.625
                          ],
                          [
                            1.204,
                            1.169
                          ],
                          [
                            3.307,
                            0
                          ],
                          [
                            3.199,
                            -1.942
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            9.466,
                            11.919
                          ],
                          [
                            6.23,
                            13.403
                          ],
                          [
                            1.915,
                            14.454
                          ],
                          [
                            -1.644,
                            15.101
                          ],
                          [
                            -9.088,
                            17.205
                          ],
                          [
                            -13.996,
                            23.731
                          ],
                          [
                            -13.052,
                            29.421
                          ],
                          [
                            -8.117,
                            31.174
                          ],
                          [
                            1.646,
                            28.262
                          ],
                          [
                            8.279,
                            17.637
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -1.332,
                            0.539
                          ],
                          [
                            -0.432,
                            1.978
                          ],
                          [
                            1.474,
                            0.917
                          ],
                          [
                            3.236,
                            0
                          ],
                          [
                            1.906,
                            -1.798
                          ],
                          [
                            0.864,
                            -2.265
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.236,
                            3.309
                          ],
                          [
                            -9.889,
                            0
                          ],
                          [
                            -4.458,
                            -2.552
                          ],
                          [
                            1.511,
                            -7.083
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.467,
                            -2.661
                          ],
                          [
                            -0.342,
                            -0.719
                          ],
                          [
                            -0.9,
                            -0.467
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.036,
                            1.043
                          ],
                          [
                            -0.181,
                            1.331
                          ],
                          [
                            3.092,
                            -1.618
                          ],
                          [
                            4.17,
                            0
                          ],
                          [
                            2.822,
                            3.038
                          ],
                          [
                            -1.187,
                            5.573
                          ],
                          [
                            -6.256,
                            3.236
                          ],
                          [
                            -6.114,
                            0.755
                          ]
                        ],
                        "o": [
                          [
                            2.947,
                            -0.359
                          ],
                          [
                            2.373,
                            -0.935
                          ],
                          [
                            0.503,
                            -2.409
                          ],
                          [
                            -1.475,
                            -0.917
                          ],
                          [
                            -3.632,
                            0
                          ],
                          [
                            -1.33,
                            1.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.438,
                            -5.141
                          ],
                          [
                            5.178,
                            -5.177
                          ],
                          [
                            6.435,
                            0
                          ],
                          [
                            4.458,
                            2.554
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.397,
                            1.87
                          ],
                          [
                            -0.323,
                            2.014
                          ],
                          [
                            0.341,
                            0.72
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.216,
                            -1.187
                          ],
                          [
                            0.035,
                            -1.042
                          ],
                          [
                            -2.626,
                            2.302
                          ],
                          [
                            -3.74,
                            1.906
                          ],
                          [
                            -5.323,
                            0
                          ],
                          [
                            -2.823,
                            -3.038
                          ],
                          [
                            1.546,
                            -7.227
                          ],
                          [
                            3.416,
                            -1.761
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.646,
                            4.746
                          ],
                          [
                            8.064,
                            3.398
                          ],
                          [
                            12.271,
                            -0.971
                          ],
                          [
                            10.814,
                            -5.96
                          ],
                          [
                            3.748,
                            -7.335
                          ],
                          [
                            -4.558,
                            -4.638
                          ],
                          [
                            -7.848,
                            0.755
                          ],
                          [
                            -22.68,
                            0.755
                          ],
                          [
                            -15.668,
                            -11.92
                          ],
                          [
                            6.931,
                            -19.686
                          ],
                          [
                            23.273,
                            -15.857
                          ],
                          [
                            27.695,
                            -1.402
                          ],
                          [
                            21.925,
                            25.565
                          ],
                          [
                            20.63,
                            32.361
                          ],
                          [
                            20.657,
                            36.46
                          ],
                          [
                            22.518,
                            38.24
                          ],
                          [
                            22.086,
                            40.505
                          ],
                          [
                            5.366,
                            40.505
                          ],
                          [
                            5.097,
                            37.161
                          ],
                          [
                            5.421,
                            33.601
                          ],
                          [
                            -3.155,
                            39.48
                          ],
                          [
                            -15.02,
                            42.339
                          ],
                          [
                            -27.237,
                            37.781
                          ],
                          [
                            -29.691,
                            24.864
                          ],
                          [
                            -17.987,
                            9.169
                          ],
                          [
                            -3.694,
                            5.393
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        1095.475,
                        118.841
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 6",
                "np": 5,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.546,
                            -2.516
                          ],
                          [
                            0.036,
                            -2.984
                          ],
                          [
                            0.79,
                            -3.81
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.396,
                            1.439
                          ],
                          [
                            3.668,
                            0
                          ],
                          [
                            2.373,
                            -3.523
                          ],
                          [
                            0.575,
                            -2.624
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.396,
                            1.583
                          ],
                          [
                            3.776,
                            0
                          ],
                          [
                            2.121,
                            -2.84
                          ],
                          [
                            0.683,
                            -3.199
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.978,
                            1.295
                          ],
                          [
                            -4.746,
                            0
                          ],
                          [
                            -2.373,
                            -1.977
                          ],
                          [
                            -0.539,
                            -2.876
                          ],
                          [
                            -3.345,
                            1.619
                          ],
                          [
                            -3.883,
                            0
                          ],
                          [
                            -2.301,
                            -1.007
                          ]
                        ],
                        "o": [
                          [
                            1.187,
                            2.05
                          ],
                          [
                            -0.073,
                            1.978
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.467,
                            -2.229
                          ],
                          [
                            -0.791,
                            -2.731
                          ],
                          [
                            -4.243,
                            0
                          ],
                          [
                            -1.223,
                            1.87
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.755,
                            -3.487
                          ],
                          [
                            -0.683,
                            -2.84
                          ],
                          [
                            -4.387,
                            0
                          ],
                          [
                            -1.151,
                            1.618
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.552,
                            -3.056
                          ],
                          [
                            3.452,
                            -2.301
                          ],
                          [
                            4.494,
                            0
                          ],
                          [
                            1.834,
                            1.833
                          ],
                          [
                            2.732,
                            -3.451
                          ],
                          [
                            3.486,
                            -1.617
                          ],
                          [
                            2.588,
                            0
                          ],
                          [
                            2.301,
                            1.007
                          ]
                        ],
                        "v": [
                          [
                            45.018,
                            -23.247
                          ],
                          [
                            46.743,
                            -15.695
                          ],
                          [
                            45.449,
                            -7.013
                          ],
                          [
                            37.466,
                            30.042
                          ],
                          [
                            21.717,
                            30.042
                          ],
                          [
                            29.646,
                            -7.389
                          ],
                          [
                            29.753,
                            -12.891
                          ],
                          [
                            23.066,
                            -16.99
                          ],
                          [
                            13.143,
                            -11.704
                          ],
                          [
                            10.445,
                            -4.962
                          ],
                          [
                            3.056,
                            30.042
                          ],
                          [
                            -12.423,
                            30.042
                          ],
                          [
                            -5.034,
                            -4.962
                          ],
                          [
                            -4.495,
                            -12.568
                          ],
                          [
                            -11.183,
                            -16.828
                          ],
                          [
                            -20.945,
                            -12.568
                          ],
                          [
                            -23.695,
                            -5.341
                          ],
                          [
                            -31.192,
                            30.042
                          ],
                          [
                            -46.779,
                            30.042
                          ],
                          [
                            -34.32,
                            -28.639
                          ],
                          [
                            -19.38,
                            -28.639
                          ],
                          [
                            -21.214,
                            -20.065
                          ],
                          [
                            -14.419,
                            -26.591
                          ],
                          [
                            -2.122,
                            -30.042
                          ],
                          [
                            8.18,
                            -27.076
                          ],
                          [
                            11.74,
                            -20.01
                          ],
                          [
                            20.855,
                            -27.615
                          ],
                          [
                            31.911,
                            -30.042
                          ],
                          [
                            39.246,
                            -28.531
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        1014.78,
                        129.304
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 7",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 7,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.259,
                            5.897
                          ],
                          [
                            1.744,
                            3.182
                          ],
                          [
                            4.494,
                            0
                          ],
                          [
                            3.092,
                            -3.182
                          ],
                          [
                            1.259,
                            -5.896
                          ],
                          [
                            -1.744,
                            -3.2
                          ],
                          [
                            -4.495,
                            0
                          ],
                          [
                            -3.093,
                            3.2
                          ]
                        ],
                        "o": [
                          [
                            1.259,
                            -5.896
                          ],
                          [
                            -1.745,
                            -3.182
                          ],
                          [
                            -4.495,
                            0
                          ],
                          [
                            -3.093,
                            3.182
                          ],
                          [
                            -1.259,
                            5.897
                          ],
                          [
                            1.743,
                            3.2
                          ],
                          [
                            4.494,
                            0
                          ],
                          [
                            3.092,
                            -3.2
                          ]
                        ],
                        "v": [
                          [
                            13.933,
                            0.027
                          ],
                          [
                            13.205,
                            -13.591
                          ],
                          [
                            3.847,
                            -18.365
                          ],
                          [
                            -7.533,
                            -13.591
                          ],
                          [
                            -14.059,
                            0.027
                          ],
                          [
                            -13.331,
                            13.673
                          ],
                          [
                            -3.973,
                            18.473
                          ],
                          [
                            7.407,
                            13.673
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            10.104,
                            0
                          ],
                          [
                            3.648,
                            6.131
                          ],
                          [
                            -1.833,
                            8.63
                          ],
                          [
                            -6.293,
                            6.221
                          ],
                          [
                            -10.103,
                            0
                          ],
                          [
                            -3.632,
                            -6.22
                          ],
                          [
                            1.797,
                            -8.485
                          ],
                          [
                            6.274,
                            -6.13
                          ]
                        ],
                        "o": [
                          [
                            -10.104,
                            0
                          ],
                          [
                            -3.651,
                            -6.13
                          ],
                          [
                            1.798,
                            -8.485
                          ],
                          [
                            6.292,
                            -6.22
                          ],
                          [
                            10.104,
                            0
                          ],
                          [
                            3.631,
                            6.221
                          ],
                          [
                            -1.834,
                            8.63
                          ],
                          [
                            -6.275,
                            6.131
                          ]
                        ],
                        "v": [
                          [
                            -6.67,
                            31.363
                          ],
                          [
                            -27.299,
                            22.167
                          ],
                          [
                            -30.024,
                            0.027
                          ],
                          [
                            -17.888,
                            -22.032
                          ],
                          [
                            6.705,
                            -31.363
                          ],
                          [
                            27.309,
                            -22.032
                          ],
                          [
                            30.06,
                            0.027
                          ],
                          [
                            17.897,
                            22.167
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        933.411,
                        130.032
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 8",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 8,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.485,
                            -0.593
                          ],
                          [
                            -3.129,
                            0
                          ],
                          [
                            -0.521,
                            0.019
                          ],
                          [
                            -0.54,
                            0.036
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.085,
                            2.77
                          ],
                          [
                            -0.755,
                            3.668
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.503,
                            2.41
                          ],
                          [
                            0.485,
                            0.593
                          ],
                          [
                            0.467,
                            0
                          ],
                          [
                            0.522,
                            -0.018
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -7.3,
                            0.251
                          ],
                          [
                            -1.33,
                            -1.761
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -17.501,
                            -10.508
                          ],
                          [
                            -15.182,
                            -21.457
                          ],
                          [
                            -6.984,
                            -21.457
                          ],
                          [
                            -3.479,
                            -37.853
                          ],
                          [
                            11.731,
                            -37.853
                          ],
                          [
                            8.226,
                            -21.457
                          ],
                          [
                            17.771,
                            -21.457
                          ],
                          [
                            15.453,
                            -10.508
                          ],
                          [
                            5.906,
                            -10.508
                          ],
                          [
                            -0.728,
                            20.558
                          ],
                          [
                            -0.755,
                            25.062
                          ],
                          [
                            4.667,
                            25.952
                          ],
                          [
                            6.148,
                            25.925
                          ],
                          [
                            7.74,
                            25.844
                          ],
                          [
                            5.26,
                            37.332
                          ],
                          [
                            -2.076,
                            37.602
                          ],
                          [
                            -16.152,
                            33.826
                          ],
                          [
                            -17.016,
                            25.682
                          ],
                          [
                            -9.303,
                            -10.508
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        885.508,
                        122.553
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 9",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 9,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.431,
                            -1.69
                          ],
                          [
                            -4.1,
                            0
                          ],
                          [
                            -2.841,
                            4.243
                          ],
                          [
                            -0.791,
                            3.775
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.755,
                            -0.899
                          ],
                          [
                            0.934,
                            -0.683
                          ],
                          [
                            2.427,
                            -0.79
                          ],
                          [
                            3.02,
                            0
                          ],
                          [
                            1.69,
                            6.257
                          ],
                          [
                            -1.439,
                            6.724
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.72,
                            3.344
                          ],
                          [
                            0.755,
                            2.985
                          ],
                          [
                            5.249,
                            0
                          ],
                          [
                            1.511,
                            -2.301
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            0.181
                          ],
                          [
                            -0.755,
                            0.899
                          ],
                          [
                            -2.877,
                            2.157
                          ],
                          [
                            -2.427,
                            0.791
                          ],
                          [
                            -8.702,
                            0
                          ],
                          [
                            -0.935,
                            -3.451
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -6.193,
                            -30.042
                          ],
                          [
                            -13.69,
                            5.394
                          ],
                          [
                            -14.122,
                            12.945
                          ],
                          [
                            -6.84,
                            17.421
                          ],
                          [
                            5.294,
                            11.057
                          ],
                          [
                            8.746,
                            1.942
                          ],
                          [
                            15.542,
                            -30.042
                          ],
                          [
                            31.13,
                            -30.042
                          ],
                          [
                            18.67,
                            28.747
                          ],
                          [
                            3.731,
                            28.747
                          ],
                          [
                            5.456,
                            20.441
                          ],
                          [
                            4.054,
                            22.06
                          ],
                          [
                            1.519,
                            24.432
                          ],
                          [
                            -6.436,
                            28.855
                          ],
                          [
                            -14.607,
                            30.042
                          ],
                          [
                            -30.195,
                            20.657
                          ],
                          [
                            -29.439,
                            5.394
                          ],
                          [
                            -21.942,
                            -30.042
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        830.512,
                        130.598
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 10",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 10,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -3.937,
                            9.708
                          ],
                          [
                            16.235,
                            9.708
                          ],
                          [
                            12.944,
                            -21.574
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            7.604,
                            -39.75
                          ],
                          [
                            26.374,
                            -39.75
                          ],
                          [
                            37.647,
                            39.75
                          ],
                          [
                            19.631,
                            39.75
                          ],
                          [
                            17.959,
                            23.407
                          ],
                          [
                            -11.327,
                            23.407
                          ],
                          [
                            -20.28,
                            39.75
                          ],
                          [
                            -37.647,
                            39.75
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        750.052,
                        119.596
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 11",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 11,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.546,
                            -2.516
                          ],
                          [
                            0.035,
                            -2.984
                          ],
                          [
                            0.79,
                            -3.81
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.395,
                            1.439
                          ],
                          [
                            3.667,
                            0
                          ],
                          [
                            2.373,
                            -3.523
                          ],
                          [
                            0.575,
                            -2.624
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.395,
                            1.583
                          ],
                          [
                            3.776,
                            0
                          ],
                          [
                            2.121,
                            -2.84
                          ],
                          [
                            0.682,
                            -3.199
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.978,
                            1.295
                          ],
                          [
                            -4.746,
                            0
                          ],
                          [
                            -2.373,
                            -1.977
                          ],
                          [
                            -0.54,
                            -2.876
                          ],
                          [
                            -3.343,
                            1.619
                          ],
                          [
                            -3.883,
                            0
                          ],
                          [
                            -2.301,
                            -1.007
                          ]
                        ],
                        "o": [
                          [
                            1.187,
                            2.05
                          ],
                          [
                            -0.072,
                            1.978
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.467,
                            -2.229
                          ],
                          [
                            -0.792,
                            -2.731
                          ],
                          [
                            -4.243,
                            0
                          ],
                          [
                            -1.223,
                            1.87
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.755,
                            -3.487
                          ],
                          [
                            -0.683,
                            -2.84
                          ],
                          [
                            -4.387,
                            0
                          ],
                          [
                            -1.151,
                            1.618
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.552,
                            -3.056
                          ],
                          [
                            3.452,
                            -2.301
                          ],
                          [
                            4.494,
                            0
                          ],
                          [
                            1.834,
                            1.833
                          ],
                          [
                            2.732,
                            -3.451
                          ],
                          [
                            3.488,
                            -1.617
                          ],
                          [
                            2.589,
                            0
                          ],
                          [
                            2.301,
                            1.007
                          ]
                        ],
                        "v": [
                          [
                            45.018,
                            -23.247
                          ],
                          [
                            46.743,
                            -15.695
                          ],
                          [
                            45.449,
                            -7.013
                          ],
                          [
                            37.466,
                            30.042
                          ],
                          [
                            21.717,
                            30.042
                          ],
                          [
                            29.646,
                            -7.389
                          ],
                          [
                            29.754,
                            -12.891
                          ],
                          [
                            23.066,
                            -16.99
                          ],
                          [
                            13.143,
                            -11.704
                          ],
                          [
                            10.445,
                            -4.962
                          ],
                          [
                            3.056,
                            30.042
                          ],
                          [
                            -12.423,
                            30.042
                          ],
                          [
                            -5.034,
                            -4.962
                          ],
                          [
                            -4.495,
                            -12.568
                          ],
                          [
                            -11.183,
                            -16.828
                          ],
                          [
                            -20.945,
                            -12.568
                          ],
                          [
                            -23.695,
                            -5.341
                          ],
                          [
                            -31.192,
                            30.042
                          ],
                          [
                            -46.779,
                            30.042
                          ],
                          [
                            -34.32,
                            -28.639
                          ],
                          [
                            -19.381,
                            -28.639
                          ],
                          [
                            -21.214,
                            -20.065
                          ],
                          [
                            -14.419,
                            -26.591
                          ],
                          [
                            -2.122,
                            -30.042
                          ],
                          [
                            8.18,
                            -27.076
                          ],
                          [
                            11.74,
                            -20.01
                          ],
                          [
                            20.854,
                            -27.615
                          ],
                          [
                            31.911,
                            -30.042
                          ],
                          [
                            39.246,
                            -28.531
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        638.424,
                        129.304
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 12",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 12,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.294,
                            -3.811
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.78,
                            2.104
                          ],
                          [
                            3.271,
                            0
                          ],
                          [
                            2.427,
                            -2.229
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.611,
                            -4.062
                          ],
                          [
                            -1.78,
                            -2.103
                          ],
                          [
                            -3.561,
                            0
                          ],
                          [
                            -2.427,
                            2.23
                          ]
                        ],
                        "v": [
                          [
                            -10.202,
                            -6.068
                          ],
                          [
                            13.691,
                            -6.068
                          ],
                          [
                            11.938,
                            -15.318
                          ],
                          [
                            4.361,
                            -18.473
                          ],
                          [
                            -4.62,
                            -15.129
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.691,
                            -3.955
                          ],
                          [
                            0.323,
                            -4.602
                          ],
                          [
                            1.151,
                            -5.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.984,
                            -2.373
                          ],
                          [
                            -2.985,
                            0
                          ],
                          [
                            -2.374,
                            1.798
                          ],
                          [
                            -1.223,
                            1.726
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.991,
                            -3.596
                          ],
                          [
                            9.062,
                            0
                          ],
                          [
                            4.692,
                            4.819
                          ],
                          [
                            -2.302,
                            10.86
                          ],
                          [
                            -6.31,
                            5.43
                          ],
                          [
                            -8.234,
                            0
                          ],
                          [
                            -3.542,
                            -1.834
                          ]
                        ],
                        "o": [
                          [
                            1.582,
                            3.488
                          ],
                          [
                            -0.144,
                            2.697
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.043,
                            5.897
                          ],
                          [
                            1.798,
                            1.475
                          ],
                          [
                            3.163,
                            0
                          ],
                          [
                            1.258,
                            -0.971
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.151,
                            3.488
                          ],
                          [
                            -6.257,
                            5.716
                          ],
                          [
                            -7.479,
                            0
                          ],
                          [
                            -4.693,
                            -4.818
                          ],
                          [
                            2.157,
                            -10.175
                          ],
                          [
                            6.311,
                            -5.429
                          ],
                          [
                            4.889,
                            0
                          ],
                          [
                            3.541,
                            1.834
                          ]
                        ],
                        "v": [
                          [
                            27.552,
                            -19.712
                          ],
                          [
                            29.44,
                            -7.577
                          ],
                          [
                            27.498,
                            4.072
                          ],
                          [
                            -12.737,
                            4.072
                          ],
                          [
                            -9.825,
                            16.478
                          ],
                          [
                            -2.651,
                            18.689
                          ],
                          [
                            5.655,
                            15.993
                          ],
                          [
                            9.376,
                            11.947
                          ],
                          [
                            25.071,
                            11.947
                          ],
                          [
                            17.359,
                            22.572
                          ],
                          [
                            -5.618,
                            31.147
                          ],
                          [
                            -23.874,
                            23.921
                          ],
                          [
                            -27.461,
                            0.405
                          ],
                          [
                            -14.76,
                            -23.003
                          ],
                          [
                            7.057,
                            -31.147
                          ],
                          [
                            19.705,
                            -28.397
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        559.4,
                        130.139
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 13",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 13,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.259,
                            5.933
                          ],
                          [
                            1.726,
                            2.913
                          ],
                          [
                            3.956,
                            0
                          ],
                          [
                            3.128,
                            -5.07
                          ],
                          [
                            0.863,
                            -3.955
                          ],
                          [
                            -0.612,
                            -2.661
                          ],
                          [
                            -5.393,
                            0
                          ],
                          [
                            -3.056,
                            2.716
                          ]
                        ],
                        "o": [
                          [
                            1.187,
                            -5.573
                          ],
                          [
                            -1.726,
                            -2.912
                          ],
                          [
                            -5.393,
                            0
                          ],
                          [
                            -1.654,
                            2.697
                          ],
                          [
                            -0.72,
                            3.417
                          ],
                          [
                            1.006,
                            4.962
                          ],
                          [
                            3.595,
                            0
                          ],
                          [
                            3.056,
                            -2.714
                          ]
                        ],
                        "v": [
                          [
                            13.709,
                            -11.596
                          ],
                          [
                            12.9,
                            -24.325
                          ],
                          [
                            4.377,
                            -28.693
                          ],
                          [
                            -8.405,
                            -21.089
                          ],
                          [
                            -12.179,
                            -11.111
                          ],
                          [
                            -12.342,
                            -1.995
                          ],
                          [
                            -2.741,
                            5.447
                          ],
                          [
                            7.236,
                            1.375
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -1.979,
                            -0.898
                          ],
                          [
                            -1.439,
                            -4.135
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.379,
                            -3.848
                          ],
                          [
                            12.441,
                            0
                          ],
                          [
                            4.117,
                            2.948
                          ],
                          [
                            -0.719,
                            5.859
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.791,
                            -0.791
                          ],
                          [
                            -3.92,
                            0
                          ],
                          [
                            -2.661,
                            3.703
                          ],
                          [
                            -1.187,
                            5.609
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.977,
                            -1.258
                          ],
                          [
                            4.89,
                            0
                          ],
                          [
                            3.38,
                            5.304
                          ],
                          [
                            -1.942,
                            9.061
                          ],
                          [
                            -5.628,
                            5.952
                          ],
                          [
                            -7.982,
                            0
                          ]
                        ],
                        "o": [
                          [
                            3.415,
                            1.547
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.583,
                            7.586
                          ],
                          [
                            -5.79,
                            6.615
                          ],
                          [
                            -7.515,
                            0
                          ],
                          [
                            -4.117,
                            -2.948
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.072,
                            1.797
                          ],
                          [
                            1.367,
                            1.403
                          ],
                          [
                            5.537,
                            0
                          ],
                          [
                            1.726,
                            -2.373
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.014,
                            2.517
                          ],
                          [
                            -3.56,
                            2.338
                          ],
                          [
                            -7.551,
                            0
                          ],
                          [
                            -3.38,
                            -5.304
                          ],
                          [
                            1.833,
                            -8.738
                          ],
                          [
                            5.627,
                            -5.95
                          ],
                          [
                            2.949,
                            0
                          ]
                        ],
                        "v": [
                          [
                            10.959,
                            -40.775
                          ],
                          [
                            18.239,
                            -32.253
                          ],
                          [
                            20.02,
                            -40.721
                          ],
                          [
                            34.958,
                            -40.721
                          ],
                          [
                            23.094,
                            15.048
                          ],
                          [
                            15.65,
                            32.199
                          ],
                          [
                            -11.694,
                            42.123
                          ],
                          [
                            -29.142,
                            37.7
                          ],
                          [
                            -34.24,
                            24.487
                          ],
                          [
                            -17.52,
                            24.487
                          ],
                          [
                            -16.225,
                            28.369
                          ],
                          [
                            -8.296,
                            30.473
                          ],
                          [
                            4.001,
                            24.918
                          ],
                          [
                            8.369,
                            12.944
                          ],
                          [
                            9.178,
                            9.169
                          ],
                          [
                            3.191,
                            14.832
                          ],
                          [
                            -9.483,
                            18.338
                          ],
                          [
                            -25.879,
                            10.383
                          ],
                          [
                            -28.037,
                            -11.164
                          ],
                          [
                            -16.845,
                            -33.197
                          ],
                          [
                            3.569,
                            -42.123
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        493.636,
                        141.277
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 14",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 14,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            1.078,
                            -0.377
                          ],
                          [
                            1.798,
                            -0.324
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.582,
                            -0.827
                          ],
                          [
                            0.611,
                            -2.948
                          ],
                          [
                            -1.205,
                            -1.168
                          ],
                          [
                            -2.085,
                            0
                          ],
                          [
                            -3.2,
                            1.942
                          ],
                          [
                            -1.223,
                            5.142
                          ]
                        ],
                        "o": [
                          [
                            -1.079,
                            0.612
                          ],
                          [
                            -1.079,
                            0.378
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.38,
                            0.576
                          ],
                          [
                            -2.661,
                            1.402
                          ],
                          [
                            -0.576,
                            2.625
                          ],
                          [
                            1.205,
                            1.169
                          ],
                          [
                            3.308,
                            0
                          ],
                          [
                            3.2,
                            -1.941
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            10.302,
                            0.593
                          ],
                          [
                            7.065,
                            2.076
                          ],
                          [
                            2.75,
                            3.128
                          ],
                          [
                            -0.81,
                            3.775
                          ],
                          [
                            -8.253,
                            5.879
                          ],
                          [
                            -13.161,
                            12.405
                          ],
                          [
                            -12.216,
                            18.095
                          ],
                          [
                            -7.281,
                            19.848
                          ],
                          [
                            2.48,
                            16.935
                          ],
                          [
                            9.115,
                            6.31
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -1.331,
                            0.539
                          ],
                          [
                            -0.431,
                            1.977
                          ],
                          [
                            1.474,
                            0.917
                          ],
                          [
                            3.236,
                            0
                          ],
                          [
                            1.905,
                            -1.797
                          ],
                          [
                            0.863,
                            -2.265
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.236,
                            3.309
                          ],
                          [
                            -9.889,
                            0
                          ],
                          [
                            -4.459,
                            -2.553
                          ],
                          [
                            1.511,
                            -7.083
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.467,
                            -2.66
                          ],
                          [
                            -0.342,
                            -0.72
                          ],
                          [
                            -0.899,
                            -0.466
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.036,
                            1.043
                          ],
                          [
                            -0.181,
                            1.331
                          ],
                          [
                            3.092,
                            -1.618
                          ],
                          [
                            4.17,
                            0
                          ],
                          [
                            2.823,
                            3.038
                          ],
                          [
                            -1.186,
                            5.574
                          ],
                          [
                            -6.256,
                            3.235
                          ],
                          [
                            -6.113,
                            0.755
                          ]
                        ],
                        "o": [
                          [
                            2.948,
                            -0.359
                          ],
                          [
                            2.373,
                            -0.935
                          ],
                          [
                            0.504,
                            -2.409
                          ],
                          [
                            -1.474,
                            -0.917
                          ],
                          [
                            -3.633,
                            0
                          ],
                          [
                            -1.331,
                            1.331
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.437,
                            -5.141
                          ],
                          [
                            5.178,
                            -5.178
                          ],
                          [
                            6.436,
                            0
                          ],
                          [
                            4.458,
                            2.553
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.395,
                            1.87
                          ],
                          [
                            -0.323,
                            2.015
                          ],
                          [
                            0.342,
                            0.719
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.216,
                            -1.186
                          ],
                          [
                            0.036,
                            -1.043
                          ],
                          [
                            -2.625,
                            2.301
                          ],
                          [
                            -3.74,
                            1.905
                          ],
                          [
                            -5.323,
                            0
                          ],
                          [
                            -2.823,
                            -3.038
                          ],
                          [
                            1.546,
                            -7.227
                          ],
                          [
                            3.415,
                            -1.762
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            2.48,
                            -6.58
                          ],
                          [
                            8.899,
                            -7.928
                          ],
                          [
                            13.105,
                            -12.297
                          ],
                          [
                            11.649,
                            -17.286
                          ],
                          [
                            4.584,
                            -18.661
                          ],
                          [
                            -3.721,
                            -15.965
                          ],
                          [
                            -7.012,
                            -10.572
                          ],
                          [
                            -21.844,
                            -10.572
                          ],
                          [
                            -14.833,
                            -23.246
                          ],
                          [
                            7.766,
                            -31.012
                          ],
                          [
                            24.108,
                            -27.183
                          ],
                          [
                            28.53,
                            -12.729
                          ],
                          [
                            22.759,
                            14.239
                          ],
                          [
                            21.465,
                            21.034
                          ],
                          [
                            21.492,
                            25.134
                          ],
                          [
                            23.353,
                            26.913
                          ],
                          [
                            22.922,
                            29.178
                          ],
                          [
                            6.202,
                            29.178
                          ],
                          [
                            5.932,
                            25.835
                          ],
                          [
                            6.256,
                            22.275
                          ],
                          [
                            -2.32,
                            28.154
                          ],
                          [
                            -14.185,
                            31.012
                          ],
                          [
                            -26.401,
                            26.455
                          ],
                          [
                            -28.856,
                            13.537
                          ],
                          [
                            -17.151,
                            -2.157
                          ],
                          [
                            -2.859,
                            -5.933
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        429.733,
                        130.167
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 15",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 15,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            13.268,
                            -25.808
                          ],
                          [
                            -2.319,
                            -25.808
                          ],
                          [
                            0.701,
                            -39.993
                          ],
                          [
                            16.288,
                            -39.993
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -3.829,
                            -18.796
                          ],
                          [
                            11.758,
                            -18.796
                          ],
                          [
                            -0.701,
                            39.993
                          ],
                          [
                            -16.288,
                            39.993
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        387.394,
                        119.352
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 16",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 16,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.647,
                            -0.036
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.755,
                            0.036
                          ],
                          [
                            0.467,
                            0
                          ],
                          [
                            2.984,
                            -4.027
                          ],
                          [
                            1.007,
                            -4.71
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.05,
                            1.439
                          ],
                          [
                            -4.603,
                            0
                          ],
                          [
                            -0.198,
                            -0.018
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.936,
                            -0.108
                          ],
                          [
                            -0.755,
                            -0.035
                          ],
                          [
                            -6.184,
                            0
                          ],
                          [
                            -1.655,
                            2.265
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.199,
                            -3.919
                          ],
                          [
                            3.416,
                            -2.408
                          ],
                          [
                            0.288,
                            0
                          ],
                          [
                            0.198,
                            0.019
                          ]
                        ],
                        "v": [
                          [
                            23.435,
                            -29.988
                          ],
                          [
                            20.09,
                            -14.238
                          ],
                          [
                            17.555,
                            -14.454
                          ],
                          [
                            15.721,
                            -14.509
                          ],
                          [
                            1.969,
                            -8.467
                          ],
                          [
                            -2.023,
                            1.996
                          ],
                          [
                            -7.956,
                            30.095
                          ],
                          [
                            -23.435,
                            30.095
                          ],
                          [
                            -10.977,
                            -28.694
                          ],
                          [
                            3.694,
                            -28.694
                          ],
                          [
                            1.537,
                            -18.445
                          ],
                          [
                            9.411,
                            -26.483
                          ],
                          [
                            21.438,
                            -30.095
                          ],
                          [
                            22.167,
                            -30.069
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        351.178,
                        129.25
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 17",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 17,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            33.709,
                            -39.75
                          ],
                          [
                            30.689,
                            -25.673
                          ],
                          [
                            6.904,
                            -25.673
                          ],
                          [
                            -6.958,
                            39.75
                          ],
                          [
                            -23.677,
                            39.75
                          ],
                          [
                            -9.816,
                            -25.673
                          ],
                          [
                            -33.709,
                            -25.673
                          ],
                          [
                            -30.689,
                            -39.75
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        308.65,
                        119.596
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 18",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 18,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            69.836,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -69.837
                          ],
                          [
                            -69.836,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            69.836
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -69.836,
                            0
                          ],
                          [
                            0,
                            69.836
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            69.836,
                            0
                          ],
                          [
                            0,
                            -69.837
                          ]
                        ],
                        "v": [
                          [
                            579.176,
                            -126.45
                          ],
                          [
                            -579.175,
                            -126.45
                          ],
                          [
                            -705.625,
                            0
                          ],
                          [
                            -579.175,
                            126.45
                          ],
                          [
                            579.176,
                            126.45
                          ],
                          [
                            705.625,
                            0
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.086000001197,
                        0.791999966491,
                        0.709999952129,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        705.875,
                        126.7
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 19",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 19,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": 310,
            "op": 398,
            "st": -178,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 19,
            "ty": 4,
            "nm": "Talk 02/conversas_whatsapp contornos",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 887,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 900,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 399,
                    "s": [
                      682.5,
                      430,
                      0
                    ],
                    "to": [
                      -26.833,
                      -6,
                      0
                    ],
                    "ti": [
                      26.833,
                      6,
                      0
                    ]
                  },
                  {
                    "t": 411,
                    "s": [
                      521.5,
                      394,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  130.5,
                  48,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 290,
                    "s": [
                      0,
                      0,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 296,
                    "s": [
                      180,
                      180,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 301,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 399,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "t": 411,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0.254,
                                0.204
                              ],
                              [
                                1.434,
                                -1.783
                              ],
                              [
                                0.202,
                                0.189
                              ],
                              [
                                0.174,
                                -0.219
                              ],
                              [
                                -0.434,
                                -0.435
                              ],
                              [
                                -1.665,
                                2.071
                              ]
                            ],
                            "o": [
                              [
                                -1.447,
                                1.8
                              ],
                              [
                                -0.214,
                                -0.199
                              ],
                              [
                                -0.211,
                                0.265
                              ],
                              [
                                0.428,
                                0.429
                              ],
                              [
                                1.651,
                                -2.056
                              ],
                              [
                                -0.264,
                                -0.211
                              ]
                            ],
                            "v": [
                              [
                                2.363,
                                -3.393
                              ],
                              [
                                -1.941,
                                1.96
                              ],
                              [
                                -2.546,
                                1.395
                              ],
                              [
                                -3.12,
                                2.114
                              ],
                              [
                                -1.845,
                                3.393
                              ],
                              [
                                3.12,
                                -2.785
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Caminho 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 1,
                          "k": [
                            {
                              "i": {
                                "x": [
                                  0.833
                                ],
                                "y": [
                                  0.833
                                ]
                              },
                              "o": {
                                "x": [
                                  0.167
                                ],
                                "y": [
                                  0.167
                                ]
                              },
                              "t": 410,
                              "s": [
                                0.207843139768,
                                0.564705908298,
                                0.517647087574,
                                1
                              ]
                            },
                            {
                              "t": 411,
                              "s": [
                                0,
                                0.642999985639,
                                0.933000033509,
                                1
                              ]
                            }
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Preenchimento 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            227.225,
                            85.605
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Grupo 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0.261,
                                0.208
                              ],
                              [
                                1.462,
                                -1.817
                              ],
                              [
                                0.612,
                                0.619
                              ],
                              [
                                0.197,
                                -0.197
                              ],
                              [
                                -0.884,
                                -0.883
                              ],
                              [
                                -1.663,
                                2.071
                              ]
                            ],
                            "o": [
                              [
                                -1.442,
                                1.794
                              ],
                              [
                                -0.645,
                                -0.652
                              ],
                              [
                                -0.224,
                                0.225
                              ],
                              [
                                0.878,
                                0.879
                              ],
                              [
                                1.64,
                                -2.042
                              ],
                              [
                                -0.262,
                                -0.209
                              ]
                            ],
                            "v": [
                              [
                                3.038,
                                -3.388
                              ],
                              [
                                -1.294,
                                1.998
                              ],
                              [
                                -3.156,
                                0.116
                              ],
                              [
                                -3.794,
                                0.755
                              ],
                              [
                                -1.163,
                                3.388
                              ],
                              [
                                3.794,
                                -2.783
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Caminho 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 1,
                          "k": [
                            {
                              "i": {
                                "x": [
                                  0.833
                                ],
                                "y": [
                                  0.833
                                ]
                              },
                              "o": {
                                "x": [
                                  0.167
                                ],
                                "y": [
                                  0.167
                                ]
                              },
                              "t": 410,
                              "s": [
                                0.207843139768,
                                0.564705908298,
                                0.517647087574,
                                1
                              ]
                            },
                            {
                              "t": 411,
                              "s": [
                                0,
                                0.642999985639,
                                0.933000033509,
                                1
                              ]
                            }
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Preenchimento 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            223.396,
                            85.602
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Grupo 2",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        105.597,
                        115.943
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        105.597,
                        115.943
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 9",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.206,
                            0.205
                          ],
                          [
                            0,
                            0.284
                          ],
                          [
                            0.196,
                            0.207
                          ],
                          [
                            0.403,
                            0
                          ],
                          [
                            0.178,
                            -0.207
                          ],
                          [
                            0,
                            -0.278
                          ],
                          [
                            -0.23,
                            -0.176
                          ],
                          [
                            -0.314,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.206,
                            -0.205
                          ],
                          [
                            0,
                            -0.246
                          ],
                          [
                            -0.197,
                            -0.207
                          ],
                          [
                            -0.399,
                            0
                          ],
                          [
                            -0.179,
                            0.207
                          ],
                          [
                            0,
                            0.312
                          ],
                          [
                            0.231,
                            0.176
                          ],
                          [
                            0.366,
                            0
                          ]
                        ],
                        "v": [
                          [
                            0.85,
                            -0.929
                          ],
                          [
                            1.159,
                            -1.663
                          ],
                          [
                            0.864,
                            -2.343
                          ],
                          [
                            -0.035,
                            -2.653
                          ],
                          [
                            -0.901,
                            -2.343
                          ],
                          [
                            -1.169,
                            -1.616
                          ],
                          [
                            -0.823,
                            -0.885
                          ],
                          [
                            -0.007,
                            -0.621
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.254,
                            0.208
                          ],
                          [
                            0,
                            0.413
                          ],
                          [
                            0.261,
                            0.222
                          ],
                          [
                            0.409,
                            0
                          ],
                          [
                            0.251,
                            -0.226
                          ],
                          [
                            0,
                            -0.4
                          ],
                          [
                            -0.23,
                            -0.251
                          ],
                          [
                            -0.48,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.254,
                            -0.208
                          ],
                          [
                            0,
                            -0.427
                          ],
                          [
                            -0.262,
                            -0.221
                          ],
                          [
                            -0.397,
                            0
                          ],
                          [
                            -0.251,
                            0.226
                          ],
                          [
                            0,
                            0.344
                          ],
                          [
                            0.229,
                            0.251
                          ],
                          [
                            0.385,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.004,
                            2.341
                          ],
                          [
                            1.385,
                            1.41
                          ],
                          [
                            0.993,
                            0.436
                          ],
                          [
                            -0.014,
                            0.104
                          ],
                          [
                            -0.986,
                            0.443
                          ],
                          [
                            -1.362,
                            1.383
                          ],
                          [
                            -1.018,
                            2.276
                          ],
                          [
                            0.046,
                            2.653
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.129,
                            0.133
                          ],
                          [
                            0,
                            0.394
                          ],
                          [
                            -0.357,
                            0.354
                          ],
                          [
                            -0.654,
                            0
                          ],
                          [
                            -0.36,
                            -0.334
                          ],
                          [
                            0,
                            -0.446
                          ],
                          [
                            0.209,
                            -0.255
                          ],
                          [
                            0.246,
                            -0.138
                          ],
                          [
                            -0.158,
                            -0.163
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.392,
                            -0.404
                          ],
                          [
                            0.714,
                            0
                          ],
                          [
                            0.445,
                            0.35
                          ],
                          [
                            0,
                            0.665
                          ],
                          [
                            -0.19,
                            0.284
                          ],
                          [
                            -0.375,
                            0.151
                          ]
                        ],
                        "o": [
                          [
                            -0.244,
                            -0.246
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.357,
                            -0.354
                          ],
                          [
                            0.634,
                            0
                          ],
                          [
                            0.36,
                            0.334
                          ],
                          [
                            0,
                            0.413
                          ],
                          [
                            -0.117,
                            0.145
                          ],
                          [
                            0.275,
                            0.126
                          ],
                          [
                            0.293,
                            0.308
                          ],
                          [
                            0,
                            0.582
                          ],
                          [
                            -0.391,
                            0.405
                          ],
                          [
                            -0.644,
                            0
                          ],
                          [
                            -0.444,
                            -0.349
                          ],
                          [
                            0,
                            -0.391
                          ],
                          [
                            0.191,
                            -0.285
                          ],
                          [
                            -0.231,
                            -0.098
                          ]
                        ],
                        "v": [
                          [
                            -1.676,
                            -0.649
                          ],
                          [
                            -2.042,
                            -1.61
                          ],
                          [
                            -1.506,
                            -2.879
                          ],
                          [
                            0.011,
                            -3.41
                          ],
                          [
                            1.501,
                            -2.909
                          ],
                          [
                            2.04,
                            -1.739
                          ],
                          [
                            1.727,
                            -0.737
                          ],
                          [
                            1.182,
                            -0.312
                          ],
                          [
                            1.831,
                            0.122
                          ],
                          [
                            2.272,
                            1.322
                          ],
                          [
                            1.685,
                            2.802
                          ],
                          [
                            0.028,
                            3.41
                          ],
                          [
                            -1.605,
                            2.885
                          ],
                          [
                            -2.272,
                            1.364
                          ],
                          [
                            -1.986,
                            0.351
                          ],
                          [
                            -1.136,
                            -0.303
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.208000004292,
                        0.564999997616,
                        0.518000006676,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        212.733,
                        85.202
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 3",
                "np": 7,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.256,
                            0.382
                          ],
                          [
                            0,
                            1.04
                          ],
                          [
                            0.185,
                            0.485
                          ],
                          [
                            0.534,
                            0
                          ],
                          [
                            0.227,
                            -0.46
                          ],
                          [
                            0,
                            -0.896
                          ],
                          [
                            -0.145,
                            -0.409
                          ],
                          [
                            -0.537,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.256,
                            -0.381
                          ],
                          [
                            0,
                            -0.751
                          ],
                          [
                            -0.185,
                            -0.485
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.226,
                            0.46
                          ],
                          [
                            0,
                            0.674
                          ],
                          [
                            0.222,
                            0.625
                          ],
                          [
                            0.431,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.002,
                            2.066
                          ],
                          [
                            1.385,
                            -0.067
                          ],
                          [
                            1.107,
                            -1.921
                          ],
                          [
                            0.029,
                            -2.648
                          ],
                          [
                            -1.046,
                            -1.958
                          ],
                          [
                            -1.386,
                            0.076
                          ],
                          [
                            -1.167,
                            1.701
                          ],
                          [
                            -0.029,
                            2.639
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.382,
                            -0.705
                          ],
                          [
                            0,
                            -0.948
                          ],
                          [
                            0.268,
                            -0.588
                          ],
                          [
                            0.879,
                            0
                          ],
                          [
                            0.388,
                            0.689
                          ],
                          [
                            0,
                            0.969
                          ],
                          [
                            -0.194,
                            0.539
                          ],
                          [
                            -0.951,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.296,
                            0.545
                          ],
                          [
                            0,
                            0.899
                          ],
                          [
                            -0.388,
                            0.843
                          ],
                          [
                            -0.795,
                            0
                          ],
                          [
                            -0.323,
                            -0.576
                          ],
                          [
                            0,
                            -0.751
                          ],
                          [
                            0.363,
                            -1.003
                          ],
                          [
                            0.857,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.838,
                            -2.339
                          ],
                          [
                            2.281,
                            -0.1
                          ],
                          [
                            1.88,
                            2.131
                          ],
                          [
                            -0.023,
                            3.396
                          ],
                          [
                            -1.796,
                            2.362
                          ],
                          [
                            -2.281,
                            0.044
                          ],
                          [
                            -1.99,
                            -1.891
                          ],
                          [
                            -0.02,
                            -3.396
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        207.473,
                        85.206
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 4",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            1.434
                          ],
                          [
                            0.483,
                            1.434
                          ],
                          [
                            0.483,
                            2.44
                          ],
                          [
                            -0.483,
                            2.44
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            -2.44
                          ],
                          [
                            0.483,
                            -2.44
                          ],
                          [
                            0.483,
                            -1.434
                          ],
                          [
                            -0.483,
                            -1.434
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        203.801,
                        85.982
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 5",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.204,
                            0.422
                          ],
                          [
                            -0.594,
                            0.345
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.164
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.231,
                            0.226
                          ],
                          [
                            0.385,
                            0
                          ],
                          [
                            0.218,
                            -0.432
                          ],
                          [
                            0.013,
                            -0.41
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.203,
                            0.363
                          ],
                          [
                            -0.911,
                            0
                          ],
                          [
                            -0.349,
                            -0.41
                          ],
                          [
                            0,
                            -0.502
                          ],
                          [
                            0.372,
                            -0.376
                          ],
                          [
                            0.557,
                            -0.311
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.172,
                            -0.151
                          ],
                          [
                            0.08,
                            -0.327
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.205,
                            -0.422
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.397,
                            -0.231
                          ],
                          [
                            0.252,
                            -0.256
                          ],
                          [
                            0,
                            -0.386
                          ],
                          [
                            -0.23,
                            -0.227
                          ],
                          [
                            -0.569,
                            0
                          ],
                          [
                            -0.118,
                            0.232
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.009,
                            -0.575
                          ],
                          [
                            0.36,
                            -0.64
                          ],
                          [
                            0.758,
                            0
                          ],
                          [
                            0.35,
                            0.409
                          ],
                          [
                            0,
                            0.529
                          ],
                          [
                            -0.216,
                            0.219
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.302,
                            0.166
                          ],
                          [
                            -0.307,
                            0.268
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.031,
                            -0.57
                          ]
                        ],
                        "v": [
                          [
                            -1.933,
                            1.83
                          ],
                          [
                            -0.735,
                            0.68
                          ],
                          [
                            0.152,
                            0.168
                          ],
                          [
                            0.988,
                            -0.424
                          ],
                          [
                            1.367,
                            -1.303
                          ],
                          [
                            1.02,
                            -2.221
                          ],
                          [
                            0.096,
                            -2.561
                          ],
                          [
                            -1.085,
                            -1.913
                          ],
                          [
                            -1.28,
                            -0.95
                          ],
                          [
                            -2.124,
                            -0.95
                          ],
                          [
                            -1.806,
                            -2.358
                          ],
                          [
                            0.101,
                            -3.318
                          ],
                          [
                            1.761,
                            -2.704
                          ],
                          [
                            2.286,
                            -1.337
                          ],
                          [
                            1.727,
                            0.02
                          ],
                          [
                            0.568,
                            0.814
                          ],
                          [
                            -0.065,
                            1.165
                          ],
                          [
                            -0.776,
                            1.641
                          ],
                          [
                            -1.358,
                            2.533
                          ],
                          [
                            2.254,
                            2.533
                          ],
                          [
                            2.254,
                            3.318
                          ],
                          [
                            -2.286,
                            3.318
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        199.592,
                        85.105
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 6",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.237,
                            0.138
                          ],
                          [
                            -0.117,
                            0.51
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.6,
                            -0.059
                          ],
                          [
                            0.237,
                            -0.136
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.221,
                            -1.39
                          ],
                          [
                            -1.221,
                            -2.027
                          ],
                          [
                            0.035,
                            -2.321
                          ],
                          [
                            0.566,
                            -3.292
                          ],
                          [
                            1.221,
                            -3.292
                          ],
                          [
                            1.221,
                            3.292
                          ],
                          [
                            0.335,
                            3.292
                          ],
                          [
                            0.335,
                            -1.39
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.20800000359,
                        0.564999988032,
                        0.517999985639,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        193.877,
                        85.13
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 7",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            9.15,
                            2.815
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.315,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.314
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.314
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -9.15,
                            -2.815
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.314
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.314
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.315,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            121.092,
                            36.453
                          ],
                          [
                            111.658,
                            23.501
                          ],
                          [
                            111.658,
                            -41.34
                          ],
                          [
                            105.658,
                            -47.34
                          ],
                          [
                            -124.241,
                            -47.34
                          ],
                          [
                            -130.241,
                            -41.34
                          ],
                          [
                            -130.241,
                            41.34
                          ],
                          [
                            -124.241,
                            47.34
                          ],
                          [
                            105.658,
                            47.34
                          ],
                          [
                            111.658,
                            41.34
                          ],
                          [
                            111.658,
                            41.38
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.33300000359,
                        0.282000014361,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        130.491,
                        47.59
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 8",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 7,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": 289,
            "op": 901,
            "st": 110,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 20,
            "ty": 5,
            "nm": "Merhaba",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 887,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 900,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 279,
                    "s": [
                      300.5,
                      336.5,
                      0
                    ],
                    "to": [
                      32.667,
                      -2.75,
                      0
                    ],
                    "ti": [
                      -32.667,
                      2.75,
                      0
                    ]
                  },
                  {
                    "t": 291,
                    "s": [
                      496.5,
                      320,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 279,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  },
                  {
                    "t": 291,
                    "s": [
                      71,
                      71,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "t": {
              "d": {
                "k": [
                  {
                    "s": {
                      "sz": [
                        339,
                        35
                      ],
                      "ps": [
                        -169.5,
                        -14.5
                      ],
                      "s": 16,
                      "f": "Helvetica",
                      "t": "Merhaba",
                      "ca": 0,
                      "j": 0,
                      "tr": 0,
                      "lh": 19.2,
                      "ls": 0,
                      "fc": [
                        1,
                        1,
                        1
                      ]
                    },
                    "t": 0
                  }
                ]
              },
              "p": {
                
              },
              "m": {
                "g": 1,
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 2
                }
              },
              "a": [
                {
                  "nm": "Animador 1",
                  "s": {
                    "t": 0,
                    "xe": {
                      "a": 0,
                      "k": 0,
                      "ix": 7
                    },
                    "ne": {
                      "a": 0,
                      "k": 0,
                      "ix": 8
                    },
                    "a": {
                      "a": 0,
                      "k": 100,
                      "ix": 4
                    },
                    "b": 1,
                    "rn": 0,
                    "sh": 1,
                    "s": {
                      "a": 1,
                      "k": [
                        {
                          "i": {
                            "x": [
                              0.833
                            ],
                            "y": [
                              0.833
                            ]
                          },
                          "o": {
                            "x": [
                              0.167
                            ],
                            "y": [
                              0.167
                            ]
                          },
                          "t": 181,
                          "s": [
                            0
                          ]
                        },
                        {
                          "t": 230,
                          "s": [
                            100
                          ]
                        }
                      ],
                      "ix": 1
                    },
                    "r": 1
                  },
                  "a": {
                    "o": {
                      "a": 0,
                      "k": 0,
                      "ix": 9
                    }
                  }
                }
              ]
            },
            "ip": 170,
            "op": 901,
            "st": 110,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 21,
            "ty": 4,
            "nm": "Talk 01/conversas_whatsapp contornos",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 887,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 900,
                    "s": [
                      0
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 279,
                    "s": [
                      286.5,
                      338,
                      0
                    ],
                    "to": [
                      31.667,
                      -3,
                      0
                    ],
                    "ti": [
                      -31.667,
                      3,
                      0
                    ]
                  },
                  {
                    "t": 291,
                    "s": [
                      476.5,
                      320,
                      0
                    ]
                  }
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  130,
                  19,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 170,
                    "s": [
                      0,
                      0,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 176,
                    "s": [
                      180,
                      180,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 181,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0.167
                      ]
                    },
                    "t": 279,
                    "s": [
                      150,
                      150,
                      100
                    ]
                  },
                  {
                    "t": 291,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.206,
                            0.205
                          ],
                          [
                            0,
                            0.284
                          ],
                          [
                            0.196,
                            0.207
                          ],
                          [
                            0.403,
                            0
                          ],
                          [
                            0.178,
                            -0.207
                          ],
                          [
                            0,
                            -0.278
                          ],
                          [
                            -0.23,
                            -0.176
                          ],
                          [
                            -0.314,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.206,
                            -0.205
                          ],
                          [
                            0,
                            -0.246
                          ],
                          [
                            -0.197,
                            -0.207
                          ],
                          [
                            -0.399,
                            0
                          ],
                          [
                            -0.179,
                            0.207
                          ],
                          [
                            0,
                            0.312
                          ],
                          [
                            0.231,
                            0.176
                          ],
                          [
                            0.366,
                            0
                          ]
                        ],
                        "v": [
                          [
                            0.85,
                            -0.929
                          ],
                          [
                            1.159,
                            -1.663
                          ],
                          [
                            0.864,
                            -2.343
                          ],
                          [
                            -0.035,
                            -2.653
                          ],
                          [
                            -0.901,
                            -2.343
                          ],
                          [
                            -1.169,
                            -1.616
                          ],
                          [
                            -0.823,
                            -0.885
                          ],
                          [
                            -0.007,
                            -0.621
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.254,
                            0.208
                          ],
                          [
                            0,
                            0.413
                          ],
                          [
                            0.261,
                            0.222
                          ],
                          [
                            0.409,
                            0
                          ],
                          [
                            0.251,
                            -0.226
                          ],
                          [
                            0,
                            -0.4
                          ],
                          [
                            -0.23,
                            -0.251
                          ],
                          [
                            -0.48,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.254,
                            -0.208
                          ],
                          [
                            0,
                            -0.427
                          ],
                          [
                            -0.262,
                            -0.221
                          ],
                          [
                            -0.397,
                            0
                          ],
                          [
                            -0.251,
                            0.226
                          ],
                          [
                            0,
                            0.344
                          ],
                          [
                            0.229,
                            0.251
                          ],
                          [
                            0.385,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.004,
                            2.341
                          ],
                          [
                            1.385,
                            1.41
                          ],
                          [
                            0.993,
                            0.436
                          ],
                          [
                            -0.014,
                            0.104
                          ],
                          [
                            -0.986,
                            0.443
                          ],
                          [
                            -1.362,
                            1.383
                          ],
                          [
                            -1.018,
                            2.276
                          ],
                          [
                            0.046,
                            2.653
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.129,
                            0.133
                          ],
                          [
                            0,
                            0.394
                          ],
                          [
                            -0.357,
                            0.354
                          ],
                          [
                            -0.654,
                            0
                          ],
                          [
                            -0.36,
                            -0.334
                          ],
                          [
                            0,
                            -0.446
                          ],
                          [
                            0.209,
                            -0.255
                          ],
                          [
                            0.246,
                            -0.138
                          ],
                          [
                            -0.158,
                            -0.163
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.392,
                            -0.404
                          ],
                          [
                            0.714,
                            0
                          ],
                          [
                            0.445,
                            0.35
                          ],
                          [
                            0,
                            0.665
                          ],
                          [
                            -0.19,
                            0.284
                          ],
                          [
                            -0.375,
                            0.151
                          ]
                        ],
                        "o": [
                          [
                            -0.244,
                            -0.246
                          ],
                          [
                            0,
                            -0.492
                          ],
                          [
                            0.357,
                            -0.354
                          ],
                          [
                            0.634,
                            0
                          ],
                          [
                            0.36,
                            0.334
                          ],
                          [
                            0,
                            0.413
                          ],
                          [
                            -0.117,
                            0.145
                          ],
                          [
                            0.275,
                            0.126
                          ],
                          [
                            0.293,
                            0.308
                          ],
                          [
                            0,
                            0.582
                          ],
                          [
                            -0.391,
                            0.405
                          ],
                          [
                            -0.644,
                            0
                          ],
                          [
                            -0.444,
                            -0.349
                          ],
                          [
                            0,
                            -0.391
                          ],
                          [
                            0.191,
                            -0.285
                          ],
                          [
                            -0.231,
                            -0.098
                          ]
                        ],
                        "v": [
                          [
                            -1.676,
                            -0.649
                          ],
                          [
                            -2.042,
                            -1.61
                          ],
                          [
                            -1.506,
                            -2.879
                          ],
                          [
                            0.011,
                            -3.41
                          ],
                          [
                            1.501,
                            -2.909
                          ],
                          [
                            2.04,
                            -1.739
                          ],
                          [
                            1.727,
                            -0.737
                          ],
                          [
                            1.182,
                            -0.312
                          ],
                          [
                            1.831,
                            0.122
                          ],
                          [
                            2.272,
                            1.322
                          ],
                          [
                            1.685,
                            2.802
                          ],
                          [
                            0.028,
                            3.41
                          ],
                          [
                            -1.605,
                            2.885
                          ],
                          [
                            -2.272,
                            1.364
                          ],
                          [
                            -1.986,
                            0.351
                          ],
                          [
                            -1.136,
                            -0.303
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        249.954,
                        29.622
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 7,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.256,
                            0.382
                          ],
                          [
                            0,
                            1.04
                          ],
                          [
                            0.185,
                            0.485
                          ],
                          [
                            0.534,
                            0
                          ],
                          [
                            0.227,
                            -0.46
                          ],
                          [
                            0,
                            -0.896
                          ],
                          [
                            -0.145,
                            -0.409
                          ],
                          [
                            -0.537,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.256,
                            -0.381
                          ],
                          [
                            0,
                            -0.751
                          ],
                          [
                            -0.185,
                            -0.485
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.226,
                            0.46
                          ],
                          [
                            0,
                            0.674
                          ],
                          [
                            0.222,
                            0.625
                          ],
                          [
                            0.431,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.002,
                            2.066
                          ],
                          [
                            1.385,
                            -0.067
                          ],
                          [
                            1.107,
                            -1.921
                          ],
                          [
                            0.029,
                            -2.648
                          ],
                          [
                            -1.046,
                            -1.958
                          ],
                          [
                            -1.386,
                            0.076
                          ],
                          [
                            -1.167,
                            1.701
                          ],
                          [
                            -0.029,
                            2.639
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.382,
                            -0.705
                          ],
                          [
                            0,
                            -0.948
                          ],
                          [
                            0.268,
                            -0.588
                          ],
                          [
                            0.879,
                            0
                          ],
                          [
                            0.388,
                            0.689
                          ],
                          [
                            0,
                            0.969
                          ],
                          [
                            -0.194,
                            0.539
                          ],
                          [
                            -0.951,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.296,
                            0.545
                          ],
                          [
                            0,
                            0.899
                          ],
                          [
                            -0.388,
                            0.843
                          ],
                          [
                            -0.795,
                            0
                          ],
                          [
                            -0.323,
                            -0.576
                          ],
                          [
                            0,
                            -0.751
                          ],
                          [
                            0.363,
                            -1.003
                          ],
                          [
                            0.857,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.838,
                            -2.339
                          ],
                          [
                            2.281,
                            -0.1
                          ],
                          [
                            1.88,
                            2.131
                          ],
                          [
                            -0.023,
                            3.396
                          ],
                          [
                            -1.796,
                            2.362
                          ],
                          [
                            -2.281,
                            0.044
                          ],
                          [
                            -1.99,
                            -1.891
                          ],
                          [
                            -0.02,
                            -3.396
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        244.694,
                        29.627
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 2",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            1.434
                          ],
                          [
                            0.483,
                            1.434
                          ],
                          [
                            0.483,
                            2.441
                          ],
                          [
                            -0.483,
                            2.441
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.483,
                            -2.441
                          ],
                          [
                            0.483,
                            -2.441
                          ],
                          [
                            0.483,
                            -1.434
                          ],
                          [
                            -0.483,
                            -1.434
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        241.021,
                        30.402
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 3",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.204,
                            0.422
                          ],
                          [
                            -0.594,
                            0.345
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.164
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.231,
                            0.226
                          ],
                          [
                            0.385,
                            0
                          ],
                          [
                            0.218,
                            -0.432
                          ],
                          [
                            0.013,
                            -0.41
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.203,
                            0.363
                          ],
                          [
                            -0.911,
                            0
                          ],
                          [
                            -0.349,
                            -0.41
                          ],
                          [
                            0,
                            -0.502
                          ],
                          [
                            0.372,
                            -0.376
                          ],
                          [
                            0.557,
                            -0.311
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.172,
                            -0.151
                          ],
                          [
                            0.08,
                            -0.327
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.205,
                            -0.422
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.397,
                            -0.231
                          ],
                          [
                            0.252,
                            -0.256
                          ],
                          [
                            0,
                            -0.386
                          ],
                          [
                            -0.23,
                            -0.227
                          ],
                          [
                            -0.569,
                            0
                          ],
                          [
                            -0.118,
                            0.232
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.009,
                            -0.575
                          ],
                          [
                            0.36,
                            -0.64
                          ],
                          [
                            0.758,
                            0
                          ],
                          [
                            0.35,
                            0.409
                          ],
                          [
                            0,
                            0.529
                          ],
                          [
                            -0.216,
                            0.219
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.302,
                            0.166
                          ],
                          [
                            -0.307,
                            0.268
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.031,
                            -0.57
                          ]
                        ],
                        "v": [
                          [
                            -1.933,
                            1.83
                          ],
                          [
                            -0.735,
                            0.68
                          ],
                          [
                            0.152,
                            0.168
                          ],
                          [
                            0.988,
                            -0.424
                          ],
                          [
                            1.367,
                            -1.303
                          ],
                          [
                            1.02,
                            -2.221
                          ],
                          [
                            0.096,
                            -2.561
                          ],
                          [
                            -1.085,
                            -1.913
                          ],
                          [
                            -1.28,
                            -0.95
                          ],
                          [
                            -2.124,
                            -0.95
                          ],
                          [
                            -1.806,
                            -2.358
                          ],
                          [
                            0.101,
                            -3.318
                          ],
                          [
                            1.761,
                            -2.704
                          ],
                          [
                            2.286,
                            -1.337
                          ],
                          [
                            1.727,
                            0.02
                          ],
                          [
                            0.568,
                            0.814
                          ],
                          [
                            -0.065,
                            1.165
                          ],
                          [
                            -0.776,
                            1.641
                          ],
                          [
                            -1.358,
                            2.533
                          ],
                          [
                            2.254,
                            2.533
                          ],
                          [
                            2.254,
                            3.318
                          ],
                          [
                            -2.286,
                            3.318
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        236.813,
                        29.526
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 4",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.237,
                            0.138
                          ],
                          [
                            -0.117,
                            0.51
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.6,
                            -0.059
                          ],
                          [
                            0.237,
                            -0.136
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.221,
                            -1.39
                          ],
                          [
                            -1.221,
                            -2.027
                          ],
                          [
                            0.035,
                            -2.321
                          ],
                          [
                            0.566,
                            -3.292
                          ],
                          [
                            1.221,
                            -3.292
                          ],
                          [
                            1.221,
                            3.292
                          ],
                          [
                            0.335,
                            3.292
                          ],
                          [
                            0.335,
                            -1.39
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.416000007181,
                        0.416000007181,
                        0.423999980852,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        231.098,
                        29.551
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 5",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.314
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            6.271,
                            -1.929
                          ],
                          [
                            -2.298,
                            -0.28
                          ],
                          [
                            -3.042,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            3.314
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.705,
                            3.188
                          ],
                          [
                            -8.478,
                            2.609
                          ],
                          [
                            0.392,
                            2.935
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.314,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.314
                          ]
                        ],
                        "v": [
                          [
                            123.73,
                            -18.513
                          ],
                          [
                            -106.17,
                            -18.513
                          ],
                          [
                            -112.17,
                            -12.513
                          ],
                          [
                            -112.17,
                            -2.063
                          ],
                          [
                            -121.251,
                            8.421
                          ],
                          [
                            -112.111,
                            13.313
                          ],
                          [
                            -106.17,
                            18.513
                          ],
                          [
                            123.73,
                            18.513
                          ],
                          [
                            129.729,
                            12.513
                          ],
                          [
                            129.729,
                            -12.513
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.238999998803,
                        0.234999997008,
                        0.246999987434,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        129.979,
                        18.763
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 6",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": 170,
            "op": 900,
            "st": 83,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 22,
            "ty": 0,
            "nm": "01",
            "refId": "comp_2",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 887,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 900,
                    "s": [
                      100
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  500,
                  500,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  175,
                  354.5,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.667,
                        0.667,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 0,
                    "s": [
                      0,
                      0,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0,
                        0,
                        0.667
                      ],
                      "y": [
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.333,
                        0.333,
                        0.333
                      ],
                      "y": [
                        0,
                        0,
                        0
                      ]
                    },
                    "t": 9,
                    "s": [
                      135,
                      135,
                      100
                    ]
                  },
                  {
                    "t": 15,
                    "s": [
                      100,
                      100,
                      100
                    ]
                  }
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "w": 350,
            "h": 709,
            "ip": 0,
            "op": 901,
            "st": 0,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 23,
            "ty": 4,
            "nm": "Union contornos",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 34,
                    "s": [
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 45,
                    "s": [
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 887,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 900,
                    "s": [
                      10
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  500,
                  500,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  250,
                  269.5,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  150.464,
                  150.464,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            2.595,
                            -0.078
                          ],
                          [
                            1.483,
                            -1.952
                          ]
                        ],
                        "o": [
                          [
                            -2.522,
                            0.829
                          ],
                          [
                            -0.791,
                            2.265
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -15.216,
                            120.339
                          ],
                          [
                            -22.931,
                            121.692
                          ],
                          [
                            -26.35,
                            128.063
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            3.191,
                            -0.095
                          ],
                          [
                            1.824,
                            -2.4
                          ]
                        ],
                        "o": [
                          [
                            -3.101,
                            1.02
                          ],
                          [
                            -0.972,
                            2.787
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            6.112,
                            -77.048
                          ],
                          [
                            -3.376,
                            -75.384
                          ],
                          [
                            -7.581,
                            -67.548
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -5.276,
                            -7.606
                          ],
                          [
                            -1.594,
                            -1.109
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -10.608,
                            -15.291
                          ],
                          [
                            -6.491,
                            -2.263
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -8.967,
                            -12.925
                          ],
                          [
                            -12.926,
                            8.968
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.134,
                            -4.519
                          ],
                          [
                            -6.306,
                            4.374
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.298,
                            -0.428
                          ],
                          [
                            -3.665,
                            0.654
                          ],
                          [
                            -3.205,
                            -4.621
                          ],
                          [
                            -1.821,
                            -1.667
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -8.625,
                            -12.433
                          ],
                          [
                            -5.278,
                            -1.84
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -7.291,
                            -10.51
                          ],
                          [
                            -10.511,
                            7.291
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.549,
                            -3.673
                          ],
                          [
                            -5.127,
                            3.557
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -4.866,
                            -7.013
                          ],
                          [
                            -12.433,
                            8.625
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -5.701,
                            -0.523
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -4.29,
                            -6.185
                          ],
                          [
                            -6.184,
                            4.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            4.29,
                            6.183
                          ],
                          [
                            1.527,
                            0.952
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            11.115,
                            16.022
                          ],
                          [
                            16.022,
                            -11.115
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            3.557,
                            5.129
                          ],
                          [
                            4.141,
                            -0.644
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            8.625,
                            12.433
                          ],
                          [
                            2.452,
                            1.77
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            13.67,
                            19.705
                          ],
                          [
                            19.701,
                            -13.625
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            4.375,
                            6.306
                          ],
                          [
                            5.093,
                            -0.792
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            10.608,
                            15.291
                          ],
                          [
                            15.291,
                            -10.608
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.856,
                            2.675
                          ],
                          [
                            15.292,
                            -10.608
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.172,
                            1.689
                          ],
                          [
                            7.605,
                            -5.276
                          ]
                        ],
                        "o": [
                          [
                            -7.606,
                            5.276
                          ],
                          [
                            1.172,
                            1.689
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -15.292,
                            10.608
                          ],
                          [
                            4.218,
                            6.081
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -12.927,
                            8.968
                          ],
                          [
                            8.968,
                            12.927
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.525,
                            4.493
                          ],
                          [
                            4.375,
                            6.306
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.221,
                            0.455
                          ],
                          [
                            2.26,
                            3.259
                          ],
                          [
                            0.655,
                            5.218
                          ],
                          [
                            1.467,
                            2.113
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -12.433,
                            8.625
                          ],
                          [
                            3.43,
                            4.943
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -10.511,
                            7.291
                          ],
                          [
                            7.292,
                            10.51
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.054,
                            3.653
                          ],
                          [
                            3.557,
                            5.127
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.163,
                            7.616
                          ],
                          [
                            8.625,
                            12.433
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            4.869,
                            3.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -6.183,
                            4.29
                          ],
                          [
                            4.29,
                            6.183
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            6.183,
                            -4.29
                          ],
                          [
                            -1.091,
                            -1.573
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            16.022,
                            -11.114
                          ],
                          [
                            -11.114,
                            -16.022
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            5.127,
                            -3.556
                          ],
                          [
                            -2.549,
                            -3.674
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            12.433,
                            -8.626
                          ],
                          [
                            -1.822,
                            -2.625
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            19.705,
                            -13.67
                          ],
                          [
                            -13.659,
                            -19.688
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            6.306,
                            -4.375
                          ],
                          [
                            -3.135,
                            -4.52
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            15.292,
                            -10.608
                          ],
                          [
                            -10.609,
                            -15.291
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.989,
                            -2.938
                          ],
                          [
                            -10.608,
                            -15.291
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.481,
                            -1.882
                          ],
                          [
                            -5.277,
                            -7.606
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -126.156,
                            -145.564
                          ],
                          [
                            -130.374,
                            -122.24
                          ],
                          [
                            -126.181,
                            -118.034
                          ],
                          [
                            -204.019,
                            -64.035
                          ],
                          [
                            -212.499,
                            -17.141
                          ],
                          [
                            -195.93,
                            -4.535
                          ],
                          [
                            -237.748,
                            24.475
                          ],
                          [
                            -244.917,
                            64.118
                          ],
                          [
                            -205.274,
                            71.287
                          ],
                          [
                            -185.138,
                            57.318
                          ],
                          [
                            -184.445,
                            72.058
                          ],
                          [
                            -165.106,
                            75.555
                          ],
                          [
                            -159.166,
                            71.434
                          ],
                          [
                            -158.389,
                            72.761
                          ],
                          [
                            -148.584,
                            76.834
                          ],
                          [
                            -142.834,
                            91.815
                          ],
                          [
                            -137.881,
                            97.49
                          ],
                          [
                            -186.069,
                            130.919
                          ],
                          [
                            -192.964,
                            169.048
                          ],
                          [
                            -179.492,
                            179.297
                          ],
                          [
                            -213.493,
                            202.885
                          ],
                          [
                            -219.322,
                            235.118
                          ],
                          [
                            -187.089,
                            240.946
                          ],
                          [
                            -170.717,
                            229.589
                          ],
                          [
                            -170.153,
                            241.573
                          ],
                          [
                            -154.43,
                            244.416
                          ],
                          [
                            -140.161,
                            234.518
                          ],
                          [
                            -136.32,
                            257.636
                          ],
                          [
                            -98.191,
                            264.531
                          ],
                          [
                            -36.89,
                            222.005
                          ],
                          [
                            -20.767,
                            227.607
                          ],
                          [
                            -39.855,
                            240.848
                          ],
                          [
                            -43.284,
                            259.813
                          ],
                          [
                            -24.32,
                            263.241
                          ],
                          [
                            78.272,
                            192.071
                          ],
                          [
                            81.701,
                            173.108
                          ],
                          [
                            77.721,
                            169.311
                          ],
                          [
                            167.8,
                            106.82
                          ],
                          [
                            176.685,
                            57.685
                          ],
                          [
                            127.55,
                            48.8
                          ],
                          [
                            144.028,
                            37.369
                          ],
                          [
                            146.871,
                            21.645
                          ],
                          [
                            135.843,
                            16.92
                          ],
                          [
                            140.379,
                            13.775
                          ],
                          [
                            147.274,
                            -24.356
                          ],
                          [
                            140.802,
                            -30.96
                          ],
                          [
                            231.204,
                            -93.674
                          ],
                          [
                            242.132,
                            -154.105
                          ],
                          [
                            181.753,
                            -165.07
                          ],
                          [
                            201.966,
                            -179.092
                          ],
                          [
                            205.463,
                            -198.43
                          ],
                          [
                            191.9,
                            -204.242
                          ],
                          [
                            197.477,
                            -208.112
                          ],
                          [
                            205.958,
                            -255.007
                          ],
                          [
                            159.064,
                            -263.487
                          ],
                          [
                            127.434,
                            -241.545
                          ],
                          [
                            123.175,
                            -250.006
                          ],
                          [
                            76.28,
                            -258.486
                          ],
                          [
                            64.886,
                            -250.581
                          ],
                          [
                            62.415,
                            -255.982
                          ],
                          [
                            39.091,
                            -260.2
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 3,
                    "ty": "sh",
                    "ix": 4,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            3.803,
                            5.483
                          ],
                          [
                            -5.483,
                            3.804
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -3.803,
                            -5.483
                          ],
                          [
                            5.483,
                            -3.804
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -3.803,
                            -5.483
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            5.483,
                            -3.804
                          ],
                          [
                            3.804,
                            5.483
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -5.483,
                            3.803
                          ]
                        ],
                        "v": [
                          [
                            -169.976,
                            -135.563
                          ],
                          [
                            -166.935,
                            -152.378
                          ],
                          [
                            -59.332,
                            -227.024
                          ],
                          [
                            -42.518,
                            -223.984
                          ],
                          [
                            -45.558,
                            -207.169
                          ],
                          [
                            -153.161,
                            -132.522
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 4",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.925,
                        0.972999961703,
                        0.976000019148,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        250,
                        269.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 8,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": 34,
            "op": 901,
            "st": 0,
            "bm": 0
          }
        ]
      },
      {
        "id": "comp_1",
        "layers": [
          {
            "ddd": 0,
            "ind": 1,
            "ty": 2,
            "nm": "Lorem Ipsum",
            "refId": "image_2",
            "sr": 1,
            "ks": {
              "o": {
                "a": 0,
                "k": 100,
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  72,
                  66,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  72,
                  66,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "ip": 0,
            "op": 796,
            "st": 0,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 2,
            "ty": 2,
            "nm": "KZ",
            "refId": "image_3",
            "sr": 1,
            "ks": {
              "o": {
                "a": 0,
                "k": 100,
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  72,
                  66,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  72,
                  66,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "ip": 0,
            "op": 796,
            "st": 0,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 3,
            "ty": 2,
            "nm": "Layer 1",
            "refId": "image_4",
            "sr": 1,
            "ks": {
              "o": {
                "a": 0,
                "k": 100,
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  72,
                  66,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  72,
                  66,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "ip": 0,
            "op": 796,
            "st": 0,
            "bm": 0
          }
        ]
      },
      {
        "id": "comp_2",
        "layers": [
          {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "IOS/conversas_whatsapp contornos",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 113,
                    "s": [
                      0
                    ]
                  },
                  {
                    "t": 133,
                    "s": [
                      100
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  173,
                  343.5,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  151,
                  255,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.248,
                            0.293
                          ],
                          [
                            0,
                            0.462
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.299,
                            0.248
                          ],
                          [
                            0,
                            0.451
                          ],
                          [
                            -0.287,
                            0.254
                          ],
                          [
                            -0.473,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.248,
                            0.293
                          ],
                          [
                            -0.451,
                            0
                          ],
                          [
                            -0.26,
                            -0.282
                          ],
                          [
                            0,
                            -0.485
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.282,
                            -0.253
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.293,
                            -0.248
                          ],
                          [
                            0.474,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.259,
                            -0.287
                          ],
                          [
                            0.44,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.248,
                            -0.294
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.45,
                            0
                          ],
                          [
                            -0.299,
                            -0.248
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.287,
                            -0.253
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.463
                          ],
                          [
                            0.248,
                            -0.294
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.259,
                            0.282
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.496,
                            0
                          ],
                          [
                            0.282,
                            0.254
                          ],
                          [
                            0,
                            0.451
                          ],
                          [
                            -0.293,
                            0.248
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.473
                          ],
                          [
                            -0.26,
                            0.288
                          ],
                          [
                            -0.451,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.057,
                            6.857
                          ],
                          [
                            -1.428,
                            5.724
                          ],
                          [
                            -1.428,
                            1.564
                          ],
                          [
                            -5.859,
                            1.564
                          ],
                          [
                            -6.982,
                            1.193
                          ],
                          [
                            -7.43,
                            0.143
                          ],
                          [
                            -6.999,
                            -0.914
                          ],
                          [
                            -5.859,
                            -1.293
                          ],
                          [
                            -1.428,
                            -1.293
                          ],
                          [
                            -1.428,
                            -5.723
                          ],
                          [
                            -1.057,
                            -6.855
                          ],
                          [
                            -0.008,
                            -7.296
                          ],
                          [
                            1.04,
                            -6.872
                          ],
                          [
                            1.428,
                            -5.723
                          ],
                          [
                            1.428,
                            -1.293
                          ],
                          [
                            5.842,
                            -1.293
                          ],
                          [
                            7.008,
                            -0.914
                          ],
                          [
                            7.43,
                            0.143
                          ],
                          [
                            6.992,
                            1.193
                          ],
                          [
                            5.842,
                            1.564
                          ],
                          [
                            1.428,
                            1.564
                          ],
                          [
                            1.428,
                            5.724
                          ],
                          [
                            1.04,
                            6.865
                          ],
                          [
                            -0.008,
                            7.296
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.642999985639,
                        0.933000033509,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        15.573,
                        496.766
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.391,
                            -0.081
                          ],
                          [
                            0.28,
                            -0.279
                          ],
                          [
                            0.081,
                            -0.384
                          ],
                          [
                            0,
                            -0.484
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.323,
                            0.064
                          ],
                          [
                            0.199,
                            0.199
                          ],
                          [
                            0.062,
                            0.32
                          ],
                          [
                            0,
                            0.352
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.063,
                            0.323
                          ],
                          [
                            -0.197,
                            0.198
                          ],
                          [
                            -0.327,
                            0.067
                          ],
                          [
                            -0.357,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.325,
                            -0.067
                          ],
                          [
                            -0.197,
                            -0.198
                          ],
                          [
                            -0.062,
                            -0.318
                          ],
                          [
                            0,
                            -0.358
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.481,
                            0
                          ],
                          [
                            -0.389,
                            0.082
                          ],
                          [
                            -0.283,
                            0.287
                          ],
                          [
                            -0.079,
                            0.383
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.352,
                            0
                          ],
                          [
                            -0.324,
                            -0.066
                          ],
                          [
                            -0.197,
                            -0.197
                          ],
                          [
                            -0.063,
                            -0.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.356
                          ],
                          [
                            0.062,
                            -0.323
                          ],
                          [
                            0.199,
                            -0.198
                          ],
                          [
                            0.325,
                            -0.067
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.351,
                            0
                          ],
                          [
                            0.326,
                            0.067
                          ],
                          [
                            0.193,
                            0.198
                          ],
                          [
                            0.064,
                            0.318
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            5.095,
                            -1.11
                          ],
                          [
                            5.019,
                            -1.018
                          ],
                          [
                            2.098,
                            -1.018
                          ],
                          [
                            0.791,
                            -0.896
                          ],
                          [
                            -0.213,
                            -0.354
                          ],
                          [
                            -0.758,
                            0.653
                          ],
                          [
                            -0.877,
                            1.956
                          ],
                          [
                            -0.877,
                            5.077
                          ],
                          [
                            -2.839,
                            5.077
                          ],
                          [
                            -3.851,
                            4.98
                          ],
                          [
                            -4.633,
                            4.585
                          ],
                          [
                            -5.023,
                            3.808
                          ],
                          [
                            -5.117,
                            2.799
                          ],
                          [
                            -5.117,
                            -2.792
                          ],
                          [
                            -5.023,
                            -3.811
                          ],
                          [
                            -4.633,
                            -4.592
                          ],
                          [
                            -3.847,
                            -4.99
                          ],
                          [
                            -2.824,
                            -5.091
                          ],
                          [
                            2.817,
                            -5.091
                          ],
                          [
                            3.832,
                            -4.99
                          ],
                          [
                            4.617,
                            -4.592
                          ],
                          [
                            5,
                            -3.818
                          ],
                          [
                            5.095,
                            -2.805
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.26
                          ],
                          [
                            -0.159,
                            0.159
                          ],
                          [
                            -0.263,
                            0.055
                          ],
                          [
                            -0.287,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.287
                          ],
                          [
                            0.051,
                            -0.261
                          ],
                          [
                            0.159,
                            -0.159
                          ],
                          [
                            0.261,
                            -0.055
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            0.125,
                            4.912
                          ],
                          [
                            0.125,
                            1.828
                          ],
                          [
                            0.2,
                            1.008
                          ],
                          [
                            0.515,
                            0.379
                          ],
                          [
                            1.147,
                            0.059
                          ],
                          [
                            1.97,
                            -0.023
                          ],
                          [
                            4.198,
                            -0.023
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.076,
                            0.417
                          ],
                          [
                            0.003,
                            0.194
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.098,
                            0.48
                          ],
                          [
                            0.346,
                            0.353
                          ],
                          [
                            0.484,
                            0.101
                          ],
                          [
                            0.608,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.485,
                            -0.101
                          ],
                          [
                            0.348,
                            -0.346
                          ],
                          [
                            0.099,
                            -0.476
                          ],
                          [
                            0,
                            -0.603
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.095,
                            -0.482
                          ],
                          [
                            -0.356,
                            -0.351
                          ],
                          [
                            -0.487,
                            -0.101
                          ],
                          [
                            -0.608,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0.006
                          ],
                          [
                            -0.501,
                            0.437
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.043,
                            0.059
                          ]
                        ],
                        "o": [
                          [
                            0.019,
                            -0.106
                          ],
                          [
                            -0.004,
                            -0.26
                          ],
                          [
                            0,
                            -0.612
                          ],
                          [
                            -0.1,
                            -0.48
                          ],
                          [
                            -0.353,
                            -0.346
                          ],
                          [
                            -0.484,
                            -0.101
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.597,
                            0
                          ],
                          [
                            -0.484,
                            0.101
                          ],
                          [
                            -0.351,
                            0.358
                          ],
                          [
                            -0.098,
                            0.478
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.607
                          ],
                          [
                            0.097,
                            0.483
                          ],
                          [
                            0.348,
                            0.348
                          ],
                          [
                            0.486,
                            0.102
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.923,
                            -0.044
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.616,
                            -0.836
                          ]
                        ],
                        "v": [
                          [
                            6.339,
                            -1.608
                          ],
                          [
                            6.358,
                            -2.108
                          ],
                          [
                            6.339,
                            -2.618
                          ],
                          [
                            6.191,
                            -4.256
                          ],
                          [
                            5.522,
                            -5.504
                          ],
                          [
                            4.267,
                            -6.176
                          ],
                          [
                            2.628,
                            -6.328
                          ],
                          [
                            -2.666,
                            -6.328
                          ],
                          [
                            -4.289,
                            -6.176
                          ],
                          [
                            -5.537,
                            -5.504
                          ],
                          [
                            -6.213,
                            -4.253
                          ],
                          [
                            -6.361,
                            -2.632
                          ],
                          [
                            -6.361,
                            2.611
                          ],
                          [
                            -6.217,
                            4.245
                          ],
                          [
                            -5.537,
                            5.496
                          ],
                          [
                            -4.285,
                            6.169
                          ],
                          [
                            -2.643,
                            6.321
                          ],
                          [
                            -1.753,
                            6.321
                          ],
                          [
                            -0.871,
                            6.321
                          ],
                          [
                            -0.351,
                            6.321
                          ],
                          [
                            1.236,
                            5.514
                          ],
                          [
                            5.095,
                            0.774
                          ],
                          [
                            5.56,
                            0.202
                          ],
                          [
                            5.743,
                            -0.023
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.642999985639,
                        0.933000033509,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        215.79,
                        496.48
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 2",
                "np": 7,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.665,
                            5.176
                          ],
                          [
                            0.665,
                            5.176
                          ],
                          [
                            0.665,
                            7.629
                          ],
                          [
                            -0.665,
                            7.629
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.291,
                            0.332
                          ],
                          [
                            0,
                            0.554
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.291,
                            0.335
                          ],
                          [
                            0.477,
                            0
                          ],
                          [
                            0.288,
                            -0.335
                          ],
                          [
                            0,
                            -0.549
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.288,
                            -0.333
                          ],
                          [
                            -0.476,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.291,
                            -0.333
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.549
                          ],
                          [
                            -0.291,
                            -0.335
                          ],
                          [
                            -0.476,
                            0
                          ],
                          [
                            -0.288,
                            0.335
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.554
                          ],
                          [
                            0.288,
                            0.332
                          ],
                          [
                            0.477,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.152,
                            0.87
                          ],
                          [
                            1.588,
                            -0.461
                          ],
                          [
                            1.588,
                            -5.409
                          ],
                          [
                            1.152,
                            -6.735
                          ],
                          [
                            0,
                            -7.238
                          ],
                          [
                            -1.147,
                            -6.735
                          ],
                          [
                            -1.58,
                            -5.409
                          ],
                          [
                            -1.58,
                            -0.461
                          ],
                          [
                            -1.147,
                            0.87
                          ],
                          [
                            0,
                            1.368
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.443,
                            0.269
                          ],
                          [
                            0.252,
                            0.478
                          ],
                          [
                            0,
                            0.621
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.252,
                            0.477
                          ],
                          [
                            -0.443,
                            0.266
                          ],
                          [
                            -0.577,
                            0
                          ],
                          [
                            -0.443,
                            -0.267
                          ],
                          [
                            -0.252,
                            -0.476
                          ],
                          [
                            0,
                            -0.62
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.252,
                            -0.476
                          ],
                          [
                            0.444,
                            -0.269
                          ],
                          [
                            0.577,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.443,
                            -0.269
                          ],
                          [
                            -0.252,
                            -0.476
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.62
                          ],
                          [
                            0.252,
                            -0.476
                          ],
                          [
                            0.443,
                            -0.267
                          ],
                          [
                            0.577,
                            0
                          ],
                          [
                            0.444,
                            0.266
                          ],
                          [
                            0.252,
                            0.477
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.621
                          ],
                          [
                            -0.252,
                            0.478
                          ],
                          [
                            -0.443,
                            0.269
                          ],
                          [
                            -0.577,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.53,
                            2.287
                          ],
                          [
                            -2.574,
                            1.168
                          ],
                          [
                            -2.952,
                            -0.478
                          ],
                          [
                            -2.952,
                            -5.392
                          ],
                          [
                            -2.574,
                            -7.039
                          ],
                          [
                            -1.53,
                            -8.153
                          ],
                          [
                            0,
                            -8.552
                          ],
                          [
                            1.53,
                            -8.153
                          ],
                          [
                            2.574,
                            -7.039
                          ],
                          [
                            2.952,
                            -5.392
                          ],
                          [
                            2.952,
                            -0.478
                          ],
                          [
                            2.574,
                            1.168
                          ],
                          [
                            1.53,
                            2.287
                          ],
                          [
                            0,
                            2.69
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 3,
                    "ty": "sh",
                    "ix": 4,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.135,
                            0.13
                          ],
                          [
                            0,
                            0.189
                          ],
                          [
                            -0.136,
                            0.133
                          ],
                          [
                            -0.188,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.131,
                            -0.134
                          ],
                          [
                            0,
                            -0.188
                          ],
                          [
                            0.13,
                            -0.13
                          ],
                          [
                            0.194,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.136,
                            -0.13
                          ],
                          [
                            0,
                            -0.188
                          ],
                          [
                            0.135,
                            -0.134
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.194,
                            0
                          ],
                          [
                            0.13,
                            0.133
                          ],
                          [
                            0,
                            0.189
                          ],
                          [
                            -0.131,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.188,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -4.053,
                            8.357
                          ],
                          [
                            -4.257,
                            7.878
                          ],
                          [
                            -4.053,
                            7.397
                          ],
                          [
                            -3.567,
                            7.198
                          ],
                          [
                            3.567,
                            7.198
                          ],
                          [
                            4.054,
                            7.397
                          ],
                          [
                            4.249,
                            7.878
                          ],
                          [
                            4.054,
                            8.357
                          ],
                          [
                            3.567,
                            8.552
                          ],
                          [
                            -3.567,
                            8.552
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 4",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 4,
                    "ty": "sh",
                    "ix": 5,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.713,
                            0.271
                          ],
                          [
                            0.521,
                            0.499
                          ],
                          [
                            0.283,
                            0.696
                          ],
                          [
                            0,
                            0.854
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0.131
                          ],
                          [
                            -0.187,
                            0
                          ],
                          [
                            -0.133,
                            -0.13
                          ],
                          [
                            0,
                            -0.189
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.375,
                            -0.668
                          ],
                          [
                            -0.671,
                            -0.372
                          ],
                          [
                            -0.892,
                            0
                          ],
                          [
                            -0.671,
                            0.371
                          ],
                          [
                            -0.375,
                            0.668
                          ],
                          [
                            0,
                            0.893
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.133,
                            0.131
                          ],
                          [
                            -0.189,
                            0
                          ],
                          [
                            -0.13,
                            -0.13
                          ],
                          [
                            0,
                            -0.189
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.282,
                            -0.695
                          ],
                          [
                            0.52,
                            -0.499
                          ],
                          [
                            0.712,
                            -0.272
                          ],
                          [
                            0.854,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.712,
                            -0.272
                          ],
                          [
                            -0.521,
                            -0.499
                          ],
                          [
                            -0.282,
                            -0.695
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.189
                          ],
                          [
                            0.13,
                            -0.13
                          ],
                          [
                            0.189,
                            0
                          ],
                          [
                            0.132,
                            0.131
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.893
                          ],
                          [
                            0.374,
                            0.668
                          ],
                          [
                            0.671,
                            0.371
                          ],
                          [
                            0.892,
                            0
                          ],
                          [
                            0.671,
                            -0.372
                          ],
                          [
                            0.375,
                            -0.668
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.189
                          ],
                          [
                            0.133,
                            -0.13
                          ],
                          [
                            0.188,
                            0
                          ],
                          [
                            0.131,
                            0.131
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.854
                          ],
                          [
                            -0.284,
                            0.696
                          ],
                          [
                            -0.522,
                            0.499
                          ],
                          [
                            -0.712,
                            0.271
                          ],
                          [
                            -0.853,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -2.349,
                            5.119
                          ],
                          [
                            -4.199,
                            3.962
                          ],
                          [
                            -5.405,
                            2.17
                          ],
                          [
                            -5.829,
                            -0.153
                          ],
                          [
                            -5.829,
                            -1.725
                          ],
                          [
                            -5.633,
                            -2.204
                          ],
                          [
                            -5.156,
                            -2.399
                          ],
                          [
                            -4.673,
                            -2.204
                          ],
                          [
                            -4.473,
                            -1.725
                          ],
                          [
                            -4.473,
                            -0.204
                          ],
                          [
                            -3.912,
                            2.137
                          ],
                          [
                            -2.344,
                            3.697
                          ],
                          [
                            0,
                            4.253
                          ],
                          [
                            2.345,
                            3.697
                          ],
                          [
                            3.913,
                            2.137
                          ],
                          [
                            4.474,
                            -0.204
                          ],
                          [
                            4.474,
                            -1.725
                          ],
                          [
                            4.673,
                            -2.204
                          ],
                          [
                            5.156,
                            -2.399
                          ],
                          [
                            5.633,
                            -2.204
                          ],
                          [
                            5.829,
                            -1.725
                          ],
                          [
                            5.829,
                            -0.153
                          ],
                          [
                            5.406,
                            2.17
                          ],
                          [
                            4.2,
                            3.962
                          ],
                          [
                            2.349,
                            5.119
                          ],
                          [
                            0,
                            5.526
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 5",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.642999985639,
                        0.933000033509,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        289.821,
                        495.979
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 3",
                "np": 9,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.156,
                            0.156
                          ],
                          [
                            0,
                            0.219
                          ],
                          [
                            -0.156,
                            0.16
                          ],
                          [
                            -0.228,
                            0
                          ],
                          [
                            -0.159,
                            -0.158
                          ],
                          [
                            0,
                            -0.228
                          ],
                          [
                            0.158,
                            -0.155
                          ],
                          [
                            0.218,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.156,
                            -0.155
                          ],
                          [
                            0,
                            -0.228
                          ],
                          [
                            0.156,
                            -0.158
                          ],
                          [
                            0.218,
                            0
                          ],
                          [
                            0.158,
                            0.16
                          ],
                          [
                            0,
                            0.219
                          ],
                          [
                            -0.159,
                            0.156
                          ],
                          [
                            -0.228,
                            0
                          ]
                        ],
                        "v": [
                          [
                            3.989,
                            -1.286
                          ],
                          [
                            3.755,
                            -1.849
                          ],
                          [
                            3.989,
                            -2.43
                          ],
                          [
                            4.565,
                            -2.667
                          ],
                          [
                            5.131,
                            -2.43
                          ],
                          [
                            5.368,
                            -1.849
                          ],
                          [
                            5.131,
                            -1.286
                          ],
                          [
                            4.565,
                            -1.053
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.385,
                            0.232
                          ],
                          [
                            -0.23,
                            0.386
                          ],
                          [
                            0,
                            0.473
                          ],
                          [
                            0.228,
                            0.388
                          ],
                          [
                            0.385,
                            0.228
                          ],
                          [
                            0.472,
                            0
                          ],
                          [
                            0.387,
                            -0.23
                          ],
                          [
                            0.228,
                            -0.387
                          ],
                          [
                            0,
                            -0.468
                          ],
                          [
                            -0.229,
                            -0.388
                          ],
                          [
                            -0.387,
                            -0.231
                          ],
                          [
                            -0.474,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.385,
                            -0.231
                          ],
                          [
                            0.228,
                            -0.388
                          ],
                          [
                            0,
                            -0.468
                          ],
                          [
                            -0.23,
                            -0.387
                          ],
                          [
                            -0.385,
                            -0.23
                          ],
                          [
                            -0.474,
                            0
                          ],
                          [
                            -0.387,
                            0.228
                          ],
                          [
                            -0.229,
                            0.388
                          ],
                          [
                            0,
                            0.473
                          ],
                          [
                            0.228,
                            0.386
                          ],
                          [
                            0.387,
                            0.232
                          ],
                          [
                            0.472,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.29,
                            2.904
                          ],
                          [
                            2.211,
                            1.977
                          ],
                          [
                            2.553,
                            0.686
                          ],
                          [
                            2.211,
                            -0.596
                          ],
                          [
                            1.29,
                            -1.52
                          ],
                          [
                            0.005,
                            -1.864
                          ],
                          [
                            -1.287,
                            -1.52
                          ],
                          [
                            -2.21,
                            -0.596
                          ],
                          [
                            -2.554,
                            0.686
                          ],
                          [
                            -2.21,
                            1.977
                          ],
                          [
                            -1.287,
                            2.904
                          ],
                          [
                            0.005,
                            3.251
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.543,
                            0.322
                          ],
                          [
                            0.325,
                            0.543
                          ],
                          [
                            0,
                            0.666
                          ],
                          [
                            -0.325,
                            0.543
                          ],
                          [
                            -0.543,
                            0.322
                          ],
                          [
                            -0.661,
                            0
                          ],
                          [
                            -0.543,
                            -0.322
                          ],
                          [
                            -0.32,
                            -0.543
                          ],
                          [
                            0,
                            -0.661
                          ],
                          [
                            0.32,
                            -0.543
                          ],
                          [
                            0.544,
                            -0.322
                          ],
                          [
                            0.66,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.543,
                            -0.322
                          ],
                          [
                            -0.325,
                            -0.543
                          ],
                          [
                            0,
                            -0.661
                          ],
                          [
                            0.325,
                            -0.543
                          ],
                          [
                            0.543,
                            -0.322
                          ],
                          [
                            0.66,
                            0
                          ],
                          [
                            0.544,
                            0.322
                          ],
                          [
                            0.32,
                            0.543
                          ],
                          [
                            0,
                            0.666
                          ],
                          [
                            -0.32,
                            0.543
                          ],
                          [
                            -0.543,
                            0.322
                          ],
                          [
                            -0.661,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.801,
                            3.797
                          ],
                          [
                            -3.104,
                            2.499
                          ],
                          [
                            -3.59,
                            0.686
                          ],
                          [
                            -3.104,
                            -1.118
                          ],
                          [
                            -1.801,
                            -2.418
                          ],
                          [
                            0.005,
                            -2.901
                          ],
                          [
                            1.808,
                            -2.418
                          ],
                          [
                            3.104,
                            -1.118
                          ],
                          [
                            3.583,
                            0.686
                          ],
                          [
                            3.104,
                            2.499
                          ],
                          [
                            1.808,
                            3.797
                          ],
                          [
                            0.005,
                            4.28
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 3,
                    "ty": "sh",
                    "ix": 4,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.205,
                            0.205
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.205,
                            0.204
                          ],
                          [
                            0.385,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.208,
                            0.078
                          ],
                          [
                            0.188,
                            0.208
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.136,
                            0.059
                          ],
                          [
                            0.203,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.128,
                            -0.06
                          ],
                          [
                            0.13,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.211,
                            -0.079
                          ],
                          [
                            0.317,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.205,
                            -0.202
                          ],
                          [
                            0,
                            -0.4
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.205,
                            -0.206
                          ],
                          [
                            -0.389,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.385,
                            0
                          ],
                          [
                            0.205,
                            -0.206
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.4
                          ],
                          [
                            -0.205,
                            -0.202
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.323,
                            0
                          ],
                          [
                            -0.208,
                            -0.079
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            -0.13
                          ],
                          [
                            -0.135,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.218,
                            0
                          ],
                          [
                            -0.127,
                            0.059
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.192,
                            0.208
                          ],
                          [
                            -0.21,
                            0.078
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.389,
                            0
                          ],
                          [
                            -0.205,
                            0.204
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            0.205,
                            0.205
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            5.36,
                            5.326
                          ],
                          [
                            6.247,
                            5.018
                          ],
                          [
                            6.553,
                            4.109
                          ],
                          [
                            6.553,
                            -2.527
                          ],
                          [
                            6.247,
                            -3.432
                          ],
                          [
                            5.36,
                            -3.734
                          ],
                          [
                            4.169,
                            -3.734
                          ],
                          [
                            3.372,
                            -3.852
                          ],
                          [
                            2.779,
                            -4.281
                          ],
                          [
                            2.156,
                            -4.952
                          ],
                          [
                            1.773,
                            -5.236
                          ],
                          [
                            1.266,
                            -5.326
                          ],
                          [
                            -1.26,
                            -5.326
                          ],
                          [
                            -1.779,
                            -5.236
                          ],
                          [
                            -2.163,
                            -4.952
                          ],
                          [
                            -2.781,
                            -4.281
                          ],
                          [
                            -3.385,
                            -3.852
                          ],
                          [
                            -4.175,
                            -3.734
                          ],
                          [
                            -5.361,
                            -3.734
                          ],
                          [
                            -6.253,
                            -3.432
                          ],
                          [
                            -6.563,
                            -2.527
                          ],
                          [
                            -6.563,
                            4.109
                          ],
                          [
                            -6.253,
                            5.018
                          ],
                          [
                            -5.361,
                            5.326
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 4",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 4,
                    "ty": "sh",
                    "ix": 5,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.374,
                            0.374
                          ],
                          [
                            0,
                            0.743
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.375,
                            0.371
                          ],
                          [
                            -0.759,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0.057
                          ],
                          [
                            -0.166,
                            0.177
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.197,
                            0.096
                          ],
                          [
                            -0.297,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.203,
                            -0.096
                          ],
                          [
                            -0.193,
                            -0.204
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.057
                          ],
                          [
                            -0.275,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.38,
                            -0.372
                          ],
                          [
                            0,
                            -0.743
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.38,
                            -0.374
                          ],
                          [
                            0.748,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.375,
                            -0.374
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.743
                          ],
                          [
                            0.374,
                            -0.372
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.281,
                            0
                          ],
                          [
                            0.13,
                            -0.057
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.192,
                            -0.204
                          ],
                          [
                            0.197,
                            -0.096
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.286,
                            0
                          ],
                          [
                            0.202,
                            0.096
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.166,
                            0.177
                          ],
                          [
                            0.129,
                            0.057
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.748,
                            0
                          ],
                          [
                            0.38,
                            0.371
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.743
                          ],
                          [
                            -0.38,
                            0.374
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.759,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -7.076,
                            5.84
                          ],
                          [
                            -7.637,
                            4.164
                          ],
                          [
                            -7.637,
                            -2.582
                          ],
                          [
                            -7.076,
                            -4.254
                          ],
                          [
                            -5.377,
                            -4.811
                          ],
                          [
                            -4.425,
                            -4.811
                          ],
                          [
                            -3.809,
                            -4.897
                          ],
                          [
                            -3.365,
                            -5.247
                          ],
                          [
                            -2.843,
                            -5.809
                          ],
                          [
                            -2.257,
                            -6.258
                          ],
                          [
                            -1.516,
                            -6.402
                          ],
                          [
                            1.516,
                            -6.402
                          ],
                          [
                            2.25,
                            -6.258
                          ],
                          [
                            2.842,
                            -5.809
                          ],
                          [
                            3.357,
                            -5.247
                          ],
                          [
                            3.802,
                            -4.897
                          ],
                          [
                            4.409,
                            -4.811
                          ],
                          [
                            5.378,
                            -4.811
                          ],
                          [
                            7.068,
                            -4.254
                          ],
                          [
                            7.638,
                            -2.582
                          ],
                          [
                            7.638,
                            4.164
                          ],
                          [
                            7.068,
                            5.84
                          ],
                          [
                            5.378,
                            6.401
                          ],
                          [
                            -5.377,
                            6.401
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 5",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.642999985639,
                        0.933000033509,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        255.422,
                        495.979
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 4",
                "np": 9,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            7.153,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -7.153
                          ],
                          [
                            -7.153,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            7.152
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -7.153,
                            0
                          ],
                          [
                            0,
                            7.152
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            7.153,
                            0
                          ],
                          [
                            0,
                            -7.153
                          ]
                        ],
                        "v": [
                          [
                            84.142,
                            -12.951
                          ],
                          [
                            -84.14,
                            -12.951
                          ],
                          [
                            -97.092,
                            0.001
                          ],
                          [
                            -84.14,
                            12.952
                          ],
                          [
                            84.142,
                            12.952
                          ],
                          [
                            97.092,
                            0.001
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.172999991623,
                        0.172999991623,
                        0.180000005984,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        135.016,
                        496.478
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 5",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.084,
                            0
                          ],
                          [
                            0.042,
                            -0.025
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.096,
                            -0.337
                          ],
                          [
                            -3.753,
                            -3.752
                          ],
                          [
                            -2.537,
                            0.694
                          ],
                          [
                            -0.178,
                            0.302
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.115,
                            0.078
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.084,
                            -0.105
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.549,
                            0.302
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.759,
                            1.76
                          ],
                          [
                            0.39,
                            0.715
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.496,
                            0.382
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.074,
                            0.113
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.046,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.306,
                            0.181
                          ],
                          [
                            -0.694,
                            2.534
                          ],
                          [
                            3.753,
                            3.754
                          ],
                          [
                            0.333,
                            -0.095
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.071,
                            -0.119
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.112,
                            -0.073
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.38,
                            0.493
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.716,
                            -0.388
                          ],
                          [
                            -1.764,
                            -1.765
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.304,
                            -0.548
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.105,
                            -0.083
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.075
                          ]
                        ],
                        "v": [
                          [
                            -5.665,
                            -8.117
                          ],
                          [
                            -5.799,
                            -8.08
                          ],
                          [
                            -7.322,
                            -7.166
                          ],
                          [
                            -7.944,
                            -6.364
                          ],
                          [
                            -3.201,
                            3.386
                          ],
                          [
                            6.554,
                            8.128
                          ],
                          [
                            7.349,
                            7.511
                          ],
                          [
                            8.265,
                            5.984
                          ],
                          [
                            8.187,
                            5.634
                          ],
                          [
                            4.543,
                            3.205
                          ],
                          [
                            4.193,
                            3.262
                          ],
                          [
                            3.134,
                            4.626
                          ],
                          [
                            1.532,
                            4.957
                          ],
                          [
                            1.336,
                            4.848
                          ],
                          [
                            -2.028,
                            2.214
                          ],
                          [
                            -4.666,
                            -1.155
                          ],
                          [
                            -4.77,
                            -1.346
                          ],
                          [
                            -4.439,
                            -2.95
                          ],
                          [
                            -3.076,
                            -4.01
                          ],
                          [
                            -3.019,
                            -4.358
                          ],
                          [
                            -5.449,
                            -8.001
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.552,
                            0
                          ],
                          [
                            4.085,
                            4.086
                          ],
                          [
                            -0.562,
                            2.051
                          ],
                          [
                            -0.525,
                            0.309
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.374,
                            -0.562
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.517,
                            -0.402
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.061,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.661,
                            -1.663
                          ],
                          [
                            -0.659,
                            -0.358
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.077,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.544,
                            -0.36
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.347,
                            -0.577
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.587,
                            -0.166
                          ]
                        ],
                        "o": [
                          [
                            -2.118,
                            0
                          ],
                          [
                            -5.15,
                            -5.148
                          ],
                          [
                            0.168,
                            -0.591
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.573,
                            -0.345
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.363,
                            0.546
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.101,
                            0.078
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.358,
                            0.659
                          ],
                          [
                            1.656,
                            1.659
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.107,
                            0.057
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.405,
                            -0.517
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.561,
                            0.374
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.307,
                            0.522
                          ],
                          [
                            -0.424,
                            0.117
                          ]
                        ],
                        "v": [
                          [
                            5.358,
                            9.282
                          ],
                          [
                            -3.908,
                            4.093
                          ],
                          [
                            -8.907,
                            -6.632
                          ],
                          [
                            -7.833,
                            -8.025
                          ],
                          [
                            -6.312,
                            -8.937
                          ],
                          [
                            -4.617,
                            -8.555
                          ],
                          [
                            -2.187,
                            -4.912
                          ],
                          [
                            -2.462,
                            -3.221
                          ],
                          [
                            -3.827,
                            -2.159
                          ],
                          [
                            -3.896,
                            -1.831
                          ],
                          [
                            -3.788,
                            -1.634
                          ],
                          [
                            -1.321,
                            1.507
                          ],
                          [
                            1.814,
                            3.97
                          ],
                          [
                            2.018,
                            4.083
                          ],
                          [
                            2.343,
                            4.014
                          ],
                          [
                            3.405,
                            2.648
                          ],
                          [
                            5.097,
                            2.372
                          ],
                          [
                            8.741,
                            4.802
                          ],
                          [
                            9.122,
                            6.499
                          ],
                          [
                            8.208,
                            8.021
                          ],
                          [
                            6.822,
                            9.091
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.642999985639,
                        0.933000033509,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        291.941,
                        45.885
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 6",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.867,
                            1.586
                          ],
                          [
                            1.867,
                            3.625
                          ],
                          [
                            1.867,
                            -3.603
                          ],
                          [
                            -1.867,
                            -1.564
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.088,
                            0
                          ],
                          [
                            0.074,
                            0.041
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.182
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.161,
                            0.088
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.151,
                            -0.089
                          ],
                          [
                            0,
                            -0.176
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.153,
                            -0.09
                          ]
                        ],
                        "o": [
                          [
                            -0.082,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.161,
                            -0.087
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.183
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.154,
                            -0.083
                          ],
                          [
                            0.153,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.177
                          ],
                          [
                            -0.078,
                            0.046
                          ]
                        ],
                        "v": [
                          [
                            2.367,
                            4.969
                          ],
                          [
                            2.128,
                            4.906
                          ],
                          [
                            -2.607,
                            2.322
                          ],
                          [
                            -2.867,
                            1.884
                          ],
                          [
                            -2.867,
                            -1.862
                          ],
                          [
                            -2.607,
                            -2.3
                          ],
                          [
                            2.128,
                            -4.885
                          ],
                          [
                            2.622,
                            -4.876
                          ],
                          [
                            2.867,
                            -4.446
                          ],
                          [
                            2.867,
                            4.469
                          ],
                          [
                            2.622,
                            4.898
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.642999985639,
                        0.933000033509,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        261.206,
                        47.821
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 7",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 7,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0.001,
                            -0.484
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.484,
                            -0.001
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.001,
                            0.484
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.483,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.483,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.001,
                            0.483
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.483,
                            -0.001
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.001,
                            -0.483
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -5.716,
                            -5.412
                          ],
                          [
                            -6.594,
                            -4.533
                          ],
                          [
                            -6.594,
                            4.533
                          ],
                          [
                            -5.715,
                            5.412
                          ],
                          [
                            5.717,
                            5.412
                          ],
                          [
                            6.595,
                            4.533
                          ],
                          [
                            6.595,
                            -4.535
                          ],
                          [
                            5.717,
                            -5.412
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.033,
                            -0.001
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.001,
                            1.033
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.034,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.001,
                            -1.034
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -1.034,
                            -0.001
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.001,
                            -1.034
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.034,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.001,
                            1.034
                          ]
                        ],
                        "v": [
                          [
                            5.718,
                            6.412
                          ],
                          [
                            -5.716,
                            6.412
                          ],
                          [
                            -7.594,
                            4.535
                          ],
                          [
                            -7.594,
                            -4.535
                          ],
                          [
                            -5.716,
                            -6.412
                          ],
                          [
                            5.717,
                            -6.412
                          ],
                          [
                            7.595,
                            -4.535
                          ],
                          [
                            7.595,
                            4.533
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.642999985639,
                        0.933000033509,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        249.827,
                        47.817
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 8",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 8,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.113,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.113
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            1.113,
                            0
                          ],
                          [
                            0,
                            -1.114
                          ]
                        ],
                        "v": [
                          [
                            -1.008,
                            -2.016
                          ],
                          [
                            -1.008,
                            2.016
                          ],
                          [
                            1.008,
                            0.001
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.26699999641,
                        0.26699999641,
                        0.26699999641,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        297.967,
                        5.313
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 9",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 9,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.827
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.827,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.827
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.827,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.827,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.827
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.827,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.827
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -6.98,
                            -4.04
                          ],
                          [
                            -8.48,
                            -2.54
                          ],
                          [
                            -8.48,
                            2.54
                          ],
                          [
                            -6.98,
                            4.04
                          ],
                          [
                            6.98,
                            4.04
                          ],
                          [
                            8.48,
                            2.54
                          ],
                          [
                            8.48,
                            -2.54
                          ],
                          [
                            6.98,
                            -4.04
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.379,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.378
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.379,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.378
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -1.379,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.378
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.379,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.378
                          ]
                        ],
                        "v": [
                          [
                            6.98,
                            5.04
                          ],
                          [
                            -6.98,
                            5.04
                          ],
                          [
                            -9.48,
                            2.54
                          ],
                          [
                            -9.48,
                            -2.54
                          ],
                          [
                            -6.98,
                            -5.04
                          ],
                          [
                            6.98,
                            -5.04
                          ],
                          [
                            9.48,
                            -2.54
                          ],
                          [
                            9.48,
                            2.54
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.26699999641,
                        0.26699999641,
                        0.26699999641,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        287.157,
                        5.656
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 10",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 10,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.828,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.829
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.829,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.829
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.829,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.829
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.828,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.829
                          ]
                        ],
                        "v": [
                          [
                            6.436,
                            -3.56
                          ],
                          [
                            -6.436,
                            -3.56
                          ],
                          [
                            -7.936,
                            -2.06
                          ],
                          [
                            -7.936,
                            2.06
                          ],
                          [
                            -6.436,
                            3.56
                          ],
                          [
                            6.436,
                            3.56
                          ],
                          [
                            7.936,
                            2.06
                          ],
                          [
                            7.936,
                            -2.06
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.995999983245,
                        0.995999983245,
                        0.995999983245,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        287.181,
                        5.628
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 11",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 11,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.276
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.276
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.276
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.276
                          ]
                        ],
                        "v": [
                          [
                            0.873,
                            4.681
                          ],
                          [
                            -0.873,
                            4.681
                          ],
                          [
                            -1.373,
                            4.181
                          ],
                          [
                            -1.373,
                            -4.181
                          ],
                          [
                            -0.873,
                            -4.681
                          ],
                          [
                            0.873,
                            -4.681
                          ],
                          [
                            1.372,
                            -4.181
                          ],
                          [
                            1.372,
                            4.181
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.26699999641,
                        0.26699999641,
                        0.26699999641,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        255.125,
                        5.797
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 12",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 12,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.276
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.276
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.276
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.276
                          ]
                        ],
                        "v": [
                          [
                            0.873,
                            3.59
                          ],
                          [
                            -0.873,
                            3.59
                          ],
                          [
                            -1.373,
                            3.09
                          ],
                          [
                            -1.373,
                            -3.09
                          ],
                          [
                            -0.873,
                            -3.59
                          ],
                          [
                            0.873,
                            -3.59
                          ],
                          [
                            1.373,
                            -3.09
                          ],
                          [
                            1.373,
                            3.09
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.26699999641,
                        0.26699999641,
                        0.26699999641,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        251.042,
                        6.888
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 13",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 13,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.276
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.276
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.276
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.276
                          ]
                        ],
                        "v": [
                          [
                            0.873,
                            2.969
                          ],
                          [
                            -0.873,
                            2.969
                          ],
                          [
                            -1.373,
                            2.469
                          ],
                          [
                            -1.373,
                            -2.469
                          ],
                          [
                            -0.873,
                            -2.969
                          ],
                          [
                            0.873,
                            -2.969
                          ],
                          [
                            1.373,
                            -2.469
                          ],
                          [
                            1.373,
                            2.469
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.995999983245,
                        0.995999983245,
                        0.995999983245,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        247.311,
                        7.508
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 14",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 14,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.275,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.276
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.276
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.276,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.276
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.275,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.276
                          ]
                        ],
                        "v": [
                          [
                            0.873,
                            2.246
                          ],
                          [
                            -0.873,
                            2.246
                          ],
                          [
                            -1.373,
                            1.746
                          ],
                          [
                            -1.373,
                            -1.746
                          ],
                          [
                            -0.873,
                            -2.246
                          ],
                          [
                            0.873,
                            -2.246
                          ],
                          [
                            1.373,
                            -1.746
                          ],
                          [
                            1.373,
                            1.746
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.995999983245,
                        0.995999983245,
                        0.995999983245,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        243.159,
                        8.231
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 15",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 15,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.848,
                            -0.848
                          ],
                          [
                            0,
                            -0.141
                          ],
                          [
                            -0.099,
                            -0.098
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0
                          ],
                          [
                            -0.097,
                            0.098
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            0.098,
                            0.098
                          ]
                        ],
                        "o": [
                          [
                            -0.1,
                            0.1
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.097,
                            0.099
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.098,
                            -0.099
                          ],
                          [
                            0,
                            -0.141
                          ],
                          [
                            -0.849,
                            -0.849
                          ]
                        ],
                        "v": [
                          [
                            -1.588,
                            -0.632
                          ],
                          [
                            -1.741,
                            -0.259
                          ],
                          [
                            -1.588,
                            0.111
                          ],
                          [
                            -0.374,
                            1.326
                          ],
                          [
                            -0.001,
                            1.481
                          ],
                          [
                            0.371,
                            1.327
                          ],
                          [
                            1.587,
                            0.112
                          ],
                          [
                            1.741,
                            -0.26
                          ],
                          [
                            1.587,
                            -0.632
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.995999983245,
                        0.995999983245,
                        0.995999983245,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        267.174,
                        8.342
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 16",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 16,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.55,
                            0
                          ],
                          [
                            1.099,
                            -1.099
                          ],
                          [
                            0,
                            -0.138
                          ],
                          [
                            -0.099,
                            -0.101
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.196,
                            0.196
                          ],
                          [
                            -1.135,
                            -1.135
                          ],
                          [
                            -0.138,
                            0
                          ],
                          [
                            -0.098,
                            0.098
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.206,
                            0.205
                          ]
                        ],
                        "o": [
                          [
                            -1.55,
                            0
                          ],
                          [
                            -0.097,
                            0.097
                          ],
                          [
                            0,
                            0.139
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.197,
                            0.196
                          ],
                          [
                            1.133,
                            -1.133
                          ],
                          [
                            0.099,
                            0.098
                          ],
                          [
                            0.139,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.205,
                            -0.205
                          ],
                          [
                            -1.098,
                            -1.099
                          ]
                        ],
                        "v": [
                          [
                            -0.025,
                            -1.944
                          ],
                          [
                            -4.133,
                            -0.24
                          ],
                          [
                            -4.286,
                            0.131
                          ],
                          [
                            -4.133,
                            0.503
                          ],
                          [
                            -2.888,
                            1.748
                          ],
                          [
                            -2.143,
                            1.748
                          ],
                          [
                            2.093,
                            1.748
                          ],
                          [
                            2.465,
                            1.902
                          ],
                          [
                            2.837,
                            1.748
                          ],
                          [
                            4.082,
                            0.503
                          ],
                          [
                            4.081,
                            -0.24
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.995999983245,
                        0.995999983245,
                        0.995999983245,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        267.199,
                        5.497
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 17",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 17,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.097,
                            0.094
                          ],
                          [
                            2.43,
                            0
                          ],
                          [
                            1.725,
                            -1.724
                          ],
                          [
                            -0.202,
                            -0.205
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.194,
                            0.194
                          ],
                          [
                            -1.68,
                            0
                          ],
                          [
                            -1.195,
                            -1.194
                          ],
                          [
                            -0.138,
                            0
                          ],
                          [
                            -0.099,
                            0.098
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.141
                          ]
                        ],
                        "o": [
                          [
                            -1.724,
                            -1.723
                          ],
                          [
                            -2.431,
                            0
                          ],
                          [
                            -0.202,
                            0.205
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.198,
                            0.194
                          ],
                          [
                            1.193,
                            -1.191
                          ],
                          [
                            1.68,
                            0
                          ],
                          [
                            0.098,
                            0.097
                          ],
                          [
                            0.138,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.101,
                            -0.099
                          ],
                          [
                            0,
                            -0.141
                          ]
                        ],
                        "v": [
                          [
                            6.466,
                            0.243
                          ],
                          [
                            0.026,
                            -2.429
                          ],
                          [
                            -6.417,
                            0.245
                          ],
                          [
                            -6.417,
                            0.987
                          ],
                          [
                            -5.169,
                            2.234
                          ],
                          [
                            -4.43,
                            2.232
                          ],
                          [
                            0.026,
                            0.385
                          ],
                          [
                            4.482,
                            2.234
                          ],
                          [
                            4.849,
                            2.385
                          ],
                          [
                            5.221,
                            2.232
                          ],
                          [
                            6.464,
                            0.989
                          ],
                          [
                            6.62,
                            0.615
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.995999983245,
                        0.995999983245,
                        0.995999983245,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        267.149,
                        2.679
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 18",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 18,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.253,
                            0
                          ],
                          [
                            0.195,
                            0.199
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.388,
                            0.388
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.391,
                            -0.39
                          ],
                          [
                            0.391,
                            -0.39
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.394,
                            -0.387
                          ]
                        ],
                        "o": [
                          [
                            -0.259,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.385,
                            -0.391
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.391,
                            -0.39
                          ],
                          [
                            0.391,
                            0.391
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.388,
                            0.394
                          ],
                          [
                            -0.195,
                            0.191
                          ]
                        ],
                        "v": [
                          [
                            3.941,
                            9.002
                          ],
                          [
                            3.227,
                            8.704
                          ],
                          [
                            -4.656,
                            0.679
                          ],
                          [
                            -4.65,
                            -0.728
                          ],
                          [
                            3.234,
                            -8.613
                          ],
                          [
                            4.647,
                            -8.613
                          ],
                          [
                            4.647,
                            -7.199
                          ],
                          [
                            -2.535,
                            -0.015
                          ],
                          [
                            4.654,
                            7.301
                          ],
                          [
                            4.641,
                            8.715
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.642999985639,
                        0.933000033509,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        5.291,
                        41.963
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 19",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 19,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.983,
                            1.004
                          ],
                          [
                            -1.321,
                            0
                          ],
                          [
                            -0.818,
                            -1.171
                          ],
                          [
                            -0.033,
                            -0.663
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.221,
                            0.259
                          ],
                          [
                            0.776,
                            0
                          ],
                          [
                            0.456,
                            -0.651
                          ],
                          [
                            0,
                            -1.191
                          ],
                          [
                            -0.481,
                            -0.593
                          ],
                          [
                            -0.742,
                            0
                          ],
                          [
                            -0.4,
                            0.509
                          ],
                          [
                            -0.145,
                            0.547
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.782,
                            -0.725
                          ],
                          [
                            1.221,
                            0
                          ],
                          [
                            0.865,
                            0.98
                          ],
                          [
                            0,
                            1.715
                          ]
                        ],
                        "o": [
                          [
                            0.855,
                            -0.874
                          ],
                          [
                            1.768,
                            0
                          ],
                          [
                            0.451,
                            0.658
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.141,
                            -0.51
                          ],
                          [
                            -0.395,
                            -0.461
                          ],
                          [
                            -0.791,
                            0
                          ],
                          [
                            -0.457,
                            0.65
                          ],
                          [
                            0,
                            1.192
                          ],
                          [
                            0.482,
                            0.593
                          ],
                          [
                            0.761,
                            0
                          ],
                          [
                            0.22,
                            -0.274
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            1.157
                          ],
                          [
                            -0.782,
                            0.725
                          ],
                          [
                            -1.51,
                            0
                          ],
                          [
                            -0.865,
                            -0.984
                          ],
                          [
                            0,
                            -1.853
                          ]
                        ],
                        "v": [
                          [
                            -3.196,
                            -4.246
                          ],
                          [
                            0.068,
                            -5.558
                          ],
                          [
                            3.946,
                            -3.8
                          ],
                          [
                            4.672,
                            -1.818
                          ],
                          [
                            2.453,
                            -1.818
                          ],
                          [
                            1.91,
                            -2.971
                          ],
                          [
                            0.153,
                            -3.663
                          ],
                          [
                            -1.717,
                            -2.686
                          ],
                          [
                            -2.402,
                            0.076
                          ],
                          [
                            -1.68,
                            2.753
                          ],
                          [
                            0.156,
                            3.642
                          ],
                          [
                            1.897,
                            2.879
                          ],
                          [
                            2.446,
                            1.647
                          ],
                          [
                            4.651,
                            1.647
                          ],
                          [
                            3.193,
                            4.471
                          ],
                          [
                            0.189,
                            5.558
                          ],
                          [
                            -3.374,
                            4.089
                          ],
                          [
                            -4.672,
                            0.04
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        64.419,
                        43.312
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 20",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 20,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.384,
                            1.296
                          ],
                          [
                            1.335,
                            1.296
                          ],
                          [
                            -0.007,
                            -2.882
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.238,
                            -5.309
                          ],
                          [
                            1.273,
                            -5.309
                          ],
                          [
                            5.029,
                            5.309
                          ],
                          [
                            2.624,
                            5.309
                          ],
                          [
                            1.923,
                            3.126
                          ],
                          [
                            -1.988,
                            3.126
                          ],
                          [
                            -2.708,
                            5.309
                          ],
                          [
                            -5.029,
                            5.309
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        53.829,
                        43.266
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 21",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 21,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            -8.863
                          ],
                          [
                            8.864,
                            0
                          ],
                          [
                            0,
                            8.864
                          ],
                          [
                            -8.863,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            8.864
                          ],
                          [
                            -8.863,
                            0
                          ],
                          [
                            0,
                            -8.863
                          ],
                          [
                            8.864,
                            0
                          ]
                        ],
                        "v": [
                          [
                            16.049,
                            0
                          ],
                          [
                            0,
                            16.049
                          ],
                          [
                            -16.049,
                            0
                          ],
                          [
                            0,
                            -16.049
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        0.6,
                        0.779999976065,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        59.851,
                        42.974
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 22",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 22,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0.137,
                            0.242
                          ],
                          [
                            0.593,
                            0
                          ],
                          [
                            0.288,
                            -0.308
                          ],
                          [
                            0.018,
                            -0.477
                          ]
                        ],
                        "o": [
                          [
                            -0.038,
                            -0.404
                          ],
                          [
                            -0.254,
                            -0.449
                          ],
                          [
                            -0.426,
                            0
                          ],
                          [
                            -0.288,
                            0.31
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.561,
                            -0.48
                          ],
                          [
                            1.299,
                            -1.45
                          ],
                          [
                            0.029,
                            -2.124
                          ],
                          [
                            -1.041,
                            -1.66
                          ],
                          [
                            -1.499,
                            -0.48
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.368,
                            -0.184
                          ],
                          [
                            -0.193,
                            -0.294
                          ],
                          [
                            -0.062,
                            -0.374
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.247,
                            -0.341
                          ],
                          [
                            -0.518,
                            0
                          ],
                          [
                            -0.288,
                            0.322
                          ],
                          [
                            -0.068,
                            0.246
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.136,
                            -0.251
                          ],
                          [
                            0.168,
                            -0.158
                          ],
                          [
                            0.415,
                            -0.097
                          ],
                          [
                            0.282,
                            0
                          ],
                          [
                            0.478,
                            0.503
                          ],
                          [
                            0,
                            0.906
                          ],
                          [
                            -0.481,
                            0.557
                          ],
                          [
                            -0.777,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.367,
                            0.186
                          ],
                          [
                            0.185,
                            0.28
                          ],
                          [
                            0.055,
                            0.255
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.017,
                            0.565
                          ],
                          [
                            0.247,
                            0.341
                          ],
                          [
                            0.484,
                            0
                          ],
                          [
                            0.161,
                            -0.188
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.025,
                            0.204
                          ],
                          [
                            -0.137,
                            0.251
                          ],
                          [
                            -0.282,
                            0.278
                          ],
                          [
                            -0.223,
                            0.055
                          ],
                          [
                            -0.687,
                            0
                          ],
                          [
                            -0.477,
                            -0.503
                          ],
                          [
                            0,
                            -0.892
                          ],
                          [
                            0.481,
                            -0.557
                          ],
                          [
                            0.391,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.227,
                            -2.661
                          ],
                          [
                            2.067,
                            -1.942
                          ],
                          [
                            2.438,
                            -0.961
                          ],
                          [
                            2.52,
                            0.262
                          ],
                          [
                            -1.519,
                            0.262
                          ],
                          [
                            -1.123,
                            1.622
                          ],
                          [
                            0.024,
                            2.134
                          ],
                          [
                            1.182,
                            1.65
                          ],
                          [
                            1.525,
                            0.999
                          ],
                          [
                            2.443,
                            0.999
                          ],
                          [
                            2.202,
                            1.68
                          ],
                          [
                            1.745,
                            2.294
                          ],
                          [
                            0.7,
                            2.855
                          ],
                          [
                            -0.057,
                            2.938
                          ],
                          [
                            -1.804,
                            2.183
                          ],
                          [
                            -2.52,
                            0.07
                          ],
                          [
                            -1.798,
                            -2.103
                          ],
                          [
                            0.088,
                            -2.938
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.560999971278,
                        0.560999971278,
                        0.560999971278,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        107.233,
                        51.174
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 23",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 23,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.294,
                            0.141
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.277,
                            -0.55
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0.207
                          ],
                          [
                            0.436,
                            0
                          ],
                          [
                            0.142,
                            -0.045
                          ],
                          [
                            0.193,
                            -0.228
                          ],
                          [
                            0.047,
                            -0.196
                          ],
                          [
                            0,
                            -0.364
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.262,
                            -0.325
                          ],
                          [
                            0.294,
                            -0.142
                          ],
                          [
                            0.788,
                            0
                          ],
                          [
                            0.152,
                            0.301
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.339
                          ],
                          [
                            -0.166,
                            -0.345
                          ],
                          [
                            -0.221,
                            0
                          ],
                          [
                            -0.256,
                            0.076
                          ],
                          [
                            -0.156,
                            0.184
                          ],
                          [
                            -0.046,
                            0.195
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -2.264,
                            -2.715
                          ],
                          [
                            -1.377,
                            -2.715
                          ],
                          [
                            -1.377,
                            -1.926
                          ],
                          [
                            -0.542,
                            -2.626
                          ],
                          [
                            0.438,
                            -2.84
                          ],
                          [
                            2.036,
                            -2.014
                          ],
                          [
                            2.264,
                            -0.723
                          ],
                          [
                            2.264,
                            2.84
                          ],
                          [
                            1.314,
                            2.84
                          ],
                          [
                            1.314,
                            -0.66
                          ],
                          [
                            1.165,
                            -1.48
                          ],
                          [
                            0.262,
                            -1.999
                          ],
                          [
                            -0.283,
                            -1.931
                          ],
                          [
                            -0.956,
                            -1.475
                          ],
                          [
                            -1.26,
                            -0.908
                          ],
                          [
                            -1.329,
                            -0.069
                          ],
                          [
                            -1.329,
                            2.84
                          ],
                          [
                            -2.264,
                            2.84
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.560999971278,
                        0.560999971278,
                        0.560999971278,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        101.386,
                        51.076
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 24",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 24,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.475,
                            -1.72
                          ],
                          [
                            0.475,
                            -1.72
                          ],
                          [
                            0.475,
                            3.809
                          ],
                          [
                            -0.475,
                            3.809
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.475,
                            -3.809
                          ],
                          [
                            0.475,
                            -3.809
                          ],
                          [
                            0.475,
                            -2.751
                          ],
                          [
                            -0.475,
                            -2.751
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.560999971278,
                        0.560999971278,
                        0.560999971278,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        97.237,
                        50.106
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 25",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 25,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.467,
                            -3.809
                          ],
                          [
                            0.467,
                            -3.809
                          ],
                          [
                            0.467,
                            3.809
                          ],
                          [
                            -0.467,
                            3.809
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.560999971278,
                        0.560999971278,
                        0.560999971278,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        94.897,
                        50.107
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 26",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 26,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.294,
                            0.141
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.277,
                            -0.55
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0.207
                          ],
                          [
                            0.436,
                            0
                          ],
                          [
                            0.142,
                            -0.045
                          ],
                          [
                            0.193,
                            -0.228
                          ],
                          [
                            0.047,
                            -0.196
                          ],
                          [
                            0,
                            -0.364
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.262,
                            -0.325
                          ],
                          [
                            0.294,
                            -0.142
                          ],
                          [
                            0.788,
                            0
                          ],
                          [
                            0.152,
                            0.301
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.339
                          ],
                          [
                            -0.166,
                            -0.345
                          ],
                          [
                            -0.221,
                            0
                          ],
                          [
                            -0.256,
                            0.076
                          ],
                          [
                            -0.156,
                            0.184
                          ],
                          [
                            -0.046,
                            0.195
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -2.264,
                            -2.715
                          ],
                          [
                            -1.377,
                            -2.715
                          ],
                          [
                            -1.377,
                            -1.926
                          ],
                          [
                            -0.542,
                            -2.626
                          ],
                          [
                            0.438,
                            -2.84
                          ],
                          [
                            2.036,
                            -2.014
                          ],
                          [
                            2.264,
                            -0.723
                          ],
                          [
                            2.264,
                            2.84
                          ],
                          [
                            1.314,
                            2.84
                          ],
                          [
                            1.314,
                            -0.66
                          ],
                          [
                            1.165,
                            -1.48
                          ],
                          [
                            0.262,
                            -1.999
                          ],
                          [
                            -0.283,
                            -1.931
                          ],
                          [
                            -0.956,
                            -1.475
                          ],
                          [
                            -1.26,
                            -0.908
                          ],
                          [
                            -1.329,
                            -0.069
                          ],
                          [
                            -1.329,
                            2.84
                          ],
                          [
                            -2.264,
                            2.84
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.560999971278,
                        0.560999971278,
                        0.560999971278,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        90.761,
                        51.076
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 27",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 27,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.227,
                            0.468
                          ],
                          [
                            0,
                            0.574
                          ],
                          [
                            0.164,
                            0.324
                          ],
                          [
                            0.636,
                            0
                          ],
                          [
                            0.256,
                            -0.435
                          ],
                          [
                            0,
                            -0.615
                          ],
                          [
                            -0.256,
                            -0.393
                          ],
                          [
                            -0.557,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.228,
                            -0.468
                          ],
                          [
                            0,
                            -0.517
                          ],
                          [
                            -0.26,
                            -0.511
                          ],
                          [
                            -0.563,
                            0
                          ],
                          [
                            -0.256,
                            0.435
                          ],
                          [
                            0,
                            0.59
                          ],
                          [
                            0.256,
                            0.394
                          ],
                          [
                            0.612,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.254,
                            1.45
                          ],
                          [
                            1.595,
                            -0.112
                          ],
                          [
                            1.349,
                            -1.375
                          ],
                          [
                            0.005,
                            -2.142
                          ],
                          [
                            -1.225,
                            -1.489
                          ],
                          [
                            -1.611,
                            0.086
                          ],
                          [
                            -1.225,
                            1.561
                          ],
                          [
                            -0.005,
                            2.152
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.491,
                            -0.477
                          ],
                          [
                            0,
                            -0.926
                          ],
                          [
                            0.433,
                            -0.584
                          ],
                          [
                            0.909,
                            0
                          ],
                          [
                            0.446,
                            0.516
                          ],
                          [
                            0,
                            0.871
                          ],
                          [
                            -0.47,
                            0.553
                          ],
                          [
                            -0.793,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.491,
                            0.477
                          ],
                          [
                            0,
                            0.896
                          ],
                          [
                            -0.432,
                            0.584
                          ],
                          [
                            -0.759,
                            0
                          ],
                          [
                            -0.446,
                            -0.516
                          ],
                          [
                            0,
                            -0.932
                          ],
                          [
                            0.471,
                            -0.553
                          ],
                          [
                            0.711,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.834,
                            -2.241
                          ],
                          [
                            2.57,
                            -0.138
                          ],
                          [
                            1.921,
                            2.08
                          ],
                          [
                            -0.092,
                            2.956
                          ],
                          [
                            -1.9,
                            2.181
                          ],
                          [
                            -2.57,
                            0.1
                          ],
                          [
                            -1.865,
                            -2.127
                          ],
                          [
                            0.031,
                            -2.956
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.560999971278,
                        0.560999971278,
                        0.560999971278,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        84.781,
                        51.157
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 28",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 28,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0.126,
                            -0.047
                          ],
                          [
                            0.22,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            -0.104
                          ],
                          [
                            0,
                            -0.371
                          ],
                          [
                            -0.186,
                            -0.147
                          ],
                          [
                            -0.266,
                            0
                          ],
                          [
                            -0.355,
                            0.244
                          ],
                          [
                            -0.014,
                            0.647
                          ]
                        ],
                        "o": [
                          [
                            -0.124,
                            0.077
                          ],
                          [
                            -0.126,
                            0.048
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.413,
                            0.072
                          ],
                          [
                            -0.304,
                            0.176
                          ],
                          [
                            0,
                            0.329
                          ],
                          [
                            0.185,
                            0.147
                          ],
                          [
                            0.422,
                            0
                          ],
                          [
                            0.357,
                            -0.244
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.135,
                            0.075
                          ],
                          [
                            0.76,
                            0.261
                          ],
                          [
                            0.241,
                            0.393
                          ],
                          [
                            -0.198,
                            0.475
                          ],
                          [
                            -1.087,
                            0.739
                          ],
                          [
                            -1.543,
                            1.56
                          ],
                          [
                            -1.264,
                            2.275
                          ],
                          [
                            -0.586,
                            2.495
                          ],
                          [
                            0.58,
                            2.129
                          ],
                          [
                            1.135,
                            0.793
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.154,
                            0.067
                          ],
                          [
                            0,
                            0.249
                          ],
                          [
                            0.212,
                            0.115
                          ],
                          [
                            0.412,
                            0
                          ],
                          [
                            0.192,
                            -0.226
                          ],
                          [
                            0.046,
                            -0.284
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.322,
                            0.416
                          ],
                          [
                            -1.248,
                            0
                          ],
                          [
                            -0.631,
                            -0.321
                          ],
                          [
                            0,
                            -0.89
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.009,
                            -0.334
                          ],
                          [
                            -0.064,
                            -0.091
                          ],
                          [
                            -0.126,
                            -0.059
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.023,
                            0.131
                          ],
                          [
                            0.012,
                            0.167
                          ],
                          [
                            0.349,
                            -0.203
                          ],
                          [
                            0.527,
                            0
                          ],
                          [
                            0.438,
                            0.382
                          ],
                          [
                            0,
                            0.701
                          ],
                          [
                            -0.706,
                            0.407
                          ],
                          [
                            -0.752,
                            0.095
                          ]
                        ],
                        "o": [
                          [
                            0.36,
                            -0.045
                          ],
                          [
                            0.278,
                            -0.118
                          ],
                          [
                            0,
                            -0.302
                          ],
                          [
                            -0.213,
                            -0.115
                          ],
                          [
                            -0.463,
                            0
                          ],
                          [
                            -0.138,
                            0.167
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.041,
                            -0.646
                          ],
                          [
                            0.513,
                            -0.651
                          ],
                          [
                            0.813,
                            0
                          ],
                          [
                            0.631,
                            0.321
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.235
                          ],
                          [
                            0.014,
                            0.254
                          ],
                          [
                            0.063,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.058,
                            -0.149
                          ],
                          [
                            -0.022,
                            -0.131
                          ],
                          [
                            -0.269,
                            0.289
                          ],
                          [
                            -0.419,
                            0.24
                          ],
                          [
                            -0.673,
                            0
                          ],
                          [
                            -0.44,
                            -0.382
                          ],
                          [
                            0,
                            -0.909
                          ],
                          [
                            0.387,
                            -0.221
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.047,
                            -0.827
                          ],
                          [
                            0.725,
                            -0.996
                          ],
                          [
                            1.142,
                            -1.546
                          ],
                          [
                            0.823,
                            -2.173
                          ],
                          [
                            -0.116,
                            -2.346
                          ],
                          [
                            -1.098,
                            -2.007
                          ],
                          [
                            -1.374,
                            -1.329
                          ],
                          [
                            -3.238,
                            -1.329
                          ],
                          [
                            -2.693,
                            -2.922
                          ],
                          [
                            -0.052,
                            -3.899
                          ],
                          [
                            2.114,
                            -3.417
                          ],
                          [
                            3.061,
                            -1.6
                          ],
                          [
                            3.061,
                            1.79
                          ],
                          [
                            3.074,
                            2.644
                          ],
                          [
                            3.19,
                            3.16
                          ],
                          [
                            3.474,
                            3.384
                          ],
                          [
                            3.474,
                            3.668
                          ],
                          [
                            1.372,
                            3.668
                          ],
                          [
                            1.25,
                            3.248
                          ],
                          [
                            1.197,
                            2.801
                          ],
                          [
                            0.269,
                            3.539
                          ],
                          [
                            -1.15,
                            3.899
                          ],
                          [
                            -2.817,
                            3.326
                          ],
                          [
                            -3.475,
                            1.702
                          ],
                          [
                            -2.417,
                            -0.271
                          ],
                          [
                            -0.709,
                            -0.746
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        163.799,
                        36.936
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 29",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 29,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.484,
                            -0.4
                          ],
                          [
                            0,
                            -0.927
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.103,
                            0.208
                          ],
                          [
                            0.529,
                            0
                          ],
                          [
                            0.242,
                            -0.556
                          ],
                          [
                            0,
                            -0.456
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.221,
                            0.167
                          ],
                          [
                            -0.608,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.483,
                            0.4
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.389
                          ],
                          [
                            -0.189,
                            -0.38
                          ],
                          [
                            -0.651,
                            0
                          ],
                          [
                            -0.126,
                            0.294
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.248,
                            -0.38
                          ],
                          [
                            0.396,
                            -0.299
                          ],
                          [
                            0.761,
                            0
                          ]
                        ],
                        "v": [
                          [
                            2.61,
                            -3.184
                          ],
                          [
                            3.336,
                            -1.193
                          ],
                          [
                            3.336,
                            3.784
                          ],
                          [
                            1.356,
                            3.784
                          ],
                          [
                            1.356,
                            -0.711
                          ],
                          [
                            1.201,
                            -1.607
                          ],
                          [
                            0.124,
                            -2.177
                          ],
                          [
                            -1.215,
                            -1.343
                          ],
                          [
                            -1.404,
                            -0.218
                          ],
                          [
                            -1.404,
                            3.784
                          ],
                          [
                            -3.336,
                            3.784
                          ],
                          [
                            -3.336,
                            -3.594
                          ],
                          [
                            -1.465,
                            -3.594
                          ],
                          [
                            -1.465,
                            -2.516
                          ],
                          [
                            -0.763,
                            -3.336
                          ],
                          [
                            0.743,
                            -3.784
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        155.694,
                        36.821
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 30",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 30,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.98,
                            -2.363
                          ],
                          [
                            0.979,
                            -2.363
                          ],
                          [
                            0.979,
                            5.028
                          ],
                          [
                            -0.98,
                            5.028
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            0.979,
                            -3.245
                          ],
                          [
                            -0.98,
                            -3.245
                          ],
                          [
                            -0.98,
                            -5.028
                          ],
                          [
                            0.979,
                            -5.028
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        149.492,
                        35.577
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 31",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 31,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            0.966,
                            4.997
                          ],
                          [
                            -0.967,
                            4.997
                          ],
                          [
                            -0.967,
                            -4.997
                          ],
                          [
                            0.966,
                            -4.997
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        145.634,
                        35.607
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 32",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 32,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.303,
                            0.402
                          ],
                          [
                            0,
                            0.74
                          ],
                          [
                            0.303,
                            0.399
                          ],
                          [
                            0.565,
                            0
                          ],
                          [
                            0.305,
                            -0.4
                          ],
                          [
                            0,
                            -0.74
                          ],
                          [
                            -0.305,
                            -0.402
                          ],
                          [
                            -0.565,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.303,
                            -0.402
                          ],
                          [
                            0,
                            -0.74
                          ],
                          [
                            -0.303,
                            -0.4
                          ],
                          [
                            -0.565,
                            0
                          ],
                          [
                            -0.305,
                            0.399
                          ],
                          [
                            0,
                            0.74
                          ],
                          [
                            0.305,
                            0.402
                          ],
                          [
                            0.565,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.296,
                            1.716
                          ],
                          [
                            1.75,
                            0.004
                          ],
                          [
                            1.296,
                            -1.706
                          ],
                          [
                            -0.006,
                            -2.305
                          ],
                          [
                            -1.311,
                            -1.706
                          ],
                          [
                            -1.768,
                            0.004
                          ],
                          [
                            -1.311,
                            1.716
                          ],
                          [
                            -0.006,
                            2.319
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.624,
                            -0.77
                          ],
                          [
                            1.27,
                            0
                          ],
                          [
                            0.624,
                            0.77
                          ],
                          [
                            0,
                            1.084
                          ],
                          [
                            -0.624,
                            0.781
                          ],
                          [
                            -1.27,
                            0
                          ],
                          [
                            -0.624,
                            -0.782
                          ],
                          [
                            0,
                            -1.066
                          ]
                        ],
                        "o": [
                          [
                            -0.624,
                            0.77
                          ],
                          [
                            -1.27,
                            0
                          ],
                          [
                            -0.624,
                            -0.77
                          ],
                          [
                            0,
                            -1.066
                          ],
                          [
                            0.624,
                            -0.782
                          ],
                          [
                            1.27,
                            0
                          ],
                          [
                            0.624,
                            0.781
                          ],
                          [
                            0,
                            1.084
                          ]
                        ],
                        "v": [
                          [
                            2.842,
                            2.785
                          ],
                          [
                            0.001,
                            3.939
                          ],
                          [
                            -2.84,
                            2.785
                          ],
                          [
                            -3.776,
                            0.004
                          ],
                          [
                            -2.84,
                            -2.767
                          ],
                          [
                            0.001,
                            -3.939
                          ],
                          [
                            2.842,
                            -2.767
                          ],
                          [
                            3.777,
                            0.004
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        139.468,
                        36.915
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 33",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 33,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.025,
                            -0.002
                          ],
                          [
                            -0.086,
                            -0.004
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.096,
                            0.005
                          ],
                          [
                            0.058,
                            0
                          ],
                          [
                            0.267,
                            -0.507
                          ],
                          [
                            0,
                            -0.592
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.222,
                            0.181
                          ],
                          [
                            -0.578,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.024,
                            0.002
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.122,
                            -0.013
                          ],
                          [
                            -0.094,
                            -0.005
                          ],
                          [
                            -0.777,
                            0
                          ],
                          [
                            -0.149,
                            0.284
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.299,
                            -0.492
                          ],
                          [
                            0.361,
                            -0.303
                          ],
                          [
                            0.036,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.98,
                            -3.78
                          ],
                          [
                            2.146,
                            -3.77
                          ],
                          [
                            2.146,
                            -1.79
                          ],
                          [
                            1.82,
                            -1.817
                          ],
                          [
                            1.59,
                            -1.824
                          ],
                          [
                            0.024,
                            -1.064
                          ],
                          [
                            -0.2,
                            0.251
                          ],
                          [
                            -0.2,
                            3.783
                          ],
                          [
                            -2.146,
                            3.783
                          ],
                          [
                            -2.146,
                            -3.607
                          ],
                          [
                            -0.302,
                            -3.607
                          ],
                          [
                            -0.302,
                            -2.319
                          ],
                          [
                            0.478,
                            -3.329
                          ],
                          [
                            1.888,
                            -3.783
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        132.868,
                        36.821
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 34",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 34,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0.126,
                            -0.047
                          ],
                          [
                            0.22,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.179,
                            -0.104
                          ],
                          [
                            0,
                            -0.371
                          ],
                          [
                            -0.186,
                            -0.147
                          ],
                          [
                            -0.266,
                            0
                          ],
                          [
                            -0.356,
                            0.244
                          ],
                          [
                            -0.014,
                            0.647
                          ]
                        ],
                        "o": [
                          [
                            -0.124,
                            0.077
                          ],
                          [
                            -0.125,
                            0.048
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.413,
                            0.072
                          ],
                          [
                            -0.305,
                            0.176
                          ],
                          [
                            0,
                            0.329
                          ],
                          [
                            0.186,
                            0.147
                          ],
                          [
                            0.422,
                            0
                          ],
                          [
                            0.356,
                            -0.244
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.136,
                            0.075
                          ],
                          [
                            0.761,
                            0.261
                          ],
                          [
                            0.243,
                            0.393
                          ],
                          [
                            -0.198,
                            0.475
                          ],
                          [
                            -1.086,
                            0.739
                          ],
                          [
                            -1.543,
                            1.56
                          ],
                          [
                            -1.264,
                            2.275
                          ],
                          [
                            -0.586,
                            2.495
                          ],
                          [
                            0.582,
                            2.129
                          ],
                          [
                            1.136,
                            0.793
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.154,
                            0.067
                          ],
                          [
                            0,
                            0.249
                          ],
                          [
                            0.212,
                            0.115
                          ],
                          [
                            0.412,
                            0
                          ],
                          [
                            0.192,
                            -0.226
                          ],
                          [
                            0.046,
                            -0.284
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.322,
                            0.416
                          ],
                          [
                            -1.249,
                            0
                          ],
                          [
                            -0.631,
                            -0.321
                          ],
                          [
                            0,
                            -0.89
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.009,
                            -0.334
                          ],
                          [
                            -0.064,
                            -0.091
                          ],
                          [
                            -0.126,
                            -0.059
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.022,
                            0.131
                          ],
                          [
                            0.013,
                            0.167
                          ],
                          [
                            0.35,
                            -0.203
                          ],
                          [
                            0.528,
                            0
                          ],
                          [
                            0.439,
                            0.382
                          ],
                          [
                            0,
                            0.701
                          ],
                          [
                            -0.705,
                            0.407
                          ],
                          [
                            -0.751,
                            0.095
                          ]
                        ],
                        "o": [
                          [
                            0.359,
                            -0.045
                          ],
                          [
                            0.278,
                            -0.118
                          ],
                          [
                            0,
                            -0.302
                          ],
                          [
                            -0.213,
                            -0.115
                          ],
                          [
                            -0.463,
                            0
                          ],
                          [
                            -0.138,
                            0.167
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.041,
                            -0.646
                          ],
                          [
                            0.513,
                            -0.651
                          ],
                          [
                            0.812,
                            0
                          ],
                          [
                            0.631,
                            0.321
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.235
                          ],
                          [
                            0.014,
                            0.254
                          ],
                          [
                            0.063,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.059,
                            -0.149
                          ],
                          [
                            -0.023,
                            -0.131
                          ],
                          [
                            -0.269,
                            0.289
                          ],
                          [
                            -0.419,
                            0.24
                          ],
                          [
                            -0.673,
                            0
                          ],
                          [
                            -0.439,
                            -0.382
                          ],
                          [
                            0,
                            -0.909
                          ],
                          [
                            0.387,
                            -0.221
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.046,
                            -0.827
                          ],
                          [
                            0.726,
                            -0.996
                          ],
                          [
                            1.143,
                            -1.546
                          ],
                          [
                            0.824,
                            -2.173
                          ],
                          [
                            -0.115,
                            -2.346
                          ],
                          [
                            -1.098,
                            -2.007
                          ],
                          [
                            -1.373,
                            -1.329
                          ],
                          [
                            -3.238,
                            -1.329
                          ],
                          [
                            -2.693,
                            -2.922
                          ],
                          [
                            -0.051,
                            -3.899
                          ],
                          [
                            2.115,
                            -3.417
                          ],
                          [
                            3.062,
                            -1.6
                          ],
                          [
                            3.062,
                            1.79
                          ],
                          [
                            3.075,
                            2.644
                          ],
                          [
                            3.191,
                            3.16
                          ],
                          [
                            3.475,
                            3.384
                          ],
                          [
                            3.475,
                            3.668
                          ],
                          [
                            1.374,
                            3.668
                          ],
                          [
                            1.252,
                            3.248
                          ],
                          [
                            1.198,
                            2.801
                          ],
                          [
                            0.27,
                            3.539
                          ],
                          [
                            -1.15,
                            3.899
                          ],
                          [
                            -2.817,
                            3.326
                          ],
                          [
                            -3.475,
                            1.702
                          ],
                          [
                            -2.417,
                            -0.271
                          ],
                          [
                            -0.709,
                            -0.746
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        125.992,
                        36.936
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 35",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 35,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.926,
                            0.945
                          ],
                          [
                            -1.243,
                            0
                          ],
                          [
                            -0.769,
                            -1.103
                          ],
                          [
                            -0.031,
                            -0.624
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.208,
                            0.244
                          ],
                          [
                            0.73,
                            0
                          ],
                          [
                            0.429,
                            -0.613
                          ],
                          [
                            0,
                            -1.121
                          ],
                          [
                            -0.453,
                            -0.558
                          ],
                          [
                            -0.699,
                            0
                          ],
                          [
                            -0.376,
                            0.479
                          ],
                          [
                            -0.138,
                            0.516
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.736,
                            -0.683
                          ],
                          [
                            1.149,
                            0
                          ],
                          [
                            0.813,
                            0.922
                          ],
                          [
                            0,
                            1.614
                          ]
                        ],
                        "o": [
                          [
                            0.805,
                            -0.823
                          ],
                          [
                            1.664,
                            0
                          ],
                          [
                            0.425,
                            0.62
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.133,
                            -0.479
                          ],
                          [
                            -0.372,
                            -0.434
                          ],
                          [
                            -0.744,
                            0
                          ],
                          [
                            -0.43,
                            0.613
                          ],
                          [
                            0,
                            1.121
                          ],
                          [
                            0.453,
                            0.558
                          ],
                          [
                            0.716,
                            0
                          ],
                          [
                            0.208,
                            -0.258
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.179,
                            1.089
                          ],
                          [
                            -0.735,
                            0.682
                          ],
                          [
                            -1.422,
                            0
                          ],
                          [
                            -0.814,
                            -0.927
                          ],
                          [
                            0,
                            -1.744
                          ]
                        ],
                        "v": [
                          [
                            -3.008,
                            -3.997
                          ],
                          [
                            0.064,
                            -5.231
                          ],
                          [
                            3.713,
                            -3.577
                          ],
                          [
                            4.397,
                            -1.712
                          ],
                          [
                            2.309,
                            -1.712
                          ],
                          [
                            1.798,
                            -2.797
                          ],
                          [
                            0.144,
                            -3.448
                          ],
                          [
                            -1.616,
                            -2.529
                          ],
                          [
                            -2.26,
                            0.071
                          ],
                          [
                            -1.581,
                            2.59
                          ],
                          [
                            0.147,
                            3.427
                          ],
                          [
                            1.785,
                            2.709
                          ],
                          [
                            2.303,
                            1.549
                          ],
                          [
                            4.377,
                            1.549
                          ],
                          [
                            3.005,
                            4.207
                          ],
                          [
                            0.178,
                            5.231
                          ],
                          [
                            -3.175,
                            3.848
                          ],
                          [
                            -4.397,
                            0.037
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        117.11,
                        35.651
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 36",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 36,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0.126,
                            -0.047
                          ],
                          [
                            0.22,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.179,
                            -0.104
                          ],
                          [
                            0,
                            -0.371
                          ],
                          [
                            -0.186,
                            -0.147
                          ],
                          [
                            -0.266,
                            0
                          ],
                          [
                            -0.356,
                            0.244
                          ],
                          [
                            -0.014,
                            0.647
                          ]
                        ],
                        "o": [
                          [
                            -0.124,
                            0.077
                          ],
                          [
                            -0.125,
                            0.048
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.413,
                            0.072
                          ],
                          [
                            -0.305,
                            0.176
                          ],
                          [
                            0,
                            0.329
                          ],
                          [
                            0.186,
                            0.147
                          ],
                          [
                            0.422,
                            0
                          ],
                          [
                            0.356,
                            -0.244
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.136,
                            0.075
                          ],
                          [
                            0.761,
                            0.261
                          ],
                          [
                            0.243,
                            0.393
                          ],
                          [
                            -0.198,
                            0.475
                          ],
                          [
                            -1.085,
                            0.739
                          ],
                          [
                            -1.542,
                            1.56
                          ],
                          [
                            -1.264,
                            2.275
                          ],
                          [
                            -0.585,
                            2.495
                          ],
                          [
                            0.582,
                            2.129
                          ],
                          [
                            1.136,
                            0.793
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.154,
                            0.067
                          ],
                          [
                            0,
                            0.249
                          ],
                          [
                            0.212,
                            0.115
                          ],
                          [
                            0.412,
                            0
                          ],
                          [
                            0.192,
                            -0.226
                          ],
                          [
                            0.046,
                            -0.284
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.322,
                            0.416
                          ],
                          [
                            -1.249,
                            0
                          ],
                          [
                            -0.631,
                            -0.321
                          ],
                          [
                            0,
                            -0.89
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.009,
                            -0.334
                          ],
                          [
                            -0.064,
                            -0.091
                          ],
                          [
                            -0.126,
                            -0.059
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.022,
                            0.131
                          ],
                          [
                            0.013,
                            0.167
                          ],
                          [
                            0.35,
                            -0.203
                          ],
                          [
                            0.528,
                            0
                          ],
                          [
                            0.439,
                            0.382
                          ],
                          [
                            0,
                            0.701
                          ],
                          [
                            -0.705,
                            0.407
                          ],
                          [
                            -0.751,
                            0.095
                          ]
                        ],
                        "o": [
                          [
                            0.359,
                            -0.045
                          ],
                          [
                            0.278,
                            -0.118
                          ],
                          [
                            0,
                            -0.302
                          ],
                          [
                            -0.213,
                            -0.115
                          ],
                          [
                            -0.463,
                            0
                          ],
                          [
                            -0.138,
                            0.167
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.041,
                            -0.646
                          ],
                          [
                            0.513,
                            -0.651
                          ],
                          [
                            0.812,
                            0
                          ],
                          [
                            0.631,
                            0.321
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.235
                          ],
                          [
                            0.014,
                            0.254
                          ],
                          [
                            0.063,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.059,
                            -0.149
                          ],
                          [
                            -0.023,
                            -0.131
                          ],
                          [
                            -0.269,
                            0.289
                          ],
                          [
                            -0.419,
                            0.24
                          ],
                          [
                            -0.673,
                            0
                          ],
                          [
                            -0.439,
                            -0.382
                          ],
                          [
                            0,
                            -0.909
                          ],
                          [
                            0.387,
                            -0.221
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.046,
                            -0.827
                          ],
                          [
                            0.726,
                            -0.996
                          ],
                          [
                            1.143,
                            -1.546
                          ],
                          [
                            0.824,
                            -2.173
                          ],
                          [
                            -0.115,
                            -2.346
                          ],
                          [
                            -1.098,
                            -2.007
                          ],
                          [
                            -1.372,
                            -1.329
                          ],
                          [
                            -3.238,
                            -1.329
                          ],
                          [
                            -2.693,
                            -2.922
                          ],
                          [
                            -0.051,
                            -3.899
                          ],
                          [
                            2.115,
                            -3.417
                          ],
                          [
                            3.062,
                            -1.6
                          ],
                          [
                            3.062,
                            1.79
                          ],
                          [
                            3.075,
                            2.644
                          ],
                          [
                            3.191,
                            3.16
                          ],
                          [
                            3.475,
                            3.384
                          ],
                          [
                            3.475,
                            3.668
                          ],
                          [
                            1.374,
                            3.668
                          ],
                          [
                            1.252,
                            3.248
                          ],
                          [
                            1.198,
                            2.801
                          ],
                          [
                            0.27,
                            3.539
                          ],
                          [
                            -1.15,
                            3.899
                          ],
                          [
                            -2.816,
                            3.326
                          ],
                          [
                            -3.475,
                            1.702
                          ],
                          [
                            -2.417,
                            -0.271
                          ],
                          [
                            -0.708,
                            -0.746
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        104.384,
                        36.936
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 37",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 37,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.484,
                            -0.4
                          ],
                          [
                            0,
                            -0.927
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.103,
                            0.208
                          ],
                          [
                            0.529,
                            0
                          ],
                          [
                            0.242,
                            -0.556
                          ],
                          [
                            0,
                            -0.456
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.167
                          ],
                          [
                            -0.608,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.484,
                            0.4
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.389
                          ],
                          [
                            -0.189,
                            -0.38
                          ],
                          [
                            -0.65,
                            0
                          ],
                          [
                            -0.126,
                            0.294
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.248,
                            -0.38
                          ],
                          [
                            0.396,
                            -0.299
                          ],
                          [
                            0.761,
                            0
                          ]
                        ],
                        "v": [
                          [
                            2.61,
                            -3.184
                          ],
                          [
                            3.336,
                            -1.193
                          ],
                          [
                            3.336,
                            3.784
                          ],
                          [
                            1.356,
                            3.784
                          ],
                          [
                            1.356,
                            -0.711
                          ],
                          [
                            1.201,
                            -1.607
                          ],
                          [
                            0.124,
                            -2.177
                          ],
                          [
                            -1.215,
                            -1.343
                          ],
                          [
                            -1.404,
                            -0.218
                          ],
                          [
                            -1.404,
                            3.784
                          ],
                          [
                            -3.336,
                            3.784
                          ],
                          [
                            -3.336,
                            -3.594
                          ],
                          [
                            -1.465,
                            -3.594
                          ],
                          [
                            -1.465,
                            -2.516
                          ],
                          [
                            -0.763,
                            -3.336
                          ],
                          [
                            0.743,
                            -3.784
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        96.279,
                        36.821
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 38",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 38,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.303,
                            1.221
                          ],
                          [
                            1.257,
                            1.221
                          ],
                          [
                            -0.007,
                            -2.712
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.165,
                            -4.997
                          ],
                          [
                            1.197,
                            -4.997
                          ],
                          [
                            4.734,
                            4.997
                          ],
                          [
                            2.469,
                            4.997
                          ],
                          [
                            1.809,
                            2.943
                          ],
                          [
                            -1.872,
                            2.943
                          ],
                          [
                            -2.549,
                            4.997
                          ],
                          [
                            -4.734,
                            4.997
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        87.081,
                        35.607
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 39",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 39,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.22,
                            -0.226
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.215,
                            0.226
                          ],
                          [
                            0,
                            0.358
                          ],
                          [
                            0.215,
                            0.219
                          ],
                          [
                            0.394,
                            0
                          ],
                          [
                            0.22,
                            -0.219
                          ],
                          [
                            0,
                            -0.388
                          ]
                        ],
                        "o": [
                          [
                            0.22,
                            0.226
                          ],
                          [
                            0.394,
                            0
                          ],
                          [
                            0.215,
                            -0.226
                          ],
                          [
                            0,
                            -0.388
                          ],
                          [
                            -0.215,
                            -0.219
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.22,
                            0.219
                          ],
                          [
                            0,
                            0.358
                          ]
                        ],
                        "v": [
                          [
                            -0.911,
                            -1.394
                          ],
                          [
                            0.003,
                            -1.054
                          ],
                          [
                            0.917,
                            -1.394
                          ],
                          [
                            1.24,
                            -2.269
                          ],
                          [
                            0.917,
                            -3.179
                          ],
                          [
                            0.003,
                            -3.509
                          ],
                          [
                            -0.911,
                            -3.179
                          ],
                          [
                            -1.242,
                            -2.269
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.251,
                            -0.267
                          ],
                          [
                            -0.443,
                            0
                          ],
                          [
                            -0.251,
                            0.267
                          ],
                          [
                            0,
                            0.483
                          ],
                          [
                            0.256,
                            0.26
                          ],
                          [
                            0.434,
                            0
                          ],
                          [
                            0.255,
                            -0.26
                          ],
                          [
                            0,
                            -0.502
                          ]
                        ],
                        "o": [
                          [
                            0.251,
                            0.267
                          ],
                          [
                            0.443,
                            0
                          ],
                          [
                            0.25,
                            -0.267
                          ],
                          [
                            0,
                            -0.502
                          ],
                          [
                            -0.255,
                            -0.26
                          ],
                          [
                            -0.434,
                            0
                          ],
                          [
                            -0.256,
                            0.26
                          ],
                          [
                            0,
                            0.483
                          ]
                        ],
                        "v": [
                          [
                            -1.035,
                            3.082
                          ],
                          [
                            0.007,
                            3.481
                          ],
                          [
                            1.048,
                            3.082
                          ],
                          [
                            1.424,
                            1.957
                          ],
                          [
                            1.04,
                            0.814
                          ],
                          [
                            0.007,
                            0.423
                          ],
                          [
                            -1.027,
                            0.814
                          ],
                          [
                            -1.41,
                            1.957
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 2,
                    "ty": "sh",
                    "ix": 3,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.249,
                            0.448
                          ],
                          [
                            -0.481,
                            0.226
                          ],
                          [
                            0.143,
                            0.369
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            -0.539,
                            0.503
                          ],
                          [
                            -0.983,
                            0
                          ],
                          [
                            -0.539,
                            -0.504
                          ],
                          [
                            0,
                            -0.715
                          ],
                          [
                            0.142,
                            -0.368
                          ],
                          [
                            0.474,
                            -0.271
                          ],
                          [
                            -0.245,
                            -0.447
                          ],
                          [
                            0,
                            -0.552
                          ],
                          [
                            0.613,
                            -0.58
                          ],
                          [
                            1.099,
                            0
                          ],
                          [
                            0.566,
                            0.581
                          ],
                          [
                            0,
                            0.827
                          ]
                        ],
                        "o": [
                          [
                            0.249,
                            -0.447
                          ],
                          [
                            -0.477,
                            -0.317
                          ],
                          [
                            -0.143,
                            -0.368
                          ],
                          [
                            0,
                            -0.715
                          ],
                          [
                            0.539,
                            -0.504
                          ],
                          [
                            0.984,
                            0
                          ],
                          [
                            0.539,
                            0.503
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            -0.143,
                            0.369
                          ],
                          [
                            0.486,
                            0.271
                          ],
                          [
                            0.246,
                            0.448
                          ],
                          [
                            0,
                            0.827
                          ],
                          [
                            -0.613,
                            0.581
                          ],
                          [
                            -1.099,
                            0
                          ],
                          [
                            -0.565,
                            -0.58
                          ],
                          [
                            0,
                            -0.552
                          ]
                        ],
                        "v": [
                          [
                            -3.044,
                            0.587
                          ],
                          [
                            -1.949,
                            -0.423
                          ],
                          [
                            -2.878,
                            -1.452
                          ],
                          [
                            -3.092,
                            -2.484
                          ],
                          [
                            -2.283,
                            -4.311
                          ],
                          [
                            -0.001,
                            -5.069
                          ],
                          [
                            2.283,
                            -4.311
                          ],
                          [
                            3.092,
                            -2.484
                          ],
                          [
                            2.878,
                            -1.452
                          ],
                          [
                            1.952,
                            -0.491
                          ],
                          [
                            3.049,
                            0.587
                          ],
                          [
                            3.417,
                            2.085
                          ],
                          [
                            2.497,
                            4.197
                          ],
                          [
                            -0.072,
                            5.069
                          ],
                          [
                            -2.57,
                            4.197
                          ],
                          [
                            -3.417,
                            2.085
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        43.712,
                        5.958
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 40",
                "np": 7,
                "cix": 2,
                "bm": 0,
                "ix": 40,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.186,
                            -0.599
                          ],
                          [
                            -0.574,
                            0
                          ],
                          [
                            -0.179,
                            0.599
                          ],
                          [
                            0,
                            1.131
                          ],
                          [
                            0.178,
                            0.57
                          ],
                          [
                            0.574,
                            0
                          ],
                          [
                            0.185,
                            -0.569
                          ],
                          [
                            0,
                            -1.184
                          ]
                        ],
                        "o": [
                          [
                            0.185,
                            0.599
                          ],
                          [
                            0.574,
                            0
                          ],
                          [
                            0.178,
                            -0.599
                          ],
                          [
                            0,
                            -1.184
                          ],
                          [
                            -0.179,
                            -0.569
                          ],
                          [
                            -0.574,
                            0
                          ],
                          [
                            -0.186,
                            0.57
                          ],
                          [
                            0,
                            1.131
                          ]
                        ],
                        "v": [
                          [
                            -1.139,
                            2.6
                          ],
                          [
                            0,
                            3.499
                          ],
                          [
                            1.129,
                            2.6
                          ],
                          [
                            1.397,
                            0.007
                          ],
                          [
                            1.129,
                            -2.624
                          ],
                          [
                            0,
                            -3.478
                          ],
                          [
                            -1.139,
                            -2.624
                          ],
                          [
                            -1.417,
                            0.007
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.504,
                            -0.881
                          ],
                          [
                            0,
                            -1.622
                          ],
                          [
                            0.504,
                            -0.877
                          ],
                          [
                            1.252,
                            0
                          ],
                          [
                            0.504,
                            0.877
                          ],
                          [
                            0,
                            1.623
                          ],
                          [
                            -0.504,
                            0.882
                          ],
                          [
                            -1.252,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.504,
                            0.882
                          ],
                          [
                            0,
                            1.623
                          ],
                          [
                            -0.504,
                            0.877
                          ],
                          [
                            -1.252,
                            0
                          ],
                          [
                            -0.504,
                            -0.877
                          ],
                          [
                            0,
                            -1.622
                          ],
                          [
                            0.504,
                            -0.881
                          ],
                          [
                            1.252,
                            0
                          ]
                        ],
                        "v": [
                          [
                            2.634,
                            -3.749
                          ],
                          [
                            3.39,
                            0.007
                          ],
                          [
                            2.634,
                            3.757
                          ],
                          [
                            0,
                            5.072
                          ],
                          [
                            -2.634,
                            3.757
                          ],
                          [
                            -3.39,
                            0.007
                          ],
                          [
                            -2.634,
                            -3.749
                          ],
                          [
                            0,
                            -5.072
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        36.03,
                        5.941
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 41",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 41,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.027,
                            1.526
                          ],
                          [
                            1.027,
                            1.526
                          ],
                          [
                            1.027,
                            3.552
                          ],
                          [
                            -1.027,
                            3.552
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.027,
                            -3.552
                          ],
                          [
                            1.027,
                            -3.552
                          ],
                          [
                            1.027,
                            -1.526
                          ],
                          [
                            -1.027,
                            -1.526
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        30.182,
                        7.215
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 42",
                "np": 6,
                "cix": 2,
                "bm": 0,
                "ix": 42,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -0.285,
                            0.583
                          ],
                          [
                            -1.026,
                            0.732
                          ],
                          [
                            -0.263,
                            0.275
                          ],
                          [
                            0,
                            0.511
                          ],
                          [
                            0.231,
                            0.276
                          ],
                          [
                            0.43,
                            0
                          ],
                          [
                            0.212,
                            -0.438
                          ],
                          [
                            0.023,
                            -0.552
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.272,
                            0.515
                          ],
                          [
                            -1.317,
                            0
                          ],
                          [
                            -0.615,
                            -0.576
                          ],
                          [
                            0,
                            -0.949
                          ],
                          [
                            0.434,
                            -0.565
                          ],
                          [
                            0.652,
                            -0.461
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.178,
                            -0.154
                          ],
                          [
                            0.122,
                            -0.203
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0.276,
                            -0.656
                          ],
                          [
                            0.89,
                            -0.637
                          ],
                          [
                            0.402,
                            -0.43
                          ],
                          [
                            0,
                            -0.415
                          ],
                          [
                            -0.23,
                            -0.276
                          ],
                          [
                            -0.587,
                            0
                          ],
                          [
                            -0.123,
                            0.253
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.032,
                            -0.836
                          ],
                          [
                            0.516,
                            -0.981
                          ],
                          [
                            1.04,
                            0
                          ],
                          [
                            0.615,
                            0.576
                          ],
                          [
                            0,
                            0.728
                          ],
                          [
                            -0.285,
                            0.375
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.484,
                            0.343
                          ],
                          [
                            -0.179,
                            0.153
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.018,
                            -0.705
                          ]
                        ],
                        "v": [
                          [
                            -2.912,
                            3.007
                          ],
                          [
                            -0.959,
                            0.926
                          ],
                          [
                            0.77,
                            -0.444
                          ],
                          [
                            1.373,
                            -1.855
                          ],
                          [
                            1.027,
                            -2.892
                          ],
                          [
                            0.037,
                            -3.304
                          ],
                          [
                            -1.162,
                            -2.647
                          ],
                          [
                            -1.38,
                            -1.441
                          ],
                          [
                            -3.258,
                            -1.441
                          ],
                          [
                            -2.803,
                            -3.467
                          ],
                          [
                            -0.054,
                            -4.939
                          ],
                          [
                            2.43,
                            -4.074
                          ],
                          [
                            3.353,
                            -1.786
                          ],
                          [
                            2.701,
                            0.154
                          ],
                          [
                            1.295,
                            1.407
                          ],
                          [
                            0.52,
                            1.957
                          ],
                          [
                            -0.474,
                            2.702
                          ],
                          [
                            -0.925,
                            3.238
                          ],
                          [
                            3.366,
                            3.238
                          ],
                          [
                            3.366,
                            4.939
                          ],
                          [
                            -3.366,
                            4.939
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        23.659,
                        5.829
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 43",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 43,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.243,
                            0.054
                          ],
                          [
                            -0.244,
                            0.258
                          ],
                          [
                            -0.086,
                            0.294
                          ],
                          [
                            0,
                            0.086
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.608,
                            -0.027
                          ],
                          [
                            0.388,
                            -0.086
                          ],
                          [
                            0.167,
                            -0.176
                          ],
                          [
                            0.049,
                            -0.176
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -2.146,
                            -1.865
                          ],
                          [
                            -2.146,
                            -3.179
                          ],
                          [
                            -0.868,
                            -3.301
                          ],
                          [
                            0.079,
                            -3.817
                          ],
                          [
                            0.458,
                            -4.522
                          ],
                          [
                            0.532,
                            -4.915
                          ],
                          [
                            2.146,
                            -4.915
                          ],
                          [
                            2.146,
                            4.915
                          ],
                          [
                            0.166,
                            4.915
                          ],
                          [
                            0.166,
                            -1.865
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.991999966491,
                        0.991999966491,
                        0.991999966491,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        15.245,
                        5.852
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 44",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 44,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": 112,
            "op": 1058,
            "st": 121,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "WhatsScreen/conversas_whatsapp contornos",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 21,
                    "s": [
                      0
                    ]
                  },
                  {
                    "t": 41,
                    "s": [
                      100
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  174.75,
                  346.75,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  157.5,
                  268.5,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            157,
                            268
                          ],
                          [
                            -157,
                            268
                          ],
                          [
                            -157,
                            -268
                          ],
                          [
                            157,
                            -268
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.090000002992,
                        0.090000002992,
                        0.090000002992,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        157.25,
                        268.25
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": -7,
            "op": 1055,
            "st": 121,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "iphone",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": -4,
                    "s": [
                      0
                    ]
                  },
                  {
                    "t": 16,
                    "s": [
                      100
                    ]
                  }
                ],
                "ix": 11
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 10
              },
              "p": {
                "a": 0,
                "k": [
                  175,
                  354.5,
                  0
                ],
                "ix": 2,
                "l": 2
              },
              "a": {
                "a": 0,
                "k": [
                  175,
                  354.5,
                  0
                ],
                "ix": 1,
                "l": 2
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ],
                "ix": 6,
                "l": 2
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            -0.552,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.552
                          ]
                        ],
                        "o": [
                          [
                            0,
                            -0.552
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.552,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.5,
                            -21
                          ],
                          [
                            -0.5,
                            -22
                          ],
                          [
                            1.5,
                            -22
                          ],
                          [
                            1.5,
                            22
                          ],
                          [
                            -0.5,
                            22
                          ],
                          [
                            -1.5,
                            21
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.463000009574,
                        0.490000017952,
                        0.525,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        1.5,
                        226
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.552
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.552,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.552,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.552
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -1.5,
                            -22
                          ],
                          [
                            -1.5,
                            22
                          ],
                          [
                            0.5,
                            22
                          ],
                          [
                            1.5,
                            21
                          ],
                          [
                            1.5,
                            -21
                          ],
                          [
                            0.5,
                            -22
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.5,
                        0.5,
                        0.5,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        346.5,
                        167
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.552
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.552,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.552,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.552
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.5,
                            -22
                          ],
                          [
                            -1.5,
                            -21
                          ],
                          [
                            -1.5,
                            21
                          ],
                          [
                            -0.5,
                            22
                          ],
                          [
                            1.5,
                            22
                          ],
                          [
                            1.5,
                            -22
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.5,
                        0.5,
                        0.5,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        1.5,
                        167
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.552
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.552,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -0.552,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.552
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -0.5,
                            -17.5
                          ],
                          [
                            -1.5,
                            -16.5
                          ],
                          [
                            -1.5,
                            16.5
                          ],
                          [
                            -0.5,
                            17.5
                          ],
                          [
                            1.5,
                            17.5
                          ],
                          [
                            1.5,
                            -17.5
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.5,
                        0.5,
                        0.5,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        1.5,
                        98.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 4",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            2.481,
                            0
                          ],
                          [
                            0,
                            -2.481
                          ],
                          [
                            -2.481,
                            0
                          ],
                          [
                            0,
                            2.481
                          ]
                        ],
                        "o": [
                          [
                            -2.481,
                            0
                          ],
                          [
                            0,
                            2.481
                          ],
                          [
                            2.481,
                            0
                          ],
                          [
                            0,
                            -2.481
                          ]
                        ],
                        "v": [
                          [
                            0,
                            -4.5
                          ],
                          [
                            -4.5,
                            0
                          ],
                          [
                            0,
                            4.5
                          ],
                          [
                            4.5,
                            0
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            3.584,
                            0
                          ],
                          [
                            0,
                            3.584
                          ],
                          [
                            -3.584,
                            0
                          ],
                          [
                            0,
                            -3.584
                          ]
                        ],
                        "o": [
                          [
                            -3.584,
                            0
                          ],
                          [
                            0,
                            -3.584
                          ],
                          [
                            3.584,
                            0
                          ],
                          [
                            0,
                            3.584
                          ]
                        ],
                        "v": [
                          [
                            0,
                            6.5
                          ],
                          [
                            -6.5,
                            0
                          ],
                          [
                            0,
                            -6.5
                          ],
                          [
                            6.5,
                            0
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.113999998803,
                        0.136999990426,
                        0.156999999402,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        125,
                        46
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 5",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -3.038,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -3.038
                          ],
                          [
                            3.038,
                            0
                          ],
                          [
                            0,
                            3.038
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            3.038,
                            0
                          ],
                          [
                            0,
                            3.038
                          ],
                          [
                            -3.038,
                            0
                          ],
                          [
                            0,
                            -3.038
                          ]
                        ],
                        "v": [
                          [
                            0,
                            -5.5
                          ],
                          [
                            0,
                            -5.5
                          ],
                          [
                            5.5,
                            0
                          ],
                          [
                            0,
                            5.5
                          ],
                          [
                            -5.5,
                            0
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.141000007181,
                        0.161000001197,
                        0.184000007779,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        125,
                        46
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 6",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.654
                          ],
                          [
                            -1.654,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.654
                          ],
                          [
                            1.654,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -1.654,
                            0
                          ],
                          [
                            0,
                            1.654
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.654,
                            0
                          ],
                          [
                            0,
                            -1.654
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -26,
                            -3
                          ],
                          [
                            -29,
                            0
                          ],
                          [
                            -26,
                            3
                          ],
                          [
                            26,
                            3
                          ],
                          [
                            29,
                            0
                          ],
                          [
                            26,
                            -3
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            2.757,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.757
                          ],
                          [
                            -2.757,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.757
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -2.757,
                            0
                          ],
                          [
                            0,
                            -2.757
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.757,
                            0
                          ],
                          [
                            0,
                            2.757
                          ]
                        ],
                        "v": [
                          [
                            26,
                            5
                          ],
                          [
                            -26,
                            5
                          ],
                          [
                            -31,
                            0
                          ],
                          [
                            -26,
                            -5
                          ],
                          [
                            26,
                            -5
                          ],
                          [
                            31,
                            0
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.113999998803,
                        0.136999990426,
                        0.156999999402,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        174.5,
                        47.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 7",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 7,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -2.209,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.209
                          ],
                          [
                            2.209,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.209
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            2.209,
                            0
                          ],
                          [
                            0,
                            2.209
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.209,
                            0
                          ],
                          [
                            0,
                            -2.209
                          ]
                        ],
                        "v": [
                          [
                            -26,
                            -4
                          ],
                          [
                            26,
                            -4
                          ],
                          [
                            30,
                            0
                          ],
                          [
                            26,
                            4
                          ],
                          [
                            -26,
                            4
                          ],
                          [
                            -30,
                            0
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.141000007181,
                        0.161000001197,
                        0.184000007779,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        174.5,
                        47.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 8",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 8,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            -13.589
                          ],
                          [
                            13.836,
                            0
                          ],
                          [
                            0,
                            13.589
                          ],
                          [
                            -13.836,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            13.589
                          ],
                          [
                            -13.836,
                            0
                          ],
                          [
                            0,
                            -13.589
                          ],
                          [
                            13.836,
                            0
                          ]
                        ],
                        "v": [
                          [
                            25.053,
                            0
                          ],
                          [
                            0,
                            24.605
                          ],
                          [
                            -25.053,
                            0
                          ],
                          [
                            0,
                            -24.605
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            -15.188
                          ],
                          [
                            -15.464,
                            0
                          ],
                          [
                            0,
                            15.188
                          ],
                          [
                            15.464,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            15.188
                          ],
                          [
                            15.464,
                            0
                          ],
                          [
                            0,
                            -15.188
                          ],
                          [
                            -15.464,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -28,
                            0
                          ],
                          [
                            0,
                            27.5
                          ],
                          [
                            28,
                            0
                          ],
                          [
                            0,
                            -27.5
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.113999998803,
                        0.136999990426,
                        0.156999999402,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        176,
                        656.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 9",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 9,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            -14.636,
                            0
                          ],
                          [
                            0,
                            -14.636
                          ],
                          [
                            14.636,
                            0
                          ],
                          [
                            0,
                            14.636
                          ]
                        ],
                        "o": [
                          [
                            14.636,
                            0
                          ],
                          [
                            0,
                            14.636
                          ],
                          [
                            -14.636,
                            0
                          ],
                          [
                            0,
                            -14.636
                          ]
                        ],
                        "v": [
                          [
                            0,
                            -26.5
                          ],
                          [
                            26.5,
                            0
                          ],
                          [
                            0,
                            26.5
                          ],
                          [
                            -26.5,
                            0
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.141000007181,
                        0.161000001197,
                        0.184000007779,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        175.5,
                        656.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 10",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 10,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -3,
                            -7.5
                          ],
                          [
                            3,
                            -7.5
                          ],
                          [
                            3,
                            7.5
                          ],
                          [
                            -3,
                            7.5
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.5,
                        0.5,
                        0.5,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        6,
                        62.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 11",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 11,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            2.999,
                            7.5
                          ],
                          [
                            -2.999,
                            7.5
                          ],
                          [
                            -2.999,
                            -7.5
                          ],
                          [
                            2.999,
                            -7.5
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.5,
                        0.5,
                        0.5,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        341.999,
                        628.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 12",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 12,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -3,
                            -7.5
                          ],
                          [
                            3,
                            -7.5
                          ],
                          [
                            3,
                            7.5
                          ],
                          [
                            -3,
                            7.5
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.5,
                        0.5,
                        0.5,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        6,
                        628.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 13",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 13,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            2.999,
                            7.5
                          ],
                          [
                            -2.999,
                            7.5
                          ],
                          [
                            -2.999,
                            -7.5
                          ],
                          [
                            2.999,
                            -7.5
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.5,
                        0.5,
                        0.5,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        341.999,
                        62.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 14",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 14,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -30.649
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -30.674,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            30.65
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            30.672,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -30.674,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            30.65
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            30.672,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -30.649
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -115.461,
                            -350.5
                          ],
                          [
                            -171,
                            -295.005
                          ],
                          [
                            -171,
                            295.004
                          ],
                          [
                            -115.461,
                            350.5
                          ],
                          [
                            115.462,
                            350.5
                          ],
                          [
                            171,
                            295.004
                          ],
                          [
                            171,
                            -295.005
                          ],
                          [
                            115.462,
                            -350.5
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            27.423
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -27.445,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -27.423
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            27.444,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -27.423
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            27.444,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            27.423
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -27.445,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -165.154,
                            295.004
                          ],
                          [
                            -165.154,
                            -295.005
                          ],
                          [
                            -115.461,
                            -344.659
                          ],
                          [
                            115.462,
                            -344.659
                          ],
                          [
                            165.154,
                            -295.005
                          ],
                          [
                            165.154,
                            295.004
                          ],
                          [
                            115.462,
                            344.658
                          ],
                          [
                            -115.461,
                            344.658
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.5,
                        0.5,
                        0.5,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        174,
                        352.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 15",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 15,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            9.116,
                            -18.195
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -27.445,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -27.423
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            27.444,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            27.423
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -21.749,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -9.115,
                            18.195
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            21.748,
                            0
                          ]
                        ],
                        "o": [
                          [
                            -21.749,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -27.423
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            27.444,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            27.423
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -27.445,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            9.116,
                            18.195
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            21.748,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -9.115,
                            -18.194
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -115.461,
                            -350.5
                          ],
                          [
                            -165.154,
                            -319.816
                          ],
                          [
                            -165.154,
                            -295.005
                          ],
                          [
                            -115.461,
                            -344.659
                          ],
                          [
                            115.462,
                            -344.659
                          ],
                          [
                            165.154,
                            -295.005
                          ],
                          [
                            165.154,
                            295.004
                          ],
                          [
                            115.462,
                            344.658
                          ],
                          [
                            -115.461,
                            344.658
                          ],
                          [
                            -165.154,
                            295.004
                          ],
                          [
                            -165.154,
                            319.816
                          ],
                          [
                            -115.461,
                            350.5
                          ],
                          [
                            115.462,
                            350.5
                          ],
                          [
                            165.154,
                            319.814
                          ],
                          [
                            165.154,
                            -319.815
                          ],
                          [
                            115.462,
                            -350.5
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.5,
                        0.5,
                        0.5,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        174,
                        352.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 16",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 16,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            157.5,
                            262
                          ],
                          [
                            -156.5,
                            262
                          ],
                          [
                            -156.5,
                            -274
                          ],
                          [
                            157.5,
                            -274
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            30.673,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -30.65
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -30.674,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            30.65
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -30.674,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            30.65
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            30.673,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -30.65
                          ]
                        ],
                        "v": [
                          [
                            115.462,
                            -350.5
                          ],
                          [
                            -115.461,
                            -350.5
                          ],
                          [
                            -171,
                            -295.004
                          ],
                          [
                            -171,
                            295.004
                          ],
                          [
                            -115.461,
                            350.5
                          ],
                          [
                            115.462,
                            350.5
                          ],
                          [
                            171,
                            295.004
                          ],
                          [
                            171,
                            -295.004
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Caminho 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "mm",
                    "mm": 1,
                    "nm": "Mesclar caminhos 1",
                    "mn": "ADBE Vector Filter - Merge",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.141000007181,
                        0.161000001197,
                        0.184000007779,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Preenchimento 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        174,
                        352.5
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Grupo 17",
                "np": 4,
                "cix": 2,
                "bm": 0,
                "ix": 17,
                "mn": "ADBE Vector Group",
                "hd": false
              }
            ],
            "ip": -4,
            "op": 1053,
            "st": 121,
            "bm": 0
          }
        ]
      }
    ],
    "fonts": {
      "list": [
        {
          "fName": "Helvetica",
          "fFamily": "Helvetica",
          "fStyle": "Regular",
          "ascent": 71.97265625
        }
      ]
    },
    "layers": [
      {
        "ddd": 0,
        "ind": 1,
        "ty": 0,
        "nm": "Pre-comp 1",
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              500,
              500,
              0
            ],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [
              500,
              500,
              0
            ],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "w": 1000,
        "h": 1000,
        "ip": 0,
        "op": 1050,
        "st": 0,
        "bm": 0
      }
    ],
    "markers": [
      
    ],
    "chars": [
      {
        "ch": "M",
        "size": 16,
        "style": "Regular",
        "w": 83.3,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.081,
                          3.597
                        ],
                        [
                          0,
                          1.758
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.065,
                          -3.385
                        ],
                        [
                          0,
                          -1.465
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -1.692
                        ],
                        [
                          -0.082,
                          -3.596
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          3.874
                        ],
                        [
                          -0.066,
                          3.386
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          7.373,
                          0
                        ],
                        [
                          16.65,
                          0
                        ],
                        [
                          16.65,
                          -42.334
                        ],
                        [
                          16.528,
                          -50.269
                        ],
                        [
                          16.406,
                          -58.301
                        ],
                        [
                          16.406,
                          -60.498
                        ],
                        [
                          37.012,
                          0
                        ],
                        [
                          46.631,
                          0
                        ],
                        [
                          67.09,
                          -60.498
                        ],
                        [
                          66.992,
                          -49.609
                        ],
                        [
                          66.895,
                          -42.334
                        ],
                        [
                          66.895,
                          0
                        ],
                        [
                          76.123,
                          0
                        ],
                        [
                          76.123,
                          -71.729
                        ],
                        [
                          62.354,
                          -71.729
                        ],
                        [
                          41.895,
                          -11.084
                        ],
                        [
                          21.289,
                          -71.729
                        ],
                        [
                          7.373,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "M",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "M",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "e",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          3.711,
                          0
                        ],
                        [
                          4.557,
                          -5.241
                        ],
                        [
                          0,
                          -8.398
                        ],
                        [
                          -4.525,
                          -4.736
                        ],
                        [
                          -6.511,
                          0
                        ],
                        [
                          -2.116,
                          0.52
                        ],
                        [
                          -2.67,
                          2.605
                        ],
                        [
                          -1.286,
                          2.361
                        ],
                        [
                          -0.228,
                          1.921
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.563,
                          -1.758
                        ],
                        [
                          4.59,
                          0
                        ],
                        [
                          2.344,
                          3.207
                        ],
                        [
                          0.163,
                          5.306
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.52,
                          2.409
                        ],
                        [
                          1.758,
                          2.637
                        ],
                        [
                          3.483,
                          1.742
                        ]
                      ],
                      "o": [
                        [
                          -7.357,
                          0
                        ],
                        [
                          -4.558,
                          5.241
                        ],
                        [
                          0,
                          8.529
                        ],
                        [
                          4.524,
                          4.736
                        ],
                        [
                          2.669,
                          0
                        ],
                        [
                          3.938,
                          -0.912
                        ],
                        [
                          1.595,
                          -1.497
                        ],
                        [
                          1.286,
                          -2.36
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.652,
                          2.312
                        ],
                        [
                          -2.734,
                          3.027
                        ],
                        [
                          -4.916,
                          0
                        ],
                        [
                          -2.344,
                          -3.206
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -5.273
                        ],
                        [
                          -0.586,
                          -3.516
                        ],
                        [
                          -1.823,
                          -2.766
                        ],
                        [
                          -3.484,
                          -1.741
                        ]
                      ],
                      "v": [
                        [
                          28.223,
                          -53.467
                        ],
                        [
                          10.352,
                          -45.605
                        ],
                        [
                          3.516,
                          -25.146
                        ],
                        [
                          10.303,
                          -5.249
                        ],
                        [
                          26.855,
                          1.855
                        ],
                        [
                          34.033,
                          1.074
                        ],
                        [
                          43.945,
                          -4.199
                        ],
                        [
                          48.267,
                          -9.985
                        ],
                        [
                          50.537,
                          -16.406
                        ],
                        [
                          41.895,
                          -16.406
                        ],
                        [
                          38.574,
                          -10.303
                        ],
                        [
                          27.588,
                          -5.762
                        ],
                        [
                          16.699,
                          -10.571
                        ],
                        [
                          12.939,
                          -23.34
                        ],
                        [
                          51.27,
                          -23.34
                        ],
                        [
                          50.488,
                          -34.863
                        ],
                        [
                          46.973,
                          -44.092
                        ],
                        [
                          39.014,
                          -50.854
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "e",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          -2.734,
                          2.914
                        ],
                        [
                          -4.037,
                          0
                        ],
                        [
                          -2.409,
                          -4.231
                        ],
                        [
                          -0.359,
                          -3.809
                        ]
                      ],
                      "o": [
                        [
                          0.163,
                          -4.492
                        ],
                        [
                          2.734,
                          -2.913
                        ],
                        [
                          5.631,
                          0
                        ],
                        [
                          1.302,
                          2.279
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          13.184,
                          -30.322
                        ],
                        [
                          17.529,
                          -41.431
                        ],
                        [
                          27.686,
                          -45.801
                        ],
                        [
                          39.746,
                          -39.453
                        ],
                        [
                          42.236,
                          -30.322
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "e",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "e",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "r",
        "size": 16,
        "style": "Regular",
        "w": 33.3,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.377,
                          2.849
                        ],
                        [
                          -4.427,
                          0
                        ],
                        [
                          -0.439,
                          -0.032
                        ],
                        [
                          -0.521,
                          -0.098
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.391,
                          0.033
                        ],
                        [
                          0.163,
                          0
                        ],
                        [
                          2.669,
                          -2.522
                        ],
                        [
                          0.684,
                          -1.758
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -3.711
                        ],
                        [
                          2.376,
                          -2.848
                        ],
                        [
                          0.52,
                          0
                        ],
                        [
                          0.439,
                          0.033
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.945,
                          -0.098
                        ],
                        [
                          -0.391,
                          -0.032
                        ],
                        [
                          -3.484,
                          0
                        ],
                        [
                          -2.67,
                          2.523
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          6.689,
                          0
                        ],
                        [
                          15.479,
                          0
                        ],
                        [
                          15.479,
                          -30.078
                        ],
                        [
                          19.043,
                          -39.917
                        ],
                        [
                          29.248,
                          -44.189
                        ],
                        [
                          30.688,
                          -44.141
                        ],
                        [
                          32.129,
                          -43.945
                        ],
                        [
                          32.129,
                          -53.223
                        ],
                        [
                          30.127,
                          -53.418
                        ],
                        [
                          29.297,
                          -53.467
                        ],
                        [
                          20.068,
                          -49.683
                        ],
                        [
                          15.039,
                          -43.262
                        ],
                        [
                          15.039,
                          -52.295
                        ],
                        [
                          6.689,
                          -52.295
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "r",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "r",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "h",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.962,
                          2.507
                        ],
                        [
                          -3.646,
                          0
                        ],
                        [
                          -1.595,
                          -2.864
                        ],
                        [
                          0,
                          -3.841
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.465,
                          2.898
                        ],
                        [
                          7.584,
                          0
                        ],
                        [
                          2.832,
                          -1.855
                        ],
                        [
                          2.083,
                          -2.637
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -6.966
                        ],
                        [
                          2.962,
                          -2.506
                        ],
                        [
                          4.395,
                          0
                        ],
                        [
                          0.977,
                          1.791
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -5.143
                        ],
                        [
                          -2.702,
                          -5.305
                        ],
                        [
                          -4.232,
                          0
                        ],
                        [
                          -1.66,
                          1.074
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          6.445,
                          0
                        ],
                        [
                          15.234,
                          0
                        ],
                        [
                          15.234,
                          -27.734
                        ],
                        [
                          19.678,
                          -41.943
                        ],
                        [
                          29.59,
                          -45.703
                        ],
                        [
                          38.574,
                          -41.406
                        ],
                        [
                          40.039,
                          -32.959
                        ],
                        [
                          40.039,
                          0
                        ],
                        [
                          49.072,
                          0
                        ],
                        [
                          49.072,
                          -33.545
                        ],
                        [
                          46.875,
                          -45.605
                        ],
                        [
                          31.445,
                          -53.564
                        ],
                        [
                          20.85,
                          -50.781
                        ],
                        [
                          15.234,
                          -45.215
                        ],
                        [
                          15.234,
                          -71.973
                        ],
                        [
                          6.445,
                          -71.973
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "h",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "h",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "a",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          2.539
                        ],
                        [
                          -2.702,
                          1.53
                        ],
                        [
                          -3.191,
                          0.423
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.693,
                          0.456
                        ],
                        [
                          -1.074,
                          0.684
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          4.883,
                          -2.376
                        ],
                        [
                          3.092,
                          0
                        ],
                        [
                          1.855,
                          1.465
                        ]
                      ],
                      "o": [
                        [
                          0,
                          -3.352
                        ],
                        [
                          1.595,
                          -0.911
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.627,
                          -0.195
                        ],
                        [
                          1.692,
                          -0.455
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          5.404
                        ],
                        [
                          -2.898,
                          1.433
                        ],
                        [
                          -2.539,
                          0
                        ],
                        [
                          -1.855,
                          -1.465
                        ]
                      ],
                      "v": [
                        [
                          13.184,
                          -13.916
                        ],
                        [
                          17.236,
                          -21.24
                        ],
                        [
                          24.414,
                          -23.242
                        ],
                        [
                          29.736,
                          -23.926
                        ],
                        [
                          34.717,
                          -24.902
                        ],
                        [
                          38.867,
                          -26.611
                        ],
                        [
                          38.867,
                          -19.531
                        ],
                        [
                          31.543,
                          -7.861
                        ],
                        [
                          22.559,
                          -5.713
                        ],
                        [
                          15.967,
                          -7.91
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "a",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          3.027,
                          -2.669
                        ],
                        [
                          0,
                          -4.85
                        ],
                        [
                          -3.076,
                          -2.946
                        ],
                        [
                          -4.851,
                          0
                        ],
                        [
                          -3.353,
                          1.725
                        ],
                        [
                          -1.791,
                          2.344
                        ],
                        [
                          -0.716,
                          -1.139
                        ],
                        [
                          -3.027,
                          0
                        ],
                        [
                          -0.716,
                          0.098
                        ],
                        [
                          -1.367,
                          0.391
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.488,
                          -0.049
                        ],
                        [
                          0.391,
                          0
                        ],
                        [
                          0.374,
                          0.554
                        ],
                        [
                          0,
                          0.912
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.809,
                          2.344
                        ],
                        [
                          6.152,
                          0
                        ],
                        [
                          4.02,
                          -2.522
                        ],
                        [
                          0.163,
                          -6.445
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.074,
                          1.367
                        ],
                        [
                          -4.59,
                          0
                        ],
                        [
                          -2.132,
                          -1.35
                        ],
                        [
                          0,
                          -2.995
                        ],
                        [
                          0.391,
                          -0.781
                        ],
                        [
                          2.018,
                          -0.26
                        ]
                      ],
                      "o": [
                        [
                          -4.916,
                          0.619
                        ],
                        [
                          -3.027,
                          2.67
                        ],
                        [
                          0,
                          4.427
                        ],
                        [
                          3.076,
                          2.946
                        ],
                        [
                          4.036,
                          0
                        ],
                        [
                          3.352,
                          -1.725
                        ],
                        [
                          0.293,
                          2.084
                        ],
                        [
                          1.367,
                          2.148
                        ],
                        [
                          1.237,
                          0
                        ],
                        [
                          0.716,
                          -0.098
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.554,
                          0.098
                        ],
                        [
                          -0.488,
                          0.049
                        ],
                        [
                          -1.205,
                          0
                        ],
                        [
                          -0.375,
                          -0.553
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -4.948
                        ],
                        [
                          -3.841,
                          -2.344
                        ],
                        [
                          -5.306,
                          0
                        ],
                        [
                          -4.021,
                          2.523
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.325,
                          -2.702
                        ],
                        [
                          1.92,
                          -2.473
                        ],
                        [
                          3.971,
                          0
                        ],
                        [
                          2.132,
                          1.351
                        ],
                        [
                          0,
                          1.465
                        ],
                        [
                          -0.684,
                          1.433
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          20.459,
                          -29.932
                        ],
                        [
                          8.545,
                          -25
                        ],
                        [
                          4.004,
                          -13.721
                        ],
                        [
                          8.618,
                          -2.661
                        ],
                        [
                          20.508,
                          1.758
                        ],
                        [
                          31.592,
                          -0.83
                        ],
                        [
                          39.307,
                          -6.934
                        ],
                        [
                          40.82,
                          -2.1
                        ],
                        [
                          47.412,
                          1.123
                        ],
                        [
                          50.342,
                          0.977
                        ],
                        [
                          53.467,
                          0.244
                        ],
                        [
                          53.467,
                          -6.25
                        ],
                        [
                          51.904,
                          -6.03
                        ],
                        [
                          50.586,
                          -5.957
                        ],
                        [
                          48.218,
                          -6.787
                        ],
                        [
                          47.656,
                          -8.984
                        ],
                        [
                          47.656,
                          -39.111
                        ],
                        [
                          41.943,
                          -50.049
                        ],
                        [
                          26.953,
                          -53.564
                        ],
                        [
                          12.964,
                          -49.78
                        ],
                        [
                          6.689,
                          -36.328
                        ],
                        [
                          14.893,
                          -36.328
                        ],
                        [
                          16.992,
                          -42.432
                        ],
                        [
                          26.758,
                          -46.143
                        ],
                        [
                          35.913,
                          -44.116
                        ],
                        [
                          39.111,
                          -37.598
                        ],
                        [
                          38.525,
                          -34.229
                        ],
                        [
                          34.473,
                          -31.689
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "a",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "a",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "b",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.628,
                          -1.139
                        ],
                        [
                          -3.972,
                          0
                        ],
                        [
                          -4.004,
                          5.469
                        ],
                        [
                          0,
                          8.269
                        ],
                        [
                          4.053,
                          4.476
                        ],
                        [
                          6.51,
                          0
                        ],
                        [
                          2.669,
                          -1.318
                        ],
                        [
                          1.92,
                          -2.506
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.855,
                          2.507
                        ],
                        [
                          2.734,
                          1.92
                        ],
                        [
                          7.096,
                          0
                        ],
                        [
                          4.004,
                          -5.469
                        ],
                        [
                          0,
                          -8.723
                        ],
                        [
                          -4.053,
                          -4.475
                        ],
                        [
                          -3.125,
                          0
                        ],
                        [
                          -2.67,
                          1.318
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          5.762,
                          0
                        ],
                        [
                          13.867,
                          0
                        ],
                        [
                          13.867,
                          -6.689
                        ],
                        [
                          19.092,
                          -1.221
                        ],
                        [
                          29.15,
                          1.66
                        ],
                        [
                          45.801,
                          -6.543
                        ],
                        [
                          51.807,
                          -27.148
                        ],
                        [
                          45.728,
                          -46.948
                        ],
                        [
                          29.883,
                          -53.662
                        ],
                        [
                          21.191,
                          -51.685
                        ],
                        [
                          14.307,
                          -45.947
                        ],
                        [
                          14.307,
                          -71.973
                        ],
                        [
                          5.762,
                          -71.973
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "b",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          4.752,
                          0
                        ],
                        [
                          2.311,
                          5.762
                        ],
                        [
                          0,
                          4.916
                        ],
                        [
                          -3.011,
                          2.962
                        ],
                        [
                          -4.004,
                          0
                        ],
                        [
                          -2.361,
                          -3.613
                        ],
                        [
                          0,
                          -5.501
                        ],
                        [
                          2.36,
                          -3.776
                        ]
                      ],
                      "o": [
                        [
                          -6.316,
                          0
                        ],
                        [
                          -1.237,
                          -3.059
                        ],
                        [
                          0,
                          -6.803
                        ],
                        [
                          3.011,
                          -2.962
                        ],
                        [
                          4.59,
                          0
                        ],
                        [
                          2.36,
                          3.613
                        ],
                        [
                          0,
                          6.185
                        ],
                        [
                          -2.361,
                          3.777
                        ]
                      ],
                      "v": [
                        [
                          28.613,
                          -6.104
                        ],
                        [
                          15.674,
                          -14.746
                        ],
                        [
                          13.818,
                          -26.709
                        ],
                        [
                          18.335,
                          -41.357
                        ],
                        [
                          28.857,
                          -45.801
                        ],
                        [
                          39.282,
                          -40.381
                        ],
                        [
                          42.822,
                          -26.709
                        ],
                        [
                          39.282,
                          -11.768
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "b",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "b",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "1",
        "size": 16,
        "style": "Regular",
        "w": 48.24,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.506,
                          -1.448
                        ],
                        [
                          6.348,
                          -0.618
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.237,
                          5.404
                        ],
                        [
                          -2.507,
                          1.449
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          26.025,
                          -49.512
                        ],
                        [
                          26.025,
                          0
                        ],
                        [
                          35.4,
                          0
                        ],
                        [
                          35.4,
                          -69.629
                        ],
                        [
                          28.467,
                          -69.629
                        ],
                        [
                          22.852,
                          -59.351
                        ],
                        [
                          9.57,
                          -56.25
                        ],
                        [
                          9.57,
                          -49.512
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": " ",
        "size": 16,
        "style": "Regular",
        "w": 27.78,
        "data": {
          
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "C",
        "size": 16,
        "style": "Regular",
        "w": 72.22,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          9.082,
                          0
                        ],
                        [
                          6.055,
                          -7.356
                        ],
                        [
                          0,
                          -10.579
                        ],
                        [
                          -7.455,
                          -6.673
                        ],
                        [
                          -8.334,
                          0
                        ],
                        [
                          -5.697,
                          6.152
                        ],
                        [
                          -0.847,
                          7.552
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.985,
                          -2.897
                        ],
                        [
                          7.161,
                          0
                        ],
                        [
                          3.922,
                          5.225
                        ],
                        [
                          0,
                          8.398
                        ],
                        [
                          -4.346,
                          4.964
                        ],
                        [
                          -7.064,
                          0
                        ],
                        [
                          -3.207,
                          -2.702
                        ],
                        [
                          -1.074,
                          -4.622
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          5.013,
                          4.785
                        ]
                      ],
                      "o": [
                        [
                          -10.645,
                          0
                        ],
                        [
                          -5.599,
                          6.771
                        ],
                        [
                          0,
                          13.933
                        ],
                        [
                          5.664,
                          5.046
                        ],
                        [
                          9.668,
                          0
                        ],
                        [
                          4.752,
                          -5.11
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.977,
                          4.72
                        ],
                        [
                          -3.744,
                          5.502
                        ],
                        [
                          -7.78,
                          0
                        ],
                        [
                          -3.923,
                          -5.225
                        ],
                        [
                          0,
                          -10.254
                        ],
                        [
                          4.346,
                          -4.964
                        ],
                        [
                          5.794,
                          0
                        ],
                        [
                          3.206,
                          2.702
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.554,
                          -6.087
                        ],
                        [
                          -5.013,
                          -4.785
                        ]
                      ],
                      "v": [
                        [
                          37.842,
                          -73.682
                        ],
                        [
                          12.793,
                          -62.646
                        ],
                        [
                          4.395,
                          -36.621
                        ],
                        [
                          15.576,
                          -5.713
                        ],
                        [
                          36.572,
                          1.855
                        ],
                        [
                          59.619,
                          -7.373
                        ],
                        [
                          68.018,
                          -26.367
                        ],
                        [
                          58.545,
                          -26.367
                        ],
                        [
                          54.102,
                          -14.941
                        ],
                        [
                          37.744,
                          -6.689
                        ],
                        [
                          20.19,
                          -14.526
                        ],
                        [
                          14.307,
                          -34.961
                        ],
                        [
                          20.825,
                          -57.788
                        ],
                        [
                          37.939,
                          -65.234
                        ],
                        [
                          51.44,
                          -61.182
                        ],
                        [
                          57.861,
                          -50.195
                        ],
                        [
                          67.334,
                          -50.195
                        ],
                        [
                          58.984,
                          -66.504
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "C",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "C",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "i",
        "size": 16,
        "style": "Regular",
        "w": 22.22,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          6.445,
                          0
                        ],
                        [
                          15.381,
                          0
                        ],
                        [
                          15.381,
                          -52.051
                        ],
                        [
                          6.445,
                          -52.051
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "i",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          6.445,
                          -61.768
                        ],
                        [
                          15.381,
                          -61.768
                        ],
                        [
                          15.381,
                          -71.729
                        ],
                        [
                          6.445,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "i",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "i",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "o",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          5.827,
                          0
                        ],
                        [
                          2.441,
                          3.711
                        ],
                        [
                          0,
                          5.566
                        ],
                        [
                          -2.441,
                          4.102
                        ],
                        [
                          -5.371,
                          0
                        ],
                        [
                          -2.474,
                          -4.817
                        ],
                        [
                          0,
                          -4.883
                        ],
                        [
                          2.164,
                          -4.411
                        ]
                      ],
                      "o": [
                        [
                          -5.306,
                          0
                        ],
                        [
                          -2.441,
                          -3.711
                        ],
                        [
                          0,
                          -5.794
                        ],
                        [
                          2.441,
                          -4.102
                        ],
                        [
                          6.055,
                          0
                        ],
                        [
                          1.563,
                          3.06
                        ],
                        [
                          0,
                          5.404
                        ],
                        [
                          -2.165,
                          4.411
                        ]
                      ],
                      "v": [
                        [
                          27.197,
                          -5.664
                        ],
                        [
                          15.576,
                          -11.23
                        ],
                        [
                          11.914,
                          -25.146
                        ],
                        [
                          15.576,
                          -39.99
                        ],
                        [
                          27.295,
                          -46.143
                        ],
                        [
                          40.088,
                          -38.916
                        ],
                        [
                          42.432,
                          -27.002
                        ],
                        [
                          39.185,
                          -12.28
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "o",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          6.738,
                          0
                        ],
                        [
                          4.459,
                          -5.208
                        ],
                        [
                          0,
                          -8.789
                        ],
                        [
                          -4.232,
                          -4.866
                        ],
                        [
                          -7.195,
                          0
                        ],
                        [
                          -4.102,
                          5.502
                        ],
                        [
                          0,
                          8.431
                        ],
                        [
                          4.655,
                          4.492
                        ]
                      ],
                      "o": [
                        [
                          -7.52,
                          0
                        ],
                        [
                          -4.46,
                          5.209
                        ],
                        [
                          0,
                          8.203
                        ],
                        [
                          4.231,
                          4.867
                        ],
                        [
                          8.626,
                          0
                        ],
                        [
                          4.102,
                          -5.501
                        ],
                        [
                          0,
                          -8.723
                        ],
                        [
                          -4.655,
                          -4.492
                        ]
                      ],
                      "v": [
                        [
                          27.539,
                          -53.809
                        ],
                        [
                          9.57,
                          -45.996
                        ],
                        [
                          2.881,
                          -25
                        ],
                        [
                          9.229,
                          -5.396
                        ],
                        [
                          26.367,
                          1.904
                        ],
                        [
                          45.459,
                          -6.348
                        ],
                        [
                          51.611,
                          -27.246
                        ],
                        [
                          44.629,
                          -47.07
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "o",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "o",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "\r",
        "size": 16,
        "style": "Regular",
        "w": 0,
        "fFamily": "Helvetica"
      },
      {
        "ch": "2",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0.325,
                          -6.022
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.255,
                          2.832
                        ],
                        [
                          -3.191,
                          1.758
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.279,
                          2.312
                        ],
                        [
                          0,
                          5.599
                        ],
                        [
                          3.694,
                          4.33
                        ],
                        [
                          8.008,
                          0
                        ],
                        [
                          3.809,
                          -6.77
                        ],
                        [
                          0.098,
                          -6.087
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.237,
                          2.441
                        ],
                        [
                          -6.023,
                          0
                        ],
                        [
                          -2.441,
                          -2.393
                        ],
                        [
                          0,
                          -4.069
                        ],
                        [
                          2.669,
                          -2.702
                        ],
                        [
                          4.199,
                          -2.441
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.164,
                          -4.459
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.846,
                          -3.45
                        ],
                        [
                          1.823,
                          -1.595
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          5.891,
                          -3.288
                        ],
                        [
                          3.938,
                          -3.971
                        ],
                        [
                          0,
                          -5.305
                        ],
                        [
                          -3.695,
                          -4.329
                        ],
                        [
                          -9.636,
                          0
                        ],
                        [
                          -2.148,
                          3.841
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.13,
                          -4.329
                        ],
                        [
                          2.311,
                          -4.557
                        ],
                        [
                          4.069,
                          0
                        ],
                        [
                          2.441,
                          2.393
                        ],
                        [
                          0,
                          3.484
                        ],
                        [
                          -1.693,
                          1.726
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -6.283,
                          3.646
                        ],
                        [
                          -2.165,
                          4.46
                        ]
                      ],
                      "v": [
                        [
                          3.125,
                          0
                        ],
                        [
                          51.123,
                          0
                        ],
                        [
                          51.123,
                          -8.301
                        ],
                        [
                          12.939,
                          -8.301
                        ],
                        [
                          19.092,
                          -17.725
                        ],
                        [
                          26.611,
                          -22.754
                        ],
                        [
                          33.301,
                          -26.465
                        ],
                        [
                          45.557,
                          -34.863
                        ],
                        [
                          51.465,
                          -49.219
                        ],
                        [
                          45.923,
                          -63.672
                        ],
                        [
                          28.369,
                          -70.166
                        ],
                        [
                          8.203,
                          -60.01
                        ],
                        [
                          4.834,
                          -45.117
                        ],
                        [
                          13.77,
                          -45.117
                        ],
                        [
                          15.82,
                          -55.273
                        ],
                        [
                          28.32,
                          -62.109
                        ],
                        [
                          38.086,
                          -58.521
                        ],
                        [
                          41.748,
                          -48.828
                        ],
                        [
                          37.744,
                          -39.551
                        ],
                        [
                          28.906,
                          -33.301
                        ],
                        [
                          19.531,
                          -27.881
                        ],
                        [
                          6.86,
                          -15.723
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "2",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "l",
        "size": 16,
        "style": "Regular",
        "w": 22.22,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          6.689,
                          0
                        ],
                        [
                          15.479,
                          0
                        ],
                        [
                          15.479,
                          -71.729
                        ],
                        [
                          6.689,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "l",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "l",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "y",
        "size": 16,
        "style": "Regular",
        "w": 50,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.009,
                          -2.409
                        ],
                        [
                          0.163,
                          -0.261
                        ],
                        [
                          0.764,
                          -0.537
                        ],
                        [
                          1.627,
                          0
                        ],
                        [
                          0.684,
                          0.098
                        ],
                        [
                          1.53,
                          0.423
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.668,
                          -0.098
                        ],
                        [
                          -1.237,
                          0
                        ],
                        [
                          -2.084,
                          2.93
                        ],
                        [
                          -5.078,
                          13.346
                        ],
                        [
                          -3.191,
                          8.984
                        ],
                        [
                          -1.237,
                          3.353
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.456,
                          1.172
                        ],
                        [
                          -1.009,
                          2.409
                        ],
                        [
                          -0.521,
                          0.781
                        ],
                        [
                          -0.765,
                          0.537
                        ],
                        [
                          -0.521,
                          0
                        ],
                        [
                          -0.684,
                          -0.098
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.977,
                          0.26
                        ],
                        [
                          0.667,
                          0.098
                        ],
                        [
                          5.078,
                          0
                        ],
                        [
                          2.083,
                          -2.93
                        ],
                        [
                          2.148,
                          -5.664
                        ],
                        [
                          4.264,
                          -11.946
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          25,
                          -9.717
                        ],
                        [
                          10.986,
                          -52.295
                        ],
                        [
                          1.025,
                          -52.295
                        ],
                        [
                          20.361,
                          1.514
                        ],
                        [
                          18.164,
                          6.885
                        ],
                        [
                          16.406,
                          10.889
                        ],
                        [
                          14.478,
                          12.866
                        ],
                        [
                          10.889,
                          13.672
                        ],
                        [
                          9.082,
                          13.525
                        ],
                        [
                          5.762,
                          12.744
                        ],
                        [
                          5.762,
                          20.752
                        ],
                        [
                          8.228,
                          21.289
                        ],
                        [
                          11.084,
                          21.436
                        ],
                        [
                          21.826,
                          17.041
                        ],
                        [
                          32.568,
                          -7.373
                        ],
                        [
                          40.576,
                          -29.346
                        ],
                        [
                          48.828,
                          -52.295
                        ],
                        [
                          39.111,
                          -52.295
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "y",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "y",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "t",
        "size": 16,
        "style": "Regular",
        "w": 27.78,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.465,
                          -2.1
                        ],
                        [
                          -4.102,
                          0
                        ],
                        [
                          -1.091,
                          0.13
                        ],
                        [
                          -1.009,
                          0.293
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.488,
                          -0.016
                        ],
                        [
                          0.423,
                          0
                        ],
                        [
                          0.684,
                          0.359
                        ],
                        [
                          0,
                          1.823
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          3.353
                        ],
                        [
                          1.465,
                          2.1
                        ],
                        [
                          1.27,
                          0
                        ],
                        [
                          1.09,
                          -0.13
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.652,
                          0.066
                        ],
                        [
                          -0.488,
                          0.017
                        ],
                        [
                          -1.595,
                          0
                        ],
                        [
                          -1.237,
                          -0.618
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          8.203,
                          -52.295
                        ],
                        [
                          1.123,
                          -52.295
                        ],
                        [
                          1.123,
                          -45.117
                        ],
                        [
                          8.203,
                          -45.117
                        ],
                        [
                          8.203,
                          -10.498
                        ],
                        [
                          10.4,
                          -2.319
                        ],
                        [
                          18.75,
                          0.83
                        ],
                        [
                          22.29,
                          0.635
                        ],
                        [
                          25.439,
                          0
                        ],
                        [
                          25.439,
                          -6.934
                        ],
                        [
                          23.73,
                          -6.812
                        ],
                        [
                          22.363,
                          -6.787
                        ],
                        [
                          18.945,
                          -7.324
                        ],
                        [
                          17.09,
                          -10.986
                        ],
                        [
                          17.09,
                          -45.117
                        ],
                        [
                          25.439,
                          -45.117
                        ],
                        [
                          25.439,
                          -52.295
                        ],
                        [
                          17.09,
                          -52.295
                        ],
                        [
                          17.09,
                          -66.895
                        ],
                        [
                          8.203,
                          -66.895
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "t",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "t",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "3",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          -8.269,
                          0
                        ],
                        [
                          -4.395,
                          4.199
                        ],
                        [
                          0,
                          6.673
                        ],
                        [
                          2.067,
                          2.881
                        ],
                        [
                          3.678,
                          1.009
                        ],
                        [
                          -1.433,
                          1.66
                        ],
                        [
                          0,
                          4.297
                        ],
                        [
                          3.906,
                          3.174
                        ],
                        [
                          7.129,
                          0
                        ],
                        [
                          3.58,
                          -6.51
                        ],
                        [
                          0,
                          -5.208
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.237,
                          2.148
                        ],
                        [
                          -5.859,
                          0
                        ],
                        [
                          -2.474,
                          -1.888
                        ],
                        [
                          0,
                          -3.483
                        ],
                        [
                          3.711,
                          -1.823
                        ],
                        [
                          3.288,
                          0
                        ],
                        [
                          0.618,
                          0.033
                        ],
                        [
                          0.911,
                          0.098
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.603,
                          0.017
                        ],
                        [
                          -0.586,
                          0
                        ],
                        [
                          -2.946,
                          -1.92
                        ],
                        [
                          0,
                          -4.817
                        ],
                        [
                          2.799,
                          -2.473
                        ],
                        [
                          4.622,
                          0
                        ],
                        [
                          2.278,
                          3.679
                        ],
                        [
                          0.391,
                          4.525
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.728,
                          -4.541
                        ]
                      ],
                      "o": [
                        [
                          8.073,
                          0
                        ],
                        [
                          4.395,
                          -4.199
                        ],
                        [
                          0,
                          -4.166
                        ],
                        [
                          -2.068,
                          -2.881
                        ],
                        [
                          2.278,
                          -0.944
                        ],
                        [
                          2.311,
                          -2.669
                        ],
                        [
                          0,
                          -6.022
                        ],
                        [
                          -3.906,
                          -3.174
                        ],
                        [
                          -9.017,
                          0
                        ],
                        [
                          -2.084,
                          3.646
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.163,
                          -3.971
                        ],
                        [
                          2.246,
                          -3.906
                        ],
                        [
                          3.288,
                          0
                        ],
                        [
                          2.473,
                          1.888
                        ],
                        [
                          0,
                          4.688
                        ],
                        [
                          -2.116,
                          1.042
                        ],
                        [
                          -0.716,
                          0
                        ],
                        [
                          -0.619,
                          -0.032
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.618,
                          -0.032
                        ],
                        [
                          0.602,
                          -0.016
                        ],
                        [
                          5.241,
                          0
                        ],
                        [
                          2.946,
                          1.921
                        ],
                        [
                          0,
                          3.906
                        ],
                        [
                          -2.8,
                          2.474
                        ],
                        [
                          -5.957,
                          0
                        ],
                        [
                          -1.302,
                          -2.051
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          6.511
                        ],
                        [
                          3.727,
                          4.541
                        ]
                      ],
                      "v": [
                        [
                          25.977,
                          1.904
                        ],
                        [
                          44.678,
                          -4.395
                        ],
                        [
                          51.27,
                          -20.703
                        ],
                        [
                          48.169,
                          -31.274
                        ],
                        [
                          39.551,
                          -37.109
                        ],
                        [
                          45.117,
                          -41.016
                        ],
                        [
                          48.584,
                          -51.465
                        ],
                        [
                          42.725,
                          -65.259
                        ],
                        [
                          26.172,
                          -70.02
                        ],
                        [
                          7.275,
                          -60.254
                        ],
                        [
                          4.15,
                          -46.973
                        ],
                        [
                          12.842,
                          -46.973
                        ],
                        [
                          14.941,
                          -56.152
                        ],
                        [
                          27.1,
                          -62.012
                        ],
                        [
                          35.742,
                          -59.18
                        ],
                        [
                          39.453,
                          -51.123
                        ],
                        [
                          33.887,
                          -41.357
                        ],
                        [
                          25.781,
                          -39.795
                        ],
                        [
                          23.779,
                          -39.844
                        ],
                        [
                          21.484,
                          -40.039
                        ],
                        [
                          21.484,
                          -32.275
                        ],
                        [
                          23.315,
                          -32.349
                        ],
                        [
                          25.098,
                          -32.373
                        ],
                        [
                          37.378,
                          -29.492
                        ],
                        [
                          41.797,
                          -19.385
                        ],
                        [
                          37.598,
                          -9.814
                        ],
                        [
                          26.465,
                          -6.104
                        ],
                        [
                          14.111,
                          -11.621
                        ],
                        [
                          11.572,
                          -21.484
                        ],
                        [
                          2.393,
                          -21.484
                        ],
                        [
                          7.983,
                          -4.907
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "3",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "F",
        "size": 16,
        "style": "Regular",
        "w": 61.08,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          8.545,
                          0
                        ],
                        [
                          18.262,
                          0
                        ],
                        [
                          18.262,
                          -32.617
                        ],
                        [
                          53.467,
                          -32.617
                        ],
                        [
                          53.467,
                          -41.162
                        ],
                        [
                          18.262,
                          -41.162
                        ],
                        [
                          18.262,
                          -62.939
                        ],
                        [
                          58.301,
                          -62.939
                        ],
                        [
                          58.301,
                          -71.729
                        ],
                        [
                          8.545,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "F",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "F",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "u",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.465,
                          -2.669
                        ],
                        [
                          -7.455,
                          0
                        ],
                        [
                          -3.353,
                          2.734
                        ],
                        [
                          -1.14,
                          1.986
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.204,
                          -2.93
                        ],
                        [
                          6.12,
                          0
                        ],
                        [
                          1.563,
                          3.125
                        ],
                        [
                          0,
                          2.67
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          4.46
                        ],
                        [
                          2.702,
                          4.98
                        ],
                        [
                          4.785,
                          0
                        ],
                        [
                          1.692,
                          -1.367
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          5.111
                        ],
                        [
                          -2.214,
                          5.469
                        ],
                        [
                          -4.265,
                          0
                        ],
                        [
                          -0.847,
                          -1.692
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          6.25,
                          -52.295
                        ],
                        [
                          6.25,
                          -16.748
                        ],
                        [
                          8.447,
                          -6.055
                        ],
                        [
                          23.682,
                          1.416
                        ],
                        [
                          35.889,
                          -2.686
                        ],
                        [
                          40.137,
                          -7.715
                        ],
                        [
                          40.039,
                          0
                        ],
                        [
                          48.34,
                          0
                        ],
                        [
                          48.34,
                          -52.295
                        ],
                        [
                          39.551,
                          -52.295
                        ],
                        [
                          39.551,
                          -26.611
                        ],
                        [
                          37.744,
                          -14.551
                        ],
                        [
                          25.244,
                          -6.348
                        ],
                        [
                          16.504,
                          -11.035
                        ],
                        [
                          15.234,
                          -17.578
                        ],
                        [
                          15.234,
                          -52.295
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "u",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "u",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "4",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          10.645,
                          -24.756
                        ],
                        [
                          33.057,
                          -56.445
                        ],
                        [
                          33.057,
                          -24.756
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          41.992,
                          0
                        ],
                        [
                          41.992,
                          -17.09
                        ],
                        [
                          52.295,
                          -17.09
                        ],
                        [
                          52.295,
                          -24.756
                        ],
                        [
                          41.992,
                          -24.756
                        ],
                        [
                          41.992,
                          -70.117
                        ],
                        [
                          34.57,
                          -70.117
                        ],
                        [
                          2.539,
                          -25.684
                        ],
                        [
                          2.539,
                          -17.09
                        ],
                        [
                          33.203,
                          -17.09
                        ],
                        [
                          33.203,
                          0
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "4",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "B",
        "size": 16,
        "style": "Regular",
        "w": 66.7,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.148,
                          -0.911
                        ],
                        [
                          0,
                          -4.688
                        ],
                        [
                          3.58,
                          -1.79
                        ],
                        [
                          4.102,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          4.231,
                          0
                        ],
                        [
                          3.809,
                          1.628
                        ],
                        [
                          0,
                          4.655
                        ],
                        [
                          -2.279,
                          1.14
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          16.895,
                          -41.406
                        ],
                        [
                          16.895,
                          -63.623
                        ],
                        [
                          34.229,
                          -63.623
                        ],
                        [
                          43.799,
                          -62.256
                        ],
                        [
                          49.512,
                          -52.783
                        ],
                        [
                          44.141,
                          -43.115
                        ],
                        [
                          34.57,
                          -41.406
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "B",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.474,
                          -1.009
                        ],
                        [
                          0,
                          -5.208
                        ],
                        [
                          1.595,
                          -2.18
                        ],
                        [
                          5.957,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          4.069,
                          0
                        ],
                        [
                          4.655,
                          1.888
                        ],
                        [
                          0,
                          3.093
                        ],
                        [
                          -2.539,
                          3.451
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          16.895,
                          -8.301
                        ],
                        [
                          16.895,
                          -33.545
                        ],
                        [
                          36.182,
                          -33.545
                        ],
                        [
                          45.996,
                          -32.031
                        ],
                        [
                          52.979,
                          -21.387
                        ],
                        [
                          50.586,
                          -13.477
                        ],
                        [
                          37.842,
                          -8.301
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "B",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -4.33,
                          5.599
                        ],
                        [
                          0,
                          4.623
                        ],
                        [
                          3.223,
                          3.125
                        ],
                        [
                          3.678,
                          1.4
                        ],
                        [
                          -1.335,
                          1.53
                        ],
                        [
                          0,
                          4.525
                        ],
                        [
                          2.083,
                          2.962
                        ],
                        [
                          8.398,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          9.44,
                          0
                        ],
                        [
                          2.897,
                          -3.743
                        ],
                        [
                          0,
                          -5.501
                        ],
                        [
                          -1.823,
                          -1.758
                        ],
                        [
                          2.506,
                          -1.27
                        ],
                        [
                          2.571,
                          -2.897
                        ],
                        [
                          0,
                          -3.873
                        ],
                        [
                          -3.548,
                          -5.013
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          7.373,
                          0
                        ],
                        [
                          37.695,
                          0
                        ],
                        [
                          58.35,
                          -8.398
                        ],
                        [
                          62.695,
                          -20.947
                        ],
                        [
                          57.861,
                          -33.887
                        ],
                        [
                          49.609,
                          -38.623
                        ],
                        [
                          55.371,
                          -42.822
                        ],
                        [
                          59.229,
                          -53.955
                        ],
                        [
                          56.104,
                          -64.209
                        ],
                        [
                          38.184,
                          -71.729
                        ],
                        [
                          7.373,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "B",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "B",
              "np": 6,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "ç",
        "size": 16,
        "style": "Regular",
        "w": 50,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          5.891,
                          0
                        ],
                        [
                          4.459,
                          -5.11
                        ],
                        [
                          0,
                          -9.18
                        ],
                        [
                          -4.688,
                          -5.305
                        ],
                        [
                          -4.623,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.57,
                          0.13
                        ],
                        [
                          -0.716,
                          0
                        ],
                        [
                          -0.863,
                          -0.765
                        ],
                        [
                          0,
                          -1.042
                        ],
                        [
                          1.692,
                          -0.684
                        ],
                        [
                          1.204,
                          0
                        ],
                        [
                          1.334,
                          0.358
                        ],
                        [
                          1.237,
                          0.455
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.042,
                          -0.261
                        ],
                        [
                          -1.726,
                          0
                        ],
                        [
                          -1.953,
                          1.79
                        ],
                        [
                          0,
                          2.473
                        ],
                        [
                          1.481,
                          1.318
                        ],
                        [
                          2.278,
                          0
                        ],
                        [
                          0.944,
                          -0.293
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.906,
                          3.207
                        ],
                        [
                          -0.977,
                          6.934
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.132,
                          -2.229
                        ],
                        [
                          3.645,
                          0
                        ],
                        [
                          2.213,
                          3.581
                        ],
                        [
                          0,
                          5.241
                        ],
                        [
                          -1.563,
                          3.548
                        ],
                        [
                          -5.599,
                          0
                        ],
                        [
                          -1.855,
                          -2.132
                        ],
                        [
                          -0.521,
                          -3.223
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.694,
                          2.865
                        ]
                      ],
                      "o": [
                        [
                          -6.902,
                          0
                        ],
                        [
                          -4.46,
                          5.111
                        ],
                        [
                          0,
                          8.464
                        ],
                        [
                          3.45,
                          3.711
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.781,
                          -0.293
                        ],
                        [
                          0.569,
                          -0.13
                        ],
                        [
                          1.432,
                          0
                        ],
                        [
                          0.862,
                          0.764
                        ],
                        [
                          0,
                          1.79
                        ],
                        [
                          -0.879,
                          0.358
                        ],
                        [
                          -1.074,
                          0
                        ],
                        [
                          -0.684,
                          -0.195
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.758,
                          0.651
                        ],
                        [
                          1.855,
                          0.488
                        ],
                        [
                          4.036,
                          0
                        ],
                        [
                          1.953,
                          -1.791
                        ],
                        [
                          0,
                          -2.441
                        ],
                        [
                          -1.482,
                          -1.318
                        ],
                        [
                          -1.498,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          5.176,
                          0
                        ],
                        [
                          3.906,
                          -3.206
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.814,
                          3.874
                        ],
                        [
                          -2.132,
                          2.23
                        ],
                        [
                          -4.753,
                          0
                        ],
                        [
                          -2.214,
                          -3.58
                        ],
                        [
                          0,
                          -5.208
                        ],
                        [
                          2.409,
                          -5.469
                        ],
                        [
                          4.102,
                          0
                        ],
                        [
                          1.855,
                          2.132
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.749,
                          -6.998
                        ],
                        [
                          -3.695,
                          -2.864
                        ]
                      ],
                      "v": [
                        [
                          26.611,
                          -53.809
                        ],
                        [
                          9.57,
                          -46.143
                        ],
                        [
                          2.881,
                          -24.707
                        ],
                        [
                          9.912,
                          -4.053
                        ],
                        [
                          22.021,
                          1.514
                        ],
                        [
                          16.748,
                          8.691
                        ],
                        [
                          18.457,
                          10.693
                        ],
                        [
                          20.483,
                          10.059
                        ],
                        [
                          22.412,
                          9.863
                        ],
                        [
                          25.854,
                          11.011
                        ],
                        [
                          27.148,
                          13.721
                        ],
                        [
                          24.609,
                          17.432
                        ],
                        [
                          21.484,
                          17.969
                        ],
                        [
                          17.871,
                          17.432
                        ],
                        [
                          14.99,
                          16.455
                        ],
                        [
                          13.281,
                          20.41
                        ],
                        [
                          17.48,
                          21.777
                        ],
                        [
                          22.852,
                          22.51
                        ],
                        [
                          31.836,
                          19.824
                        ],
                        [
                          34.766,
                          13.428
                        ],
                        [
                          32.544,
                          7.788
                        ],
                        [
                          26.904,
                          5.811
                        ],
                        [
                          23.242,
                          6.25
                        ],
                        [
                          26.709,
                          1.514
                        ],
                        [
                          40.332,
                          -3.296
                        ],
                        [
                          47.656,
                          -18.506
                        ],
                        [
                          39.111,
                          -18.506
                        ],
                        [
                          34.692,
                          -9.351
                        ],
                        [
                          26.025,
                          -6.006
                        ],
                        [
                          15.576,
                          -11.377
                        ],
                        [
                          12.256,
                          -24.609
                        ],
                        [
                          14.6,
                          -37.744
                        ],
                        [
                          26.611,
                          -45.947
                        ],
                        [
                          35.547,
                          -42.749
                        ],
                        [
                          39.111,
                          -34.717
                        ],
                        [
                          47.656,
                          -34.717
                        ],
                        [
                          40.991,
                          -49.512
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "ç",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "ç",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "5",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          -4.379,
                          -3.206
                        ],
                        [
                          -5.697,
                          0
                        ],
                        [
                          -4.086,
                          5.046
                        ],
                        [
                          0,
                          6.609
                        ],
                        [
                          4.459,
                          4.134
                        ],
                        [
                          6.413,
                          0
                        ],
                        [
                          2.604,
                          -1.074
                        ],
                        [
                          1.627,
                          -1.237
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.165,
                          1.172
                        ],
                        [
                          -3.027,
                          0
                        ],
                        [
                          -2.979,
                          -2.669
                        ],
                        [
                          0,
                          -4.883
                        ],
                        [
                          2.506,
                          -3.32
                        ],
                        [
                          5.208,
                          0
                        ],
                        [
                          2.083,
                          0.977
                        ],
                        [
                          0.586,
                          5.013
                        ]
                      ],
                      "o": [
                        [
                          0.52,
                          6.641
                        ],
                        [
                          4.378,
                          3.206
                        ],
                        [
                          8.952,
                          0
                        ],
                        [
                          4.085,
                          -5.045
                        ],
                        [
                          0,
                          -6.348
                        ],
                        [
                          -4.46,
                          -4.134
                        ],
                        [
                          -3.418,
                          0
                        ],
                        [
                          -1.465,
                          0.619
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.53,
                          -2.083
                        ],
                        [
                          2.164,
                          -1.172
                        ],
                        [
                          4.166,
                          0
                        ],
                        [
                          2.979,
                          2.67
                        ],
                        [
                          0,
                          4.037
                        ],
                        [
                          -2.507,
                          3.32
                        ],
                        [
                          -2.734,
                          0
                        ],
                        [
                          -4.07,
                          -1.92
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          3.223,
                          -17.822
                        ],
                        [
                          10.571,
                          -3.052
                        ],
                        [
                          25.684,
                          1.758
                        ],
                        [
                          45.239,
                          -5.811
                        ],
                        [
                          51.367,
                          -23.291
                        ],
                        [
                          44.678,
                          -39.014
                        ],
                        [
                          28.369,
                          -45.215
                        ],
                        [
                          19.336,
                          -43.604
                        ],
                        [
                          14.697,
                          -40.82
                        ],
                        [
                          17.676,
                          -60.254
                        ],
                        [
                          47.412,
                          -60.254
                        ],
                        [
                          47.412,
                          -68.75
                        ],
                        [
                          11.084,
                          -68.75
                        ],
                        [
                          5.762,
                          -31.104
                        ],
                        [
                          13.379,
                          -30.664
                        ],
                        [
                          18.921,
                          -35.547
                        ],
                        [
                          26.709,
                          -37.305
                        ],
                        [
                          37.427,
                          -33.301
                        ],
                        [
                          41.895,
                          -21.973
                        ],
                        [
                          38.135,
                          -10.938
                        ],
                        [
                          26.563,
                          -5.957
                        ],
                        [
                          19.336,
                          -7.422
                        ],
                        [
                          12.354,
                          -17.822
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "5",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "A",
        "size": 16,
        "style": "Regular",
        "w": 66.7,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          21.973,
                          -29.395
                        ],
                        [
                          33.545,
                          -61.084
                        ],
                        [
                          44.434,
                          -29.395
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "A",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          1.465,
                          0
                        ],
                        [
                          11.426,
                          0
                        ],
                        [
                          19.189,
                          -21.484
                        ],
                        [
                          47.559,
                          -21.484
                        ],
                        [
                          54.834,
                          0
                        ],
                        [
                          65.479,
                          0
                        ],
                        [
                          39.453,
                          -71.729
                        ],
                        [
                          28.467,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "A",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "A",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "c",
        "size": 16,
        "style": "Regular",
        "w": 50,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          5.891,
                          0
                        ],
                        [
                          4.459,
                          -5.11
                        ],
                        [
                          0,
                          -9.18
                        ],
                        [
                          -4.07,
                          -4.996
                        ],
                        [
                          -6.836,
                          0
                        ],
                        [
                          -3.906,
                          3.207
                        ],
                        [
                          -0.977,
                          6.934
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.132,
                          -2.229
                        ],
                        [
                          3.645,
                          0
                        ],
                        [
                          2.213,
                          3.581
                        ],
                        [
                          0,
                          5.241
                        ],
                        [
                          -1.563,
                          3.548
                        ],
                        [
                          -5.599,
                          0
                        ],
                        [
                          -1.855,
                          -2.132
                        ],
                        [
                          -0.521,
                          -3.223
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.694,
                          2.865
                        ]
                      ],
                      "o": [
                        [
                          -6.902,
                          0
                        ],
                        [
                          -4.46,
                          5.111
                        ],
                        [
                          0,
                          7.487
                        ],
                        [
                          4.069,
                          4.997
                        ],
                        [
                          6.087,
                          0
                        ],
                        [
                          3.906,
                          -3.206
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.814,
                          3.874
                        ],
                        [
                          -2.132,
                          2.23
                        ],
                        [
                          -4.753,
                          0
                        ],
                        [
                          -2.214,
                          -3.58
                        ],
                        [
                          0,
                          -5.208
                        ],
                        [
                          2.409,
                          -5.469
                        ],
                        [
                          4.102,
                          0
                        ],
                        [
                          1.855,
                          2.132
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.749,
                          -6.998
                        ],
                        [
                          -3.695,
                          -2.864
                        ]
                      ],
                      "v": [
                        [
                          26.611,
                          -53.809
                        ],
                        [
                          9.57,
                          -46.143
                        ],
                        [
                          2.881,
                          -24.707
                        ],
                        [
                          8.984,
                          -5.981
                        ],
                        [
                          25.342,
                          1.514
                        ],
                        [
                          40.332,
                          -3.296
                        ],
                        [
                          47.656,
                          -18.506
                        ],
                        [
                          39.111,
                          -18.506
                        ],
                        [
                          34.692,
                          -9.351
                        ],
                        [
                          26.025,
                          -6.006
                        ],
                        [
                          15.576,
                          -11.377
                        ],
                        [
                          12.256,
                          -24.609
                        ],
                        [
                          14.6,
                          -37.744
                        ],
                        [
                          26.611,
                          -45.947
                        ],
                        [
                          35.547,
                          -42.749
                        ],
                        [
                          39.111,
                          -34.717
                        ],
                        [
                          47.656,
                          -34.717
                        ],
                        [
                          40.991,
                          -49.512
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "c",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "c",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "k",
        "size": 16,
        "style": "Regular",
        "w": 50,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          6.25,
                          0
                        ],
                        [
                          14.697,
                          0
                        ],
                        [
                          14.697,
                          -19.629
                        ],
                        [
                          22.07,
                          -26.367
                        ],
                        [
                          38.379,
                          0
                        ],
                        [
                          49.609,
                          0
                        ],
                        [
                          28.467,
                          -32.715
                        ],
                        [
                          48.486,
                          -52.295
                        ],
                        [
                          37.256,
                          -52.295
                        ],
                        [
                          14.697,
                          -30.078
                        ],
                        [
                          14.697,
                          -71.729
                        ],
                        [
                          6.25,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "k",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "k",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "6",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          7.813,
                          0
                        ],
                        [
                          4.069,
                          -11.588
                        ],
                        [
                          0,
                          -8.691
                        ],
                        [
                          -4.753,
                          -4.964
                        ],
                        [
                          -6.543,
                          0
                        ],
                        [
                          -4.134,
                          4.9
                        ],
                        [
                          0,
                          6.348
                        ],
                        [
                          4.362,
                          3.744
                        ],
                        [
                          5.859,
                          0
                        ],
                        [
                          2.799,
                          -1.302
                        ],
                        [
                          2.018,
                          -2.962
                        ],
                        [
                          -2.898,
                          4.541
                        ],
                        [
                          -4.916,
                          0
                        ],
                        [
                          -2.116,
                          -2.93
                        ],
                        [
                          -0.521,
                          -2.766
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.076,
                          4.053
                        ]
                      ],
                      "o": [
                        [
                          -10.808,
                          0
                        ],
                        [
                          -2.116,
                          6.055
                        ],
                        [
                          0,
                          11.752
                        ],
                        [
                          4.752,
                          4.964
                        ],
                        [
                          7.649,
                          0
                        ],
                        [
                          4.134,
                          -4.899
                        ],
                        [
                          0,
                          -7.422
                        ],
                        [
                          -4.362,
                          -3.743
                        ],
                        [
                          -3.451,
                          0
                        ],
                        [
                          -3.06,
                          1.465
                        ],
                        [
                          0.325,
                          -8.463
                        ],
                        [
                          2.897,
                          -4.541
                        ],
                        [
                          4.297,
                          0
                        ],
                        [
                          1.139,
                          1.563
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -4.297
                        ],
                        [
                          -3.076,
                          -4.053
                        ]
                      ],
                      "v": [
                        [
                          29.248,
                          -70.215
                        ],
                        [
                          6.934,
                          -52.832
                        ],
                        [
                          3.76,
                          -30.713
                        ],
                        [
                          10.889,
                          -5.64
                        ],
                        [
                          27.832,
                          1.807
                        ],
                        [
                          45.508,
                          -5.542
                        ],
                        [
                          51.709,
                          -22.412
                        ],
                        [
                          45.166,
                          -39.16
                        ],
                        [
                          29.834,
                          -44.775
                        ],
                        [
                          20.459,
                          -42.822
                        ],
                        [
                          12.842,
                          -36.182
                        ],
                        [
                          17.676,
                          -55.688
                        ],
                        [
                          29.395,
                          -62.5
                        ],
                        [
                          39.014,
                          -58.105
                        ],
                        [
                          41.504,
                          -51.611
                        ],
                        [
                          50.195,
                          -51.611
                        ],
                        [
                          45.581,
                          -64.136
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          4.622,
                          0
                        ],
                        [
                          2.588,
                          3.011
                        ],
                        [
                          0,
                          4.427
                        ],
                        [
                          -2.849,
                          2.507
                        ],
                        [
                          -3.777,
                          0
                        ],
                        [
                          -2.051,
                          -3.239
                        ],
                        [
                          0,
                          -3.58
                        ],
                        [
                          2.295,
                          -3.108
                        ]
                      ],
                      "o": [
                        [
                          -4.59,
                          0
                        ],
                        [
                          -2.588,
                          -3.011
                        ],
                        [
                          0,
                          -5.045
                        ],
                        [
                          2.848,
                          -2.506
                        ],
                        [
                          5.403,
                          0
                        ],
                        [
                          2.051,
                          3.239
                        ],
                        [
                          0,
                          4.232
                        ],
                        [
                          -2.295,
                          3.109
                        ]
                      ],
                      "v": [
                        [
                          28.613,
                          -6.006
                        ],
                        [
                          17.847,
                          -10.522
                        ],
                        [
                          13.965,
                          -21.68
                        ],
                        [
                          18.237,
                          -33.008
                        ],
                        [
                          28.174,
                          -36.768
                        ],
                        [
                          39.355,
                          -31.909
                        ],
                        [
                          42.432,
                          -21.68
                        ],
                        [
                          38.989,
                          -10.669
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "6",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "S",
        "size": 16,
        "style": "Regular",
        "w": 66.7,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          -5.046,
                          -4.524
                        ],
                        [
                          -8.92,
                          0
                        ],
                        [
                          -5.779,
                          3.418
                        ],
                        [
                          0,
                          7.943
                        ],
                        [
                          4.557,
                          3.353
                        ],
                        [
                          4.85,
                          1.107
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.92,
                          1.042
                        ],
                        [
                          0,
                          3.516
                        ],
                        [
                          -2.507,
                          2.409
                        ],
                        [
                          -5.73,
                          0
                        ],
                        [
                          -2.962,
                          -3.743
                        ],
                        [
                          -0.488,
                          -3.841
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          5.257,
                          3.63
                        ],
                        [
                          7.52,
                          0
                        ],
                        [
                          4.459,
                          -4.134
                        ],
                        [
                          0,
                          -6.445
                        ],
                        [
                          -4.558,
                          -2.995
                        ],
                        [
                          -6.348,
                          -1.432
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.474,
                          -1.627
                        ],
                        [
                          0,
                          -3.906
                        ],
                        [
                          5.794,
                          -2.018
                        ],
                        [
                          3.645,
                          0
                        ],
                        [
                          3.223,
                          4.753
                        ],
                        [
                          0.227,
                          4.07
                        ]
                      ],
                      "o": [
                        [
                          -0.098,
                          7.748
                        ],
                        [
                          5.045,
                          4.558
                        ],
                        [
                          7.649,
                          0
                        ],
                        [
                          5.778,
                          -3.418
                        ],
                        [
                          0,
                          -6.38
                        ],
                        [
                          -2.637,
                          -1.92
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -6.771,
                          -1.563
                        ],
                        [
                          -2.93,
                          -1.627
                        ],
                        [
                          0,
                          -3.19
                        ],
                        [
                          2.506,
                          -2.409
                        ],
                        [
                          7.096,
                          0
                        ],
                        [
                          1.595,
                          2.051
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -7.975
                        ],
                        [
                          -5.257,
                          -3.629
                        ],
                        [
                          -8.171,
                          0
                        ],
                        [
                          -4.46,
                          4.134
                        ],
                        [
                          0,
                          5.957
                        ],
                        [
                          2.637,
                          1.726
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          5.273,
                          1.205
                        ],
                        [
                          2.441,
                          1.66
                        ],
                        [
                          0,
                          5.209
                        ],
                        [
                          -2.995,
                          1.042
                        ],
                        [
                          -8.138,
                          0
                        ],
                        [
                          -1.693,
                          -2.539
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          4.834,
                          -23.145
                        ],
                        [
                          12.256,
                          -4.736
                        ],
                        [
                          33.203,
                          2.1
                        ],
                        [
                          53.345,
                          -3.027
                        ],
                        [
                          62.012,
                          -20.068
                        ],
                        [
                          55.176,
                          -34.668
                        ],
                        [
                          43.945,
                          -39.209
                        ],
                        [
                          33.887,
                          -41.504
                        ],
                        [
                          20.85,
                          -45.41
                        ],
                        [
                          16.455,
                          -53.125
                        ],
                        [
                          20.215,
                          -61.523
                        ],
                        [
                          32.568,
                          -65.137
                        ],
                        [
                          47.656,
                          -59.521
                        ],
                        [
                          50.781,
                          -50.684
                        ],
                        [
                          59.912,
                          -50.684
                        ],
                        [
                          52.026,
                          -68.091
                        ],
                        [
                          32.861,
                          -73.535
                        ],
                        [
                          13.916,
                          -67.334
                        ],
                        [
                          7.227,
                          -51.465
                        ],
                        [
                          14.063,
                          -38.037
                        ],
                        [
                          27.539,
                          -33.301
                        ],
                        [
                          37.256,
                          -31.104
                        ],
                        [
                          48.877,
                          -26.855
                        ],
                        [
                          52.539,
                          -18.506
                        ],
                        [
                          43.848,
                          -7.666
                        ],
                        [
                          33.887,
                          -6.104
                        ],
                        [
                          16.846,
                          -13.232
                        ],
                        [
                          13.965,
                          -23.145
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "S",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "S",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "ö",
        "size": 16,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          5.827,
                          0
                        ],
                        [
                          2.441,
                          3.711
                        ],
                        [
                          0,
                          5.566
                        ],
                        [
                          -2.441,
                          4.102
                        ],
                        [
                          -5.371,
                          0
                        ],
                        [
                          -2.474,
                          -4.817
                        ],
                        [
                          0,
                          -4.883
                        ],
                        [
                          2.164,
                          -4.411
                        ]
                      ],
                      "o": [
                        [
                          -5.306,
                          0
                        ],
                        [
                          -2.441,
                          -3.711
                        ],
                        [
                          0,
                          -5.794
                        ],
                        [
                          2.441,
                          -4.102
                        ],
                        [
                          6.055,
                          0
                        ],
                        [
                          1.563,
                          3.06
                        ],
                        [
                          0,
                          5.404
                        ],
                        [
                          -2.165,
                          4.411
                        ]
                      ],
                      "v": [
                        [
                          27.197,
                          -5.664
                        ],
                        [
                          15.576,
                          -11.23
                        ],
                        [
                          11.914,
                          -25.146
                        ],
                        [
                          15.576,
                          -39.99
                        ],
                        [
                          27.295,
                          -46.143
                        ],
                        [
                          40.088,
                          -38.916
                        ],
                        [
                          42.432,
                          -27.002
                        ],
                        [
                          39.185,
                          -12.28
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "ö",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          6.738,
                          0
                        ],
                        [
                          4.459,
                          -5.208
                        ],
                        [
                          0,
                          -8.789
                        ],
                        [
                          -4.232,
                          -4.866
                        ],
                        [
                          -7.195,
                          0
                        ],
                        [
                          -4.102,
                          5.502
                        ],
                        [
                          0,
                          8.431
                        ],
                        [
                          4.655,
                          4.492
                        ]
                      ],
                      "o": [
                        [
                          -7.52,
                          0
                        ],
                        [
                          -4.46,
                          5.209
                        ],
                        [
                          0,
                          8.203
                        ],
                        [
                          4.231,
                          4.867
                        ],
                        [
                          8.626,
                          0
                        ],
                        [
                          4.102,
                          -5.501
                        ],
                        [
                          0,
                          -8.723
                        ],
                        [
                          -4.655,
                          -4.492
                        ]
                      ],
                      "v": [
                        [
                          27.539,
                          -53.809
                        ],
                        [
                          9.57,
                          -45.996
                        ],
                        [
                          2.881,
                          -25
                        ],
                        [
                          9.229,
                          -5.396
                        ],
                        [
                          26.367,
                          1.904
                        ],
                        [
                          45.459,
                          -6.348
                        ],
                        [
                          51.611,
                          -27.246
                        ],
                        [
                          44.629,
                          -47.07
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "ö",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          31.348,
                          -60.4
                        ],
                        [
                          40.479,
                          -60.4
                        ],
                        [
                          40.479,
                          -70.557
                        ],
                        [
                          31.348,
                          -70.557
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "ö",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          15.234,
                          -60.4
                        ],
                        [
                          24.365,
                          -60.4
                        ],
                        [
                          24.365,
                          -70.557
                        ],
                        [
                          15.234,
                          -70.557
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "ö",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "ö",
              "np": 7,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "z",
        "size": 16,
        "style": "Regular",
        "w": 50,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          2.539,
                          0
                        ],
                        [
                          46.289,
                          0
                        ],
                        [
                          46.289,
                          -7.861
                        ],
                        [
                          14.551,
                          -7.861
                        ],
                        [
                          45.361,
                          -45.117
                        ],
                        [
                          45.361,
                          -52.295
                        ],
                        [
                          4.834,
                          -52.295
                        ],
                        [
                          4.834,
                          -44.434
                        ],
                        [
                          33.545,
                          -44.434
                        ],
                        [
                          2.539,
                          -6.934
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "z",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "z",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "ş",
        "size": 16,
        "style": "Regular",
        "w": 50,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          -3.239,
                          -3.532
                        ],
                        [
                          -5.566,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.57,
                          0.13
                        ],
                        [
                          -0.716,
                          0
                        ],
                        [
                          -0.863,
                          -0.765
                        ],
                        [
                          0,
                          -1.042
                        ],
                        [
                          1.692,
                          -0.684
                        ],
                        [
                          1.204,
                          0
                        ],
                        [
                          1.334,
                          0.358
                        ],
                        [
                          1.237,
                          0.455
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.042,
                          -0.261
                        ],
                        [
                          -1.726,
                          0
                        ],
                        [
                          -1.953,
                          1.79
                        ],
                        [
                          0,
                          2.473
                        ],
                        [
                          1.481,
                          1.318
                        ],
                        [
                          2.278,
                          0
                        ],
                        [
                          0.944,
                          -0.293
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.532,
                          3.385
                        ],
                        [
                          0,
                          4.655
                        ],
                        [
                          3.418,
                          2.246
                        ],
                        [
                          6.315,
                          1.53
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.302,
                          0.814
                        ],
                        [
                          0,
                          2.279
                        ],
                        [
                          -1.709,
                          1.27
                        ],
                        [
                          -3.32,
                          0
                        ],
                        [
                          -2.019,
                          -2.311
                        ],
                        [
                          -0.163,
                          -1.985
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.18,
                          2.93
                        ],
                        [
                          7.877,
                          0
                        ],
                        [
                          3.564,
                          -3.059
                        ],
                        [
                          0,
                          -4.948
                        ],
                        [
                          -3.777,
                          -2.376
                        ],
                        [
                          -4.46,
                          -1.106
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.27,
                          -0.716
                        ],
                        [
                          0,
                          -2.246
                        ],
                        [
                          2.473,
                          -1.416
                        ],
                        [
                          3.255,
                          0
                        ],
                        [
                          2.213,
                          2.832
                        ],
                        [
                          0.26,
                          2.93
                        ]
                      ],
                      "o": [
                        [
                          0.227,
                          5.209
                        ],
                        [
                          3.239,
                          3.532
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.781,
                          -0.293
                        ],
                        [
                          0.569,
                          -0.13
                        ],
                        [
                          1.432,
                          0
                        ],
                        [
                          0.862,
                          0.764
                        ],
                        [
                          0,
                          1.79
                        ],
                        [
                          -0.879,
                          0.358
                        ],
                        [
                          -1.074,
                          0
                        ],
                        [
                          -0.684,
                          -0.195
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.758,
                          0.651
                        ],
                        [
                          1.855,
                          0.488
                        ],
                        [
                          4.036,
                          0
                        ],
                        [
                          1.953,
                          -1.791
                        ],
                        [
                          0,
                          -2.441
                        ],
                        [
                          -1.482,
                          -1.318
                        ],
                        [
                          -1.498,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          6.282,
                          0
                        ],
                        [
                          3.532,
                          -3.385
                        ],
                        [
                          0,
                          -4.817
                        ],
                        [
                          -2.148,
                          -1.432
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.539,
                          -0.618
                        ],
                        [
                          -2.246,
                          -1.367
                        ],
                        [
                          0,
                          -2.083
                        ],
                        [
                          1.709,
                          -1.27
                        ],
                        [
                          4.98,
                          0
                        ],
                        [
                          1.237,
                          1.628
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.065,
                          -3.385
                        ],
                        [
                          -3.484,
                          -4.622
                        ],
                        [
                          -6.023,
                          0
                        ],
                        [
                          -3.564,
                          3.06
                        ],
                        [
                          0,
                          4.199
                        ],
                        [
                          2.116,
                          1.367
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.743,
                          0.945
                        ],
                        [
                          1.985,
                          1.172
                        ],
                        [
                          0,
                          2.962
                        ],
                        [
                          -2.474,
                          1.416
                        ],
                        [
                          -5.469,
                          0
                        ],
                        [
                          -1.205,
                          -1.563
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          3.223,
                          -16.406
                        ],
                        [
                          8.423,
                          -3.296
                        ],
                        [
                          21.631,
                          2.002
                        ],
                        [
                          16.748,
                          8.691
                        ],
                        [
                          18.457,
                          10.693
                        ],
                        [
                          20.483,
                          10.059
                        ],
                        [
                          22.412,
                          9.863
                        ],
                        [
                          25.854,
                          11.011
                        ],
                        [
                          27.148,
                          13.721
                        ],
                        [
                          24.609,
                          17.432
                        ],
                        [
                          21.484,
                          17.969
                        ],
                        [
                          17.871,
                          17.432
                        ],
                        [
                          14.99,
                          16.455
                        ],
                        [
                          13.281,
                          20.41
                        ],
                        [
                          17.48,
                          21.777
                        ],
                        [
                          22.852,
                          22.51
                        ],
                        [
                          31.836,
                          19.824
                        ],
                        [
                          34.766,
                          13.428
                        ],
                        [
                          32.544,
                          7.788
                        ],
                        [
                          26.904,
                          5.811
                        ],
                        [
                          23.242,
                          6.25
                        ],
                        [
                          26.367,
                          2.002
                        ],
                        [
                          41.089,
                          -3.076
                        ],
                        [
                          46.387,
                          -15.137
                        ],
                        [
                          41.26,
                          -25.732
                        ],
                        [
                          28.564,
                          -30.176
                        ],
                        [
                          22.754,
                          -31.592
                        ],
                        [
                          16.992,
                          -33.74
                        ],
                        [
                          13.623,
                          -39.209
                        ],
                        [
                          16.187,
                          -44.238
                        ],
                        [
                          23.73,
                          -46.143
                        ],
                        [
                          34.229,
                          -42.676
                        ],
                        [
                          36.328,
                          -37.256
                        ],
                        [
                          44.629,
                          -37.256
                        ],
                        [
                          41.455,
                          -46.729
                        ],
                        [
                          24.414,
                          -53.662
                        ],
                        [
                          10.034,
                          -49.072
                        ],
                        [
                          4.688,
                          -37.061
                        ],
                        [
                          10.352,
                          -27.197
                        ],
                        [
                          20.215,
                          -23.486
                        ],
                        [
                          27.197,
                          -21.729
                        ],
                        [
                          34.717,
                          -19.238
                        ],
                        [
                          37.695,
                          -14.111
                        ],
                        [
                          33.984,
                          -7.544
                        ],
                        [
                          25.391,
                          -5.42
                        ],
                        [
                          13.867,
                          -9.668
                        ],
                        [
                          11.67,
                          -16.406
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "ş",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "ş",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "m",
        "size": 16,
        "style": "Regular",
        "w": 83.3,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.718,
                          2.572
                        ],
                        [
                          -3.32,
                          0
                        ],
                        [
                          -1.335,
                          -2.441
                        ],
                        [
                          0,
                          -3.548
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.49,
                          2.312
                        ],
                        [
                          -3.451,
                          0
                        ],
                        [
                          -1.742,
                          -1.302
                        ],
                        [
                          0,
                          -3.483
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.367,
                          2.734
                        ],
                        [
                          7.031,
                          0
                        ],
                        [
                          2.637,
                          -1.35
                        ],
                        [
                          1.953,
                          -2.799
                        ],
                        [
                          1.432,
                          1.172
                        ],
                        [
                          4.166,
                          0
                        ],
                        [
                          2.897,
                          -1.985
                        ],
                        [
                          2.083,
                          -2.571
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -6.738
                        ],
                        [
                          2.718,
                          -2.571
                        ],
                        [
                          3.645,
                          0
                        ],
                        [
                          0.846,
                          1.628
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -5.403
                        ],
                        [
                          2.49,
                          -2.311
                        ],
                        [
                          2.506,
                          0
                        ],
                        [
                          1.741,
                          1.302
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -4.622
                        ],
                        [
                          -2.539,
                          -5.078
                        ],
                        [
                          -3.288,
                          0
                        ],
                        [
                          -2.637,
                          1.351
                        ],
                        [
                          -1.172,
                          -2.278
                        ],
                        [
                          -2.539,
                          -2.051
                        ],
                        [
                          -3.679,
                          0
                        ],
                        [
                          -1.693,
                          1.172
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          6.445,
                          0
                        ],
                        [
                          15.234,
                          0
                        ],
                        [
                          15.234,
                          -27.734
                        ],
                        [
                          19.312,
                          -41.699
                        ],
                        [
                          28.369,
                          -45.557
                        ],
                        [
                          35.84,
                          -41.895
                        ],
                        [
                          37.109,
                          -34.131
                        ],
                        [
                          37.109,
                          0
                        ],
                        [
                          46.045,
                          0
                        ],
                        [
                          46.045,
                          -30.42
                        ],
                        [
                          49.78,
                          -41.992
                        ],
                        [
                          58.691,
                          -45.459
                        ],
                        [
                          65.063,
                          -43.506
                        ],
                        [
                          67.676,
                          -36.328
                        ],
                        [
                          67.676,
                          0
                        ],
                        [
                          76.807,
                          0
                        ],
                        [
                          76.807,
                          -34.814
                        ],
                        [
                          74.756,
                          -45.85
                        ],
                        [
                          60.4,
                          -53.467
                        ],
                        [
                          51.514,
                          -51.44
                        ],
                        [
                          44.629,
                          -45.215
                        ],
                        [
                          40.723,
                          -50.391
                        ],
                        [
                          30.664,
                          -53.467
                        ],
                        [
                          20.801,
                          -50.488
                        ],
                        [
                          15.137,
                          -44.873
                        ],
                        [
                          15.137,
                          -52.295
                        ],
                        [
                          6.445,
                          -52.295
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "m",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "m",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "n",
        "size": 14,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.439,
                          1.839
                        ],
                        [
                          -1.465,
                          1.726
                        ],
                        [
                          -2.409,
                          0.716
                        ],
                        [
                          -2.084,
                          0
                        ],
                        [
                          -1.563,
                          -3.255
                        ],
                        [
                          0,
                          -3.19
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.432,
                          2.832
                        ],
                        [
                          7.422,
                          0
                        ],
                        [
                          2.766,
                          -1.334
                        ],
                        [
                          2.473,
                          -3.059
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -3.418
                        ],
                        [
                          0.439,
                          -1.839
                        ],
                        [
                          1.823,
                          -2.148
                        ],
                        [
                          1.334,
                          -0.423
                        ],
                        [
                          4.102,
                          0
                        ],
                        [
                          0.944,
                          1.953
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -5.273
                        ],
                        [
                          -2.605,
                          -5.176
                        ],
                        [
                          -3.386,
                          0
                        ],
                        [
                          -2.767,
                          1.335
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          6.445,
                          0
                        ],
                        [
                          15.234,
                          0
                        ],
                        [
                          15.234,
                          -27.393
                        ],
                        [
                          15.894,
                          -35.278
                        ],
                        [
                          18.75,
                          -40.625
                        ],
                        [
                          25.098,
                          -44.922
                        ],
                        [
                          30.225,
                          -45.557
                        ],
                        [
                          38.721,
                          -40.674
                        ],
                        [
                          40.137,
                          -32.959
                        ],
                        [
                          40.137,
                          0
                        ],
                        [
                          49.072,
                          0
                        ],
                        [
                          49.072,
                          -33.545
                        ],
                        [
                          46.924,
                          -45.703
                        ],
                        [
                          31.885,
                          -53.467
                        ],
                        [
                          22.656,
                          -51.465
                        ],
                        [
                          14.795,
                          -44.873
                        ],
                        [
                          14.795,
                          -52.295
                        ],
                        [
                          6.445,
                          -52.295
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "n",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "n",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "g",
        "size": 14,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          4.102,
                          0
                        ],
                        [
                          4.28,
                          -4.915
                        ],
                        [
                          0,
                          -8.756
                        ],
                        [
                          -4.248,
                          -4.02
                        ],
                        [
                          -5.664,
                          0
                        ],
                        [
                          -2.474,
                          1.302
                        ],
                        [
                          -1.758,
                          2.67
                        ],
                        [
                          1.237,
                          -2.8
                        ],
                        [
                          6.738,
                          0
                        ],
                        [
                          1.985,
                          1.953
                        ],
                        [
                          0.423,
                          2.344
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.841,
                          -2.523
                        ],
                        [
                          -5.632,
                          0
                        ],
                        [
                          -3.646,
                          7.096
                        ],
                        [
                          0,
                          6.641
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.66,
                          1.14
                        ]
                      ],
                      "o": [
                        [
                          -6.055,
                          0
                        ],
                        [
                          -4.281,
                          4.916
                        ],
                        [
                          0,
                          9.277
                        ],
                        [
                          4.248,
                          4.021
                        ],
                        [
                          4.069,
                          0
                        ],
                        [
                          2.473,
                          -1.302
                        ],
                        [
                          0.098,
                          7.195
                        ],
                        [
                          -2.084,
                          4.752
                        ],
                        [
                          -4.265,
                          0
                        ],
                        [
                          -1.27,
                          -1.27
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.455,
                          5.371
                        ],
                        [
                          3.841,
                          2.522
                        ],
                        [
                          10.123,
                          0
                        ],
                        [
                          1.953,
                          -3.841
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.726,
                          -2.18
                        ],
                        [
                          -3.06,
                          -2.018
                        ]
                      ],
                      "v": [
                        [
                          24.902,
                          -53.223
                        ],
                        [
                          9.399,
                          -45.85
                        ],
                        [
                          2.979,
                          -25.342
                        ],
                        [
                          9.351,
                          -5.396
                        ],
                        [
                          24.219,
                          0.635
                        ],
                        [
                          34.033,
                          -1.318
                        ],
                        [
                          40.381,
                          -7.275
                        ],
                        [
                          38.672,
                          7.715
                        ],
                        [
                          25.439,
                          14.844
                        ],
                        [
                          16.064,
                          11.914
                        ],
                        [
                          13.525,
                          6.494
                        ],
                        [
                          4.59,
                          6.494
                        ],
                        [
                          11.035,
                          18.335
                        ],
                        [
                          25.244,
                          22.119
                        ],
                        [
                          45.898,
                          11.475
                        ],
                        [
                          48.828,
                          -4.248
                        ],
                        [
                          48.828,
                          -51.807
                        ],
                        [
                          40.723,
                          -51.807
                        ],
                        [
                          40.723,
                          -45.215
                        ],
                        [
                          35.645,
                          -50.195
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "g",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          -6.477
                        ],
                        [
                          1.432,
                          -3.223
                        ],
                        [
                          6.315,
                          0
                        ],
                        [
                          2.393,
                          3.076
                        ],
                        [
                          0,
                          5.892
                        ],
                        [
                          -1.205,
                          3.093
                        ],
                        [
                          -6.185,
                          0
                        ],
                        [
                          -2.67,
                          -3.125
                        ]
                      ],
                      "o": [
                        [
                          0,
                          4.297
                        ],
                        [
                          -2.572,
                          5.697
                        ],
                        [
                          -4.037,
                          0
                        ],
                        [
                          -2.393,
                          -3.076
                        ],
                        [
                          0,
                          -5.013
                        ],
                        [
                          2.278,
                          -5.794
                        ],
                        [
                          4.134,
                          0
                        ],
                        [
                          2.669,
                          3.125
                        ]
                      ],
                      "v": [
                        [
                          40.723,
                          -26.367
                        ],
                        [
                          38.574,
                          -15.088
                        ],
                        [
                          25.244,
                          -6.543
                        ],
                        [
                          15.601,
                          -11.157
                        ],
                        [
                          12.012,
                          -24.609
                        ],
                        [
                          13.818,
                          -36.768
                        ],
                        [
                          26.514,
                          -45.459
                        ],
                        [
                          36.719,
                          -40.771
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "g",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "g",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "ü",
        "size": 14,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.465,
                          -2.669
                        ],
                        [
                          -7.455,
                          0
                        ],
                        [
                          -3.353,
                          2.734
                        ],
                        [
                          -1.14,
                          1.986
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.204,
                          -2.93
                        ],
                        [
                          6.12,
                          0
                        ],
                        [
                          1.563,
                          3.125
                        ],
                        [
                          0,
                          2.67
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          4.46
                        ],
                        [
                          2.702,
                          4.98
                        ],
                        [
                          4.785,
                          0
                        ],
                        [
                          1.692,
                          -1.367
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          5.111
                        ],
                        [
                          -2.214,
                          5.469
                        ],
                        [
                          -4.265,
                          0
                        ],
                        [
                          -0.847,
                          -1.692
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          6.25,
                          -52.295
                        ],
                        [
                          6.25,
                          -16.748
                        ],
                        [
                          8.447,
                          -6.055
                        ],
                        [
                          23.682,
                          1.416
                        ],
                        [
                          35.889,
                          -2.686
                        ],
                        [
                          40.137,
                          -7.715
                        ],
                        [
                          40.039,
                          0
                        ],
                        [
                          48.34,
                          0
                        ],
                        [
                          48.34,
                          -52.295
                        ],
                        [
                          39.551,
                          -52.295
                        ],
                        [
                          39.551,
                          -26.611
                        ],
                        [
                          37.744,
                          -14.551
                        ],
                        [
                          25.244,
                          -6.348
                        ],
                        [
                          16.504,
                          -11.035
                        ],
                        [
                          15.234,
                          -17.578
                        ],
                        [
                          15.234,
                          -52.295
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "ü",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          31.396,
                          -60.4
                        ],
                        [
                          40.527,
                          -60.4
                        ],
                        [
                          40.527,
                          -70.557
                        ],
                        [
                          31.396,
                          -70.557
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "ü",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          15.283,
                          -60.4
                        ],
                        [
                          24.414,
                          -60.4
                        ],
                        [
                          24.414,
                          -70.557
                        ],
                        [
                          15.283,
                          -70.557
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "ü",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "ü",
              "np": 6,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "d",
        "size": 14,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          5.599
                        ],
                        [
                          -2.751,
                          3.386
                        ],
                        [
                          -4.427,
                          0
                        ],
                        [
                          -2.702,
                          -3.174
                        ],
                        [
                          0,
                          -6.608
                        ],
                        [
                          2.62,
                          -3.499
                        ],
                        [
                          4.069,
                          0
                        ],
                        [
                          2.376,
                          3.777
                        ]
                      ],
                      "o": [
                        [
                          0,
                          -6.575
                        ],
                        [
                          2.75,
                          -3.385
                        ],
                        [
                          3.971,
                          0
                        ],
                        [
                          2.702,
                          3.174
                        ],
                        [
                          0,
                          6.543
                        ],
                        [
                          -2.621,
                          3.5
                        ],
                        [
                          -5.241,
                          0
                        ],
                        [
                          -2.377,
                          -3.776
                        ]
                      ],
                      "v": [
                        [
                          12.012,
                          -25.537
                        ],
                        [
                          16.138,
                          -40.479
                        ],
                        [
                          26.904,
                          -45.557
                        ],
                        [
                          36.914,
                          -40.796
                        ],
                        [
                          40.967,
                          -26.123
                        ],
                        [
                          37.036,
                          -11.06
                        ],
                        [
                          27.002,
                          -5.811
                        ],
                        [
                          15.576,
                          -11.475
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "d",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          4.004,
                          0
                        ],
                        [
                          3.889,
                          -5.582
                        ],
                        [
                          0,
                          -7.617
                        ],
                        [
                          -4.265,
                          -4.899
                        ],
                        [
                          -5.827,
                          0
                        ],
                        [
                          -2.8,
                          1.432
                        ],
                        [
                          -2.051,
                          3.223
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.563,
                          0.977
                        ]
                      ],
                      "o": [
                        [
                          -7.227,
                          0
                        ],
                        [
                          -3.89,
                          5.583
                        ],
                        [
                          0,
                          8.138
                        ],
                        [
                          4.264,
                          4.9
                        ],
                        [
                          3.613,
                          0
                        ],
                        [
                          2.799,
                          -1.432
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.986,
                          -2.441
                        ],
                        [
                          -2.702,
                          -1.692
                        ]
                      ],
                      "v": [
                        [
                          25.244,
                          -53.223
                        ],
                        [
                          8.569,
                          -44.849
                        ],
                        [
                          2.734,
                          -25.049
                        ],
                        [
                          9.131,
                          -5.493
                        ],
                        [
                          24.268,
                          1.855
                        ],
                        [
                          33.887,
                          -0.293
                        ],
                        [
                          41.162,
                          -7.275
                        ],
                        [
                          41.162,
                          0
                        ],
                        [
                          49.072,
                          0
                        ],
                        [
                          49.072,
                          -71.973
                        ],
                        [
                          40.625,
                          -71.973
                        ],
                        [
                          40.625,
                          -45.557
                        ],
                        [
                          35.303,
                          -50.684
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "d",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "d",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "”",
        "size": 14,
        "style": "Regular",
        "w": 33.3,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          -1.595,
                          3.044
                        ],
                        [
                          0,
                          3.874
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.455,
                          -1.855
                        ],
                        [
                          2.441,
                          -0.455
                        ]
                      ],
                      "o": [
                        [
                          3.776,
                          -0.455
                        ],
                        [
                          1.595,
                          -3.043
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.13,
                          1.367
                        ],
                        [
                          -0.781,
                          3.125
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          20.215,
                          -46.289
                        ],
                        [
                          28.271,
                          -51.538
                        ],
                        [
                          30.664,
                          -61.914
                        ],
                        [
                          30.664,
                          -71.729
                        ],
                        [
                          20.215,
                          -71.729
                        ],
                        [
                          20.215,
                          -61.084
                        ],
                        [
                          25.537,
                          -61.084
                        ],
                        [
                          25.049,
                          -56.25
                        ],
                        [
                          20.215,
                          -50.879
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "”",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          -1.595,
                          3.011
                        ],
                        [
                          0,
                          3.874
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.455,
                          -1.855
                        ],
                        [
                          2.441,
                          -0.455
                        ]
                      ],
                      "o": [
                        [
                          3.743,
                          -0.52
                        ],
                        [
                          1.595,
                          -3.011
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.163,
                          1.367
                        ],
                        [
                          -0.814,
                          3.125
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          3.809,
                          -46.289
                        ],
                        [
                          11.816,
                          -51.587
                        ],
                        [
                          14.209,
                          -61.914
                        ],
                        [
                          14.209,
                          -71.729
                        ],
                        [
                          3.809,
                          -71.729
                        ],
                        [
                          3.809,
                          -61.084
                        ],
                        [
                          9.131,
                          -61.084
                        ],
                        [
                          8.691,
                          -56.25
                        ],
                        [
                          3.809,
                          -50.879
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "”",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "”",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "s",
        "size": 14,
        "style": "Regular",
        "w": 50,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          -3.239,
                          -3.532
                        ],
                        [
                          -7.78,
                          0
                        ],
                        [
                          -3.532,
                          3.385
                        ],
                        [
                          0,
                          4.655
                        ],
                        [
                          3.418,
                          2.246
                        ],
                        [
                          6.315,
                          1.53
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.302,
                          0.814
                        ],
                        [
                          0,
                          2.279
                        ],
                        [
                          -1.709,
                          1.27
                        ],
                        [
                          -3.32,
                          0
                        ],
                        [
                          -2.019,
                          -2.311
                        ],
                        [
                          -0.163,
                          -1.985
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.18,
                          2.93
                        ],
                        [
                          7.877,
                          0
                        ],
                        [
                          3.564,
                          -3.059
                        ],
                        [
                          0,
                          -4.948
                        ],
                        [
                          -3.777,
                          -2.376
                        ],
                        [
                          -4.46,
                          -1.106
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.27,
                          -0.716
                        ],
                        [
                          0,
                          -2.246
                        ],
                        [
                          2.473,
                          -1.416
                        ],
                        [
                          3.255,
                          0
                        ],
                        [
                          2.213,
                          2.832
                        ],
                        [
                          0.26,
                          2.93
                        ]
                      ],
                      "o": [
                        [
                          0.227,
                          5.209
                        ],
                        [
                          3.239,
                          3.532
                        ],
                        [
                          7.227,
                          0
                        ],
                        [
                          3.532,
                          -3.385
                        ],
                        [
                          0,
                          -4.817
                        ],
                        [
                          -2.148,
                          -1.432
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.539,
                          -0.618
                        ],
                        [
                          -2.246,
                          -1.367
                        ],
                        [
                          0,
                          -2.083
                        ],
                        [
                          1.709,
                          -1.27
                        ],
                        [
                          4.98,
                          0
                        ],
                        [
                          1.237,
                          1.628
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.065,
                          -3.385
                        ],
                        [
                          -3.484,
                          -4.622
                        ],
                        [
                          -6.023,
                          0
                        ],
                        [
                          -3.564,
                          3.06
                        ],
                        [
                          0,
                          4.199
                        ],
                        [
                          2.116,
                          1.367
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.743,
                          0.945
                        ],
                        [
                          1.985,
                          1.172
                        ],
                        [
                          0,
                          2.962
                        ],
                        [
                          -2.474,
                          1.416
                        ],
                        [
                          -5.469,
                          0
                        ],
                        [
                          -1.205,
                          -1.563
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          3.223,
                          -16.406
                        ],
                        [
                          8.423,
                          -3.296
                        ],
                        [
                          24.951,
                          2.002
                        ],
                        [
                          41.089,
                          -3.076
                        ],
                        [
                          46.387,
                          -15.137
                        ],
                        [
                          41.26,
                          -25.732
                        ],
                        [
                          28.564,
                          -30.176
                        ],
                        [
                          22.754,
                          -31.592
                        ],
                        [
                          16.992,
                          -33.74
                        ],
                        [
                          13.623,
                          -39.209
                        ],
                        [
                          16.187,
                          -44.238
                        ],
                        [
                          23.73,
                          -46.143
                        ],
                        [
                          34.229,
                          -42.676
                        ],
                        [
                          36.328,
                          -37.256
                        ],
                        [
                          44.629,
                          -37.256
                        ],
                        [
                          41.455,
                          -46.729
                        ],
                        [
                          24.414,
                          -53.662
                        ],
                        [
                          10.034,
                          -49.072
                        ],
                        [
                          4.688,
                          -37.061
                        ],
                        [
                          10.352,
                          -27.197
                        ],
                        [
                          20.215,
                          -23.486
                        ],
                        [
                          27.197,
                          -21.729
                        ],
                        [
                          34.717,
                          -19.238
                        ],
                        [
                          37.695,
                          -14.111
                        ],
                        [
                          33.984,
                          -7.544
                        ],
                        [
                          25.391,
                          -5.42
                        ],
                        [
                          13.867,
                          -9.668
                        ],
                        [
                          11.67,
                          -16.406
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "s",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "s",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "ı",
        "size": 14,
        "style": "Regular",
        "w": 27.78,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          9.229,
                          0
                        ],
                        [
                          18.164,
                          0
                        ],
                        [
                          18.164,
                          -52.051
                        ],
                        [
                          9.229,
                          -52.051
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "ı",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "ı",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "Ş",
        "size": 14,
        "style": "Regular",
        "w": 66.7,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          -5.046,
                          -4.541
                        ],
                        [
                          -6.738,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.57,
                          0.13
                        ],
                        [
                          -0.716,
                          0
                        ],
                        [
                          -0.863,
                          -0.765
                        ],
                        [
                          0,
                          -1.042
                        ],
                        [
                          1.692,
                          -0.684
                        ],
                        [
                          1.204,
                          0
                        ],
                        [
                          1.334,
                          0.358
                        ],
                        [
                          1.237,
                          0.455
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.042,
                          -0.261
                        ],
                        [
                          -1.726,
                          0
                        ],
                        [
                          -1.953,
                          1.79
                        ],
                        [
                          0,
                          2.473
                        ],
                        [
                          1.481,
                          1.318
                        ],
                        [
                          2.278,
                          0
                        ],
                        [
                          0.944,
                          -0.293
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -5.779,
                          3.418
                        ],
                        [
                          0,
                          7.943
                        ],
                        [
                          4.557,
                          3.353
                        ],
                        [
                          4.85,
                          1.107
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.92,
                          1.042
                        ],
                        [
                          0,
                          3.516
                        ],
                        [
                          -2.507,
                          2.409
                        ],
                        [
                          -5.73,
                          0
                        ],
                        [
                          -2.962,
                          -3.743
                        ],
                        [
                          -0.488,
                          -3.841
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          5.257,
                          3.63
                        ],
                        [
                          7.52,
                          0
                        ],
                        [
                          4.459,
                          -4.134
                        ],
                        [
                          0,
                          -6.445
                        ],
                        [
                          -4.558,
                          -2.995
                        ],
                        [
                          -6.348,
                          -1.432
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.458,
                          -1.643
                        ],
                        [
                          0,
                          -3.906
                        ],
                        [
                          5.794,
                          -2.018
                        ],
                        [
                          3.645,
                          0
                        ],
                        [
                          3.223,
                          4.753
                        ],
                        [
                          0.227,
                          4.07
                        ]
                      ],
                      "o": [
                        [
                          -0.098,
                          7.748
                        ],
                        [
                          5.045,
                          4.541
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.781,
                          -0.293
                        ],
                        [
                          0.569,
                          -0.13
                        ],
                        [
                          1.432,
                          0
                        ],
                        [
                          0.862,
                          0.764
                        ],
                        [
                          0,
                          1.79
                        ],
                        [
                          -0.879,
                          0.358
                        ],
                        [
                          -1.074,
                          0
                        ],
                        [
                          -0.684,
                          -0.195
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.758,
                          0.651
                        ],
                        [
                          1.855,
                          0.488
                        ],
                        [
                          4.036,
                          0
                        ],
                        [
                          1.953,
                          -1.791
                        ],
                        [
                          0,
                          -2.441
                        ],
                        [
                          -1.482,
                          -1.318
                        ],
                        [
                          -1.498,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          6.738,
                          0
                        ],
                        [
                          5.778,
                          -3.418
                        ],
                        [
                          0,
                          -6.38
                        ],
                        [
                          -2.637,
                          -1.92
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -6.771,
                          -1.563
                        ],
                        [
                          -2.93,
                          -1.627
                        ],
                        [
                          0,
                          -3.19
                        ],
                        [
                          2.506,
                          -2.409
                        ],
                        [
                          7.096,
                          0
                        ],
                        [
                          1.595,
                          2.051
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -7.975
                        ],
                        [
                          -5.257,
                          -3.629
                        ],
                        [
                          -8.171,
                          0
                        ],
                        [
                          -4.46,
                          4.134
                        ],
                        [
                          0,
                          5.957
                        ],
                        [
                          2.637,
                          1.726
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          5.273,
                          1.205
                        ],
                        [
                          2.457,
                          1.644
                        ],
                        [
                          0,
                          5.209
                        ],
                        [
                          -2.995,
                          1.042
                        ],
                        [
                          -8.138,
                          0
                        ],
                        [
                          -1.693,
                          -2.539
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          4.834,
                          -23.145
                        ],
                        [
                          12.256,
                          -4.712
                        ],
                        [
                          29.932,
                          2.1
                        ],
                        [
                          25.098,
                          8.691
                        ],
                        [
                          26.807,
                          10.693
                        ],
                        [
                          28.833,
                          10.059
                        ],
                        [
                          30.762,
                          9.863
                        ],
                        [
                          34.204,
                          11.011
                        ],
                        [
                          35.498,
                          13.721
                        ],
                        [
                          32.959,
                          17.432
                        ],
                        [
                          29.834,
                          17.969
                        ],
                        [
                          26.221,
                          17.432
                        ],
                        [
                          23.34,
                          16.455
                        ],
                        [
                          21.631,
                          20.41
                        ],
                        [
                          25.83,
                          21.777
                        ],
                        [
                          31.201,
                          22.51
                        ],
                        [
                          40.186,
                          19.824
                        ],
                        [
                          43.115,
                          13.428
                        ],
                        [
                          40.894,
                          7.788
                        ],
                        [
                          35.254,
                          5.811
                        ],
                        [
                          31.592,
                          6.25
                        ],
                        [
                          34.57,
                          2.1
                        ],
                        [
                          53.345,
                          -3.027
                        ],
                        [
                          62.012,
                          -20.068
                        ],
                        [
                          55.176,
                          -34.668
                        ],
                        [
                          43.945,
                          -39.209
                        ],
                        [
                          33.887,
                          -41.504
                        ],
                        [
                          20.85,
                          -45.41
                        ],
                        [
                          16.455,
                          -53.125
                        ],
                        [
                          20.215,
                          -61.523
                        ],
                        [
                          32.568,
                          -65.137
                        ],
                        [
                          47.656,
                          -59.521
                        ],
                        [
                          50.781,
                          -50.684
                        ],
                        [
                          59.912,
                          -50.684
                        ],
                        [
                          52.026,
                          -68.091
                        ],
                        [
                          32.861,
                          -73.535
                        ],
                        [
                          13.916,
                          -67.334
                        ],
                        [
                          7.227,
                          -51.465
                        ],
                        [
                          14.063,
                          -38.037
                        ],
                        [
                          27.539,
                          -33.301
                        ],
                        [
                          37.256,
                          -31.104
                        ],
                        [
                          48.853,
                          -26.831
                        ],
                        [
                          52.539,
                          -18.506
                        ],
                        [
                          43.848,
                          -7.666
                        ],
                        [
                          33.887,
                          -6.104
                        ],
                        [
                          16.846,
                          -13.232
                        ],
                        [
                          13.965,
                          -23.145
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Ş",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "Ş",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "\t",
        "size": 14,
        "style": "Regular",
        "w": 13.78,
        "data": {
          
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "0",
        "size": 14,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          9.049,
                          0
                        ],
                        [
                          3.841,
                          -10.612
                        ],
                        [
                          0,
                          -7.942
                        ],
                        [
                          -3.418,
                          -6.087
                        ],
                        [
                          -8.398,
                          0
                        ],
                        [
                          -4.102,
                          8.92
                        ],
                        [
                          0,
                          9.505
                        ],
                        [
                          3.125,
                          5.762
                        ]
                      ],
                      "o": [
                        [
                          -10.059,
                          0
                        ],
                        [
                          -2.051,
                          5.697
                        ],
                        [
                          0,
                          10.254
                        ],
                        [
                          4.102,
                          7.292
                        ],
                        [
                          9.309,
                          0
                        ],
                        [
                          2.832,
                          -6.217
                        ],
                        [
                          0,
                          -10.026
                        ],
                        [
                          -4.037,
                          -7.454
                        ]
                      ],
                      "v": [
                        [
                          27.051,
                          -69.922
                        ],
                        [
                          6.201,
                          -54.004
                        ],
                        [
                          3.125,
                          -33.545
                        ],
                        [
                          8.252,
                          -9.033
                        ],
                        [
                          27.002,
                          1.904
                        ],
                        [
                          47.119,
                          -11.475
                        ],
                        [
                          51.367,
                          -35.059
                        ],
                        [
                          46.68,
                          -58.74
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "0",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          4.557,
                          0
                        ],
                        [
                          2.344,
                          6.609
                        ],
                        [
                          0,
                          7.129
                        ],
                        [
                          -2.393,
                          4.867
                        ],
                        [
                          -5.176,
                          0
                        ],
                        [
                          -1.953,
                          -5.127
                        ],
                        [
                          0,
                          -7.942
                        ],
                        [
                          2.702,
                          -4.036
                        ]
                      ],
                      "o": [
                        [
                          -5.664,
                          0
                        ],
                        [
                          -1.53,
                          -4.329
                        ],
                        [
                          0,
                          -9.473
                        ],
                        [
                          2.393,
                          -4.866
                        ],
                        [
                          5.631,
                          0
                        ],
                        [
                          1.953,
                          5.127
                        ],
                        [
                          0,
                          11.003
                        ],
                        [
                          -2.702,
                          4.037
                        ]
                      ],
                      "v": [
                        [
                          26.953,
                          -6.104
                        ],
                        [
                          14.941,
                          -16.016
                        ],
                        [
                          12.646,
                          -33.203
                        ],
                        [
                          16.235,
                          -54.712
                        ],
                        [
                          27.588,
                          -62.012
                        ],
                        [
                          38.965,
                          -54.321
                        ],
                        [
                          41.895,
                          -34.717
                        ],
                        [
                          37.842,
                          -12.158
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "0",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "0",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": ".",
        "size": 14,
        "style": "Regular",
        "w": 27.78,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          8.545,
                          0
                        ],
                        [
                          18.75,
                          0
                        ],
                        [
                          18.75,
                          -10.645
                        ],
                        [
                          8.545,
                          -10.645
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": ".",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": ".",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "v",
        "size": 14,
        "style": "Regular",
        "w": 50,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          0.537,
                          -52.295
                        ],
                        [
                          19.824,
                          0
                        ],
                        [
                          29.199,
                          0
                        ],
                        [
                          48.926,
                          -52.295
                        ],
                        [
                          39.307,
                          -52.295
                        ],
                        [
                          24.707,
                          -9.717
                        ],
                        [
                          10.742,
                          -52.295
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "v",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "v",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "G",
        "size": 14,
        "style": "Regular",
        "w": 77.78,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          6.738,
                          0
                        ],
                        [
                          6.184,
                          -6.77
                        ],
                        [
                          0,
                          -12.012
                        ],
                        [
                          -6.673,
                          -6.901
                        ],
                        [
                          -8.496,
                          0
                        ],
                        [
                          -4.265,
                          2.409
                        ],
                        [
                          -3.288,
                          3.613
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          4.248,
                          -3.76
                        ],
                        [
                          6.477,
                          0
                        ],
                        [
                          3.743,
                          5.355
                        ],
                        [
                          0,
                          8.529
                        ],
                        [
                          -4.541,
                          4.98
                        ],
                        [
                          -6.641,
                          0
                        ],
                        [
                          -3.679,
                          -2.393
                        ],
                        [
                          -1.172,
                          -5.241
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          7.129,
                          3.744
                        ]
                      ],
                      "o": [
                        [
                          -9.831,
                          0
                        ],
                        [
                          -6.511,
                          7.097
                        ],
                        [
                          0,
                          12.045
                        ],
                        [
                          6.12,
                          5.502
                        ],
                        [
                          6.575,
                          0
                        ],
                        [
                          2.539,
                          -1.399
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.098,
                          8.398
                        ],
                        [
                          -4.248,
                          3.76
                        ],
                        [
                          -8.464,
                          0
                        ],
                        [
                          -3.744,
                          -5.354
                        ],
                        [
                          0,
                          -9.863
                        ],
                        [
                          4.541,
                          -4.98
                        ],
                        [
                          5.598,
                          0
                        ],
                        [
                          3.678,
                          2.393
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.595,
                          -9.375
                        ],
                        [
                          -4.916,
                          -2.604
                        ]
                      ],
                      "v": [
                        [
                          38.623,
                          -73.584
                        ],
                        [
                          14.6,
                          -63.428
                        ],
                        [
                          4.834,
                          -34.766
                        ],
                        [
                          14.844,
                          -6.348
                        ],
                        [
                          36.768,
                          1.904
                        ],
                        [
                          53.027,
                          -1.709
                        ],
                        [
                          61.768,
                          -9.229
                        ],
                        [
                          64.111,
                          0
                        ],
                        [
                          70.361,
                          0
                        ],
                        [
                          70.361,
                          -38.379
                        ],
                        [
                          38.867,
                          -38.379
                        ],
                        [
                          38.867,
                          -30.322
                        ],
                        [
                          61.328,
                          -30.322
                        ],
                        [
                          54.81,
                          -12.085
                        ],
                        [
                          38.721,
                          -6.445
                        ],
                        [
                          20.41,
                          -14.478
                        ],
                        [
                          14.795,
                          -35.303
                        ],
                        [
                          21.606,
                          -57.568
                        ],
                        [
                          38.379,
                          -65.039
                        ],
                        [
                          52.295,
                          -61.45
                        ],
                        [
                          59.57,
                          -50
                        ],
                        [
                          69.189,
                          -50
                        ],
                        [
                          56.104,
                          -69.678
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "G",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "G",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "p",
        "size": 14,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          4.102,
                          0
                        ],
                        [
                          2.278,
                          5.404
                        ],
                        [
                          0,
                          4.037
                        ],
                        [
                          -1.205,
                          3.255
                        ],
                        [
                          -6.087,
                          0
                        ],
                        [
                          -2.279,
                          -5.762
                        ],
                        [
                          0,
                          -4.166
                        ],
                        [
                          2.718,
                          -3.434
                        ]
                      ],
                      "o": [
                        [
                          -6.055,
                          0
                        ],
                        [
                          -1.205,
                          -2.832
                        ],
                        [
                          0,
                          -5.013
                        ],
                        [
                          2.246,
                          -6.087
                        ],
                        [
                          6.055,
                          0
                        ],
                        [
                          1.204,
                          2.995
                        ],
                        [
                          0,
                          6.836
                        ],
                        [
                          -2.718,
                          3.435
                        ]
                      ],
                      "v": [
                        [
                          28.516,
                          -5.908
                        ],
                        [
                          16.016,
                          -14.014
                        ],
                        [
                          14.209,
                          -24.316
                        ],
                        [
                          16.016,
                          -36.719
                        ],
                        [
                          28.516,
                          -45.85
                        ],
                        [
                          41.016,
                          -37.207
                        ],
                        [
                          42.822,
                          -26.465
                        ],
                        [
                          38.745,
                          -11.06
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "p",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.563,
                          -0.977
                        ],
                        [
                          -3.939,
                          0
                        ],
                        [
                          -3.777,
                          3.092
                        ],
                        [
                          0,
                          11.394
                        ],
                        [
                          4.134,
                          4.541
                        ],
                        [
                          5.924,
                          0
                        ],
                        [
                          2.962,
                          -1.953
                        ],
                        [
                          1.758,
                          -2.376
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.92,
                          2.377
                        ],
                        [
                          2.669,
                          1.725
                        ],
                        [
                          5.013,
                          0
                        ],
                        [
                          5.957,
                          -4.883
                        ],
                        [
                          0,
                          -8.43
                        ],
                        [
                          -4.134,
                          -4.541
                        ],
                        [
                          -4.004,
                          0
                        ],
                        [
                          -2.084,
                          1.302
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          5.762,
                          20.85
                        ],
                        [
                          14.551,
                          20.85
                        ],
                        [
                          14.551,
                          -5.859
                        ],
                        [
                          19.775,
                          -0.83
                        ],
                        [
                          29.688,
                          1.758
                        ],
                        [
                          42.871,
                          -2.881
                        ],
                        [
                          51.807,
                          -27.295
                        ],
                        [
                          45.605,
                          -46.753
                        ],
                        [
                          30.518,
                          -53.564
                        ],
                        [
                          20.068,
                          -50.635
                        ],
                        [
                          14.307,
                          -45.117
                        ],
                        [
                          14.307,
                          -52.051
                        ],
                        [
                          5.762,
                          -52.051
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "p",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "p",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "T",
        "size": 14,
        "style": "Regular",
        "w": 61.08,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          1.611,
                          -71.729
                        ],
                        [
                          1.611,
                          -63.184
                        ],
                        [
                          25.781,
                          -63.184
                        ],
                        [
                          25.781,
                          0
                        ],
                        [
                          35.645,
                          0
                        ],
                        [
                          35.645,
                          -63.184
                        ],
                        [
                          59.814,
                          -63.184
                        ],
                        [
                          59.814,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "T",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "T",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "8",
        "size": 14,
        "style": "Regular",
        "w": 55.62,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          3.873,
                          0
                        ],
                        [
                          2.441,
                          1.855
                        ],
                        [
                          0,
                          3.288
                        ],
                        [
                          -1.888,
                          2.181
                        ],
                        [
                          -4.232,
                          0
                        ],
                        [
                          -2.084,
                          -2.18
                        ],
                        [
                          0,
                          -2.604
                        ],
                        [
                          2.18,
                          -2.164
                        ]
                      ],
                      "o": [
                        [
                          -3.32,
                          0
                        ],
                        [
                          -2.441,
                          -1.855
                        ],
                        [
                          0,
                          -2.93
                        ],
                        [
                          1.888,
                          -2.18
                        ],
                        [
                          4.264,
                          0
                        ],
                        [
                          2.083,
                          2.181
                        ],
                        [
                          0,
                          2.995
                        ],
                        [
                          -2.181,
                          2.165
                        ]
                      ],
                      "v": [
                        [
                          27.197,
                          -40.625
                        ],
                        [
                          18.555,
                          -43.408
                        ],
                        [
                          14.893,
                          -51.123
                        ],
                        [
                          17.725,
                          -58.789
                        ],
                        [
                          26.904,
                          -62.061
                        ],
                        [
                          36.426,
                          -58.789
                        ],
                        [
                          39.551,
                          -51.611
                        ],
                        [
                          36.279,
                          -43.872
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          4.069,
                          0
                        ],
                        [
                          2.425,
                          2.654
                        ],
                        [
                          0,
                          3.646
                        ],
                        [
                          -2.654,
                          2.393
                        ],
                        [
                          -4.199,
                          0
                        ],
                        [
                          -2.767,
                          -2.344
                        ],
                        [
                          0,
                          -4.524
                        ],
                        [
                          2.686,
                          -2.197
                        ]
                      ],
                      "o": [
                        [
                          -5.078,
                          0
                        ],
                        [
                          -2.425,
                          -2.653
                        ],
                        [
                          0,
                          -4.231
                        ],
                        [
                          2.653,
                          -2.393
                        ],
                        [
                          4.329,
                          0
                        ],
                        [
                          2.766,
                          2.344
                        ],
                        [
                          0,
                          4.362
                        ],
                        [
                          -2.686,
                          2.197
                        ]
                      ],
                      "v": [
                        [
                          27.734,
                          -6.006
                        ],
                        [
                          16.479,
                          -9.985
                        ],
                        [
                          12.842,
                          -19.434
                        ],
                        [
                          16.821,
                          -29.37
                        ],
                        [
                          27.1,
                          -32.959
                        ],
                        [
                          37.744,
                          -29.443
                        ],
                        [
                          41.895,
                          -19.141
                        ],
                        [
                          37.866,
                          -9.302
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          -2.441,
                          -1.041
                        ],
                        [
                          2.018,
                          -3.011
                        ],
                        [
                          0,
                          -4.134
                        ],
                        [
                          -4.704,
                          -3.694
                        ],
                        [
                          -6.804,
                          0
                        ],
                        [
                          -4.134,
                          4.281
                        ],
                        [
                          0,
                          6.152
                        ],
                        [
                          3.092,
                          3.255
                        ],
                        [
                          2.897,
                          1.335
                        ],
                        [
                          -1.237,
                          1.53
                        ],
                        [
                          0,
                          4.362
                        ],
                        [
                          3.809,
                          3.532
                        ],
                        [
                          6.705,
                          0
                        ],
                        [
                          3.776,
                          -3.743
                        ],
                        [
                          0,
                          -5.208
                        ],
                        [
                          -2.572,
                          -2.604
                        ]
                      ],
                      "o": [
                        [
                          -3.972,
                          1.595
                        ],
                        [
                          -2.019,
                          3.011
                        ],
                        [
                          0,
                          7.031
                        ],
                        [
                          4.704,
                          3.694
                        ],
                        [
                          7.552,
                          0
                        ],
                        [
                          4.134,
                          -4.28
                        ],
                        [
                          0,
                          -5.208
                        ],
                        [
                          -1.66,
                          -1.725
                        ],
                        [
                          2.604,
                          -1.465
                        ],
                        [
                          2.213,
                          -2.702
                        ],
                        [
                          0,
                          -4.72
                        ],
                        [
                          -3.809,
                          -3.532
                        ],
                        [
                          -6.934,
                          0
                        ],
                        [
                          -3.777,
                          3.744
                        ],
                        [
                          0,
                          4.167
                        ],
                        [
                          1.367,
                          1.4
                        ]
                      ],
                      "v": [
                        [
                          15.234,
                          -37.256
                        ],
                        [
                          6.25,
                          -30.347
                        ],
                        [
                          3.223,
                          -19.629
                        ],
                        [
                          10.278,
                          -3.54
                        ],
                        [
                          27.539,
                          2.002
                        ],
                        [
                          45.068,
                          -4.419
                        ],
                        [
                          51.27,
                          -20.068
                        ],
                        [
                          46.631,
                          -32.764
                        ],
                        [
                          39.795,
                          -37.354
                        ],
                        [
                          45.557,
                          -41.846
                        ],
                        [
                          48.877,
                          -52.441
                        ],
                        [
                          43.164,
                          -64.819
                        ],
                        [
                          27.393,
                          -70.117
                        ],
                        [
                          11.328,
                          -64.502
                        ],
                        [
                          5.664,
                          -51.074
                        ],
                        [
                          9.521,
                          -40.918
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "8",
              "np": 6,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "K",
        "size": 16,
        "style": "Regular",
        "w": 66.7,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          7.617,
                          0
                        ],
                        [
                          17.09,
                          0
                        ],
                        [
                          17.09,
                          -25
                        ],
                        [
                          28.564,
                          -35.986
                        ],
                        [
                          53.662,
                          0
                        ],
                        [
                          66.309,
                          0
                        ],
                        [
                          35.645,
                          -42.822
                        ],
                        [
                          65.479,
                          -71.729
                        ],
                        [
                          52.051,
                          -71.729
                        ],
                        [
                          17.09,
                          -36.768
                        ],
                        [
                          17.09,
                          -71.729
                        ],
                        [
                          7.617,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "K",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "K",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "P",
        "size": 16,
        "style": "Regular",
        "w": 66.7,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.484,
                          4.15
                        ],
                        [
                          0,
                          5.599
                        ],
                        [
                          3.906,
                          3.597
                        ],
                        [
                          6.38,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          7.227,
                          0
                        ],
                        [
                          3.483,
                          -4.15
                        ],
                        [
                          0,
                          -6.51
                        ],
                        [
                          -3.906,
                          -3.596
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          8.545,
                          0
                        ],
                        [
                          18.262,
                          0
                        ],
                        [
                          18.262,
                          -30.322
                        ],
                        [
                          40.82,
                          -30.322
                        ],
                        [
                          56.885,
                          -36.548
                        ],
                        [
                          62.109,
                          -51.172
                        ],
                        [
                          56.25,
                          -66.333
                        ],
                        [
                          40.82,
                          -71.729
                        ],
                        [
                          8.545,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "P",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          -5.273
                        ],
                        [
                          2.718,
                          -1.855
                        ],
                        [
                          4.362,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.148,
                          -1.009
                        ]
                      ],
                      "o": [
                        [
                          0,
                          4.688
                        ],
                        [
                          -2.718,
                          1.855
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.743,
                          0
                        ],
                        [
                          3.906,
                          1.888
                        ]
                      ],
                      "v": [
                        [
                          52.295,
                          -51.123
                        ],
                        [
                          48.218,
                          -41.309
                        ],
                        [
                          37.598,
                          -38.525
                        ],
                        [
                          18.262,
                          -38.525
                        ],
                        [
                          18.262,
                          -63.379
                        ],
                        [
                          37.598,
                          -63.379
                        ],
                        [
                          46.436,
                          -61.865
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "P",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "P",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "D",
        "size": 16,
        "style": "Regular",
        "w": 72.22,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.532,
                          -4.915
                        ],
                        [
                          0,
                          -8.887
                        ],
                        [
                          0.488,
                          -2.702
                        ],
                        [
                          1.92,
                          -2.897
                        ],
                        [
                          3.776,
                          -1.27
                        ],
                        [
                          3.288,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          7.845,
                          0
                        ],
                        [
                          3.532,
                          4.916
                        ],
                        [
                          0,
                          2.312
                        ],
                        [
                          -0.847,
                          4.525
                        ],
                        [
                          -2.409,
                          3.613
                        ],
                        [
                          -2.116,
                          0.684
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          17.822,
                          -8.301
                        ],
                        [
                          17.822,
                          -63.379
                        ],
                        [
                          35.059,
                          -63.379
                        ],
                        [
                          52.124,
                          -56.006
                        ],
                        [
                          57.422,
                          -35.303
                        ],
                        [
                          56.689,
                          -27.783
                        ],
                        [
                          52.539,
                          -16.65
                        ],
                        [
                          43.262,
                          -9.326
                        ],
                        [
                          35.156,
                          -8.301
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "D",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -5.046,
                          10.873
                        ],
                        [
                          0,
                          7.617
                        ],
                        [
                          4.85,
                          6.316
                        ],
                        [
                          9.863,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          12.305,
                          0
                        ],
                        [
                          2.864,
                          -6.152
                        ],
                        [
                          0,
                          -9.863
                        ],
                        [
                          -5.437,
                          -6.998
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          8.057,
                          0
                        ],
                        [
                          37.012,
                          0
                        ],
                        [
                          63.037,
                          -16.309
                        ],
                        [
                          67.334,
                          -36.963
                        ],
                        [
                          60.059,
                          -61.23
                        ],
                        [
                          37.109,
                          -71.729
                        ],
                        [
                          8.057,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "D",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "D",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "Z",
        "size": 14,
        "style": "Regular",
        "w": 61.08,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          2.295,
                          0
                        ],
                        [
                          58.789,
                          0
                        ],
                        [
                          58.789,
                          -8.545
                        ],
                        [
                          14.551,
                          -8.545
                        ],
                        [
                          58.789,
                          -63.379
                        ],
                        [
                          58.789,
                          -71.729
                        ],
                        [
                          5.518,
                          -71.729
                        ],
                        [
                          5.518,
                          -63.184
                        ],
                        [
                          46.289,
                          -63.184
                        ],
                        [
                          2.295,
                          -8.057
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Z",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "Z",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      },
      {
        "ch": "E",
        "size": 14,
        "style": "Regular",
        "w": 66.7,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          8.545,
                          0
                        ],
                        [
                          61.572,
                          0
                        ],
                        [
                          61.572,
                          -8.545
                        ],
                        [
                          18.018,
                          -8.545
                        ],
                        [
                          18.018,
                          -32.861
                        ],
                        [
                          57.617,
                          -32.861
                        ],
                        [
                          57.617,
                          -41.162
                        ],
                        [
                          18.018,
                          -41.162
                        ],
                        [
                          18.018,
                          -62.939
                        ],
                        [
                          60.84,
                          -62.939
                        ],
                        [
                          60.84,
                          -71.729
                        ],
                        [
                          8.545,
                          -71.729
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "E",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "E",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Helvetica"
      }
    ]
  };

  export const smsAnimationData = {
    "v": "4.8.0",
    "meta": {
      "g": "LottieFiles AE 1.0.0",
      "a": "",
      "k": "",
      "d": "",
      "tc": ""
    },
    "fr": 29.9700012207031,
    "ip": 0,
    "op": 240.0000097754,
    "w": 1080,
    "h": 1080,
    "nm": "ICON 2 SIN EXP",
    "ddd": 0,
    "assets": [
      {
        "id": "comp_0",
        "layers": [
          {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Layer 28",
            "sr": 1,
            "ks": {
              "o": {
                "a": 0,
                "k": 100
              },
              "r": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 78,
                    "s": [
                      -19
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 79,
                    "s": [
                      -17.675
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 80,
                    "s": [
                      -16.413
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.711
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 81,
                    "s": [
                      -15.212
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.117
                      ]
                    },
                    "t": 82,
                    "s": [
                      -14.072
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.834
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.166
                      ]
                    },
                    "t": 83,
                    "s": [
                      -11.261
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.834
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 84,
                    "s": [
                      -8.426
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 85,
                    "s": [
                      -5.608
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 86,
                    "s": [
                      -2.825
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 87,
                    "s": [
                      -0.083
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 88,
                    "s": [
                      2.614
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 89,
                    "s": [
                      5.262
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 90,
                    "s": [
                      7.861
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 91,
                    "s": [
                      10.409
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 92,
                    "s": [
                      12.906
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 93,
                    "s": [
                      15.351
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 94,
                    "s": [
                      17.745
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 95,
                    "s": [
                      20.087
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 96,
                    "s": [
                      22.376
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 97,
                    "s": [
                      24.612
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 98,
                    "s": [
                      26.794
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 99,
                    "s": [
                      28.922
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 100,
                    "s": [
                      30.993
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 101,
                    "s": [
                      33.009
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 102,
                    "s": [
                      34.968
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 103,
                    "s": [
                      36.869
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.17
                      ]
                    },
                    "t": 104,
                    "s": [
                      38.709
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.838
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.17
                      ]
                    },
                    "t": 105,
                    "s": [
                      40.484
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.839
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 106,
                    "s": [
                      42.184
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.842
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.173
                      ]
                    },
                    "t": 107,
                    "s": [
                      43.797
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.847
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.176
                      ]
                    },
                    "t": 108,
                    "s": [
                      45.301
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.865
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.184
                      ]
                    },
                    "t": 109,
                    "s": [
                      46.655
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.94
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.218
                      ]
                    },
                    "t": 110,
                    "s": [
                      47.781
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.597
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        -0.216
                      ]
                    },
                    "t": 111,
                    "s": [
                      48.477
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.804
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.105
                      ]
                    },
                    "t": 112,
                    "s": [
                      48.283
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.821
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.145
                      ]
                    },
                    "t": 113,
                    "s": [
                      47.539
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.826
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.156
                      ]
                    },
                    "t": 114,
                    "s": [
                      46.532
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.16
                      ]
                    },
                    "t": 115,
                    "s": [
                      45.371
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.831
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 116,
                    "s": [
                      44.115
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.832
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.164
                      ]
                    },
                    "t": 117,
                    "s": [
                      42.797
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.166
                      ]
                    },
                    "t": 118,
                    "s": [
                      41.443
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.834
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.166
                      ]
                    },
                    "t": 119,
                    "s": [
                      40.07
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.834
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 120,
                    "s": [
                      38.692
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 121,
                    "s": [
                      37.322
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 122,
                    "s": [
                      35.968
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 123,
                    "s": [
                      34.637
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 124,
                    "s": [
                      33.337
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.17
                      ]
                    },
                    "t": 125,
                    "s": [
                      32.072
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.17
                      ]
                    },
                    "t": 126,
                    "s": [
                      30.85
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.838
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 127,
                    "s": [
                      29.675
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.838
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 128,
                    "s": [
                      28.554
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.839
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.172
                      ]
                    },
                    "t": 129,
                    "s": [
                      27.491
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.841
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.173
                      ]
                    },
                    "t": 130,
                    "s": [
                      26.494
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.843
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.175
                      ]
                    },
                    "t": 131,
                    "s": [
                      25.569
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.847
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.177
                      ]
                    },
                    "t": 132,
                    "s": [
                      24.727
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.858
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.183
                      ]
                    },
                    "t": 133,
                    "s": [
                      23.982
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        1.206
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.201
                      ]
                    },
                    "t": 134,
                    "s": [
                      23.357
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.059
                      ]
                    },
                    "t": 135,
                    "s": [
                      22.916
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.162
                      ]
                    },
                    "t": 136,
                    "s": [
                      24.451
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.162
                      ]
                    },
                    "t": 137,
                    "s": [
                      26.071
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 138,
                    "s": [
                      27.778
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 139,
                    "s": [
                      29.576
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 140,
                    "s": [
                      31.466
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 141,
                    "s": [
                      33.45
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 142,
                    "s": [
                      35.531
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.83
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 143,
                    "s": [
                      37.711
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.83
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 144,
                    "s": [
                      39.992
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.83
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 145,
                    "s": [
                      42.377
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.83
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 146,
                    "s": [
                      44.868
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.83
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 147,
                    "s": [
                      47.467
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 148,
                    "s": [
                      50.177
                    ]
                  },
                  {
                    "t": 149.000006068894,
                    "s": [
                      53
                    ]
                  }
                ]
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.837
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 78,
                    "s": [
                      455.71,
                      1076.154,
                      0
                    ],
                    "to": [
                      -3.754,
                      -4.254,
                      0
                    ],
                    "ti": [
                      7.33,
                      8.306,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.837
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.171
                    },
                    "t": 79,
                    "s": [
                      433.184,
                      1050.629,
                      0
                    ],
                    "to": [
                      -7.33,
                      -8.306,
                      0
                    ],
                    "ti": [
                      6.977,
                      7.906,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.837
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.171
                    },
                    "t": 80,
                    "s": [
                      411.73,
                      1026.319,
                      0
                    ],
                    "to": [
                      -6.977,
                      -7.906,
                      0
                    ],
                    "ti": [
                      6.633,
                      7.515,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.171
                    },
                    "t": 81,
                    "s": [
                      391.322,
                      1003.195,
                      0
                    ],
                    "to": [
                      -6.633,
                      -7.515,
                      0
                    ],
                    "ti": [
                      6.025,
                      7.814,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.165
                    },
                    "t": 82,
                    "s": [
                      371.934,
                      981.226,
                      0
                    ],
                    "to": [
                      -6.025,
                      -7.814,
                      0
                    ],
                    "ti": [
                      5.405,
                      8.114,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.171
                    },
                    "t": 83,
                    "s": [
                      355.172,
                      956.308,
                      0
                    ],
                    "to": [
                      -5.405,
                      -8.114,
                      0
                    ],
                    "ti": [
                      5.045,
                      7.733,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.171
                    },
                    "t": 84,
                    "s": [
                      339.502,
                      932.545,
                      0
                    ],
                    "to": [
                      -5.045,
                      -7.733,
                      0
                    ],
                    "ti": [
                      4.692,
                      7.361,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 85,
                    "s": [
                      324.901,
                      909.911,
                      0
                    ],
                    "to": [
                      -4.692,
                      -7.361,
                      0
                    ],
                    "ti": [
                      4.347,
                      6.997,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 86,
                    "s": [
                      311.347,
                      888.38,
                      0
                    ],
                    "to": [
                      -4.347,
                      -6.997,
                      0
                    ],
                    "ti": [
                      4.011,
                      6.642,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 87,
                    "s": [
                      298.818,
                      867.927,
                      0
                    ],
                    "to": [
                      -4.011,
                      -6.642,
                      0
                    ],
                    "ti": [
                      3.684,
                      6.294,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 88,
                    "s": [
                      287.283,
                      848.53,
                      0
                    ],
                    "to": [
                      -3.684,
                      -6.294,
                      0
                    ],
                    "ti": [
                      3.368,
                      5.955,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 89,
                    "s": [
                      276.713,
                      830.163,
                      0
                    ],
                    "to": [
                      -3.368,
                      -5.955,
                      0
                    ],
                    "ti": [
                      3.062,
                      5.626,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 90,
                    "s": [
                      267.076,
                      812.797,
                      0
                    ],
                    "to": [
                      -3.062,
                      -5.626,
                      0
                    ],
                    "ti": [
                      2.767,
                      5.307,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 91,
                    "s": [
                      258.341,
                      796.404,
                      0
                    ],
                    "to": [
                      -2.767,
                      -5.307,
                      0
                    ],
                    "ti": [
                      2.485,
                      4.999,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 92,
                    "s": [
                      250.471,
                      780.953,
                      0
                    ],
                    "to": [
                      -2.485,
                      -4.999,
                      0
                    ],
                    "ti": [
                      2.215,
                      4.701,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 93,
                    "s": [
                      243.432,
                      766.411,
                      0
                    ],
                    "to": [
                      -2.215,
                      -4.701,
                      0
                    ],
                    "ti": [
                      1.957,
                      4.414,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 94,
                    "s": [
                      237.184,
                      752.748,
                      0
                    ],
                    "to": [
                      -1.957,
                      -4.414,
                      0
                    ],
                    "ti": [
                      1.711,
                      4.139,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.84
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 95,
                    "s": [
                      231.691,
                      739.927,
                      0
                    ],
                    "to": [
                      -1.711,
                      -4.139,
                      0
                    ],
                    "ti": [
                      1.477,
                      3.877,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.84
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 96,
                    "s": [
                      226.918,
                      727.911,
                      0
                    ],
                    "to": [
                      -1.477,
                      -3.877,
                      0
                    ],
                    "ti": [
                      1.254,
                      3.628,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.84
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 97,
                    "s": [
                      222.832,
                      716.663,
                      0
                    ],
                    "to": [
                      -1.254,
                      -3.628,
                      0
                    ],
                    "ti": [
                      1.043,
                      3.39,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.84
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.174
                    },
                    "t": 98,
                    "s": [
                      219.396,
                      706.145,
                      0
                    ],
                    "to": [
                      -1.043,
                      -3.39,
                      0
                    ],
                    "ti": [
                      0.844,
                      3.164,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.84
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.174
                    },
                    "t": 99,
                    "s": [
                      216.576,
                      696.324,
                      0
                    ],
                    "to": [
                      -0.844,
                      -3.164,
                      0
                    ],
                    "ti": [
                      0.657,
                      2.954,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 100,
                    "s": [
                      214.335,
                      687.16,
                      0
                    ],
                    "to": [
                      -0.657,
                      -2.954,
                      0
                    ],
                    "ti": [
                      0.482,
                      2.762,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 101,
                    "s": [
                      212.636,
                      678.6,
                      0
                    ],
                    "to": [
                      -0.482,
                      -2.762,
                      0
                    ],
                    "ti": [
                      0.318,
                      2.589,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 102,
                    "s": [
                      211.445,
                      670.588,
                      0
                    ],
                    "to": [
                      -0.318,
                      -2.589,
                      0
                    ],
                    "ti": [
                      0.166,
                      2.434,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.834
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 103,
                    "s": [
                      210.727,
                      663.067,
                      0
                    ],
                    "to": [
                      -0.166,
                      -2.434,
                      0
                    ],
                    "ti": [
                      -0.043,
                      2.354,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.837
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 104,
                    "s": [
                      210.447,
                      655.982,
                      0
                    ],
                    "to": [
                      0.043,
                      -2.354,
                      0
                    ],
                    "ti": [
                      -0.243,
                      2.29,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.836
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.17
                    },
                    "t": 105,
                    "s": [
                      210.985,
                      648.943,
                      0
                    ],
                    "to": [
                      0.243,
                      -2.29,
                      0
                    ],
                    "ti": [
                      -0.361,
                      2.188,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.835
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.169
                    },
                    "t": 106,
                    "s": [
                      211.904,
                      642.242,
                      0
                    ],
                    "to": [
                      0.361,
                      -2.188,
                      0
                    ],
                    "ti": [
                      -0.462,
                      2.105,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.834
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.169
                    },
                    "t": 107,
                    "s": [
                      213.149,
                      635.817,
                      0
                    ],
                    "to": [
                      0.462,
                      -2.105,
                      0
                    ],
                    "ti": [
                      -0.549,
                      2.043,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.834
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.168
                    },
                    "t": 108,
                    "s": [
                      214.676,
                      629.609,
                      0
                    ],
                    "to": [
                      0.549,
                      -2.043,
                      0
                    ],
                    "ti": [
                      -0.621,
                      2.002,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 109,
                    "s": [
                      216.44,
                      623.557,
                      0
                    ],
                    "to": [
                      0.621,
                      -2.002,
                      0
                    ],
                    "ti": [
                      -0.681,
                      1.98,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.832
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.166
                    },
                    "t": 110,
                    "s": [
                      218.403,
                      617.6,
                      0
                    ],
                    "to": [
                      0.681,
                      -1.98,
                      0
                    ],
                    "ti": [
                      -0.726,
                      1.979,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.832
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.166
                    },
                    "t": 111,
                    "s": [
                      220.523,
                      611.675,
                      0
                    ],
                    "to": [
                      0.726,
                      -1.979,
                      0
                    ],
                    "ti": [
                      -0.756,
                      1.998,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.165
                    },
                    "t": 112,
                    "s": [
                      222.757,
                      605.724,
                      0
                    ],
                    "to": [
                      0.756,
                      -1.998,
                      0
                    ],
                    "ti": [
                      -0.771,
                      2.037,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.165
                    },
                    "t": 113,
                    "s": [
                      225.06,
                      599.687,
                      0
                    ],
                    "to": [
                      0.771,
                      -2.037,
                      0
                    ],
                    "ti": [
                      -0.77,
                      2.096,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 114,
                    "s": [
                      227.384,
                      593.504,
                      0
                    ],
                    "to": [
                      0.77,
                      -2.096,
                      0
                    ],
                    "ti": [
                      -0.752,
                      2.176,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 115,
                    "s": [
                      229.681,
                      587.112,
                      0
                    ],
                    "to": [
                      0.752,
                      -2.176,
                      0
                    ],
                    "ti": [
                      -0.716,
                      2.278,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.829
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 116,
                    "s": [
                      231.898,
                      580.447,
                      0
                    ],
                    "to": [
                      0.716,
                      -2.278,
                      0
                    ],
                    "ti": [
                      -0.66,
                      2.402,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.829
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 117,
                    "s": [
                      233.978,
                      573.444,
                      0
                    ],
                    "to": [
                      0.66,
                      -2.402,
                      0
                    ],
                    "ti": [
                      -0.579,
                      2.547,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.829
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 118,
                    "s": [
                      235.857,
                      566.037,
                      0
                    ],
                    "to": [
                      0.579,
                      -2.547,
                      0
                    ],
                    "ti": [
                      -0.471,
                      2.712,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.828
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 119,
                    "s": [
                      237.454,
                      558.164,
                      0
                    ],
                    "to": [
                      0.471,
                      -2.712,
                      0
                    ],
                    "ti": [
                      -0.332,
                      2.897,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.828
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 120,
                    "s": [
                      238.682,
                      549.765,
                      0
                    ],
                    "to": [
                      0.332,
                      -2.897,
                      0
                    ],
                    "ti": [
                      -0.161,
                      3.097,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.828
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 121,
                    "s": [
                      239.446,
                      540.783,
                      0
                    ],
                    "to": [
                      0.161,
                      -3.097,
                      0
                    ],
                    "ti": [
                      0.043,
                      3.302,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.828
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 122,
                    "s": [
                      239.651,
                      531.18,
                      0
                    ],
                    "to": [
                      -0.043,
                      -3.302,
                      0
                    ],
                    "ti": [
                      0.285,
                      3.496,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.828
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 123,
                    "s": [
                      239.185,
                      520.972,
                      0
                    ],
                    "to": [
                      -0.285,
                      -3.496,
                      0
                    ],
                    "ti": [
                      0.558,
                      3.674,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.824
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 124,
                    "s": [
                      237.94,
                      510.204,
                      0
                    ],
                    "to": [
                      -0.558,
                      -3.674,
                      0
                    ],
                    "ti": [
                      0.817,
                      3.96,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.158
                    },
                    "t": 125,
                    "s": [
                      235.837,
                      498.927,
                      0
                    ],
                    "to": [
                      -0.817,
                      -3.96,
                      0
                    ],
                    "ti": [
                      0.988,
                      4.24,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 126,
                    "s": [
                      233.038,
                      486.445,
                      0
                    ],
                    "to": [
                      -0.988,
                      -4.24,
                      0
                    ],
                    "ti": [
                      1.1,
                      4.407,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 127,
                    "s": [
                      229.911,
                      473.485,
                      0
                    ],
                    "to": [
                      -1.1,
                      -4.407,
                      0
                    ],
                    "ti": [
                      1.22,
                      4.581,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 128,
                    "s": [
                      226.435,
                      460.004,
                      0
                    ],
                    "to": [
                      -1.22,
                      -4.581,
                      0
                    ],
                    "ti": [
                      1.345,
                      4.757,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 129,
                    "s": [
                      222.593,
                      445.999,
                      0
                    ],
                    "to": [
                      -1.345,
                      -4.757,
                      0
                    ],
                    "ti": [
                      1.475,
                      4.935,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 130,
                    "s": [
                      218.367,
                      431.464,
                      0
                    ],
                    "to": [
                      -1.475,
                      -4.935,
                      0
                    ],
                    "ti": [
                      1.611,
                      5.115,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 131,
                    "s": [
                      213.742,
                      416.392,
                      0
                    ],
                    "to": [
                      -1.611,
                      -5.115,
                      0
                    ],
                    "ti": [
                      1.752,
                      5.297,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 132,
                    "s": [
                      208.701,
                      400.777,
                      0
                    ],
                    "to": [
                      -1.752,
                      -5.297,
                      0
                    ],
                    "ti": [
                      1.898,
                      5.48,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 133,
                    "s": [
                      203.229,
                      384.613,
                      0
                    ],
                    "to": [
                      -1.898,
                      -5.48,
                      0
                    ],
                    "ti": [
                      2.047,
                      5.663,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 134,
                    "s": [
                      197.314,
                      367.9,
                      0
                    ],
                    "to": [
                      -2.047,
                      -5.663,
                      0
                    ],
                    "ti": [
                      2.199,
                      5.848,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 135,
                    "s": [
                      190.947,
                      350.635,
                      0
                    ],
                    "to": [
                      -2.199,
                      -5.848,
                      0
                    ],
                    "ti": [
                      2.352,
                      6.034,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 136,
                    "s": [
                      184.121,
                      332.814,
                      0
                    ],
                    "to": [
                      -2.352,
                      -6.034,
                      0
                    ],
                    "ti": [
                      2.505,
                      6.222,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 137,
                    "s": [
                      176.836,
                      314.433,
                      0
                    ],
                    "to": [
                      -2.505,
                      -6.222,
                      0
                    ],
                    "ti": [
                      2.657,
                      6.413,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 138,
                    "s": [
                      169.091,
                      295.483,
                      0
                    ],
                    "to": [
                      -2.657,
                      -6.413,
                      0
                    ],
                    "ti": [
                      2.805,
                      6.609,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 139,
                    "s": [
                      160.896,
                      275.952,
                      0
                    ],
                    "to": [
                      -2.805,
                      -6.609,
                      0
                    ],
                    "ti": [
                      2.947,
                      6.811,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 140,
                    "s": [
                      152.264,
                      255.827,
                      0
                    ],
                    "to": [
                      -2.947,
                      -6.811,
                      0
                    ],
                    "ti": [
                      3.082,
                      7.023,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 141,
                    "s": [
                      143.217,
                      235.084,
                      0
                    ],
                    "to": [
                      -3.082,
                      -7.023,
                      0
                    ],
                    "ti": [
                      3.209,
                      7.249,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 142,
                    "s": [
                      133.774,
                      213.689,
                      0
                    ],
                    "to": [
                      -3.209,
                      -7.249,
                      0
                    ],
                    "ti": [
                      3.326,
                      7.493,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 143,
                    "s": [
                      123.962,
                      191.591,
                      0
                    ],
                    "to": [
                      -3.326,
                      -7.493,
                      0
                    ],
                    "ti": [
                      3.427,
                      7.762,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 144,
                    "s": [
                      113.821,
                      168.73,
                      0
                    ],
                    "to": [
                      -3.427,
                      -7.762,
                      0
                    ],
                    "ti": [
                      3.507,
                      8.068,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 145,
                    "s": [
                      103.399,
                      145.016,
                      0
                    ],
                    "to": [
                      -3.507,
                      -8.068,
                      0
                    ],
                    "ti": [
                      3.547,
                      8.428,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 146,
                    "s": [
                      92.778,
                      120.321,
                      0
                    ],
                    "to": [
                      -3.547,
                      -8.428,
                      0
                    ],
                    "ti": [
                      3.502,
                      8.872,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.846
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 147,
                    "s": [
                      82.116,
                      94.447,
                      0
                    ],
                    "to": [
                      -3.502,
                      -8.872,
                      0
                    ],
                    "ti": [
                      2.901,
                      8.549,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.181
                    },
                    "t": 148,
                    "s": [
                      71.767,
                      67.089,
                      0
                    ],
                    "to": [
                      -2.901,
                      -8.549,
                      0
                    ],
                    "ti": [
                      1.176,
                      3.989,
                      0
                    ]
                  },
                  {
                    "t": 149.000006068894,
                    "s": [
                      64.71,
                      43.154,
                      0
                    ]
                  }
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  -407.29,
                  -43.846,
                  0
                ]
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.837,
                        0.837,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0
                      ]
                    },
                    "t": 78,
                    "s": [
                      0,
                      0,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.837,
                        0.837,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 79,
                    "s": [
                      8.439,
                      8.439,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.837,
                        0.837,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 80,
                    "s": [
                      16.476,
                      16.476,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 81,
                    "s": [
                      24.121,
                      24.121,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 82,
                    "s": [
                      31.383,
                      31.383,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 83,
                    "s": [
                      38.274,
                      38.274,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 84,
                    "s": [
                      44.802,
                      44.802,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 85,
                    "s": [
                      50.977,
                      50.977,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 86,
                    "s": [
                      56.809,
                      56.809,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 87,
                    "s": [
                      62.308,
                      62.308,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.839,
                        0.839,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 88,
                    "s": [
                      67.484,
                      67.484,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.839,
                        0.839,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 89,
                    "s": [
                      72.346,
                      72.346,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.839,
                        0.839,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 90,
                    "s": [
                      76.904,
                      76.904,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.839,
                        0.839,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.173,
                        0.173,
                        0
                      ]
                    },
                    "t": 91,
                    "s": [
                      81.168,
                      81.168,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.839,
                        0.839,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.173,
                        0.173,
                        0
                      ]
                    },
                    "t": 92,
                    "s": [
                      85.148,
                      85.148,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.84,
                        0.84,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.173,
                        0.173,
                        0
                      ]
                    },
                    "t": 93,
                    "s": [
                      88.854,
                      88.854,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.84,
                        0.84,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.173,
                        0.173,
                        0
                      ]
                    },
                    "t": 94,
                    "s": [
                      92.295,
                      92.295,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.84,
                        0.84,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.174,
                        0.174,
                        0
                      ]
                    },
                    "t": 95,
                    "s": [
                      95.481,
                      95.481,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.84,
                        0.84,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.174,
                        0.174,
                        0
                      ]
                    },
                    "t": 96,
                    "s": [
                      98.423,
                      98.423,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.841,
                        0.841,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.174,
                        0.174,
                        0
                      ]
                    },
                    "t": 97,
                    "s": [
                      101.129,
                      101.129,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.841,
                        0.841,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.175,
                        0.175,
                        0
                      ]
                    },
                    "t": 98,
                    "s": [
                      103.61,
                      103.61,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.841,
                        0.841,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.175,
                        0.175,
                        0
                      ]
                    },
                    "t": 99,
                    "s": [
                      105.875,
                      105.875,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.842,
                        0.842,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.176,
                        0.176,
                        0
                      ]
                    },
                    "t": 100,
                    "s": [
                      107.934,
                      107.934,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.843,
                        0.843,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.177,
                        0.177,
                        0
                      ]
                    },
                    "t": 101,
                    "s": [
                      109.791,
                      109.791,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.844,
                        0.844,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.178,
                        0.178,
                        0
                      ]
                    },
                    "t": 102,
                    "s": [
                      111.451,
                      111.451,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.845,
                        0.845,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.179,
                        0.179,
                        0
                      ]
                    },
                    "t": 103,
                    "s": [
                      112.918,
                      112.918,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.847,
                        0.847,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.181,
                        0.181,
                        0
                      ]
                    },
                    "t": 104,
                    "s": [
                      114.196,
                      114.196,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.85,
                        0.85,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.183,
                        0.183,
                        0
                      ]
                    },
                    "t": 105,
                    "s": [
                      115.288,
                      115.288,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.853,
                        0.853,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.187,
                        0.187,
                        0
                      ]
                    },
                    "t": 106,
                    "s": [
                      116.199,
                      116.199,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.859,
                        0.859,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.193,
                        0.193,
                        0
                      ]
                    },
                    "t": 107,
                    "s": [
                      116.931,
                      116.931,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.869,
                        0.869,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.203,
                        0.203,
                        0
                      ]
                    },
                    "t": 108,
                    "s": [
                      117.489,
                      117.489,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.895,
                        0.895,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.23,
                        0.23,
                        0
                      ]
                    },
                    "t": 109,
                    "s": [
                      117.876,
                      117.876,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        1.064,
                        1.064,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.403,
                        0.403,
                        0
                      ]
                    },
                    "t": 110,
                    "s": [
                      118.096,
                      118.096,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.706,
                        0.706,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.036,
                        0.036,
                        0
                      ]
                    },
                    "t": 111,
                    "s": [
                      118.153,
                      118.153,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.784,
                        0.784,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.116,
                        0.116,
                        0
                      ]
                    },
                    "t": 112,
                    "s": [
                      118.052,
                      118.052,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.803,
                        0.803,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.136,
                        0.136,
                        0
                      ]
                    },
                    "t": 113,
                    "s": [
                      117.796,
                      117.796,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.812,
                        0.812,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.145,
                        0.145,
                        0
                      ]
                    },
                    "t": 114,
                    "s": [
                      117.39,
                      117.39,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.817,
                        0.817,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.15,
                        0.15,
                        0
                      ]
                    },
                    "t": 115,
                    "s": [
                      116.838,
                      116.838,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.82,
                        0.82,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.153,
                        0.153,
                        0
                      ]
                    },
                    "t": 116,
                    "s": [
                      116.144,
                      116.144,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.822,
                        0.822,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.155,
                        0.155,
                        0
                      ]
                    },
                    "t": 117,
                    "s": [
                      115.313,
                      115.313,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.824,
                        0.824,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.157,
                        0.157,
                        0
                      ]
                    },
                    "t": 118,
                    "s": [
                      114.348,
                      114.348,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.825,
                        0.825,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.158,
                        0.158,
                        0
                      ]
                    },
                    "t": 119,
                    "s": [
                      113.254,
                      113.254,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.825,
                        0.825,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.159,
                        0.159,
                        0
                      ]
                    },
                    "t": 120,
                    "s": [
                      112.035,
                      112.035,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.826,
                        0.826,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.159,
                        0.159,
                        0
                      ]
                    },
                    "t": 121,
                    "s": [
                      110.693,
                      110.693,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.826,
                        0.826,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.16,
                        0.16,
                        0
                      ]
                    },
                    "t": 122,
                    "s": [
                      109.222,
                      109.222,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.826,
                        0.826,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.16,
                        0.16,
                        0
                      ]
                    },
                    "t": 123,
                    "s": [
                      107.618,
                      107.618,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.827,
                        0.827,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.16,
                        0.16,
                        0
                      ]
                    },
                    "t": 124,
                    "s": [
                      105.875,
                      105.875,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.827,
                        0.827,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.16,
                        0.16,
                        0
                      ]
                    },
                    "t": 125,
                    "s": [
                      103.986,
                      103.986,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.827,
                        0.827,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.161,
                        0.161,
                        0
                      ]
                    },
                    "t": 126,
                    "s": [
                      101.947,
                      101.947,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.827,
                        0.827,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.161,
                        0.161,
                        0
                      ]
                    },
                    "t": 127,
                    "s": [
                      99.75,
                      99.75,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.161,
                        0.161,
                        0
                      ]
                    },
                    "t": 128,
                    "s": [
                      97.391,
                      97.391,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.161,
                        0.161,
                        0
                      ]
                    },
                    "t": 129,
                    "s": [
                      94.864,
                      94.864,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.161,
                        0.161,
                        0
                      ]
                    },
                    "t": 130,
                    "s": [
                      92.162,
                      92.162,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 131,
                    "s": [
                      89.281,
                      89.281,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 132,
                    "s": [
                      86.213,
                      86.213,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 133,
                    "s": [
                      82.954,
                      82.954,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 134,
                    "s": [
                      79.497,
                      79.497,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 135,
                    "s": [
                      75.837,
                      75.837,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 136,
                    "s": [
                      71.968,
                      71.968,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 137,
                    "s": [
                      67.884,
                      67.884,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 138,
                    "s": [
                      63.579,
                      63.579,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 139,
                    "s": [
                      59.048,
                      59.048,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 140,
                    "s": [
                      54.284,
                      54.284,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 141,
                    "s": [
                      49.283,
                      49.283,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 142,
                    "s": [
                      44.037,
                      44.037,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.83,
                        0.83,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 143,
                    "s": [
                      38.542,
                      38.542,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.83,
                        0.83,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 144,
                    "s": [
                      32.791,
                      32.791,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.83,
                        0.83,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 145,
                    "s": [
                      26.779,
                      26.779,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.83,
                        0.83,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 146,
                    "s": [
                      20.499,
                      20.499,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.83,
                        0.83,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 147,
                    "s": [
                      13.947,
                      13.947,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 148,
                    "s": [
                      7.116,
                      7.116,
                      100
                    ]
                  },
                  {
                    "t": 149.000006068894,
                    "s": [
                      0,
                      0,
                      100
                    ]
                  }
                ]
              }
            },
            "ao": 0,
            "ef": [
              {
                "ty": 5,
                "nm": "AC IN [GLA] Controls",
                "np": 5,
                "mn": "Pseudo/MHAC PrCtrl GLA 3",
                "ix": 1,
                "en": 1,
                "ef": [
                  {
                    "ty": 3,
                    "nm": "Position",
                    "mn": "Pseudo/MHAC PrCtrl GLA 3-0001",
                    "ix": 1,
                    "v": {
                      "a": 0,
                      "k": [
                        323,
                        366
                      ]
                    }
                  },
                  {
                    "ty": 0,
                    "nm": "Angle",
                    "mn": "Pseudo/MHAC PrCtrl GLA 3-0002",
                    "ix": 2,
                    "v": {
                      "a": 0,
                      "k": -19
                    }
                  },
                  {
                    "ty": 0,
                    "nm": "Scale",
                    "mn": "Pseudo/MHAC PrCtrl GLA 3-0003",
                    "ix": 3,
                    "v": {
                      "a": 0,
                      "k": 0
                    }
                  }
                ]
              },
              {
                "ty": 5,
                "nm": "AC OUT [0SE] Controls",
                "np": 5,
                "mn": "Pseudo/MHAC PrCtrl 0SE 3",
                "ix": 2,
                "en": 1,
                "ef": [
                  {
                    "ty": 3,
                    "nm": "Position",
                    "mn": "Pseudo/MHAC PrCtrl 0SE 3-0001",
                    "ix": 1,
                    "v": {
                      "a": 0,
                      "k": [
                        -120,
                        -407
                      ]
                    }
                  },
                  {
                    "ty": 0,
                    "nm": "Angle",
                    "mn": "Pseudo/MHAC PrCtrl 0SE 3-0002",
                    "ix": 2,
                    "v": {
                      "a": 0,
                      "k": 48
                    }
                  },
                  {
                    "ty": 0,
                    "nm": "Scale",
                    "mn": "Pseudo/MHAC PrCtrl 0SE 3-0003",
                    "ix": 3,
                    "v": {
                      "a": 0,
                      "k": 0
                    }
                  }
                ]
              }
            ],
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -495.209,
                            -101.99
                          ],
                          [
                            -377.984,
                            -27.434
                          ],
                          [
                            -395.333,
                            -18.525
                          ],
                          [
                            -367.199,
                            14.298
                          ],
                          [
                            -363.917,
                            -39.625
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.462745127958,
                        0.196078446332,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -495.209,
                            -101.99
                          ],
                          [
                            -430.032,
                            -1.175
                          ],
                          [
                            -393.926,
                            -18.994
                          ],
                          [
                            -367.199,
                            13.829
                          ],
                          [
                            -363.917,
                            -39.157
                          ],
                          [
                            -319.371,
                            -60.726
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.6,
                        0.392156892664,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "bm": 0,
                "hd": false
              }
            ],
            "ip": 78.0000031770051,
            "op": 150.000006109625,
            "st": -14.0000005702317,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Layer 27",
            "sr": 1,
            "ks": {
              "o": {
                "a": 0,
                "k": 100
              },
              "r": {
                "a": 0,
                "k": 0
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 133,
                    "s": [
                      198.271,
                      744.056,
                      0
                    ],
                    "to": [
                      -11.995,
                      -21.282,
                      0
                    ],
                    "ti": [
                      29.523,
                      52.379,
                      0
                    ]
                  },
                  {
                    "t": 154.000006272549,
                    "s": [
                      131.871,
                      526.056,
                      0
                    ]
                  }
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  -341.729,
                  180.056,
                  0
                ]
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ]
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            1.609,
                            77.467
                          ],
                          [
                            71.318,
                            115.204
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -1.954,
                            -94.085
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -252.241,
                            286.315
                          ],
                          [
                            -334.046,
                            143.085
                          ],
                          [
                            -331.318,
                            -153.204
                          ]
                        ],
                        "c": false
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "st",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "w": {
                      "a": 0,
                      "k": 4.689
                    },
                    "lc": 1,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 116,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 144.00000586524,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 93,
                      "s": [
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 112,
                      "s": [
                        35
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 127,
                      "s": [
                        62
                      ]
                    },
                    {
                      "t": 138.000005620855,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              }
            ],
            "ip": 81.0000032991976,
            "op": 157.000006394741,
            "st": 54.0000021994651,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Layer 10",
            "sr": 1,
            "ks": {
              "o": {
                "a": 0,
                "k": 100
              },
              "r": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 0,
                    "s": [
                      -19
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 1,
                    "s": [
                      -17.675
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 2,
                    "s": [
                      -16.413
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.711
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 3,
                    "s": [
                      -15.212
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.117
                      ]
                    },
                    "t": 4,
                    "s": [
                      -14.072
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.834
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.166
                      ]
                    },
                    "t": 5,
                    "s": [
                      -11.261
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.834
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 6,
                    "s": [
                      -8.426
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 7,
                    "s": [
                      -5.608
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 8,
                    "s": [
                      -2.825
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 9,
                    "s": [
                      -0.083
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 10,
                    "s": [
                      2.614
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 11,
                    "s": [
                      5.262
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 12,
                    "s": [
                      7.861
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 13,
                    "s": [
                      10.409
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 14,
                    "s": [
                      12.906
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 15,
                    "s": [
                      15.351
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 16,
                    "s": [
                      17.745
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 17,
                    "s": [
                      20.087
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 18,
                    "s": [
                      22.376
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 19,
                    "s": [
                      24.612
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 20,
                    "s": [
                      26.794
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 21,
                    "s": [
                      28.922
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 22,
                    "s": [
                      30.993
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 23,
                    "s": [
                      33.009
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 24,
                    "s": [
                      34.968
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 25,
                    "s": [
                      36.869
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.17
                      ]
                    },
                    "t": 26,
                    "s": [
                      38.709
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.838
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.17
                      ]
                    },
                    "t": 27,
                    "s": [
                      40.484
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.839
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 28,
                    "s": [
                      42.184
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.842
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.173
                      ]
                    },
                    "t": 29,
                    "s": [
                      43.797
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.847
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.176
                      ]
                    },
                    "t": 30,
                    "s": [
                      45.301
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.865
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.184
                      ]
                    },
                    "t": 31,
                    "s": [
                      46.655
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.94
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.218
                      ]
                    },
                    "t": 32,
                    "s": [
                      47.781
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.597
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        -0.216
                      ]
                    },
                    "t": 33,
                    "s": [
                      48.477
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.804
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.105
                      ]
                    },
                    "t": 34,
                    "s": [
                      48.283
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.821
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.145
                      ]
                    },
                    "t": 35,
                    "s": [
                      47.539
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.826
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.156
                      ]
                    },
                    "t": 36,
                    "s": [
                      46.532
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.16
                      ]
                    },
                    "t": 37,
                    "s": [
                      45.371
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.831
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 38,
                    "s": [
                      44.115
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.832
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.164
                      ]
                    },
                    "t": 39,
                    "s": [
                      42.797
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.166
                      ]
                    },
                    "t": 40,
                    "s": [
                      41.443
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.834
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.166
                      ]
                    },
                    "t": 41,
                    "s": [
                      40.07
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.834
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 42,
                    "s": [
                      38.692
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 43,
                    "s": [
                      37.322
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.835
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.168
                      ]
                    },
                    "t": 44,
                    "s": [
                      35.968
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 45,
                    "s": [
                      34.637
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.836
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.169
                      ]
                    },
                    "t": 46,
                    "s": [
                      33.337
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.17
                      ]
                    },
                    "t": 47,
                    "s": [
                      32.072
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.837
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.17
                      ]
                    },
                    "t": 48,
                    "s": [
                      30.85
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.838
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 49,
                    "s": [
                      29.675
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.838
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.171
                      ]
                    },
                    "t": 50,
                    "s": [
                      28.554
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.839
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.172
                      ]
                    },
                    "t": 51,
                    "s": [
                      27.491
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.841
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.173
                      ]
                    },
                    "t": 52,
                    "s": [
                      26.494
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.843
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.175
                      ]
                    },
                    "t": 53,
                    "s": [
                      25.569
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.847
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.177
                      ]
                    },
                    "t": 54,
                    "s": [
                      24.727
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.858
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.183
                      ]
                    },
                    "t": 55,
                    "s": [
                      23.982
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        1.206
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.201
                      ]
                    },
                    "t": 56,
                    "s": [
                      23.357
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.059
                      ]
                    },
                    "t": 57,
                    "s": [
                      22.916
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.162
                      ]
                    },
                    "t": 58,
                    "s": [
                      24.451
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.162
                      ]
                    },
                    "t": 59,
                    "s": [
                      26.071
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 60,
                    "s": [
                      27.778
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 61,
                    "s": [
                      29.576
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 62,
                    "s": [
                      31.466
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 63,
                    "s": [
                      33.45
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.829
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 64,
                    "s": [
                      35.531
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.83
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 65,
                    "s": [
                      37.711
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.83
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 66,
                    "s": [
                      39.992
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.83
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 67,
                    "s": [
                      42.377
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.83
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 68,
                    "s": [
                      44.868
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.83
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 69,
                    "s": [
                      47.467
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.163
                      ]
                    },
                    "t": 70,
                    "s": [
                      50.177
                    ]
                  },
                  {
                    "t": 71.0000028918893,
                    "s": [
                      53
                    ]
                  }
                ]
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.837
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 0,
                    "s": [
                      455.71,
                      1076.154,
                      0
                    ],
                    "to": [
                      -3.754,
                      -4.254,
                      0
                    ],
                    "ti": [
                      7.33,
                      8.306,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.837
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.171
                    },
                    "t": 1,
                    "s": [
                      433.184,
                      1050.629,
                      0
                    ],
                    "to": [
                      -7.33,
                      -8.306,
                      0
                    ],
                    "ti": [
                      6.977,
                      7.906,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.837
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.171
                    },
                    "t": 2,
                    "s": [
                      411.73,
                      1026.319,
                      0
                    ],
                    "to": [
                      -6.977,
                      -7.906,
                      0
                    ],
                    "ti": [
                      6.633,
                      7.515,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.171
                    },
                    "t": 3,
                    "s": [
                      391.322,
                      1003.195,
                      0
                    ],
                    "to": [
                      -6.633,
                      -7.515,
                      0
                    ],
                    "ti": [
                      6.025,
                      7.814,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.165
                    },
                    "t": 4,
                    "s": [
                      371.934,
                      981.226,
                      0
                    ],
                    "to": [
                      -6.025,
                      -7.814,
                      0
                    ],
                    "ti": [
                      5.405,
                      8.114,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.171
                    },
                    "t": 5,
                    "s": [
                      355.172,
                      956.308,
                      0
                    ],
                    "to": [
                      -5.405,
                      -8.114,
                      0
                    ],
                    "ti": [
                      5.045,
                      7.733,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.171
                    },
                    "t": 6,
                    "s": [
                      339.502,
                      932.545,
                      0
                    ],
                    "to": [
                      -5.045,
                      -7.733,
                      0
                    ],
                    "ti": [
                      4.692,
                      7.361,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 7,
                    "s": [
                      324.901,
                      909.911,
                      0
                    ],
                    "to": [
                      -4.692,
                      -7.361,
                      0
                    ],
                    "ti": [
                      4.347,
                      6.997,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 8,
                    "s": [
                      311.347,
                      888.38,
                      0
                    ],
                    "to": [
                      -4.347,
                      -6.997,
                      0
                    ],
                    "ti": [
                      4.011,
                      6.642,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 9,
                    "s": [
                      298.818,
                      867.927,
                      0
                    ],
                    "to": [
                      -4.011,
                      -6.642,
                      0
                    ],
                    "ti": [
                      3.684,
                      6.294,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 10,
                    "s": [
                      287.283,
                      848.53,
                      0
                    ],
                    "to": [
                      -3.684,
                      -6.294,
                      0
                    ],
                    "ti": [
                      3.368,
                      5.955,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 11,
                    "s": [
                      276.713,
                      830.163,
                      0
                    ],
                    "to": [
                      -3.368,
                      -5.955,
                      0
                    ],
                    "ti": [
                      3.062,
                      5.626,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 12,
                    "s": [
                      267.076,
                      812.797,
                      0
                    ],
                    "to": [
                      -3.062,
                      -5.626,
                      0
                    ],
                    "ti": [
                      2.767,
                      5.307,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 13,
                    "s": [
                      258.341,
                      796.404,
                      0
                    ],
                    "to": [
                      -2.767,
                      -5.307,
                      0
                    ],
                    "ti": [
                      2.485,
                      4.999,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 14,
                    "s": [
                      250.471,
                      780.953,
                      0
                    ],
                    "to": [
                      -2.485,
                      -4.999,
                      0
                    ],
                    "ti": [
                      2.215,
                      4.701,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 15,
                    "s": [
                      243.432,
                      766.411,
                      0
                    ],
                    "to": [
                      -2.215,
                      -4.701,
                      0
                    ],
                    "ti": [
                      1.957,
                      4.414,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 16,
                    "s": [
                      237.184,
                      752.748,
                      0
                    ],
                    "to": [
                      -1.957,
                      -4.414,
                      0
                    ],
                    "ti": [
                      1.711,
                      4.139,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.84
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 17,
                    "s": [
                      231.691,
                      739.927,
                      0
                    ],
                    "to": [
                      -1.711,
                      -4.139,
                      0
                    ],
                    "ti": [
                      1.477,
                      3.877,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.84
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 18,
                    "s": [
                      226.918,
                      727.911,
                      0
                    ],
                    "to": [
                      -1.477,
                      -3.877,
                      0
                    ],
                    "ti": [
                      1.254,
                      3.628,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.84
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 19,
                    "s": [
                      222.832,
                      716.663,
                      0
                    ],
                    "to": [
                      -1.254,
                      -3.628,
                      0
                    ],
                    "ti": [
                      1.043,
                      3.39,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.84
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.174
                    },
                    "t": 20,
                    "s": [
                      219.396,
                      706.145,
                      0
                    ],
                    "to": [
                      -1.043,
                      -3.39,
                      0
                    ],
                    "ti": [
                      0.844,
                      3.164,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.84
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.174
                    },
                    "t": 21,
                    "s": [
                      216.576,
                      696.324,
                      0
                    ],
                    "to": [
                      -0.844,
                      -3.164,
                      0
                    ],
                    "ti": [
                      0.657,
                      2.954,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 22,
                    "s": [
                      214.335,
                      687.16,
                      0
                    ],
                    "to": [
                      -0.657,
                      -2.954,
                      0
                    ],
                    "ti": [
                      0.482,
                      2.762,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.839
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 23,
                    "s": [
                      212.636,
                      678.6,
                      0
                    ],
                    "to": [
                      -0.482,
                      -2.762,
                      0
                    ],
                    "ti": [
                      0.318,
                      2.589,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.838
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.173
                    },
                    "t": 24,
                    "s": [
                      211.445,
                      670.588,
                      0
                    ],
                    "to": [
                      -0.318,
                      -2.589,
                      0
                    ],
                    "ti": [
                      0.166,
                      2.434,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.834
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.172
                    },
                    "t": 25,
                    "s": [
                      210.727,
                      663.067,
                      0
                    ],
                    "to": [
                      -0.166,
                      -2.434,
                      0
                    ],
                    "ti": [
                      -0.043,
                      2.354,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.837
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 26,
                    "s": [
                      210.447,
                      655.982,
                      0
                    ],
                    "to": [
                      0.043,
                      -2.354,
                      0
                    ],
                    "ti": [
                      -0.243,
                      2.29,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.836
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.17
                    },
                    "t": 27,
                    "s": [
                      210.985,
                      648.943,
                      0
                    ],
                    "to": [
                      0.243,
                      -2.29,
                      0
                    ],
                    "ti": [
                      -0.361,
                      2.188,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.835
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.169
                    },
                    "t": 28,
                    "s": [
                      211.904,
                      642.242,
                      0
                    ],
                    "to": [
                      0.361,
                      -2.188,
                      0
                    ],
                    "ti": [
                      -0.462,
                      2.105,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.834
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.169
                    },
                    "t": 29,
                    "s": [
                      213.149,
                      635.817,
                      0
                    ],
                    "to": [
                      0.462,
                      -2.105,
                      0
                    ],
                    "ti": [
                      -0.549,
                      2.043,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.834
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.168
                    },
                    "t": 30,
                    "s": [
                      214.676,
                      629.609,
                      0
                    ],
                    "to": [
                      0.549,
                      -2.043,
                      0
                    ],
                    "ti": [
                      -0.621,
                      2.002,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.167
                    },
                    "t": 31,
                    "s": [
                      216.44,
                      623.557,
                      0
                    ],
                    "to": [
                      0.621,
                      -2.002,
                      0
                    ],
                    "ti": [
                      -0.681,
                      1.98,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.832
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.166
                    },
                    "t": 32,
                    "s": [
                      218.403,
                      617.6,
                      0
                    ],
                    "to": [
                      0.681,
                      -1.98,
                      0
                    ],
                    "ti": [
                      -0.726,
                      1.979,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.832
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.166
                    },
                    "t": 33,
                    "s": [
                      220.523,
                      611.675,
                      0
                    ],
                    "to": [
                      0.726,
                      -1.979,
                      0
                    ],
                    "ti": [
                      -0.756,
                      1.998,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.165
                    },
                    "t": 34,
                    "s": [
                      222.757,
                      605.724,
                      0
                    ],
                    "to": [
                      0.756,
                      -1.998,
                      0
                    ],
                    "ti": [
                      -0.771,
                      2.037,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.165
                    },
                    "t": 35,
                    "s": [
                      225.06,
                      599.687,
                      0
                    ],
                    "to": [
                      0.771,
                      -2.037,
                      0
                    ],
                    "ti": [
                      -0.77,
                      2.096,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 36,
                    "s": [
                      227.384,
                      593.504,
                      0
                    ],
                    "to": [
                      0.77,
                      -2.096,
                      0
                    ],
                    "ti": [
                      -0.752,
                      2.176,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 37,
                    "s": [
                      229.681,
                      587.112,
                      0
                    ],
                    "to": [
                      0.752,
                      -2.176,
                      0
                    ],
                    "ti": [
                      -0.716,
                      2.278,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.829
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 38,
                    "s": [
                      231.898,
                      580.447,
                      0
                    ],
                    "to": [
                      0.716,
                      -2.278,
                      0
                    ],
                    "ti": [
                      -0.66,
                      2.402,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.829
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 39,
                    "s": [
                      233.978,
                      573.444,
                      0
                    ],
                    "to": [
                      0.66,
                      -2.402,
                      0
                    ],
                    "ti": [
                      -0.579,
                      2.547,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.829
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 40,
                    "s": [
                      235.857,
                      566.037,
                      0
                    ],
                    "to": [
                      0.579,
                      -2.547,
                      0
                    ],
                    "ti": [
                      -0.471,
                      2.712,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.828
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 41,
                    "s": [
                      237.454,
                      558.164,
                      0
                    ],
                    "to": [
                      0.471,
                      -2.712,
                      0
                    ],
                    "ti": [
                      -0.332,
                      2.897,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.828
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 42,
                    "s": [
                      238.682,
                      549.765,
                      0
                    ],
                    "to": [
                      0.332,
                      -2.897,
                      0
                    ],
                    "ti": [
                      -0.161,
                      3.097,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.828
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 43,
                    "s": [
                      239.446,
                      540.783,
                      0
                    ],
                    "to": [
                      0.161,
                      -3.097,
                      0
                    ],
                    "ti": [
                      0.043,
                      3.302,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.828
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 44,
                    "s": [
                      239.651,
                      531.18,
                      0
                    ],
                    "to": [
                      -0.043,
                      -3.302,
                      0
                    ],
                    "ti": [
                      0.285,
                      3.496,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.828
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 45,
                    "s": [
                      239.185,
                      520.972,
                      0
                    ],
                    "to": [
                      -0.285,
                      -3.496,
                      0
                    ],
                    "ti": [
                      0.558,
                      3.674,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.824
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.162
                    },
                    "t": 46,
                    "s": [
                      237.94,
                      510.204,
                      0
                    ],
                    "to": [
                      -0.558,
                      -3.674,
                      0
                    ],
                    "ti": [
                      0.817,
                      3.96,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.158
                    },
                    "t": 47,
                    "s": [
                      235.837,
                      498.927,
                      0
                    ],
                    "to": [
                      -0.817,
                      -3.96,
                      0
                    ],
                    "ti": [
                      0.988,
                      4.24,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 48,
                    "s": [
                      233.038,
                      486.445,
                      0
                    ],
                    "to": [
                      -0.988,
                      -4.24,
                      0
                    ],
                    "ti": [
                      1.1,
                      4.407,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 49,
                    "s": [
                      229.911,
                      473.485,
                      0
                    ],
                    "to": [
                      -1.1,
                      -4.407,
                      0
                    ],
                    "ti": [
                      1.22,
                      4.581,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 50,
                    "s": [
                      226.435,
                      460.004,
                      0
                    ],
                    "to": [
                      -1.22,
                      -4.581,
                      0
                    ],
                    "ti": [
                      1.345,
                      4.757,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 51,
                    "s": [
                      222.593,
                      445.999,
                      0
                    ],
                    "to": [
                      -1.345,
                      -4.757,
                      0
                    ],
                    "ti": [
                      1.475,
                      4.935,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 52,
                    "s": [
                      218.367,
                      431.464,
                      0
                    ],
                    "to": [
                      -1.475,
                      -4.935,
                      0
                    ],
                    "ti": [
                      1.611,
                      5.115,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 53,
                    "s": [
                      213.742,
                      416.392,
                      0
                    ],
                    "to": [
                      -1.611,
                      -5.115,
                      0
                    ],
                    "ti": [
                      1.752,
                      5.297,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 54,
                    "s": [
                      208.701,
                      400.777,
                      0
                    ],
                    "to": [
                      -1.752,
                      -5.297,
                      0
                    ],
                    "ti": [
                      1.898,
                      5.48,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 55,
                    "s": [
                      203.229,
                      384.613,
                      0
                    ],
                    "to": [
                      -1.898,
                      -5.48,
                      0
                    ],
                    "ti": [
                      2.047,
                      5.663,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 56,
                    "s": [
                      197.314,
                      367.9,
                      0
                    ],
                    "to": [
                      -2.047,
                      -5.663,
                      0
                    ],
                    "ti": [
                      2.199,
                      5.848,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 57,
                    "s": [
                      190.947,
                      350.635,
                      0
                    ],
                    "to": [
                      -2.199,
                      -5.848,
                      0
                    ],
                    "ti": [
                      2.352,
                      6.034,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 58,
                    "s": [
                      184.121,
                      332.814,
                      0
                    ],
                    "to": [
                      -2.352,
                      -6.034,
                      0
                    ],
                    "ti": [
                      2.505,
                      6.222,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 59,
                    "s": [
                      176.836,
                      314.433,
                      0
                    ],
                    "to": [
                      -2.505,
                      -6.222,
                      0
                    ],
                    "ti": [
                      2.657,
                      6.413,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 60,
                    "s": [
                      169.091,
                      295.483,
                      0
                    ],
                    "to": [
                      -2.657,
                      -6.413,
                      0
                    ],
                    "ti": [
                      2.805,
                      6.609,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 61,
                    "s": [
                      160.896,
                      275.952,
                      0
                    ],
                    "to": [
                      -2.805,
                      -6.609,
                      0
                    ],
                    "ti": [
                      2.947,
                      6.811,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 62,
                    "s": [
                      152.264,
                      255.827,
                      0
                    ],
                    "to": [
                      -2.947,
                      -6.811,
                      0
                    ],
                    "ti": [
                      3.082,
                      7.023,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.831
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 63,
                    "s": [
                      143.217,
                      235.084,
                      0
                    ],
                    "to": [
                      -3.082,
                      -7.023,
                      0
                    ],
                    "ti": [
                      3.209,
                      7.249,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 64,
                    "s": [
                      133.774,
                      213.689,
                      0
                    ],
                    "to": [
                      -3.209,
                      -7.249,
                      0
                    ],
                    "ti": [
                      3.326,
                      7.493,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 65,
                    "s": [
                      123.962,
                      191.591,
                      0
                    ],
                    "to": [
                      -3.326,
                      -7.493,
                      0
                    ],
                    "ti": [
                      3.427,
                      7.762,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 66,
                    "s": [
                      113.821,
                      168.73,
                      0
                    ],
                    "to": [
                      -3.427,
                      -7.762,
                      0
                    ],
                    "ti": [
                      3.507,
                      8.068,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.164
                    },
                    "t": 67,
                    "s": [
                      103.399,
                      145.016,
                      0
                    ],
                    "to": [
                      -3.507,
                      -8.068,
                      0
                    ],
                    "ti": [
                      3.547,
                      8.428,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.83
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 68,
                    "s": [
                      92.778,
                      120.321,
                      0
                    ],
                    "to": [
                      -3.547,
                      -8.428,
                      0
                    ],
                    "ti": [
                      3.502,
                      8.872,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.846
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.163
                    },
                    "t": 69,
                    "s": [
                      82.116,
                      94.447,
                      0
                    ],
                    "to": [
                      -3.502,
                      -8.872,
                      0
                    ],
                    "ti": [
                      2.901,
                      8.549,
                      0
                    ]
                  },
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.167,
                      "y": 0.181
                    },
                    "t": 70,
                    "s": [
                      71.767,
                      67.089,
                      0
                    ],
                    "to": [
                      -2.901,
                      -8.549,
                      0
                    ],
                    "ti": [
                      1.176,
                      3.989,
                      0
                    ]
                  },
                  {
                    "t": 71.0000028918893,
                    "s": [
                      64.71,
                      43.154,
                      0
                    ]
                  }
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  -407.29,
                  -43.846,
                  0
                ]
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.837,
                        0.837,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.167,
                        0.167,
                        0
                      ]
                    },
                    "t": 0,
                    "s": [
                      0,
                      0,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.837,
                        0.837,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 1,
                    "s": [
                      6.974,
                      6.974,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.837,
                        0.837,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 2,
                    "s": [
                      13.616,
                      13.616,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 3,
                    "s": [
                      19.934,
                      19.934,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 4,
                    "s": [
                      25.937,
                      25.937,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 5,
                    "s": [
                      31.631,
                      31.631,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.171,
                        0.171,
                        0
                      ]
                    },
                    "t": 6,
                    "s": [
                      37.026,
                      37.026,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 7,
                    "s": [
                      42.13,
                      42.13,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 8,
                    "s": [
                      46.95,
                      46.95,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.838,
                        0.838,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 9,
                    "s": [
                      51.494,
                      51.494,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.839,
                        0.839,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 10,
                    "s": [
                      55.772,
                      55.772,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.839,
                        0.839,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 11,
                    "s": [
                      59.79,
                      59.79,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.839,
                        0.839,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.172,
                        0.172,
                        0
                      ]
                    },
                    "t": 12,
                    "s": [
                      63.557,
                      63.557,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.839,
                        0.839,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.173,
                        0.173,
                        0
                      ]
                    },
                    "t": 13,
                    "s": [
                      67.081,
                      67.081,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.839,
                        0.839,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.173,
                        0.173,
                        0
                      ]
                    },
                    "t": 14,
                    "s": [
                      70.37,
                      70.37,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.84,
                        0.84,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.173,
                        0.173,
                        0
                      ]
                    },
                    "t": 15,
                    "s": [
                      73.433,
                      73.433,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.84,
                        0.84,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.173,
                        0.173,
                        0
                      ]
                    },
                    "t": 16,
                    "s": [
                      76.277,
                      76.277,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.84,
                        0.84,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.174,
                        0.174,
                        0
                      ]
                    },
                    "t": 17,
                    "s": [
                      78.91,
                      78.91,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.84,
                        0.84,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.174,
                        0.174,
                        0
                      ]
                    },
                    "t": 18,
                    "s": [
                      81.341,
                      81.341,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.841,
                        0.841,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.174,
                        0.174,
                        0
                      ]
                    },
                    "t": 19,
                    "s": [
                      83.578,
                      83.578,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.841,
                        0.841,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.175,
                        0.175,
                        0
                      ]
                    },
                    "t": 20,
                    "s": [
                      85.628,
                      85.628,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.841,
                        0.841,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.175,
                        0.175,
                        0
                      ]
                    },
                    "t": 21,
                    "s": [
                      87.5,
                      87.5,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.842,
                        0.842,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.176,
                        0.176,
                        0
                      ]
                    },
                    "t": 22,
                    "s": [
                      89.201,
                      89.201,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.843,
                        0.843,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.177,
                        0.177,
                        0
                      ]
                    },
                    "t": 23,
                    "s": [
                      90.736,
                      90.736,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.844,
                        0.844,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.178,
                        0.178,
                        0
                      ]
                    },
                    "t": 24,
                    "s": [
                      92.108,
                      92.108,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.845,
                        0.845,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.179,
                        0.179,
                        0
                      ]
                    },
                    "t": 25,
                    "s": [
                      93.321,
                      93.321,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.847,
                        0.847,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.181,
                        0.181,
                        0
                      ]
                    },
                    "t": 26,
                    "s": [
                      94.377,
                      94.377,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.85,
                        0.85,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.183,
                        0.183,
                        0
                      ]
                    },
                    "t": 27,
                    "s": [
                      95.28,
                      95.28,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.853,
                        0.853,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.187,
                        0.187,
                        0
                      ]
                    },
                    "t": 28,
                    "s": [
                      96.032,
                      96.032,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.859,
                        0.859,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.193,
                        0.193,
                        0
                      ]
                    },
                    "t": 29,
                    "s": [
                      96.637,
                      96.637,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.869,
                        0.869,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.203,
                        0.203,
                        0
                      ]
                    },
                    "t": 30,
                    "s": [
                      97.098,
                      97.098,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.895,
                        0.895,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.23,
                        0.23,
                        0
                      ]
                    },
                    "t": 31,
                    "s": [
                      97.418,
                      97.418,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        1.064,
                        1.064,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.403,
                        0.403,
                        0
                      ]
                    },
                    "t": 32,
                    "s": [
                      97.6,
                      97.6,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.706,
                        0.706,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.036,
                        0.036,
                        0
                      ]
                    },
                    "t": 33,
                    "s": [
                      97.647,
                      97.647,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.784,
                        0.784,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.116,
                        0.116,
                        0
                      ]
                    },
                    "t": 34,
                    "s": [
                      97.563,
                      97.563,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.803,
                        0.803,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.136,
                        0.136,
                        0
                      ]
                    },
                    "t": 35,
                    "s": [
                      97.352,
                      97.352,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.812,
                        0.812,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.145,
                        0.145,
                        0
                      ]
                    },
                    "t": 36,
                    "s": [
                      97.016,
                      97.016,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.817,
                        0.817,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.15,
                        0.15,
                        0
                      ]
                    },
                    "t": 37,
                    "s": [
                      96.56,
                      96.56,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.82,
                        0.82,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.153,
                        0.153,
                        0
                      ]
                    },
                    "t": 38,
                    "s": [
                      95.987,
                      95.987,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.822,
                        0.822,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.155,
                        0.155,
                        0
                      ]
                    },
                    "t": 39,
                    "s": [
                      95.3,
                      95.3,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.824,
                        0.824,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.157,
                        0.157,
                        0
                      ]
                    },
                    "t": 40,
                    "s": [
                      94.503,
                      94.503,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.825,
                        0.825,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.158,
                        0.158,
                        0
                      ]
                    },
                    "t": 41,
                    "s": [
                      93.599,
                      93.599,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.825,
                        0.825,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.159,
                        0.159,
                        0
                      ]
                    },
                    "t": 42,
                    "s": [
                      92.591,
                      92.591,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.826,
                        0.826,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.159,
                        0.159,
                        0
                      ]
                    },
                    "t": 43,
                    "s": [
                      91.482,
                      91.482,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.826,
                        0.826,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.16,
                        0.16,
                        0
                      ]
                    },
                    "t": 44,
                    "s": [
                      90.266,
                      90.266,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.826,
                        0.826,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.16,
                        0.16,
                        0
                      ]
                    },
                    "t": 45,
                    "s": [
                      88.941,
                      88.941,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.827,
                        0.827,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.16,
                        0.16,
                        0
                      ]
                    },
                    "t": 46,
                    "s": [
                      87.5,
                      87.5,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.827,
                        0.827,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.16,
                        0.16,
                        0
                      ]
                    },
                    "t": 47,
                    "s": [
                      85.939,
                      85.939,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.827,
                        0.827,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.161,
                        0.161,
                        0
                      ]
                    },
                    "t": 48,
                    "s": [
                      84.254,
                      84.254,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.827,
                        0.827,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.161,
                        0.161,
                        0
                      ]
                    },
                    "t": 49,
                    "s": [
                      82.438,
                      82.438,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.161,
                        0.161,
                        0
                      ]
                    },
                    "t": 50,
                    "s": [
                      80.489,
                      80.489,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.161,
                        0.161,
                        0
                      ]
                    },
                    "t": 51,
                    "s": [
                      78.4,
                      78.4,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.161,
                        0.161,
                        0
                      ]
                    },
                    "t": 52,
                    "s": [
                      76.167,
                      76.167,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 53,
                    "s": [
                      73.786,
                      73.786,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 54,
                    "s": [
                      71.25,
                      71.25,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.828,
                        0.828,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 55,
                    "s": [
                      68.557,
                      68.557,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 56,
                    "s": [
                      65.7,
                      65.7,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 57,
                    "s": [
                      62.675,
                      62.675,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 58,
                    "s": [
                      59.478,
                      59.478,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.162,
                        0.162,
                        0
                      ]
                    },
                    "t": 59,
                    "s": [
                      56.102,
                      56.102,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 60,
                    "s": [
                      52.545,
                      52.545,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 61,
                    "s": [
                      48.8,
                      48.8,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 62,
                    "s": [
                      44.863,
                      44.863,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 63,
                    "s": [
                      40.73,
                      40.73,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.829,
                        0.829,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 64,
                    "s": [
                      36.394,
                      36.394,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.83,
                        0.83,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 65,
                    "s": [
                      31.853,
                      31.853,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.83,
                        0.83,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 66,
                    "s": [
                      27.1,
                      27.1,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.83,
                        0.83,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 67,
                    "s": [
                      22.131,
                      22.131,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.83,
                        0.83,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 68,
                    "s": [
                      16.942,
                      16.942,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.83,
                        0.83,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 69,
                    "s": [
                      11.526,
                      11.526,
                      100
                    ]
                  },
                  {
                    "i": {
                      "x": [
                        0.833,
                        0.833,
                        0.833
                      ],
                      "y": [
                        0.833,
                        0.833,
                        1
                      ]
                    },
                    "o": {
                      "x": [
                        0.167,
                        0.167,
                        0.167
                      ],
                      "y": [
                        0.163,
                        0.163,
                        0
                      ]
                    },
                    "t": 70,
                    "s": [
                      5.881,
                      5.881,
                      100
                    ]
                  },
                  {
                    "t": 71.0000028918893,
                    "s": [
                      0,
                      0,
                      100
                    ]
                  }
                ]
              }
            },
            "ao": 0,
            "ef": [
              {
                "ty": 5,
                "nm": "AC IN [GLA] Controls",
                "np": 5,
                "mn": "Pseudo/MHAC PrCtrl GLA 3",
                "ix": 1,
                "en": 1,
                "ef": [
                  {
                    "ty": 3,
                    "nm": "Position",
                    "mn": "Pseudo/MHAC PrCtrl GLA 3-0001",
                    "ix": 1,
                    "v": {
                      "a": 0,
                      "k": [
                        323,
                        366
                      ]
                    }
                  },
                  {
                    "ty": 0,
                    "nm": "Angle",
                    "mn": "Pseudo/MHAC PrCtrl GLA 3-0002",
                    "ix": 2,
                    "v": {
                      "a": 0,
                      "k": -19
                    }
                  },
                  {
                    "ty": 0,
                    "nm": "Scale",
                    "mn": "Pseudo/MHAC PrCtrl GLA 3-0003",
                    "ix": 3,
                    "v": {
                      "a": 0,
                      "k": 0
                    }
                  }
                ]
              },
              {
                "ty": 5,
                "nm": "AC OUT [0SE] Controls",
                "np": 5,
                "mn": "Pseudo/MHAC PrCtrl 0SE 3",
                "ix": 2,
                "en": 1,
                "ef": [
                  {
                    "ty": 3,
                    "nm": "Position",
                    "mn": "Pseudo/MHAC PrCtrl 0SE 3-0001",
                    "ix": 1,
                    "v": {
                      "a": 0,
                      "k": [
                        -120,
                        -407
                      ]
                    }
                  },
                  {
                    "ty": 0,
                    "nm": "Angle",
                    "mn": "Pseudo/MHAC PrCtrl 0SE 3-0002",
                    "ix": 2,
                    "v": {
                      "a": 0,
                      "k": 48
                    }
                  },
                  {
                    "ty": 0,
                    "nm": "Scale",
                    "mn": "Pseudo/MHAC PrCtrl 0SE 3-0003",
                    "ix": 3,
                    "v": {
                      "a": 0,
                      "k": 0
                    }
                  }
                ]
              }
            ],
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -495.209,
                            -101.99
                          ],
                          [
                            -377.984,
                            -27.434
                          ],
                          [
                            -395.333,
                            -18.525
                          ],
                          [
                            -367.199,
                            14.298
                          ],
                          [
                            -363.917,
                            -39.625
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0.403921574354,
                        0.92549020052,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -495.209,
                            -101.99
                          ],
                          [
                            -430.032,
                            -1.175
                          ],
                          [
                            -393.926,
                            -18.994
                          ],
                          [
                            -367.199,
                            13.829
                          ],
                          [
                            -363.917,
                            -39.157
                          ],
                          [
                            -319.371,
                            -60.726
                          ]
                        ],
                        "c": true
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.176470592618,
                        0.509803950787,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "bm": 0,
                "hd": false
              }
            ],
            "ip": 0,
            "op": 72.0000029326201,
            "st": -92.0000037472368,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Layer 11",
            "sr": 1,
            "ks": {
              "o": {
                "a": 0,
                "k": 100
              },
              "r": {
                "a": 0,
                "k": 0
              },
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.833,
                      "y": 0.833
                    },
                    "o": {
                      "x": 0.333,
                      "y": 0
                    },
                    "t": 55,
                    "s": [
                      198.271,
                      744.056,
                      0
                    ],
                    "to": [
                      -11.995,
                      -21.282,
                      0
                    ],
                    "ti": [
                      29.523,
                      52.379,
                      0
                    ]
                  },
                  {
                    "t": 76.0000030955435,
                    "s": [
                      131.871,
                      526.056,
                      0
                    ]
                  }
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  -341.729,
                  180.056,
                  0
                ]
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ]
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            1.609,
                            77.467
                          ],
                          [
                            71.318,
                            115.204
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -1.954,
                            -94.085
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            -252.241,
                            286.315
                          ],
                          [
                            -334.046,
                            143.085
                          ],
                          [
                            -331.318,
                            -153.204
                          ]
                        ],
                        "c": false
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "st",
                    "c": {
                      "a": 0,
                      "k": [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "w": {
                      "a": 0,
                      "k": 4.689
                    },
                    "lc": 1,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 38,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 66.0000026882351,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 15,
                      "s": [
                        0
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 34,
                      "s": [
                        35
                      ]
                    },
                    {
                      "i": {
                        "x": [
                          0.833
                        ],
                        "y": [
                          0.833
                        ]
                      },
                      "o": {
                        "x": [
                          0.167
                        ],
                        "y": [
                          0.167
                        ]
                      },
                      "t": 49,
                      "s": [
                        62
                      ]
                    },
                    {
                      "t": 60.0000024438501,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              }
            ],
            "ip": 3.00000012219251,
            "op": 79.000003217736,
            "st": -24.00000097754,
            "bm": 0
          }
        ]
      },
      {
        "id": "comp_1",
        "layers": [
          {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Layer 14",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 67,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 78.0000031770051,
                    "s": [
                      0
                    ]
                  }
                ]
              },
              "r": {
                "a": 0,
                "k": 0
              },
              "p": {
                "a": 0,
                "k": [
                  385,
                  511,
                  0
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  145,
                  -169,
                  0
                ]
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ]
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            40,
                            -169
                          ],
                          [
                            250,
                            -169
                          ]
                        ],
                        "c": false
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "st",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "w": {
                      "a": 0,
                      "k": 10
                    },
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.143
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.333
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 17,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 39.0000015885026,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              }
            ],
            "ip": 14.0000005702317,
            "op": 84.0000034213901,
            "st": 14.0000005702317,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Layer 15",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 67,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 78.0000031770051,
                    "s": [
                      0
                    ]
                  }
                ]
              },
              "r": {
                "a": 0,
                "k": 0
              },
              "p": {
                "a": 0,
                "k": [
                  449,
                  486,
                  0
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  209,
                  -194,
                  0
                ]
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ]
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            168,
                            -194
                          ],
                          [
                            250,
                            -194
                          ]
                        ],
                        "c": false
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "st",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "w": {
                      "a": 0,
                      "k": 10
                    },
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.143
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.333
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 15,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 37.0000015070409,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 0,
                  "k": 100
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 2",
                "hd": false
              }
            ],
            "ip": 12.00000048877,
            "op": 84.0000034213901,
            "st": 12.00000048877,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Layer 16",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 67,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 78.0000031770051,
                    "s": [
                      0
                    ]
                  }
                ]
              },
              "r": {
                "a": 0,
                "k": 0
              },
              "p": {
                "a": 0,
                "k": [
                  332.5,
                  486,
                  0
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  92.5,
                  -194,
                  0
                ]
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ]
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            40,
                            -194
                          ],
                          [
                            145,
                            -194
                          ]
                        ],
                        "c": false
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "st",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "w": {
                      "a": 0,
                      "k": 10
                    },
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.143
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.333
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 13,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 35.0000014255792,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 0,
                  "k": 100
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 2",
                "hd": false
              }
            ],
            "ip": 10.0000004073083,
            "op": 84.0000034213901,
            "st": 10.0000004073083,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Layer 21",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 67,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 78.0000031770051,
                    "s": [
                      0
                    ]
                  }
                ]
              },
              "r": {
                "a": 0,
                "k": 0
              },
              "p": {
                "a": 0,
                "k": [
                  451.5,
                  460,
                  0
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  211.5,
                  -220,
                  0
                ]
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ]
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            173,
                            -220
                          ],
                          [
                            250,
                            -220
                          ]
                        ],
                        "c": false
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "st",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "w": {
                      "a": 0,
                      "k": 10
                    },
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.143
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.333
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 11,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 33.0000013441176,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 0,
                  "k": 100
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 2",
                "hd": false
              }
            ],
            "ip": 8.00000032584668,
            "op": 84.0000034213901,
            "st": 8.00000032584668,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "Layer 20",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 67,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 78.0000031770051,
                    "s": [
                      0
                    ]
                  }
                ]
              },
              "r": {
                "a": 0,
                "k": 0
              },
              "p": {
                "a": 0,
                "k": [
                  368.5,
                  460,
                  0
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  128.5,
                  -220,
                  0
                ]
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ]
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            101,
                            -220
                          ],
                          [
                            156,
                            -220
                          ]
                        ],
                        "c": false
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "st",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "w": {
                      "a": 0,
                      "k": 10
                    },
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.143
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.333
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 9,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 31.0000012626559,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 0,
                  "k": 100
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 2",
                "hd": false
              }
            ],
            "ip": 6.00000024438501,
            "op": 84.0000034213901,
            "st": 6.00000024438501,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "Layer 19",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 67,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 78.0000031770051,
                    "s": [
                      0
                    ]
                  }
                ]
              },
              "r": {
                "a": 0,
                "k": 0
              },
              "p": {
                "a": 0,
                "k": [
                  301,
                  460,
                  0
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  61,
                  -220,
                  0
                ]
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ]
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            40,
                            -220
                          ],
                          [
                            82,
                            -220
                          ]
                        ],
                        "c": false
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "st",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "w": {
                      "a": 0,
                      "k": 10
                    },
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.143
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.333
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 7,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 29.0000011811942,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 0,
                  "k": 100
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 2",
                "hd": false
              }
            ],
            "ip": 4.00000016292334,
            "op": 84.0000034213901,
            "st": 4.00000016292334,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "Layer 17",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 67,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 78.0000031770051,
                    "s": [
                      0
                    ]
                  }
                ]
              },
              "r": {
                "a": 0,
                "k": 0
              },
              "p": {
                "a": 0,
                "k": [
                  430,
                  433,
                  0
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  190,
                  -247,
                  0
                ]
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ]
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            130,
                            -247
                          ],
                          [
                            250,
                            -247
                          ]
                        ],
                        "c": false
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "st",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "w": {
                      "a": 0,
                      "k": 10
                    },
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.143
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.333
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 5,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 27.0000010997325,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 0,
                  "k": 100
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 2",
                "hd": false
              }
            ],
            "ip": 2.00000008146167,
            "op": 84.0000034213901,
            "st": 2.00000008146167,
            "bm": 0
          },
          {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "Layer 18",
            "sr": 1,
            "ks": {
              "o": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": [
                        0.833
                      ],
                      "y": [
                        0.833
                      ]
                    },
                    "o": {
                      "x": [
                        0.167
                      ],
                      "y": [
                        0.167
                      ]
                    },
                    "t": 67,
                    "s": [
                      100
                    ]
                  },
                  {
                    "t": 78.0000031770051,
                    "s": [
                      0
                    ]
                  }
                ]
              },
              "r": {
                "a": 0,
                "k": 0
              },
              "p": {
                "a": 0,
                "k": [
                  314.5,
                  433,
                  0
                ]
              },
              "a": {
                "a": 0,
                "k": [
                  74.5,
                  -247,
                  0
                ]
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100,
                  100
                ]
              }
            },
            "ao": 0,
            "shapes": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            41,
                            -247
                          ],
                          [
                            108,
                            -247
                          ]
                        ],
                        "c": false
                      }
                    },
                    "nm": "Path 1",
                    "hd": false
                  },
                  {
                    "ty": "st",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "w": {
                      "a": 0,
                      "k": 10
                    },
                    "lc": 2,
                    "lj": 1,
                    "ml": 10,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": [
                          0.143
                        ],
                        "y": [
                          1
                        ]
                      },
                      "o": {
                        "x": [
                          0.333
                        ],
                        "y": [
                          0
                        ]
                      },
                      "t": 3,
                      "s": [
                        0
                      ]
                    },
                    {
                      "t": 25.0000010182709,
                      "s": [
                        100
                      ]
                    }
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 1",
                "hd": false
              },
              {
                "ty": "tm",
                "s": {
                  "a": 0,
                  "k": 0
                },
                "e": {
                  "a": 0,
                  "k": 100
                },
                "o": {
                  "a": 0,
                  "k": 0
                },
                "m": 1,
                "nm": "Trim Paths 2",
                "hd": false
              }
            ],
            "ip": 0,
            "op": 84.0000034213901,
            "st": 0,
            "bm": 0
          }
        ]
      }
    ],
    "layers": [
      {
        "ddd": 0,
        "ind": 1,
        "ty": 0,
        "nm": "Paperplanes",
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              540,
              540,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              540,
              540,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              -100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "w": 1080,
        "h": 1080,
        "ip": 78.0000031770051,
        "op": 235.000009571746,
        "st": 78.0000031770051,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 2,
        "ty": 0,
        "nm": "Paperplanes",
        "refId": "comp_0",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              540,
              540,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              540,
              540,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "w": 1080,
        "h": 1080,
        "ip": 29.0000011811942,
        "op": 186.000007575935,
        "st": 29.0000011811942,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 5,
        "ty": 4,
        "nm": "Shape Layer 3",
        "parent": 13,
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 102.875,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 112.125,
                "s": [
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 117.521,
                "s": [
                  100
                ]
              },
              {
                "t": 126.000005132085,
                "s": [
                  0
                ]
              }
            ]
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              114,
              0,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "d": 1,
                "ty": "el",
                "s": {
                  "a": 0,
                  "k": [
                    29,
                    29
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "nm": "Ellipse Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    90.5,
                    -207
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Ellipse 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 99.0000040323527,
        "op": 140.000005702317,
        "st": 17.0000006924242,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 6,
        "ty": 4,
        "nm": "Shape Layer 2",
        "parent": 13,
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 95.938,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 105.188,
                "s": [
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 110.584,
                "s": [
                  100
                ]
              },
              {
                "t": 119.062504849515,
                "s": [
                  0
                ]
              }
            ]
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              55.5,
              0,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "d": 1,
                "ty": "el",
                "s": {
                  "a": 0,
                  "k": [
                    29,
                    29
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "nm": "Ellipse Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    90.5,
                    -207
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Ellipse 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 90.0000036657751,
        "op": 131.000005335739,
        "st": 8.00000032584668,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 7,
        "ty": 4,
        "nm": "Shape Layer 1",
        "parent": 13,
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 89,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 98.25,
                "s": [
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 103.646,
                "s": [
                  100
                ]
              },
              {
                "t": 112.125004566945,
                "s": [
                  0
                ]
              }
            ]
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "d": 1,
                "ty": "el",
                "s": {
                  "a": 0,
                  "k": [
                    29,
                    29
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "nm": "Ellipse Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    90.5,
                    -207
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Ellipse 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 81.0000032991976,
        "op": 122.000004969162,
        "st": -1.00000004073083,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 8,
        "ty": 0,
        "nm": "TEXT",
        "parent": 13,
        "refId": "comp_1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              302.5,
              -137.5,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              540,
              540,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "w": 1080,
        "h": 1080,
        "ip": 115.000004684046,
        "op": 199.000008105436,
        "st": 115.000004684046,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 9,
        "ty": 0,
        "nm": "TEXT",
        "parent": 13,
        "refId": "comp_1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              302.5,
              -137.5,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              540,
              540,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "w": 1080,
        "h": 1080,
        "ip": 8.00000032584668,
        "op": 92.0000037472368,
        "st": 8.00000032584668,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 10,
        "ty": 4,
        "nm": "Layer 23",
        "parent": 13,
        "td": 1,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              -35.216,
              -204.842,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.845,
                    0.845,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 10,
                "s": [
                  0,
                  0,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.85,
                    0.85,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.18,
                    0.18,
                    0
                  ]
                },
                "t": 11,
                "s": [
                  26.796,
                  26.796,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.854,
                    0.854,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.187,
                    0.187,
                    0
                  ]
                },
                "t": 12,
                "s": [
                  49.945,
                  49.945,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.858,
                    0.858,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.194,
                    0.194,
                    0
                  ]
                },
                "t": 13,
                "s": [
                  68.53,
                  68.53,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.862,
                    0.862,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.202,
                    0.202,
                    0
                  ]
                },
                "t": 14,
                "s": [
                  82.517,
                  82.517,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.867,
                    0.867,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.211,
                    0.211,
                    0
                  ]
                },
                "t": 15,
                "s": [
                  92.38,
                  92.38,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.875,
                    0.875,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.224,
                    0.224,
                    0
                  ]
                },
                "t": 16,
                "s": [
                  98.83,
                  98.83,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.89,
                    0.89,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.251,
                    0.251,
                    0
                  ]
                },
                "t": 17,
                "s": [
                  102.639,
                  102.639,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.946,
                    0.946,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.348,
                    0.348,
                    0
                  ]
                },
                "t": 18,
                "s": [
                  104.533,
                  104.533,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.659,
                    0.659,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.154,
                    -0.154,
                    0
                  ]
                },
                "t": 19,
                "s": [
                  105.129,
                  105.129,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.81,
                    0.81,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 20,
                "s": [
                  104.92,
                  104.92,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.832,
                    0.832,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.148,
                    0.148,
                    0
                  ]
                },
                "t": 21,
                "s": [
                  104.273,
                  104.273,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.841,
                    0.841,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.165,
                    0.165,
                    0
                  ]
                },
                "t": 22,
                "s": [
                  103.446,
                  103.446,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.847,
                    0.847,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.176,
                    0.176,
                    0
                  ]
                },
                "t": 23,
                "s": [
                  102.605,
                  102.605,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.852,
                    0.852,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.184,
                    0.184,
                    0
                  ]
                },
                "t": 24,
                "s": [
                  101.845,
                  101.845,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.856,
                    0.856,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.191,
                    0.191,
                    0
                  ]
                },
                "t": 25,
                "s": [
                  101.213,
                  101.213,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.86,
                    0.86,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.198,
                    0.198,
                    0
                  ]
                },
                "t": 26,
                "s": [
                  100.722,
                  100.722,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.206,
                    0.206,
                    0
                  ]
                },
                "t": 27,
                "s": [
                  100.365,
                  100.365,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.871,
                    0.871,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.217,
                    0.217,
                    0
                  ]
                },
                "t": 28,
                "s": [
                  100.121,
                  100.121,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.911,
                    0.911,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.235,
                    0.235,
                    0
                  ]
                },
                "t": 29,
                "s": [
                  99.969,
                  99.969,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.33,
                    1.33,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    1.342,
                    1.342,
                    0
                  ]
                },
                "t": 30,
                "s": [
                  99.886,
                  99.886,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.806,
                    0.806,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.067,
                    0.067,
                    0
                  ]
                },
                "t": 31,
                "s": [
                  99.88,
                  99.88,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.842,
                    0.842,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.146,
                    0.146,
                    0
                  ]
                },
                "t": 32,
                "s": [
                  99.908,
                  99.908,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.176,
                    0.176,
                    0
                  ]
                },
                "t": 33,
                "s": [
                  99.944,
                  99.944,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.917,
                    0.917,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 34,
                "s": [
                  99.977,
                  99.977,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.002,
                    0.002,
                    0
                  ]
                },
                "t": 35,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 36,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 37,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 38,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 39,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 40,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 41,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 42,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 43,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 44,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 45,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 46,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 47,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 48,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 49,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 50,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 51,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 52,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 53,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 54,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 55,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 56,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 141,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 142,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 143,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 144,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 145,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 146,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 147,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 148,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 149,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 150,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 151,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 152,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 153,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 154,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 155,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 156,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 157,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 158,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 159,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 160,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 161,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 162,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 163,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 164,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.002,
                    1.002,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 165,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.083,
                    0.083,
                    0
                  ]
                },
                "t": 166,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.457,
                    1.457,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.316,
                    0.316,
                    0
                  ]
                },
                "t": 167,
                "s": [
                  99.976,
                  99.976,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.66,
                    0.66,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.07,
                    0.07,
                    0
                  ]
                },
                "t": 168,
                "s": [
                  99.967,
                  99.967,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.802,
                    0.802,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 169,
                "s": [
                  100.023,
                  100.023,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.86,
                    0.86,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 170,
                "s": [
                  100.194,
                  100.194,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.936,
                    0.936,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.205,
                    0.205,
                    0
                  ]
                },
                "t": 171,
                "s": [
                  100.429,
                  100.429,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.03,
                    0.03,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.284,
                    -0.284,
                    0
                  ]
                },
                "t": 172,
                "s": [
                  100.59,
                  100.59,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.739,
                    0.739,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.091,
                    0.091,
                    0
                  ]
                },
                "t": 173,
                "s": [
                  100.554,
                  100.554,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.798,
                    0.798,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.122,
                    0.122,
                    0
                  ]
                },
                "t": 174,
                "s": [
                  100.165,
                  100.165,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.834,
                    0.834,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.142,
                    0.142,
                    0
                  ]
                },
                "t": 175,
                "s": [
                  99.336,
                  99.336,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.883,
                    0.883,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.168,
                    0.168,
                    0
                  ]
                },
                "t": 176,
                "s": [
                  98.152,
                  98.152,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.115,
                    1.115,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.29,
                    0.29,
                    0
                  ]
                },
                "t": 177,
                "s": [
                  96.98,
                  96.98,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.658,
                    0.658,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.048,
                    0.048,
                    0
                  ]
                },
                "t": 178,
                "s": [
                  96.508,
                  96.508,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.775,
                    0.775,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 179,
                "s": [
                  97.63,
                  97.63,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.816,
                    0.816,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.132,
                    0.132,
                    0
                  ]
                },
                "t": 180,
                "s": [
                  101.116,
                  101.116,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.855,
                    0.855,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.153,
                    0.153,
                    0
                  ]
                },
                "t": 181,
                "s": [
                  107.061,
                  107.061,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.936,
                    0.936,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.195,
                    0.195,
                    0
                  ]
                },
                "t": 182,
                "s": [
                  114.221,
                  114.221,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.03,
                    0.03,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.284,
                    -0.284,
                    0
                  ]
                },
                "t": 183,
                "s": [
                  119.549,
                  119.549,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.739,
                    0.739,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.091,
                    0.091,
                    0
                  ]
                },
                "t": 184,
                "s": [
                  118.34,
                  118.34,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.798,
                    0.798,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.122,
                    0.122,
                    0
                  ]
                },
                "t": 185,
                "s": [
                  105.479,
                  105.479,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.834,
                    0.834,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.142,
                    0.142,
                    0
                  ]
                },
                "t": 186,
                "s": [
                  78.016,
                  78.016,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.168,
                    0.168,
                    0
                  ]
                },
                "t": 187,
                "s": [
                  38.801,
                  38.801,
                  100
                ]
              },
              {
                "t": 188.000007657397,
                "s": [
                  0,
                  0,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "AC IN [NWX] Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl NWX 4",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Number of bounces",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 1
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "AC OUT [NWX] 2 Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl NWX 4",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Number of bounces",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 2
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "d": 1,
                "ty": "el",
                "s": {
                  "a": 0,
                  "k": [
                    115.35,
                    115.35
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "nm": "Ellipse Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.996078431606,
                    0.996078431606,
                    0.996078431606,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 10.0000004073083,
        "op": 189.000007698128,
        "st": -5.00000020365417,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 11,
        "ty": 4,
        "nm": "Layer 9",
        "parent": 13,
        "tt": 1,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.839
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 1,
                "s": [
                  -90
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.839
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.173
                  ]
                },
                "t": 2,
                "s": [
                  -81.007
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.84
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.173
                  ]
                },
                "t": 3,
                "s": [
                  -72.634
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.84
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.173
                  ]
                },
                "t": 4,
                "s": [
                  -64.859
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.84
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.174
                  ]
                },
                "t": 5,
                "s": [
                  -57.659
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.84
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.174
                  ]
                },
                "t": 6,
                "s": [
                  -51.013
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.841
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.174
                  ]
                },
                "t": 7,
                "s": [
                  -44.899
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.841
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.175
                  ]
                },
                "t": 8,
                "s": [
                  -39.293
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.841
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.175
                  ]
                },
                "t": 9,
                "s": [
                  -34.175
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.842
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.175
                  ]
                },
                "t": 10,
                "s": [
                  -29.522
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.842
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.176
                  ]
                },
                "t": 11,
                "s": [
                  -25.311
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.843
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.176
                  ]
                },
                "t": 12,
                "s": [
                  -21.521
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.843
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.177
                  ]
                },
                "t": 13,
                "s": [
                  -18.13
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.844
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.178
                  ]
                },
                "t": 14,
                "s": [
                  -15.115
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.844
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.179
                  ]
                },
                "t": 15,
                "s": [
                  -12.454
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.845
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.179
                  ]
                },
                "t": 16,
                "s": [
                  -10.126
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.846
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.181
                  ]
                },
                "t": 17,
                "s": [
                  -8.107
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.847
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.182
                  ]
                },
                "t": 18,
                "s": [
                  -6.377
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.848
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.183
                  ]
                },
                "t": 19,
                "s": [
                  -4.912
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.85
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.185
                  ]
                },
                "t": 20,
                "s": [
                  -3.69
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.852
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.187
                  ]
                },
                "t": 21,
                "s": [
                  -2.69
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.854
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.19
                  ]
                },
                "t": 22,
                "s": [
                  -1.889
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.857
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.194
                  ]
                },
                "t": 23,
                "s": [
                  -1.266
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.861
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.2
                  ]
                },
                "t": 24,
                "s": [
                  -0.797
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.866
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.208
                  ]
                },
                "t": 25,
                "s": [
                  -0.461
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.874
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.221
                  ]
                },
                "t": 26,
                "s": [
                  -0.236
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.886
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.246
                  ]
                },
                "t": 27,
                "s": [
                  -0.1
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.905
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.31
                  ]
                },
                "t": 28,
                "s": [
                  -0.03
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.917
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.667
                  ]
                },
                "t": 29,
                "s": [
                  -0.004
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 30,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 31,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 32,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 33,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 34,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 35,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 36,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 37,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 38,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 39,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 40,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 41,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 42,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 43,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 44,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 45,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 46,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 47,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 48,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 49,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 50,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 51,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 52,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 53,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 54,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 55,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 56,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 57,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 58,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 59,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 60,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 61,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 62,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 63,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 64,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 65,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 66,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 67,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 68,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 69,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 70,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 71,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 72,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 73,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 74,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 75,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 76,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 77,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 78,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 79,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 80,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 81,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 82,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 83,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 84,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 85,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 86,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 87,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 88,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 89,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 90,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 91,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 92,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 93,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 94,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 95,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 96,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 97,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 98,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 99,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 100,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 101,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 102,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 103,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 104,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 105,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 106,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 107,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 108,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 109,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 110,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 111,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 112,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 113,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 114,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 115,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 116,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 117,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 118,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 119,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 120,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 121,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 122,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 123,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 124,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 125,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 126,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 127,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 128,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 129,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 130,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 131,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 132,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 133,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 134,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 135,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 136,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 137,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 138,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 139,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 140,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 141,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 142,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 143,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 144,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 145,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 146,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 147,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 148,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 149,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 150,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 151,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 152,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 153,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 154,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 155,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 156,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 157,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 158,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 159,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 160,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 161,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 162,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 163,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 164,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 165,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 166,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 167,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 168,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1.001
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 169,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.333
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.083
                  ]
                },
                "t": 170,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.69
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.095
                  ]
                },
                "t": 171,
                "s": [
                  -0.011
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.754
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.114
                  ]
                },
                "t": 172,
                "s": [
                  -0.09
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.779
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.126
                  ]
                },
                "t": 173,
                "s": [
                  -0.304
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.792
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.134
                  ]
                },
                "t": 174,
                "s": [
                  -0.72
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.8
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.139
                  ]
                },
                "t": 175,
                "s": [
                  -1.406
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.806
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.143
                  ]
                },
                "t": 176,
                "s": [
                  -2.43
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.81
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.146
                  ]
                },
                "t": 177,
                "s": [
                  -3.859
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.813
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.148
                  ]
                },
                "t": 178,
                "s": [
                  -5.76
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.815
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.15
                  ]
                },
                "t": 179,
                "s": [
                  -8.201
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.817
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.152
                  ]
                },
                "t": 180,
                "s": [
                  -11.25
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.818
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.153
                  ]
                },
                "t": 181,
                "s": [
                  -14.974
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.819
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.154
                  ]
                },
                "t": 182,
                "s": [
                  -19.44
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.821
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.155
                  ]
                },
                "t": 183,
                "s": [
                  -24.716
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.821
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 184,
                "s": [
                  -30.87
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.822
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 185,
                "s": [
                  -37.969
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.823
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.157
                  ]
                },
                "t": 186,
                "s": [
                  -46.08
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.157
                  ]
                },
                "t": 187,
                "s": [
                  -55.271
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 188,
                "s": [
                  -65.61
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 189,
                "s": [
                  -77.164
                ]
              },
              {
                "t": 190.000007738859,
                "s": [
                  -90
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.833,
                  "y": 0.839
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 1,
                "s": [
                  -2535.067,
                  -205.494,
                  0
                ],
                "to": [
                  41.634,
                  0,
                  0
                ],
                "ti": [
                  -80.398,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.839
                },
                "o": {
                  "x": 0.167,
                  "y": 0.173
                },
                "t": 2,
                "s": [
                  -2285.262,
                  -205.494,
                  0
                ],
                "to": [
                  80.398,
                  0,
                  0
                ],
                "ti": [
                  -74.76,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.173
                },
                "t": 3,
                "s": [
                  -2052.677,
                  -205.494,
                  0
                ],
                "to": [
                  74.76,
                  0,
                  0
                ],
                "ti": [
                  -69.328,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.173
                },
                "t": 4,
                "s": [
                  -1836.699,
                  -205.494,
                  0
                ],
                "to": [
                  69.328,
                  0,
                  0
                ],
                "ti": [
                  -64.1,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 5,
                "s": [
                  -1636.711,
                  -205.494,
                  0
                ],
                "to": [
                  64.1,
                  0,
                  0
                ],
                "ti": [
                  -59.077,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 6,
                "s": [
                  -1452.099,
                  -205.494,
                  0
                ],
                "to": [
                  59.077,
                  0,
                  0
                ],
                "ti": [
                  -54.259,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.841
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 7,
                "s": [
                  -1282.248,
                  -205.494,
                  0
                ],
                "to": [
                  54.259,
                  0,
                  0
                ],
                "ti": [
                  -49.647,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.841
                },
                "o": {
                  "x": 0.167,
                  "y": 0.175
                },
                "t": 8,
                "s": [
                  -1126.543,
                  -205.494,
                  0
                ],
                "to": [
                  49.647,
                  0,
                  0
                ],
                "ti": [
                  -45.239,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.841
                },
                "o": {
                  "x": 0.167,
                  "y": 0.175
                },
                "t": 9,
                "s": [
                  -984.368,
                  -205.494,
                  0
                ],
                "to": [
                  45.239,
                  0,
                  0
                ],
                "ti": [
                  -41.036,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.842
                },
                "o": {
                  "x": 0.167,
                  "y": 0.175
                },
                "t": 10,
                "s": [
                  -855.109,
                  -205.494,
                  0
                ],
                "to": [
                  41.036,
                  0,
                  0
                ],
                "ti": [
                  -37.039,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.842
                },
                "o": {
                  "x": 0.167,
                  "y": 0.176
                },
                "t": 11,
                "s": [
                  -738.15,
                  -205.494,
                  0
                ],
                "to": [
                  37.039,
                  0,
                  0
                ],
                "ti": [
                  -33.246,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.843
                },
                "o": {
                  "x": 0.167,
                  "y": 0.176
                },
                "t": 12,
                "s": [
                  -632.877,
                  -205.494,
                  0
                ],
                "to": [
                  33.246,
                  0,
                  0
                ],
                "ti": [
                  -29.658,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.843
                },
                "o": {
                  "x": 0.167,
                  "y": 0.177
                },
                "t": 13,
                "s": [
                  -538.675,
                  -205.494,
                  0
                ],
                "to": [
                  29.658,
                  0,
                  0
                ],
                "ti": [
                  -26.276,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.844
                },
                "o": {
                  "x": 0.167,
                  "y": 0.178
                },
                "t": 14,
                "s": [
                  -454.928,
                  -205.494,
                  0
                ],
                "to": [
                  26.276,
                  0,
                  0
                ],
                "ti": [
                  -23.098,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.844
                },
                "o": {
                  "x": 0.167,
                  "y": 0.179
                },
                "t": 15,
                "s": [
                  -381.022,
                  -205.494,
                  0
                ],
                "to": [
                  23.098,
                  0,
                  0
                ],
                "ti": [
                  -20.125,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.845
                },
                "o": {
                  "x": 0.167,
                  "y": 0.179
                },
                "t": 16,
                "s": [
                  -316.341,
                  -205.494,
                  0
                ],
                "to": [
                  20.125,
                  0,
                  0
                ],
                "ti": [
                  -17.358,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.846
                },
                "o": {
                  "x": 0.167,
                  "y": 0.181
                },
                "t": 17,
                "s": [
                  -260.271,
                  -205.494,
                  0
                ],
                "to": [
                  17.358,
                  0,
                  0
                ],
                "ti": [
                  -14.795,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 18,
                "s": [
                  -212.196,
                  -205.494,
                  0
                ],
                "to": [
                  14.795,
                  0,
                  0
                ],
                "ti": [
                  -12.437,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.848
                },
                "o": {
                  "x": 0.167,
                  "y": 0.183
                },
                "t": 19,
                "s": [
                  -171.501,
                  -205.494,
                  0
                ],
                "to": [
                  12.437,
                  0,
                  0
                ],
                "ti": [
                  -10.285,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.185
                },
                "t": 20,
                "s": [
                  -137.572,
                  -205.494,
                  0
                ],
                "to": [
                  10.285,
                  0,
                  0
                ],
                "ti": [
                  -8.337,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.852
                },
                "o": {
                  "x": 0.167,
                  "y": 0.187
                },
                "t": 21,
                "s": [
                  -109.793,
                  -205.494,
                  0
                ],
                "to": [
                  8.337,
                  0,
                  0
                ],
                "ti": [
                  -6.595,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.854
                },
                "o": {
                  "x": 0.167,
                  "y": 0.19
                },
                "t": 22,
                "s": [
                  -87.55,
                  -205.494,
                  0
                ],
                "to": [
                  6.595,
                  0,
                  0
                ],
                "ti": [
                  -5.057,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.857
                },
                "o": {
                  "x": 0.167,
                  "y": 0.194
                },
                "t": 23,
                "s": [
                  -70.226,
                  -205.494,
                  0
                ],
                "to": [
                  5.057,
                  0,
                  0
                ],
                "ti": [
                  -3.724,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.861
                },
                "o": {
                  "x": 0.167,
                  "y": 0.2
                },
                "t": 24,
                "s": [
                  -57.208,
                  -205.494,
                  0
                ],
                "to": [
                  3.724,
                  0,
                  0
                ],
                "ti": [
                  -2.597,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.866
                },
                "o": {
                  "x": 0.167,
                  "y": 0.208
                },
                "t": 25,
                "s": [
                  -47.88,
                  -205.494,
                  0
                ],
                "to": [
                  2.597,
                  0,
                  0
                ],
                "ti": [
                  -1.674,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.874
                },
                "o": {
                  "x": 0.167,
                  "y": 0.221
                },
                "t": 26,
                "s": [
                  -41.627,
                  -205.494,
                  0
                ],
                "to": [
                  1.674,
                  0,
                  0
                ],
                "ti": [
                  -0.957,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.886
                },
                "o": {
                  "x": 0.167,
                  "y": 0.246
                },
                "t": 27,
                "s": [
                  -37.835,
                  -205.494,
                  0
                ],
                "to": [
                  0.957,
                  0,
                  0
                ],
                "ti": [
                  -0.444,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.905
                },
                "o": {
                  "x": 0.167,
                  "y": 0.31
                },
                "t": 28,
                "s": [
                  -35.887,
                  -205.494,
                  0
                ],
                "to": [
                  0.444,
                  0,
                  0
                ],
                "ti": [
                  -0.137,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.917
                },
                "o": {
                  "x": 0.167,
                  "y": 0.663
                },
                "t": 29,
                "s": [
                  -35.169,
                  -205.494,
                  0
                ],
                "to": [
                  0.137,
                  0,
                  0
                ],
                "ti": [
                  -0.017,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 30,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 31,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 32,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 33,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 34,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 35,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 36,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 37,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 38,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 39,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 40,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 41,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 42,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 43,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 44,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 45,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 46,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 47,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 48,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 49,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 50,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 51,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 52,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 53,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 54,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 55,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 56,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 57,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 58,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 59,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 60,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 61,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 62,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 63,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 64,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 65,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 66,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 67,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 68,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 69,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 70,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 71,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 72,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 73,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 74,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 75,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 76,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 77,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 78,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 79,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 80,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 81,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 82,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 83,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 84,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 85,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 86,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 87,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 88,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 89,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 90,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 91,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 92,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 93,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 94,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 95,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 96,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 97,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 98,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 99,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 100,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 101,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 102,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 103,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 104,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 105,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 106,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 107,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 108,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 109,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 110,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 111,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 112,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 113,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 114,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 115,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 116,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 117,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 118,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 119,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 120,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 121,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 122,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 123,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 124,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 125,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 126,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 127,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 128,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 129,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 130,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 131,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 132,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 133,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 134,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 135,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 136,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 137,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 138,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 139,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 140,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 141,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 142,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 143,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 144,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 145,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 146,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 147,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 148,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 149,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 150,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 151,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 152,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 153,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 154,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 155,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 156,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 157,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 158,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 159,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 160,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 161,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 162,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 163,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 164,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 165,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 166,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 167,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 168,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 169,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.337
                },
                "o": {
                  "x": 0.167,
                  "y": 0.083
                },
                "t": 170,
                "s": [
                  -35.067,
                  -205.494,
                  0
                ],
                "to": [
                  -0.052,
                  0,
                  0
                ],
                "ti": [
                  0.417,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.69
                },
                "o": {
                  "x": 0.167,
                  "y": 0.095
                },
                "t": 171,
                "s": [
                  -35.379,
                  -205.494,
                  0
                ],
                "to": [
                  -0.417,
                  0,
                  0
                ],
                "ti": [
                  1.354,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.754
                },
                "o": {
                  "x": 0.167,
                  "y": 0.114
                },
                "t": 172,
                "s": [
                  -37.567,
                  -205.494,
                  0
                ],
                "to": [
                  -1.354,
                  0,
                  0
                ],
                "ti": [
                  2.917,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.779
                },
                "o": {
                  "x": 0.167,
                  "y": 0.126
                },
                "t": 173,
                "s": [
                  -43.504,
                  -205.494,
                  0
                ],
                "to": [
                  -2.917,
                  0,
                  0
                ],
                "ti": [
                  5.104,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.792
                },
                "o": {
                  "x": 0.167,
                  "y": 0.134
                },
                "t": 174,
                "s": [
                  -55.067,
                  -205.494,
                  0
                ],
                "to": [
                  -5.104,
                  0,
                  0
                ],
                "ti": [
                  7.917,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.8
                },
                "o": {
                  "x": 0.167,
                  "y": 0.139
                },
                "t": 175,
                "s": [
                  -74.129,
                  -205.494,
                  0
                ],
                "to": [
                  -7.917,
                  0,
                  0
                ],
                "ti": [
                  11.354,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.806
                },
                "o": {
                  "x": 0.167,
                  "y": 0.143
                },
                "t": 176,
                "s": [
                  -102.567,
                  -205.494,
                  0
                ],
                "to": [
                  -11.354,
                  0,
                  0
                ],
                "ti": [
                  15.417,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.81
                },
                "o": {
                  "x": 0.167,
                  "y": 0.146
                },
                "t": 177,
                "s": [
                  -142.254,
                  -205.494,
                  0
                ],
                "to": [
                  -15.417,
                  0,
                  0
                ],
                "ti": [
                  20.104,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.813
                },
                "o": {
                  "x": 0.167,
                  "y": 0.148
                },
                "t": 178,
                "s": [
                  -195.067,
                  -205.494,
                  0
                ],
                "to": [
                  -20.104,
                  0,
                  0
                ],
                "ti": [
                  25.417,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.815
                },
                "o": {
                  "x": 0.167,
                  "y": 0.15
                },
                "t": 179,
                "s": [
                  -262.879,
                  -205.494,
                  0
                ],
                "to": [
                  -25.417,
                  0,
                  0
                ],
                "ti": [
                  31.354,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.817
                },
                "o": {
                  "x": 0.167,
                  "y": 0.152
                },
                "t": 180,
                "s": [
                  -347.567,
                  -205.494,
                  0
                ],
                "to": [
                  -31.354,
                  0,
                  0
                ],
                "ti": [
                  37.917,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.818
                },
                "o": {
                  "x": 0.167,
                  "y": 0.153
                },
                "t": 181,
                "s": [
                  -451.004,
                  -205.494,
                  0
                ],
                "to": [
                  -37.917,
                  0,
                  0
                ],
                "ti": [
                  45.104,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.819
                },
                "o": {
                  "x": 0.167,
                  "y": 0.154
                },
                "t": 182,
                "s": [
                  -575.067,
                  -205.494,
                  0
                ],
                "to": [
                  -45.104,
                  0,
                  0
                ],
                "ti": [
                  52.917,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.821
                },
                "o": {
                  "x": 0.167,
                  "y": 0.155
                },
                "t": 183,
                "s": [
                  -721.629,
                  -205.494,
                  0
                ],
                "to": [
                  -52.917,
                  0,
                  0
                ],
                "ti": [
                  61.354,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.821
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 184,
                "s": [
                  -892.567,
                  -205.494,
                  0
                ],
                "to": [
                  -61.354,
                  0,
                  0
                ],
                "ti": [
                  70.417,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.822
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 185,
                "s": [
                  -1089.754,
                  -205.494,
                  0
                ],
                "to": [
                  -70.417,
                  0,
                  0
                ],
                "ti": [
                  80.104,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 186,
                "s": [
                  -1315.067,
                  -205.494,
                  0
                ],
                "to": [
                  -80.104,
                  0,
                  0
                ],
                "ti": [
                  90.417,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 187,
                "s": [
                  -1570.379,
                  -205.494,
                  0
                ],
                "to": [
                  -90.417,
                  0,
                  0
                ],
                "ti": [
                  101.354,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 188,
                "s": [
                  -1857.567,
                  -205.494,
                  0
                ],
                "to": [
                  -101.354,
                  0,
                  0
                ],
                "ti": [
                  112.917,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 189,
                "s": [
                  -2178.504,
                  -205.494,
                  0
                ],
                "to": [
                  -112.917,
                  0,
                  0
                ],
                "ti": [
                  59.427,
                  0,
                  0
                ]
              },
              {
                "t": 190.000007738859,
                "s": [
                  -2535.067,
                  -205.494,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              -35.067,
              -205.494,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "AC IN [ZBS] Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl ZBS 3",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl ZBS 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    -2500,
                    0
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl ZBS 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": -90
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "AC OUT [ZBS] 2 Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl ZBS 3",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl ZBS 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    -2500,
                    0
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl ZBS 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": -90
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        14.77,
                        -0.703
                      ],
                      [
                        -9.378,
                        3.751
                      ],
                      [
                        -20.163,
                        0.938
                      ],
                      [
                        -11.723,
                        -21.101
                      ],
                      [
                        -13.129,
                        -26.259
                      ],
                      [
                        1.876,
                        -22.976
                      ],
                      [
                        1.407,
                        6.565
                      ],
                      [
                        -10.316,
                        22.507
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -65.694,
                        -206.249
                      ],
                      [
                        -62.412,
                        -236.259
                      ],
                      [
                        -60.067,
                        -240.01
                      ],
                      [
                        -55.847,
                        -242.354
                      ],
                      [
                        -6.144,
                        -233.914
                      ],
                      [
                        -5.206,
                        -206.249
                      ],
                      [
                        -17.163,
                        -225.708
                      ],
                      [
                        -30.761,
                        -224.302
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        9.378,
                        14.067
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -43.656,
                        -186.555
                      ],
                      [
                        -24.9,
                        -186.555
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.996078431606,
                    0.996078431606,
                    0.996078431606,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -3.282,
                        4.689
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        3.751,
                        3.751
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -42.718,
                        -166.392
                      ],
                      [
                        -25.838,
                        -166.392
                      ],
                      [
                        -25.838,
                        -169.205
                      ],
                      [
                        -42.718,
                        -169.205
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    0.603921592236,
                    0.329411774874,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        3.721,
                        0.772
                      ],
                      [
                        1.282,
                        -0.727
                      ],
                      [
                        16.013,
                        0
                      ],
                      [
                        1.014,
                        -18.846
                      ],
                      [
                        1.476,
                        -0.306
                      ],
                      [
                        -0.988,
                        -4.758
                      ],
                      [
                        -3.721,
                        0.772
                      ],
                      [
                        -0.739,
                        0.652
                      ],
                      [
                        -9.485,
                        -2.988
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -3.269,
                        10.233
                      ],
                      [
                        -0.918,
                        -0.191
                      ],
                      [
                        -0.988,
                        4.758
                      ]
                    ],
                    "o": [
                      [
                        -1.415,
                        -0.294
                      ],
                      [
                        -1.056,
                        -18.797
                      ],
                      [
                        -16.042,
                        0
                      ],
                      [
                        -1.324,
                        -0.799
                      ],
                      [
                        -3.721,
                        0.772
                      ],
                      [
                        0.988,
                        4.758
                      ],
                      [
                        0.977,
                        -0.203
                      ],
                      [
                        3.423,
                        10.831
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        8.798,
                        -3.328
                      ],
                      [
                        0.709,
                        0.591
                      ],
                      [
                        3.721,
                        0.772
                      ],
                      [
                        0.988,
                        -4.758
                      ]
                    ],
                    "v": [
                      [
                        -0.69,
                        -207.075
                      ],
                      [
                        -4.814,
                        -206.354
                      ],
                      [
                        -34.981,
                        -240.01
                      ],
                      [
                        -65.155,
                        -206.25
                      ],
                      [
                        -69.444,
                        -207.075
                      ],
                      [
                        -74.394,
                        -197.062
                      ],
                      [
                        -65.868,
                        -189.845
                      ],
                      [
                        -63.282,
                        -191.164
                      ],
                      [
                        -42.718,
                        -168.996
                      ],
                      [
                        -42.718,
                        -159.827
                      ],
                      [
                        -25.838,
                        -159.827
                      ],
                      [
                        -25.838,
                        -169.483
                      ],
                      [
                        -6.719,
                        -191.045
                      ],
                      [
                        -4.266,
                        -189.845
                      ],
                      [
                        4.26,
                        -197.062
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    0.768627464771,
                    0.623529434204,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 4",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 1.00000004073083,
        "op": 191.000007779589,
        "st": -5.00000020365417,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 12,
        "ty": 4,
        "nm": "Layer 8",
        "parent": 13,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              -35.216,
              -204.842,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.845,
                    0.845,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 10,
                "s": [
                  0,
                  0,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.85,
                    0.85,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.18,
                    0.18,
                    0
                  ]
                },
                "t": 11,
                "s": [
                  26.796,
                  26.796,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.854,
                    0.854,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.187,
                    0.187,
                    0
                  ]
                },
                "t": 12,
                "s": [
                  49.945,
                  49.945,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.858,
                    0.858,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.194,
                    0.194,
                    0
                  ]
                },
                "t": 13,
                "s": [
                  68.53,
                  68.53,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.862,
                    0.862,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.202,
                    0.202,
                    0
                  ]
                },
                "t": 14,
                "s": [
                  82.517,
                  82.517,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.867,
                    0.867,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.211,
                    0.211,
                    0
                  ]
                },
                "t": 15,
                "s": [
                  92.38,
                  92.38,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.875,
                    0.875,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.224,
                    0.224,
                    0
                  ]
                },
                "t": 16,
                "s": [
                  98.83,
                  98.83,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.89,
                    0.89,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.251,
                    0.251,
                    0
                  ]
                },
                "t": 17,
                "s": [
                  102.639,
                  102.639,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.946,
                    0.946,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.348,
                    0.348,
                    0
                  ]
                },
                "t": 18,
                "s": [
                  104.533,
                  104.533,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.659,
                    0.659,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.154,
                    -0.154,
                    0
                  ]
                },
                "t": 19,
                "s": [
                  105.129,
                  105.129,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.81,
                    0.81,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 20,
                "s": [
                  104.92,
                  104.92,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.832,
                    0.832,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.148,
                    0.148,
                    0
                  ]
                },
                "t": 21,
                "s": [
                  104.273,
                  104.273,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.841,
                    0.841,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.165,
                    0.165,
                    0
                  ]
                },
                "t": 22,
                "s": [
                  103.446,
                  103.446,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.847,
                    0.847,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.176,
                    0.176,
                    0
                  ]
                },
                "t": 23,
                "s": [
                  102.605,
                  102.605,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.852,
                    0.852,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.184,
                    0.184,
                    0
                  ]
                },
                "t": 24,
                "s": [
                  101.845,
                  101.845,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.856,
                    0.856,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.191,
                    0.191,
                    0
                  ]
                },
                "t": 25,
                "s": [
                  101.213,
                  101.213,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.86,
                    0.86,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.198,
                    0.198,
                    0
                  ]
                },
                "t": 26,
                "s": [
                  100.722,
                  100.722,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.206,
                    0.206,
                    0
                  ]
                },
                "t": 27,
                "s": [
                  100.365,
                  100.365,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.871,
                    0.871,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.217,
                    0.217,
                    0
                  ]
                },
                "t": 28,
                "s": [
                  100.121,
                  100.121,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.911,
                    0.911,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.235,
                    0.235,
                    0
                  ]
                },
                "t": 29,
                "s": [
                  99.969,
                  99.969,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.33,
                    1.33,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    1.342,
                    1.342,
                    0
                  ]
                },
                "t": 30,
                "s": [
                  99.886,
                  99.886,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.806,
                    0.806,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.067,
                    0.067,
                    0
                  ]
                },
                "t": 31,
                "s": [
                  99.88,
                  99.88,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.842,
                    0.842,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.146,
                    0.146,
                    0
                  ]
                },
                "t": 32,
                "s": [
                  99.908,
                  99.908,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.176,
                    0.176,
                    0
                  ]
                },
                "t": 33,
                "s": [
                  99.944,
                  99.944,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.917,
                    0.917,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 34,
                "s": [
                  99.977,
                  99.977,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.002,
                    0.002,
                    0
                  ]
                },
                "t": 35,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 36,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 37,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 38,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 39,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 40,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 41,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 42,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 43,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 44,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 45,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 46,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 47,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 48,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 49,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 50,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 51,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 52,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 53,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 54,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 55,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 56,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 141,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 142,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 143,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 144,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 145,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 146,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 147,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 148,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 149,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 150,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 151,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 152,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 153,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 154,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 155,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 156,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 157,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 158,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 159,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 160,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 161,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 162,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 163,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 164,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.002,
                    1.002,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 165,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.083,
                    0.083,
                    0
                  ]
                },
                "t": 166,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.457,
                    1.457,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.316,
                    0.316,
                    0
                  ]
                },
                "t": 167,
                "s": [
                  99.976,
                  99.976,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.66,
                    0.66,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.07,
                    0.07,
                    0
                  ]
                },
                "t": 168,
                "s": [
                  99.967,
                  99.967,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.802,
                    0.802,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 169,
                "s": [
                  100.023,
                  100.023,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.86,
                    0.86,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 170,
                "s": [
                  100.194,
                  100.194,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.936,
                    0.936,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.205,
                    0.205,
                    0
                  ]
                },
                "t": 171,
                "s": [
                  100.429,
                  100.429,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.03,
                    0.03,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.284,
                    -0.284,
                    0
                  ]
                },
                "t": 172,
                "s": [
                  100.59,
                  100.59,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.739,
                    0.739,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.091,
                    0.091,
                    0
                  ]
                },
                "t": 173,
                "s": [
                  100.554,
                  100.554,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.798,
                    0.798,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.122,
                    0.122,
                    0
                  ]
                },
                "t": 174,
                "s": [
                  100.165,
                  100.165,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.834,
                    0.834,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.142,
                    0.142,
                    0
                  ]
                },
                "t": 175,
                "s": [
                  99.336,
                  99.336,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.883,
                    0.883,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.168,
                    0.168,
                    0
                  ]
                },
                "t": 176,
                "s": [
                  98.152,
                  98.152,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.115,
                    1.115,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.29,
                    0.29,
                    0
                  ]
                },
                "t": 177,
                "s": [
                  96.98,
                  96.98,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.658,
                    0.658,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.048,
                    0.048,
                    0
                  ]
                },
                "t": 178,
                "s": [
                  96.508,
                  96.508,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.775,
                    0.775,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 179,
                "s": [
                  97.63,
                  97.63,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.816,
                    0.816,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.132,
                    0.132,
                    0
                  ]
                },
                "t": 180,
                "s": [
                  101.116,
                  101.116,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.855,
                    0.855,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.153,
                    0.153,
                    0
                  ]
                },
                "t": 181,
                "s": [
                  107.061,
                  107.061,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.936,
                    0.936,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.195,
                    0.195,
                    0
                  ]
                },
                "t": 182,
                "s": [
                  114.221,
                  114.221,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.03,
                    0.03,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.284,
                    -0.284,
                    0
                  ]
                },
                "t": 183,
                "s": [
                  119.549,
                  119.549,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.739,
                    0.739,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.091,
                    0.091,
                    0
                  ]
                },
                "t": 184,
                "s": [
                  118.34,
                  118.34,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.798,
                    0.798,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.122,
                    0.122,
                    0
                  ]
                },
                "t": 185,
                "s": [
                  105.479,
                  105.479,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.834,
                    0.834,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.142,
                    0.142,
                    0
                  ]
                },
                "t": 186,
                "s": [
                  78.016,
                  78.016,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.168,
                    0.168,
                    0
                  ]
                },
                "t": 187,
                "s": [
                  38.801,
                  38.801,
                  100
                ]
              },
              {
                "t": 188.000007657397,
                "s": [
                  0,
                  0,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "AC IN [NWX] Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl NWX 4",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Number of bounces",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 1
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "AC OUT [NWX] 2 Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl NWX 4",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Number of bounces",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 2
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "d": 1,
                "ty": "el",
                "s": {
                  "a": 0,
                  "k": [
                    115.35,
                    115.35
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "nm": "Ellipse Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.996078431606,
                    0.996078431606,
                    0.996078431606,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 10.0000004073083,
        "op": 189.000007698128,
        "st": -5.00000020365417,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 13,
        "ty": 4,
        "nm": "Layer 5",
        "sr": 1.11111111111111,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.842
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 2,
                "s": [
                  -89.998
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.843
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.177
                  ]
                },
                "t": 3,
                "s": [
                  -76.447
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.843
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.177
                  ]
                },
                "t": 4,
                "s": [
                  -64.33
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.844
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.178
                  ]
                },
                "t": 5,
                "s": [
                  -53.566
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.845
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.179
                  ]
                },
                "t": 6,
                "s": [
                  -44.076
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.845
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.18
                  ]
                },
                "t": 7,
                "s": [
                  -35.778
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.846
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.181
                  ]
                },
                "t": 8,
                "s": [
                  -28.593
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.847
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.182
                  ]
                },
                "t": 9,
                "s": [
                  -22.44
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.849
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.183
                  ]
                },
                "t": 10,
                "s": [
                  -17.241
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.85
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.185
                  ]
                },
                "t": 11,
                "s": [
                  -12.914
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.852
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.188
                  ]
                },
                "t": 12,
                "s": [
                  -9.379
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.854
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.191
                  ]
                },
                "t": 13,
                "s": [
                  -6.556
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.857
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.195
                  ]
                },
                "t": 14,
                "s": [
                  -4.366
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.861
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.2
                  ]
                },
                "t": 15,
                "s": [
                  -2.727
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.867
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.209
                  ]
                },
                "t": 16,
                "s": [
                  -1.56
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.875
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.223
                  ]
                },
                "t": 17,
                "s": [
                  -0.785
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.888
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.25
                  ]
                },
                "t": 18,
                "s": [
                  -0.322
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.907
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.323
                  ]
                },
                "t": 19,
                "s": [
                  -0.09
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.917
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.8
                  ]
                },
                "t": 20,
                "s": [
                  -0.009
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.001
                  ]
                },
                "t": 21,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 22,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 23,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 24,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 25,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 26,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 27,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 28,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 29,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 30,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 31,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 32,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 33,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 34,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 35,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 36,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 37,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 38,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 39,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 40,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 41,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 42,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 43,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 44,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 45,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 46,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 47,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 48,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 49,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 50,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 51,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 52,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 53,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 54,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 55,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 56,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 57,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 58,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 59,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 60,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 61,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 62,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 63,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 64,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 65,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 66,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 67,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 68,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 69,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 70,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 71,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 72,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 73,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 74,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 75,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 76,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 77,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 78,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 79,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 80,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 81,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 82,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 83,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 84,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 85,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 86,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 87,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 88,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 89,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 90,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 91,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 92,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 93,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 94,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 95,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 96,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 97,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 98,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 99,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 100,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 101,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 102,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 103,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 104,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 105,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 106,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 107,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 108,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 109,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 110,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 111,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 112,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 113,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 114,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 115,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 116,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 117,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 118,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 119,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 120,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 121,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 122,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 123,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 124,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 125,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 126,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 127,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 128,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 129,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 130,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 131,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 132,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 133,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 134,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 135,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 136,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 137,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 138,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 139,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 140,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 141,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 142,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 143,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 144,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 145,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 146,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 147,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 148,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 149,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 150,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 151,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 152,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 153,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 154,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 155,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 156,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 157,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 158,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 159,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 160,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 161,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 162,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 163,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 164,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 165,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 166,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 167,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    -4.318
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.083
                  ]
                },
                "t": 168,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.548
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.085
                  ]
                },
                "t": 169,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.72
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.102
                  ]
                },
                "t": 170,
                "s": [
                  -0.019
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.765
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.119
                  ]
                },
                "t": 171,
                "s": [
                  -0.103
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.784
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.129
                  ]
                },
                "t": 172,
                "s": [
                  -0.299
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.795
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.136
                  ]
                },
                "t": 173,
                "s": [
                  -0.658
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.802
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.141
                  ]
                },
                "t": 174,
                "s": [
                  -1.226
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.807
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.144
                  ]
                },
                "t": 175,
                "s": [
                  -2.053
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.811
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.147
                  ]
                },
                "t": 176,
                "s": [
                  -3.187
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.813
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.149
                  ]
                },
                "t": 177,
                "s": [
                  -4.676
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.816
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.151
                  ]
                },
                "t": 178,
                "s": [
                  -6.57
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.817
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.152
                  ]
                },
                "t": 179,
                "s": [
                  -8.915
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.819
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.153
                  ]
                },
                "t": 180,
                "s": [
                  -11.762
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.82
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.154
                  ]
                },
                "t": 181,
                "s": [
                  -15.158
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.821
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.155
                  ]
                },
                "t": 182,
                "s": [
                  -19.152
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.822
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 183,
                "s": [
                  -23.793
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.822
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 184,
                "s": [
                  -29.128
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.823
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.157
                  ]
                },
                "t": 185,
                "s": [
                  -35.207
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 186,
                "s": [
                  -42.077
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 187,
                "s": [
                  -49.787
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.825
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 188,
                "s": [
                  -58.387
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.825
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.159
                  ]
                },
                "t": 189,
                "s": [
                  -67.923
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.159
                  ]
                },
                "t": 190,
                "s": [
                  -78.445
                ]
              },
              {
                "t": 191.000146668484,
                "s": [
                  -90
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.833,
                  "y": 0.842
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 2,
                "s": [
                  551.701,
                  759.766,
                  0
                ],
                "to": [
                  1.882,
                  -10.037,
                  0
                ],
                "ti": [
                  -3.565,
                  19.013,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.843
                },
                "o": {
                  "x": 0.167,
                  "y": 0.177
                },
                "t": 3,
                "s": [
                  562.993,
                  699.542,
                  0
                ],
                "to": [
                  3.565,
                  -19.013,
                  0
                ],
                "ti": [
                  -3.178,
                  16.949,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.843
                },
                "o": {
                  "x": 0.167,
                  "y": 0.177
                },
                "t": 4,
                "s": [
                  573.091,
                  645.688,
                  0
                ],
                "to": [
                  3.178,
                  -16.949,
                  0
                ],
                "ti": [
                  -2.813,
                  15.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.844
                },
                "o": {
                  "x": 0.167,
                  "y": 0.178
                },
                "t": 5,
                "s": [
                  582.061,
                  597.848,
                  0
                ],
                "to": [
                  2.813,
                  -15.004,
                  0
                ],
                "ti": [
                  -2.471,
                  13.177,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.845
                },
                "o": {
                  "x": 0.167,
                  "y": 0.179
                },
                "t": 6,
                "s": [
                  589.97,
                  555.667,
                  0
                ],
                "to": [
                  2.471,
                  -13.177,
                  0
                ],
                "ti": [
                  -2.15,
                  11.469,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.845
                },
                "o": {
                  "x": 0.167,
                  "y": 0.18
                },
                "t": 7,
                "s": [
                  596.884,
                  518.787,
                  0
                ],
                "to": [
                  2.15,
                  -11.469,
                  0
                ],
                "ti": [
                  -1.852,
                  9.879,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.846
                },
                "o": {
                  "x": 0.167,
                  "y": 0.181
                },
                "t": 8,
                "s": [
                  602.872,
                  486.854,
                  0
                ],
                "to": [
                  1.852,
                  -9.879,
                  0
                ],
                "ti": [
                  -1.577,
                  8.409,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 9,
                "s": [
                  607.999,
                  459.511,
                  0
                ],
                "to": [
                  1.577,
                  -8.409,
                  0
                ],
                "ti": [
                  -1.323,
                  7.057,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.849
                },
                "o": {
                  "x": 0.167,
                  "y": 0.183
                },
                "t": 10,
                "s": [
                  612.332,
                  436.401,
                  0
                ],
                "to": [
                  1.323,
                  -7.057,
                  0
                ],
                "ti": [
                  -1.092,
                  5.824,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.185
                },
                "t": 11,
                "s": [
                  615.938,
                  417.169,
                  0
                ],
                "to": [
                  1.092,
                  -5.824,
                  0
                ],
                "ti": [
                  -0.883,
                  4.709,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.852
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 12,
                "s": [
                  618.884,
                  401.459,
                  0
                ],
                "to": [
                  0.883,
                  -4.709,
                  0
                ],
                "ti": [
                  -0.696,
                  3.713,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.854
                },
                "o": {
                  "x": 0.167,
                  "y": 0.191
                },
                "t": 13,
                "s": [
                  621.236,
                  388.914,
                  0
                ],
                "to": [
                  0.696,
                  -3.713,
                  0
                ],
                "ti": [
                  -0.532,
                  2.836,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.857
                },
                "o": {
                  "x": 0.167,
                  "y": 0.195
                },
                "t": 14,
                "s": [
                  623.061,
                  379.178,
                  0
                ],
                "to": [
                  0.532,
                  -2.836,
                  0
                ],
                "ti": [
                  -0.39,
                  2.078,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.861
                },
                "o": {
                  "x": 0.167,
                  "y": 0.2
                },
                "t": 15,
                "s": [
                  624.427,
                  371.896,
                  0
                ],
                "to": [
                  0.39,
                  -2.078,
                  0
                ],
                "ti": [
                  -0.27,
                  1.438,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.209
                },
                "t": 16,
                "s": [
                  625.399,
                  366.71,
                  0
                ],
                "to": [
                  0.27,
                  -1.438,
                  0
                ],
                "ti": [
                  -0.172,
                  0.917,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.875
                },
                "o": {
                  "x": 0.167,
                  "y": 0.223
                },
                "t": 17,
                "s": [
                  626.045,
                  363.266,
                  0
                ],
                "to": [
                  0.172,
                  -0.917,
                  0
                ],
                "ti": [
                  -0.097,
                  0.515,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.888
                },
                "o": {
                  "x": 0.167,
                  "y": 0.25
                },
                "t": 18,
                "s": [
                  626.431,
                  361.206,
                  0
                ],
                "to": [
                  0.097,
                  -0.515,
                  0
                ],
                "ti": [
                  -0.043,
                  0.232,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.906
                },
                "o": {
                  "x": 0.167,
                  "y": 0.323
                },
                "t": 19,
                "s": [
                  626.624,
                  360.175,
                  0
                ],
                "to": [
                  0.043,
                  -0.232,
                  0
                ],
                "ti": [
                  -0.012,
                  0.067,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.917
                },
                "o": {
                  "x": 0.167,
                  "y": 0.713
                },
                "t": 20,
                "s": [
                  626.691,
                  359.817,
                  0
                ],
                "to": [
                  0.012,
                  -0.067,
                  0
                ],
                "ti": [
                  -0.001,
                  0.007,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 21,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 22,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 23,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 24,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 25,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 26,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 27,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 28,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 29,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 30,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 31,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 32,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 33,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 34,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 35,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 36,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 37,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 38,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 39,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 40,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 41,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 42,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 43,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 44,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 45,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 46,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 47,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 48,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 49,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 50,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 51,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 52,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 53,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 54,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 55,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 56,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 57,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 58,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 59,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 60,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 61,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 62,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 63,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 64,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 65,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 66,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 67,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 68,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 69,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 70,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 71,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 72,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 73,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 74,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 75,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 76,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 77,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 78,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 79,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 80,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 81,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 82,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 83,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 84,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 85,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 86,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 87,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 88,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 89,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 90,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 91,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 92,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 93,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 94,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 95,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 96,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 97,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 98,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 99,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 100,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 101,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 102,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 103,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 104,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 105,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 106,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 107,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 108,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 109,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 110,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 111,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 112,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 113,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 114,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 115,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 116,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 117,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 118,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 119,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 120,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 121,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 122,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 123,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 124,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 125,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 126,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 127,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 128,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 129,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 130,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 131,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 132,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 133,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 134,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 135,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 136,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 137,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 138,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 139,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 140,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 141,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 142,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 143,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 144,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 145,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 146,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 147,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 148,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 149,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 150,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 151,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 152,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 153,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 154,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 155,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 156,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 157,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 158,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 159,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 160,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 161,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 162,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 163,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 164,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 165,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 166,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 167,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.326
                },
                "o": {
                  "x": 0.167,
                  "y": 0.084
                },
                "t": 168,
                "s": [
                  626.699,
                  359.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -0.014,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.548
                },
                "o": {
                  "x": 0.167,
                  "y": 0.095
                },
                "t": 169,
                "s": [
                  626.699,
                  359.777,
                  0
                ],
                "to": [
                  0,
                  0.014,
                  0
                ],
                "ti": [
                  0,
                  -0.076,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.72
                },
                "o": {
                  "x": 0.167,
                  "y": 0.102
                },
                "t": 170,
                "s": [
                  626.699,
                  359.86,
                  0
                ],
                "to": [
                  0,
                  0.076,
                  0
                ],
                "ti": [
                  0,
                  -0.208,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.765
                },
                "o": {
                  "x": 0.167,
                  "y": 0.119
                },
                "t": 171,
                "s": [
                  626.699,
                  360.232,
                  0
                ],
                "to": [
                  0,
                  0.208,
                  0
                ],
                "ti": [
                  0,
                  -0.411,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.784
                },
                "o": {
                  "x": 0.167,
                  "y": 0.129
                },
                "t": 172,
                "s": [
                  626.699,
                  361.106,
                  0
                ],
                "to": [
                  0,
                  0.411,
                  0
                ],
                "ti": [
                  0,
                  -0.686,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.795
                },
                "o": {
                  "x": 0.167,
                  "y": 0.136
                },
                "t": 173,
                "s": [
                  626.699,
                  362.698,
                  0
                ],
                "to": [
                  0,
                  0.686,
                  0
                ],
                "ti": [
                  0,
                  -1.033,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.802
                },
                "o": {
                  "x": 0.167,
                  "y": 0.141
                },
                "t": 174,
                "s": [
                  626.699,
                  365.224,
                  0
                ],
                "to": [
                  0,
                  1.033,
                  0
                ],
                "ti": [
                  0,
                  -1.452,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.807
                },
                "o": {
                  "x": 0.167,
                  "y": 0.144
                },
                "t": 175,
                "s": [
                  626.699,
                  368.899,
                  0
                ],
                "to": [
                  0,
                  1.452,
                  0
                ],
                "ti": [
                  0,
                  -1.943,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.811
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 176,
                "s": [
                  626.699,
                  373.939,
                  0
                ],
                "to": [
                  0,
                  1.943,
                  0
                ],
                "ti": [
                  0,
                  -2.506,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.813
                },
                "o": {
                  "x": 0.167,
                  "y": 0.149
                },
                "t": 177,
                "s": [
                  626.699,
                  380.558,
                  0
                ],
                "to": [
                  0,
                  2.506,
                  0
                ],
                "ti": [
                  0,
                  -3.14,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.816
                },
                "o": {
                  "x": 0.167,
                  "y": 0.151
                },
                "t": 178,
                "s": [
                  626.699,
                  388.973,
                  0
                ],
                "to": [
                  0,
                  3.14,
                  0
                ],
                "ti": [
                  0,
                  -3.846,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.817
                },
                "o": {
                  "x": 0.167,
                  "y": 0.152
                },
                "t": 179,
                "s": [
                  626.699,
                  399.399,
                  0
                ],
                "to": [
                  0,
                  3.846,
                  0
                ],
                "ti": [
                  0,
                  -4.624,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.819
                },
                "o": {
                  "x": 0.167,
                  "y": 0.153
                },
                "t": 180,
                "s": [
                  626.699,
                  412.052,
                  0
                ],
                "to": [
                  0,
                  4.624,
                  0
                ],
                "ti": [
                  0,
                  -5.474,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.82
                },
                "o": {
                  "x": 0.167,
                  "y": 0.154
                },
                "t": 181,
                "s": [
                  626.699,
                  427.146,
                  0
                ],
                "to": [
                  0,
                  5.474,
                  0
                ],
                "ti": [
                  0,
                  -6.396,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.821
                },
                "o": {
                  "x": 0.167,
                  "y": 0.155
                },
                "t": 182,
                "s": [
                  626.699,
                  444.897,
                  0
                ],
                "to": [
                  0,
                  6.396,
                  0
                ],
                "ti": [
                  0,
                  -7.389,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.822
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 183,
                "s": [
                  626.699,
                  465.521,
                  0
                ],
                "to": [
                  0,
                  7.389,
                  0
                ],
                "ti": [
                  0,
                  -8.455,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.822
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 184,
                "s": [
                  626.699,
                  489.233,
                  0
                ],
                "to": [
                  0,
                  8.455,
                  0
                ],
                "ti": [
                  0,
                  -9.592,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 185,
                "s": [
                  626.699,
                  516.249,
                  0
                ],
                "to": [
                  0,
                  9.592,
                  0
                ],
                "ti": [
                  0,
                  -10.801,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 186,
                "s": [
                  626.699,
                  546.784,
                  0
                ],
                "to": [
                  0,
                  10.801,
                  0
                ],
                "ti": [
                  0,
                  -12.081,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 187,
                "s": [
                  626.699,
                  581.053,
                  0
                ],
                "to": [
                  0,
                  12.081,
                  0
                ],
                "ti": [
                  0,
                  -13.434,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.825
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 188,
                "s": [
                  626.699,
                  619.272,
                  0
                ],
                "to": [
                  0,
                  13.434,
                  0
                ],
                "ti": [
                  0,
                  -14.858,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.825
                },
                "o": {
                  "x": 0.167,
                  "y": 0.159
                },
                "t": 189,
                "s": [
                  626.699,
                  661.656,
                  0
                ],
                "to": [
                  0,
                  14.858,
                  0
                ],
                "ti": [
                  0,
                  -16.353,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.159
                },
                "t": 190,
                "s": [
                  626.699,
                  708.421,
                  0
                ],
                "to": [
                  0,
                  16.353,
                  0
                ],
                "ti": [
                  0,
                  -8.559,
                  0
                ]
              },
              {
                "t": 191.000146668484,
                "s": [
                  626.699,
                  759.775,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              86.699,
              -180.225,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.842,
                    0.842,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 2,
                "s": [
                  0.002,
                  0.002,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.843,
                    0.843,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.177,
                    0.177,
                    0
                  ]
                },
                "t": 3,
                "s": [
                  15.058,
                  15.058,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.843,
                    0.843,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.177,
                    0.177,
                    0
                  ]
                },
                "t": 4,
                "s": [
                  28.522,
                  28.522,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.178,
                    0.178,
                    0
                  ]
                },
                "t": 5,
                "s": [
                  40.482,
                  40.482,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.845,
                    0.845,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 6,
                "s": [
                  51.027,
                  51.027,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.845,
                    0.845,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.18,
                    0.18,
                    0
                  ]
                },
                "t": 7,
                "s": [
                  60.247,
                  60.247,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.846,
                    0.846,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.181,
                    0.181,
                    0
                  ]
                },
                "t": 8,
                "s": [
                  68.23,
                  68.23,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.847,
                    0.847,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.182,
                    0.182,
                    0
                  ]
                },
                "t": 9,
                "s": [
                  75.066,
                  75.066,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.849,
                    0.849,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.183,
                    0.183,
                    0
                  ]
                },
                "t": 10,
                "s": [
                  80.844,
                  80.844,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.85,
                    0.85,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.185,
                    0.185,
                    0
                  ]
                },
                "t": 11,
                "s": [
                  85.652,
                  85.652,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.852,
                    0.852,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.188,
                    0.188,
                    0
                  ]
                },
                "t": 12,
                "s": [
                  89.579,
                  89.579,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.854,
                    0.854,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.191,
                    0.191,
                    0
                  ]
                },
                "t": 13,
                "s": [
                  92.715,
                  92.715,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.195,
                    0.195,
                    0
                  ]
                },
                "t": 14,
                "s": [
                  95.149,
                  95.149,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.861,
                    0.861,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 15,
                "s": [
                  96.97,
                  96.97,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.867,
                    0.867,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.209,
                    0.209,
                    0
                  ]
                },
                "t": 16,
                "s": [
                  98.266,
                  98.266,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.875,
                    0.875,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.223,
                    0.223,
                    0
                  ]
                },
                "t": 17,
                "s": [
                  99.127,
                  99.127,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.888,
                    0.888,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.25,
                    0.25,
                    0
                  ]
                },
                "t": 18,
                "s": [
                  99.642,
                  99.642,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.907,
                    0.907,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.323,
                    0.323,
                    0
                  ]
                },
                "t": 19,
                "s": [
                  99.9,
                  99.9,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.917,
                    0.917,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.8,
                    0.8,
                    0
                  ]
                },
                "t": 20,
                "s": [
                  99.99,
                  99.99,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.001,
                    0.001,
                    0
                  ]
                },
                "t": 21,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 22,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 23,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 24,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 25,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 26,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 27,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 28,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 29,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 30,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 31,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 32,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 33,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 34,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 35,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 36,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 37,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 38,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 39,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 40,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 41,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 42,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 43,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 44,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 45,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 46,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 47,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 48,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 49,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 50,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 51,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 52,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 53,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 54,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 55,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 56,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 141,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 142,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 143,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 144,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 145,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 146,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 147,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 148,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 149,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 150,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 151,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 152,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 153,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 154,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 155,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 156,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 157,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 158,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 159,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 160,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 161,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 162,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 163,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 164,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 165,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 166,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 167,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    -4.318,
                    -4.318,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.083,
                    0.083,
                    0
                  ]
                },
                "t": 168,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.548,
                    0.548,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.085,
                    0.085,
                    0
                  ]
                },
                "t": 169,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.72,
                    0.72,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.102,
                    0.102,
                    0
                  ]
                },
                "t": 170,
                "s": [
                  99.979,
                  99.979,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.765,
                    0.765,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.119,
                    0.119,
                    0
                  ]
                },
                "t": 171,
                "s": [
                  99.886,
                  99.886,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.784,
                    0.784,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.129,
                    0.129,
                    0
                  ]
                },
                "t": 172,
                "s": [
                  99.667,
                  99.667,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.795,
                    0.795,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.136,
                    0.136,
                    0
                  ]
                },
                "t": 173,
                "s": [
                  99.269,
                  99.269,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.802,
                    0.802,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.141,
                    0.141,
                    0
                  ]
                },
                "t": 174,
                "s": [
                  98.638,
                  98.638,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.807,
                    0.807,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 175,
                "s": [
                  97.719,
                  97.719,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.811,
                    0.811,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.147,
                    0.147,
                    0
                  ]
                },
                "t": 176,
                "s": [
                  96.459,
                  96.459,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.813,
                    0.813,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.149,
                    0.149,
                    0
                  ]
                },
                "t": 177,
                "s": [
                  94.804,
                  94.804,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.816,
                    0.816,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.151,
                    0.151,
                    0
                  ]
                },
                "t": 178,
                "s": [
                  92.701,
                  92.701,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.817,
                    0.817,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.152,
                    0.152,
                    0
                  ]
                },
                "t": 179,
                "s": [
                  90.094,
                  90.094,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.153,
                    0.153,
                    0
                  ]
                },
                "t": 180,
                "s": [
                  86.931,
                  86.931,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.82,
                    0.82,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.154,
                    0.154,
                    0
                  ]
                },
                "t": 181,
                "s": [
                  83.157,
                  83.157,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.821,
                    0.821,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 182,
                "s": [
                  78.72,
                  78.72,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.822,
                    0.822,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.156,
                    0.156,
                    0
                  ]
                },
                "t": 183,
                "s": [
                  73.564,
                  73.564,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.822,
                    0.822,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.156,
                    0.156,
                    0
                  ]
                },
                "t": 184,
                "s": [
                  67.636,
                  67.636,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.823,
                    0.823,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.157,
                    0.157,
                    0
                  ]
                },
                "t": 185,
                "s": [
                  60.882,
                  60.882,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.824,
                    0.824,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.158,
                    0.158,
                    0
                  ]
                },
                "t": 186,
                "s": [
                  53.248,
                  53.248,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.824,
                    0.824,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.158,
                    0.158,
                    0
                  ]
                },
                "t": 187,
                "s": [
                  44.681,
                  44.681,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.825,
                    0.825,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.158,
                    0.158,
                    0
                  ]
                },
                "t": 188,
                "s": [
                  35.126,
                  35.126,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.825,
                    0.825,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.159,
                    0.159,
                    0
                  ]
                },
                "t": 189,
                "s": [
                  24.53,
                  24.53,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.159,
                    0.159,
                    0
                  ]
                },
                "t": 190,
                "s": [
                  12.838,
                  12.838,
                  100
                ]
              },
              {
                "t": 191.000146668484,
                "s": [
                  0,
                  0,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "AC IN [GLA] Controls",
            "np": 5,
            "mn": "Pseudo/MHAC PrCtrl GLA 3",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    -75,
                    400
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": -90
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0003",
                "ix": 3,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "AC OUT [GLA] 2 Controls",
            "np": 5,
            "mn": "Pseudo/MHAC PrCtrl GLA 3",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    0,
                    400
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": -90
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0003",
                "ix": 3,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -13.765
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        13.765
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        13.765
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -13.765
                      ]
                    ],
                    "v": [
                      [
                        -93.287,
                        -303.312
                      ],
                      [
                        266.686,
                        -303.312
                      ],
                      [
                        291.61,
                        -278.388
                      ],
                      [
                        291.61,
                        -128.952
                      ],
                      [
                        266.686,
                        -104.028
                      ],
                      [
                        -20.878,
                        -104.028
                      ],
                      [
                        -55.847,
                        -57.138
                      ],
                      [
                        -51.382,
                        -104.028
                      ],
                      [
                        -93.287,
                        -104.028
                      ],
                      [
                        -118.211,
                        -128.952
                      ],
                      [
                        -118.211,
                        -278.388
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.156862750649,
                    0.57647061348,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 2.00000008146167,
        "op": 192.00000782032,
        "st": -26.1111121746385,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 14,
        "ty": 4,
        "nm": "Layer 4",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.843
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 5,
                "s": [
                  -90
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.844
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.178
                  ]
                },
                "t": 6,
                "s": [
                  -75.034
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.844
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.179
                  ]
                },
                "t": 7,
                "s": [
                  -61.826
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.845
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.179
                  ]
                },
                "t": 8,
                "s": [
                  -50.267
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.846
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.181
                  ]
                },
                "t": 9,
                "s": [
                  -40.246
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.847
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.182
                  ]
                },
                "t": 10,
                "s": [
                  -31.655
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.848
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.183
                  ]
                },
                "t": 11,
                "s": [
                  -24.382
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.85
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.185
                  ]
                },
                "t": 12,
                "s": [
                  -18.319
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.852
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.187
                  ]
                },
                "t": 13,
                "s": [
                  -13.354
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.854
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.19
                  ]
                },
                "t": 14,
                "s": [
                  -9.379
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.857
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.194
                  ]
                },
                "t": 15,
                "s": [
                  -6.283
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.861
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.2
                  ]
                },
                "t": 16,
                "s": [
                  -3.957
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.866
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.208
                  ]
                },
                "t": 17,
                "s": [
                  -2.29
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.874
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.221
                  ]
                },
                "t": 18,
                "s": [
                  -1.172
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.886
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.246
                  ]
                },
                "t": 19,
                "s": [
                  -0.495
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.905
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.31
                  ]
                },
                "t": 20,
                "s": [
                  -0.147
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.917
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.667
                  ]
                },
                "t": 21,
                "s": [
                  -0.018
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.002
                  ]
                },
                "t": 22,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 23,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 24,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 25,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 26,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 27,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 28,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 29,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 30,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 31,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 32,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 33,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 34,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 35,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 36,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 37,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 38,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 39,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 40,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 41,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 42,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 43,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 44,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 45,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 46,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 47,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 48,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 49,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 50,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 51,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 52,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 53,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 54,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 55,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 56,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 57,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 58,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 59,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 60,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 61,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 62,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 63,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 64,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 65,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 66,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 67,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 68,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 69,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 70,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 71,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 72,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 73,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 74,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 75,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 76,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 77,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 78,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 79,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 80,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 81,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 82,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 83,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 84,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 85,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 86,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 87,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 88,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 89,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 90,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 91,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 92,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 93,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 94,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 95,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 96,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 97,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 98,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 99,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 100,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 101,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 102,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 103,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 104,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 105,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 106,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 107,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 108,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 109,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 110,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 111,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 112,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 113,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 114,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 115,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 116,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 117,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 118,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 119,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 120,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 121,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 122,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 123,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 124,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 125,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 126,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 127,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 128,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 129,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 130,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 131,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 132,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 133,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 134,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 135,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 136,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 137,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 138,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 139,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 140,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 141,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 142,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 143,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 144,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 145,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 146,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 147,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 148,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 149,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 150,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 151,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 152,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 153,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 154,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 155,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 156,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 157,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 158,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 159,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 160,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 161,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 162,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 163,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1.001
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 164,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.333
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.083
                  ]
                },
                "t": 165,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.69
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.095
                  ]
                },
                "t": 166,
                "s": [
                  -0.011
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.754
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.114
                  ]
                },
                "t": 167,
                "s": [
                  -0.09
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.779
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.126
                  ]
                },
                "t": 168,
                "s": [
                  -0.304
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.792
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.134
                  ]
                },
                "t": 169,
                "s": [
                  -0.72
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.8
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.139
                  ]
                },
                "t": 170,
                "s": [
                  -1.406
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.806
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.143
                  ]
                },
                "t": 171,
                "s": [
                  -2.43
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.81
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.146
                  ]
                },
                "t": 172,
                "s": [
                  -3.859
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.813
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.148
                  ]
                },
                "t": 173,
                "s": [
                  -5.76
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.815
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.15
                  ]
                },
                "t": 174,
                "s": [
                  -8.201
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.817
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.152
                  ]
                },
                "t": 175,
                "s": [
                  -11.25
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.818
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.153
                  ]
                },
                "t": 176,
                "s": [
                  -14.974
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.819
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.154
                  ]
                },
                "t": 177,
                "s": [
                  -19.44
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.821
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.155
                  ]
                },
                "t": 178,
                "s": [
                  -24.716
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.821
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 179,
                "s": [
                  -30.87
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.822
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 180,
                "s": [
                  -37.969
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.823
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.157
                  ]
                },
                "t": 181,
                "s": [
                  -46.08
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.157
                  ]
                },
                "t": 182,
                "s": [
                  -55.271
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 183,
                "s": [
                  -65.61
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 184,
                "s": [
                  -77.164
                ]
              },
              {
                "t": 185.000007535204,
                "s": [
                  -90
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.833,
                  "y": 0.843
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 5,
                "s": [
                  537.163,
                  793.067,
                  0
                ],
                "to": [
                  2.079,
                  -11.086,
                  0
                ],
                "ti": [
                  -3.913,
                  20.87,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.844
                },
                "o": {
                  "x": 0.167,
                  "y": 0.178
                },
                "t": 6,
                "s": [
                  549.635,
                  726.55,
                  0
                ],
                "to": [
                  3.913,
                  -20.87,
                  0
                ],
                "ti": [
                  -3.44,
                  18.346,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.844
                },
                "o": {
                  "x": 0.167,
                  "y": 0.179
                },
                "t": 7,
                "s": [
                  560.642,
                  667.849,
                  0
                ],
                "to": [
                  3.44,
                  -18.346,
                  0
                ],
                "ti": [
                  -2.997,
                  15.985,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.845
                },
                "o": {
                  "x": 0.167,
                  "y": 0.179
                },
                "t": 8,
                "s": [
                  570.274,
                  616.475,
                  0
                ],
                "to": [
                  2.997,
                  -15.985,
                  0
                ],
                "ti": [
                  -2.585,
                  13.787,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.846
                },
                "o": {
                  "x": 0.167,
                  "y": 0.181
                },
                "t": 9,
                "s": [
                  578.625,
                  571.94,
                  0
                ],
                "to": [
                  2.585,
                  -13.787,
                  0
                ],
                "ti": [
                  -2.203,
                  11.751,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 10,
                "s": [
                  585.784,
                  533.755,
                  0
                ],
                "to": [
                  2.203,
                  -11.751,
                  0
                ],
                "ti": [
                  -1.852,
                  9.879,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.848
                },
                "o": {
                  "x": 0.167,
                  "y": 0.183
                },
                "t": 11,
                "s": [
                  591.845,
                  501.433,
                  0
                ],
                "to": [
                  1.852,
                  -9.879,
                  0
                ],
                "ti": [
                  -1.532,
                  8.169,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.185
                },
                "t": 12,
                "s": [
                  596.898,
                  474.484,
                  0
                ],
                "to": [
                  1.532,
                  -8.169,
                  0
                ],
                "ti": [
                  -1.242,
                  6.622,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.852
                },
                "o": {
                  "x": 0.167,
                  "y": 0.187
                },
                "t": 13,
                "s": [
                  601.035,
                  452.42,
                  0
                ],
                "to": [
                  1.242,
                  -6.622,
                  0
                ],
                "ti": [
                  -0.982,
                  5.238,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.854
                },
                "o": {
                  "x": 0.167,
                  "y": 0.19
                },
                "t": 14,
                "s": [
                  604.347,
                  434.753,
                  0
                ],
                "to": [
                  0.982,
                  -5.238,
                  0
                ],
                "ti": [
                  -0.753,
                  4.017,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.857
                },
                "o": {
                  "x": 0.167,
                  "y": 0.194
                },
                "t": 15,
                "s": [
                  606.927,
                  420.993,
                  0
                ],
                "to": [
                  0.753,
                  -4.017,
                  0
                ],
                "ti": [
                  -0.555,
                  2.958,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.861
                },
                "o": {
                  "x": 0.167,
                  "y": 0.2
                },
                "t": 16,
                "s": [
                  608.866,
                  410.653,
                  0
                ],
                "to": [
                  0.555,
                  -2.958,
                  0
                ],
                "ti": [
                  -0.387,
                  2.063,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.866
                },
                "o": {
                  "x": 0.167,
                  "y": 0.208
                },
                "t": 17,
                "s": [
                  610.255,
                  403.244,
                  0
                ],
                "to": [
                  0.387,
                  -2.063,
                  0
                ],
                "ti": [
                  -0.249,
                  1.33,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.874
                },
                "o": {
                  "x": 0.167,
                  "y": 0.221
                },
                "t": 18,
                "s": [
                  611.186,
                  398.278,
                  0
                ],
                "to": [
                  0.249,
                  -1.33,
                  0
                ],
                "ti": [
                  -0.142,
                  0.76,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.886
                },
                "o": {
                  "x": 0.167,
                  "y": 0.246
                },
                "t": 19,
                "s": [
                  611.751,
                  395.266,
                  0
                ],
                "to": [
                  0.142,
                  -0.76,
                  0
                ],
                "ti": [
                  -0.066,
                  0.353,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.905
                },
                "o": {
                  "x": 0.167,
                  "y": 0.31
                },
                "t": 20,
                "s": [
                  612.041,
                  393.719,
                  0
                ],
                "to": [
                  0.066,
                  -0.353,
                  0
                ],
                "ti": [
                  -0.02,
                  0.109,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.917
                },
                "o": {
                  "x": 0.167,
                  "y": 0.663
                },
                "t": 21,
                "s": [
                  612.148,
                  393.149,
                  0
                ],
                "to": [
                  0.02,
                  -0.109,
                  0
                ],
                "ti": [
                  -0.003,
                  0.014,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 22,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 23,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 24,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 25,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 26,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 27,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 28,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 29,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 30,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 31,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 32,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 33,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 34,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 35,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 36,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 37,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 38,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 39,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 40,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 41,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 42,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 43,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 44,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 45,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 46,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 47,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 48,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 49,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 50,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 51,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 52,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 53,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 54,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 55,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 56,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 57,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 58,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 59,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 60,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 61,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 62,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 63,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 64,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 65,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 66,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 67,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 68,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 69,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 70,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 71,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 72,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 73,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 74,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 75,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 76,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 77,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 78,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 79,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 80,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 81,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 82,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 83,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 84,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 85,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 86,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 87,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 88,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 89,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 90,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 91,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 92,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 93,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 94,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 95,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 96,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 97,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 98,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 99,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 100,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 101,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 102,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 103,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 104,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 105,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 106,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 107,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 108,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 109,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 110,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 111,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 112,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 113,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 114,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 115,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 116,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 117,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 118,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 119,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 120,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 121,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 122,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 123,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 124,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 125,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 126,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 127,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 128,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 129,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 130,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 131,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 132,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 133,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 134,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 135,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 136,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 137,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 138,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 139,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 140,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 141,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 142,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 143,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 144,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 145,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 146,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 147,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 148,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 149,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 150,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 151,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 152,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 153,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 154,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 155,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 156,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 157,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 158,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 159,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 160,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 161,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 162,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 163,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 164,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.339
                },
                "o": {
                  "x": 0.167,
                  "y": 0.083
                },
                "t": 165,
                "s": [
                  612.163,
                  393.067,
                  0
                ],
                "to": [
                  0,
                  0.008,
                  0
                ],
                "ti": [
                  0,
                  -0.067,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.69
                },
                "o": {
                  "x": 0.167,
                  "y": 0.095
                },
                "t": 166,
                "s": [
                  612.163,
                  393.117,
                  0
                ],
                "to": [
                  0,
                  0.067,
                  0
                ],
                "ti": [
                  0,
                  -0.217,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.754
                },
                "o": {
                  "x": 0.167,
                  "y": 0.114
                },
                "t": 167,
                "s": [
                  612.163,
                  393.467,
                  0
                ],
                "to": [
                  0,
                  0.217,
                  0
                ],
                "ti": [
                  0,
                  -0.467,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.779
                },
                "o": {
                  "x": 0.167,
                  "y": 0.126
                },
                "t": 168,
                "s": [
                  612.163,
                  394.417,
                  0
                ],
                "to": [
                  0,
                  0.467,
                  0
                ],
                "ti": [
                  0,
                  -0.817,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.792
                },
                "o": {
                  "x": 0.167,
                  "y": 0.134
                },
                "t": 169,
                "s": [
                  612.163,
                  396.267,
                  0
                ],
                "to": [
                  0,
                  0.817,
                  0
                ],
                "ti": [
                  0,
                  -1.267,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.8
                },
                "o": {
                  "x": 0.167,
                  "y": 0.139
                },
                "t": 170,
                "s": [
                  612.163,
                  399.317,
                  0
                ],
                "to": [
                  0,
                  1.267,
                  0
                ],
                "ti": [
                  0,
                  -1.817,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.806
                },
                "o": {
                  "x": 0.167,
                  "y": 0.143
                },
                "t": 171,
                "s": [
                  612.163,
                  403.867,
                  0
                ],
                "to": [
                  0,
                  1.817,
                  0
                ],
                "ti": [
                  0,
                  -2.467,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.81
                },
                "o": {
                  "x": 0.167,
                  "y": 0.146
                },
                "t": 172,
                "s": [
                  612.163,
                  410.217,
                  0
                ],
                "to": [
                  0,
                  2.467,
                  0
                ],
                "ti": [
                  0,
                  -3.217,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.813
                },
                "o": {
                  "x": 0.167,
                  "y": 0.148
                },
                "t": 173,
                "s": [
                  612.163,
                  418.667,
                  0
                ],
                "to": [
                  0,
                  3.217,
                  0
                ],
                "ti": [
                  0,
                  -4.067,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.815
                },
                "o": {
                  "x": 0.167,
                  "y": 0.15
                },
                "t": 174,
                "s": [
                  612.163,
                  429.517,
                  0
                ],
                "to": [
                  0,
                  4.067,
                  0
                ],
                "ti": [
                  0,
                  -5.017,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.817
                },
                "o": {
                  "x": 0.167,
                  "y": 0.152
                },
                "t": 175,
                "s": [
                  612.163,
                  443.067,
                  0
                ],
                "to": [
                  0,
                  5.017,
                  0
                ],
                "ti": [
                  0,
                  -6.067,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.818
                },
                "o": {
                  "x": 0.167,
                  "y": 0.153
                },
                "t": 176,
                "s": [
                  612.163,
                  459.617,
                  0
                ],
                "to": [
                  0,
                  6.067,
                  0
                ],
                "ti": [
                  0,
                  -7.217,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.819
                },
                "o": {
                  "x": 0.167,
                  "y": 0.154
                },
                "t": 177,
                "s": [
                  612.163,
                  479.467,
                  0
                ],
                "to": [
                  0,
                  7.217,
                  0
                ],
                "ti": [
                  0,
                  -8.467,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.821
                },
                "o": {
                  "x": 0.167,
                  "y": 0.155
                },
                "t": 178,
                "s": [
                  612.163,
                  502.917,
                  0
                ],
                "to": [
                  0,
                  8.467,
                  0
                ],
                "ti": [
                  0,
                  -9.817,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.821
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 179,
                "s": [
                  612.163,
                  530.267,
                  0
                ],
                "to": [
                  0,
                  9.817,
                  0
                ],
                "ti": [
                  0,
                  -11.267,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.822
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 180,
                "s": [
                  612.163,
                  561.817,
                  0
                ],
                "to": [
                  0,
                  11.267,
                  0
                ],
                "ti": [
                  0,
                  -12.817,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 181,
                "s": [
                  612.163,
                  597.867,
                  0
                ],
                "to": [
                  0,
                  12.817,
                  0
                ],
                "ti": [
                  0,
                  -14.467,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 182,
                "s": [
                  612.163,
                  638.717,
                  0
                ],
                "to": [
                  0,
                  14.467,
                  0
                ],
                "ti": [
                  0,
                  -16.217,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 183,
                "s": [
                  612.163,
                  684.667,
                  0
                ],
                "to": [
                  0,
                  16.217,
                  0
                ],
                "ti": [
                  0,
                  -18.067,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 184,
                "s": [
                  612.163,
                  736.017,
                  0
                ],
                "to": [
                  0,
                  18.067,
                  0
                ],
                "ti": [
                  0,
                  -9.508,
                  0
                ]
              },
              {
                "t": 185.000007535204,
                "s": [
                  612.163,
                  793.067,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              72.163,
              -146.933,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.843,
                    0.843,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 5,
                "s": [
                  0,
                  0,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.178,
                    0.178,
                    0
                  ]
                },
                "t": 6,
                "s": [
                  16.629,
                  16.629,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 7,
                "s": [
                  31.305,
                  31.305,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.845,
                    0.845,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 8,
                "s": [
                  44.148,
                  44.148,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.846,
                    0.846,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.181,
                    0.181,
                    0
                  ]
                },
                "t": 9,
                "s": [
                  55.282,
                  55.282,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.847,
                    0.847,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.182,
                    0.182,
                    0
                  ]
                },
                "t": 10,
                "s": [
                  64.828,
                  64.828,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.848,
                    0.848,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.183,
                    0.183,
                    0
                  ]
                },
                "t": 11,
                "s": [
                  72.909,
                  72.909,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.85,
                    0.85,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.185,
                    0.185,
                    0
                  ]
                },
                "t": 12,
                "s": [
                  79.646,
                  79.646,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.852,
                    0.852,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.187,
                    0.187,
                    0
                  ]
                },
                "t": 13,
                "s": [
                  85.162,
                  85.162,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.854,
                    0.854,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.19,
                    0.19,
                    0
                  ]
                },
                "t": 14,
                "s": [
                  89.579,
                  89.579,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.194,
                    0.194,
                    0
                  ]
                },
                "t": 15,
                "s": [
                  93.019,
                  93.019,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.861,
                    0.861,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 16,
                "s": [
                  95.604,
                  95.604,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.866,
                    0.866,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.208,
                    0.208,
                    0
                  ]
                },
                "t": 17,
                "s": [
                  97.456,
                  97.456,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.221,
                    0.221,
                    0
                  ]
                },
                "t": 18,
                "s": [
                  98.697,
                  98.697,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.886,
                    0.886,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.246,
                    0.246,
                    0
                  ]
                },
                "t": 19,
                "s": [
                  99.45,
                  99.45,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.905,
                    0.905,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.31,
                    0.31,
                    0
                  ]
                },
                "t": 20,
                "s": [
                  99.837,
                  99.837,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.917,
                    0.917,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.667,
                    0.667,
                    0
                  ]
                },
                "t": 21,
                "s": [
                  99.98,
                  99.98,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.002,
                    0.002,
                    0
                  ]
                },
                "t": 22,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 23,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 24,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 25,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 26,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 27,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 28,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 29,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 30,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 31,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 32,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 33,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 34,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 35,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 36,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 37,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 38,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 39,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 40,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 41,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 42,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 43,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 44,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 45,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 46,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 47,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 48,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 49,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 50,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 51,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 52,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 53,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 54,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 55,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 56,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 141,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 142,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 143,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 144,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 145,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 146,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 147,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 148,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 149,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 150,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 151,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 152,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 153,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 154,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 155,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 156,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 157,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 158,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 159,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 160,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 161,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 162,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 163,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.001,
                    1.001,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 164,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.333,
                    0.333,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.083,
                    0.083,
                    0
                  ]
                },
                "t": 165,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.69,
                    0.69,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.095,
                    0.095,
                    0
                  ]
                },
                "t": 166,
                "s": [
                  99.987,
                  99.987,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.754,
                    0.754,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.114,
                    0.114,
                    0
                  ]
                },
                "t": 167,
                "s": [
                  99.9,
                  99.9,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.779,
                    0.779,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.126,
                    0.126,
                    0
                  ]
                },
                "t": 168,
                "s": [
                  99.662,
                  99.662,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.792,
                    0.792,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.134,
                    0.134,
                    0
                  ]
                },
                "t": 169,
                "s": [
                  99.2,
                  99.2,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.8,
                    0.8,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.139,
                    0.139,
                    0
                  ]
                },
                "t": 170,
                "s": [
                  98.437,
                  98.437,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.806,
                    0.806,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.143,
                    0.143,
                    0
                  ]
                },
                "t": 171,
                "s": [
                  97.3,
                  97.3,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.81,
                    0.81,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.146,
                    0.146,
                    0
                  ]
                },
                "t": 172,
                "s": [
                  95.712,
                  95.712,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.813,
                    0.813,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.148,
                    0.148,
                    0
                  ]
                },
                "t": 173,
                "s": [
                  93.6,
                  93.6,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.815,
                    0.815,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.15,
                    0.15,
                    0
                  ]
                },
                "t": 174,
                "s": [
                  90.888,
                  90.888,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.817,
                    0.817,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.152,
                    0.152,
                    0
                  ]
                },
                "t": 175,
                "s": [
                  87.5,
                  87.5,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.818,
                    0.818,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.153,
                    0.153,
                    0
                  ]
                },
                "t": 176,
                "s": [
                  83.362,
                  83.362,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.154,
                    0.154,
                    0
                  ]
                },
                "t": 177,
                "s": [
                  78.4,
                  78.4,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.821,
                    0.821,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 178,
                "s": [
                  72.537,
                  72.537,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.821,
                    0.821,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.156,
                    0.156,
                    0
                  ]
                },
                "t": 179,
                "s": [
                  65.7,
                  65.7,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.822,
                    0.822,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.156,
                    0.156,
                    0
                  ]
                },
                "t": 180,
                "s": [
                  57.813,
                  57.813,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.823,
                    0.823,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.157,
                    0.157,
                    0
                  ]
                },
                "t": 181,
                "s": [
                  48.8,
                  48.8,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.824,
                    0.824,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.157,
                    0.157,
                    0
                  ]
                },
                "t": 182,
                "s": [
                  38.587,
                  38.587,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.824,
                    0.824,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.158,
                    0.158,
                    0
                  ]
                },
                "t": 183,
                "s": [
                  27.1,
                  27.1,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.158,
                    0.158,
                    0
                  ]
                },
                "t": 184,
                "s": [
                  14.262,
                  14.262,
                  100
                ]
              },
              {
                "t": 185.000007535204,
                "s": [
                  0,
                  0,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "AC IN [GLA] Controls",
            "np": 5,
            "mn": "Pseudo/MHAC PrCtrl GLA 3",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    -75,
                    400
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": -90
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0003",
                "ix": 3,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "AC OUT [GLA] 2 Controls",
            "np": 5,
            "mn": "Pseudo/MHAC PrCtrl GLA 3",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    0,
                    400
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": -90
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0003",
                "ix": 3,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -13.765
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        13.765
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        13.765
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -13.765
                      ]
                    ],
                    "v": [
                      [
                        -107.823,
                        -270.02
                      ],
                      [
                        252.15,
                        -270.02
                      ],
                      [
                        277.074,
                        -245.096
                      ],
                      [
                        277.074,
                        -95.66
                      ],
                      [
                        252.15,
                        -70.736
                      ],
                      [
                        -35.414,
                        -70.736
                      ],
                      [
                        -70.383,
                        -23.846
                      ],
                      [
                        -65.918,
                        -70.736
                      ],
                      [
                        -107.823,
                        -70.736
                      ],
                      [
                        -132.747,
                        -95.66
                      ],
                      [
                        -132.747,
                        -245.096
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.670588254929,
                    0.803921580315,
                    0.960784316063,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 5.00000020365417,
        "op": 186.000007575935,
        "st": -5.00000020365417,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 15,
        "ty": 4,
        "nm": "Shape Layer 6",
        "parent": 23,
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 149.875,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 159.125,
                "s": [
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 164.521,
                "s": [
                  100
                ]
              },
              {
                "t": 173.000007046434,
                "s": [
                  0
                ]
              }
            ]
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              53.398,
              1,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              -100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "d": 1,
                "ty": "el",
                "s": {
                  "a": 0,
                  "k": [
                    29,
                    29
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "nm": "Ellipse Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    90.5,
                    -207
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Ellipse 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 146.000005946702,
        "op": 187.000007616666,
        "st": 64.0000026067734,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 16,
        "ty": 4,
        "nm": "Shape Layer 5",
        "parent": 23,
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 142.938,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 152.188,
                "s": [
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 157.584,
                "s": [
                  100
                ]
              },
              {
                "t": 166.062506763864,
                "s": [
                  0
                ]
              }
            ]
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              111.898,
              1,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              -100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "d": 1,
                "ty": "el",
                "s": {
                  "a": 0,
                  "k": [
                    29,
                    29
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "nm": "Ellipse Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    90.5,
                    -207
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Ellipse 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 137.000005580124,
        "op": 178.000007250089,
        "st": 55.0000022401959,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 17,
        "ty": 4,
        "nm": "Shape Layer 4",
        "parent": 23,
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 136,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 145.25,
                "s": [
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 150.646,
                "s": [
                  100
                ]
              },
              {
                "t": 159.125006481294,
                "s": [
                  0
                ]
              }
            ]
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              167.398,
              1,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              -100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "d": 1,
                "ty": "el",
                "s": {
                  "a": 0,
                  "k": [
                    29,
                    29
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "nm": "Ellipse Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    90.5,
                    -207
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Ellipse 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 128.000005213547,
        "op": 169.000006883511,
        "st": 46.0000018736184,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 18,
        "ty": 0,
        "nm": "TEXT",
        "parent": 23,
        "refId": "comp_1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              -125.102,
              -141.5,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              540,
              540,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              -100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "w": 1080,
        "h": 1080,
        "ip": 162.000006598395,
        "op": 246.000010019785,
        "st": 162.000006598395,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 19,
        "ty": 0,
        "nm": "TEXT",
        "parent": 23,
        "refId": "comp_1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              -125.102,
              -141.5,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              540,
              540,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              -100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "w": 1080,
        "h": 1080,
        "ip": 55.0000022401959,
        "op": 139.000005661586,
        "st": 55.0000022401959,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 20,
        "ty": 4,
        "nm": "Layer 26",
        "parent": 23,
        "td": 1,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              210.854,
              -204.294,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.845,
                    0.845,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  0,
                  0,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.85,
                    0.85,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.18,
                    0.18,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  -26.796,
                  26.796,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.854,
                    0.854,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.187,
                    0.187,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  -49.945,
                  49.945,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.858,
                    0.858,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.194,
                    0.194,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  -68.53,
                  68.53,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.862,
                    0.862,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.202,
                    0.202,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  -82.517,
                  82.517,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.867,
                    0.867,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.211,
                    0.211,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  -92.38,
                  92.38,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.875,
                    0.875,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.224,
                    0.224,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  -98.83,
                  98.83,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.89,
                    0.89,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.251,
                    0.251,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  -102.639,
                  102.639,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.946,
                    0.946,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.348,
                    0.348,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  -104.533,
                  104.533,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.659,
                    0.659,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.154,
                    -0.154,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  -105.129,
                  105.129,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.81,
                    0.81,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  -104.92,
                  104.92,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.832,
                    0.832,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.148,
                    0.148,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  -104.273,
                  104.273,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.841,
                    0.841,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.165,
                    0.165,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  -103.446,
                  103.446,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.847,
                    0.847,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.176,
                    0.176,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  -102.605,
                  102.605,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.852,
                    0.852,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.184,
                    0.184,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  -101.845,
                  101.845,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.856,
                    0.856,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.191,
                    0.191,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  -101.213,
                  101.213,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.86,
                    0.86,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.198,
                    0.198,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  -100.722,
                  100.722,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.206,
                    0.206,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  -100.365,
                  100.365,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.871,
                    0.871,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.217,
                    0.217,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  -100.121,
                  100.121,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.911,
                    0.911,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.235,
                    0.235,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  -99.969,
                  99.969,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.33,
                    1.33,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    1.342,
                    1.342,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  -99.886,
                  99.886,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.806,
                    0.806,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.067,
                    0.067,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  -99.88,
                  99.88,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.842,
                    0.842,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.146,
                    0.146,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  -99.908,
                  99.908,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.176,
                    0.176,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  -99.944,
                  99.944,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.917,
                    0.917,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  -99.977,
                  99.977,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.002,
                    0.002,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 141,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 142,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 143,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 144,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 145,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 146,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 147,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 148,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 149,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 150,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 151,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 152,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 153,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 154,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 155,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 156,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 157,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 158,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 159,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 160,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 161,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 162,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 163,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 164,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 165,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 166,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 167,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 168,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 169,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 170,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 171,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 172,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 173,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 174,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 175,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 176,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 177,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 178,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 179,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 180,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 181,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 182,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 183,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 184,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 185,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 186,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 187,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 188,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 189,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 190,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 191,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 192,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 193,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 194,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 195,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 196,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 197,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 198,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 199,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 200,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 201,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 202,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 203,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 204,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 205,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 206,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 207,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 208,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 209,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 210,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 211,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.998,
                    1.002,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 212,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.083,
                    0.083,
                    0
                  ]
                },
                "t": 213,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.457,
                    1.457,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.316,
                    0.316,
                    0
                  ]
                },
                "t": 214,
                "s": [
                  -99.976,
                  99.976,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.66,
                    0.66,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.07,
                    0.07,
                    0
                  ]
                },
                "t": 215,
                "s": [
                  -99.967,
                  99.967,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.802,
                    0.802,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 216,
                "s": [
                  -100.023,
                  100.023,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.86,
                    0.86,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 217,
                "s": [
                  -100.194,
                  100.194,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.936,
                    0.936,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.205,
                    0.205,
                    0
                  ]
                },
                "t": 218,
                "s": [
                  -100.429,
                  100.429,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.03,
                    0.03,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.284,
                    -0.284,
                    0
                  ]
                },
                "t": 219,
                "s": [
                  -100.59,
                  100.59,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.739,
                    0.739,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.091,
                    0.091,
                    0
                  ]
                },
                "t": 220,
                "s": [
                  -100.554,
                  100.554,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.798,
                    0.798,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.122,
                    0.122,
                    0
                  ]
                },
                "t": 221,
                "s": [
                  -100.165,
                  100.165,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.834,
                    0.834,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.142,
                    0.142,
                    0
                  ]
                },
                "t": 222,
                "s": [
                  -99.336,
                  99.336,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.883,
                    0.883,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.168,
                    0.168,
                    0
                  ]
                },
                "t": 223,
                "s": [
                  -98.152,
                  98.152,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.115,
                    1.115,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.29,
                    0.29,
                    0
                  ]
                },
                "t": 224,
                "s": [
                  -96.98,
                  96.98,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.658,
                    0.658,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.048,
                    0.048,
                    0
                  ]
                },
                "t": 225,
                "s": [
                  -96.508,
                  96.508,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.775,
                    0.775,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 226,
                "s": [
                  -97.63,
                  97.63,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.816,
                    0.816,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.132,
                    0.132,
                    0
                  ]
                },
                "t": 227,
                "s": [
                  -101.116,
                  101.116,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.855,
                    0.855,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.153,
                    0.153,
                    0
                  ]
                },
                "t": 228,
                "s": [
                  -107.061,
                  107.061,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.936,
                    0.936,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.195,
                    0.195,
                    0
                  ]
                },
                "t": 229,
                "s": [
                  -114.221,
                  114.221,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.03,
                    0.03,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.284,
                    -0.284,
                    0
                  ]
                },
                "t": 230,
                "s": [
                  -119.549,
                  119.549,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.739,
                    0.739,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.091,
                    0.091,
                    0
                  ]
                },
                "t": 231,
                "s": [
                  -118.34,
                  118.34,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.798,
                    0.798,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.122,
                    0.122,
                    0
                  ]
                },
                "t": 232,
                "s": [
                  -105.479,
                  105.479,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.834,
                    0.834,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.142,
                    0.142,
                    0
                  ]
                },
                "t": 233,
                "s": [
                  -78.016,
                  78.016,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.168,
                    0.168,
                    0
                  ]
                },
                "t": 234,
                "s": [
                  -38.801,
                  38.801,
                  100
                ]
              },
              {
                "t": 235.000009571746,
                "s": [
                  0,
                  0,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "AC IN [NWX] Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl NWX 4",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Number of bounces",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 1
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "AC OUT [NWX] 2 Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl NWX 4",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Number of bounces",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 2
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "d": 1,
                "ty": "el",
                "s": {
                  "a": 0,
                  "k": [
                    115.35,
                    115.35
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "nm": "Ellipse Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.996078431606,
                    0.996078431606,
                    0.996078431606,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 57.0000023216576,
        "op": 236.000009612477,
        "st": 42.0000017106951,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 21,
        "ty": 4,
        "nm": "Layer 7",
        "parent": 23,
        "tt": 1,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.839
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 48,
                "s": [
                  -90
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.839
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.173
                  ]
                },
                "t": 49,
                "s": [
                  -81.007
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.84
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.173
                  ]
                },
                "t": 50,
                "s": [
                  -72.634
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.84
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.173
                  ]
                },
                "t": 51,
                "s": [
                  -64.859
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.84
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.174
                  ]
                },
                "t": 52,
                "s": [
                  -57.659
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.84
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.174
                  ]
                },
                "t": 53,
                "s": [
                  -51.013
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.841
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.174
                  ]
                },
                "t": 54,
                "s": [
                  -44.899
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.841
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.175
                  ]
                },
                "t": 55,
                "s": [
                  -39.293
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.841
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.175
                  ]
                },
                "t": 56,
                "s": [
                  -34.175
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.842
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.175
                  ]
                },
                "t": 57,
                "s": [
                  -29.522
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.842
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.176
                  ]
                },
                "t": 58,
                "s": [
                  -25.311
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.843
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.176
                  ]
                },
                "t": 59,
                "s": [
                  -21.521
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.843
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.177
                  ]
                },
                "t": 60,
                "s": [
                  -18.13
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.844
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.178
                  ]
                },
                "t": 61,
                "s": [
                  -15.115
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.844
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.179
                  ]
                },
                "t": 62,
                "s": [
                  -12.454
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.845
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.179
                  ]
                },
                "t": 63,
                "s": [
                  -10.126
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.846
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.181
                  ]
                },
                "t": 64,
                "s": [
                  -8.107
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.847
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.182
                  ]
                },
                "t": 65,
                "s": [
                  -6.377
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.848
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.183
                  ]
                },
                "t": 66,
                "s": [
                  -4.912
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.85
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.185
                  ]
                },
                "t": 67,
                "s": [
                  -3.69
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.852
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.187
                  ]
                },
                "t": 68,
                "s": [
                  -2.69
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.854
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.19
                  ]
                },
                "t": 69,
                "s": [
                  -1.889
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.857
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.194
                  ]
                },
                "t": 70,
                "s": [
                  -1.266
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.861
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.2
                  ]
                },
                "t": 71,
                "s": [
                  -0.797
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.866
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.208
                  ]
                },
                "t": 72,
                "s": [
                  -0.461
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.874
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.221
                  ]
                },
                "t": 73,
                "s": [
                  -0.236
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.886
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.246
                  ]
                },
                "t": 74,
                "s": [
                  -0.1
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.905
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.31
                  ]
                },
                "t": 75,
                "s": [
                  -0.03
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.917
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.667
                  ]
                },
                "t": 76,
                "s": [
                  -0.004
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 77,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 78,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 79,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 80,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 81,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 82,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 83,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 84,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 85,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 86,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 87,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 88,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 89,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 90,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 91,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 92,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 93,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 94,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 95,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 96,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 97,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 98,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 99,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 100,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 101,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 102,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 103,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 104,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 105,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 106,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 107,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 108,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 109,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 110,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 111,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 112,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 113,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 114,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 115,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 116,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 117,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 118,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 119,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 120,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 121,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 122,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 123,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 124,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 125,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 126,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 127,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 128,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 129,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 130,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 131,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 132,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 133,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 134,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 135,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 136,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 137,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 138,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 139,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 140,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 141,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 142,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 143,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 144,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 145,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 146,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 147,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 148,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 149,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 150,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 151,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 152,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 153,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 154,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 155,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 156,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 157,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 158,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 159,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 160,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 161,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 162,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 163,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 164,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 165,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 166,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 167,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 168,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 169,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 170,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 171,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 172,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 173,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 174,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 175,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 176,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 177,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 178,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 179,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 180,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 181,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 182,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 183,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 184,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 185,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 186,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 187,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 188,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 189,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 190,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 191,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 192,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 193,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 194,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 195,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 196,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 197,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 198,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 199,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 200,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 201,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 202,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 203,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 204,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 205,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 206,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 207,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 208,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 209,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 210,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 211,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 212,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 213,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 214,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 215,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1.001
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 216,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.333
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.083
                  ]
                },
                "t": 217,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.69
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.095
                  ]
                },
                "t": 218,
                "s": [
                  -0.011
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.754
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.114
                  ]
                },
                "t": 219,
                "s": [
                  -0.09
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.779
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.126
                  ]
                },
                "t": 220,
                "s": [
                  -0.304
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.792
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.134
                  ]
                },
                "t": 221,
                "s": [
                  -0.72
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.8
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.139
                  ]
                },
                "t": 222,
                "s": [
                  -1.406
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.806
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.143
                  ]
                },
                "t": 223,
                "s": [
                  -2.43
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.81
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.146
                  ]
                },
                "t": 224,
                "s": [
                  -3.859
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.813
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.148
                  ]
                },
                "t": 225,
                "s": [
                  -5.76
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.815
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.15
                  ]
                },
                "t": 226,
                "s": [
                  -8.201
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.817
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.152
                  ]
                },
                "t": 227,
                "s": [
                  -11.25
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.818
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.153
                  ]
                },
                "t": 228,
                "s": [
                  -14.974
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.819
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.154
                  ]
                },
                "t": 229,
                "s": [
                  -19.44
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.821
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.155
                  ]
                },
                "t": 230,
                "s": [
                  -24.716
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.821
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 231,
                "s": [
                  -30.87
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.822
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 232,
                "s": [
                  -37.969
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.823
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.157
                  ]
                },
                "t": 233,
                "s": [
                  -46.08
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.157
                  ]
                },
                "t": 234,
                "s": [
                  -55.271
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 235,
                "s": [
                  -65.61
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 236,
                "s": [
                  -77.164
                ]
              },
              {
                "t": 237.000009653208,
                "s": [
                  -90
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.833,
                  "y": 0.839
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 48,
                "s": [
                  -2284.229,
                  -210.251,
                  0
                ],
                "to": [
                  41.634,
                  0,
                  0
                ],
                "ti": [
                  -80.398,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.839
                },
                "o": {
                  "x": 0.167,
                  "y": 0.173
                },
                "t": 49,
                "s": [
                  -2034.424,
                  -210.251,
                  0
                ],
                "to": [
                  80.398,
                  0,
                  0
                ],
                "ti": [
                  -74.76,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.173
                },
                "t": 50,
                "s": [
                  -1801.839,
                  -210.251,
                  0
                ],
                "to": [
                  74.76,
                  0,
                  0
                ],
                "ti": [
                  -69.328,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.173
                },
                "t": 51,
                "s": [
                  -1585.861,
                  -210.251,
                  0
                ],
                "to": [
                  69.328,
                  0,
                  0
                ],
                "ti": [
                  -64.1,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 52,
                "s": [
                  -1385.873,
                  -210.251,
                  0
                ],
                "to": [
                  64.1,
                  0,
                  0
                ],
                "ti": [
                  -59.077,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 53,
                "s": [
                  -1201.261,
                  -210.251,
                  0
                ],
                "to": [
                  59.077,
                  0,
                  0
                ],
                "ti": [
                  -54.259,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.841
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 54,
                "s": [
                  -1031.41,
                  -210.251,
                  0
                ],
                "to": [
                  54.259,
                  0,
                  0
                ],
                "ti": [
                  -49.647,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.841
                },
                "o": {
                  "x": 0.167,
                  "y": 0.175
                },
                "t": 55,
                "s": [
                  -875.704,
                  -210.251,
                  0
                ],
                "to": [
                  49.647,
                  0,
                  0
                ],
                "ti": [
                  -45.239,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.841
                },
                "o": {
                  "x": 0.167,
                  "y": 0.175
                },
                "t": 56,
                "s": [
                  -733.53,
                  -210.251,
                  0
                ],
                "to": [
                  45.239,
                  0,
                  0
                ],
                "ti": [
                  -41.036,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.842
                },
                "o": {
                  "x": 0.167,
                  "y": 0.175
                },
                "t": 57,
                "s": [
                  -604.271,
                  -210.251,
                  0
                ],
                "to": [
                  41.036,
                  0,
                  0
                ],
                "ti": [
                  -37.039,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.842
                },
                "o": {
                  "x": 0.167,
                  "y": 0.176
                },
                "t": 58,
                "s": [
                  -487.312,
                  -210.251,
                  0
                ],
                "to": [
                  37.039,
                  0,
                  0
                ],
                "ti": [
                  -33.246,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.843
                },
                "o": {
                  "x": 0.167,
                  "y": 0.176
                },
                "t": 59,
                "s": [
                  -382.039,
                  -210.251,
                  0
                ],
                "to": [
                  33.246,
                  0,
                  0
                ],
                "ti": [
                  -29.658,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.843
                },
                "o": {
                  "x": 0.167,
                  "y": 0.177
                },
                "t": 60,
                "s": [
                  -287.837,
                  -210.251,
                  0
                ],
                "to": [
                  29.658,
                  0,
                  0
                ],
                "ti": [
                  -26.276,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.844
                },
                "o": {
                  "x": 0.167,
                  "y": 0.178
                },
                "t": 61,
                "s": [
                  -204.09,
                  -210.251,
                  0
                ],
                "to": [
                  26.276,
                  0,
                  0
                ],
                "ti": [
                  -23.098,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.844
                },
                "o": {
                  "x": 0.167,
                  "y": 0.179
                },
                "t": 62,
                "s": [
                  -130.184,
                  -210.251,
                  0
                ],
                "to": [
                  23.098,
                  0,
                  0
                ],
                "ti": [
                  -20.125,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.845
                },
                "o": {
                  "x": 0.167,
                  "y": 0.179
                },
                "t": 63,
                "s": [
                  -65.503,
                  -210.251,
                  0
                ],
                "to": [
                  20.125,
                  0,
                  0
                ],
                "ti": [
                  -17.358,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.846
                },
                "o": {
                  "x": 0.167,
                  "y": 0.181
                },
                "t": 64,
                "s": [
                  -9.433,
                  -210.251,
                  0
                ],
                "to": [
                  17.358,
                  0,
                  0
                ],
                "ti": [
                  -14.795,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 65,
                "s": [
                  38.642,
                  -210.251,
                  0
                ],
                "to": [
                  14.795,
                  0,
                  0
                ],
                "ti": [
                  -12.437,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.848
                },
                "o": {
                  "x": 0.167,
                  "y": 0.183
                },
                "t": 66,
                "s": [
                  79.337,
                  -210.251,
                  0
                ],
                "to": [
                  12.437,
                  0,
                  0
                ],
                "ti": [
                  -10.285,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.185
                },
                "t": 67,
                "s": [
                  113.266,
                  -210.251,
                  0
                ],
                "to": [
                  10.285,
                  0,
                  0
                ],
                "ti": [
                  -8.337,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.852
                },
                "o": {
                  "x": 0.167,
                  "y": 0.187
                },
                "t": 68,
                "s": [
                  141.045,
                  -210.251,
                  0
                ],
                "to": [
                  8.337,
                  0,
                  0
                ],
                "ti": [
                  -6.595,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.854
                },
                "o": {
                  "x": 0.167,
                  "y": 0.19
                },
                "t": 69,
                "s": [
                  163.289,
                  -210.251,
                  0
                ],
                "to": [
                  6.595,
                  0,
                  0
                ],
                "ti": [
                  -5.057,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.857
                },
                "o": {
                  "x": 0.167,
                  "y": 0.194
                },
                "t": 70,
                "s": [
                  180.612,
                  -210.251,
                  0
                ],
                "to": [
                  5.057,
                  0,
                  0
                ],
                "ti": [
                  -3.724,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.861
                },
                "o": {
                  "x": 0.167,
                  "y": 0.2
                },
                "t": 71,
                "s": [
                  193.63,
                  -210.251,
                  0
                ],
                "to": [
                  3.724,
                  0,
                  0
                ],
                "ti": [
                  -2.597,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.866
                },
                "o": {
                  "x": 0.167,
                  "y": 0.208
                },
                "t": 72,
                "s": [
                  202.958,
                  -210.251,
                  0
                ],
                "to": [
                  2.597,
                  0,
                  0
                ],
                "ti": [
                  -1.674,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.874
                },
                "o": {
                  "x": 0.167,
                  "y": 0.221
                },
                "t": 73,
                "s": [
                  209.211,
                  -210.251,
                  0
                ],
                "to": [
                  1.674,
                  0,
                  0
                ],
                "ti": [
                  -0.957,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.886
                },
                "o": {
                  "x": 0.167,
                  "y": 0.246
                },
                "t": 74,
                "s": [
                  213.004,
                  -210.251,
                  0
                ],
                "to": [
                  0.957,
                  0,
                  0
                ],
                "ti": [
                  -0.444,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.905
                },
                "o": {
                  "x": 0.167,
                  "y": 0.31
                },
                "t": 75,
                "s": [
                  214.951,
                  -210.251,
                  0
                ],
                "to": [
                  0.444,
                  0,
                  0
                ],
                "ti": [
                  -0.137,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.917
                },
                "o": {
                  "x": 0.167,
                  "y": 0.663
                },
                "t": 76,
                "s": [
                  215.669,
                  -210.251,
                  0
                ],
                "to": [
                  0.137,
                  0,
                  0
                ],
                "ti": [
                  -0.017,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 77,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 78,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 79,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 80,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 81,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 82,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 83,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 84,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 85,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 86,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 87,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 88,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 89,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 90,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 91,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 92,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 93,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 94,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 95,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 96,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 97,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 98,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 99,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 100,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 101,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 102,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 103,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 104,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 105,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 106,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 107,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 108,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 109,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 110,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 111,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 112,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 113,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 114,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 115,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 116,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 117,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 118,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 119,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 120,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 121,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 122,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 123,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 124,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 125,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 126,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 127,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 128,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 129,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 130,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 131,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 132,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 133,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 134,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 135,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 136,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 137,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 138,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 139,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 140,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 141,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 142,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 143,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 144,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 145,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 146,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 147,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 148,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 149,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 150,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 151,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 152,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 153,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 154,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 155,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 156,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 157,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 158,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 159,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 160,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 161,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 162,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 163,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 164,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 165,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 166,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 167,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 168,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 169,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 170,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 171,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 172,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 173,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 174,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 175,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 176,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 177,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 178,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 179,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 180,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 181,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 182,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 183,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 184,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 185,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 186,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 187,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 188,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 189,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 190,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 191,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 192,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 193,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 194,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 195,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 196,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 197,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 198,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 199,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 200,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 201,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 202,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 203,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 204,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 205,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 206,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 207,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 208,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 209,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 210,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 211,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 212,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 213,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 214,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 215,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 216,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.337
                },
                "o": {
                  "x": 0.167,
                  "y": 0.083
                },
                "t": 217,
                "s": [
                  215.771,
                  -210.251,
                  0
                ],
                "to": [
                  -0.052,
                  0,
                  0
                ],
                "ti": [
                  0.417,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.69
                },
                "o": {
                  "x": 0.167,
                  "y": 0.095
                },
                "t": 218,
                "s": [
                  215.459,
                  -210.251,
                  0
                ],
                "to": [
                  -0.417,
                  0,
                  0
                ],
                "ti": [
                  1.354,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.754
                },
                "o": {
                  "x": 0.167,
                  "y": 0.114
                },
                "t": 219,
                "s": [
                  213.271,
                  -210.251,
                  0
                ],
                "to": [
                  -1.354,
                  0,
                  0
                ],
                "ti": [
                  2.917,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.779
                },
                "o": {
                  "x": 0.167,
                  "y": 0.126
                },
                "t": 220,
                "s": [
                  207.334,
                  -210.251,
                  0
                ],
                "to": [
                  -2.917,
                  0,
                  0
                ],
                "ti": [
                  5.104,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.792
                },
                "o": {
                  "x": 0.167,
                  "y": 0.134
                },
                "t": 221,
                "s": [
                  195.771,
                  -210.251,
                  0
                ],
                "to": [
                  -5.104,
                  0,
                  0
                ],
                "ti": [
                  7.917,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.8
                },
                "o": {
                  "x": 0.167,
                  "y": 0.139
                },
                "t": 222,
                "s": [
                  176.709,
                  -210.251,
                  0
                ],
                "to": [
                  -7.917,
                  0,
                  0
                ],
                "ti": [
                  11.354,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.806
                },
                "o": {
                  "x": 0.167,
                  "y": 0.143
                },
                "t": 223,
                "s": [
                  148.271,
                  -210.251,
                  0
                ],
                "to": [
                  -11.354,
                  0,
                  0
                ],
                "ti": [
                  15.417,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.81
                },
                "o": {
                  "x": 0.167,
                  "y": 0.146
                },
                "t": 224,
                "s": [
                  108.584,
                  -210.251,
                  0
                ],
                "to": [
                  -15.417,
                  0,
                  0
                ],
                "ti": [
                  20.104,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.813
                },
                "o": {
                  "x": 0.167,
                  "y": 0.148
                },
                "t": 225,
                "s": [
                  55.771,
                  -210.251,
                  0
                ],
                "to": [
                  -20.104,
                  0,
                  0
                ],
                "ti": [
                  25.417,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.815
                },
                "o": {
                  "x": 0.167,
                  "y": 0.15
                },
                "t": 226,
                "s": [
                  -12.041,
                  -210.251,
                  0
                ],
                "to": [
                  -25.417,
                  0,
                  0
                ],
                "ti": [
                  31.354,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.817
                },
                "o": {
                  "x": 0.167,
                  "y": 0.152
                },
                "t": 227,
                "s": [
                  -96.729,
                  -210.251,
                  0
                ],
                "to": [
                  -31.354,
                  0,
                  0
                ],
                "ti": [
                  37.917,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.818
                },
                "o": {
                  "x": 0.167,
                  "y": 0.153
                },
                "t": 228,
                "s": [
                  -200.166,
                  -210.251,
                  0
                ],
                "to": [
                  -37.917,
                  0,
                  0
                ],
                "ti": [
                  45.104,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.819
                },
                "o": {
                  "x": 0.167,
                  "y": 0.154
                },
                "t": 229,
                "s": [
                  -324.229,
                  -210.251,
                  0
                ],
                "to": [
                  -45.104,
                  0,
                  0
                ],
                "ti": [
                  52.917,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.821
                },
                "o": {
                  "x": 0.167,
                  "y": 0.155
                },
                "t": 230,
                "s": [
                  -470.791,
                  -210.251,
                  0
                ],
                "to": [
                  -52.917,
                  0,
                  0
                ],
                "ti": [
                  61.354,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.821
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 231,
                "s": [
                  -641.729,
                  -210.251,
                  0
                ],
                "to": [
                  -61.354,
                  0,
                  0
                ],
                "ti": [
                  70.417,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.822
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 232,
                "s": [
                  -838.916,
                  -210.251,
                  0
                ],
                "to": [
                  -70.417,
                  0,
                  0
                ],
                "ti": [
                  80.104,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 233,
                "s": [
                  -1064.229,
                  -210.251,
                  0
                ],
                "to": [
                  -80.104,
                  0,
                  0
                ],
                "ti": [
                  90.417,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 234,
                "s": [
                  -1319.541,
                  -210.251,
                  0
                ],
                "to": [
                  -90.417,
                  0,
                  0
                ],
                "ti": [
                  101.354,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 235,
                "s": [
                  -1606.729,
                  -210.251,
                  0
                ],
                "to": [
                  -101.354,
                  0,
                  0
                ],
                "ti": [
                  112.917,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 236,
                "s": [
                  -1927.666,
                  -210.251,
                  0
                ],
                "to": [
                  -112.917,
                  0,
                  0
                ],
                "ti": [
                  59.427,
                  0,
                  0
                ]
              },
              {
                "t": 237.000009653208,
                "s": [
                  -2284.229,
                  -210.251,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              -202.373,
              107.749,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              -100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "AC IN [ZBS] Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl ZBS 3",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl ZBS 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    -2500,
                    0
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl ZBS 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": -90
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "AC OUT [ZBS] 2 Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl ZBS 3",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl ZBS 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    -2500,
                    0
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl ZBS 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": -90
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        12.66,
                        -5.627
                      ],
                      [
                        -2.345,
                        0.469
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.407,
                        -0.469
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -219.026,
                        79.945
                      ],
                      [
                        -218.088,
                        81.351
                      ],
                      [
                        -204.021,
                        76.194
                      ],
                      [
                        -204.958,
                        75.256
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.329411774874,
                    0.749019622803,
                    0.192156866193,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        36.106,
                        -5.158
                      ],
                      [
                        0.805,
                        -0.151
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.543,
                        -0.509
                      ],
                      [
                        1,
                        -12
                      ],
                      [
                        1.583,
                        -1.93
                      ],
                      [
                        -9.378,
                        4.689
                      ],
                      [
                        -2.462,
                        -0.592
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -0.856,
                        0.122
                      ],
                      [
                        -1.937,
                        -13.696
                      ],
                      [
                        -6.322,
                        -1.827
                      ],
                      [
                        -5,
                        1
                      ],
                      [
                        -1,
                        5
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        4.705,
                        -2.353
                      ],
                      [
                        -16.692,
                        10.715
                      ],
                      [
                        21.335,
                        -4.923
                      ],
                      [
                        0,
                        6.096
                      ],
                      [
                        15.474,
                        -2.813
                      ],
                      [
                        9.847,
                        7.971
                      ],
                      [
                        3.751,
                        -6.565
                      ]
                    ],
                    "v": [
                      [
                        -202.145,
                        75.256
                      ],
                      [
                        -204.628,
                        75.671
                      ],
                      [
                        -215.509,
                        58.61
                      ],
                      [
                        -228,
                        57
                      ],
                      [
                        -242,
                        74
                      ],
                      [
                        -247,
                        82
                      ],
                      [
                        -229.107,
                        82.524
                      ],
                      [
                        -218.297,
                        80.772
                      ],
                      [
                        -228.872,
                        112.299
                      ],
                      [
                        -196.753,
                        94.715
                      ],
                      [
                        -200.973,
                        109.72
                      ],
                      [
                        -176.59,
                        90.964
                      ],
                      [
                        -167.446,
                        112.299
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        9.378,
                        14.067
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -205.896,
                        131.993
                      ],
                      [
                        -187.14,
                        131.993
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.996078431606,
                    0.996078431606,
                    0.996078431606,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -3.282,
                        4.689
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        3.751,
                        3.751
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -204.958,
                        152.156
                      ],
                      [
                        -188.078,
                        152.156
                      ],
                      [
                        -188.078,
                        149.342
                      ],
                      [
                        -204.958,
                        149.342
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    0.603921592236,
                    0.329411774874,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 4",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        3.721,
                        0.772
                      ],
                      [
                        1.282,
                        -0.727
                      ],
                      [
                        16.013,
                        0
                      ],
                      [
                        1.014,
                        -18.846
                      ],
                      [
                        1.476,
                        -0.306
                      ],
                      [
                        -0.988,
                        -4.758
                      ],
                      [
                        -3.721,
                        0.772
                      ],
                      [
                        -0.739,
                        0.652
                      ],
                      [
                        -9.485,
                        -2.988
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -3.269,
                        10.233
                      ],
                      [
                        -0.918,
                        -0.191
                      ],
                      [
                        -0.988,
                        4.758
                      ]
                    ],
                    "o": [
                      [
                        -1.415,
                        -0.294
                      ],
                      [
                        -1.056,
                        -18.797
                      ],
                      [
                        -16.042,
                        0
                      ],
                      [
                        -1.324,
                        -0.799
                      ],
                      [
                        -3.721,
                        0.772
                      ],
                      [
                        0.988,
                        4.758
                      ],
                      [
                        0.977,
                        -0.203
                      ],
                      [
                        3.423,
                        10.831
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        8.798,
                        -3.328
                      ],
                      [
                        0.709,
                        0.591
                      ],
                      [
                        3.721,
                        0.772
                      ],
                      [
                        0.988,
                        -4.758
                      ]
                    ],
                    "v": [
                      [
                        -162.93,
                        111.473
                      ],
                      [
                        -167.054,
                        112.194
                      ],
                      [
                        -197.222,
                        78.538
                      ],
                      [
                        -227.395,
                        112.297
                      ],
                      [
                        -231.684,
                        111.473
                      ],
                      [
                        -236.634,
                        121.486
                      ],
                      [
                        -228.108,
                        128.703
                      ],
                      [
                        -225.523,
                        127.384
                      ],
                      [
                        -204.958,
                        149.552
                      ],
                      [
                        -204.958,
                        158.72
                      ],
                      [
                        -188.078,
                        158.72
                      ],
                      [
                        -188.078,
                        149.065
                      ],
                      [
                        -168.96,
                        127.503
                      ],
                      [
                        -166.507,
                        128.703
                      ],
                      [
                        -157.981,
                        121.486
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    0.768627464771,
                    0.623529434204,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 5",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 48.0000019550801,
        "op": 238.000009693939,
        "st": 42.0000017106951,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 22,
        "ty": 4,
        "nm": "Layer 6",
        "parent": 23,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              210.854,
              -204.294,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.845,
                    0.845,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  0,
                  0,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.85,
                    0.85,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.18,
                    0.18,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  -26.796,
                  26.796,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.854,
                    0.854,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.187,
                    0.187,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  -49.945,
                  49.945,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.858,
                    0.858,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.194,
                    0.194,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  -68.53,
                  68.53,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.862,
                    0.862,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.202,
                    0.202,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  -82.517,
                  82.517,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.867,
                    0.867,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.211,
                    0.211,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  -92.38,
                  92.38,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.875,
                    0.875,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.224,
                    0.224,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  -98.83,
                  98.83,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.89,
                    0.89,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.251,
                    0.251,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  -102.639,
                  102.639,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.946,
                    0.946,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.348,
                    0.348,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  -104.533,
                  104.533,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.659,
                    0.659,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.154,
                    -0.154,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  -105.129,
                  105.129,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.81,
                    0.81,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  -104.92,
                  104.92,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.832,
                    0.832,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.148,
                    0.148,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  -104.273,
                  104.273,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.841,
                    0.841,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.165,
                    0.165,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  -103.446,
                  103.446,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.847,
                    0.847,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.176,
                    0.176,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  -102.605,
                  102.605,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.852,
                    0.852,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.184,
                    0.184,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  -101.845,
                  101.845,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.856,
                    0.856,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.191,
                    0.191,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  -101.213,
                  101.213,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.86,
                    0.86,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.198,
                    0.198,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  -100.722,
                  100.722,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.206,
                    0.206,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  -100.365,
                  100.365,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.871,
                    0.871,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.217,
                    0.217,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  -100.121,
                  100.121,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.911,
                    0.911,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.235,
                    0.235,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  -99.969,
                  99.969,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.33,
                    1.33,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    1.342,
                    1.342,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  -99.886,
                  99.886,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.806,
                    0.806,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.067,
                    0.067,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  -99.88,
                  99.88,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.842,
                    0.842,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.146,
                    0.146,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  -99.908,
                  99.908,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.176,
                    0.176,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  -99.944,
                  99.944,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.917,
                    0.917,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  -99.977,
                  99.977,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.002,
                    0.002,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 141,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 142,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 143,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 144,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 145,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 146,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 147,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 148,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 149,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 150,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 151,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 152,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 153,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 154,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 155,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 156,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 157,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 158,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 159,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 160,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 161,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 162,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 163,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 164,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 165,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 166,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 167,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 168,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 169,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 170,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 171,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 172,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 173,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 174,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 175,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 176,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 177,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 178,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 179,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 180,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 181,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 182,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 183,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 184,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 185,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 186,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 187,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 188,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 189,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 190,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 191,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 192,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 193,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 194,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 195,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 196,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 197,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 198,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 199,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 200,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 201,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 202,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 203,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 204,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 205,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 206,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 207,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 208,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 209,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 210,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 211,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.998,
                    1.002,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 212,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.083,
                    0.083,
                    0
                  ]
                },
                "t": 213,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.457,
                    1.457,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.316,
                    0.316,
                    0
                  ]
                },
                "t": 214,
                "s": [
                  -99.976,
                  99.976,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.66,
                    0.66,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.07,
                    0.07,
                    0
                  ]
                },
                "t": 215,
                "s": [
                  -99.967,
                  99.967,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.802,
                    0.802,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 216,
                "s": [
                  -100.023,
                  100.023,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.86,
                    0.86,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 217,
                "s": [
                  -100.194,
                  100.194,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.936,
                    0.936,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.205,
                    0.205,
                    0
                  ]
                },
                "t": 218,
                "s": [
                  -100.429,
                  100.429,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.03,
                    0.03,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.284,
                    -0.284,
                    0
                  ]
                },
                "t": 219,
                "s": [
                  -100.59,
                  100.59,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.739,
                    0.739,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.091,
                    0.091,
                    0
                  ]
                },
                "t": 220,
                "s": [
                  -100.554,
                  100.554,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.798,
                    0.798,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.122,
                    0.122,
                    0
                  ]
                },
                "t": 221,
                "s": [
                  -100.165,
                  100.165,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.834,
                    0.834,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.142,
                    0.142,
                    0
                  ]
                },
                "t": 222,
                "s": [
                  -99.336,
                  99.336,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.883,
                    0.883,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.168,
                    0.168,
                    0
                  ]
                },
                "t": 223,
                "s": [
                  -98.152,
                  98.152,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.115,
                    1.115,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.29,
                    0.29,
                    0
                  ]
                },
                "t": 224,
                "s": [
                  -96.98,
                  96.98,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.658,
                    0.658,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.048,
                    0.048,
                    0
                  ]
                },
                "t": 225,
                "s": [
                  -96.508,
                  96.508,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.775,
                    0.775,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.11,
                    0.11,
                    0
                  ]
                },
                "t": 226,
                "s": [
                  -97.63,
                  97.63,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.816,
                    0.816,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.132,
                    0.132,
                    0
                  ]
                },
                "t": 227,
                "s": [
                  -101.116,
                  101.116,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.855,
                    0.855,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.153,
                    0.153,
                    0
                  ]
                },
                "t": 228,
                "s": [
                  -107.061,
                  107.061,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.936,
                    0.936,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.195,
                    0.195,
                    0
                  ]
                },
                "t": 229,
                "s": [
                  -114.221,
                  114.221,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.03,
                    0.03,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.284,
                    -0.284,
                    0
                  ]
                },
                "t": 230,
                "s": [
                  -119.549,
                  119.549,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.739,
                    0.739,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.091,
                    0.091,
                    0
                  ]
                },
                "t": 231,
                "s": [
                  -118.34,
                  118.34,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.798,
                    0.798,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.122,
                    0.122,
                    0
                  ]
                },
                "t": 232,
                "s": [
                  -105.479,
                  105.479,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.834,
                    0.834,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.142,
                    0.142,
                    0
                  ]
                },
                "t": 233,
                "s": [
                  -78.016,
                  78.016,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.168,
                    0.168,
                    0
                  ]
                },
                "t": 234,
                "s": [
                  -38.801,
                  38.801,
                  100
                ]
              },
              {
                "t": 235.000009571746,
                "s": [
                  0,
                  0,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "AC IN [NWX] Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl NWX 4",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Number of bounces",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 1
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "AC OUT [NWX] 2 Controls",
            "np": 4,
            "mn": "Pseudo/MHAC PrCtrl NWX 4",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Number of bounces",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 2
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl NWX 4-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "d": 1,
                "ty": "el",
                "s": {
                  "a": 0,
                  "k": [
                    115.35,
                    115.35
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "nm": "Ellipse Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.996078431606,
                    0.996078431606,
                    0.996078431606,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 57.0000023216576,
        "op": 236.000009612477,
        "st": 42.0000017106951,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 23,
        "ty": 4,
        "nm": "Layer 25",
        "sr": 1.11111111111111,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.842
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 49,
                "s": [
                  89.998
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.843
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.177
                  ]
                },
                "t": 50,
                "s": [
                  76.447
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.843
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.177
                  ]
                },
                "t": 51,
                "s": [
                  64.33
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.844
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.178
                  ]
                },
                "t": 52,
                "s": [
                  53.566
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.845
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.179
                  ]
                },
                "t": 53,
                "s": [
                  44.076
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.845
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.18
                  ]
                },
                "t": 54,
                "s": [
                  35.778
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.846
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.181
                  ]
                },
                "t": 55,
                "s": [
                  28.593
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.847
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.182
                  ]
                },
                "t": 56,
                "s": [
                  22.44
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.849
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.183
                  ]
                },
                "t": 57,
                "s": [
                  17.241
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.85
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.185
                  ]
                },
                "t": 58,
                "s": [
                  12.914
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.852
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.188
                  ]
                },
                "t": 59,
                "s": [
                  9.379
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.854
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.191
                  ]
                },
                "t": 60,
                "s": [
                  6.556
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.857
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.195
                  ]
                },
                "t": 61,
                "s": [
                  4.366
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.861
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.2
                  ]
                },
                "t": 62,
                "s": [
                  2.727
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.867
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.209
                  ]
                },
                "t": 63,
                "s": [
                  1.56
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.875
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.223
                  ]
                },
                "t": 64,
                "s": [
                  0.785
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.888
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.25
                  ]
                },
                "t": 65,
                "s": [
                  0.322
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.907
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.323
                  ]
                },
                "t": 66,
                "s": [
                  0.09
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.917
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.8
                  ]
                },
                "t": 67,
                "s": [
                  0.009
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    -0.001
                  ]
                },
                "t": 68,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 69,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 70,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 71,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 72,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 73,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 74,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 75,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 76,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 77,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 78,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 79,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 80,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 81,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 82,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 83,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 84,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 85,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 86,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 87,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 88,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 89,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 90,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 91,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 92,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 93,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 94,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 95,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 96,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 97,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 98,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 99,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 100,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 101,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 102,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 103,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 104,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 105,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 106,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 107,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 108,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 109,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 110,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 111,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 112,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 113,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 114,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 115,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 116,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 117,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 118,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 119,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 120,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 121,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 122,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 123,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 124,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 125,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 126,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 127,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 128,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 129,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 130,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 131,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 132,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 133,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 134,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 135,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 136,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 137,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 138,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 139,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 140,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 141,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 142,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 143,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 144,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 145,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 146,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 147,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 148,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 149,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 150,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 151,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 152,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 153,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 154,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 155,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 156,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 157,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 158,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 159,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 160,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 161,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 162,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 163,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 164,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 165,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 166,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 167,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 168,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 169,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 170,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 171,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 172,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 173,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 174,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 175,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 176,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 177,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 178,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 179,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 180,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 181,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 182,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 183,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 184,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 185,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 186,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 187,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 188,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 189,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 190,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 191,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 192,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 193,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 194,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 195,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 196,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 197,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 198,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 199,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 200,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 201,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 202,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 203,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 204,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 205,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 206,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 207,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 208,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 209,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 210,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 211,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 212,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 213,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 214,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    -4.318
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.083
                  ]
                },
                "t": 215,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.548
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.085
                  ]
                },
                "t": 216,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.72
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.102
                  ]
                },
                "t": 217,
                "s": [
                  0.019
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.765
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.119
                  ]
                },
                "t": 218,
                "s": [
                  0.103
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.784
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.129
                  ]
                },
                "t": 219,
                "s": [
                  0.299
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.795
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.136
                  ]
                },
                "t": 220,
                "s": [
                  0.658
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.802
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.141
                  ]
                },
                "t": 221,
                "s": [
                  1.226
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.807
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.144
                  ]
                },
                "t": 222,
                "s": [
                  2.053
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.811
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.147
                  ]
                },
                "t": 223,
                "s": [
                  3.187
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.813
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.149
                  ]
                },
                "t": 224,
                "s": [
                  4.676
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.816
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.151
                  ]
                },
                "t": 225,
                "s": [
                  6.57
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.817
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.152
                  ]
                },
                "t": 226,
                "s": [
                  8.915
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.819
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.153
                  ]
                },
                "t": 227,
                "s": [
                  11.762
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.82
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.154
                  ]
                },
                "t": 228,
                "s": [
                  15.158
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.821
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.155
                  ]
                },
                "t": 229,
                "s": [
                  19.152
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.822
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 230,
                "s": [
                  23.793
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.822
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 231,
                "s": [
                  29.128
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.823
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.157
                  ]
                },
                "t": 232,
                "s": [
                  35.207
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 233,
                "s": [
                  42.077
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 234,
                "s": [
                  49.787
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.825
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 235,
                "s": [
                  58.387
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.825
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.159
                  ]
                },
                "t": 236,
                "s": [
                  67.923
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.159
                  ]
                },
                "t": 237,
                "s": [
                  78.445
                ]
              },
              {
                "t": 238.000148582833,
                "s": [
                  90
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.833,
                  "y": 0.842
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 49,
                "s": [
                  628.696,
                  852.771,
                  0
                ],
                "to": [
                  -4.065,
                  -4.391,
                  0
                ],
                "ti": [
                  7.7,
                  8.318,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.843
                },
                "o": {
                  "x": 0.167,
                  "y": 0.177
                },
                "t": 50,
                "s": [
                  604.305,
                  826.423,
                  0
                ],
                "to": [
                  -7.7,
                  -8.318,
                  0
                ],
                "ti": [
                  6.864,
                  7.415,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.843
                },
                "o": {
                  "x": 0.167,
                  "y": 0.177
                },
                "t": 51,
                "s": [
                  582.494,
                  802.862,
                  0
                ],
                "to": [
                  -6.864,
                  -7.415,
                  0
                ],
                "ti": [
                  6.076,
                  6.564,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.844
                },
                "o": {
                  "x": 0.167,
                  "y": 0.178
                },
                "t": 52,
                "s": [
                  563.119,
                  781.932,
                  0
                ],
                "to": [
                  -6.076,
                  -6.564,
                  0
                ],
                "ti": [
                  5.337,
                  5.765,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.845
                },
                "o": {
                  "x": 0.167,
                  "y": 0.179
                },
                "t": 53,
                "s": [
                  546.035,
                  763.478,
                  0
                ],
                "to": [
                  -5.337,
                  -5.765,
                  0
                ],
                "ti": [
                  4.645,
                  5.018,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.845
                },
                "o": {
                  "x": 0.167,
                  "y": 0.18
                },
                "t": 54,
                "s": [
                  531.099,
                  747.343,
                  0
                ],
                "to": [
                  -4.645,
                  -5.018,
                  0
                ],
                "ti": [
                  4.001,
                  4.322,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.846
                },
                "o": {
                  "x": 0.167,
                  "y": 0.181
                },
                "t": 55,
                "s": [
                  518.166,
                  733.372,
                  0
                ],
                "to": [
                  -4.001,
                  -4.322,
                  0
                ],
                "ti": [
                  3.406,
                  3.679,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 56,
                "s": [
                  507.092,
                  721.41,
                  0
                ],
                "to": [
                  -3.406,
                  -3.679,
                  0
                ],
                "ti": [
                  2.858,
                  3.087,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.849
                },
                "o": {
                  "x": 0.167,
                  "y": 0.183
                },
                "t": 57,
                "s": [
                  497.733,
                  711.299,
                  0
                ],
                "to": [
                  -2.858,
                  -3.087,
                  0
                ],
                "ti": [
                  2.359,
                  2.548,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.185
                },
                "t": 58,
                "s": [
                  489.944,
                  702.885,
                  0
                ],
                "to": [
                  -2.359,
                  -2.548,
                  0
                ],
                "ti": [
                  1.907,
                  2.06,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.852
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 59,
                "s": [
                  483.581,
                  696.012,
                  0
                ],
                "to": [
                  -1.907,
                  -2.06,
                  0
                ],
                "ti": [
                  1.504,
                  1.625,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.854
                },
                "o": {
                  "x": 0.167,
                  "y": 0.191
                },
                "t": 60,
                "s": [
                  478.5,
                  690.523,
                  0
                ],
                "to": [
                  -1.504,
                  -1.625,
                  0
                ],
                "ti": [
                  1.149,
                  1.241,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.857
                },
                "o": {
                  "x": 0.167,
                  "y": 0.195
                },
                "t": 61,
                "s": [
                  474.557,
                  686.264,
                  0
                ],
                "to": [
                  -1.149,
                  -1.241,
                  0
                ],
                "ti": [
                  0.842,
                  0.909,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.861
                },
                "o": {
                  "x": 0.167,
                  "y": 0.2
                },
                "t": 62,
                "s": [
                  471.608,
                  683.078,
                  0
                ],
                "to": [
                  -0.842,
                  -0.909,
                  0
                ],
                "ti": [
                  0.583,
                  0.629,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.209
                },
                "t": 63,
                "s": [
                  469.508,
                  680.809,
                  0
                ],
                "to": [
                  -0.583,
                  -0.629,
                  0
                ],
                "ti": [
                  0.372,
                  0.401,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.875
                },
                "o": {
                  "x": 0.167,
                  "y": 0.223
                },
                "t": 64,
                "s": [
                  468.113,
                  679.302,
                  0
                ],
                "to": [
                  -0.372,
                  -0.401,
                  0
                ],
                "ti": [
                  0.209,
                  0.225,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.888
                },
                "o": {
                  "x": 0.167,
                  "y": 0.25
                },
                "t": 65,
                "s": [
                  467.279,
                  678.401,
                  0
                ],
                "to": [
                  -0.209,
                  -0.225,
                  0
                ],
                "ti": [
                  0.094,
                  0.101,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.906
                },
                "o": {
                  "x": 0.167,
                  "y": 0.323
                },
                "t": 66,
                "s": [
                  466.861,
                  677.95,
                  0
                ],
                "to": [
                  -0.094,
                  -0.101,
                  0
                ],
                "ti": [
                  0.027,
                  0.029,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.916
                },
                "o": {
                  "x": 0.167,
                  "y": 0.718
                },
                "t": 67,
                "s": [
                  466.716,
                  677.794,
                  0
                ],
                "to": [
                  -0.027,
                  -0.029,
                  0
                ],
                "ti": [
                  0.003,
                  0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 68,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 69,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 70,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 71,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 72,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 73,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 74,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 75,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 76,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 77,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 78,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 79,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 80,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 81,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 82,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 83,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 84,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 85,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 86,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 87,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 88,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 89,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 90,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 91,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 92,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 93,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 94,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 95,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 96,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 97,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 98,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 99,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 100,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 101,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 102,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 103,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 104,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 105,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 106,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 107,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 108,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 109,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 110,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 111,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 112,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 113,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 114,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 115,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 116,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 117,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 118,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 119,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 120,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 121,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 122,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 123,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 124,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 125,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 126,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 127,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 128,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 129,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 130,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 131,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 132,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 133,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 134,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 135,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 136,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 137,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 138,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 139,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 140,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 141,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 142,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 143,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 144,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 145,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 146,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 147,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 148,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 149,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 150,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 151,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 152,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 153,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 154,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 155,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 156,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 157,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 158,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 159,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 160,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 161,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 162,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 163,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 164,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 165,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 166,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 167,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 168,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 169,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 170,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 171,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 172,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 173,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 174,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 175,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 176,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 177,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 178,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 179,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 180,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 181,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 182,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 183,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 184,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 185,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 186,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 187,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 188,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 189,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 190,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 191,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 192,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 193,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 194,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 195,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 196,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 197,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 198,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 199,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 200,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 201,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 202,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 203,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 204,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 205,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 206,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 207,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 208,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 209,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 210,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 211,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 212,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 213,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 214,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.338
                },
                "o": {
                  "x": 0.167,
                  "y": 0.082
                },
                "t": 215,
                "s": [
                  466.699,
                  677.775,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  -0.006,
                  -0.006,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.548
                },
                "o": {
                  "x": 0.167,
                  "y": 0.095
                },
                "t": 216,
                "s": [
                  466.7,
                  677.776,
                  0
                ],
                "to": [
                  0.006,
                  0.006,
                  0
                ],
                "ti": [
                  -0.031,
                  -0.033,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.72
                },
                "o": {
                  "x": 0.167,
                  "y": 0.102
                },
                "t": 217,
                "s": [
                  466.734,
                  677.813,
                  0
                ],
                "to": [
                  0.031,
                  0.033,
                  0
                ],
                "ti": [
                  -0.084,
                  -0.091,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.765
                },
                "o": {
                  "x": 0.167,
                  "y": 0.119
                },
                "t": 218,
                "s": [
                  466.884,
                  677.975,
                  0
                ],
                "to": [
                  0.084,
                  0.091,
                  0
                ],
                "ti": [
                  -0.166,
                  -0.18,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.784
                },
                "o": {
                  "x": 0.167,
                  "y": 0.129
                },
                "t": 219,
                "s": [
                  467.238,
                  678.357,
                  0
                ],
                "to": [
                  0.166,
                  0.18,
                  0
                ],
                "ti": [
                  -0.278,
                  -0.3,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.795
                },
                "o": {
                  "x": 0.167,
                  "y": 0.136
                },
                "t": 220,
                "s": [
                  467.883,
                  679.054,
                  0
                ],
                "to": [
                  0.278,
                  0.3,
                  0
                ],
                "ti": [
                  -0.419,
                  -0.452,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.802
                },
                "o": {
                  "x": 0.167,
                  "y": 0.141
                },
                "t": 221,
                "s": [
                  468.906,
                  680.159,
                  0
                ],
                "to": [
                  0.419,
                  0.452,
                  0
                ],
                "ti": [
                  -0.588,
                  -0.635,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.807
                },
                "o": {
                  "x": 0.167,
                  "y": 0.144
                },
                "t": 222,
                "s": [
                  470.394,
                  681.767,
                  0
                ],
                "to": [
                  0.588,
                  0.635,
                  0
                ],
                "ti": [
                  -0.787,
                  -0.85,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.811
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 223,
                "s": [
                  472.435,
                  683.972,
                  0
                ],
                "to": [
                  0.787,
                  0.85,
                  0
                ],
                "ti": [
                  -1.015,
                  -1.096,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.813
                },
                "o": {
                  "x": 0.167,
                  "y": 0.149
                },
                "t": 224,
                "s": [
                  475.116,
                  686.868,
                  0
                ],
                "to": [
                  1.015,
                  1.096,
                  0
                ],
                "ti": [
                  -1.272,
                  -1.374,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.816
                },
                "o": {
                  "x": 0.167,
                  "y": 0.151
                },
                "t": 225,
                "s": [
                  478.524,
                  690.549,
                  0
                ],
                "to": [
                  1.272,
                  1.374,
                  0
                ],
                "ti": [
                  -1.558,
                  -1.683,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.817
                },
                "o": {
                  "x": 0.167,
                  "y": 0.152
                },
                "t": 226,
                "s": [
                  482.747,
                  695.111,
                  0
                ],
                "to": [
                  1.558,
                  1.683,
                  0
                ],
                "ti": [
                  -1.873,
                  -2.023,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.819
                },
                "o": {
                  "x": 0.167,
                  "y": 0.153
                },
                "t": 227,
                "s": [
                  487.871,
                  700.646,
                  0
                ],
                "to": [
                  1.873,
                  2.023,
                  0
                ],
                "ti": [
                  -2.217,
                  -2.395,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.82
                },
                "o": {
                  "x": 0.167,
                  "y": 0.154
                },
                "t": 228,
                "s": [
                  493.984,
                  707.25,
                  0
                ],
                "to": [
                  2.217,
                  2.395,
                  0
                ],
                "ti": [
                  -2.59,
                  -2.798,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.821
                },
                "o": {
                  "x": 0.167,
                  "y": 0.155
                },
                "t": 229,
                "s": [
                  501.173,
                  715.016,
                  0
                ],
                "to": [
                  2.59,
                  2.798,
                  0
                ],
                "ti": [
                  -2.993,
                  -3.233,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.822
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 230,
                "s": [
                  509.526,
                  724.039,
                  0
                ],
                "to": [
                  2.993,
                  3.233,
                  0
                ],
                "ti": [
                  -3.424,
                  -3.699,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.822
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 231,
                "s": [
                  519.13,
                  734.413,
                  0
                ],
                "to": [
                  3.424,
                  3.699,
                  0
                ],
                "ti": [
                  -3.885,
                  -4.196,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 232,
                "s": [
                  530.071,
                  746.232,
                  0
                ],
                "to": [
                  3.885,
                  4.196,
                  0
                ],
                "ti": [
                  -4.374,
                  -4.725,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 233,
                "s": [
                  542.438,
                  759.591,
                  0
                ],
                "to": [
                  4.374,
                  4.725,
                  0
                ],
                "ti": [
                  -4.893,
                  -5.286,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 234,
                "s": [
                  556.317,
                  774.584,
                  0
                ],
                "to": [
                  4.893,
                  5.286,
                  0
                ],
                "ti": [
                  -5.441,
                  -5.877,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.825
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 235,
                "s": [
                  571.795,
                  791.305,
                  0
                ],
                "to": [
                  5.441,
                  5.877,
                  0
                ],
                "ti": [
                  -6.018,
                  -6.5,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.825
                },
                "o": {
                  "x": 0.167,
                  "y": 0.159
                },
                "t": 236,
                "s": [
                  588.961,
                  809.848,
                  0
                ],
                "to": [
                  6.018,
                  6.5,
                  0
                ],
                "ti": [
                  -6.623,
                  -7.155,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.159
                },
                "t": 237,
                "s": [
                  607.901,
                  830.308,
                  0
                ],
                "to": [
                  6.623,
                  7.155,
                  0
                ],
                "ti": [
                  -3.466,
                  -3.745,
                  0
                ]
              },
              {
                "t": 238.000148582833,
                "s": [
                  628.699,
                  852.775,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              86.699,
              -180.225,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.842,
                    0.842,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 49,
                "s": [
                  -0.002,
                  0.002,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.843,
                    0.843,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.177,
                    0.177,
                    0
                  ]
                },
                "t": 50,
                "s": [
                  -15.058,
                  15.058,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.843,
                    0.843,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.177,
                    0.177,
                    0
                  ]
                },
                "t": 51,
                "s": [
                  -28.522,
                  28.522,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.178,
                    0.178,
                    0
                  ]
                },
                "t": 52,
                "s": [
                  -40.482,
                  40.482,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.845,
                    0.845,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 53,
                "s": [
                  -51.027,
                  51.027,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.845,
                    0.845,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.18,
                    0.18,
                    0
                  ]
                },
                "t": 54,
                "s": [
                  -60.247,
                  60.247,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.846,
                    0.846,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.181,
                    0.181,
                    0
                  ]
                },
                "t": 55,
                "s": [
                  -68.23,
                  68.23,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.847,
                    0.847,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.182,
                    0.182,
                    0
                  ]
                },
                "t": 56,
                "s": [
                  -75.066,
                  75.066,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.849,
                    0.849,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.183,
                    0.183,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  -80.844,
                  80.844,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.85,
                    0.85,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.185,
                    0.185,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  -85.652,
                  85.652,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.852,
                    0.852,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.188,
                    0.188,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  -89.579,
                  89.579,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.854,
                    0.854,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.191,
                    0.191,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  -92.715,
                  92.715,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.195,
                    0.195,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  -95.149,
                  95.149,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.861,
                    0.861,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  -96.97,
                  96.97,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.867,
                    0.867,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.209,
                    0.209,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  -98.266,
                  98.266,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.875,
                    0.875,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.223,
                    0.223,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  -99.127,
                  99.127,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.888,
                    0.888,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.25,
                    0.25,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  -99.642,
                  99.642,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.907,
                    0.907,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.323,
                    0.323,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  -99.9,
                  99.9,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.917,
                    0.917,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.8,
                    0.8,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  -99.99,
                  99.99,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.001,
                    0.001,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 141,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 142,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 143,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 144,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 145,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 146,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 147,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 148,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 149,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 150,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 151,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 152,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 153,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 154,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 155,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 156,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 157,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 158,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 159,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 160,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 161,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 162,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 163,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 164,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 165,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 166,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 167,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 168,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 169,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 170,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 171,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 172,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 173,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 174,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 175,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 176,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 177,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 178,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 179,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 180,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 181,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 182,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 183,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 184,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 185,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 186,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 187,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 188,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 189,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 190,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 191,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 192,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 193,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 194,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 195,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 196,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 197,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 198,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 199,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 200,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 201,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 202,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 203,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 204,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 205,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 206,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 207,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 208,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 209,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 210,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 211,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 212,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 213,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 214,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    -4.318,
                    -4.318,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.083,
                    0.083,
                    0
                  ]
                },
                "t": 215,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.548,
                    0.548,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.085,
                    0.085,
                    0
                  ]
                },
                "t": 216,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.72,
                    0.72,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.102,
                    0.102,
                    0
                  ]
                },
                "t": 217,
                "s": [
                  -99.979,
                  99.979,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.765,
                    0.765,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.119,
                    0.119,
                    0
                  ]
                },
                "t": 218,
                "s": [
                  -99.886,
                  99.886,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.784,
                    0.784,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.129,
                    0.129,
                    0
                  ]
                },
                "t": 219,
                "s": [
                  -99.667,
                  99.667,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.795,
                    0.795,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.136,
                    0.136,
                    0
                  ]
                },
                "t": 220,
                "s": [
                  -99.269,
                  99.269,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.802,
                    0.802,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.141,
                    0.141,
                    0
                  ]
                },
                "t": 221,
                "s": [
                  -98.638,
                  98.638,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.807,
                    0.807,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 222,
                "s": [
                  -97.719,
                  97.719,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.811,
                    0.811,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.147,
                    0.147,
                    0
                  ]
                },
                "t": 223,
                "s": [
                  -96.459,
                  96.459,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.813,
                    0.813,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.149,
                    0.149,
                    0
                  ]
                },
                "t": 224,
                "s": [
                  -94.804,
                  94.804,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.816,
                    0.816,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.151,
                    0.151,
                    0
                  ]
                },
                "t": 225,
                "s": [
                  -92.701,
                  92.701,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.817,
                    0.817,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.152,
                    0.152,
                    0
                  ]
                },
                "t": 226,
                "s": [
                  -90.094,
                  90.094,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.153,
                    0.153,
                    0
                  ]
                },
                "t": 227,
                "s": [
                  -86.931,
                  86.931,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.82,
                    0.82,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.154,
                    0.154,
                    0
                  ]
                },
                "t": 228,
                "s": [
                  -83.157,
                  83.157,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.821,
                    0.821,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 229,
                "s": [
                  -78.72,
                  78.72,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.822,
                    0.822,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.156,
                    0.156,
                    0
                  ]
                },
                "t": 230,
                "s": [
                  -73.564,
                  73.564,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.822,
                    0.822,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.156,
                    0.156,
                    0
                  ]
                },
                "t": 231,
                "s": [
                  -67.636,
                  67.636,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.823,
                    0.823,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.157,
                    0.157,
                    0
                  ]
                },
                "t": 232,
                "s": [
                  -60.882,
                  60.882,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.824,
                    0.824,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.158,
                    0.158,
                    0
                  ]
                },
                "t": 233,
                "s": [
                  -53.248,
                  53.248,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.824,
                    0.824,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.158,
                    0.158,
                    0
                  ]
                },
                "t": 234,
                "s": [
                  -44.681,
                  44.681,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.825,
                    0.825,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.158,
                    0.158,
                    0
                  ]
                },
                "t": 235,
                "s": [
                  -35.126,
                  35.126,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.825,
                    0.825,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.159,
                    0.159,
                    0
                  ]
                },
                "t": 236,
                "s": [
                  -24.53,
                  24.53,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.159,
                    0.159,
                    0
                  ]
                },
                "t": 237,
                "s": [
                  -12.838,
                  12.838,
                  100
                ]
              },
              {
                "t": 238.000148582833,
                "s": [
                  0,
                  0,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "AC IN [GLA] Controls",
            "np": 5,
            "mn": "Pseudo/MHAC PrCtrl GLA 3",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    162,
                    175
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 90
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0003",
                "ix": 3,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "AC OUT [GLA] 2 Controls",
            "np": 5,
            "mn": "Pseudo/MHAC PrCtrl GLA 3",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    162,
                    175
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 90
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0003",
                "ix": 3,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -13.765
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        13.765
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        13.765
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -13.765
                      ]
                    ],
                    "v": [
                      [
                        -93.287,
                        -303.312
                      ],
                      [
                        266.686,
                        -303.312
                      ],
                      [
                        291.61,
                        -278.388
                      ],
                      [
                        291.61,
                        -128.952
                      ],
                      [
                        266.686,
                        -104.028
                      ],
                      [
                        -20.878,
                        -104.028
                      ],
                      [
                        -55.847,
                        -57.138
                      ],
                      [
                        -51.382,
                        -104.028
                      ],
                      [
                        -93.287,
                        -104.028
                      ],
                      [
                        -118.211,
                        -128.952
                      ],
                      [
                        -118.211,
                        -278.388
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.580392156863,
                    0.372549019608,
                    0.984313785329,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 49.0000019958109,
        "op": 239.00000973467,
        "st": 20.8888897397108,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 24,
        "ty": 4,
        "nm": "Layer 24",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.843
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.167
                  ]
                },
                "t": 52,
                "s": [
                  90
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.844
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.178
                  ]
                },
                "t": 53,
                "s": [
                  75.034
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.844
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.179
                  ]
                },
                "t": 54,
                "s": [
                  61.826
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.845
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.179
                  ]
                },
                "t": 55,
                "s": [
                  50.267
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.846
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.181
                  ]
                },
                "t": 56,
                "s": [
                  40.246
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.847
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.182
                  ]
                },
                "t": 57,
                "s": [
                  31.655
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.848
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.183
                  ]
                },
                "t": 58,
                "s": [
                  24.382
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.85
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.185
                  ]
                },
                "t": 59,
                "s": [
                  18.319
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.852
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.187
                  ]
                },
                "t": 60,
                "s": [
                  13.354
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.854
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.19
                  ]
                },
                "t": 61,
                "s": [
                  9.379
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.857
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.194
                  ]
                },
                "t": 62,
                "s": [
                  6.283
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.861
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.2
                  ]
                },
                "t": 63,
                "s": [
                  3.957
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.866
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.208
                  ]
                },
                "t": 64,
                "s": [
                  2.29
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.874
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.221
                  ]
                },
                "t": 65,
                "s": [
                  1.172
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.886
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.246
                  ]
                },
                "t": 66,
                "s": [
                  0.495
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.905
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.31
                  ]
                },
                "t": 67,
                "s": [
                  0.147
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.917
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.667
                  ]
                },
                "t": 68,
                "s": [
                  0.018
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    -0.002
                  ]
                },
                "t": 69,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 70,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 71,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 72,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 73,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 74,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 75,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 76,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 77,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 78,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 79,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 80,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 81,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 82,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 83,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 84,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 85,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 86,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 87,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 88,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 89,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 90,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 91,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 92,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 93,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 94,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 95,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 96,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 97,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 98,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 99,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 100,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 101,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 102,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 103,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 104,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 105,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 106,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 107,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 108,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 109,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 110,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 111,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 112,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 113,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 114,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 115,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 116,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 117,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 118,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 119,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 120,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 121,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 122,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 123,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 124,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 125,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 126,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 127,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 128,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 129,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 130,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 131,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 132,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 133,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 134,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 135,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 136,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 137,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 138,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 139,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 140,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 141,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 142,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 143,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 144,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 145,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 146,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 147,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 148,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 149,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 150,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 151,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 152,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 153,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 154,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 155,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 156,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 157,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 158,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 159,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 160,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 161,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 162,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 163,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 164,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 165,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 166,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 167,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 168,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 169,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 170,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 171,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 172,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 173,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 174,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 175,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 176,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 177,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 178,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 179,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 180,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 181,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 182,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 183,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 184,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 185,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 186,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 187,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 188,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 189,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 190,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 191,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 192,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 193,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 194,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 195,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 196,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 197,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 198,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 199,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 200,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 201,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 202,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 203,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 204,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 205,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 206,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 207,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 208,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 209,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 210,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.999
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 211,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.333
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.083
                  ]
                },
                "t": 212,
                "s": [
                  0
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.69
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.095
                  ]
                },
                "t": 213,
                "s": [
                  0.011
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.754
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.114
                  ]
                },
                "t": 214,
                "s": [
                  0.09
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.779
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.126
                  ]
                },
                "t": 215,
                "s": [
                  0.304
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.792
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.134
                  ]
                },
                "t": 216,
                "s": [
                  0.72
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.8
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.139
                  ]
                },
                "t": 217,
                "s": [
                  1.406
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.806
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.143
                  ]
                },
                "t": 218,
                "s": [
                  2.43
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.81
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.146
                  ]
                },
                "t": 219,
                "s": [
                  3.859
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.813
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.148
                  ]
                },
                "t": 220,
                "s": [
                  5.76
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.815
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.15
                  ]
                },
                "t": 221,
                "s": [
                  8.201
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.817
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.152
                  ]
                },
                "t": 222,
                "s": [
                  11.25
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.818
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.153
                  ]
                },
                "t": 223,
                "s": [
                  14.974
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.819
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.154
                  ]
                },
                "t": 224,
                "s": [
                  19.44
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.821
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.155
                  ]
                },
                "t": 225,
                "s": [
                  24.716
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.821
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 226,
                "s": [
                  30.87
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.822
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.156
                  ]
                },
                "t": 227,
                "s": [
                  37.969
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.823
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.157
                  ]
                },
                "t": 228,
                "s": [
                  46.08
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.157
                  ]
                },
                "t": 229,
                "s": [
                  55.271
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.824
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 230,
                "s": [
                  65.61
                ]
              },
              {
                "i": {
                  "x": [
                    0.833
                  ],
                  "y": [
                    0.833
                  ]
                },
                "o": {
                  "x": [
                    0.167
                  ],
                  "y": [
                    0.158
                  ]
                },
                "t": 231,
                "s": [
                  77.164
                ]
              },
              {
                "t": 232.000009449554,
                "s": [
                  90
                ]
              }
            ]
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.833,
                  "y": 0.843
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 52,
                "s": [
                  640.163,
                  886.067,
                  0
                ],
                "to": [
                  -4.49,
                  -4.85,
                  0
                ],
                "ti": [
                  8.452,
                  9.131,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.844
                },
                "o": {
                  "x": 0.167,
                  "y": 0.178
                },
                "t": 53,
                "s": [
                  613.224,
                  856.966,
                  0
                ],
                "to": [
                  -8.452,
                  -9.131,
                  0
                ],
                "ti": [
                  7.43,
                  8.026,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.844
                },
                "o": {
                  "x": 0.167,
                  "y": 0.179
                },
                "t": 54,
                "s": [
                  589.45,
                  831.284,
                  0
                ],
                "to": [
                  -7.43,
                  -8.026,
                  0
                ],
                "ti": [
                  6.474,
                  6.993,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.845
                },
                "o": {
                  "x": 0.167,
                  "y": 0.179
                },
                "t": 55,
                "s": [
                  568.643,
                  808.808,
                  0
                ],
                "to": [
                  -6.474,
                  -6.993,
                  0
                ],
                "ti": [
                  5.584,
                  6.032,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.846
                },
                "o": {
                  "x": 0.167,
                  "y": 0.181
                },
                "t": 56,
                "s": [
                  550.606,
                  789.324,
                  0
                ],
                "to": [
                  -5.584,
                  -6.032,
                  0
                ],
                "ti": [
                  4.759,
                  5.141,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 57,
                "s": [
                  535.142,
                  772.618,
                  0
                ],
                "to": [
                  -4.759,
                  -5.141,
                  0
                ],
                "ti": [
                  4.001,
                  4.322,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.848
                },
                "o": {
                  "x": 0.167,
                  "y": 0.183
                },
                "t": 58,
                "s": [
                  522.051,
                  758.477,
                  0
                ],
                "to": [
                  -4.001,
                  -4.322,
                  0
                ],
                "ti": [
                  3.308,
                  3.574,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.185
                },
                "t": 59,
                "s": [
                  511.137,
                  746.687,
                  0
                ],
                "to": [
                  -3.308,
                  -3.574,
                  0
                ],
                "ti": [
                  2.682,
                  2.897,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.852
                },
                "o": {
                  "x": 0.167,
                  "y": 0.187
                },
                "t": 60,
                "s": [
                  502.201,
                  737.034,
                  0
                ],
                "to": [
                  -2.682,
                  -2.897,
                  0
                ],
                "ti": [
                  2.121,
                  2.292,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.854
                },
                "o": {
                  "x": 0.167,
                  "y": 0.19
                },
                "t": 61,
                "s": [
                  495.046,
                  729.305,
                  0
                ],
                "to": [
                  -2.121,
                  -2.292,
                  0
                ],
                "ti": [
                  1.627,
                  1.757,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.857
                },
                "o": {
                  "x": 0.167,
                  "y": 0.194
                },
                "t": 62,
                "s": [
                  489.473,
                  723.285,
                  0
                ],
                "to": [
                  -1.627,
                  -1.757,
                  0
                ],
                "ti": [
                  1.198,
                  1.294,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.861
                },
                "o": {
                  "x": 0.167,
                  "y": 0.2
                },
                "t": 63,
                "s": [
                  485.285,
                  718.761,
                  0
                ],
                "to": [
                  -1.198,
                  -1.294,
                  0
                ],
                "ti": [
                  0.835,
                  0.902,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.866
                },
                "o": {
                  "x": 0.167,
                  "y": 0.208
                },
                "t": 64,
                "s": [
                  482.285,
                  715.52,
                  0
                ],
                "to": [
                  -0.835,
                  -0.902,
                  0
                ],
                "ti": [
                  0.539,
                  0.582,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.874
                },
                "o": {
                  "x": 0.167,
                  "y": 0.221
                },
                "t": 65,
                "s": [
                  480.273,
                  713.347,
                  0
                ],
                "to": [
                  -0.539,
                  -0.582,
                  0
                ],
                "ti": [
                  0.308,
                  0.332,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.886
                },
                "o": {
                  "x": 0.167,
                  "y": 0.246
                },
                "t": 66,
                "s": [
                  479.053,
                  712.029,
                  0
                ],
                "to": [
                  -0.308,
                  -0.332,
                  0
                ],
                "ti": [
                  0.143,
                  0.154,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.905
                },
                "o": {
                  "x": 0.167,
                  "y": 0.31
                },
                "t": 67,
                "s": [
                  478.427,
                  711.352,
                  0
                ],
                "to": [
                  -0.143,
                  -0.154,
                  0
                ],
                "ti": [
                  0.044,
                  0.047,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.917
                },
                "o": {
                  "x": 0.167,
                  "y": 0.663
                },
                "t": 68,
                "s": [
                  478.196,
                  711.103,
                  0
                ],
                "to": [
                  -0.044,
                  -0.047,
                  0
                ],
                "ti": [
                  0.005,
                  0.006,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 69,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 70,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 71,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 72,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 73,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 74,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 75,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 76,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 77,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 78,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 79,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 80,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 81,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 82,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 83,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 84,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 85,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 86,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 87,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 88,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 89,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 90,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 91,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 92,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 93,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 94,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 95,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 96,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 97,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 98,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 99,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 100,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 101,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 102,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 103,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 104,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 105,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 106,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 107,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 108,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 109,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 110,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 111,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 112,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 113,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 114,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 115,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 116,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 117,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 118,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 119,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 120,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 121,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 122,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 123,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 124,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 125,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 126,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 127,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 128,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 129,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 130,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 131,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 132,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 133,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 134,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 135,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 136,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 137,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 138,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 139,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 140,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 141,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 142,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 143,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 144,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 145,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 146,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 147,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 148,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 149,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 150,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 151,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 152,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 153,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 154,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 155,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 156,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 157,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 158,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 159,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 160,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 161,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 162,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 163,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 164,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 165,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 166,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 167,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 168,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 169,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 170,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 171,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 172,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 173,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 174,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 175,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 176,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 177,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 178,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 179,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 180,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 181,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 182,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 183,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 184,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 185,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 186,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 187,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 188,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 189,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 190,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 191,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 192,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 193,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 194,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 195,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 196,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 197,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 198,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 199,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 200,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 201,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 202,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 203,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 204,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 205,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 206,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 207,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 208,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 209,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 210,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 211,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.337
                },
                "o": {
                  "x": 0.167,
                  "y": 0.083
                },
                "t": 212,
                "s": [
                  478.163,
                  711.067,
                  0
                ],
                "to": [
                  0.003,
                  0.004,
                  0
                ],
                "ti": [
                  -0.027,
                  -0.029,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.69
                },
                "o": {
                  "x": 0.167,
                  "y": 0.095
                },
                "t": 213,
                "s": [
                  478.183,
                  711.089,
                  0
                ],
                "to": [
                  0.027,
                  0.029,
                  0
                ],
                "ti": [
                  -0.088,
                  -0.095,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.754
                },
                "o": {
                  "x": 0.167,
                  "y": 0.114
                },
                "t": 214,
                "s": [
                  478.325,
                  711.242,
                  0
                ],
                "to": [
                  0.088,
                  0.095,
                  0
                ],
                "ti": [
                  -0.189,
                  -0.204,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.779
                },
                "o": {
                  "x": 0.167,
                  "y": 0.126
                },
                "t": 215,
                "s": [
                  478.71,
                  711.658,
                  0
                ],
                "to": [
                  0.189,
                  0.204,
                  0
                ],
                "ti": [
                  -0.331,
                  -0.357,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.792
                },
                "o": {
                  "x": 0.167,
                  "y": 0.134
                },
                "t": 216,
                "s": [
                  479.459,
                  712.467,
                  0
                ],
                "to": [
                  0.331,
                  0.357,
                  0
                ],
                "ti": [
                  -0.513,
                  -0.554,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.8
                },
                "o": {
                  "x": 0.167,
                  "y": 0.139
                },
                "t": 217,
                "s": [
                  480.694,
                  713.802,
                  0
                ],
                "to": [
                  0.513,
                  0.554,
                  0
                ],
                "ti": [
                  -0.736,
                  -0.795,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.806
                },
                "o": {
                  "x": 0.167,
                  "y": 0.143
                },
                "t": 218,
                "s": [
                  482.537,
                  715.792,
                  0
                ],
                "to": [
                  0.736,
                  0.795,
                  0
                ],
                "ti": [
                  -0.999,
                  -1.079,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.81
                },
                "o": {
                  "x": 0.167,
                  "y": 0.146
                },
                "t": 219,
                "s": [
                  485.109,
                  718.571,
                  0
                ],
                "to": [
                  0.999,
                  1.079,
                  0
                ],
                "ti": [
                  -1.303,
                  -1.407,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.813
                },
                "o": {
                  "x": 0.167,
                  "y": 0.148
                },
                "t": 220,
                "s": [
                  488.531,
                  722.267,
                  0
                ],
                "to": [
                  1.303,
                  1.407,
                  0
                ],
                "ti": [
                  -1.647,
                  -1.779,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.815
                },
                "o": {
                  "x": 0.167,
                  "y": 0.15
                },
                "t": 221,
                "s": [
                  492.925,
                  727.014,
                  0
                ],
                "to": [
                  1.647,
                  1.779,
                  0
                ],
                "ti": [
                  -2.032,
                  -2.195,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.817
                },
                "o": {
                  "x": 0.167,
                  "y": 0.152
                },
                "t": 222,
                "s": [
                  498.413,
                  732.942,
                  0
                ],
                "to": [
                  2.032,
                  2.195,
                  0
                ],
                "ti": [
                  -2.457,
                  -2.654,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.818
                },
                "o": {
                  "x": 0.167,
                  "y": 0.153
                },
                "t": 223,
                "s": [
                  505.116,
                  740.183,
                  0
                ],
                "to": [
                  2.457,
                  2.654,
                  0
                ],
                "ti": [
                  -2.923,
                  -3.157,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.819
                },
                "o": {
                  "x": 0.167,
                  "y": 0.154
                },
                "t": 224,
                "s": [
                  513.155,
                  748.867,
                  0
                ],
                "to": [
                  2.923,
                  3.157,
                  0
                ],
                "ti": [
                  -3.429,
                  -3.704,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.821
                },
                "o": {
                  "x": 0.167,
                  "y": 0.155
                },
                "t": 225,
                "s": [
                  522.652,
                  759.127,
                  0
                ],
                "to": [
                  3.429,
                  3.704,
                  0
                ],
                "ti": [
                  -3.976,
                  -4.295,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.821
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 226,
                "s": [
                  533.729,
                  771.092,
                  0
                ],
                "to": [
                  3.976,
                  4.295,
                  0
                ],
                "ti": [
                  -4.563,
                  -4.929,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.822
                },
                "o": {
                  "x": 0.167,
                  "y": 0.156
                },
                "t": 227,
                "s": [
                  546.507,
                  784.896,
                  0
                ],
                "to": [
                  4.563,
                  4.929,
                  0
                ],
                "ti": [
                  -5.191,
                  -5.607,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 228,
                "s": [
                  561.107,
                  800.667,
                  0
                ],
                "to": [
                  5.191,
                  5.607,
                  0
                ],
                "ti": [
                  -5.859,
                  -6.329,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 229,
                "s": [
                  577.651,
                  818.539,
                  0
                ],
                "to": [
                  5.859,
                  6.329,
                  0
                ],
                "ti": [
                  -6.568,
                  -7.095,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.824
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 230,
                "s": [
                  596.261,
                  838.642,
                  0
                ],
                "to": [
                  6.568,
                  7.095,
                  0
                ],
                "ti": [
                  -7.317,
                  -7.904,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.158
                },
                "t": 231,
                "s": [
                  617.058,
                  861.108,
                  0
                ],
                "to": [
                  7.317,
                  7.904,
                  0
                ],
                "ti": [
                  -3.851,
                  -4.16,
                  0
                ]
              },
              {
                "t": 232.000009449554,
                "s": [
                  640.163,
                  886.067,
                  0
                ]
              }
            ]
          },
          "a": {
            "a": 0,
            "k": [
              72.163,
              -146.933,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.843,
                    0.843,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 52,
                "s": [
                  0,
                  0,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.178,
                    0.178,
                    0
                  ]
                },
                "t": 53,
                "s": [
                  -16.629,
                  16.629,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 54,
                "s": [
                  -31.305,
                  31.305,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.845,
                    0.845,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 55,
                "s": [
                  -44.148,
                  44.148,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.846,
                    0.846,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.181,
                    0.181,
                    0
                  ]
                },
                "t": 56,
                "s": [
                  -55.282,
                  55.282,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.847,
                    0.847,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.182,
                    0.182,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  -64.828,
                  64.828,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.848,
                    0.848,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.183,
                    0.183,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  -72.909,
                  72.909,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.85,
                    0.85,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.185,
                    0.185,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  -79.646,
                  79.646,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.852,
                    0.852,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.187,
                    0.187,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  -85.162,
                  85.162,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.854,
                    0.854,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.19,
                    0.19,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  -89.579,
                  89.579,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.194,
                    0.194,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  -93.019,
                  93.019,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.861,
                    0.861,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  -95.604,
                  95.604,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.866,
                    0.866,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.208,
                    0.208,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  -97.456,
                  97.456,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.221,
                    0.221,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  -98.697,
                  98.697,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.886,
                    0.886,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.246,
                    0.246,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  -99.45,
                  99.45,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.905,
                    0.905,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.31,
                    0.31,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  -99.837,
                  99.837,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.917,
                    0.917,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.667,
                    0.667,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  -99.98,
                  99.98,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.002,
                    0.002,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 141,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 142,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 143,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 144,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 145,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 146,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 147,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 148,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 149,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 150,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 151,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 152,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 153,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 154,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 155,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 156,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 157,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 158,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 159,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 160,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 161,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 162,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 163,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 164,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 165,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 166,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 167,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 168,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 169,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 170,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 171,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 172,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 173,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 174,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 175,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 176,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 177,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 178,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 179,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 180,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 181,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 182,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 183,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 184,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 185,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 186,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 187,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 188,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 189,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 190,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 191,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 192,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 193,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 194,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 195,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 196,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 197,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 198,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 199,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 200,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 201,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 202,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 203,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 204,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 205,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 206,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 207,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 208,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 209,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 210,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.999,
                    1.001,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 211,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.333,
                    0.333,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.083,
                    0.083,
                    0
                  ]
                },
                "t": 212,
                "s": [
                  -100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.69,
                    0.69,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.095,
                    0.095,
                    0
                  ]
                },
                "t": 213,
                "s": [
                  -99.987,
                  99.987,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.754,
                    0.754,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.114,
                    0.114,
                    0
                  ]
                },
                "t": 214,
                "s": [
                  -99.9,
                  99.9,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.779,
                    0.779,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.126,
                    0.126,
                    0
                  ]
                },
                "t": 215,
                "s": [
                  -99.662,
                  99.662,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.792,
                    0.792,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.134,
                    0.134,
                    0
                  ]
                },
                "t": 216,
                "s": [
                  -99.2,
                  99.2,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.8,
                    0.8,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.139,
                    0.139,
                    0
                  ]
                },
                "t": 217,
                "s": [
                  -98.438,
                  98.438,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.806,
                    0.806,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.143,
                    0.143,
                    0
                  ]
                },
                "t": 218,
                "s": [
                  -97.3,
                  97.3,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.81,
                    0.81,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.146,
                    0.146,
                    0
                  ]
                },
                "t": 219,
                "s": [
                  -95.712,
                  95.712,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.813,
                    0.813,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.148,
                    0.148,
                    0
                  ]
                },
                "t": 220,
                "s": [
                  -93.6,
                  93.6,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.815,
                    0.815,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.15,
                    0.15,
                    0
                  ]
                },
                "t": 221,
                "s": [
                  -90.887,
                  90.887,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.817,
                    0.817,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.152,
                    0.152,
                    0
                  ]
                },
                "t": 222,
                "s": [
                  -87.5,
                  87.5,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.818,
                    0.818,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.153,
                    0.153,
                    0
                  ]
                },
                "t": 223,
                "s": [
                  -83.363,
                  83.363,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.154,
                    0.154,
                    0
                  ]
                },
                "t": 224,
                "s": [
                  -78.4,
                  78.4,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.821,
                    0.821,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 225,
                "s": [
                  -72.537,
                  72.537,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.821,
                    0.821,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.156,
                    0.156,
                    0
                  ]
                },
                "t": 226,
                "s": [
                  -65.7,
                  65.7,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.822,
                    0.822,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.156,
                    0.156,
                    0
                  ]
                },
                "t": 227,
                "s": [
                  -57.812,
                  57.812,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.823,
                    0.823,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.157,
                    0.157,
                    0
                  ]
                },
                "t": 228,
                "s": [
                  -48.8,
                  48.8,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.824,
                    0.824,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.157,
                    0.157,
                    0
                  ]
                },
                "t": 229,
                "s": [
                  -38.588,
                  38.588,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.824,
                    0.824,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.158,
                    0.158,
                    0
                  ]
                },
                "t": 230,
                "s": [
                  -27.1,
                  27.1,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.158,
                    0.158,
                    0
                  ]
                },
                "t": 231,
                "s": [
                  -14.263,
                  14.263,
                  100
                ]
              },
              {
                "t": 232.000009449554,
                "s": [
                  0,
                  0,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "AC IN [GLA] Controls",
            "np": 5,
            "mn": "Pseudo/MHAC PrCtrl GLA 3",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    162,
                    175
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 90
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0003",
                "ix": 3,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "AC OUT [GLA] 2 Controls",
            "np": 5,
            "mn": "Pseudo/MHAC PrCtrl GLA 3",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 3,
                "nm": "Position",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": [
                    162,
                    175
                  ]
                }
              },
              {
                "ty": 0,
                "nm": "Angle",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0002",
                "ix": 2,
                "v": {
                  "a": 0,
                  "k": 90
                }
              },
              {
                "ty": 0,
                "nm": "Scale",
                "mn": "Pseudo/MHAC PrCtrl GLA 3-0003",
                "ix": 3,
                "v": {
                  "a": 0,
                  "k": 0
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -13.765
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        13.765
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        13.765
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -13.765,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -13.765
                      ]
                    ],
                    "v": [
                      [
                        -107.823,
                        -270.02
                      ],
                      [
                        252.15,
                        -270.02
                      ],
                      [
                        277.074,
                        -245.096
                      ],
                      [
                        277.074,
                        -95.66
                      ],
                      [
                        252.15,
                        -70.736
                      ],
                      [
                        -35.414,
                        -70.736
                      ],
                      [
                        -70.383,
                        -23.846
                      ],
                      [
                        -65.918,
                        -70.736
                      ],
                      [
                        -107.823,
                        -70.736
                      ],
                      [
                        -132.747,
                        -95.66
                      ],
                      [
                        -132.747,
                        -245.096
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.670588254929,
                    0.803921580315,
                    0.960784316063,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 52.0000021180034,
        "op": 233.000009490285,
        "st": 42.0000017106951,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 25,
        "ty": 4,
        "nm": "Layer 2",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 20
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              555.148,
              533.471,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              1.148,
              -106.529,
              0
            ]
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.667,
                    0.667,
                    0.667
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.333,
                    0.333,
                    0.333
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": -26.204,
                "s": [
                  55.203,
                  55.203,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.667,
                    0.667,
                    0.667
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.333,
                    0.333,
                    0.333
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 33,
                "s": [
                  49.001,
                  49.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.667,
                    0.667,
                    0.667
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.333,
                    0.333,
                    0.333
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  55.203,
                  55.203,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.667,
                    0.667,
                    0.667
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.333,
                    0.333,
                    0.333
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 155,
                "s": [
                  49.001,
                  49.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.667,
                    0.667,
                    0.667
                  ],
                  "y": [
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.333,
                    0.333,
                    0.333
                  ],
                  "y": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 215,
                "s": [
                  55.203,
                  55.203,
                  100
                ]
              },
              {
                "t": 274.203761168548,
                "s": [
                  49.001,
                  49.001,
                  100
                ]
              }
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.3,
                                    2.8
                                  ],
                                  [
                                    0.9,
                                    -1.4
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.9,
                                    1.3
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    -105.651,
                                    -9.229
                                  ],
                                  [
                                    -103.751,
                                    -13.829
                                  ],
                                  [
                                    -106.351,
                                    -9.729
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 1",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                1,
                                1,
                                1,
                                1
                              ]
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ]
                            },
                            "r": {
                              "a": 0,
                              "k": 0
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "sk": {
                              "a": 0,
                              "k": 0
                            },
                            "sa": {
                              "a": 0,
                              "k": 0
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 1",
                        "bm": 0,
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    -12.1,
                                    9
                                  ],
                                  [
                                    9.4,
                                    -16.9
                                  ],
                                  [
                                    -17.9,
                                    9.1
                                  ],
                                  [
                                    4.5,
                                    14
                                  ],
                                  [
                                    16,
                                    -2.6
                                  ],
                                  [
                                    -25.7,
                                    -29.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.9,
                                    1.4
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    17.9,
                                    -9.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -16.1,
                                    2.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.8,
                                    -1.4
                                  ],
                                  [
                                    3.8,
                                    -8.7
                                  ]
                                ],
                                "v": [
                                  [
                                    -78.751,
                                    -50.729
                                  ],
                                  [
                                    -106.351,
                                    -27.729
                                  ],
                                  [
                                    -88.751,
                                    -51.029
                                  ],
                                  [
                                    -63.051,
                                    -97.429
                                  ],
                                  [
                                    -89.051,
                                    -78.529
                                  ],
                                  [
                                    -108.151,
                                    -11.029
                                  ],
                                  [
                                    -106.451,
                                    -9.729
                                  ],
                                  [
                                    -103.851,
                                    -13.829
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 1",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                1,
                                1,
                                1,
                                1
                              ]
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ]
                            },
                            "r": {
                              "a": 0,
                              "k": 0
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "sk": {
                              "a": 0,
                              "k": 0
                            },
                            "sa": {
                              "a": 0,
                              "k": 0
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 2",
                        "bm": 0,
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    35.8,
                                    7.9
                                  ],
                                  [
                                    -47.6,
                                    23.6
                                  ]
                                ],
                                "v": [
                                  [
                                    74.249,
                                    -78.429
                                  ],
                                  [
                                    157.849,
                                    -88.629
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 1",
                            "hd": false
                          },
                          {
                            "ind": 1,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    28.2,
                                    7.3
                                  ],
                                  [
                                    -30.8,
                                    2.4
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.1,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    97.449,
                                    -55.429
                                  ],
                                  [
                                    153.949,
                                    -55.429
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 2",
                            "hd": false
                          },
                          {
                            "ind": 2,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    30.1,
                                    24.6
                                  ],
                                  [
                                    -56.8,
                                    3.1
                                  ]
                                ],
                                "v": [
                                  [
                                    68.449,
                                    -36.729
                                  ],
                                  [
                                    147.449,
                                    -9.229
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 3",
                            "hd": false
                          },
                          {
                            "ind": 3,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    14.1,
                                    25.5
                                  ],
                                  [
                                    -34.6,
                                    -12.8
                                  ]
                                ],
                                "v": [
                                  [
                                    24.749,
                                    -34.529
                                  ],
                                  [
                                    71.949,
                                    10.471
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 4",
                            "hd": false
                          },
                          {
                            "ind": 4,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    20,
                                    30.2
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -12.7,
                                    -22.3
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    -14.1,
                                    -21.3
                                  ],
                                  [
                                    13.3,
                                    -15.7
                                  ],
                                  [
                                    12.7,
                                    22.3
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    -12.951,
                                    -11.729
                                  ],
                                  [
                                    -45.751,
                                    -12.729
                                  ],
                                  [
                                    -7.051,
                                    -15.329
                                  ],
                                  [
                                    41.949,
                                    36.471
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 5",
                            "hd": false
                          },
                          {
                            "ind": 5,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    6.8,
                                    16.8
                                  ],
                                  [
                                    -14.5,
                                    -10.4
                                  ]
                                ],
                                "v": [
                                  [
                                    -32.551,
                                    10.471
                                  ],
                                  [
                                    -9.351,
                                    44.971
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 6",
                            "hd": false
                          },
                          {
                            "ind": 6,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    -41.6,
                                    22.2
                                  ],
                                  [
                                    -1.5,
                                    56
                                  ],
                                  [
                                    26.9,
                                    -22.1
                                  ],
                                  [
                                    19.7,
                                    -63.3
                                  ]
                                ],
                                "o": [
                                  [
                                    41.6,
                                    -22.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -26.9,
                                    22.1
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    -1.351,
                                    -110.729
                                  ],
                                  [
                                    32.749,
                                    -194.329
                                  ],
                                  [
                                    28.849,
                                    -113.429
                                  ],
                                  [
                                    -43.551,
                                    -39.229
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 7",
                            "hd": false
                          },
                          {
                            "ind": 7,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    14.2,
                                    13.7
                                  ],
                                  [
                                    -9.7,
                                    7
                                  ],
                                  [
                                    -15.1,
                                    -30.3
                                  ],
                                  [
                                    -5.7,
                                    -17.9
                                  ],
                                  [
                                    14.5,
                                    1.8
                                  ],
                                  [
                                    17.8,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    9.7,
                                    -7
                                  ],
                                  [
                                    15.2,
                                    30.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -14.5,
                                    -1.8
                                  ],
                                  [
                                    -17.9,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    7.049,
                                    -254.629
                                  ],
                                  [
                                    27.049,
                                    -262.229
                                  ],
                                  [
                                    70.349,
                                    -248.929
                                  ],
                                  [
                                    122.749,
                                    -197.729
                                  ],
                                  [
                                    80.649,
                                    -221.029
                                  ],
                                  [
                                    47.049,
                                    -254.329
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 8",
                            "hd": false
                          },
                          {
                            "ind": 8,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    20.9,
                                    -13.1
                                  ]
                                ],
                                "o": [
                                  [
                                    53.3,
                                    -65.1
                                  ],
                                  [
                                    -15.4,
                                    -17.7
                                  ],
                                  [
                                    -20.9,
                                    13
                                  ]
                                ],
                                "v": [
                                  [
                                    1.849,
                                    -262.229
                                  ],
                                  [
                                    98.549,
                                    -264.029
                                  ],
                                  [
                                    39.149,
                                    -278.829
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 9",
                            "hd": false
                          },
                          {
                            "ind": 9,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.9,
                                    10.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -17.5,
                                    -8.9
                                  ]
                                ],
                                "o": [
                                  [
                                    -10,
                                    -26.7
                                  ],
                                  [
                                    -0.9,
                                    -10.9
                                  ],
                                  [
                                    24.5,
                                    2.7
                                  ],
                                  [
                                    17.4,
                                    8.8
                                  ]
                                ],
                                "v": [
                                  [
                                    130.049,
                                    -201.029
                                  ],
                                  [
                                    86.449,
                                    -244.029
                                  ],
                                  [
                                    64.949,
                                    -268.529
                                  ],
                                  [
                                    102.849,
                                    -239.129
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 10",
                            "hd": false
                          },
                          {
                            "ind": 10,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    20.9,
                                    -7
                                  ],
                                  [
                                    29.5,
                                    -14.6
                                  ],
                                  [
                                    -13.5,
                                    -22.7
                                  ],
                                  [
                                    0.5,
                                    8.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -5.3,
                                    4.9
                                  ],
                                  [
                                    -0.1,
                                    0
                                  ],
                                  [
                                    -0.1,
                                    0.2
                                  ],
                                  [
                                    -2.2,
                                    1.5
                                  ],
                                  [
                                    -36.7,
                                    16.7
                                  ],
                                  [
                                    20.9,
                                    54.5
                                  ],
                                  [
                                    -40.3,
                                    -12.7
                                  ]
                                ],
                                "o": [
                                  [
                                    -15.4,
                                    5.1
                                  ],
                                  [
                                    -8.2,
                                    4.2
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -24.7,
                                    -5.6
                                  ],
                                  [
                                    3.9,
                                    -28.2
                                  ],
                                  [
                                    1,
                                    -4.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.1,
                                    -0.1
                                  ],
                                  [
                                    1.6,
                                    -1.5
                                  ],
                                  [
                                    15.5,
                                    -12
                                  ],
                                  [
                                    29.9,
                                    -13.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    40.3,
                                    12.8
                                  ]
                                ],
                                "v": [
                                  [
                                    132.149,
                                    -122.529
                                  ],
                                  [
                                    46.249,
                                    -86.329
                                  ],
                                  [
                                    22.949,
                                    -42.529
                                  ],
                                  [
                                    15.249,
                                    -56.529
                                  ],
                                  [
                                    -19.351,
                                    -35.029
                                  ],
                                  [
                                    15.649,
                                    -61.429
                                  ],
                                  [
                                    24.549,
                                    -75.029
                                  ],
                                  [
                                    24.649,
                                    -75.129
                                  ],
                                  [
                                    25.049,
                                    -75.529
                                  ],
                                  [
                                    30.749,
                                    -80.029
                                  ],
                                  [
                                    114.949,
                                    -132.029
                                  ],
                                  [
                                    54.349,
                                    -216.529
                                  ],
                                  [
                                    109.449,
                                    -173.529
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 11",
                            "hd": false
                          },
                          {
                            "ind": 11,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    10.9,
                                    -0.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    1.5,
                                    6.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    -10.9,
                                    0.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.5,
                                    -6.1
                                  ],
                                  [
                                    -2.7,
                                    -1.2
                                  ],
                                  [
                                    7,
                                    4.5
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    -49.051,
                                    -207.029
                                  ],
                                  [
                                    -80.551,
                                    -199.129
                                  ],
                                  [
                                    -63.851,
                                    -208.229
                                  ],
                                  [
                                    -66.851,
                                    -216.729
                                  ],
                                  [
                                    -48.951,
                                    -222.529
                                  ],
                                  [
                                    -53.151,
                                    -229.229
                                  ],
                                  [
                                    -29.251,
                                    -219.229
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 12",
                            "hd": false
                          },
                          {
                            "ind": 12,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    -15.1,
                                    3.4
                                  ],
                                  [
                                    2.1,
                                    -9.3
                                  ],
                                  [
                                    6.7,
                                    -0.4
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.1,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    -49.651,
                                    -244.029
                                  ],
                                  [
                                    -64.551,
                                    -224.629
                                  ],
                                  [
                                    -75.151,
                                    -229.129
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 13",
                            "hd": false
                          },
                          {
                            "ind": 13,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -19,
                                    37.3
                                  ],
                                  [
                                    2.4,
                                    9.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -20.4,
                                    37.7
                                  ],
                                  [
                                    3.7,
                                    8.2
                                  ],
                                  [
                                    91,
                                    -17.7
                                  ],
                                  [
                                    -2.7,
                                    10.2
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    24.6,
                                    5.1
                                  ],
                                  [
                                    33.4,
                                    25.4
                                  ],
                                  [
                                    8.8,
                                    -16.9
                                  ],
                                  [
                                    0.7,
                                    -0.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    23.3,
                                    -4.9
                                  ],
                                  [
                                    3,
                                    -10.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.9,
                                    -4.2
                                  ],
                                  [
                                    -2.4,
                                    4
                                  ],
                                  [
                                    -1.5,
                                    3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -14.1,
                                    0.8
                                  ],
                                  [
                                    -7.3,
                                    -3.7
                                  ],
                                  [
                                    -3.5,
                                    -3
                                  ],
                                  [
                                    6.1,
                                    3.2
                                  ],
                                  [
                                    5.2,
                                    -0.2
                                  ],
                                  [
                                    7.5,
                                    4.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -9.1,
                                    0.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -7.2,
                                    6.1
                                  ],
                                  [
                                    -32.7,
                                    18.8
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    2.8,
                                    -11.9
                                  ],
                                  [
                                    0.4,
                                    -2.8
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    16.2,
                                    -24.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -11.6,
                                    -28.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -11.4,
                                    18.1
                                  ],
                                  [
                                    1.9,
                                    -19.3
                                  ],
                                  [
                                    13.9,
                                    1.8
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -2.7,
                                    8.4
                                  ],
                                  [
                                    17.9,
                                    7.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -21,
                                    -4.5
                                  ],
                                  [
                                    -16.1,
                                    11.2
                                  ],
                                  [
                                    2.4,
                                    0.1
                                  ],
                                  [
                                    11.6,
                                    1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.2,
                                    20.9
                                  ],
                                  [
                                    11.5,
                                    -4.2
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -19,
                                    32.2
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -18.7,
                                    35.3
                                  ],
                                  [
                                    0,
                                    0.9
                                  ],
                                  [
                                    0.3,
                                    5.5
                                  ]
                                ],
                                "o": [
                                  [
                                    69.1,
                                    -17
                                  ],
                                  [
                                    -1.5,
                                    -9.7
                                  ],
                                  [
                                    -49.4,
                                    71
                                  ],
                                  [
                                    52.5,
                                    -28
                                  ],
                                  [
                                    -2.9,
                                    -8.6
                                  ],
                                  [
                                    -25.7,
                                    39.7
                                  ],
                                  [
                                    21.6,
                                    -8.2
                                  ],
                                  [
                                    3.9,
                                    -14.8
                                  ],
                                  [
                                    -14.2,
                                    -18.2
                                  ],
                                  [
                                    -24.6,
                                    -5.1
                                  ],
                                  [
                                    -33.3,
                                    -25.5
                                  ],
                                  [
                                    -8.5,
                                    16.4
                                  ],
                                  [
                                    6.4,
                                    -3.7
                                  ],
                                  [
                                    -23.8,
                                    4.2
                                  ],
                                  [
                                    -23.3,
                                    4.9
                                  ],
                                  [
                                    -3,
                                    10.9
                                  ],
                                  [
                                    -36,
                                    8.8
                                  ],
                                  [
                                    0.9,
                                    4.2
                                  ],
                                  [
                                    2.4,
                                    -3.9
                                  ],
                                  [
                                    1.5,
                                    -3
                                  ],
                                  [
                                    -1.8,
                                    12.1
                                  ],
                                  [
                                    -5.8,
                                    26.1
                                  ],
                                  [
                                    7.5,
                                    -0.5
                                  ],
                                  [
                                    3.9,
                                    1.6
                                  ],
                                  [
                                    -0.5,
                                    -0.4
                                  ],
                                  [
                                    -11.6,
                                    -4.7
                                  ],
                                  [
                                    -7,
                                    0.3
                                  ],
                                  [
                                    -7.6,
                                    -4.8
                                  ],
                                  [
                                    -0.6,
                                    30.3
                                  ],
                                  [
                                    9.1,
                                    -0.9
                                  ],
                                  [
                                    29.7,
                                    6.7
                                  ],
                                  [
                                    9.3,
                                    -9.4
                                  ],
                                  [
                                    32.7,
                                    -18.8
                                  ],
                                  [
                                    11.2,
                                    32.1
                                  ],
                                  [
                                    -38.5,
                                    30.5
                                  ],
                                  [
                                    -0.1,
                                    3
                                  ],
                                  [
                                    0,
                                    0.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -5.3,
                                    34.3
                                  ],
                                  [
                                    -1.2,
                                    2.8
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -10.9,
                                    18.1
                                  ],
                                  [
                                    22.1,
                                    53.9
                                  ],
                                  [
                                    2.9,
                                    -28.8
                                  ],
                                  [
                                    -13.2,
                                    29.7
                                  ],
                                  [
                                    -5,
                                    49.5
                                  ],
                                  [
                                    -44.5,
                                    -5.8
                                  ],
                                  [
                                    43.6,
                                    70
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.7,
                                    -2.2
                                  ],
                                  [
                                    -26,
                                    -11.3
                                  ],
                                  [
                                    38.4,
                                    29.6
                                  ],
                                  [
                                    19.2,
                                    4.1
                                  ],
                                  [
                                    4.2,
                                    -2.9
                                  ],
                                  [
                                    -4.5,
                                    -0.2
                                  ],
                                  [
                                    -37.3,
                                    -3.2
                                  ],
                                  [
                                    116.1,
                                    41.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -3
                                  ],
                                  [
                                    -40,
                                    14.5
                                  ],
                                  [
                                    130.7,
                                    32.6
                                  ],
                                  [
                                    19,
                                    -32.2
                                  ],
                                  [
                                    -65.9,
                                    53.6
                                  ],
                                  [
                                    78.9,
                                    -6.3
                                  ],
                                  [
                                    0,
                                    -0.9
                                  ],
                                  [
                                    0,
                                    -5.7
                                  ],
                                  [
                                    -59.6,
                                    71.7
                                  ]
                                ],
                                "v": [
                                  [
                                    164.249,
                                    -55.829
                                  ],
                                  [
                                    287.549,
                                    -151.529
                                  ],
                                  [
                                    281.648,
                                    -180.229
                                  ],
                                  [
                                    170.249,
                                    -92.629
                                  ],
                                  [
                                    275.749,
                                    -200.129
                                  ],
                                  [
                                    265.849,
                                    -225.329
                                  ],
                                  [
                                    92.949,
                                    -99.629
                                  ],
                                  [
                                    152.749,
                                    -132.829
                                  ],
                                  [
                                    150.049,
                                    -155.829
                                  ],
                                  [
                                    130.349,
                                    -232.129
                                  ],
                                  [
                                    83.049,
                                    -294.529
                                  ],
                                  [
                                    6.349,
                                    -281.529
                                  ],
                                  [
                                    -14.251,
                                    -259.429
                                  ],
                                  [
                                    -1.451,
                                    -281.529
                                  ],
                                  [
                                    -31.551,
                                    -255.429
                                  ],
                                  [
                                    -81.251,
                                    -230.629
                                  ],
                                  [
                                    -97.351,
                                    -217.629
                                  ],
                                  [
                                    -151.551,
                                    -187.629
                                  ],
                                  [
                                    -143.351,
                                    -184.929
                                  ],
                                  [
                                    -128.551,
                                    -187.629
                                  ],
                                  [
                                    -124.051,
                                    -190.929
                                  ],
                                  [
                                    -141.651,
                                    -170.329
                                  ],
                                  [
                                    -117.751,
                                    -131.529
                                  ],
                                  [
                                    -93.451,
                                    -124.329
                                  ],
                                  [
                                    -82.151,
                                    -117.629
                                  ],
                                  [
                                    -93.451,
                                    -124.329
                                  ],
                                  [
                                    -122.351,
                                    -128.529
                                  ],
                                  [
                                    -135.951,
                                    -133.43
                                  ],
                                  [
                                    -146.851,
                                    -130.729
                                  ],
                                  [
                                    -115.051,
                                    -98.93
                                  ],
                                  [
                                    -98.951,
                                    -99.529
                                  ],
                                  [
                                    -62.951,
                                    -104.729
                                  ],
                                  [
                                    -6.551,
                                    -175.329
                                  ],
                                  [
                                    18.349,
                                    -224.729
                                  ],
                                  [
                                    -4.051,
                                    -168.329
                                  ],
                                  [
                                    -55.951,
                                    -103.529
                                  ],
                                  [
                                    -56.751,
                                    -94.729
                                  ],
                                  [
                                    -56.651,
                                    -93.93
                                  ],
                                  [
                                    -56.851,
                                    -94.229
                                  ],
                                  [
                                    -103.951,
                                    -13.829
                                  ],
                                  [
                                    -105.851,
                                    -9.229
                                  ],
                                  [
                                    -106.551,
                                    -9.729
                                  ],
                                  [
                                    -111.051,
                                    56.871
                                  ],
                                  [
                                    -90.751,
                                    84.171
                                  ],
                                  [
                                    -66.851,
                                    14.07
                                  ],
                                  [
                                    -85.851,
                                    91.87
                                  ],
                                  [
                                    25.649,
                                    126.87
                                  ],
                                  [
                                    -42.651,
                                    70.471
                                  ],
                                  [
                                    66.149,
                                    118.471
                                  ],
                                  [
                                    83.649,
                                    106.471
                                  ],
                                  [
                                    62.449,
                                    99.071
                                  ],
                                  [
                                    -4.551,
                                    53.771
                                  ],
                                  [
                                    84.749,
                                    99.971
                                  ],
                                  [
                                    141.449,
                                    85.971
                                  ],
                                  [
                                    147.149,
                                    75.171
                                  ],
                                  [
                                    125.449,
                                    73.371
                                  ],
                                  [
                                    49.449,
                                    43.871
                                  ],
                                  [
                                    200.149,
                                    56.971
                                  ],
                                  [
                                    217.649,
                                    24.671
                                  ],
                                  [
                                    196.749,
                                    32.071
                                  ],
                                  [
                                    89.449,
                                    19.771
                                  ],
                                  [
                                    277.249,
                                    -47.029
                                  ],
                                  [
                                    269.949,
                                    -54.729
                                  ],
                                  [
                                    155.149,
                                    -9.929
                                  ],
                                  [
                                    290.849,
                                    -104.329
                                  ],
                                  [
                                    290.849,
                                    -107.129
                                  ],
                                  [
                                    290.349,
                                    -123.929
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 14",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                1,
                                1,
                                1,
                                1
                              ]
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ]
                            },
                            "r": {
                              "a": 0,
                              "k": 0
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "sk": {
                              "a": 0,
                              "k": 0
                            },
                            "sa": {
                              "a": 0,
                              "k": 0
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 3",
                        "bm": 0,
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 1",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -6.6,
                                1.6
                              ],
                              [
                                0.7,
                                2.8
                              ],
                              [
                                6.6,
                                -1.6
                              ],
                              [
                                -0.7,
                                -2.9
                              ]
                            ],
                            "o": [
                              [
                                0.7,
                                2.9
                              ],
                              [
                                6.6,
                                -1.6
                              ],
                              [
                                -0.7,
                                -2.9
                              ],
                              [
                                -6.6,
                                1.5
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -62.951,
                                -211.829
                              ],
                              [
                                -49.751,
                                -209.529
                              ],
                              [
                                -42.051,
                                -217.229
                              ],
                              [
                                -52.451,
                                -218.429
                              ],
                              [
                                -62.951,
                                -211.829
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            1,
                            1,
                            1,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 2",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -6.7,
                                    8.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -16.2
                                  ]
                                ],
                                "o": [
                                  [
                                    9.6,
                                    -17.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    9.2
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    -47.851,
                                    -287.729
                                  ],
                                  [
                                    -22.251,
                                    -326.429
                                  ],
                                  [
                                    -0.051,
                                    -326.429
                                  ],
                                  [
                                    -0.051,
                                    -287.729
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 1",
                            "hd": false
                          },
                          {
                            "ind": 1,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    8.8,
                                    -16.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -13.8,
                                    8.2
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    19.3,
                                    -17.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -7.5,
                                    9.1
                                  ]
                                ],
                                "v": [
                                  [
                                    -56.151,
                                    -287.729
                                  ],
                                  [
                                    -105.651,
                                    -287.729
                                  ],
                                  [
                                    -53.751,
                                    -326.429
                                  ],
                                  [
                                    -30.951,
                                    -326.429
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 2",
                            "hd": false
                          },
                          {
                            "ind": 2,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    4.2,
                                    0.3
                                  ],
                                  [
                                    2.4,
                                    -2.1
                                  ],
                                  [
                                    15.9,
                                    -3.9
                                  ],
                                  [
                                    11.5,
                                    -4.1
                                  ],
                                  [
                                    7.5,
                                    -1
                                  ],
                                  [
                                    10.8,
                                    -1.3
                                  ],
                                  [
                                    33.8,
                                    3.7
                                  ],
                                  [
                                    7,
                                    3.7
                                  ],
                                  [
                                    0,
                                    109.9
                                  ],
                                  [
                                    -133.9,
                                    0
                                  ],
                                  [
                                    -28.6,
                                    -11.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    3.3,
                                    1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -7.8,
                                    -4.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    2.5,
                                    2
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -3.8,
                                    -4.2
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    1.5
                                  ],
                                  [
                                    4.3,
                                    0.6
                                  ],
                                  [
                                    0.7,
                                    0.1
                                  ],
                                  [
                                    0,
                                    -4.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    7.8,
                                    -6.3
                                  ],
                                  [
                                    3.7,
                                    -4.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    9.6,
                                    -3
                                  ],
                                  [
                                    8.6,
                                    -5.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -1.4
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    17.4,
                                    -16.8
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -1.4
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    10.3,
                                    -14.8
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -1.4
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    7.2,
                                    -21.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -1.4
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.4,
                                    -22.8
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -1.4
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -11.9,
                                    -39.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -1.4
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -10.6,
                                    -17.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -1.4
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -12.2,
                                    -13
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -1.4
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -5.3,
                                    -4.7
                                  ],
                                  [
                                    1.9,
                                    5
                                  ],
                                  [
                                    0.1,
                                    0.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.6,
                                    1.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    9.7,
                                    14.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.3,
                                    1.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    6.2,
                                    18.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.1,
                                    1.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.1,
                                    24.7
                                  ],
                                  [
                                    0,
                                    0.2
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.7,
                                    1.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -5.9,
                                    19.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.5,
                                    1.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -11.5,
                                    17
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -2,
                                    1.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -11.7,
                                    11.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    5.1,
                                    -14.6
                                  ],
                                  [
                                    -3.4,
                                    1.6
                                  ],
                                  [
                                    -5.2,
                                    9.8
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.4,
                                    2.3
                                  ],
                                  [
                                    0,
                                    7.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -3.7,
                                    -5.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.6,
                                    -0.3
                                  ],
                                  [
                                    3.4,
                                    4.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -19.3,
                                    -17.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.2,
                                    -1.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -10.7,
                                    -15
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -3.5,
                                    -0.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -7.2,
                                    -21.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.2,
                                    -1.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.2,
                                    -5.1
                                  ],
                                  [
                                    -1.4,
                                    1.3
                                  ],
                                  [
                                    1.2,
                                    3.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.6,
                                    1.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    11.4,
                                    17.2
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    11.3,
                                    11.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    13.7,
                                    8.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    0.1,
                                    0.3
                                  ],
                                  [
                                    -22.6,
                                    -63.6
                                  ],
                                  [
                                    -2.6,
                                    3
                                  ],
                                  [
                                    25.7,
                                    25.7
                                  ],
                                  [
                                    67.8,
                                    0
                                  ],
                                  [
                                    47.9,
                                    -47.9
                                  ],
                                  [
                                    0,
                                    -67.8
                                  ],
                                  [
                                    -47.9,
                                    -47.9
                                  ],
                                  [
                                    -67.8,
                                    0
                                  ],
                                  [
                                    -47.9,
                                    47.9
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    -2.4,
                                    2.2
                                  ],
                                  [
                                    -5.9,
                                    15.4
                                  ],
                                  [
                                    -10.6,
                                    5.7
                                  ],
                                  [
                                    -5.1,
                                    3.5
                                  ],
                                  [
                                    -10.4,
                                    2.7
                                  ],
                                  [
                                    -11.8,
                                    3.9
                                  ],
                                  [
                                    -12.7,
                                    -1.4
                                  ],
                                  [
                                    -100.5,
                                    -29.7
                                  ],
                                  [
                                    0,
                                    -133.8
                                  ],
                                  [
                                    32.8,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -8.6,
                                    -5.1
                                  ],
                                  [
                                    -9.6,
                                    -2.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -3.7,
                                    -4.1
                                  ],
                                  [
                                    -7.9,
                                    -6.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -2.7
                                  ],
                                  [
                                    -0.3,
                                    -0.8
                                  ],
                                  [
                                    -5.2,
                                    2.1
                                  ],
                                  [
                                    0,
                                    0.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    3.7,
                                    -4.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -2.5,
                                    2
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    7.8,
                                    -4.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -3.3,
                                    1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -13.8,
                                    8.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -11.3,
                                    11.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -11.4,
                                    17.2
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -6.1,
                                    19.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    5.1,
                                    15.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    8.2,
                                    12.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    4.7,
                                    4.8
                                  ],
                                  [
                                    -2.1,
                                    -4.2
                                  ],
                                  [
                                    -0.1,
                                    -0.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.6,
                                    -1.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -10.9,
                                    -11.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.2,
                                    -1.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -9.4,
                                    -15
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.2,
                                    -1.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -6.4,
                                    -20.5
                                  ],
                                  [
                                    0,
                                    -0.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.9,
                                    -1.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.4,
                                    -23
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.7,
                                    -2.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    7.2,
                                    -21.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    1.5,
                                    -1.8
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    10.7,
                                    -15
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -5.7,
                                    11.3
                                  ],
                                  [
                                    2.8,
                                    -2.1
                                  ],
                                  [
                                    4.9,
                                    -12.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    7.3,
                                    -5.6
                                  ],
                                  [
                                    0.8,
                                    -2.8
                                  ],
                                  [
                                    0,
                                    -13.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    2.9,
                                    3.6
                                  ],
                                  [
                                    2.7,
                                    0
                                  ],
                                  [
                                    1.7,
                                    0.3
                                  ],
                                  [
                                    -3.8,
                                    -5.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    13.7,
                                    8.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    1.5,
                                    1.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    11.8,
                                    11.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    2.5,
                                    2.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    11.5,
                                    16.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    1.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    1.5,
                                    4.8
                                  ],
                                  [
                                    1.5,
                                    -1.2
                                  ],
                                  [
                                    -1,
                                    -3.8
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    1.7,
                                    -1.7
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -7.2,
                                    -21.3
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    -1.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -10.3,
                                    -14.8
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    -1.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -17.4,
                                    -16.9
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    -0.3
                                  ],
                                  [
                                    61.6,
                                    26.7
                                  ],
                                  [
                                    3,
                                    -3.2
                                  ],
                                  [
                                    -12.6,
                                    -33
                                  ],
                                  [
                                    -47.9,
                                    -47.9
                                  ],
                                  [
                                    -67.8,
                                    0
                                  ],
                                  [
                                    -47.9,
                                    47.9
                                  ],
                                  [
                                    0,
                                    67.8
                                  ],
                                  [
                                    47.9,
                                    47.9
                                  ],
                                  [
                                    67.8,
                                    0
                                  ],
                                  [
                                    0.1,
                                    -0.1
                                  ],
                                  [
                                    -6.9,
                                    1.1
                                  ]
                                ],
                                "v": [
                                  [
                                    163.549,
                                    72.871
                                  ],
                                  [
                                    156.249,
                                    79.271
                                  ],
                                  [
                                    116.249,
                                    106.371
                                  ],
                                  [
                                    83.049,
                                    121.171
                                  ],
                                  [
                                    62.849,
                                    127.471
                                  ],
                                  [
                                    31.049,
                                    133.571
                                  ],
                                  [
                                    -38.351,
                                    133.671
                                  ],
                                  [
                                    -67.551,
                                    125.471
                                  ],
                                  [
                                    -241.551,
                                    -107.229
                                  ],
                                  [
                                    1.149,
                                    -349.829
                                  ],
                                  [
                                    93.749,
                                    -331.429
                                  ],
                                  [
                                    74.749,
                                    -331.429
                                  ],
                                  [
                                    56.349,
                                    -340.629
                                  ],
                                  [
                                    51.149,
                                    -337.929
                                  ],
                                  [
                                    63.649,
                                    -331.529
                                  ],
                                  [
                                    45.149,
                                    -331.529
                                  ],
                                  [
                                    35.749,
                                    -340.729
                                  ],
                                  [
                                    30.549,
                                    -338.029
                                  ],
                                  [
                                    36.549,
                                    -331.629
                                  ],
                                  [
                                    6.049,
                                    -331.629
                                  ],
                                  [
                                    6.049,
                                    -338.029
                                  ],
                                  [
                                    3.049,
                                    -342.929
                                  ],
                                  [
                                    0.049,
                                    -340.429
                                  ],
                                  [
                                    0.049,
                                    -331.529
                                  ],
                                  [
                                    -17.951,
                                    -331.529
                                  ],
                                  [
                                    -11.951,
                                    -337.929
                                  ],
                                  [
                                    -17.051,
                                    -340.629
                                  ],
                                  [
                                    -26.451,
                                    -331.429
                                  ],
                                  [
                                    -44.951,
                                    -331.429
                                  ],
                                  [
                                    -32.451,
                                    -337.829
                                  ],
                                  [
                                    -37.551,
                                    -340.529
                                  ],
                                  [
                                    -55.951,
                                    -331.329
                                  ],
                                  [
                                    -87.751,
                                    -331.329
                                  ],
                                  [
                                    -90.251,
                                    -328.829
                                  ],
                                  [
                                    -87.751,
                                    -326.329
                                  ],
                                  [
                                    -64.251,
                                    -326.329
                                  ],
                                  [
                                    -112.651,
                                    -287.629
                                  ],
                                  [
                                    -152.151,
                                    -287.629
                                  ],
                                  [
                                    -154.651,
                                    -285.129
                                  ],
                                  [
                                    -152.151,
                                    -282.629
                                  ],
                                  [
                                    -117.751,
                                    -282.629
                                  ],
                                  [
                                    -150.651,
                                    -243.229
                                  ],
                                  [
                                    -190.351,
                                    -243.229
                                  ],
                                  [
                                    -192.851,
                                    -240.729
                                  ],
                                  [
                                    -190.351,
                                    -238.229
                                  ],
                                  [
                                    -154.051,
                                    -238.229
                                  ],
                                  [
                                    -182.651,
                                    -180.429
                                  ],
                                  [
                                    -221.651,
                                    -180.429
                                  ],
                                  [
                                    -224.151,
                                    -177.929
                                  ],
                                  [
                                    -221.651,
                                    -175.429
                                  ],
                                  [
                                    -184.151,
                                    -175.429
                                  ],
                                  [
                                    -194.451,
                                    -112.029
                                  ],
                                  [
                                    -233.251,
                                    -112.029
                                  ],
                                  [
                                    -235.751,
                                    -109.529
                                  ],
                                  [
                                    -233.251,
                                    -107.029
                                  ],
                                  [
                                    -194.551,
                                    -107.029
                                  ],
                                  [
                                    -185.351,
                                    -39.029
                                  ],
                                  [
                                    -221.651,
                                    -39.029
                                  ],
                                  [
                                    -224.151,
                                    -36.529
                                  ],
                                  [
                                    -221.651,
                                    -34.029
                                  ],
                                  [
                                    -183.751,
                                    -34.029
                                  ],
                                  [
                                    -160.751,
                                    16.171
                                  ],
                                  [
                                    -193.751,
                                    16.171
                                  ],
                                  [
                                    -196.251,
                                    18.671
                                  ],
                                  [
                                    -193.751,
                                    21.171
                                  ],
                                  [
                                    -157.751,
                                    21.171
                                  ],
                                  [
                                    -127.451,
                                    60.171
                                  ],
                                  [
                                    -158.851,
                                    60.171
                                  ],
                                  [
                                    -161.351,
                                    62.671
                                  ],
                                  [
                                    -158.851,
                                    65.171
                                  ],
                                  [
                                    -122.651,
                                    65.171
                                  ],
                                  [
                                    -107.551,
                                    79.471
                                  ],
                                  [
                                    -113.551,
                                    65.571
                                  ],
                                  [
                                    -113.951,
                                    65.171
                                  ],
                                  [
                                    -113.651,
                                    65.171
                                  ],
                                  [
                                    -115.451,
                                    60.171
                                  ],
                                  [
                                    -118.851,
                                    60.171
                                  ],
                                  [
                                    -150.151,
                                    21.171
                                  ],
                                  [
                                    -122.251,
                                    21.171
                                  ],
                                  [
                                    -121.451,
                                    16.171
                                  ],
                                  [
                                    -153.351,
                                    16.171
                                  ],
                                  [
                                    -177.151,
                                    -34.029
                                  ],
                                  [
                                    -123.451,
                                    -34.029
                                  ],
                                  [
                                    -123.651,
                                    -39.029
                                  ],
                                  [
                                    -178.751,
                                    -39.029
                                  ],
                                  [
                                    -189.051,
                                    -106.729
                                  ],
                                  [
                                    -189.051,
                                    -107.129
                                  ],
                                  [
                                    -146.051,
                                    -107.129
                                  ],
                                  [
                                    -148.551,
                                    -112.129
                                  ],
                                  [
                                    -189.051,
                                    -112.129
                                  ],
                                  [
                                    -179.051,
                                    -175.529
                                  ],
                                  [
                                    -153.451,
                                    -175.529
                                  ],
                                  [
                                    -153.951,
                                    -180.529
                                  ],
                                  [
                                    -177.451,
                                    -180.529
                                  ],
                                  [
                                    -148.651,
                                    -238.329
                                  ],
                                  [
                                    -81.151,
                                    -238.329
                                  ],
                                  [
                                    -75.851,
                                    -243.329
                                  ],
                                  [
                                    -145.251,
                                    -243.329
                                  ],
                                  [
                                    -111.051,
                                    -282.729
                                  ],
                                  [
                                    -58.751,
                                    -282.729
                                  ],
                                  [
                                    -75.051,
                                    -243.93
                                  ],
                                  [
                                    -65.751,
                                    -249.43
                                  ],
                                  [
                                    -50.551,
                                    -282.729
                                  ],
                                  [
                                    -13.051,
                                    -282.729
                                  ],
                                  [
                                    2.749,
                                    -286.529
                                  ],
                                  [
                                    6.049,
                                    -294.129
                                  ],
                                  [
                                    6.049,
                                    -326.429
                                  ],
                                  [
                                    40.749,
                                    -326.429
                                  ],
                                  [
                                    50.848,
                                    -312.929
                                  ],
                                  [
                                    55.249,
                                    -312.829
                                  ],
                                  [
                                    60.249,
                                    -311.929
                                  ],
                                  [
                                    49.449,
                                    -326.429
                                  ],
                                  [
                                    72.249,
                                    -326.429
                                  ],
                                  [
                                    124.149,
                                    -287.729
                                  ],
                                  [
                                    100.949,
                                    -287.729
                                  ],
                                  [
                                    104.949,
                                    -282.729
                                  ],
                                  [
                                    129.449,
                                    -282.729
                                  ],
                                  [
                                    163.649,
                                    -243.329
                                  ],
                                  [
                                    125.049,
                                    -243.329
                                  ],
                                  [
                                    134.049,
                                    -238.329
                                  ],
                                  [
                                    167.149,
                                    -238.329
                                  ],
                                  [
                                    195.949,
                                    -180.529
                                  ],
                                  [
                                    150.049,
                                    -180.529
                                  ],
                                  [
                                    150.249,
                                    -175.529
                                  ],
                                  [
                                    197.549,
                                    -175.529
                                  ],
                                  [
                                    201.549,
                                    -160.729
                                  ],
                                  [
                                    205.848,
                                    -164.429
                                  ],
                                  [
                                    202.649,
                                    -175.529
                                  ],
                                  [
                                    217.749,
                                    -175.529
                                  ],
                                  [
                                    222.749,
                                    -180.529
                                  ],
                                  [
                                    201.049,
                                    -180.529
                                  ],
                                  [
                                    172.449,
                                    -238.329
                                  ],
                                  [
                                    194.549,
                                    -238.329
                                  ],
                                  [
                                    197.049,
                                    -240.829
                                  ],
                                  [
                                    194.549,
                                    -243.329
                                  ],
                                  [
                                    169.049,
                                    -243.329
                                  ],
                                  [
                                    136.249,
                                    -282.729
                                  ],
                                  [
                                    155.449,
                                    -282.729
                                  ],
                                  [
                                    157.949,
                                    -285.229
                                  ],
                                  [
                                    155.449,
                                    -287.729
                                  ],
                                  [
                                    131.149,
                                    -287.729
                                  ],
                                  [
                                    82.749,
                                    -326.429
                                  ],
                                  [
                                    94.949,
                                    -326.429
                                  ],
                                  [
                                    97.449,
                                    -328.929
                                  ],
                                  [
                                    97.249,
                                    -329.929
                                  ],
                                  [
                                    229.849,
                                    -188.129
                                  ],
                                  [
                                    238.249,
                                    -197.529
                                  ],
                                  [
                                    180.449,
                                    -286.529
                                  ],
                                  [
                                    1.049,
                                    -360.829
                                  ],
                                  [
                                    -178.351,
                                    -286.529
                                  ],
                                  [
                                    -252.551,
                                    -107.229
                                  ],
                                  [
                                    -178.251,
                                    72.171
                                  ],
                                  [
                                    1.149,
                                    146.471
                                  ],
                                  [
                                    180.549,
                                    72.171
                                  ],
                                  [
                                    180.749,
                                    71.971
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 3",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                1,
                                1,
                                1,
                                1
                              ]
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ]
                            },
                            "r": {
                              "a": 0,
                              "k": 0
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "sk": {
                              "a": 0,
                              "k": 0
                            },
                            "sa": {
                              "a": 0,
                              "k": 0
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 1",
                        "bm": 0,
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    1.6,
                                    0.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    -1.4
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.5,
                                    0.3
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    -1.5,
                                    0.6
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.4,
                                    0
                                  ],
                                  [
                                    0,
                                    1.4
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.2,
                                    -2.5
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    -90.251,
                                    95.071
                                  ],
                                  [
                                    -94.851,
                                    95.071
                                  ],
                                  [
                                    -113.751,
                                    95.071
                                  ],
                                  [
                                    -116.251,
                                    97.571
                                  ],
                                  [
                                    -113.751,
                                    100.071
                                  ],
                                  [
                                    -89.551,
                                    100.071
                                  ],
                                  [
                                    -89.951,
                                    95.071
                                  ],
                                  [
                                    -90.251,
                                    95.071
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 1",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                1,
                                1,
                                1,
                                1
                              ]
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ]
                            },
                            "r": {
                              "a": 0,
                              "k": 0
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "sk": {
                              "a": 0,
                              "k": 0
                            },
                            "sa": {
                              "a": 0,
                              "k": 0
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 2",
                        "bm": 0,
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    -0.2,
                                    -4.1
                                  ],
                                  [
                                    -1.9,
                                    0.8
                                  ],
                                  [
                                    0.1,
                                    2.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    2.6,
                                    0.3
                                  ]
                                ],
                                "o": [
                                  [
                                    1.9,
                                    -1
                                  ],
                                  [
                                    -0.1,
                                    -2.1
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1,
                                    -0.8
                                  ],
                                  [
                                    -0.1,
                                    2.9
                                  ]
                                ],
                                "v": [
                                  [
                                    -97.451,
                                    -82.129
                                  ],
                                  [
                                    -91.651,
                                    -84.829
                                  ],
                                  [
                                    -91.851,
                                    -91.029
                                  ],
                                  [
                                    -91.951,
                                    -91.129
                                  ],
                                  [
                                    -97.551,
                                    -92.729
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 1",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                1,
                                1,
                                1,
                                1
                              ]
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ]
                            },
                            "r": {
                              "a": 0,
                              "k": 0
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "sk": {
                              "a": 0,
                              "k": 0
                            },
                            "sa": {
                              "a": 0,
                              "k": 0
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 3",
                        "bm": 0,
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0.6,
                                    -0.9
                                  ],
                                  [
                                    15.8,
                                    -8.3
                                  ],
                                  [
                                    3,
                                    -1
                                  ],
                                  [
                                    74.1,
                                    0
                                  ],
                                  [
                                    0,
                                    142.6
                                  ],
                                  [
                                    -142.6,
                                    0
                                  ],
                                  [
                                    -37.8,
                                    -95.9
                                  ],
                                  [
                                    -2.4,
                                    3
                                  ],
                                  [
                                    25.1,
                                    25.1
                                  ],
                                  [
                                    72,
                                    0
                                  ],
                                  [
                                    50.9,
                                    -50.9
                                  ],
                                  [
                                    0,
                                    -72
                                  ],
                                  [
                                    -50.9,
                                    -50.9
                                  ],
                                  [
                                    -72,
                                    0
                                  ],
                                  [
                                    -50.9,
                                    51
                                  ],
                                  [
                                    -13.2,
                                    29
                                  ],
                                  [
                                    3.6,
                                    -2.2
                                  ]
                                ],
                                "o": [
                                  [
                                    3.4,
                                    19.2
                                  ],
                                  [
                                    -3,
                                    1.6
                                  ],
                                  [
                                    -47.2,
                                    50.2
                                  ],
                                  [
                                    -142.6,
                                    0
                                  ],
                                  [
                                    0,
                                    -142.6
                                  ],
                                  [
                                    109.2,
                                    0
                                  ],
                                  [
                                    3,
                                    -3.6
                                  ],
                                  [
                                    -13.4,
                                    -31.8
                                  ],
                                  [
                                    -50.9,
                                    -50.9
                                  ],
                                  [
                                    -72,
                                    0
                                  ],
                                  [
                                    -50.9,
                                    50.9
                                  ],
                                  [
                                    0,
                                    72
                                  ],
                                  [
                                    50.9,
                                    50.9
                                  ],
                                  [
                                    72,
                                    0
                                  ],
                                  [
                                    23.2,
                                    -23.2
                                  ],
                                  [
                                    -9.5,
                                    9.4
                                  ],
                                  [
                                    -0.5,
                                    0.9
                                  ]
                                ],
                                "v": [
                                  [
                                    223.648,
                                    24.271
                                  ],
                                  [
                                    198.449,
                                    65.971
                                  ],
                                  [
                                    189.449,
                                    69.771
                                  ],
                                  [
                                    1.148,
                                    151.371
                                  ],
                                  [
                                    -257.451,
                                    -107.229
                                  ],
                                  [
                                    1.148,
                                    -365.829
                                  ],
                                  [
                                    241.749,
                                    -201.829
                                  ],
                                  [
                                    249.749,
                                    -211.729
                                  ],
                                  [
                                    191.749,
                                    -297.829
                                  ],
                                  [
                                    1.148,
                                    -376.729
                                  ],
                                  [
                                    -189.451,
                                    -297.829
                                  ],
                                  [
                                    -268.451,
                                    -107.229
                                  ],
                                  [
                                    -189.551,
                                    83.371
                                  ],
                                  [
                                    1.049,
                                    162.37
                                  ],
                                  [
                                    191.648,
                                    83.371
                                  ],
                                  [
                                    246.549,
                                    4.371
                                  ],
                                  [
                                    225.249,
                                    21.471
                                  ]
                                ],
                                "c": true
                              }
                            },
                            "nm": "Path 1",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                1,
                                1,
                                1,
                                1
                              ]
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ]
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ]
                            },
                            "r": {
                              "a": 0,
                              "k": 0
                            },
                            "o": {
                              "a": 0,
                              "k": 100
                            },
                            "sk": {
                              "a": 0,
                              "k": 0
                            },
                            "sa": {
                              "a": 0,
                              "k": 0
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 4",
                        "bm": 0,
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 3",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                -3.7,
                                4.6
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -2.4,
                                -7.2
                              ],
                              [
                                1.5,
                                6.4
                              ]
                            ],
                            "o": [
                              [
                                -1.5,
                                -6.4
                              ],
                              [
                                3.7,
                                -4.5
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.4,
                                7.4
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -153.551,
                                -143.129
                              ],
                              [
                                -151.451,
                                -168.929
                              ],
                              [
                                -146.251,
                                -168.929
                              ],
                              [
                                -146.251,
                                -145.029
                              ],
                              [
                                -153.551,
                                -143.129
                              ]
                            ],
                            "c": false
                          }
                        },
                        "nm": "Path 1",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            1,
                            1,
                            1,
                            1
                          ]
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ]
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ]
                        },
                        "r": {
                          "a": 0,
                          "k": 0
                        },
                        "o": {
                          "a": 0,
                          "k": 100
                        },
                        "sk": {
                          "a": 0,
                          "k": 0
                        },
                        "sa": {
                          "a": 0,
                          "k": 0
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 4",
                    "bm": 0,
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ]
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ]
                    },
                    "r": {
                      "a": 0,
                      "k": 0
                    },
                    "o": {
                      "a": 0,
                      "k": 100
                    },
                    "sk": {
                      "a": 0,
                      "k": 0
                    },
                    "sa": {
                      "a": 0,
                      "k": 0
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "bm": 0,
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -160.273,
                        0
                      ],
                      [
                        0,
                        -160.273
                      ],
                      [
                        160.273,
                        0
                      ],
                      [
                        0,
                        160.273
                      ]
                    ],
                    "o": [
                      [
                        160.273,
                        0
                      ],
                      [
                        0,
                        160.273
                      ],
                      [
                        -160.273,
                        0
                      ],
                      [
                        0,
                        -160.273
                      ]
                    ],
                    "v": [
                      [
                        1.148,
                        -396.729
                      ],
                      [
                        291.349,
                        -106.529
                      ],
                      [
                        1.148,
                        183.671
                      ],
                      [
                        -289.052,
                        -106.529
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0.058823529631,
                    0.298039227724,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 0,
        "op": 240.0000097754,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 26,
        "ty": 4,
        "nm": "Layer 1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100
          },
          "r": {
            "a": 0,
            "k": 0
          },
          "p": {
            "a": 0,
            "k": [
              553.316,
              531.557,
              0
            ]
          },
          "a": {
            "a": 0,
            "k": [
              13.316,
              -8.443,
              0
            ]
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ]
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ty": "rc",
                "d": 1,
                "s": {
                  "a": 0,
                  "k": [
                    393.41,
                    43.139
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    12.847,
                    331.746
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Rectangle Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.552941203117,
                    0.713725507259,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "rc",
                "d": 1,
                "s": {
                  "a": 0,
                  "k": [
                    393.41,
                    43.139
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    12.847,
                    -344.881
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Rectangle Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.552941203117,
                    0.713725507259,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        2.863,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        2.863
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.863,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.863
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -2.863,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.863
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.863,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        2.863
                      ]
                    ],
                    "v": [
                      [
                        17.041,
                        397.626
                      ],
                      [
                        9.59,
                        397.626
                      ],
                      [
                        4.407,
                        392.443
                      ],
                      [
                        4.407,
                        384.992
                      ],
                      [
                        9.59,
                        379.808
                      ],
                      [
                        17.041,
                        379.808
                      ],
                      [
                        22.225,
                        384.992
                      ],
                      [
                        22.225,
                        392.443
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 0.469
                },
                "lc": 1,
                "lj": 1,
                "ml": 10,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "d": 1,
                "ty": "el",
                "s": {
                  "a": 0,
                  "k": [
                    43.139,
                    43.139
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    13.081,
                    388.952
                  ]
                },
                "nm": "Ellipse Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.376470595598,
                    0.376470595598,
                    0.376470595598,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 4",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "rc",
                "d": 1,
                "s": {
                  "a": 0,
                  "k": [
                    394.347,
                    719.766
                  ]
                },
                "p": {
                  "a": 0,
                  "k": [
                    13.081,
                    -6.333
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Rectangle Path 1",
                "hd": false
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "w": {
                  "a": 0,
                  "k": 0.469
                },
                "lc": 1,
                "lj": 1,
                "ml": 10,
                "bm": 0,
                "nm": "Stroke 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    1,
                    1,
                    1,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 5",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        2.978,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.978
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2.978,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        2.978
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -2.978,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        2.978
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.978,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -2.978
                      ]
                    ],
                    "v": [
                      [
                        125.853,
                        -398.336
                      ],
                      [
                        -99.69,
                        -398.336
                      ],
                      [
                        -105.082,
                        -392.944
                      ],
                      [
                        -105.082,
                        -392.944
                      ],
                      [
                        -99.69,
                        -387.551
                      ],
                      [
                        125.853,
                        -387.551
                      ],
                      [
                        131.245,
                        -392.944
                      ],
                      [
                        131.245,
                        -392.944
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.376470595598,
                    0.376470595598,
                    0.376470595598,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 6",
            "bm": 0,
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        39.241,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        39.241
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -39.241,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -39.241
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        -39.241,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -39.241
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        39.241,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        39.241
                      ]
                    ],
                    "v": [
                      [
                        159.601,
                        441
                      ],
                      [
                        -132.969,
                        441
                      ],
                      [
                        -204.021,
                        369.948
                      ],
                      [
                        -204.021,
                        -386.835
                      ],
                      [
                        -132.969,
                        -457.887
                      ],
                      [
                        159.601,
                        -457.887
                      ],
                      [
                        230.652,
                        -386.835
                      ],
                      [
                        230.652,
                        369.948
                      ]
                    ],
                    "c": true
                  }
                },
                "nm": "Path 1",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.207843139768,
                    0.207843139768,
                    0.207843139768,
                    1
                  ]
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ]
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ]
                },
                "r": {
                  "a": 0,
                  "k": 0
                },
                "o": {
                  "a": 0,
                  "k": 100
                },
                "sk": {
                  "a": 0,
                  "k": 0
                },
                "sa": {
                  "a": 0,
                  "k": 0
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 7",
            "bm": 0,
            "hd": false
          }
        ],
        "ip": 0,
        "op": 240.0000097754,
        "st": -4.00000016292334,
        "bm": 0
      }
    ],
    "markers": [
      
    ]
  };

  export const callAnimationData = {
    "v": "4.8.0",
    "meta": {
      "g": "LottieFiles AE ",
      "a": "",
      "k": "",
      "d": "",
      "tc": ""
    },
    "fr": 30,
    "ip": 0,
    "op": 120,
    "w": 500,
    "h": 500,
    "nm": "Comp 1",
    "ddd": 0,
    "assets": [
      
    ],
    "fonts": {
      "list": [
        {
          "fName": "TimesNewRomanPSMT",
          "fFamily": "Times New Roman",
          "fStyle": "Regular",
          "ascent": 69.4992065429688
        }
      ]
    },
    "layers": [
      {
        "ddd": 0,
        "ind": 1,
        "ty": 5,
        "nm": "24",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.21
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.79
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 49,
                "s": [
                  0
                ]
              },
              {
                "t": 67,
                "s": [
                  100
                ]
              }
            ],
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              139.366,
              178.281,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              13.501,
              -9.246,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "t": {
          "d": {
            "k": [
              {
                "s": {
                  "s": 27.3625640869141,
                  "f": "TimesNewRomanPSMT",
                  "t": "24",
                  "j": 0,
                  "tr": 0,
                  "lh": 32.8350769042969,
                  "ls": 0,
                  "fc": [
                    0,
                    0,
                    0
                  ]
                },
                "t": 0
              }
            ]
          },
          "p": {
            
          },
          "m": {
            "g": 1,
            "a": {
              "a": 0,
              "k": [
                0,
                0
              ],
              "ix": 2
            }
          },
          "a": [
            
          ]
        },
        "ip": 49,
        "op": 169,
        "st": 49,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 2,
        "ty": 4,
        "nm": "OBJECTS 11",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              139.902,
              179.496,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              139.902,
              179.496,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 44,
                "s": [
                  0,
                  0,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 45,
                "s": [
                  5.882,
                  5.882,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 46,
                "s": [
                  11.765,
                  11.765,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 47,
                "s": [
                  17.647,
                  17.647,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 48,
                "s": [
                  23.529,
                  23.529,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 49,
                "s": [
                  29.412,
                  29.412,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 50,
                "s": [
                  35.294,
                  35.294,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 51,
                "s": [
                  41.176,
                  41.176,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 52,
                "s": [
                  47.059,
                  47.059,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 53,
                "s": [
                  52.941,
                  52.941,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 54,
                "s": [
                  58.824,
                  58.824,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 55,
                "s": [
                  64.706,
                  64.706,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 56,
                "s": [
                  70.588,
                  70.588,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  76.471,
                  76.471,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  82.353,
                  82.353,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  88.235,
                  88.235,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.862,
                    0.862,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  94.118,
                  94.118,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.211,
                    0.211,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  103.832,
                  103.832,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  106.231,
                  106.231,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  107.096,
                  107.096,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  106.603,
                  106.603,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  105.117,
                  105.117,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  103.091,
                  103.091,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  100.973,
                  100.973,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  99.134,
                  99.134,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  97.822,
                  97.822,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  97.145,
                  97.145,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  97.082,
                  97.082,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  97.517,
                  97.517,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  98.273,
                  98.273,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  99.159,
                  99.159,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  100.666,
                  100.666,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  101.083,
                  101.083,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  101.233,
                  101.233,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  101.147,
                  101.147,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  100.889,
                  100.889,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  100.537,
                  100.537,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  100.169,
                  100.169,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  99.85,
                  99.85,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  99.622,
                  99.622,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  99.504,
                  99.504,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  99.493,
                  99.493,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  99.568,
                  99.568,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  99.7,
                  99.7,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  99.854,
                  99.854,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  100.116,
                  100.116,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  100.188,
                  100.188,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  100.214,
                  100.214,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  100.199,
                  100.199,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  100.155,
                  100.155,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  100.093,
                  100.093,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  100.029,
                  100.029,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  99.974,
                  99.974,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  99.934,
                  99.934,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  99.914,
                  99.914,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  99.912,
                  99.912,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  99.925,
                  99.925,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  99.948,
                  99.948,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  99.975,
                  99.975,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  100.02,
                  100.02,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  100.033,
                  100.033,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  100.037,
                  100.037,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  100.035,
                  100.035,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  100.027,
                  100.027,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  100.016,
                  100.016,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  100.005,
                  100.005,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  99.995,
                  99.995,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  99.989,
                  99.989,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  99.985,
                  99.985,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  99.985,
                  99.985,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  99.987,
                  99.987,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  99.991,
                  99.991,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  99.996,
                  99.996,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  100.003,
                  100.003,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  100.006,
                  100.006,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  100.006,
                  100.006,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  100.006,
                  100.006,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  100.005,
                  100.005,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  100.003,
                  100.003,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  99.998,
                  99.998,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  99.998,
                  99.998,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  99.998,
                  99.998,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 141,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 142,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 143,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 144,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 145,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 146,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 147,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 148,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 149,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 150,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 151,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 152,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 153,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 154,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 155,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 156,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 157,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 158,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 159,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 160,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 161,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 162,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "t": 163,
                "s": [
                  100,
                  100,
                  100
                ]
              }
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "Scale - Overshoot",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 15,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Scale - Bounce",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 40,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Scale - Friction",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 3,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 70,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            7.663,
                            4.855
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.002,
                            -8.681
                          ],
                          [
                            4.415,
                            -4.418
                          ],
                          [
                            6.738,
                            -0.001
                          ],
                          [
                            4.418,
                            4.415
                          ],
                          [
                            0.001,
                            6.738
                          ],
                          [
                            -4.415,
                            4.418
                          ],
                          [
                            -6.739,
                            0.001
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.001,
                            -15.126
                          ],
                          [
                            -15.125,
                            -0.001
                          ],
                          [
                            -0.001,
                            15.125
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            6.831,
                            4.322
                          ],
                          [
                            -0.001,
                            6.738
                          ],
                          [
                            -4.418,
                            4.415
                          ],
                          [
                            -6.739,
                            -0.001
                          ],
                          [
                            -4.415,
                            -4.418
                          ],
                          [
                            0.001,
                            -6.739
                          ],
                          [
                            4.418,
                            -4.415
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -15.125,
                            0.001
                          ],
                          [
                            0.001,
                            15.125
                          ],
                          [
                            15.125,
                            -0.001
                          ],
                          [
                            -0.002,
                            -9.742
                          ]
                        ],
                        "v": [
                          [
                            14.633,
                            -23.148
                          ],
                          [
                            16.139,
                            -25.503
                          ],
                          [
                            13.819,
                            -25.824
                          ],
                          [
                            4.281,
                            -27.142
                          ],
                          [
                            10.734,
                            -17.052
                          ],
                          [
                            13.016,
                            -20.62
                          ],
                          [
                            24.386,
                            0
                          ],
                          [
                            17.243,
                            17.243
                          ],
                          [
                            0,
                            24.386
                          ],
                          [
                            -17.243,
                            17.243
                          ],
                          [
                            -24.386,
                            0
                          ],
                          [
                            -17.243,
                            -17.244
                          ],
                          [
                            0,
                            -24.386
                          ],
                          [
                            0,
                            -27.386
                          ],
                          [
                            -27.386,
                            0
                          ],
                          [
                            0,
                            27.386
                          ],
                          [
                            27.386,
                            0
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.192156866193,
                        0.20000000298,
                        0.517647087574,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        139.902,
                        179.496
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    139.902,
                    179.496
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    139.902,
                    179.496
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 1,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            -18.389
                          ],
                          [
                            18.389,
                            0
                          ],
                          [
                            0,
                            18.389
                          ],
                          [
                            -18.389,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            18.389
                          ],
                          [
                            -18.389,
                            0
                          ],
                          [
                            0,
                            -18.389
                          ],
                          [
                            18.389,
                            0
                          ]
                        ],
                        "v": [
                          [
                            33.297,
                            0
                          ],
                          [
                            0,
                            33.297
                          ],
                          [
                            -33.297,
                            0
                          ],
                          [
                            0,
                            -33.297
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.662745118141,
                        0.721568644047,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    139.902,
                    179.496
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 1,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 44,
        "op": 164,
        "st": 44,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 3,
        "ty": 4,
        "nm": "OBJECTS 10",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              179.563,
              90.393,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              179.563,
              90.393,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 22,
                "s": [
                  0,
                  0,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 23,
                "s": [
                  7.692,
                  7.692,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 24,
                "s": [
                  15.385,
                  15.385,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 25,
                "s": [
                  23.077,
                  23.077,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 26,
                "s": [
                  30.769,
                  30.769,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 27,
                "s": [
                  38.462,
                  38.462,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 28,
                "s": [
                  46.154,
                  46.154,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 29,
                "s": [
                  53.846,
                  53.846,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 30,
                "s": [
                  61.538,
                  61.538,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 31,
                "s": [
                  69.231,
                  69.231,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 32,
                "s": [
                  76.923,
                  76.923,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 33,
                "s": [
                  84.615,
                  84.615,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.862,
                    0.862,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 34,
                "s": [
                  92.308,
                  92.308,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.211,
                    0.211,
                    0
                  ]
                },
                "t": 35,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 36,
                "s": [
                  105.012,
                  105.012,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 37,
                "s": [
                  108.148,
                  108.148,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 38,
                "s": [
                  109.28,
                  109.28,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 39,
                "s": [
                  108.635,
                  108.635,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 40,
                "s": [
                  106.691,
                  106.691,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 41,
                "s": [
                  104.041,
                  104.041,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 42,
                "s": [
                  101.272,
                  101.272,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 43,
                "s": [
                  98.868,
                  98.868,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 44,
                "s": [
                  97.152,
                  97.152,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 45,
                "s": [
                  96.266,
                  96.266,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 46,
                "s": [
                  96.184,
                  96.184,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 47,
                "s": [
                  96.753,
                  96.753,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 48,
                "s": [
                  97.742,
                  97.742,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 49,
                "s": [
                  98.9,
                  98.9,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 50,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 51,
                "s": [
                  100.871,
                  100.871,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 52,
                "s": [
                  101.416,
                  101.416,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 53,
                "s": [
                  101.613,
                  101.613,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 54,
                "s": [
                  101.501,
                  101.501,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 55,
                "s": [
                  101.163,
                  101.163,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 56,
                "s": [
                  100.702,
                  100.702,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  100.221,
                  100.221,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  99.803,
                  99.803,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  99.505,
                  99.505,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  99.351,
                  99.351,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  99.337,
                  99.337,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  99.436,
                  99.436,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  99.608,
                  99.608,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  99.809,
                  99.809,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  100.151,
                  100.151,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  100.246,
                  100.246,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  100.28,
                  100.28,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  100.261,
                  100.261,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  100.202,
                  100.202,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  100.122,
                  100.122,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  100.038,
                  100.038,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  99.966,
                  99.966,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  99.914,
                  99.914,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  99.887,
                  99.887,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  99.885,
                  99.885,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  99.902,
                  99.902,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  99.932,
                  99.932,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  99.967,
                  99.967,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  100.026,
                  100.026,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  100.043,
                  100.043,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  100.049,
                  100.049,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  100.045,
                  100.045,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  100.035,
                  100.035,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  100.021,
                  100.021,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  100.007,
                  100.007,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  99.994,
                  99.994,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  99.985,
                  99.985,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  99.98,
                  99.98,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  99.98,
                  99.98,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  99.983,
                  99.983,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  99.988,
                  99.988,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  99.994,
                  99.994,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  100.005,
                  100.005,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  100.007,
                  100.007,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  100.008,
                  100.008,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  100.008,
                  100.008,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  100.006,
                  100.006,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  100.004,
                  100.004,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  99.998,
                  99.998,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "t": 141,
                "s": [
                  100,
                  100,
                  100
                ]
              }
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "Scale - Overshoot",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 15,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Scale - Bounce",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 40,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Scale - Friction",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 3,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 70,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            -1.581
                          ],
                          [
                            1.581,
                            0
                          ],
                          [
                            0,
                            1.58
                          ],
                          [
                            -1.581,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            1.58
                          ],
                          [
                            -1.581,
                            0
                          ],
                          [
                            0,
                            -1.581
                          ],
                          [
                            1.581,
                            0
                          ]
                        ],
                        "v": [
                          [
                            2.862,
                            0
                          ],
                          [
                            0,
                            2.862
                          ],
                          [
                            -2.862,
                            0
                          ],
                          [
                            0,
                            -2.862
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.654901981354,
                        0.819607853889,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        190.81,
                        90.393
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            -1.581
                          ],
                          [
                            1.581,
                            0
                          ],
                          [
                            0,
                            1.58
                          ],
                          [
                            -1.58,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            1.58
                          ],
                          [
                            -1.58,
                            0
                          ],
                          [
                            0,
                            -1.581
                          ],
                          [
                            1.581,
                            0
                          ]
                        ],
                        "v": [
                          [
                            2.862,
                            0
                          ],
                          [
                            0,
                            2.862
                          ],
                          [
                            -2.862,
                            0
                          ],
                          [
                            0,
                            -2.862
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.654901981354,
                        0.819607853889,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        179.563,
                        90.393
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            -1.581
                          ],
                          [
                            1.581,
                            0
                          ],
                          [
                            0,
                            1.58
                          ],
                          [
                            -1.58,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            1.58
                          ],
                          [
                            -1.58,
                            0
                          ],
                          [
                            0,
                            -1.581
                          ],
                          [
                            1.581,
                            0
                          ]
                        ],
                        "v": [
                          [
                            2.862,
                            0
                          ],
                          [
                            0,
                            2.862
                          ],
                          [
                            -2.862,
                            0
                          ],
                          [
                            0,
                            -2.862
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.654901981354,
                        0.819607853889,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        168.315,
                        90.393
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    168.315,
                    90.393
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    168.315,
                    90.393
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        6.001
                      ],
                      [
                        11.727,
                        0
                      ],
                      [
                        0,
                        -9.423
                      ],
                      [
                        -11.727,
                        0
                      ],
                      [
                        -1.732,
                        0.367
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        -9.423
                      ],
                      [
                        -11.727,
                        0
                      ],
                      [
                        0,
                        9.423
                      ],
                      [
                        1.875,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        5.829,
                        -3.042
                      ]
                    ],
                    "v": [
                      [
                        21.234,
                        -1.961
                      ],
                      [
                        0,
                        -19.024
                      ],
                      [
                        -21.234,
                        -1.961
                      ],
                      [
                        0,
                        15.101
                      ],
                      [
                        5.417,
                        14.52
                      ],
                      [
                        12.942,
                        19.024
                      ],
                      [
                        11.541,
                        12.349
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.192156866193,
                    0.20000000298,
                    0.517647087574,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    179.563,
                    92.354
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -17.3
                      ],
                      [
                        17.3,
                        0
                      ],
                      [
                        0,
                        17.3
                      ],
                      [
                        -17.3,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        17.3
                      ],
                      [
                        -17.3,
                        0
                      ],
                      [
                        0,
                        -17.3
                      ],
                      [
                        17.3,
                        0
                      ]
                    ],
                    "v": [
                      [
                        31.324,
                        0
                      ],
                      [
                        0,
                        31.324
                      ],
                      [
                        -31.324,
                        0
                      ],
                      [
                        0,
                        -31.324
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.662745118141,
                    0.721568644047,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    179.563,
                    90.393
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 22,
        "op": 142,
        "st": 22,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 4,
        "ty": 4,
        "nm": "OBJECTS 9",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              320.437,
              90.393,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              320.437,
              90.393,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 32,
                "s": [
                  0,
                  0,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 33,
                "s": [
                  7.692,
                  7.692,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 34,
                "s": [
                  15.385,
                  15.385,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 35,
                "s": [
                  23.077,
                  23.077,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 36,
                "s": [
                  30.769,
                  30.769,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 37,
                "s": [
                  38.462,
                  38.462,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 38,
                "s": [
                  46.154,
                  46.154,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 39,
                "s": [
                  53.846,
                  53.846,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 40,
                "s": [
                  61.538,
                  61.538,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 41,
                "s": [
                  69.231,
                  69.231,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 42,
                "s": [
                  76.923,
                  76.923,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 43,
                "s": [
                  84.615,
                  84.615,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.862,
                    0.862,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 44,
                "s": [
                  92.308,
                  92.308,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.211,
                    0.211,
                    0
                  ]
                },
                "t": 45,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 46,
                "s": [
                  105.012,
                  105.012,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 47,
                "s": [
                  108.148,
                  108.148,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 48,
                "s": [
                  109.28,
                  109.28,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 49,
                "s": [
                  108.635,
                  108.635,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 50,
                "s": [
                  106.691,
                  106.691,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 51,
                "s": [
                  104.041,
                  104.041,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 52,
                "s": [
                  101.272,
                  101.272,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 53,
                "s": [
                  98.868,
                  98.868,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 54,
                "s": [
                  97.152,
                  97.152,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 55,
                "s": [
                  96.266,
                  96.266,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 56,
                "s": [
                  96.184,
                  96.184,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  96.753,
                  96.753,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  97.742,
                  97.742,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  98.9,
                  98.9,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  100.871,
                  100.871,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  101.416,
                  101.416,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  101.613,
                  101.613,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  101.501,
                  101.501,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  101.163,
                  101.163,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  100.702,
                  100.702,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  100.221,
                  100.221,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  99.803,
                  99.803,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  99.505,
                  99.505,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  99.351,
                  99.351,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  99.337,
                  99.337,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  99.436,
                  99.436,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  99.608,
                  99.608,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  99.809,
                  99.809,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  100.151,
                  100.151,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  100.246,
                  100.246,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  100.28,
                  100.28,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  100.261,
                  100.261,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  100.202,
                  100.202,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  100.122,
                  100.122,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  100.038,
                  100.038,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  99.966,
                  99.966,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  99.914,
                  99.914,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  99.887,
                  99.887,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  99.885,
                  99.885,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  99.902,
                  99.902,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  99.932,
                  99.932,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  99.967,
                  99.967,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  100.026,
                  100.026,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  100.043,
                  100.043,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  100.049,
                  100.049,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  100.045,
                  100.045,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  100.035,
                  100.035,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  100.021,
                  100.021,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  100.007,
                  100.007,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  99.994,
                  99.994,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  99.985,
                  99.985,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  99.98,
                  99.98,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  99.98,
                  99.98,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  99.983,
                  99.983,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  99.988,
                  99.988,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  99.994,
                  99.994,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  100.005,
                  100.005,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  100.007,
                  100.007,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  100.008,
                  100.008,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  100.008,
                  100.008,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  100.006,
                  100.006,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  100.004,
                  100.004,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  99.998,
                  99.998,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 141,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 142,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 143,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 144,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 145,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 146,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 147,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 148,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 149,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 150,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "t": 151,
                "s": [
                  100,
                  100,
                  100
                ]
              }
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "Scale - Overshoot",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 15,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Scale - Bounce",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 40,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Scale - Friction",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 3,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 70,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            18.795,
                            -12.505
                          ],
                          [
                            18.795,
                            12.515
                          ],
                          [
                            -18.795,
                            12.515
                          ],
                          [
                            -18.795,
                            -12.515
                          ],
                          [
                            0.005,
                            0.605
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.192156866193,
                        0.20000000298,
                        0.517647087574,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        321.187,
                        91.167
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            0.005,
                            5.955
                          ],
                          [
                            -17.055,
                            -5.955
                          ],
                          [
                            17.055,
                            -5.955
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.192156866193,
                        0.20000000298,
                        0.517647087574,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        321.187,
                        83.387
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    321.187,
                    83.387
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    321.187,
                    83.387
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            -17.3
                          ],
                          [
                            17.3,
                            0
                          ],
                          [
                            0,
                            17.3
                          ],
                          [
                            -17.3,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            17.3
                          ],
                          [
                            -17.3,
                            0
                          ],
                          [
                            0,
                            -17.3
                          ],
                          [
                            17.3,
                            0
                          ]
                        ],
                        "v": [
                          [
                            31.324,
                            0
                          ],
                          [
                            0,
                            31.324
                          ],
                          [
                            -31.324,
                            0
                          ],
                          [
                            0,
                            -31.324
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.662745118141,
                        0.721568644047,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    320.437,
                    90.393
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 1,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 32,
        "op": 152,
        "st": 32,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 5,
        "ty": 4,
        "nm": "OBJECTS 2",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              356.066,
              179.268,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              356.066,
              179.268,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 40,
                "s": [
                  0,
                  0,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 41,
                "s": [
                  9.091,
                  9.091,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 42,
                "s": [
                  18.182,
                  18.182,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 43,
                "s": [
                  27.273,
                  27.273,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 44,
                "s": [
                  36.364,
                  36.364,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 45,
                "s": [
                  45.455,
                  45.455,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 46,
                "s": [
                  54.545,
                  54.545,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 47,
                "s": [
                  63.636,
                  63.636,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 48,
                "s": [
                  72.727,
                  72.727,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 49,
                "s": [
                  81.818,
                  81.818,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.862,
                    0.862,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.167,
                    0.167,
                    0
                  ]
                },
                "t": 50,
                "s": [
                  90.909,
                  90.909,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.211,
                    0.211,
                    0
                  ]
                },
                "t": 51,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 52,
                "s": [
                  105.923,
                  105.923,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 53,
                "s": [
                  109.63,
                  109.63,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 54,
                "s": [
                  110.967,
                  110.967,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 55,
                "s": [
                  110.205,
                  110.205,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 56,
                "s": [
                  107.908,
                  107.908,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 57,
                "s": [
                  104.776,
                  104.776,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 58,
                "s": [
                  101.503,
                  101.503,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 59,
                "s": [
                  98.662,
                  98.662,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 60,
                "s": [
                  96.634,
                  96.634,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 61,
                "s": [
                  95.587,
                  95.587,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 62,
                "s": [
                  95.49,
                  95.49,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 63,
                "s": [
                  96.162,
                  96.162,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 64,
                "s": [
                  97.331,
                  97.331,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 65,
                "s": [
                  98.7,
                  98.7,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 66,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 67,
                "s": [
                  101.029,
                  101.029,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 68,
                "s": [
                  101.673,
                  101.673,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 69,
                "s": [
                  101.906,
                  101.906,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 70,
                "s": [
                  101.773,
                  101.773,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 71,
                "s": [
                  101.374,
                  101.374,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 72,
                "s": [
                  100.83,
                  100.83,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 73,
                "s": [
                  100.261,
                  100.261,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 74,
                "s": [
                  99.768,
                  99.768,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 75,
                "s": [
                  99.415,
                  99.415,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 76,
                "s": [
                  99.233,
                  99.233,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 77,
                "s": [
                  99.216,
                  99.216,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 78,
                "s": [
                  99.333,
                  99.333,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 79,
                "s": [
                  99.536,
                  99.536,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 80,
                "s": [
                  99.774,
                  99.774,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 81,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 82,
                "s": [
                  100.179,
                  100.179,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 83,
                "s": [
                  100.291,
                  100.291,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 84,
                "s": [
                  100.331,
                  100.331,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 85,
                "s": [
                  100.308,
                  100.308,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 86,
                "s": [
                  100.239,
                  100.239,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 87,
                "s": [
                  100.144,
                  100.144,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 88,
                "s": [
                  100.045,
                  100.045,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 89,
                "s": [
                  99.96,
                  99.96,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 90,
                "s": [
                  99.898,
                  99.898,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 91,
                "s": [
                  99.867,
                  99.867,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 92,
                "s": [
                  99.864,
                  99.864,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 93,
                "s": [
                  99.884,
                  99.884,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 94,
                "s": [
                  99.919,
                  99.919,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 95,
                "s": [
                  99.961,
                  99.961,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 96,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 97,
                "s": [
                  100.031,
                  100.031,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 98,
                "s": [
                  100.051,
                  100.051,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 99,
                "s": [
                  100.058,
                  100.058,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 100,
                "s": [
                  100.054,
                  100.054,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 101,
                "s": [
                  100.041,
                  100.041,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 102,
                "s": [
                  100.025,
                  100.025,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 103,
                "s": [
                  100.008,
                  100.008,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 104,
                "s": [
                  99.993,
                  99.993,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 105,
                "s": [
                  99.982,
                  99.982,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 106,
                "s": [
                  99.977,
                  99.977,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 107,
                "s": [
                  99.976,
                  99.976,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 108,
                "s": [
                  99.98,
                  99.98,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 109,
                "s": [
                  99.986,
                  99.986,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 110,
                "s": [
                  99.993,
                  99.993,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 111,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 112,
                "s": [
                  100.005,
                  100.005,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 113,
                "s": [
                  100.009,
                  100.009,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 114,
                "s": [
                  100.01,
                  100.01,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 115,
                "s": [
                  100.009,
                  100.009,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 116,
                "s": [
                  100.007,
                  100.007,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 117,
                "s": [
                  100.004,
                  100.004,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 118,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 119,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 120,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 121,
                "s": [
                  99.996,
                  99.996,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 122,
                "s": [
                  99.996,
                  99.996,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 123,
                "s": [
                  99.997,
                  99.997,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 124,
                "s": [
                  99.998,
                  99.998,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 125,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 126,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 127,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 128,
                "s": [
                  100.002,
                  100.002,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 129,
                "s": [
                  100.002,
                  100.002,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 130,
                "s": [
                  100.002,
                  100.002,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 131,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 132,
                "s": [
                  100.001,
                  100.001,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 133,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 134,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 135,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 136,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 137,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 138,
                "s": [
                  99.999,
                  99.999,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 139,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 140,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 141,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 142,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.964,
                    0.964,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 143,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.665,
                    0.665,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    -0.063,
                    -0.063,
                    0
                  ]
                },
                "t": 144,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.803,
                    0.803,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.111,
                    0.111,
                    0
                  ]
                },
                "t": 145,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.83,
                    0.83,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.144,
                    0.144,
                    0
                  ]
                },
                "t": 146,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.844,
                    0.844,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.163,
                    0.163,
                    0
                  ]
                },
                "t": 147,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.857,
                    0.857,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.179,
                    0.179,
                    0
                  ]
                },
                "t": 148,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.874,
                    0.874,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.2,
                    0.2,
                    0
                  ]
                },
                "t": 149,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.909,
                    0.909,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.245,
                    0.245,
                    0
                  ]
                },
                "t": 150,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    1.496,
                    1.496,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.986,
                    0.986,
                    0
                  ]
                },
                "t": 151,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.772,
                    0.772,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.071,
                    0.071,
                    0
                  ]
                },
                "t": 152,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.819,
                    0.819,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.131,
                    0.131,
                    0
                  ]
                },
                "t": 153,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.838,
                    0.838,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.155,
                    0.155,
                    0
                  ]
                },
                "t": 154,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.851,
                    0.851,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.171,
                    0.171,
                    0
                  ]
                },
                "t": 155,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.865,
                    0.865,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.189,
                    0.189,
                    0
                  ]
                },
                "t": 156,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.887,
                    0.887,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.216,
                    0.216,
                    0
                  ]
                },
                "t": 157,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "i": {
                  "x": [
                    0.833,
                    0.833,
                    0.833
                  ],
                  "y": [
                    0.833,
                    0.833,
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.167,
                    0.167,
                    0.167
                  ],
                  "y": [
                    0.314,
                    0.314,
                    0
                  ]
                },
                "t": 158,
                "s": [
                  100,
                  100,
                  100
                ]
              },
              {
                "t": 159,
                "s": [
                  100,
                  100,
                  100
                ]
              }
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "Scale - Overshoot",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 15,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Scale - Bounce",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 40,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Scale - Friction",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 3,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 70,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        -2.968,
                        0.309
                      ],
                      [
                        -6.887,
                        6.887
                      ],
                      [
                        -0.48,
                        4.612
                      ],
                      [
                        1.375,
                        1.316
                      ],
                      [
                        0.525,
                        -0.776
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.734,
                        -0.444
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.45,
                        -1.36
                      ],
                      [
                        2.263,
                        -0.749
                      ],
                      [
                        0.741,
                        1.226
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.711,
                        -0.48
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.648,
                        -0.677
                      ]
                    ],
                    "o": [
                      [
                        4.612,
                        -0.48
                      ],
                      [
                        6.887,
                        -6.887
                      ],
                      [
                        0.309,
                        -2.968
                      ],
                      [
                        -0.677,
                        -0.648
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.48,
                        0.711
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        1.226,
                        0.741
                      ],
                      [
                        -0.749,
                        2.262
                      ],
                      [
                        -1.36,
                        0.45
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.444,
                        -0.734
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.776,
                        0.525
                      ],
                      [
                        1.316,
                        1.375
                      ]
                    ],
                    "v": [
                      [
                        -11.284,
                        18.335
                      ],
                      [
                        7.811,
                        7.811
                      ],
                      [
                        18.335,
                        -11.284
                      ],
                      [
                        15.395,
                        -17.943
                      ],
                      [
                        13.103,
                        -17.712
                      ],
                      [
                        6.557,
                        -8.03
                      ],
                      [
                        7.023,
                        -5.907
                      ],
                      [
                        8.386,
                        -5.083
                      ],
                      [
                        9.295,
                        -1.519
                      ],
                      [
                        -1.519,
                        9.295
                      ],
                      [
                        -5.083,
                        8.386
                      ],
                      [
                        -5.907,
                        7.023
                      ],
                      [
                        -8.03,
                        6.557
                      ],
                      [
                        -17.712,
                        13.103
                      ],
                      [
                        -17.943,
                        15.395
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.192156866193,
                    0.20000000298,
                    0.517647087574,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    356.066,
                    178.493
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        -17.3
                      ],
                      [
                        17.3,
                        0
                      ],
                      [
                        0,
                        17.3
                      ],
                      [
                        -17.3,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        17.3
                      ],
                      [
                        -17.3,
                        0
                      ],
                      [
                        0,
                        -17.3
                      ],
                      [
                        17.3,
                        0
                      ]
                    ],
                    "v": [
                      [
                        31.324,
                        0
                      ],
                      [
                        0,
                        31.324
                      ],
                      [
                        -31.324,
                        0
                      ],
                      [
                        0,
                        -31.324
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.662745118141,
                    0.721568644047,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    356.066,
                    179.268
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 40,
        "op": 160,
        "st": 40,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 6,
        "ty": 4,
        "nm": "laptop",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 8,
                "s": [
                  250,
                  755.99,
                  0
                ],
                "to": [
                  0,
                  -3.632,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 9,
                "s": [
                  250,
                  734.2,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 10,
                "s": [
                  250,
                  712.41,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 11,
                "s": [
                  250,
                  690.621,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 12,
                "s": [
                  250,
                  668.83,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 13,
                "s": [
                  250,
                  647.041,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 14,
                "s": [
                  250,
                  625.245,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.262,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 15,
                "s": [
                  250,
                  603.461,
                  0
                ],
                "to": [
                  0,
                  -7.262,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 16,
                "s": [
                  250,
                  581.673,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 17,
                "s": [
                  250,
                  559.883,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 18,
                "s": [
                  250,
                  538.095,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 19,
                "s": [
                  250,
                  516.306,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.262,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 20,
                "s": [
                  250,
                  494.519,
                  0
                ],
                "to": [
                  0,
                  -7.262,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 21,
                "s": [
                  250,
                  472.731,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 22,
                "s": [
                  250,
                  450.937,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 23,
                "s": [
                  250,
                  429.149,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 24,
                "s": [
                  250,
                  407.36,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 25,
                "s": [
                  250,
                  385.569,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.881
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 26,
                "s": [
                  250,
                  363.78,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  5.183,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.278
                },
                "t": 27,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  -5.183,
                  0
                ],
                "ti": [
                  0,
                  2.48,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 28,
                "s": [
                  250,
                  332.682,
                  0
                ],
                "to": [
                  0,
                  -2.48,
                  0
                ],
                "ti": [
                  0,
                  1.227,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 29,
                "s": [
                  250,
                  327.107,
                  0
                ],
                "to": [
                  0,
                  -1.227,
                  0
                ],
                "ti": [
                  0,
                  0.062,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 30,
                "s": [
                  250,
                  325.321,
                  0
                ],
                "to": [
                  0,
                  -0.062,
                  0
                ],
                "ti": [
                  0,
                  -0.841,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 31,
                "s": [
                  250,
                  326.735,
                  0
                ],
                "to": [
                  0,
                  0.841,
                  0
                ],
                "ti": [
                  0,
                  -1.392,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 32,
                "s": [
                  250,
                  330.364,
                  0
                ],
                "to": [
                  0,
                  1.392,
                  0
                ],
                "ti": [
                  0,
                  -1.581,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 33,
                "s": [
                  250,
                  335.084,
                  0
                ],
                "to": [
                  0,
                  1.581,
                  0
                ],
                "ti": [
                  0,
                  -1.463,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 34,
                "s": [
                  250,
                  339.852,
                  0
                ],
                "to": [
                  0,
                  1.463,
                  0
                ],
                "ti": [
                  0,
                  -1.128,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 35,
                "s": [
                  250,
                  343.86,
                  0
                ],
                "to": [
                  0,
                  1.128,
                  0
                ],
                "ti": [
                  0,
                  -0.683,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 36,
                "s": [
                  250,
                  346.619,
                  0
                ],
                "to": [
                  0,
                  0.683,
                  0
                ],
                "ti": [
                  0,
                  -0.228,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.635
                },
                "o": {
                  "x": 0.167,
                  "y": 0.469
                },
                "t": 37,
                "s": [
                  250,
                  347.958,
                  0
                ],
                "to": [
                  0,
                  0.228,
                  0
                ],
                "ti": [
                  0,
                  0.158,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 38,
                "s": [
                  250,
                  347.988,
                  0
                ],
                "to": [
                  0,
                  -0.158,
                  0
                ],
                "ti": [
                  0,
                  0.428,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 39,
                "s": [
                  250,
                  347.01,
                  0
                ],
                "to": [
                  0,
                  -0.428,
                  0
                ],
                "ti": [
                  0,
                  0.563,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 40,
                "s": [
                  250,
                  345.423,
                  0
                ],
                "to": [
                  0,
                  -0.563,
                  0
                ],
                "ti": [
                  0,
                  0.572,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 41,
                "s": [
                  250,
                  343.634,
                  0
                ],
                "to": [
                  0,
                  -0.572,
                  0
                ],
                "ti": [
                  0,
                  0.484,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 42,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  -0.484,
                  0
                ],
                "ti": [
                  0,
                  0.336,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 43,
                "s": [
                  250,
                  340.73,
                  0
                ],
                "to": [
                  0,
                  -0.336,
                  0
                ],
                "ti": [
                  0,
                  0.166,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 44,
                "s": [
                  250,
                  339.975,
                  0
                ],
                "to": [
                  0,
                  -0.166,
                  0
                ],
                "ti": [
                  0,
                  0.008,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 45,
                "s": [
                  250,
                  339.734,
                  0
                ],
                "to": [
                  0,
                  -0.008,
                  0
                ],
                "ti": [
                  0,
                  -0.114,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 46,
                "s": [
                  250,
                  339.925,
                  0
                ],
                "to": [
                  0,
                  0.114,
                  0
                ],
                "ti": [
                  0,
                  -0.188,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 47,
                "s": [
                  250,
                  340.416,
                  0
                ],
                "to": [
                  0,
                  0.188,
                  0
                ],
                "ti": [
                  0,
                  -0.214,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 48,
                "s": [
                  250,
                  341.055,
                  0
                ],
                "to": [
                  0,
                  0.214,
                  0
                ],
                "ti": [
                  0,
                  -0.198,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 49,
                "s": [
                  250,
                  341.7,
                  0
                ],
                "to": [
                  0,
                  0.198,
                  0
                ],
                "ti": [
                  0,
                  -0.153,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 50,
                "s": [
                  250,
                  342.243,
                  0
                ],
                "to": [
                  0,
                  0.153,
                  0
                ],
                "ti": [
                  0,
                  -0.092,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 51,
                "s": [
                  250,
                  342.616,
                  0
                ],
                "to": [
                  0,
                  0.092,
                  0
                ],
                "ti": [
                  0,
                  -0.031,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.633
                },
                "o": {
                  "x": 0.167,
                  "y": 0.471
                },
                "t": 52,
                "s": [
                  250,
                  342.797,
                  0
                ],
                "to": [
                  0,
                  0.031,
                  0
                ],
                "ti": [
                  0,
                  0.021,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 53,
                "s": [
                  250,
                  342.801,
                  0
                ],
                "to": [
                  0,
                  -0.021,
                  0
                ],
                "ti": [
                  0,
                  0.058,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 54,
                "s": [
                  250,
                  342.669,
                  0
                ],
                "to": [
                  0,
                  -0.058,
                  0
                ],
                "ti": [
                  0,
                  0.076,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 55,
                "s": [
                  250,
                  342.454,
                  0
                ],
                "to": [
                  0,
                  -0.076,
                  0
                ],
                "ti": [
                  0,
                  0.077,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 56,
                "s": [
                  250,
                  342.212,
                  0
                ],
                "to": [
                  0,
                  -0.077,
                  0
                ],
                "ti": [
                  0,
                  0.066,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 57,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  -0.066,
                  0
                ],
                "ti": [
                  0,
                  0.045,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 58,
                "s": [
                  250,
                  341.819,
                  0
                ],
                "to": [
                  0,
                  -0.045,
                  0
                ],
                "ti": [
                  0,
                  0.022,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 59,
                "s": [
                  250,
                  341.717,
                  0
                ],
                "to": [
                  0,
                  -0.022,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 60,
                "s": [
                  250,
                  341.684,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  -0.015,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 61,
                "s": [
                  250,
                  341.71,
                  0
                ],
                "to": [
                  0,
                  0.015,
                  0
                ],
                "ti": [
                  0,
                  -0.025,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 62,
                "s": [
                  250,
                  341.777,
                  0
                ],
                "to": [
                  0,
                  0.025,
                  0
                ],
                "ti": [
                  0,
                  -0.029,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 63,
                "s": [
                  250,
                  341.863,
                  0
                ],
                "to": [
                  0,
                  0.029,
                  0
                ],
                "ti": [
                  0,
                  -0.027,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 64,
                "s": [
                  250,
                  341.95,
                  0
                ],
                "to": [
                  0,
                  0.027,
                  0
                ],
                "ti": [
                  0,
                  -0.021,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 65,
                "s": [
                  250,
                  342.024,
                  0
                ],
                "to": [
                  0,
                  0.021,
                  0
                ],
                "ti": [
                  0,
                  -0.013,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 66,
                "s": [
                  250,
                  342.074,
                  0
                ],
                "to": [
                  0,
                  0.013,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.631
                },
                "o": {
                  "x": 0.167,
                  "y": 0.474
                },
                "t": 67,
                "s": [
                  250,
                  342.099,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 68,
                "s": [
                  250,
                  342.099,
                  0
                ],
                "to": [
                  0,
                  -0.003,
                  0
                ],
                "ti": [
                  0,
                  0.008,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 69,
                "s": [
                  250,
                  342.082,
                  0
                ],
                "to": [
                  0,
                  -0.008,
                  0
                ],
                "ti": [
                  0,
                  0.01,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 70,
                "s": [
                  250,
                  342.052,
                  0
                ],
                "to": [
                  0,
                  -0.01,
                  0
                ],
                "ti": [
                  0,
                  0.01,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 71,
                "s": [
                  250,
                  342.02,
                  0
                ],
                "to": [
                  0,
                  -0.01,
                  0
                ],
                "ti": [
                  0,
                  0.009,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 72,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  -0.009,
                  0
                ],
                "ti": [
                  0,
                  0.006,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 73,
                "s": [
                  250,
                  341.966,
                  0
                ],
                "to": [
                  0,
                  -0.006,
                  0
                ],
                "ti": [
                  0,
                  0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 74,
                "s": [
                  250,
                  341.953,
                  0
                ],
                "to": [
                  0,
                  -0.003,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 75,
                "s": [
                  250,
                  341.948,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -0.002,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 76,
                "s": [
                  250,
                  341.952,
                  0
                ],
                "to": [
                  0,
                  0.002,
                  0
                ],
                "ti": [
                  0,
                  -0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 77,
                "s": [
                  250,
                  341.961,
                  0
                ],
                "to": [
                  0,
                  0.003,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 78,
                "s": [
                  250,
                  341.972,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 79,
                "s": [
                  250,
                  341.984,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  -0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 80,
                "s": [
                  250,
                  341.994,
                  0
                ],
                "to": [
                  0,
                  0.003,
                  0
                ],
                "ti": [
                  0,
                  -0.002,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 81,
                "s": [
                  250,
                  342.001,
                  0
                ],
                "to": [
                  0,
                  0.002,
                  0
                ],
                "ti": [
                  0,
                  -0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.694
                },
                "o": {
                  "x": 0.167,
                  "y": 0.394
                },
                "t": 82,
                "s": [
                  250,
                  342.004,
                  0
                ],
                "to": [
                  0,
                  0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 83,
                "s": [
                  250,
                  342.004,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 84,
                "s": [
                  250,
                  342.002,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 85,
                "s": [
                  250,
                  341.998,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 86,
                "s": [
                  250,
                  341.994,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 87,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 88,
                "s": [
                  250,
                  341.986,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 89,
                "s": [
                  250,
                  341.985,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 90,
                "s": [
                  250,
                  341.984,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 91,
                "s": [
                  250,
                  341.984,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 92,
                "s": [
                  250,
                  341.986,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 93,
                "s": [
                  250,
                  341.987,
                  0
                ],
                "to": [
                  0,
                  0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 94,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 95,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 96,
                "s": [
                  250,
                  341.991,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.953,
                  "y": 0
                },
                "o": {
                  "x": 0.037,
                  "y": 1
                },
                "t": 97,
                "s": [
                  250,
                  341.992,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 98,
                "s": [
                  250,
                  341.992,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 99,
                "s": [
                  250,
                  341.991,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 100,
                "s": [
                  250,
                  341.991,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 101,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 102,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 103,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 104,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 105,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 106,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 107,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 108,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 109,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 110,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 111,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.953,
                  "y": 0
                },
                "o": {
                  "x": 0.037,
                  "y": 1
                },
                "t": 112,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 113,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 114,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 115,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 116,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 117,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 118,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 119,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 120,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 121,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 122,
                "s": [
                  250,
                  341.989,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 123,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 124,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 125,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 126,
                "s": [
                  250,
                  341.99,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "t": 127,
                "s": [
                  250,
                  341.99,
                  0
                ]
              }
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              250,
              341.99,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "Position - Overshoot",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 10,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Position - Bounce",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 40,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Position - Friction",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 3,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 80,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            -5.044
                          ],
                          [
                            5.044,
                            0
                          ],
                          [
                            0,
                            5.045
                          ],
                          [
                            -5.045,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            5.045
                          ],
                          [
                            -5.045,
                            0
                          ],
                          [
                            0,
                            -5.044
                          ],
                          [
                            5.044,
                            0
                          ]
                        ],
                        "v": [
                          [
                            9.134,
                            0
                          ],
                          [
                            0,
                            9.134
                          ],
                          [
                            -9.134,
                            0
                          ],
                          [
                            0,
                            -9.134
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.819607853889,
                        0.905882358551,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        250,
                        349.519
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            2.674,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.674
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -2.674,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            2.674
                          ]
                        ],
                        "v": [
                          [
                            67.001,
                            2.75
                          ],
                          [
                            -67.001,
                            2.75
                          ],
                          [
                            -71.842,
                            -2.091
                          ],
                          [
                            -71.842,
                            -2.75
                          ],
                          [
                            71.842,
                            -2.75
                          ],
                          [
                            71.842,
                            -2.091
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.811764717102,
                        0.92549020052,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        249.908,
                        395.356
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -4.568,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.334,
                            -4.555
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.334,
                            -4.555
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            4.568,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            71.934,
                            43.087
                          ],
                          [
                            -71.934,
                            43.087
                          ],
                          [
                            -77.635,
                            -34.652
                          ],
                          [
                            -69.796,
                            -43.087
                          ],
                          [
                            69.796,
                            -43.087
                          ],
                          [
                            77.635,
                            -34.652
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        1,
                        1,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        250,
                        349.519
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    250,
                    349.519
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    250,
                    349.519
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.847,
                            -6.197
                          ],
                          [
                            -1.847,
                            -6.197
                          ],
                          [
                            -1.847,
                            6.197
                          ],
                          [
                            1.847,
                            6.197
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.760784327984,
                        0.760784327984,
                        0.760784327984,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        275.763,
                        292.07
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            1.814,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.814
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.814,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.814
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            -1.814,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.814
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.814,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.814
                          ]
                        ],
                        "v": [
                          [
                            8.093,
                            18.476
                          ],
                          [
                            -8.093,
                            18.476
                          ],
                          [
                            -11.378,
                            15.191
                          ],
                          [
                            -11.378,
                            -15.192
                          ],
                          [
                            -8.093,
                            -18.476
                          ],
                          [
                            8.093,
                            -18.476
                          ],
                          [
                            11.378,
                            -15.192
                          ],
                          [
                            11.378,
                            15.191
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.819607853889,
                        0.905882358551,
                        1,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        275.763,
                        310.546
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    275.763,
                    310.546
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    275.763,
                    310.546
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 8,
        "op": 128,
        "st": 8,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 7,
        "ty": 4,
        "nm": "Cl",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 3,
                "s": [
                  405.789,
                  781.552,
                  0
                ],
                "to": [
                  0,
                  -3.632,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 4,
                "s": [
                  405.789,
                  759.762,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 5,
                "s": [
                  405.789,
                  737.972,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 6,
                "s": [
                  405.789,
                  716.182,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 7,
                "s": [
                  405.789,
                  694.393,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 8,
                "s": [
                  405.789,
                  672.605,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 9,
                "s": [
                  405.789,
                  650.81,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.262,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 10,
                "s": [
                  405.789,
                  629.023,
                  0
                ],
                "to": [
                  0,
                  -7.262,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 11,
                "s": [
                  405.789,
                  607.236,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 12,
                "s": [
                  405.789,
                  585.446,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 13,
                "s": [
                  405.789,
                  563.658,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 14,
                "s": [
                  405.789,
                  541.869,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.262,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 15,
                "s": [
                  405.789,
                  520.081,
                  0
                ],
                "to": [
                  0,
                  -7.262,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 16,
                "s": [
                  405.789,
                  498.297,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 17,
                "s": [
                  405.789,
                  476.501,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 18,
                "s": [
                  405.789,
                  454.711,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 19,
                "s": [
                  405.789,
                  432.921,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 20,
                "s": [
                  405.789,
                  411.131,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.881
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 21,
                "s": [
                  405.789,
                  389.342,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  5.183,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.278
                },
                "t": 22,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  -5.183,
                  0
                ],
                "ti": [
                  0,
                  2.48,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 23,
                "s": [
                  405.789,
                  358.245,
                  0
                ],
                "to": [
                  0,
                  -2.48,
                  0
                ],
                "ti": [
                  0,
                  1.227,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 24,
                "s": [
                  405.789,
                  352.669,
                  0
                ],
                "to": [
                  0,
                  -1.227,
                  0
                ],
                "ti": [
                  0,
                  0.062,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 25,
                "s": [
                  405.789,
                  350.883,
                  0
                ],
                "to": [
                  0,
                  -0.062,
                  0
                ],
                "ti": [
                  0,
                  -0.841,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 26,
                "s": [
                  405.789,
                  352.297,
                  0
                ],
                "to": [
                  0,
                  0.841,
                  0
                ],
                "ti": [
                  0,
                  -1.392,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 27,
                "s": [
                  405.789,
                  355.926,
                  0
                ],
                "to": [
                  0,
                  1.392,
                  0
                ],
                "ti": [
                  0,
                  -1.581,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 28,
                "s": [
                  405.789,
                  360.646,
                  0
                ],
                "to": [
                  0,
                  1.581,
                  0
                ],
                "ti": [
                  0,
                  -1.463,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 29,
                "s": [
                  405.789,
                  365.414,
                  0
                ],
                "to": [
                  0,
                  1.463,
                  0
                ],
                "ti": [
                  0,
                  -1.128,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 30,
                "s": [
                  405.789,
                  369.423,
                  0
                ],
                "to": [
                  0,
                  1.128,
                  0
                ],
                "ti": [
                  0,
                  -0.683,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 31,
                "s": [
                  405.789,
                  372.181,
                  0
                ],
                "to": [
                  0,
                  0.683,
                  0
                ],
                "ti": [
                  0,
                  -0.228,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.635
                },
                "o": {
                  "x": 0.167,
                  "y": 0.469
                },
                "t": 32,
                "s": [
                  405.789,
                  373.521,
                  0
                ],
                "to": [
                  0,
                  0.228,
                  0
                ],
                "ti": [
                  0,
                  0.158,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 33,
                "s": [
                  405.789,
                  373.551,
                  0
                ],
                "to": [
                  0,
                  -0.158,
                  0
                ],
                "ti": [
                  0,
                  0.428,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 34,
                "s": [
                  405.789,
                  372.573,
                  0
                ],
                "to": [
                  0,
                  -0.428,
                  0
                ],
                "ti": [
                  0,
                  0.563,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 35,
                "s": [
                  405.789,
                  370.985,
                  0
                ],
                "to": [
                  0,
                  -0.563,
                  0
                ],
                "ti": [
                  0,
                  0.572,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 36,
                "s": [
                  405.789,
                  369.197,
                  0
                ],
                "to": [
                  0,
                  -0.572,
                  0
                ],
                "ti": [
                  0,
                  0.484,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 37,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  -0.484,
                  0
                ],
                "ti": [
                  0,
                  0.336,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 38,
                "s": [
                  405.789,
                  366.292,
                  0
                ],
                "to": [
                  0,
                  -0.336,
                  0
                ],
                "ti": [
                  0,
                  0.166,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 39,
                "s": [
                  405.789,
                  365.538,
                  0
                ],
                "to": [
                  0,
                  -0.166,
                  0
                ],
                "ti": [
                  0,
                  0.008,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 40,
                "s": [
                  405.789,
                  365.296,
                  0
                ],
                "to": [
                  0,
                  -0.008,
                  0
                ],
                "ti": [
                  0,
                  -0.114,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 41,
                "s": [
                  405.789,
                  365.488,
                  0
                ],
                "to": [
                  0,
                  0.114,
                  0
                ],
                "ti": [
                  0,
                  -0.188,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 42,
                "s": [
                  405.789,
                  365.979,
                  0
                ],
                "to": [
                  0,
                  0.188,
                  0
                ],
                "ti": [
                  0,
                  -0.214,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 43,
                "s": [
                  405.789,
                  366.617,
                  0
                ],
                "to": [
                  0,
                  0.214,
                  0
                ],
                "ti": [
                  0,
                  -0.198,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 44,
                "s": [
                  405.789,
                  367.263,
                  0
                ],
                "to": [
                  0,
                  0.198,
                  0
                ],
                "ti": [
                  0,
                  -0.153,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 45,
                "s": [
                  405.789,
                  367.805,
                  0
                ],
                "to": [
                  0,
                  0.153,
                  0
                ],
                "ti": [
                  0,
                  -0.092,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 46,
                "s": [
                  405.789,
                  368.179,
                  0
                ],
                "to": [
                  0,
                  0.092,
                  0
                ],
                "ti": [
                  0,
                  -0.031,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.633
                },
                "o": {
                  "x": 0.167,
                  "y": 0.471
                },
                "t": 47,
                "s": [
                  405.789,
                  368.36,
                  0
                ],
                "to": [
                  0,
                  0.031,
                  0
                ],
                "ti": [
                  0,
                  0.021,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 48,
                "s": [
                  405.789,
                  368.364,
                  0
                ],
                "to": [
                  0,
                  -0.021,
                  0
                ],
                "ti": [
                  0,
                  0.058,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 49,
                "s": [
                  405.789,
                  368.232,
                  0
                ],
                "to": [
                  0,
                  -0.058,
                  0
                ],
                "ti": [
                  0,
                  0.076,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 50,
                "s": [
                  405.789,
                  368.017,
                  0
                ],
                "to": [
                  0,
                  -0.076,
                  0
                ],
                "ti": [
                  0,
                  0.077,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 51,
                "s": [
                  405.789,
                  367.775,
                  0
                ],
                "to": [
                  0,
                  -0.077,
                  0
                ],
                "ti": [
                  0,
                  0.066,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 52,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  -0.066,
                  0
                ],
                "ti": [
                  0,
                  0.045,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 53,
                "s": [
                  405.789,
                  367.382,
                  0
                ],
                "to": [
                  0,
                  -0.045,
                  0
                ],
                "ti": [
                  0,
                  0.022,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 54,
                "s": [
                  405.789,
                  367.279,
                  0
                ],
                "to": [
                  0,
                  -0.022,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 55,
                "s": [
                  405.789,
                  367.247,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  -0.015,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 56,
                "s": [
                  405.789,
                  367.273,
                  0
                ],
                "to": [
                  0,
                  0.015,
                  0
                ],
                "ti": [
                  0,
                  -0.025,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 57,
                "s": [
                  405.789,
                  367.339,
                  0
                ],
                "to": [
                  0,
                  0.025,
                  0
                ],
                "ti": [
                  0,
                  -0.029,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 58,
                "s": [
                  405.789,
                  367.426,
                  0
                ],
                "to": [
                  0,
                  0.029,
                  0
                ],
                "ti": [
                  0,
                  -0.027,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 59,
                "s": [
                  405.789,
                  367.513,
                  0
                ],
                "to": [
                  0,
                  0.027,
                  0
                ],
                "ti": [
                  0,
                  -0.021,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 60,
                "s": [
                  405.789,
                  367.586,
                  0
                ],
                "to": [
                  0,
                  0.021,
                  0
                ],
                "ti": [
                  0,
                  -0.013,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 61,
                "s": [
                  405.789,
                  367.637,
                  0
                ],
                "to": [
                  0,
                  0.013,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.631
                },
                "o": {
                  "x": 0.167,
                  "y": 0.474
                },
                "t": 62,
                "s": [
                  405.789,
                  367.661,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 63,
                "s": [
                  405.789,
                  367.662,
                  0
                ],
                "to": [
                  0,
                  -0.003,
                  0
                ],
                "ti": [
                  0,
                  0.008,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 64,
                "s": [
                  405.789,
                  367.644,
                  0
                ],
                "to": [
                  0,
                  -0.008,
                  0
                ],
                "ti": [
                  0,
                  0.01,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 65,
                "s": [
                  405.789,
                  367.615,
                  0
                ],
                "to": [
                  0,
                  -0.01,
                  0
                ],
                "ti": [
                  0,
                  0.01,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 66,
                "s": [
                  405.789,
                  367.582,
                  0
                ],
                "to": [
                  0,
                  -0.01,
                  0
                ],
                "ti": [
                  0,
                  0.009,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 67,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  -0.009,
                  0
                ],
                "ti": [
                  0,
                  0.006,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 68,
                "s": [
                  405.789,
                  367.529,
                  0
                ],
                "to": [
                  0,
                  -0.006,
                  0
                ],
                "ti": [
                  0,
                  0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 69,
                "s": [
                  405.789,
                  367.515,
                  0
                ],
                "to": [
                  0,
                  -0.003,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 70,
                "s": [
                  405.789,
                  367.511,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -0.002,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 71,
                "s": [
                  405.789,
                  367.514,
                  0
                ],
                "to": [
                  0,
                  0.002,
                  0
                ],
                "ti": [
                  0,
                  -0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 72,
                "s": [
                  405.789,
                  367.523,
                  0
                ],
                "to": [
                  0,
                  0.003,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 73,
                "s": [
                  405.789,
                  367.535,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 74,
                "s": [
                  405.789,
                  367.547,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  -0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 75,
                "s": [
                  405.789,
                  367.557,
                  0
                ],
                "to": [
                  0,
                  0.003,
                  0
                ],
                "ti": [
                  0,
                  -0.002,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 76,
                "s": [
                  405.789,
                  367.564,
                  0
                ],
                "to": [
                  0,
                  0.002,
                  0
                ],
                "ti": [
                  0,
                  -0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.694
                },
                "o": {
                  "x": 0.167,
                  "y": 0.394
                },
                "t": 77,
                "s": [
                  405.789,
                  367.567,
                  0
                ],
                "to": [
                  0,
                  0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 78,
                "s": [
                  405.789,
                  367.567,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 79,
                "s": [
                  405.789,
                  367.565,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 80,
                "s": [
                  405.789,
                  367.561,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 81,
                "s": [
                  405.789,
                  367.556,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 82,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 83,
                "s": [
                  405.789,
                  367.549,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 84,
                "s": [
                  405.789,
                  367.547,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 85,
                "s": [
                  405.789,
                  367.546,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 86,
                "s": [
                  405.789,
                  367.547,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 87,
                "s": [
                  405.789,
                  367.548,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 88,
                "s": [
                  405.789,
                  367.55,
                  0
                ],
                "to": [
                  0,
                  0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 89,
                "s": [
                  405.789,
                  367.551,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 90,
                "s": [
                  405.789,
                  367.553,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 91,
                "s": [
                  405.789,
                  367.554,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.953,
                  "y": 0
                },
                "o": {
                  "x": 0.037,
                  "y": 1
                },
                "t": 92,
                "s": [
                  405.789,
                  367.554,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 93,
                "s": [
                  405.789,
                  367.554,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 94,
                "s": [
                  405.789,
                  367.554,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 95,
                "s": [
                  405.789,
                  367.553,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 96,
                "s": [
                  405.789,
                  367.553,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 97,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 98,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 99,
                "s": [
                  405.789,
                  367.551,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 100,
                "s": [
                  405.789,
                  367.551,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 101,
                "s": [
                  405.789,
                  367.551,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 102,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 103,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 104,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 105,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 106,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.953,
                  "y": 0
                },
                "o": {
                  "x": 0.037,
                  "y": 1
                },
                "t": 107,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 108,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 109,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 110,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 111,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 112,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 113,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 114,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 115,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 116,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 117,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 118,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 119,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 120,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 121,
                "s": [
                  405.789,
                  367.552,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "t": 122,
                "s": [
                  405.789,
                  367.552,
                  0
                ]
              }
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              405.789,
              367.552,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "Position - Overshoot",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 10,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Position - Bounce",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 40,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Position - Friction",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 3,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 80,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.002,
                        0.943
                      ],
                      [
                        0.942,
                        0.002
                      ],
                      [
                        0.002,
                        -0.942
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.614,
                        0
                      ],
                      [
                        0,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0.942,
                        -0.002
                      ],
                      [
                        -0.002,
                        -0.942
                      ],
                      [
                        -0.942,
                        0.002
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        1.614
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0,
                        1.707
                      ],
                      [
                        1.707,
                        0
                      ],
                      [
                        0,
                        -1.707
                      ],
                      [
                        -1.707,
                        0
                      ],
                      [
                        -2.922,
                        0
                      ],
                      [
                        0,
                        -2.922
                      ],
                      [
                        2.922,
                        0
                      ],
                      [
                        0,
                        2.922
                      ],
                      [
                        0,
                        1.707
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.819607853889,
                    0.905882358551,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    386.596,
                    339.354
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.002,
                        0.943
                      ],
                      [
                        0.942,
                        0.002
                      ],
                      [
                        0.002,
                        -0.942
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.614,
                        0
                      ],
                      [
                        0,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0.942,
                        -0.002
                      ],
                      [
                        -0.002,
                        -0.942
                      ],
                      [
                        -0.942,
                        0.002
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.001,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        1.614
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0,
                        1.707
                      ],
                      [
                        1.707,
                        0
                      ],
                      [
                        0,
                        -1.707
                      ],
                      [
                        -1.707,
                        0
                      ],
                      [
                        -2.922,
                        0
                      ],
                      [
                        0,
                        -2.922
                      ],
                      [
                        2.922,
                        0
                      ],
                      [
                        0,
                        2.922
                      ],
                      [
                        0,
                        1.707
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.819607853889,
                    0.905882358551,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    393.09,
                    339.354
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.002,
                        0.943
                      ],
                      [
                        0.942,
                        0.002
                      ],
                      [
                        0.002,
                        -0.942
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.614,
                        0
                      ],
                      [
                        0,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0.942,
                        -0.002
                      ],
                      [
                        -0.002,
                        -0.942
                      ],
                      [
                        -0.942,
                        0.002
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.001,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        1.614
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0,
                        1.707
                      ],
                      [
                        1.707,
                        0
                      ],
                      [
                        0,
                        -1.707
                      ],
                      [
                        -1.707,
                        0
                      ],
                      [
                        -2.922,
                        0
                      ],
                      [
                        0,
                        -2.922
                      ],
                      [
                        2.922,
                        0
                      ],
                      [
                        0,
                        2.922
                      ],
                      [
                        0,
                        1.707
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.819607853889,
                    0.905882358551,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    399.584,
                    339.354
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.002,
                        0.943
                      ],
                      [
                        0.942,
                        0.002
                      ],
                      [
                        0.002,
                        -0.942
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.614,
                        0
                      ],
                      [
                        0,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0.942,
                        -0.002
                      ],
                      [
                        -0.002,
                        -0.942
                      ],
                      [
                        -0.943,
                        0.002
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        1.614
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0,
                        1.707
                      ],
                      [
                        1.707,
                        0
                      ],
                      [
                        0,
                        -1.707
                      ],
                      [
                        -1.707,
                        0
                      ],
                      [
                        -2.922,
                        0
                      ],
                      [
                        0,
                        -2.922
                      ],
                      [
                        2.922,
                        0
                      ],
                      [
                        0,
                        2.922
                      ],
                      [
                        0,
                        1.707
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.819607853889,
                    0.905882358551,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    406.079,
                    339.354
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 4",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.002,
                        0.943
                      ],
                      [
                        0.942,
                        0.002
                      ],
                      [
                        0.002,
                        -0.942
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.614,
                        0
                      ],
                      [
                        0,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0.942,
                        -0.002
                      ],
                      [
                        -0.002,
                        -0.942
                      ],
                      [
                        -0.942,
                        0.002
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        1.614
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0,
                        1.707
                      ],
                      [
                        1.707,
                        0
                      ],
                      [
                        0,
                        -1.707
                      ],
                      [
                        -1.707,
                        0
                      ],
                      [
                        -2.922,
                        0
                      ],
                      [
                        0,
                        -2.922
                      ],
                      [
                        2.922,
                        0
                      ],
                      [
                        0,
                        2.922
                      ],
                      [
                        0,
                        1.707
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.819607853889,
                    0.905882358551,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    412.573,
                    339.354
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 5",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.002,
                        0.943
                      ],
                      [
                        0.943,
                        0.002
                      ],
                      [
                        0.002,
                        -0.942
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.614,
                        0
                      ],
                      [
                        -0.001,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0.943,
                        -0.002
                      ],
                      [
                        -0.002,
                        -0.942
                      ],
                      [
                        -0.942,
                        0.002
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        -0.001,
                        1.614
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0,
                        1.707
                      ],
                      [
                        1.707,
                        0
                      ],
                      [
                        0,
                        -1.707
                      ],
                      [
                        -1.707,
                        0
                      ],
                      [
                        -2.922,
                        0
                      ],
                      [
                        0,
                        -2.922
                      ],
                      [
                        2.922,
                        0
                      ],
                      [
                        0,
                        2.922
                      ],
                      [
                        0,
                        1.707
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.819607853889,
                    0.905882358551,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    419.067,
                    339.354
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 6",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        -0.002,
                        0.943
                      ],
                      [
                        0.942,
                        0.002
                      ],
                      [
                        0.002,
                        -0.942
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -1.614,
                        0
                      ],
                      [
                        0,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0.942,
                        -0.002
                      ],
                      [
                        -0.002,
                        -0.942
                      ],
                      [
                        -0.942,
                        0.002
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        -1.614
                      ],
                      [
                        1.614,
                        0
                      ],
                      [
                        0,
                        1.614
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        0,
                        1.707
                      ],
                      [
                        1.707,
                        0
                      ],
                      [
                        0,
                        -1.707
                      ],
                      [
                        -1.707,
                        0
                      ],
                      [
                        -2.922,
                        0
                      ],
                      [
                        0,
                        -2.922
                      ],
                      [
                        2.922,
                        0
                      ],
                      [
                        0,
                        2.922
                      ],
                      [
                        0,
                        1.707
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.819607853889,
                    0.905882358551,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    425.561,
                    339.354
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 7",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        -29.061,
                        -29.659
                      ],
                      [
                        17.445,
                        -29.659
                      ],
                      [
                        29.061,
                        29.659
                      ],
                      [
                        -17.445,
                        29.659
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.290196090937,
                    0.376470595598,
                    0.870588243008,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    411.598,
                    369.013
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 8",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 8,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        29.061,
                        -29.659
                      ],
                      [
                        -17.445,
                        -29.659
                      ],
                      [
                        -29.061,
                        29.659
                      ],
                      [
                        17.445,
                        29.659
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.192156866193,
                    0.20000000298,
                    0.517647087574,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    399.981,
                    369.013
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 9",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 9,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 3,
        "op": 123,
        "st": 3,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 8,
        "ty": 4,
        "nm": "Tob",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 4,
                "s": [
                  105.696,
                  767.869,
                  0
                ],
                "to": [
                  0,
                  -3.632,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 5,
                "s": [
                  105.696,
                  746.079,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 6,
                "s": [
                  105.696,
                  724.29,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 7,
                "s": [
                  105.696,
                  702.5,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 8,
                "s": [
                  105.696,
                  680.71,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 9,
                "s": [
                  105.696,
                  658.92,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 10,
                "s": [
                  105.696,
                  637.125,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.262,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 11,
                "s": [
                  105.696,
                  615.34,
                  0
                ],
                "to": [
                  0,
                  -7.262,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 12,
                "s": [
                  105.696,
                  593.553,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 13,
                "s": [
                  105.696,
                  571.763,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 14,
                "s": [
                  105.696,
                  549.975,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 15,
                "s": [
                  105.696,
                  528.185,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.262,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 16,
                "s": [
                  105.696,
                  506.398,
                  0
                ],
                "to": [
                  0,
                  -7.262,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 17,
                "s": [
                  105.696,
                  484.611,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 18,
                "s": [
                  105.696,
                  462.816,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 19,
                "s": [
                  105.696,
                  441.028,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 20,
                "s": [
                  105.696,
                  419.239,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 21,
                "s": [
                  105.696,
                  397.449,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.881
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 22,
                "s": [
                  105.696,
                  375.659,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  5.183,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.278
                },
                "t": 23,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  -5.183,
                  0
                ],
                "ti": [
                  0,
                  2.48,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 24,
                "s": [
                  105.696,
                  344.562,
                  0
                ],
                "to": [
                  0,
                  -2.48,
                  0
                ],
                "ti": [
                  0,
                  1.227,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 25,
                "s": [
                  105.696,
                  338.986,
                  0
                ],
                "to": [
                  0,
                  -1.227,
                  0
                ],
                "ti": [
                  0,
                  0.062,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 26,
                "s": [
                  105.696,
                  337.2,
                  0
                ],
                "to": [
                  0,
                  -0.062,
                  0
                ],
                "ti": [
                  0,
                  -0.841,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 27,
                "s": [
                  105.696,
                  338.614,
                  0
                ],
                "to": [
                  0,
                  0.841,
                  0
                ],
                "ti": [
                  0,
                  -1.392,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 28,
                "s": [
                  105.696,
                  342.243,
                  0
                ],
                "to": [
                  0,
                  1.392,
                  0
                ],
                "ti": [
                  0,
                  -1.581,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 29,
                "s": [
                  105.696,
                  346.963,
                  0
                ],
                "to": [
                  0,
                  1.581,
                  0
                ],
                "ti": [
                  0,
                  -1.463,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 30,
                "s": [
                  105.696,
                  351.731,
                  0
                ],
                "to": [
                  0,
                  1.463,
                  0
                ],
                "ti": [
                  0,
                  -1.128,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 31,
                "s": [
                  105.696,
                  355.74,
                  0
                ],
                "to": [
                  0,
                  1.128,
                  0
                ],
                "ti": [
                  0,
                  -0.683,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 32,
                "s": [
                  105.696,
                  358.498,
                  0
                ],
                "to": [
                  0,
                  0.683,
                  0
                ],
                "ti": [
                  0,
                  -0.228,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.635
                },
                "o": {
                  "x": 0.167,
                  "y": 0.469
                },
                "t": 33,
                "s": [
                  105.696,
                  359.838,
                  0
                ],
                "to": [
                  0,
                  0.228,
                  0
                ],
                "ti": [
                  0,
                  0.158,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 34,
                "s": [
                  105.696,
                  359.868,
                  0
                ],
                "to": [
                  0,
                  -0.158,
                  0
                ],
                "ti": [
                  0,
                  0.428,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 35,
                "s": [
                  105.696,
                  358.89,
                  0
                ],
                "to": [
                  0,
                  -0.428,
                  0
                ],
                "ti": [
                  0,
                  0.563,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 36,
                "s": [
                  105.696,
                  357.302,
                  0
                ],
                "to": [
                  0,
                  -0.563,
                  0
                ],
                "ti": [
                  0,
                  0.572,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 37,
                "s": [
                  105.696,
                  355.514,
                  0
                ],
                "to": [
                  0,
                  -0.572,
                  0
                ],
                "ti": [
                  0,
                  0.484,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 38,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  -0.484,
                  0
                ],
                "ti": [
                  0,
                  0.336,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 39,
                "s": [
                  105.696,
                  352.609,
                  0
                ],
                "to": [
                  0,
                  -0.336,
                  0
                ],
                "ti": [
                  0,
                  0.166,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 40,
                "s": [
                  105.696,
                  351.855,
                  0
                ],
                "to": [
                  0,
                  -0.166,
                  0
                ],
                "ti": [
                  0,
                  0.008,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 41,
                "s": [
                  105.696,
                  351.613,
                  0
                ],
                "to": [
                  0,
                  -0.008,
                  0
                ],
                "ti": [
                  0,
                  -0.114,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 42,
                "s": [
                  105.696,
                  351.805,
                  0
                ],
                "to": [
                  0,
                  0.114,
                  0
                ],
                "ti": [
                  0,
                  -0.188,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 43,
                "s": [
                  105.696,
                  352.296,
                  0
                ],
                "to": [
                  0,
                  0.188,
                  0
                ],
                "ti": [
                  0,
                  -0.214,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 44,
                "s": [
                  105.696,
                  352.934,
                  0
                ],
                "to": [
                  0,
                  0.214,
                  0
                ],
                "ti": [
                  0,
                  -0.198,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 45,
                "s": [
                  105.696,
                  353.58,
                  0
                ],
                "to": [
                  0,
                  0.198,
                  0
                ],
                "ti": [
                  0,
                  -0.153,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 46,
                "s": [
                  105.696,
                  354.122,
                  0
                ],
                "to": [
                  0,
                  0.153,
                  0
                ],
                "ti": [
                  0,
                  -0.092,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 47,
                "s": [
                  105.696,
                  354.496,
                  0
                ],
                "to": [
                  0,
                  0.092,
                  0
                ],
                "ti": [
                  0,
                  -0.031,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.633
                },
                "o": {
                  "x": 0.167,
                  "y": 0.471
                },
                "t": 48,
                "s": [
                  105.696,
                  354.677,
                  0
                ],
                "to": [
                  0,
                  0.031,
                  0
                ],
                "ti": [
                  0,
                  0.021,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 49,
                "s": [
                  105.696,
                  354.681,
                  0
                ],
                "to": [
                  0,
                  -0.021,
                  0
                ],
                "ti": [
                  0,
                  0.058,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 50,
                "s": [
                  105.696,
                  354.549,
                  0
                ],
                "to": [
                  0,
                  -0.058,
                  0
                ],
                "ti": [
                  0,
                  0.076,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 51,
                "s": [
                  105.696,
                  354.334,
                  0
                ],
                "to": [
                  0,
                  -0.076,
                  0
                ],
                "ti": [
                  0,
                  0.077,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 52,
                "s": [
                  105.696,
                  354.092,
                  0
                ],
                "to": [
                  0,
                  -0.077,
                  0
                ],
                "ti": [
                  0,
                  0.066,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 53,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  -0.066,
                  0
                ],
                "ti": [
                  0,
                  0.045,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 54,
                "s": [
                  105.696,
                  353.699,
                  0
                ],
                "to": [
                  0,
                  -0.045,
                  0
                ],
                "ti": [
                  0,
                  0.022,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 55,
                "s": [
                  105.696,
                  353.596,
                  0
                ],
                "to": [
                  0,
                  -0.022,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 56,
                "s": [
                  105.696,
                  353.564,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  -0.015,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 57,
                "s": [
                  105.696,
                  353.59,
                  0
                ],
                "to": [
                  0,
                  0.015,
                  0
                ],
                "ti": [
                  0,
                  -0.025,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 58,
                "s": [
                  105.696,
                  353.656,
                  0
                ],
                "to": [
                  0,
                  0.025,
                  0
                ],
                "ti": [
                  0,
                  -0.029,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 59,
                "s": [
                  105.696,
                  353.743,
                  0
                ],
                "to": [
                  0,
                  0.029,
                  0
                ],
                "ti": [
                  0,
                  -0.027,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 60,
                "s": [
                  105.696,
                  353.83,
                  0
                ],
                "to": [
                  0,
                  0.027,
                  0
                ],
                "ti": [
                  0,
                  -0.021,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 61,
                "s": [
                  105.696,
                  353.903,
                  0
                ],
                "to": [
                  0,
                  0.021,
                  0
                ],
                "ti": [
                  0,
                  -0.013,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 62,
                "s": [
                  105.696,
                  353.954,
                  0
                ],
                "to": [
                  0,
                  0.013,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.631
                },
                "o": {
                  "x": 0.167,
                  "y": 0.474
                },
                "t": 63,
                "s": [
                  105.696,
                  353.978,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 64,
                "s": [
                  105.696,
                  353.979,
                  0
                ],
                "to": [
                  0,
                  -0.003,
                  0
                ],
                "ti": [
                  0,
                  0.008,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 65,
                "s": [
                  105.696,
                  353.961,
                  0
                ],
                "to": [
                  0,
                  -0.008,
                  0
                ],
                "ti": [
                  0,
                  0.01,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 66,
                "s": [
                  105.696,
                  353.932,
                  0
                ],
                "to": [
                  0,
                  -0.01,
                  0
                ],
                "ti": [
                  0,
                  0.01,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 67,
                "s": [
                  105.696,
                  353.899,
                  0
                ],
                "to": [
                  0,
                  -0.01,
                  0
                ],
                "ti": [
                  0,
                  0.009,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 68,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  -0.009,
                  0
                ],
                "ti": [
                  0,
                  0.006,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 69,
                "s": [
                  105.696,
                  353.846,
                  0
                ],
                "to": [
                  0,
                  -0.006,
                  0
                ],
                "ti": [
                  0,
                  0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 70,
                "s": [
                  105.696,
                  353.832,
                  0
                ],
                "to": [
                  0,
                  -0.003,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 71,
                "s": [
                  105.696,
                  353.828,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -0.002,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 72,
                "s": [
                  105.696,
                  353.831,
                  0
                ],
                "to": [
                  0,
                  0.002,
                  0
                ],
                "ti": [
                  0,
                  -0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 73,
                "s": [
                  105.696,
                  353.84,
                  0
                ],
                "to": [
                  0,
                  0.003,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 74,
                "s": [
                  105.696,
                  353.852,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 75,
                "s": [
                  105.696,
                  353.864,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  -0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 76,
                "s": [
                  105.696,
                  353.874,
                  0
                ],
                "to": [
                  0,
                  0.003,
                  0
                ],
                "ti": [
                  0,
                  -0.002,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 77,
                "s": [
                  105.696,
                  353.881,
                  0
                ],
                "to": [
                  0,
                  0.002,
                  0
                ],
                "ti": [
                  0,
                  -0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.694
                },
                "o": {
                  "x": 0.167,
                  "y": 0.394
                },
                "t": 78,
                "s": [
                  105.696,
                  353.884,
                  0
                ],
                "to": [
                  0,
                  0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 79,
                "s": [
                  105.696,
                  353.884,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 80,
                "s": [
                  105.696,
                  353.881,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 81,
                "s": [
                  105.696,
                  353.878,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 82,
                "s": [
                  105.696,
                  353.873,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 83,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 84,
                "s": [
                  105.696,
                  353.866,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 85,
                "s": [
                  105.696,
                  353.864,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 86,
                "s": [
                  105.696,
                  353.863,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 87,
                "s": [
                  105.696,
                  353.864,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 88,
                "s": [
                  105.696,
                  353.865,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 89,
                "s": [
                  105.696,
                  353.867,
                  0
                ],
                "to": [
                  0,
                  0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 90,
                "s": [
                  105.696,
                  353.868,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 91,
                "s": [
                  105.696,
                  353.87,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 92,
                "s": [
                  105.696,
                  353.871,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.953,
                  "y": 0
                },
                "o": {
                  "x": 0.037,
                  "y": 1
                },
                "t": 93,
                "s": [
                  105.696,
                  353.871,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 94,
                "s": [
                  105.696,
                  353.871,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 95,
                "s": [
                  105.696,
                  353.871,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 96,
                "s": [
                  105.696,
                  353.87,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 97,
                "s": [
                  105.696,
                  353.87,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 98,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 99,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 100,
                "s": [
                  105.696,
                  353.868,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 101,
                "s": [
                  105.696,
                  353.868,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 102,
                "s": [
                  105.696,
                  353.868,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 103,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 104,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 105,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 106,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 107,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.953,
                  "y": 0
                },
                "o": {
                  "x": 0.037,
                  "y": 1
                },
                "t": 108,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 109,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 110,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 111,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 112,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 113,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 114,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 115,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 116,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 117,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 118,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 119,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 120,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 121,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 122,
                "s": [
                  105.696,
                  353.869,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "t": 123,
                "s": [
                  105.696,
                  353.869,
                  0
                ]
              }
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              105.696,
              353.869,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "Position - Overshoot",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 10,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Position - Bounce",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 40,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Position - Friction",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 3,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 80,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        11.335,
                        -12.551
                      ],
                      [
                        8.005,
                        12.564
                      ],
                      [
                        -11.335,
                        -12.564
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.654901981354,
                    0.819607853889,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    111.191,
                    371.321
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        15.433,
                        -19.205
                      ],
                      [
                        12.103,
                        5.91
                      ],
                      [
                        10.334,
                        19.217
                      ],
                      [
                        -10.334,
                        19.217
                      ],
                      [
                        -14.352,
                        -11.108
                      ],
                      [
                        -15.433,
                        -19.217
                      ],
                      [
                        -7.237,
                        -19.217
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.819607853889,
                    0.905882358551,
                    1,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    107.093,
                    377.975
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            13.073,
                            18.254
                          ],
                          [
                            -11.101,
                            -16.836
                          ]
                        ],
                        "o": [
                          [
                            2.693,
                            -23.786
                          ],
                          [
                            -4.873,
                            21.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            8.875,
                            32.953
                          ],
                          [
                            -7.398,
                            -32.953
                          ],
                          [
                            2.478,
                            27.226
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.262745112181,
                        0.309803932905,
                        0.854901969433,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        98.379,
                        343.499
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0,
                            0
                          ],
                          [
                            2.448,
                            15.701
                          ],
                          [
                            -1.262,
                            -16.133
                          ]
                        ],
                        "o": [
                          [
                            5.512,
                            -15.663
                          ],
                          [
                            -10.204,
                            13.534
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        "v": [
                          [
                            1.902,
                            24.053
                          ],
                          [
                            6.603,
                            -24.053
                          ],
                          [
                            -7.522,
                            22.811
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.290196090937,
                        0.376470595598,
                        0.870588243008,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        112.545,
                        347.787
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    112.545,
                    347.787
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    112.545,
                    347.787
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 4,
        "op": 124,
        "st": 4,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 9,
        "ty": 4,
        "nm": "Desk",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 0,
                "s": [
                  249.799,
                  869.216,
                  0
                ],
                "to": [
                  0,
                  -3.632,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 1,
                "s": [
                  249.799,
                  847.426,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 2,
                "s": [
                  249.799,
                  825.637,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 3,
                "s": [
                  249.799,
                  803.847,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 4,
                "s": [
                  249.799,
                  782.057,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 5,
                "s": [
                  249.799,
                  760.267,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 6,
                "s": [
                  249.799,
                  738.471,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.262,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 7,
                "s": [
                  249.799,
                  716.687,
                  0
                ],
                "to": [
                  0,
                  -7.262,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 8,
                "s": [
                  249.799,
                  694.899,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 9,
                "s": [
                  249.799,
                  673.11,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 10,
                "s": [
                  249.799,
                  651.322,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 11,
                "s": [
                  249.799,
                  629.532,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.262,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 12,
                "s": [
                  249.799,
                  607.745,
                  0
                ],
                "to": [
                  0,
                  -7.262,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 13,
                "s": [
                  249.799,
                  585.958,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 14,
                "s": [
                  249.799,
                  564.163,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 15,
                "s": [
                  249.799,
                  542.375,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 16,
                "s": [
                  249.799,
                  520.586,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 17,
                "s": [
                  249.799,
                  498.796,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.881
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 18,
                "s": [
                  249.799,
                  477.006,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  5.183,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.278
                },
                "t": 19,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  -5.183,
                  0
                ],
                "ti": [
                  0,
                  2.48,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 20,
                "s": [
                  249.799,
                  445.909,
                  0
                ],
                "to": [
                  0,
                  -2.48,
                  0
                ],
                "ti": [
                  0,
                  1.227,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 21,
                "s": [
                  249.799,
                  440.333,
                  0
                ],
                "to": [
                  0,
                  -1.227,
                  0
                ],
                "ti": [
                  0,
                  0.062,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 22,
                "s": [
                  249.799,
                  438.547,
                  0
                ],
                "to": [
                  0,
                  -0.062,
                  0
                ],
                "ti": [
                  0,
                  -0.841,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 23,
                "s": [
                  249.799,
                  439.961,
                  0
                ],
                "to": [
                  0,
                  0.841,
                  0
                ],
                "ti": [
                  0,
                  -1.392,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 24,
                "s": [
                  249.799,
                  443.59,
                  0
                ],
                "to": [
                  0,
                  1.392,
                  0
                ],
                "ti": [
                  0,
                  -1.581,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 25,
                "s": [
                  249.799,
                  448.31,
                  0
                ],
                "to": [
                  0,
                  1.581,
                  0
                ],
                "ti": [
                  0,
                  -1.463,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 26,
                "s": [
                  249.799,
                  453.078,
                  0
                ],
                "to": [
                  0,
                  1.463,
                  0
                ],
                "ti": [
                  0,
                  -1.128,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 27,
                "s": [
                  249.799,
                  457.087,
                  0
                ],
                "to": [
                  0,
                  1.128,
                  0
                ],
                "ti": [
                  0,
                  -0.683,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 28,
                "s": [
                  249.799,
                  459.845,
                  0
                ],
                "to": [
                  0,
                  0.683,
                  0
                ],
                "ti": [
                  0,
                  -0.228,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.635
                },
                "o": {
                  "x": 0.167,
                  "y": 0.469
                },
                "t": 29,
                "s": [
                  249.799,
                  461.185,
                  0
                ],
                "to": [
                  0,
                  0.228,
                  0
                ],
                "ti": [
                  0,
                  0.158,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 30,
                "s": [
                  249.799,
                  461.215,
                  0
                ],
                "to": [
                  0,
                  -0.158,
                  0
                ],
                "ti": [
                  0,
                  0.428,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 31,
                "s": [
                  249.799,
                  460.236,
                  0
                ],
                "to": [
                  0,
                  -0.428,
                  0
                ],
                "ti": [
                  0,
                  0.563,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 32,
                "s": [
                  249.799,
                  458.649,
                  0
                ],
                "to": [
                  0,
                  -0.563,
                  0
                ],
                "ti": [
                  0,
                  0.572,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 33,
                "s": [
                  249.799,
                  456.86,
                  0
                ],
                "to": [
                  0,
                  -0.572,
                  0
                ],
                "ti": [
                  0,
                  0.484,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 34,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  -0.484,
                  0
                ],
                "ti": [
                  0,
                  0.336,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 35,
                "s": [
                  249.799,
                  453.956,
                  0
                ],
                "to": [
                  0,
                  -0.336,
                  0
                ],
                "ti": [
                  0,
                  0.166,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 36,
                "s": [
                  249.799,
                  453.202,
                  0
                ],
                "to": [
                  0,
                  -0.166,
                  0
                ],
                "ti": [
                  0,
                  0.008,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 37,
                "s": [
                  249.799,
                  452.96,
                  0
                ],
                "to": [
                  0,
                  -0.008,
                  0
                ],
                "ti": [
                  0,
                  -0.114,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 38,
                "s": [
                  249.799,
                  453.151,
                  0
                ],
                "to": [
                  0,
                  0.114,
                  0
                ],
                "ti": [
                  0,
                  -0.188,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 39,
                "s": [
                  249.799,
                  453.642,
                  0
                ],
                "to": [
                  0,
                  0.188,
                  0
                ],
                "ti": [
                  0,
                  -0.214,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 40,
                "s": [
                  249.799,
                  454.281,
                  0
                ],
                "to": [
                  0,
                  0.214,
                  0
                ],
                "ti": [
                  0,
                  -0.198,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 41,
                "s": [
                  249.799,
                  454.927,
                  0
                ],
                "to": [
                  0,
                  0.198,
                  0
                ],
                "ti": [
                  0,
                  -0.153,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 42,
                "s": [
                  249.799,
                  455.469,
                  0
                ],
                "to": [
                  0,
                  0.153,
                  0
                ],
                "ti": [
                  0,
                  -0.092,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 43,
                "s": [
                  249.799,
                  455.842,
                  0
                ],
                "to": [
                  0,
                  0.092,
                  0
                ],
                "ti": [
                  0,
                  -0.031,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.633
                },
                "o": {
                  "x": 0.167,
                  "y": 0.471
                },
                "t": 44,
                "s": [
                  249.799,
                  456.024,
                  0
                ],
                "to": [
                  0,
                  0.031,
                  0
                ],
                "ti": [
                  0,
                  0.021,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 45,
                "s": [
                  249.799,
                  456.028,
                  0
                ],
                "to": [
                  0,
                  -0.021,
                  0
                ],
                "ti": [
                  0,
                  0.058,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 46,
                "s": [
                  249.799,
                  455.895,
                  0
                ],
                "to": [
                  0,
                  -0.058,
                  0
                ],
                "ti": [
                  0,
                  0.076,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 47,
                "s": [
                  249.799,
                  455.68,
                  0
                ],
                "to": [
                  0,
                  -0.076,
                  0
                ],
                "ti": [
                  0,
                  0.077,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 48,
                "s": [
                  249.799,
                  455.438,
                  0
                ],
                "to": [
                  0,
                  -0.077,
                  0
                ],
                "ti": [
                  0,
                  0.066,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 49,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  -0.066,
                  0
                ],
                "ti": [
                  0,
                  0.045,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 50,
                "s": [
                  249.799,
                  455.045,
                  0
                ],
                "to": [
                  0,
                  -0.045,
                  0
                ],
                "ti": [
                  0,
                  0.022,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 51,
                "s": [
                  249.799,
                  454.943,
                  0
                ],
                "to": [
                  0,
                  -0.022,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 52,
                "s": [
                  249.799,
                  454.911,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  -0.015,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 53,
                "s": [
                  249.799,
                  454.936,
                  0
                ],
                "to": [
                  0,
                  0.015,
                  0
                ],
                "ti": [
                  0,
                  -0.025,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 54,
                "s": [
                  249.799,
                  455.003,
                  0
                ],
                "to": [
                  0,
                  0.025,
                  0
                ],
                "ti": [
                  0,
                  -0.029,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 55,
                "s": [
                  249.799,
                  455.089,
                  0
                ],
                "to": [
                  0,
                  0.029,
                  0
                ],
                "ti": [
                  0,
                  -0.027,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 56,
                "s": [
                  249.799,
                  455.177,
                  0
                ],
                "to": [
                  0,
                  0.027,
                  0
                ],
                "ti": [
                  0,
                  -0.021,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 57,
                "s": [
                  249.799,
                  455.25,
                  0
                ],
                "to": [
                  0,
                  0.021,
                  0
                ],
                "ti": [
                  0,
                  -0.013,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 58,
                "s": [
                  249.799,
                  455.301,
                  0
                ],
                "to": [
                  0,
                  0.013,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.631
                },
                "o": {
                  "x": 0.167,
                  "y": 0.474
                },
                "t": 59,
                "s": [
                  249.799,
                  455.325,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 60,
                "s": [
                  249.799,
                  455.326,
                  0
                ],
                "to": [
                  0,
                  -0.003,
                  0
                ],
                "ti": [
                  0,
                  0.008,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 61,
                "s": [
                  249.799,
                  455.308,
                  0
                ],
                "to": [
                  0,
                  -0.008,
                  0
                ],
                "ti": [
                  0,
                  0.01,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 62,
                "s": [
                  249.799,
                  455.279,
                  0
                ],
                "to": [
                  0,
                  -0.01,
                  0
                ],
                "ti": [
                  0,
                  0.01,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 63,
                "s": [
                  249.799,
                  455.246,
                  0
                ],
                "to": [
                  0,
                  -0.01,
                  0
                ],
                "ti": [
                  0,
                  0.009,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 64,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  -0.009,
                  0
                ],
                "ti": [
                  0,
                  0.006,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 65,
                "s": [
                  249.799,
                  455.193,
                  0
                ],
                "to": [
                  0,
                  -0.006,
                  0
                ],
                "ti": [
                  0,
                  0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 66,
                "s": [
                  249.799,
                  455.179,
                  0
                ],
                "to": [
                  0,
                  -0.003,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 67,
                "s": [
                  249.799,
                  455.175,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -0.002,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 68,
                "s": [
                  249.799,
                  455.178,
                  0
                ],
                "to": [
                  0,
                  0.002,
                  0
                ],
                "ti": [
                  0,
                  -0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 69,
                "s": [
                  249.799,
                  455.187,
                  0
                ],
                "to": [
                  0,
                  0.003,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 70,
                "s": [
                  249.799,
                  455.199,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 71,
                "s": [
                  249.799,
                  455.211,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  -0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 72,
                "s": [
                  249.799,
                  455.22,
                  0
                ],
                "to": [
                  0,
                  0.003,
                  0
                ],
                "ti": [
                  0,
                  -0.002,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 73,
                "s": [
                  249.799,
                  455.227,
                  0
                ],
                "to": [
                  0,
                  0.002,
                  0
                ],
                "ti": [
                  0,
                  -0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.694
                },
                "o": {
                  "x": 0.167,
                  "y": 0.394
                },
                "t": 74,
                "s": [
                  249.799,
                  455.231,
                  0
                ],
                "to": [
                  0,
                  0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 75,
                "s": [
                  249.799,
                  455.231,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 76,
                "s": [
                  249.799,
                  455.228,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 77,
                "s": [
                  249.799,
                  455.224,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 78,
                "s": [
                  249.799,
                  455.22,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 79,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 80,
                "s": [
                  249.799,
                  455.213,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 81,
                "s": [
                  249.799,
                  455.211,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 82,
                "s": [
                  249.799,
                  455.21,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 83,
                "s": [
                  249.799,
                  455.211,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 84,
                "s": [
                  249.799,
                  455.212,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 85,
                "s": [
                  249.799,
                  455.214,
                  0
                ],
                "to": [
                  0,
                  0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 86,
                "s": [
                  249.799,
                  455.215,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 87,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 88,
                "s": [
                  249.799,
                  455.217,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.953,
                  "y": 0
                },
                "o": {
                  "x": 0.037,
                  "y": 1
                },
                "t": 89,
                "s": [
                  249.799,
                  455.218,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 90,
                "s": [
                  249.799,
                  455.218,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 91,
                "s": [
                  249.799,
                  455.218,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 92,
                "s": [
                  249.799,
                  455.217,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 93,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 94,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 95,
                "s": [
                  249.799,
                  455.215,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 96,
                "s": [
                  249.799,
                  455.215,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 97,
                "s": [
                  249.799,
                  455.215,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 98,
                "s": [
                  249.799,
                  455.215,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 99,
                "s": [
                  249.799,
                  455.215,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 100,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 101,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 102,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 103,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.953,
                  "y": 0
                },
                "o": {
                  "x": 0.037,
                  "y": 1
                },
                "t": 104,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 105,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 106,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 107,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 108,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 109,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 110,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 111,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 112,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 113,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 114,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 115,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 116,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 117,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 118,
                "s": [
                  249.799,
                  455.216,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "t": 119,
                "s": [
                  249.799,
                  455.216,
                  0
                ]
              }
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "Position - Overshoot",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 10,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Position - Bounce",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 40,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Position - Friction",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 3,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 80,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        205.385,
                        6.892
                      ],
                      [
                        -205.385,
                        6.892
                      ],
                      [
                        -205.385,
                        -6.892
                      ],
                      [
                        205.385,
                        -6.892
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.192156866193,
                    0.20000000298,
                    0.517647087574,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    -50
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        196.004,
                        44.784
                      ],
                      [
                        -196.004,
                        44.784
                      ],
                      [
                        -196.004,
                        -44.784
                      ],
                      [
                        196.004,
                        -44.784
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.262745112181,
                    0.309803932905,
                    0.854901969433,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 0,
        "op": 123,
        "st": 0,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 10,
        "ty": 4,
        "nm": "boy",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 12,
                "s": [
                  250,
                  694.904,
                  0
                ],
                "to": [
                  0,
                  -3.632,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 13,
                "s": [
                  250,
                  673.113,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 14,
                "s": [
                  250,
                  651.324,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 15,
                "s": [
                  250,
                  629.533,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 16,
                "s": [
                  250,
                  607.745,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 17,
                "s": [
                  250,
                  585.956,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 18,
                "s": [
                  250,
                  564.162,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.262,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 19,
                "s": [
                  250,
                  542.374,
                  0
                ],
                "to": [
                  0,
                  -7.262,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 20,
                "s": [
                  250,
                  520.588,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 21,
                "s": [
                  250,
                  498.798,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 22,
                "s": [
                  250,
                  477.01,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 23,
                "s": [
                  250,
                  455.22,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.262,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 24,
                "s": [
                  250,
                  433.432,
                  0
                ],
                "to": [
                  0,
                  -7.262,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 25,
                "s": [
                  250,
                  411.648,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.264,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 26,
                "s": [
                  250,
                  389.852,
                  0
                ],
                "to": [
                  0,
                  -7.264,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 27,
                "s": [
                  250,
                  368.063,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 28,
                "s": [
                  250,
                  346.273,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 29,
                "s": [
                  250,
                  324.483,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  7.263,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.881
                },
                "o": {
                  "x": 0.167,
                  "y": 0.167
                },
                "t": 30,
                "s": [
                  250,
                  302.693,
                  0
                ],
                "to": [
                  0,
                  -7.263,
                  0
                ],
                "ti": [
                  0,
                  5.183,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.278
                },
                "t": 31,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  -5.183,
                  0
                ],
                "ti": [
                  0,
                  2.48,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 32,
                "s": [
                  250,
                  271.596,
                  0
                ],
                "to": [
                  0,
                  -2.48,
                  0
                ],
                "ti": [
                  0,
                  1.227,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 33,
                "s": [
                  250,
                  266.021,
                  0
                ],
                "to": [
                  0,
                  -1.227,
                  0
                ],
                "ti": [
                  0,
                  0.062,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 34,
                "s": [
                  250,
                  264.235,
                  0
                ],
                "to": [
                  0,
                  -0.062,
                  0
                ],
                "ti": [
                  0,
                  -0.841,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 35,
                "s": [
                  250,
                  265.649,
                  0
                ],
                "to": [
                  0,
                  0.841,
                  0
                ],
                "ti": [
                  0,
                  -1.392,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 36,
                "s": [
                  250,
                  269.278,
                  0
                ],
                "to": [
                  0,
                  1.392,
                  0
                ],
                "ti": [
                  0,
                  -1.581,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 37,
                "s": [
                  250,
                  273.998,
                  0
                ],
                "to": [
                  0,
                  1.581,
                  0
                ],
                "ti": [
                  0,
                  -1.463,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 38,
                "s": [
                  250,
                  278.766,
                  0
                ],
                "to": [
                  0,
                  1.463,
                  0
                ],
                "ti": [
                  0,
                  -1.128,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 39,
                "s": [
                  250,
                  282.775,
                  0
                ],
                "to": [
                  0,
                  1.128,
                  0
                ],
                "ti": [
                  0,
                  -0.683,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 40,
                "s": [
                  250,
                  285.533,
                  0
                ],
                "to": [
                  0,
                  0.683,
                  0
                ],
                "ti": [
                  0,
                  -0.228,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.635
                },
                "o": {
                  "x": 0.167,
                  "y": 0.469
                },
                "t": 41,
                "s": [
                  250,
                  286.873,
                  0
                ],
                "to": [
                  0,
                  0.228,
                  0
                ],
                "ti": [
                  0,
                  0.158,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 42,
                "s": [
                  250,
                  286.903,
                  0
                ],
                "to": [
                  0,
                  -0.158,
                  0
                ],
                "ti": [
                  0,
                  0.428,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 43,
                "s": [
                  250,
                  285.924,
                  0
                ],
                "to": [
                  0,
                  -0.428,
                  0
                ],
                "ti": [
                  0,
                  0.563,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 44,
                "s": [
                  250,
                  284.337,
                  0
                ],
                "to": [
                  0,
                  -0.563,
                  0
                ],
                "ti": [
                  0,
                  0.572,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 45,
                "s": [
                  250,
                  282.548,
                  0
                ],
                "to": [
                  0,
                  -0.572,
                  0
                ],
                "ti": [
                  0,
                  0.484,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 46,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  -0.484,
                  0
                ],
                "ti": [
                  0,
                  0.336,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 47,
                "s": [
                  250,
                  279.644,
                  0
                ],
                "to": [
                  0,
                  -0.336,
                  0
                ],
                "ti": [
                  0,
                  0.166,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 48,
                "s": [
                  250,
                  278.89,
                  0
                ],
                "to": [
                  0,
                  -0.166,
                  0
                ],
                "ti": [
                  0,
                  0.008,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 49,
                "s": [
                  250,
                  278.648,
                  0
                ],
                "to": [
                  0,
                  -0.008,
                  0
                ],
                "ti": [
                  0,
                  -0.114,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 50,
                "s": [
                  250,
                  278.839,
                  0
                ],
                "to": [
                  0,
                  0.114,
                  0
                ],
                "ti": [
                  0,
                  -0.188,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 51,
                "s": [
                  250,
                  279.33,
                  0
                ],
                "to": [
                  0,
                  0.188,
                  0
                ],
                "ti": [
                  0,
                  -0.214,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 52,
                "s": [
                  250,
                  279.969,
                  0
                ],
                "to": [
                  0,
                  0.214,
                  0
                ],
                "ti": [
                  0,
                  -0.198,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 53,
                "s": [
                  250,
                  280.614,
                  0
                ],
                "to": [
                  0,
                  0.198,
                  0
                ],
                "ti": [
                  0,
                  -0.153,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 54,
                "s": [
                  250,
                  281.157,
                  0
                ],
                "to": [
                  0,
                  0.153,
                  0
                ],
                "ti": [
                  0,
                  -0.092,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 55,
                "s": [
                  250,
                  281.53,
                  0
                ],
                "to": [
                  0,
                  0.092,
                  0
                ],
                "ti": [
                  0,
                  -0.031,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.633
                },
                "o": {
                  "x": 0.167,
                  "y": 0.471
                },
                "t": 56,
                "s": [
                  250,
                  281.711,
                  0
                ],
                "to": [
                  0,
                  0.031,
                  0
                ],
                "ti": [
                  0,
                  0.021,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 57,
                "s": [
                  250,
                  281.716,
                  0
                ],
                "to": [
                  0,
                  -0.021,
                  0
                ],
                "ti": [
                  0,
                  0.058,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 58,
                "s": [
                  250,
                  281.583,
                  0
                ],
                "to": [
                  0,
                  -0.058,
                  0
                ],
                "ti": [
                  0,
                  0.076,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 59,
                "s": [
                  250,
                  281.368,
                  0
                ],
                "to": [
                  0,
                  -0.076,
                  0
                ],
                "ti": [
                  0,
                  0.077,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 60,
                "s": [
                  250,
                  281.126,
                  0
                ],
                "to": [
                  0,
                  -0.077,
                  0
                ],
                "ti": [
                  0,
                  0.066,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 61,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  -0.066,
                  0
                ],
                "ti": [
                  0,
                  0.045,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 62,
                "s": [
                  250,
                  280.733,
                  0
                ],
                "to": [
                  0,
                  -0.045,
                  0
                ],
                "ti": [
                  0,
                  0.022,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 63,
                "s": [
                  250,
                  280.631,
                  0
                ],
                "to": [
                  0,
                  -0.022,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.704
                },
                "o": {
                  "x": 0.167,
                  "y": 0.188
                },
                "t": 64,
                "s": [
                  250,
                  280.598,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  -0.015,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 65,
                "s": [
                  250,
                  280.624,
                  0
                ],
                "to": [
                  0,
                  0.015,
                  0
                ],
                "ti": [
                  0,
                  -0.025,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 66,
                "s": [
                  250,
                  280.691,
                  0
                ],
                "to": [
                  0,
                  0.025,
                  0
                ],
                "ti": [
                  0,
                  -0.029,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 67,
                "s": [
                  250,
                  280.777,
                  0
                ],
                "to": [
                  0,
                  0.029,
                  0
                ],
                "ti": [
                  0,
                  -0.027,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 68,
                "s": [
                  250,
                  280.865,
                  0
                ],
                "to": [
                  0,
                  0.027,
                  0
                ],
                "ti": [
                  0,
                  -0.021,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 69,
                "s": [
                  250,
                  280.938,
                  0
                ],
                "to": [
                  0,
                  0.021,
                  0
                ],
                "ti": [
                  0,
                  -0.013,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 70,
                "s": [
                  250,
                  280.988,
                  0
                ],
                "to": [
                  0,
                  0.013,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.631
                },
                "o": {
                  "x": 0.167,
                  "y": 0.474
                },
                "t": 71,
                "s": [
                  250,
                  281.013,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 72,
                "s": [
                  250,
                  281.014,
                  0
                ],
                "to": [
                  0,
                  -0.003,
                  0
                ],
                "ti": [
                  0,
                  0.008,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 73,
                "s": [
                  250,
                  280.996,
                  0
                ],
                "to": [
                  0,
                  -0.008,
                  0
                ],
                "ti": [
                  0,
                  0.01,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 74,
                "s": [
                  250,
                  280.967,
                  0
                ],
                "to": [
                  0,
                  -0.01,
                  0
                ],
                "ti": [
                  0,
                  0.01,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 75,
                "s": [
                  250,
                  280.934,
                  0
                ],
                "to": [
                  0,
                  -0.01,
                  0
                ],
                "ti": [
                  0,
                  0.009,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 76,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  -0.009,
                  0
                ],
                "ti": [
                  0,
                  0.006,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 77,
                "s": [
                  250,
                  280.881,
                  0
                ],
                "to": [
                  0,
                  -0.006,
                  0
                ],
                "ti": [
                  0,
                  0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 78,
                "s": [
                  250,
                  280.867,
                  0
                ],
                "to": [
                  0,
                  -0.003,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 79,
                "s": [
                  250,
                  280.862,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -0.002,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 80,
                "s": [
                  250,
                  280.866,
                  0
                ],
                "to": [
                  0,
                  0.002,
                  0
                ],
                "ti": [
                  0,
                  -0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 81,
                "s": [
                  250,
                  280.875,
                  0
                ],
                "to": [
                  0,
                  0.003,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 82,
                "s": [
                  250,
                  280.887,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  -0.004,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 83,
                "s": [
                  250,
                  280.898,
                  0
                ],
                "to": [
                  0,
                  0.004,
                  0
                ],
                "ti": [
                  0,
                  -0.003,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 84,
                "s": [
                  250,
                  280.908,
                  0
                ],
                "to": [
                  0,
                  0.003,
                  0
                ],
                "ti": [
                  0,
                  -0.002,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 85,
                "s": [
                  250,
                  280.915,
                  0
                ],
                "to": [
                  0,
                  0.002,
                  0
                ],
                "ti": [
                  0,
                  -0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.694
                },
                "o": {
                  "x": 0.167,
                  "y": 0.394
                },
                "t": 86,
                "s": [
                  250,
                  280.918,
                  0
                ],
                "to": [
                  0,
                  0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 87,
                "s": [
                  250,
                  280.919,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 88,
                "s": [
                  250,
                  280.916,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 89,
                "s": [
                  250,
                  280.912,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 90,
                "s": [
                  250,
                  280.908,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 91,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 92,
                "s": [
                  250,
                  280.901,
                  0
                ],
                "to": [
                  0,
                  -0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 93,
                "s": [
                  250,
                  280.899,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 94,
                "s": [
                  250,
                  280.898,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 95,
                "s": [
                  250,
                  280.899,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 96,
                "s": [
                  250,
                  280.9,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -0.001,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 97,
                "s": [
                  250,
                  280.901,
                  0
                ],
                "to": [
                  0,
                  0.001,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 98,
                "s": [
                  250,
                  280.903,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 99,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 100,
                "s": [
                  250,
                  280.905,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.953,
                  "y": 0
                },
                "o": {
                  "x": 0.037,
                  "y": 1
                },
                "t": 101,
                "s": [
                  250,
                  280.906,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 102,
                "s": [
                  250,
                  280.906,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 103,
                "s": [
                  250,
                  280.905,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 104,
                "s": [
                  250,
                  280.905,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 105,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 106,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 107,
                "s": [
                  250,
                  280.903,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 108,
                "s": [
                  250,
                  280.903,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 109,
                "s": [
                  250,
                  280.903,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 110,
                "s": [
                  250,
                  280.903,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 111,
                "s": [
                  250,
                  280.903,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 112,
                "s": [
                  250,
                  280.903,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 113,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 114,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.899
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 115,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.953,
                  "y": 0
                },
                "o": {
                  "x": 0.037,
                  "y": 1
                },
                "t": 116,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.781
                },
                "o": {
                  "x": 0.167,
                  "y": 0.108
                },
                "t": 117,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.823
                },
                "o": {
                  "x": 0.167,
                  "y": 0.135
                },
                "t": 118,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.84
                },
                "o": {
                  "x": 0.167,
                  "y": 0.157
                },
                "t": 119,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.853
                },
                "o": {
                  "x": 0.167,
                  "y": 0.174
                },
                "t": 120,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.867
                },
                "o": {
                  "x": 0.167,
                  "y": 0.192
                },
                "t": 121,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.89
                },
                "o": {
                  "x": 0.167,
                  "y": 0.222
                },
                "t": 122,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.85
                },
                "o": {
                  "x": 0.167,
                  "y": 0.343
                },
                "t": 123,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.702
                },
                "o": {
                  "x": 0.167,
                  "y": 0.189
                },
                "t": 124,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.808
                },
                "o": {
                  "x": 0.167,
                  "y": 0.116
                },
                "t": 125,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.832
                },
                "o": {
                  "x": 0.167,
                  "y": 0.147
                },
                "t": 126,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.847
                },
                "o": {
                  "x": 0.167,
                  "y": 0.166
                },
                "t": 127,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.859
                },
                "o": {
                  "x": 0.167,
                  "y": 0.182
                },
                "t": 128,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.876
                },
                "o": {
                  "x": 0.167,
                  "y": 0.204
                },
                "t": 129,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.833,
                  "y": 0.833
                },
                "o": {
                  "x": 0.167,
                  "y": 0.255
                },
                "t": 130,
                "s": [
                  250,
                  280.904,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  0,
                  0
                ]
              },
              {
                "t": 131,
                "s": [
                  250,
                  280.904,
                  0
                ]
              }
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              250,
              280.904,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "ef": [
          {
            "ty": 5,
            "nm": "Position - Overshoot",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 1,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 10,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Position - Bounce",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 2,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 40,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          },
          {
            "ty": 5,
            "nm": "Position - Friction",
            "np": 3,
            "mn": "ADBE Slider Control",
            "ix": 3,
            "en": 1,
            "ef": [
              {
                "ty": 0,
                "nm": "Slider",
                "mn": "ADBE Slider Control-0001",
                "ix": 1,
                "v": {
                  "a": 0,
                  "k": 80,
                  "ix": 1,
                  "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
                }
              }
            ]
          }
        ],
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ty": "gr",
                "it": [
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    1.475,
                                    -0.209
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.21,
                                    1.475
                                  ],
                                  [
                                    -1.475,
                                    0.209
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.209,
                                    -1.475
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.475,
                                    0.209
                                  ],
                                  [
                                    -0.209,
                                    -1.475
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    1.475,
                                    -0.209
                                  ],
                                  [
                                    0.21,
                                    1.475
                                  ]
                                ],
                                "v": [
                                  [
                                    1.588,
                                    2.499
                                  ],
                                  [
                                    -0.831,
                                    2.841
                                  ],
                                  [
                                    -3.879,
                                    0.55
                                  ],
                                  [
                                    -1.588,
                                    -2.499
                                  ],
                                  [
                                    0.831,
                                    -2.841
                                  ],
                                  [
                                    3.879,
                                    -0.55
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                0.192156866193,
                                0.20000000298,
                                0.517647087574,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                260.12,
                                224.61
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 1",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    4.057,
                                    -7.903
                                  ],
                                  [
                                    3.555,
                                    -3.268
                                  ],
                                  [
                                    5.477,
                                    -1.055
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -3.838,
                                    3.638
                                  ],
                                  [
                                    -2.08,
                                    5.757
                                  ],
                                  [
                                    -0.007,
                                    0.045
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.134,
                                    0.847
                                  ],
                                  [
                                    -2.027,
                                    3.952
                                  ],
                                  [
                                    -3.559,
                                    3.269
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    6.064,
                                    -1.164
                                  ],
                                  [
                                    5.76,
                                    -5.462
                                  ],
                                  [
                                    2.077,
                                    -5.759
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    12.631,
                                    -18.268
                                  ],
                                  [
                                    12.619,
                                    -18.191
                                  ],
                                  [
                                    7.107,
                                    -1.785
                                  ],
                                  [
                                    -1.182,
                                    9.446
                                  ],
                                  [
                                    -14.609,
                                    16.304
                                  ],
                                  [
                                    -14.232,
                                    18.268
                                  ],
                                  [
                                    0.535,
                                    10.579
                                  ],
                                  [
                                    11.868,
                                    -7.767
                                  ],
                                  [
                                    14.609,
                                    -17.974
                                  ],
                                  [
                                    12.631,
                                    -18.268
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                0.192156866193,
                                0.20000000298,
                                0.517647087574,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                274.268,
                                207.516
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 2",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 2,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            274.268,
                            207.516
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            274.268,
                            207.516
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.79,
                                -6.37
                              ],
                              [
                                0,
                                7.27
                              ],
                              [
                                -2.06,
                                0.68
                              ]
                            ],
                            "o": [
                              [
                                -2.23,
                                0.38
                              ],
                              [
                                0,
                                -7.27
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                4.42,
                                13.083
                              ],
                              [
                                -4.42,
                                -1.497
                              ],
                              [
                                -1.23,
                                -13.097
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.290196090937,
                            0.376470595598,
                            0.870588243008,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            207.828,
                            185.658
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                2.26,
                                0.17
                              ],
                              [
                                0.2,
                                0.04
                              ],
                              [
                                -1.44,
                                11.98
                              ],
                              [
                                -0.56,
                                -6.06
                              ]
                            ],
                            "o": [
                              [
                                -0.2,
                                -0.01
                              ],
                              [
                                1.26,
                                -4.9
                              ],
                              [
                                1.6,
                                1.24
                              ],
                              [
                                0.68,
                                7.24
                              ]
                            ],
                            "v": [
                              [
                                -3.452,
                                13.049
                              ],
                              [
                                -4.042,
                                12.969
                              ],
                              [
                                0.708,
                                -13.051
                              ],
                              [
                                3.988,
                                -2.291
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.290196090937,
                            0.376470595598,
                            0.870588243008,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            288.261,
                            184.183
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                7.125
                              ],
                              [
                                -34.475,
                                -1.25
                              ],
                              [
                                -0.563,
                                -6.75
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                -10.236
                              ],
                              [
                                0,
                                -7.125
                              ],
                              [
                                34.475,
                                1.25
                              ],
                              [
                                0.563,
                                6.75
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -38.111,
                                23.425
                              ],
                              [
                                -40.025,
                                3.362
                              ],
                              [
                                0.814,
                                -23.371
                              ],
                              [
                                39.924,
                                2.425
                              ],
                              [
                                38.515,
                                22.58
                              ]
                            ],
                            "c": false
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.800000011921,
                            0.800000011921,
                            0.800000011921,
                            1
                          ],
                          "ix": 3
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 4
                        },
                        "w": {
                          "a": 0,
                          "k": 2,
                          "ix": 5
                        },
                        "lc": 1,
                        "lj": 1,
                        "ml": 10,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "mn": "ADBE Vector Graphic - Stroke",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            247.865,
                            153.382
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 4",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                7.855
                              ],
                              [
                                -34.475,
                                -1.378
                              ],
                              [
                                -0.563,
                                -7.441
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                -11.284
                              ],
                              [
                                0,
                                -7.855
                              ],
                              [
                                34.475,
                                1.378
                              ],
                              [
                                0.563,
                                7.441
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -38.111,
                                25.781
                              ],
                              [
                                -40.025,
                                3.75
                              ],
                              [
                                0.814,
                                -25.722
                              ],
                              [
                                39.924,
                                2.717
                              ],
                              [
                                38.515,
                                24.937
                              ]
                            ],
                            "c": false
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "st",
                        "c": {
                          "a": 0,
                          "k": [
                            0.800000011921,
                            0.800000011921,
                            0.800000011921,
                            1
                          ],
                          "ix": 3
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 4
                        },
                        "w": {
                          "a": 0,
                          "k": 2,
                          "ix": 5
                        },
                        "lc": 1,
                        "lj": 1,
                        "ml": 10,
                        "bm": 0,
                        "nm": "Stroke 1",
                        "mn": "ADBE Vector Graphic - Stroke",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            247.865,
                            151.025
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 5",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                2.26,
                                0.17
                              ],
                              [
                                0.2,
                                0.04
                              ],
                              [
                                -0.27,
                                1.27
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -2.11,
                                -0.48
                              ],
                              [
                                -0.3,
                                -0.25
                              ],
                              [
                                -0.56,
                                -6.06
                              ]
                            ],
                            "o": [
                              [
                                -0.2,
                                -0.01
                              ],
                              [
                                -2.05,
                                -0.39
                              ],
                              [
                                0.3,
                                -1.39
                              ],
                              [
                                -0.34,
                                -3.62
                              ],
                              [
                                0.34,
                                0.08
                              ],
                              [
                                1.6,
                                1.24
                              ],
                              [
                                0.68,
                                7.24
                              ]
                            ],
                            "v": [
                              [
                                -1.57,
                                13.358
                              ],
                              [
                                -2.16,
                                13.278
                              ],
                              [
                                -5.9,
                                10.028
                              ],
                              [
                                -3.68,
                                -9.322
                              ],
                              [
                                1.62,
                                -13.232
                              ],
                              [
                                2.59,
                                -12.742
                              ],
                              [
                                5.87,
                                -1.982
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.192156866193,
                            0.20000000298,
                            0.517647087574,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            286.378,
                            183.874
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 6",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                2.23,
                                -0.37
                              ],
                              [
                                0,
                                7.27
                              ],
                              [
                                -2.06,
                                0.68
                              ],
                              [
                                0,
                                -3.64
                              ],
                              [
                                -0.42,
                                -1.36
                              ]
                            ],
                            "o": [
                              [
                                -2.23,
                                0.38
                              ],
                              [
                                0,
                                -7.27
                              ],
                              [
                                2.07,
                                -0.68
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.43,
                                1.35
                              ]
                            ],
                            "v": [
                              [
                                2.393,
                                13.217
                              ],
                              [
                                -6.447,
                                -1.363
                              ],
                              [
                                -3.257,
                                -12.963
                              ],
                              [
                                2.393,
                                -9.563
                              ],
                              [
                                6.393,
                                9.507
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.192156866193,
                            0.20000000298,
                            0.517647087574,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            209.855,
                            185.525
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 7",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 7,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                -1.312
                              ],
                              [
                                1.312,
                                0
                              ],
                              [
                                0,
                                1.312
                              ],
                              [
                                -1.312,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                1.312
                              ],
                              [
                                -1.312,
                                0
                              ],
                              [
                                0,
                                -1.312
                              ],
                              [
                                1.312,
                                0
                              ]
                            ],
                            "v": [
                              [
                                2.375,
                                0
                              ],
                              [
                                0,
                                2.375
                              ],
                              [
                                -2.375,
                                0
                              ],
                              [
                                0,
                                -2.375
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.290196090937,
                            0.376470595598,
                            0.870588243008,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            248.32,
                            281.682
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 8",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 8,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                -1.312
                              ],
                              [
                                1.312,
                                0
                              ],
                              [
                                0,
                                1.312
                              ],
                              [
                                -1.312,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                1.312
                              ],
                              [
                                -1.312,
                                0
                              ],
                              [
                                0,
                                -1.312
                              ],
                              [
                                1.312,
                                0
                              ]
                            ],
                            "v": [
                              [
                                2.375,
                                0
                              ],
                              [
                                0,
                                2.375
                              ],
                              [
                                -2.375,
                                0
                              ],
                              [
                                0,
                                -2.375
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.290196090937,
                            0.376470595598,
                            0.870588243008,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            248.32,
                            262.682
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 9",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 9,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                -4.735,
                                -22.092
                              ],
                              [
                                -4.735,
                                22.204
                              ],
                              [
                                4.735,
                                22.204
                              ],
                              [
                                4.735,
                                -22.204
                              ],
                              [
                                0.482,
                                -20.226
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.137254908681,
                            0.145098045468,
                            0.40000000596,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            248.106,
                            273.602
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 10",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 10,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -20.99,
                                0.58
                              ],
                              [
                                5.69,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                -2.53,
                                4.43
                              ],
                              [
                                -9,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                16.38,
                                0.18
                              ]
                            ],
                            "v": [
                              [
                                34.885,
                                -3.425
                              ],
                              [
                                21.875,
                                3.425
                              ],
                              [
                                -34.885,
                                3.425
                              ],
                              [
                                -34.885,
                                -3.285
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.886274516582,
                            0.627451002598,
                            0.721568644047,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            318.353,
                            394.677
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 11",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 11,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                1.47,
                                -2.58
                              ],
                              [
                                5.69,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.73,
                                0.16
                              ],
                              [
                                -9.77,
                                5.33
                              ],
                              [
                                -0.57,
                                -6.83
                              ]
                            ],
                            "o": [
                              [
                                -2.53,
                                4.43
                              ],
                              [
                                -9,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.77,
                                -0.14
                              ],
                              [
                                11.1,
                                -2.29
                              ],
                              [
                                1.65,
                                5.16
                              ],
                              [
                                0.32,
                                3.86
                              ]
                            ],
                            "v": [
                              [
                                33.917,
                                11.7
                              ],
                              [
                                20.907,
                                18.55
                              ],
                              [
                                -35.853,
                                18.55
                              ],
                              [
                                -35.853,
                                -0.24
                              ],
                              [
                                0.707,
                                -7.45
                              ],
                              [
                                1.067,
                                -7.52
                              ],
                              [
                                4.937,
                                -8.9
                              ],
                              [
                                31.087,
                                -18.55
                              ],
                              [
                                35.777,
                                2
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            1,
                            0.733333349228,
                            0.800000011921,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            319.321,
                            379.552
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 12",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 12,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                9,
                                0
                              ],
                              [
                                -0.88,
                                10.5
                              ],
                              [
                                -1.65,
                                5.16
                              ],
                              [
                                -11.1,
                                -2.29
                              ],
                              [
                                -0.77,
                                -0.14
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -9,
                                0
                              ],
                              [
                                0.57,
                                -6.83
                              ],
                              [
                                9.77,
                                5.33
                              ],
                              [
                                0.73,
                                0.16
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                35.854,
                                -0.24
                              ],
                              [
                                35.854,
                                18.55
                              ],
                              [
                                -20.906,
                                18.55
                              ],
                              [
                                -35.776,
                                2
                              ],
                              [
                                -31.086,
                                -18.55
                              ],
                              [
                                -3.326,
                                -7.97
                              ],
                              [
                                -1.066,
                                -7.52
                              ],
                              [
                                -0.706,
                                -7.45
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.886274516582,
                            0.627451002598,
                            0.721568644047,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            180.445,
                            379.552
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 13",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 13,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -3.286,
                                1.572
                              ],
                              [
                                -0.212,
                                -0.042
                              ],
                              [
                                0.087,
                                -0.342
                              ],
                              [
                                0.267,
                                -0.231
                              ],
                              [
                                3.856,
                                2.514
                              ],
                              [
                                -0.297,
                                0.568
                              ],
                              [
                                -0.953,
                                -0.279
                              ]
                            ],
                            "o": [
                              [
                                0.195,
                                -0.093
                              ],
                              [
                                0.346,
                                0.069
                              ],
                              [
                                -0.087,
                                0.342
                              ],
                              [
                                -3.567,
                                3.091
                              ],
                              [
                                -0.537,
                                -0.35
                              ],
                              [
                                0.891,
                                -0.438
                              ],
                              [
                                3.556,
                                1.043
                              ]
                            ],
                            "v": [
                              [
                                5.828,
                                -1.936
                              ],
                              [
                                6.446,
                                -2.085
                              ],
                              [
                                6.879,
                                -1.244
                              ],
                              [
                                6.259,
                                -0.407
                              ],
                              [
                                -5.999,
                                0.363
                              ],
                              [
                                -6.82,
                                -1.178
                              ],
                              [
                                -3.924,
                                -0.969
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.192156866193,
                            0.20000000298,
                            0.517647087574,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            249.301,
                            210.653
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 14",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 14,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                2.608,
                                4.822
                              ],
                              [
                                -2.608,
                                2.956
                              ],
                              [
                                0.528,
                                -4.822
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.137254908681,
                            0.145098045468,
                            0.40000000596,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            245.979,
                            248.554
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 15",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 15,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0.748,
                                -6.785
                              ],
                              [
                                0.236,
                                -0.758
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -3.402,
                                1.742
                              ],
                              [
                                -4.684,
                                5.36
                              ],
                              [
                                0.154,
                                3.361
                              ]
                            ],
                            "o": [
                              [
                                -0.082,
                                0.779
                              ],
                              [
                                -2.285,
                                7.379
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.603,
                                -1.322
                              ],
                              [
                                2.214,
                                -2.531
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                12.425,
                                -7.83
                              ],
                              [
                                11.954,
                                -5.514
                              ],
                              [
                                -4.239,
                                21.655
                              ],
                              [
                                -10.347,
                                8.783
                              ],
                              [
                                -12.51,
                                1.117
                              ],
                              [
                                -9.107,
                                -0.625
                              ],
                              [
                                5.528,
                                -12.452
                              ],
                              [
                                8.715,
                                -21.655
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.192156866193,
                            0.20000000298,
                            0.517647087574,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            263.188,
                            242.615
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 16",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 16,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "o": [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                2.127,
                                2.844
                              ],
                              [
                                -2.127,
                                4.822
                              ],
                              [
                                -0.036,
                                -4.822
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.137254908681,
                            0.145098045468,
                            0.40000000596,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            250.714,
                            248.554
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 17",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 17,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    2.127,
                                    2.844
                                  ],
                                  [
                                    -2.127,
                                    4.822
                                  ],
                                  [
                                    -0.036,
                                    -4.822
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                0.960784316063,
                                0.823529422283,
                                0.478431373835,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                250.714,
                                248.554
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 1",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "v": [
                                  [
                                    2.127,
                                    4.822
                                  ],
                                  [
                                    -2.127,
                                    2.844
                                  ],
                                  [
                                    0.046,
                                    -4.822
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                0.960784316063,
                                0.823529422283,
                                0.478431373835,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                246.461,
                                248.554
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 2",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 2,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.751,
                                    7.691
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -2.214,
                                    -2.531
                                  ],
                                  [
                                    -2.603,
                                    -1.322
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.332,
                                    -13.651
                                  ],
                                  [
                                    -0.154,
                                    3.361
                                  ],
                                  [
                                    4.684,
                                    5.36
                                  ],
                                  [
                                    3.413,
                                    1.742
                                  ]
                                ],
                                "v": [
                                  [
                                    12.941,
                                    1.117
                                  ],
                                  [
                                    4.66,
                                    21.655
                                  ],
                                  [
                                    -12.742,
                                    -7.051
                                  ],
                                  [
                                    -8.294,
                                    -21.655
                                  ],
                                  [
                                    -5.107,
                                    -12.452
                                  ],
                                  [
                                    9.528,
                                    -0.625
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                0.192156866193,
                                0.20000000298,
                                0.517647087574,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                233.566,
                                242.615
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 3",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 3,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            233.566,
                            242.615
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            233.566,
                            242.615
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 18",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 18,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.21,
                                -0.065
                              ],
                              [
                                -0.633,
                                0.943
                              ],
                              [
                                0.39,
                                1.492
                              ],
                              [
                                0.841,
                                2.295
                              ],
                              [
                                0.309,
                                0.347
                              ],
                              [
                                0.45,
                                -0.114
                              ],
                              [
                                0.235,
                                -0.351
                              ],
                              [
                                0.208,
                                -1.717
                              ],
                              [
                                0.197,
                                -2.185
                              ]
                            ],
                            "o": [
                              [
                                1.704,
                                0.05
                              ],
                              [
                                0.975,
                                -1.453
                              ],
                              [
                                -0.618,
                                -2.365
                              ],
                              [
                                -0.16,
                                -0.436
                              ],
                              [
                                -0.309,
                                -0.347
                              ],
                              [
                                -0.41,
                                0.104
                              ],
                              [
                                -0.986,
                                1.471
                              ],
                              [
                                -0.264,
                                2.178
                              ],
                              [
                                -0.195,
                                2.17
                              ]
                            ],
                            "v": [
                              [
                                -0.753,
                                8.089
                              ],
                              [
                                3.523,
                                6.562
                              ],
                              [
                                2.926,
                                0.625
                              ],
                              [
                                0.735,
                                -6.371
                              ],
                              [
                                0.097,
                                -7.598
                              ],
                              [
                                -1.143,
                                -8.063
                              ],
                              [
                                -2.079,
                                -7.253
                              ],
                              [
                                -3.186,
                                -1.898
                              ],
                              [
                                -3.877,
                                4.647
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.886274516582,
                            0.627451002598,
                            0.721568644047,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            249.417,
                            192.255
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 19",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 19,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0.111,
                                    0.044
                                  ],
                                  [
                                    3.414,
                                    -0.964
                                  ],
                                  [
                                    -1.745,
                                    0.357
                                  ],
                                  [
                                    -2.652,
                                    -1.615
                                  ],
                                  [
                                    0.273,
                                    -0.605
                                  ],
                                  [
                                    0.087,
                                    -0.033
                                  ]
                                ],
                                "o": [
                                  [
                                    -3.181,
                                    -1.274
                                  ],
                                  [
                                    -2.416,
                                    0.683
                                  ],
                                  [
                                    3.042,
                                    -0.623
                                  ],
                                  [
                                    0.567,
                                    0.345
                                  ],
                                  [
                                    -0.038,
                                    0.085
                                  ],
                                  [
                                    -0.111,
                                    0.042
                                  ]
                                ],
                                "v": [
                                  [
                                    5.344,
                                    1.735
                                  ],
                                  [
                                    -4.612,
                                    0.481
                                  ],
                                  [
                                    -3.995,
                                    -1.552
                                  ],
                                  [
                                    4.969,
                                    0.01
                                  ],
                                  [
                                    5.874,
                                    1.581
                                  ],
                                  [
                                    5.689,
                                    1.781
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                0.192156866193,
                                0.20000000298,
                                0.517647087574,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                261.471,
                                168.23
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 1",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    -0.1,
                                    0.064
                                  ],
                                  [
                                    -3.533,
                                    -0.316
                                  ],
                                  [
                                    1.781,
                                    0.028
                                  ],
                                  [
                                    2.308,
                                    -2.077
                                  ],
                                  [
                                    -0.38,
                                    -0.544
                                  ],
                                  [
                                    -0.092,
                                    -0.017
                                  ]
                                ],
                                "o": [
                                  [
                                    2.89,
                                    -1.841
                                  ],
                                  [
                                    2.501,
                                    0.224
                                  ],
                                  [
                                    -3.105,
                                    -0.05
                                  ],
                                  [
                                    -0.493,
                                    0.444
                                  ],
                                  [
                                    0.054,
                                    0.077
                                  ],
                                  [
                                    0.117,
                                    0.021
                                  ]
                                ],
                                "v": [
                                  [
                                    -5.063,
                                    2.423
                                  ],
                                  [
                                    4.49,
                                    -0.651
                                  ],
                                  [
                                    3.507,
                                    -2.534
                                  ],
                                  [
                                    -5.014,
                                    0.658
                                  ],
                                  [
                                    -5.613,
                                    2.37
                                  ],
                                  [
                                    -5.393,
                                    2.532
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                0.192156866193,
                                0.20000000298,
                                0.517647087574,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                231.513,
                                170.028
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 2",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 2,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ty": "gr",
                            "it": [
                              {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                  "a": 0,
                                  "k": {
                                    "i": [
                                      [
                                        0.222,
                                        -1.746
                                      ],
                                      [
                                        1.294,
                                        0.227
                                      ],
                                      [
                                        -0.222,
                                        1.746
                                      ],
                                      [
                                        -1.294,
                                        -0.227
                                      ]
                                    ],
                                    "o": [
                                      [
                                        -0.222,
                                        1.746
                                      ],
                                      [
                                        -1.294,
                                        -0.227
                                      ],
                                      [
                                        0.222,
                                        -1.746
                                      ],
                                      [
                                        1.294,
                                        0.227
                                      ]
                                    ],
                                    "v": [
                                      [
                                        2.342,
                                        0.412
                                      ],
                                      [
                                        -0.402,
                                        3.162
                                      ],
                                      [
                                        -2.342,
                                        -0.412
                                      ],
                                      [
                                        0.402,
                                        -3.162
                                      ]
                                    ],
                                    "c": true
                                  },
                                  "ix": 2
                                },
                                "nm": "Path 1",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                              },
                              {
                                "ty": "fl",
                                "c": {
                                  "a": 0,
                                  "k": [
                                    0.192156866193,
                                    0.20000000298,
                                    0.517647087574,
                                    1
                                  ],
                                  "ix": 4
                                },
                                "o": {
                                  "a": 0,
                                  "k": 100,
                                  "ix": 5
                                },
                                "r": 1,
                                "bm": 0,
                                "nm": "Fill 1",
                                "mn": "ADBE Vector Graphic - Fill",
                                "hd": false
                              },
                              {
                                "ty": "tr",
                                "p": {
                                  "a": 0,
                                  "k": [
                                    0,
                                    0
                                  ],
                                  "ix": 2
                                },
                                "a": {
                                  "a": 0,
                                  "k": [
                                    0,
                                    0
                                  ],
                                  "ix": 1
                                },
                                "s": {
                                  "a": 0,
                                  "k": [
                                    100,
                                    100
                                  ],
                                  "ix": 3
                                },
                                "r": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 6
                                },
                                "o": {
                                  "a": 0,
                                  "k": 100,
                                  "ix": 7
                                },
                                "sk": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 4
                                },
                                "sa": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 5
                                },
                                "nm": "Transform"
                              }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                261.002,
                                183.464
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 3",
                        "np": 1,
                        "cix": 2,
                        "bm": 0,
                        "ix": 3,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ty": "gr",
                            "it": [
                              {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                  "a": 0,
                                  "k": {
                                    "i": [
                                      [
                                        -0.06,
                                        -1.759
                                      ],
                                      [
                                        1.313,
                                        0.018
                                      ],
                                      [
                                        0.06,
                                        1.759
                                      ],
                                      [
                                        -1.313,
                                        -0.018
                                      ]
                                    ],
                                    "o": [
                                      [
                                        0.06,
                                        1.759
                                      ],
                                      [
                                        -1.313,
                                        -0.018
                                      ],
                                      [
                                        -0.06,
                                        -1.759
                                      ],
                                      [
                                        1.313,
                                        0.018
                                      ]
                                    ],
                                    "v": [
                                      [
                                        2.378,
                                        0.033
                                      ],
                                      [
                                        0.108,
                                        3.185
                                      ],
                                      [
                                        -2.378,
                                        -0.033
                                      ],
                                      [
                                        -0.108,
                                        -3.185
                                      ]
                                    ],
                                    "c": true
                                  },
                                  "ix": 2
                                },
                                "nm": "Path 1",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                              },
                              {
                                "ty": "fl",
                                "c": {
                                  "a": 0,
                                  "k": [
                                    0.192156866193,
                                    0.20000000298,
                                    0.517647087574,
                                    1
                                  ],
                                  "ix": 4
                                },
                                "o": {
                                  "a": 0,
                                  "k": 100,
                                  "ix": 5
                                },
                                "r": 1,
                                "bm": 0,
                                "nm": "Fill 1",
                                "mn": "ADBE Vector Graphic - Fill",
                                "hd": false
                              },
                              {
                                "ty": "tr",
                                "p": {
                                  "a": 0,
                                  "k": [
                                    0,
                                    0
                                  ],
                                  "ix": 2
                                },
                                "a": {
                                  "a": 0,
                                  "k": [
                                    0,
                                    0
                                  ],
                                  "ix": 1
                                },
                                "s": {
                                  "a": 0,
                                  "k": [
                                    100,
                                    100
                                  ],
                                  "ix": 3
                                },
                                "r": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 6
                                },
                                "o": {
                                  "a": 0,
                                  "k": 100,
                                  "ix": 7
                                },
                                "sk": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 4
                                },
                                "sa": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 5
                                },
                                "nm": "Transform"
                              }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                233.272,
                                184.162
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 4",
                        "np": 1,
                        "cix": 2,
                        "bm": 0,
                        "ix": 4,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0.631,
                                    -8.727
                                  ],
                                  [
                                    0.347,
                                    -4.028
                                  ],
                                  [
                                    -0.364,
                                    -1.727
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.945,
                                    3.117
                                  ],
                                  [
                                    0.045,
                                    -0.004
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.889,
                                    -3.537
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.054,
                                    9.825
                                  ],
                                  [
                                    -4.045,
                                    1.167
                                  ],
                                  [
                                    0.029,
                                    0.065
                                  ],
                                  [
                                    -2.791,
                                    2.269
                                  ],
                                  [
                                    -13.352,
                                    0.613
                                  ],
                                  [
                                    -4.052,
                                    -1.812
                                  ],
                                  [
                                    0.15,
                                    -4.439
                                  ],
                                  [
                                    -1.479,
                                    -4.241
                                  ]
                                ],
                                "o": [
                                  [
                                    -0.251,
                                    3.364
                                  ],
                                  [
                                    -0.186,
                                    2.117
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.968,
                                    -6.34
                                  ],
                                  [
                                    -14.085,
                                    8.244
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.168,
                                    4.421
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.028,
                                    -3.818
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -1.715,
                                    -3.136
                                  ],
                                  [
                                    10.342,
                                    -8.437
                                  ],
                                  [
                                    4.45,
                                    -0.212
                                  ],
                                  [
                                    4.054,
                                    1.834
                                  ],
                                  [
                                    4.467,
                                    -0.033
                                  ],
                                  [
                                    2.921,
                                    8.328
                                  ]
                                ],
                                "v": [
                                  [
                                    37.416,
                                    15.201
                                  ],
                                  [
                                    35.828,
                                    26.975
                                  ],
                                  [
                                    35.99,
                                    32.829
                                  ],
                                  [
                                    31.399,
                                    15.216
                                  ],
                                  [
                                    26.094,
                                    9.886
                                  ],
                                  [
                                    22.937,
                                    0
                                  ],
                                  [
                                    -22.782,
                                    1.375
                                  ],
                                  [
                                    -24.78,
                                    12.149
                                  ],
                                  [
                                    -30.246,
                                    17.918
                                  ],
                                  [
                                    -33.541,
                                    33.762
                                  ],
                                  [
                                    -39.06,
                                    -3.625
                                  ],
                                  [
                                    -33.669,
                                    -12.142
                                  ],
                                  [
                                    -33.722,
                                    -12.227
                                  ],
                                  [
                                    -29.951,
                                    -21.405
                                  ],
                                  [
                                    7.506,
                                    -33.68
                                  ],
                                  [
                                    20.621,
                                    -31.992
                                  ],
                                  [
                                    27.899,
                                    -21.722
                                  ],
                                  [
                                    37.692,
                                    -13.787
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                0.192156866193,
                                0.20000000298,
                                0.517647087574,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                246.901,
                                147.943
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 5",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 5,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    -0.011,
                                    -22.866
                                  ],
                                  [
                                    23.155,
                                    -0.309
                                  ],
                                  [
                                    2.545,
                                    0.665
                                  ],
                                  [
                                    0.518,
                                    21.036
                                  ],
                                  [
                                    -12.049,
                                    6.835
                                  ],
                                  [
                                    -7.846,
                                    0.1
                                  ]
                                ],
                                "o": [
                                  [
                                    0.01,
                                    24.063
                                  ],
                                  [
                                    -2.908,
                                    0.045
                                  ],
                                  [
                                    -17.8,
                                    -4.48
                                  ],
                                  [
                                    -0.475,
                                    -19.618
                                  ],
                                  [
                                    4.91,
                                    -2.783
                                  ],
                                  [
                                    27.212,
                                    -0.371
                                  ]
                                ],
                                "v": [
                                  [
                                    35.078,
                                    -1.598
                                  ],
                                  [
                                    0.663,
                                    45.947
                                  ],
                                  [
                                    -7.508,
                                    44.994
                                  ],
                                  [
                                    -35.039,
                                    -0.656
                                  ],
                                  [
                                    -19.597,
                                    -41.533
                                  ],
                                  [
                                    -0.595,
                                    -45.947
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                1,
                                0.733333349228,
                                0.800000011921,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                248.028,
                                175.962
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 6",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 6,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ty": "gr",
                            "it": [
                              {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                  "a": 0,
                                  "k": {
                                    "i": [
                                      [
                                        0,
                                        0
                                      ],
                                      [
                                        0.694,
                                        -3.933
                                      ],
                                      [
                                        6.044,
                                        4.776
                                      ]
                                    ],
                                    "o": [
                                      [
                                        8.17,
                                        -0.464
                                      ],
                                      [
                                        -0.694,
                                        3.933
                                      ],
                                      [
                                        -0.971,
                                        -16.43
                                      ]
                                    ],
                                    "v": [
                                      [
                                        -3.31,
                                        -9.706
                                      ],
                                      [
                                        5.756,
                                        0.842
                                      ],
                                      [
                                        -5.727,
                                        8.285
                                      ]
                                    ],
                                    "c": true
                                  },
                                  "ix": 2
                                },
                                "nm": "Path 1",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                              },
                              {
                                "ty": "fl",
                                "c": {
                                  "a": 0,
                                  "k": [
                                    1,
                                    0.733333349228,
                                    0.800000011921,
                                    1
                                  ],
                                  "ix": 4
                                },
                                "o": {
                                  "a": 0,
                                  "k": 100,
                                  "ix": 5
                                },
                                "r": 1,
                                "bm": 0,
                                "nm": "Fill 1",
                                "mn": "ADBE Vector Graphic - Fill",
                                "hd": false
                              },
                              {
                                "ty": "tr",
                                "p": {
                                  "a": 0,
                                  "k": [
                                    284.997,
                                    182.527
                                  ],
                                  "ix": 2
                                },
                                "a": {
                                  "a": 0,
                                  "k": [
                                    0,
                                    0
                                  ],
                                  "ix": 1
                                },
                                "s": {
                                  "a": 0,
                                  "k": [
                                    100,
                                    100
                                  ],
                                  "ix": 3
                                },
                                "r": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 6
                                },
                                "o": {
                                  "a": 0,
                                  "k": 100,
                                  "ix": 7
                                },
                                "sk": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 4
                                },
                                "sa": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 5
                                },
                                "nm": "Transform"
                              }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                          },
                          {
                            "ty": "gr",
                            "it": [
                              {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                  "a": 0,
                                  "k": {
                                    "i": [
                                      [
                                        0,
                                        0
                                      ],
                                      [
                                        -0.801,
                                        -3.913
                                      ],
                                      [
                                        -5.912,
                                        4.939
                                      ]
                                    ],
                                    "o": [
                                      [
                                        -8.179,
                                        -0.242
                                      ],
                                      [
                                        0.8,
                                        3.913
                                      ],
                                      [
                                        0.524,
                                        -16.45
                                      ]
                                    ],
                                    "v": [
                                      [
                                        3.007,
                                        -9.728
                                      ],
                                      [
                                        -5.77,
                                        1.062
                                      ],
                                      [
                                        5.912,
                                        8.191
                                      ]
                                    ],
                                    "c": true
                                  },
                                  "ix": 2
                                },
                                "nm": "Path 1",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                              },
                              {
                                "ty": "fl",
                                "c": {
                                  "a": 0,
                                  "k": [
                                    0.886274516582,
                                    0.627451002598,
                                    0.721568644047,
                                    1
                                  ],
                                  "ix": 4
                                },
                                "o": {
                                  "a": 0,
                                  "k": 100,
                                  "ix": 5
                                },
                                "r": 1,
                                "bm": 0,
                                "nm": "Fill 1",
                                "mn": "ADBE Vector Graphic - Fill",
                                "hd": false
                              },
                              {
                                "ty": "tr",
                                "p": {
                                  "a": 0,
                                  "k": [
                                    211.364,
                                    183.464
                                  ],
                                  "ix": 2
                                },
                                "a": {
                                  "a": 0,
                                  "k": [
                                    0,
                                    0
                                  ],
                                  "ix": 1
                                },
                                "s": {
                                  "a": 0,
                                  "k": [
                                    100,
                                    100
                                  ],
                                  "ix": 3
                                },
                                "r": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 6
                                },
                                "o": {
                                  "a": 0,
                                  "k": 100,
                                  "ix": 7
                                },
                                "sk": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 4
                                },
                                "sa": {
                                  "a": 0,
                                  "k": 0,
                                  "ix": 5
                                },
                                "nm": "Transform"
                              }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                211.364,
                                183.464
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                211.364,
                                183.464
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 7",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 7,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            211.364,
                            183.464
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            211.364,
                            183.464
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 20",
                    "np": 7,
                    "cix": 2,
                    "bm": 0,
                    "ix": 20,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    -11.003,
                                    8.219
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.687,
                                    -0.205
                                  ],
                                  [
                                    -5.639,
                                    -4.895
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -0.666,
                                    0.164
                                  ],
                                  [
                                    2.555,
                                    3.205
                                  ],
                                  [
                                    10.384,
                                    -9.24
                                  ]
                                ],
                                "v": [
                                  [
                                    21.486,
                                    -4.119
                                  ],
                                  [
                                    21.209,
                                    -24.271
                                  ],
                                  [
                                    -19.918,
                                    -23.707
                                  ],
                                  [
                                    -19.457,
                                    10.533
                                  ],
                                  [
                                    -21.486,
                                    11.087
                                  ],
                                  [
                                    -8.883,
                                    24.271
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                0.886274516582,
                                0.627451002598,
                                0.721568644047,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                247.148,
                                221.525
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 1",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    -0.594,
                                    -0.205
                                  ],
                                  [
                                    7.808,
                                    -4.822
                                  ],
                                  [
                                    3.966,
                                    4.971
                                  ],
                                  [
                                    -0.666,
                                    0.164
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ]
                                ],
                                "o": [
                                  [
                                    -6.682,
                                    8.342
                                  ],
                                  [
                                    -10.566,
                                    -6.313
                                  ],
                                  [
                                    0.697,
                                    -0.205
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0.594,
                                    0.184
                                  ]
                                ],
                                "v": [
                                  [
                                    22.485,
                                    8.558
                                  ],
                                  [
                                    0.441,
                                    28.061
                                  ],
                                  [
                                    -22.485,
                                    7.297
                                  ],
                                  [
                                    -20.456,
                                    6.744
                                  ],
                                  [
                                    -20.917,
                                    -27.497
                                  ],
                                  [
                                    20.21,
                                    -28.061
                                  ],
                                  [
                                    20.62,
                                    1.763
                                  ],
                                  [
                                    20.702,
                                    7.984
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                1,
                                0.733333349228,
                                0.800000011921,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                248.147,
                                225.315
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 2",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 2,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    -1.179,
                                    -0.082
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    2.972,
                                    -19.155
                                  ],
                                  [
                                    -0.953,
                                    -40.103
                                  ],
                                  [
                                    8.394,
                                    3.228
                                  ],
                                  [
                                    4.981,
                                    2.634
                                  ],
                                  [
                                    0.43,
                                    1.701
                                  ],
                                  [
                                    -0.789,
                                    2.04
                                  ],
                                  [
                                    1.281,
                                    27.343
                                  ],
                                  [
                                    0.697,
                                    14.738
                                  ],
                                  [
                                    -3.71,
                                    8.127
                                  ],
                                  [
                                    -18.294,
                                    7.328
                                  ],
                                  [
                                    -7.615,
                                    0.687
                                  ],
                                  [
                                    -4.161,
                                    0.01
                                  ]
                                ],
                                "o": [
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    0,
                                    0
                                  ],
                                  [
                                    -2.326,
                                    15.004
                                  ],
                                  [
                                    -9.08,
                                    -1.548
                                  ],
                                  [
                                    -5.196,
                                    -1.999
                                  ],
                                  [
                                    -1.619,
                                    -0.861
                                  ],
                                  [
                                    -0.543,
                                    -2.122
                                  ],
                                  [
                                    9.254,
                                    -24.043
                                  ],
                                  [
                                    -0.666,
                                    -14.235
                                  ],
                                  [
                                    -0.4,
                                    -8.445
                                  ],
                                  [
                                    2.767,
                                    -6.077
                                  ],
                                  [
                                    7.061,
                                    -2.818
                                  ],
                                  [
                                    4.366,
                                    -0.41
                                  ],
                                  [
                                    1.148,
                                    -0.01
                                  ]
                                ],
                                "v": [
                                  [
                                    42.38,
                                    -107.184
                                  ],
                                  [
                                    37.389,
                                    -91.432
                                  ],
                                  [
                                    1.612,
                                    -42.054
                                  ],
                                  [
                                    2.186,
                                    107.298
                                  ],
                                  [
                                    -23.989,
                                    100.114
                                  ],
                                  [
                                    -39.249,
                                    93.166
                                  ],
                                  [
                                    -42.211,
                                    88.697
                                  ],
                                  [
                                    -41.094,
                                    82.384
                                  ],
                                  [
                                    -34.258,
                                    3.829
                                  ],
                                  [
                                    -36.308,
                                    -39.636
                                  ],
                                  [
                                    -34.361,
                                    -70.555
                                  ],
                                  [
                                    8.191,
                                    -102.418
                                  ],
                                  [
                                    26.044,
                                    -106.651
                                  ],
                                  [
                                    38.875,
                                    -107.297
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                0.262745112181,
                                0.309803932905,
                                0.854901969433,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                209.753,
                                338.132
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 3",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 3,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "gr",
                        "it": [
                          {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                              "a": 0,
                              "k": {
                                "i": [
                                  [
                                    0.4,
                                    -1.148
                                  ],
                                  [
                                    0.697,
                                    -0.666
                                  ],
                                  [
                                    6.313,
                                    -2.572
                                  ],
                                  [
                                    20.261,
                                    -1.004
                                  ],
                                  [
                                    11.13,
                                    1.927
                                  ],
                                  [
                                    8.394,
                                    3.228
                                  ],
                                  [
                                    4.981,
                                    2.634
                                  ],
                                  [
                                    0.43,
                                    1.701
                                  ],
                                  [
                                    -0.789,
                                    2.04
                                  ],
                                  [
                                    1.281,
                                    27.343
                                  ],
                                  [
                                    0.697,
                                    14.738
                                  ],
                                  [
                                    -3.71,
                                    8.127
                                  ],
                                  [
                                    -18.294,
                                    7.328
                                  ],
                                  [
                                    -7.615,
                                    0.687
                                  ],
                                  [
                                    -4.161,
                                    0.01
                                  ],
                                  [
                                    -1.179,
                                    -0.082
                                  ],
                                  [
                                    -1.476,
                                    -0.205
                                  ],
                                  [
                                    -2.326,
                                    -0.543
                                  ],
                                  [
                                    -4.848,
                                    -2.019
                                  ],
                                  [
                                    -3.218,
                                    -6.785
                                  ],
                                  [
                                    -0.092,
                                    -4.089
                                  ],
                                  [
                                    0.789,
                                    -18.499
                                  ],
                                  [
                                    0.779,
                                    -14.164
                                  ],
                                  [
                                    -6.467,
                                    -18.745
                                  ]
                                ],
                                "o": [
                                  [
                                    -0.297,
                                    0.861
                                  ],
                                  [
                                    -5.001,
                                    4.766
                                  ],
                                  [
                                    -19.093,
                                    7.789
                                  ],
                                  [
                                    -12.38,
                                    0.625
                                  ],
                                  [
                                    -9.08,
                                    -1.548
                                  ],
                                  [
                                    -5.196,
                                    -1.999
                                  ],
                                  [
                                    -1.619,
                                    -0.861
                                  ],
                                  [
                                    -0.543,
                                    -2.122
                                  ],
                                  [
                                    9.254,
                                    -24.043
                                  ],
                                  [
                                    -0.666,
                                    -14.235
                                  ],
                                  [
                                    -0.4,
                                    -8.445
                                  ],
                                  [
                                    2.767,
                                    -6.077
                                  ],
                                  [
                                    7.061,
                                    -2.818
                                  ],
                                  [
                                    4.366,
                                    -0.41
                                  ],
                                  [
                                    1.148,
                                    -0.01
                                  ],
                                  [
                                    1.445,
                                    0.092
                                  ],
                                  [
                                    2.285,
                                    0.307
                                  ],
                                  [
                                    4.919,
                                    1.189
                                  ],
                                  [
                                    21.522,
                                    8.906
                                  ],
                                  [
                                    0.43,
                                    0.922
                                  ],
                                  [
                                    0.266,
                                    8.916
                                  ],
                                  [
                                    -0.553,
                                    12.657
                                  ],
                                  [
                                    -1.168,
                                    21.163
                                  ],
                                  [
                                    0.379,
                                    1.107
                                  ]
                                ],
                                "v": [
                                  [
                                    80.781,
                                    86.872
                                  ],
                                  [
                                    79.069,
                                    89.116
                                  ],
                                  [
                                    61.954,
                                    99.939
                                  ],
                                  [
                                    -1.167,
                                    108.168
                                  ],
                                  [
                                    -36.381,
                                    106.201
                                  ],
                                  [
                                    -62.556,
                                    99.016
                                  ],
                                  [
                                    -77.816,
                                    92.068
                                  ],
                                  [
                                    -80.778,
                                    87.6
                                  ],
                                  [
                                    -79.661,
                                    81.286
                                  ],
                                  [
                                    -72.825,
                                    2.731
                                  ],
                                  [
                                    -74.875,
                                    -40.733
                                  ],
                                  [
                                    -72.927,
                                    -71.653
                                  ],
                                  [
                                    -30.375,
                                    -103.516
                                  ],
                                  [
                                    -12.522,
                                    -107.749
                                  ],
                                  [
                                    0.309,
                                    -108.394
                                  ],
                                  [
                                    3.814,
                                    -108.281
                                  ],
                                  [
                                    8.19,
                                    -107.831
                                  ],
                                  [
                                    15.098,
                                    -106.519
                                  ],
                                  [
                                    29.835,
                                    -101.63
                                  ],
                                  [
                                    74.017,
                                    -70.556
                                  ],
                                  [
                                    74.816,
                                    -62.891
                                  ],
                                  [
                                    73.842,
                                    -19.939
                                  ],
                                  [
                                    71.762,
                                    20.922
                                  ],
                                  [
                                    80.402,
                                    83.418
                                  ]
                                ],
                                "c": true
                              },
                              "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                          },
                          {
                            "ty": "fl",
                            "c": {
                              "a": 0,
                              "k": [
                                0.290196090937,
                                0.376470595598,
                                0.870588243008,
                                1
                              ],
                              "ix": 4
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                          },
                          {
                            "ty": "tr",
                            "p": {
                              "a": 0,
                              "k": [
                                248.32,
                                339.23
                              ],
                              "ix": 2
                            },
                            "a": {
                              "a": 0,
                              "k": [
                                0,
                                0
                              ],
                              "ix": 1
                            },
                            "s": {
                              "a": 0,
                              "k": [
                                100,
                                100
                              ],
                              "ix": 3
                            },
                            "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                            },
                            "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                            },
                            "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                            },
                            "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                            },
                            "nm": "Transform"
                          }
                        ],
                        "nm": "Group 4",
                        "np": 2,
                        "cix": 2,
                        "bm": 0,
                        "ix": 4,
                        "mn": "ADBE Vector Group",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            248.32,
                            339.23
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            248.32,
                            339.23
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 21",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 21,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -2.23,
                                3.123
                              ],
                              [
                                -3.187,
                                -7.637
                              ],
                              [
                                3.156,
                                -2.306
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                2.375,
                                8.711
                              ]
                            ],
                            "o": [
                              [
                                9.078,
                                -4.915
                              ],
                              [
                                3.187,
                                7.637
                              ],
                              [
                                -3.156,
                                2.306
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -2.375,
                                -8.711
                              ]
                            ],
                            "v": [
                              [
                                -23.404,
                                -13.829
                              ],
                              [
                                23.225,
                                -13.829
                              ],
                              [
                                20.089,
                                5.853
                              ],
                              [
                                -0.09,
                                18.59
                              ],
                              [
                                -21.943,
                                4.059
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.137254908681,
                            0.145098045468,
                            0.40000000596,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            248.678,
                            234.784
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 22",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 22,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "gr",
                    "it": [
                      {
                        "ind": 0,
                        "ty": "sh",
                        "ix": 1,
                        "ks": {
                          "a": 0,
                          "k": {
                            "i": [
                              [
                                -0.31,
                                -6.76
                              ],
                              [
                                0.34,
                                0.06
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                9.77,
                                5.33
                              ],
                              [
                                1.65,
                                0.93
                              ],
                              [
                                -16.03,
                                22.75
                              ]
                            ],
                            "o": [
                              [
                                -0.35,
                                -0.06
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -11.1,
                                -2.29
                              ],
                              [
                                -1.49,
                                -0.82
                              ],
                              [
                                11.43,
                                -42.32
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            "v": [
                              [
                                18.055,
                                54.01
                              ],
                              [
                                17.015,
                                53.82
                              ],
                              [
                                16.655,
                                53.75
                              ],
                              [
                                14.395,
                                53.3
                              ],
                              [
                                -13.365,
                                42.72
                              ],
                              [
                                -18.055,
                                40.11
                              ],
                              [
                                14.955,
                                -54.01
                              ]
                            ],
                            "c": true
                          },
                          "ix": 2
                        },
                        "nm": "Path 1",
                        "mn": "ADBE Vector Shape - Group",
                        "hd": false
                      },
                      {
                        "ty": "fl",
                        "c": {
                          "a": 0,
                          "k": [
                            0.262745112181,
                            0.309803932905,
                            0.854901969433,
                            1
                          ],
                          "ix": 4
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 5
                        },
                        "r": 1,
                        "bm": 0,
                        "nm": "Fill 1",
                        "mn": "ADBE Vector Graphic - Fill",
                        "hd": false
                      },
                      {
                        "ty": "tr",
                        "p": {
                          "a": 0,
                          "k": [
                            162.723,
                            318.282
                          ],
                          "ix": 2
                        },
                        "a": {
                          "a": 0,
                          "k": [
                            0,
                            0
                          ],
                          "ix": 1
                        },
                        "s": {
                          "a": 0,
                          "k": [
                            100,
                            100
                          ],
                          "ix": 3
                        },
                        "r": {
                          "a": 0,
                          "k": 0,
                          "ix": 6
                        },
                        "o": {
                          "a": 0,
                          "k": 100,
                          "ix": 7
                        },
                        "sk": {
                          "a": 0,
                          "k": 0,
                          "ix": 4
                        },
                        "sa": {
                          "a": 0,
                          "k": 0,
                          "ix": 5
                        },
                        "nm": "Transform"
                      }
                    ],
                    "nm": "Group 23",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 23,
                    "mn": "ADBE Vector Group",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        162.723,
                        318.282
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        162.723,
                        318.282
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 1",
                "np": 23,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            16.044,
                            21.68
                          ],
                          [
                            0.239,
                            -8.401
                          ],
                          [
                            -1.324,
                            -8.609
                          ],
                          [
                            -3.883,
                            -20.032
                          ],
                          [
                            -7.309,
                            3.918
                          ]
                        ],
                        "o": [
                          [
                            0,
                            0
                          ],
                          [
                            0.969,
                            8.03
                          ],
                          [
                            2.034,
                            20.342
                          ],
                          [
                            5.879,
                            -2.132
                          ],
                          [
                            -11.462,
                            -40.316
                          ]
                        ],
                        "v": [
                          [
                            -16.34,
                            -49.251
                          ],
                          [
                            -16.733,
                            -35.389
                          ],
                          [
                            -14.392,
                            -10.569
                          ],
                          [
                            -1.957,
                            49.251
                          ],
                          [
                            16.733,
                            40.431
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.290196090937,
                        0.376470595598,
                        0.870588243008,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        338.676,
                        317.931
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "gr",
                "it": [
                  {
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                      "a": 0,
                      "k": {
                        "i": [
                          [
                            0.969,
                            8.03
                          ],
                          [
                            0.238,
                            -4.903
                          ],
                          [
                            -5.059,
                            1.835
                          ],
                          [
                            2.034,
                            20.342
                          ]
                        ],
                        "o": [
                          [
                            -0.765,
                            26.93
                          ],
                          [
                            7.019,
                            -1.199
                          ],
                          [
                            -3.883,
                            -20.032
                          ],
                          [
                            -1.324,
                            -8.609
                          ]
                        ],
                        "v": [
                          [
                            -6.068,
                            -44.519
                          ],
                          [
                            -8.708,
                            44.519
                          ],
                          [
                            8.708,
                            40.121
                          ],
                          [
                            -3.728,
                            -19.7
                          ]
                        ],
                        "c": true
                      },
                      "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                  },
                  {
                    "ty": "fl",
                    "c": {
                      "a": 0,
                      "k": [
                        0.262745112181,
                        0.309803932905,
                        0.854901969433,
                        1
                      ],
                      "ix": 4
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 5
                    },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                  },
                  {
                    "ty": "tr",
                    "p": {
                      "a": 0,
                      "k": [
                        328.012,
                        327.061
                      ],
                      "ix": 2
                    },
                    "a": {
                      "a": 0,
                      "k": [
                        0,
                        0
                      ],
                      "ix": 1
                    },
                    "s": {
                      "a": 0,
                      "k": [
                        100,
                        100
                      ],
                      "ix": 3
                    },
                    "r": {
                      "a": 0,
                      "k": 0,
                      "ix": 6
                    },
                    "o": {
                      "a": 0,
                      "k": 100,
                      "ix": 7
                    },
                    "sk": {
                      "a": 0,
                      "k": 0,
                      "ix": 4
                    },
                    "sa": {
                      "a": 0,
                      "k": 0,
                      "ix": 5
                    },
                    "nm": "Transform"
                  }
                ],
                "nm": "Group 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    328.012,
                    327.061
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    328.012,
                    327.061
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        3.656,
                        35.415
                      ],
                      [
                        68.507,
                        0
                      ],
                      [
                        3.656,
                        -35.415
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        -3.656,
                        -35.415
                      ],
                      [
                        -68.507,
                        0
                      ],
                      [
                        -3.656,
                        35.415
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        90.507,
                        -29.059
                      ],
                      [
                        0,
                        -79.134
                      ],
                      [
                        -90.507,
                        -29.059
                      ],
                      [
                        -93.007,
                        79.134
                      ],
                      [
                        0,
                        79.134
                      ],
                      [
                        93.007,
                        79.134
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.192156866193,
                    0.20000000298,
                    0.517647087574,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    246.507,
                    322.866
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 12,
        "op": 132,
        "st": 12,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 11,
        "ty": 4,
        "nm": "Line",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.21
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.79
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 5,
                "s": [
                  0
                ]
              },
              {
                "t": 33,
                "s": [
                  100
                ]
              }
            ],
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              371.199,
              195.814,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              371.199,
              195.814,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    297.778
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    279.815
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    261.853
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    243.891
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 4",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 4,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    227.22
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 5",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 5,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    210.549
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 6",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 6,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    193.877
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 7",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 7,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    177.206
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 8",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 8,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    160.535
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 9",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 9,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    143.864
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 10",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 10,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    127.193
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 11",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 11,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    110.522
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 12",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 12,
            "mn": "ADBE Vector Group",
            "hd": false
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        3.971
                      ],
                      [
                        -71.301,
                        -3.971
                      ],
                      [
                        71.301,
                        -3.971
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    371.199,
                    93.851
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 13",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 13,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 5,
        "op": 125,
        "st": 5,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 12,
        "ty": 4,
        "nm": "REg",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.21
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.79
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 20,
                "s": [
                  0
                ]
              },
              {
                "t": 48,
                "s": [
                  100
                ]
              }
            ],
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              230.184,
              127.783,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        30.818,
                        40.252
                      ],
                      [
                        -30.818,
                        40.252
                      ],
                      [
                        -30.818,
                        -40.252
                      ],
                      [
                        30.818,
                        -40.252
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 20,
        "op": 140,
        "st": 20,
        "bm": 0
      },
      {
        "ddd": 0,
        "ind": 13,
        "ty": 4,
        "nm": "REG",
        "sr": 1,
        "ks": {
          "o": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": [
                    0.21
                  ],
                  "y": [
                    1
                  ]
                },
                "o": {
                  "x": [
                    0.79
                  ],
                  "y": [
                    0
                  ]
                },
                "t": 9,
                "s": [
                  0
                ]
              },
              {
                "t": 37,
                "s": [
                  100
                ]
              }
            ],
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              139.902,
              178.493,
              0
            ],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [
              0,
              0,
              0
            ],
            "ix": 1
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "o": [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    "v": [
                      [
                        53.474,
                        69.844
                      ],
                      [
                        -53.474,
                        69.844
                      ],
                      [
                        -53.474,
                        -69.844
                      ],
                      [
                        53.474,
                        -69.844
                      ]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ty": "fl",
                "c": {
                  "a": 0,
                  "k": [
                    0.313725501299,
                    0.43137255311,
                    0.878431379795,
                    1
                  ],
                  "ix": 4
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 5
                },
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform"
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ],
        "ip": 9,
        "op": 129,
        "st": 9,
        "bm": 0
      }
    ],
    "markers": [
      
    ],
    "chars": [
      {
        "ch": "2",
        "size": 27.3625640869141,
        "style": "Regular",
        "w": 50,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          1.139,
                          -0.797
                        ],
                        [
                          1.416,
                          -0.26
                        ],
                        [
                          3.516,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -8.105,
                          8.855
                        ],
                        [
                          -2.409,
                          5.273
                        ],
                        [
                          0,
                          3.353
                        ],
                        [
                          3.596,
                          3.451
                        ],
                        [
                          5.371,
                          0
                        ],
                        [
                          3.369,
                          -3.223
                        ],
                        [
                          0.813,
                          -6.022
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.588,
                          1.904
                        ],
                        [
                          -3.255,
                          0
                        ],
                        [
                          -2.572,
                          -2.702
                        ],
                        [
                          0,
                          -4.199
                        ],
                        [
                          4.688,
                          -6.641
                        ],
                        [
                          11.491,
                          -10.481
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          -0.847,
                          1.465
                        ],
                        [
                          -1.14,
                          0.798
                        ],
                        [
                          -1.416,
                          0.261
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.018,
                          -1.823
                        ],
                        [
                          5.403,
                          -5.891
                        ],
                        [
                          1.563,
                          -3.352
                        ],
                        [
                          0,
                          -4.688
                        ],
                        [
                          -3.597,
                          -3.45
                        ],
                        [
                          -5.046,
                          0
                        ],
                        [
                          -3.369,
                          3.223
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.237,
                          -3.678
                        ],
                        [
                          2.588,
                          -1.904
                        ],
                        [
                          3.58,
                          0
                        ],
                        [
                          2.571,
                          2.702
                        ],
                        [
                          0,
                          5.502
                        ],
                        [
                          -4.688,
                          6.641
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          44.043,
                          -12.744
                        ],
                        [
                          41.064,
                          -9.351
                        ],
                        [
                          37.231,
                          -7.764
                        ],
                        [
                          29.834,
                          -7.373
                        ],
                        [
                          12.549,
                          -7.373
                        ],
                        [
                          27.734,
                          -23.389
                        ],
                        [
                          39.453,
                          -40.137
                        ],
                        [
                          41.797,
                          -50.195
                        ],
                        [
                          36.401,
                          -62.402
                        ],
                        [
                          22.949,
                          -67.578
                        ],
                        [
                          10.327,
                          -62.744
                        ],
                        [
                          4.053,
                          -48.877
                        ],
                        [
                          5.859,
                          -48.877
                        ],
                        [
                          11.597,
                          -57.251
                        ],
                        [
                          20.361,
                          -60.107
                        ],
                        [
                          29.59,
                          -56.055
                        ],
                        [
                          33.447,
                          -45.703
                        ],
                        [
                          26.416,
                          -27.49
                        ],
                        [
                          2.148,
                          -1.807
                        ],
                        [
                          2.148,
                          0
                        ],
                        [
                          41.211,
                          0
                        ],
                        [
                          45.85,
                          -12.744
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "2",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Times New Roman"
      },
      {
        "ch": "4",
        "size": 27.3625640869141,
        "style": "Regular",
        "w": 50,
        "data": {
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          37.646,
                          -24.414
                        ],
                        [
                          37.646,
                          -67.578
                        ],
                        [
                          32.275,
                          -67.578
                        ],
                        [
                          1.563,
                          -23.73
                        ],
                        [
                          1.563,
                          -17.48
                        ],
                        [
                          29.59,
                          -17.48
                        ],
                        [
                          29.59,
                          0
                        ],
                        [
                          37.646,
                          0
                        ],
                        [
                          37.646,
                          -17.48
                        ],
                        [
                          46.533,
                          -17.48
                        ],
                        [
                          46.533,
                          -24.414
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          6.348,
                          -24.414
                        ],
                        [
                          29.59,
                          -57.275
                        ],
                        [
                          29.59,
                          -24.414
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                }
              ],
              "nm": "4",
              "np": 5,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ]
        },
        "fFamily": "Times New Roman"
      }
    ]
  };